
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("gP1fu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f7f2b18b91bed6f1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $f7f2b18b91bed6f1$export$2e2bcd8739ae039 = {
    'act.action.dismissalMessage.common.text': "You won\u2019t see this here as often.",
    'act.action.notInterested.button.text': 'Not interested',
    'act.action.notInterestedFlag.flag.text': 'Got it, thanks for letting us know',
    'act.action.reasonsModalOkButton.common.text': 'OK',
    'act.action.showReasons.common.text': 'Why am I seeing this?'
};

});

parcelRegister("7gWdR", function(module, exports) {

$parcel$export(module.exports, "draggable", () => (parcelRequire("40DDD")).draggable);
$parcel$export(module.exports, "dropTargetForElements", () => (parcelRequire("40DDD")).dropTargetForElements);
$parcel$export(module.exports, "monitorForElements", () => (parcelRequire("40DDD")).monitorForElements);

var $40DDD = parcelRequire("40DDD");

});
parcelRegister("40DDD", function(module, exports) {

$parcel$export(module.exports, "dropTargetForElements", () => $0b9136830a524a8f$export$e7140b68045b5036);
$parcel$export(module.exports, "monitorForElements", () => $0b9136830a524a8f$export$59a074bac4c54f54);
$parcel$export(module.exports, "draggable", () => $0b9136830a524a8f$export$c746a5152d4ba26c);

var $cBeZP = parcelRequire("cBeZP");

var $kKgsQ = parcelRequire("kKgsQ");

var $8d5CE = parcelRequire("8d5CE");

var $iiVLC = parcelRequire("iiVLC");

var $3zl3q = parcelRequire("3zl3q");

var $jjNE9 = parcelRequire("jjNE9");

var $lzZrl = parcelRequire("lzZrl");

var $6XFIM = parcelRequire("6XFIM");

var $aWzmz = parcelRequire("aWzmz");



const $0b9136830a524a8f$var$draggableRegistry = new WeakMap();
function $0b9136830a524a8f$var$addToRegistry(args) {
    $0b9136830a524a8f$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $0b9136830a524a8f$var$draggableRegistry.delete(args.element);
    };
}
const $0b9136830a524a8f$var$honeyPotFix = (0, $8d5CE.makeHoneyPotFix)();
const $0b9136830a524a8f$var$adapter = (0, $iiVLC.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount (api) {
        /**  Binding event listeners the `document` rather than `window` so that
		 * this adapter always gets preference over the text adapter.
		 * `document` is the first `EventTarget` under `window`
		 * https://twitter.com/alexandereardon/status/1604658588311465985
		 */ return (0, $3zl3q.combine)($0b9136830a524a8f$var$honeyPotFix.bindEvents(), (0, $cBeZP.bind)(document, {
            type: 'dragstart',
            listener (event) {
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                const target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return null;
                // see if the thing being dragged is owned by us
                const entry = $0b9136830a524a8f$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return null;
                /**
					 * A text selection drag _can_ have the `draggable` element be
					 * the `event.target` if the user is dragging the text selection
					 * from the `draggable`.
					 *
					 * To know if the `draggable` is being dragged, we look at whether any
					 * `"text/plain"` data is being dragged. If it is, then a text selection
					 * drag is occurring.
					 *
					 * This behaviour has been validated on:
					 *
					 * - Chrome@128 on Android@14
					 * - Chrome@128 on iOS@17.6.1
					 * - Chrome@128 on Windows@11
					 * - Chrome@128 on MacOS@14.6.1
					 * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
					 * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
					 *
					 * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
					 * but unfortunately ProseMirror is always setting `""` as the dragged text
					 *
					 * Note: Unfortunately editor is (heavily) leaning on the current functionality today
					 * and unwinding it will be a decent amount of effort. So for now, a text selection
					 * where the `event.target` is a `draggable` element will still trigger the
					 * element adapter.
					 *
					 * // Future state:
					 * if(event.dataTransfer.getData(textMediaType)) {
					 * 	return;
					 * }
					 *
					 */ const input = (0, $aWzmz.getInput)(event);
                const feedback = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return null;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    const over = (0, $kKgsQ.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return null;
                    }
                }
                /**
					 *  **Goal**
					 *  Pass information to other applications
					 *
					 * **Approach**
					 *  Put data into the native data store
					 *
					 *  **What about the native adapter?**
					 *  When the element adapter puts native data into the native data store
					 *  the native adapter is not triggered in the current window,
					 *  but a native adapter in an external window _can_ be triggered
					 *
					 *  **Why bake this into core?**
					 *  This functionality could be pulled out and exposed inside of
					 *  `onGenerateDragPreview`. But decided to make it a part of the
					 *  base API as it felt like a common enough use case and ended
					 *  up being a similar amount of code to include this function as
					 *  it was to expose the hook for it
					 */ const nativeData = entry.getInitialDataForExternal?.(feedback) ?? null;
                if (nativeData) for (const [key, data] of Object.entries(nativeData))event.dataTransfer.setData(key, data ?? '');
                /**
					 *  📱 For Android devices, a drag operation will not start unless
					 * "text/plain" or "text/uri-list" data exists in the native data store
					 * https://twitter.com/alexandereardon/status/1732189803754713424
					 *
					 * Tested on:
					 * Device: Google Pixel 5
					 * Android version: 14 (November 5, 2023)
					 * Chrome version: 120.0
					 */ if ((0, $6XFIM.isAndroid)() && !event.dataTransfer.types.includes((0, $511ea0f8ed5a789e$export$fd3d00026297c0ad)) && !event.dataTransfer.types.includes((0, $8b5b4a812d80efb4$export$4c44a460f123106))) event.dataTransfer.setData((0, $511ea0f8ed5a789e$export$fd3d00026297c0ad), (0, $6XFIM.androidFallbackText));
                /**
					 * 1. Must set any media type for `iOS15` to work
					 * 2. We are also doing adding data so that the native adapter
					 * can know that the element adapter has handled this drag
					 *
					 * We used to wrap this `setData()` in a `try/catch` for Firefox,
					 * but it looks like that was not needed.
					 *
					 * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
					 *
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
					 * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
					 * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
					 *
					 * // just checking a few more combinations to be super safe
					 *
					 * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
					 * - ✅ Chrome@78 (Oct 2019) on Windows 10
					 * - ✅ Safari@14.1 on macOS Big Sur
					 */ event.dataTransfer.setData((0, $dad94f2a683170ce$export$c9c4cc54e73b125d), '');
                const payload = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    data: entry.getInitialData?.(feedback) ?? {}
                };
                const dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: ({ eventName: eventName, payload: payload })=>{
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        $0b9136830a524a8f$var$draggableRegistry.get(payload.source.element)?.[eventName]?.(// I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $0b9136830a524a8f$var$honeyPotFix.getOnPostDispatch()
});
const $0b9136830a524a8f$export$e7140b68045b5036 = $0b9136830a524a8f$var$adapter.dropTarget;
const $0b9136830a524a8f$export$59a074bac4c54f54 = $0b9136830a524a8f$var$adapter.monitor;
function $0b9136830a524a8f$export$c746a5152d4ba26c(args) {
    const cleanup = (0, $3zl3q.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $0b9136830a524a8f$var$adapter.registerUsage(), $0b9136830a524a8f$var$addToRegistry(args), (0, $lzZrl.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $jjNE9.once)(cleanup);
}

});
parcelRegister("kKgsQ", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $5328a4a0c6bbab12$export$81d0353f25f5dd);

var $dkX0L = parcelRequire("dkX0L");
function $5328a4a0c6bbab12$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    const [top, second] = document.elementsFromPoint(client.x, client.y);
    if (!top) return null;
    if ((0, $dkX0L.isHoneyPotElement)(top)) return second ?? null;
    return top;
}

});
parcelRegister("dkX0L", function(module, exports) {

$parcel$export(module.exports, "isHoneyPotElement", () => $b72c0efc16556d78$export$821bdcd739a2706b);

function $b72c0efc16556d78$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $777d0e5bd42bc367$export$6eafea55f7947469));
}

});
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
const $777d0e5bd42bc367$export$6eafea55f7947469 = 'data-pdnd-honey-pot';



parcelRegister("8d5CE", function(module, exports) {

$parcel$export(module.exports, "makeHoneyPotFix", () => $e63f81f9f360c6d0$export$8ecad27c959e89e0);

var $cBeZP = parcelRequire("cBeZP");


const $e63f81f9f360c6d0$var$honeyPotSize = 2;
const $e63f81f9f360c6d0$var$halfHoneyPotSize = $e63f81f9f360c6d0$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $e63f81f9f360c6d0$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $e63f81f9f360c6d0$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $e63f81f9f360c6d0$var$halfHoneyPotSize,
        y: point.y - $e63f81f9f360c6d0$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $e63f81f9f360c6d0$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $e63f81f9f360c6d0$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $e63f81f9f360c6d0$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $e63f81f9f360c6d0$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $e63f81f9f360c6d0$var$getHoneyPotRectFor({ client: client }) {
    const point = $e63f81f9f360c6d0$var$preventGoingForwardsOffScreen($e63f81f9f360c6d0$var$preventGoingBackwardsOffScreen($e63f81f9f360c6d0$var$pullBackByHalfHoneyPotSize($e63f81f9f360c6d0$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $e63f81f9f360c6d0$var$honeyPotSize,
        height: $e63f81f9f360c6d0$var$honeyPotSize
    });
}
function $e63f81f9f360c6d0$var$getRectStyles({ clientRect: clientRect }) {
    return {
        left: `${clientRect.left}px`,
        top: `${clientRect.top}px`,
        width: `${clientRect.width}px`,
        height: `${clientRect.height}px`
    };
}
function $e63f81f9f360c6d0$var$isWithin({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $e63f81f9f360c6d0$var$mountHoneyPot({ initial: initial }) {
    const element = document.createElement('div');
    element.setAttribute((0, $777d0e5bd42bc367$export$6eafea55f7947469), 'true');
    // can shift during the drag thanks to Firefox
    let clientRect = $e63f81f9f360c6d0$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, {
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        position: 'fixed',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        ...$e63f81f9f360c6d0$var$getRectStyles({
            clientRect: clientRect
        }),
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $ff68169bc3de57ec$export$7d0a15ee70427305)
    });
    document.body.appendChild(element);
    /**
	 *  🦊 In firefox we can get `"pointermove"` events after the drag
	 * has started, which is a spec violation.
	 * The final `"pointermove"` will reveal where the "depressed" position
	 * is for our honey pot fix.
	 */ const unbindPointerMove = (0, $cBeZP.bind)(window, {
        type: 'pointermove',
        listener (event) {
            const client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $e63f81f9f360c6d0$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $e63f81f9f360c6d0$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish({ current: current }) {
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($e63f81f9f360c6d0$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        const unbindPostDragEvents = (0, $cBeZP.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $e63f81f9f360c6d0$export$8ecad27c959e89e0() {
    let latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $cBeZP.bind)(window, {
            type: 'pointermove',
            listener (event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        let finish = null;
        return function onPostEvent({ eventName: eventName, payload: payload }) {
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                const { input: input } = payload.location.initial;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                const initial = latestPointerMove ?? {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $e63f81f9f360c6d0$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                const { input: input } = payload.location.current;
                finish?.({
                    current: {
                        x: input.clientX,
                        y: input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $ff68169bc3de57ec$export$7d0a15ee70427305 = 2147483647;


parcelRegister("iiVLC", function(module, exports) {

$parcel$export(module.exports, "makeAdapter", () => $77e910c1e7be5898$export$2aa3a33160990d96);

var $ik6C6 = parcelRequire("ik6C6");

var $dSShi = parcelRequire("dSShi");

var $c7Wsm = parcelRequire("c7Wsm");

var $7Q7eZ = parcelRequire("7Q7eZ");
function $77e910c1e7be5898$export$2aa3a33160990d96({ typeKey: typeKey, mount: mount, dispatchEventToSource: dispatchEventToSource, onPostDispatch: onPostDispatch, defaultDropEffect: defaultDropEffect }) {
    const monitorAPI = (0, $7Q7eZ.makeMonitor)();
    const dropTargetAPI = (0, $c7Wsm.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource?.(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch?.(args);
    }
    function start({ event: event, dragType: dragType }) {
        (0, $ik6C6.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            const api = {
                canStart: (0, $ik6C6.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $dSShi.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("ik6C6", function(module, exports) {

$parcel$export(module.exports, "lifecycle", () => $018f6c08d2a1465a$export$3efdceeb8ca25c51);

var $cBeZP = parcelRequire("cBeZP");

var $kKgsQ = parcelRequire("kKgsQ");

var $dkX0L = parcelRequire("dkX0L");

var $9uGIN = parcelRequire("9uGIN");

var $h5V4I = parcelRequire("h5V4I");

var $aWzmz = parcelRequire("aWzmz");

var $18GOV = parcelRequire("18GOV");
const $018f6c08d2a1465a$var$globalState = {
    isActive: false
};
function $018f6c08d2a1465a$var$canStart() {
    return !$018f6c08d2a1465a$var$globalState.isActive;
}
function $018f6c08d2a1465a$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $018f6c08d2a1465a$var$hasHierarchyChanged({ current: current, next: next }) {
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(let i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $018f6c08d2a1465a$var$start({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver, dispatchEvent: dispatchEvent }) {
    if (!$018f6c08d2a1465a$var$canStart()) return;
    const initial = $018f6c08d2a1465a$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $018f6c08d2a1465a$var$globalState.isActive = true;
    const state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $018f6c08d2a1465a$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    const dispatch = (0, $18GOV.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        const hasChanged = $018f6c08d2a1465a$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        const input = (0, $aWzmz.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        const target = (0, $dkX0L.isHoneyPotElement)(event.target) ? (0, $kKgsQ.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        const nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $018f6c08d2a1465a$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $018f6c08d2a1465a$var$globalState.isActive = false;
        unbindEvents();
    }
    const unbindEvents = (0, $cBeZP.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener (event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener (event) {
                if (!(0, $9uGIN.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
					 * At this point we don't know if a drag is being cancelled,
					 * or if a drag is leaving the `window`.
					 *
					 * Both have:
					 *   1. "dragleave" (with `relatedTarget: null`)
					 *   2. "dragend" (a "dragend" can occur when outside the `window`)
					 *
					 * **Clearing drop targets**
					 *
					 * For either case we are clearing the the drop targets
					 *
					 * - cancelling: we clear drop targets in `"dragend"` anyway
					 * - leaving the `window`: we clear the drop targets (to clear stickiness)
					 *
					 * **Leaving the window and finishing the drag**
					 *
					 * _internal drags_
					 *
					 * - The drag continues when the user is outside the `window`
					 *   and can resume if the user drags back over the `window`,
					 *   or end when the user drops in an external `window`.
					 * - We will get a `"dragend"`, or we can listen for other
					 *   events to determine the drag is finished when the user re-enters the `window`).
					 *
					 * _external drags_
					 *
					 * - We conclude the drag operation.
					 * - We have no idea if the user will drag back over the `window`,
					 *   or if the drag ends elsewhere.
					 * - We will create a new drag if the user re-enters the `window`.
					 *
					 * **Not updating `input`**
					 *
					 * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
					 * Workaround: intentionally not updating `input` in "dragleave"
					 * rather than the users current input values
					 * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
					 * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
					 **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener (event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $aWzmz.getInput)(event)
                };
                /** If there are no drop targets, then we will get
					 * a "drop" event if:
					 * - `preventUnhandled()` is being used
					 * - there is an unmanaged drop target (eg another library)
					 * In these cases, it's up to the consumer
					 * to handle the drop if it's not over one of our drop targets
					 * - `preventUnhandled()` will cancel the "drop"
					 * - unmanaged drop targets can handle the "drop" how they want to
					 * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $018f6c08d2a1465a$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener (event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $aWzmz.getInput)(event)
                };
                cancel();
            }
        },
        ...(0, $h5V4I.getBindingsForBrokenDrags)({
            onDragEnd: cancel
        })
    ], // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $018f6c08d2a1465a$var$getNativeSetDragImage(event)
    });
}
function $018f6c08d2a1465a$var$setDropEffectOnEvent({ event: event, current: current }) {
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    const innerMost = current[0]?.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $018f6c08d2a1465a$var$getStartLocation({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver }) {
    const input = (0, $aWzmz.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    const dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
const $018f6c08d2a1465a$export$3efdceeb8ca25c51 = {
    canStart: $018f6c08d2a1465a$var$canStart,
    start: $018f6c08d2a1465a$var$start
};

});
parcelRegister("9uGIN", function(module, exports) {

$parcel$export(module.exports, "isLeavingWindow", () => $37e271cec761dcee$export$57d220c74e84a273);

var $bYN8w = parcelRequire("bYN8w");

var $6aABs = parcelRequire("6aABs");

var $apnEk = parcelRequire("apnEk");

var $9Mj6M = parcelRequire("9Mj6M");
function $37e271cec761dcee$export$57d220c74e84a273({ dragLeave: dragLeave }) {
    const { type: type, relatedTarget: relatedTarget } = dragLeave;
    if (type !== 'dragleave') return false;
    if ((0, $6aABs.isSafari)()) return (0, $apnEk.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 * (foreign element)
	 */ if ((0, $bYN8w.isFirefox)()) return (0, $9Mj6M.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `dragLeave.relatedTarget` is `null` *(standard check)*
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("bYN8w", function(module, exports) {

$parcel$export(module.exports, "isFirefox", () => $d91d4bdc8d92ad8d$export$b7d78993b74f766d);

var $jjNE9 = parcelRequire("jjNE9");
const $d91d4bdc8d92ad8d$export$b7d78993b74f766d = (0, $jjNE9.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});
parcelRegister("jjNE9", function(module, exports) {

$parcel$export(module.exports, "once", () => $b679dfdbd4fba3f1$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $b679dfdbd4fba3f1$export$d2de3aaeafa91619(fn) {
    let cache = null;
    return function wrapped(...args) {
        if (!cache) {
            const result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});


parcelRegister("6aABs", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $13856bb4e07cde59$export$95df08bae54cb4df);

var $jjNE9 = parcelRequire("jjNE9");
const $13856bb4e07cde59$export$95df08bae54cb4df = (0, $jjNE9.once)(function isSafari() {
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("apnEk", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindowInSafari", () => $b3bca8f40bde8fa5$export$de68634bd94ed596);
$parcel$export(module.exports, "isLeavingWindowInSafari", () => $b3bca8f40bde8fa5$export$f21837c338005454);

var $cBeZP = parcelRequire("cBeZP");

var $6aABs = parcelRequire("6aABs");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
const $b3bca8f40bde8fa5$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $b3bca8f40bde8fa5$export$de68634bd94ed596({ dragEnter: dragEnter }) {
    if (!(0, $6aABs.isSafari)()) return false;
    return dragEnter.hasOwnProperty($b3bca8f40bde8fa5$var$symbols.isEnteringWindow);
}
function $b3bca8f40bde8fa5$export$f21837c338005454({ dragLeave: dragLeave }) {
    if (!(0, $6aABs.isSafari)()) return false;
    return dragLeave.hasOwnProperty($b3bca8f40bde8fa5$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $6aABs.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    let state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $cBeZP.bindAll)(window, [
        {
            type: 'dragstart',
            listener: ()=>{
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: (event)=>{
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                // @ts-expect-error: adding property to the event object
                event[$b3bca8f40bde8fa5$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: (event)=>{
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    // @ts-expect-error: adding property to the event object
                    event[$b3bca8f40bde8fa5$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("9Mj6M", function(module, exports) {

$parcel$export(module.exports, "isFromAnotherWindow", () => $e0983a74206d410e$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $e0983a74206d410e$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $e0983a74206d410e$export$e46810fef53b5b0e(eventTarget) {
    return $e0983a74206d410e$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("h5V4I", function(module, exports) {

$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $50c75a295ab659e5$export$ac5e5b0daf997b2);
function $50c75a295ab659e5$export$ac5e5b0daf997b2({ onDragEnd: onDragEnd }) {
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            })()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("aWzmz", function(module, exports) {

$parcel$export(module.exports, "getInput", () => $8d49417dc8e95872$export$7c112ceec8941e67);
function $8d49417dc8e95872$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("18GOV", function(module, exports) {

$parcel$export(module.exports, "makeDispatch", () => $9912bec6db707047$export$9f13ecc44e83d682);

var $7nRxN = parcelRequire("7nRxN");
const $9912bec6db707047$var$scheduleOnDrag = (0, $7nRxN.default)((fn)=>fn());
const $9912bec6db707047$var$dragStart = (()=>{
    let scheduled = null;
    function schedule(fn) {
        const frameId = requestAnimationFrame(()=>{
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
})();
function $9912bec6db707047$export$9f13ecc44e83d682({ source: source, initial: initial, dispatchEvent: dispatchEvent }) {
    let previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    const dispatch = {
        start ({ nativeSetDragImage: nativeSetDragImage }) {
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            const location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $9912bec6db707047$var$dragStart.schedule(()=>{
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate ({ current: current }) {
            $9912bec6db707047$var$dragStart.flush();
            $9912bec6db707047$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag ({ current: current }) {
            $9912bec6db707047$var$scheduleOnDrag(()=>{
                $9912bec6db707047$var$dragStart.flush();
                const location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop ({ current: current, updatedSourcePayload: updatedSourcePayload }) {
            $9912bec6db707047$var$dragStart.flush();
            $9912bec6db707047$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload ?? source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});
parcelRegister("7nRxN", function(module, exports) {

$parcel$export(module.exports, "default", () => $560437209e674614$export$2e2bcd8739ae039);
var $560437209e674614$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $560437209e674614$export$2e2bcd8739ae039 = $560437209e674614$var$rafSchd;

});



parcelRegister("dSShi", function(module, exports) {

$parcel$export(module.exports, "register", () => $9449928287939c74$export$6503ec6e8aabbaf);
const $9449928287939c74$var$ledger = new Map();
function $9449928287939c74$var$registerUsage({ typeKey: typeKey, mount: mount }) {
    const entry = $9449928287939c74$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    const initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $9449928287939c74$var$ledger.set(typeKey, initial);
    return initial;
}
function $9449928287939c74$export$6503ec6e8aabbaf(args) {
    const entry = $9449928287939c74$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $9449928287939c74$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("c7Wsm", function(module, exports) {

$parcel$export(module.exports, "makeDropTarget", () => $c9c066c5732074b2$export$47d10e7bd9c81890);

var $3zl3q = parcelRequire("3zl3q");

var $jjNE9 = parcelRequire("jjNE9");

var $lzZrl = parcelRequire("lzZrl");
function $c9c066c5732074b2$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $c9c066c5732074b2$export$47d10e7bd9c81890({ typeKey: typeKey, defaultDropEffect: defaultDropEffect }) {
    const registry = new WeakMap();
    const dropTargetDataAtt = `data-drop-target-for-${typeKey}`;
    const dropTargetSelector = `[${dropTargetDataAtt}]`;
    function addToRegistry(args) {
        registry.set(args.element, args);
        return ()=>registry.delete(args.element);
    }
    function dropTargetForConsumers(args) {
        const cleanup = (0, $3zl3q.combine)((0, $lzZrl.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $jjNE9.once)(cleanup);
    }
    function getActualDropTargets({ source: source, target: target, input: input, result: result = [] }) {
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        const closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        const args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        const feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        const data = args.getData?.(feedback) ?? {};
        const dropEffect = args.getDropEffect?.(feedback) ?? defaultDropEffect;
        const record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [
                ...result,
                record
            ]
        });
    }
    function notifyCurrent({ eventName: eventName, payload: payload }) {
        for (const record of payload.location.current.dropTargets){
            const entry = registry.get(record.element);
            const args = {
                ...payload,
                self: record
            };
            entry?.[eventName]?.(// I cannot seem to get the types right here.
            // TS doesn't seem to like that one event can need `nativeSetDragImage`
            // @ts-expect-error
            args);
        }
    }
    const actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: ({ payload: payload })=>{
            const isCurrent = new Set(payload.location.current.dropTargets.map((record)=>record.element));
            const visited = new Set();
            for (const record of payload.location.previous.dropTargets){
                visited.add(record.element);
                const entry = registry.get(record.element);
                const isOver = isCurrent.has(record.element);
                const args = {
                    ...payload,
                    self: record
                };
                entry?.onDropTargetChange?.(args);
                // if we cannot find the drop target in the current array, then it has been left
                if (!isOver) entry?.onDragLeave?.(args);
            }
            for (const record of payload.location.current.dropTargets){
                // already published an update to this drop target
                if (visited.has(record.element)) continue;
                // at this point we have a new drop target that is being entered into
                const args = {
                    ...payload,
                    self: record
                };
                const entry = registry.get(record.element);
                entry?.onDropTargetChange?.(args);
                entry?.onDragEnter?.(args);
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver({ source: source, target: target, input: input, current: current }) {
        const actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        const lastCaptureOrdered = $c9c066c5732074b2$var$copyReverse(current);
        const actualCaptureOrdered = $c9c066c5732074b2$var$copyReverse(actual);
        const resultCaptureOrdered = [];
        for(let index = 0; index < lastCaptureOrdered.length; index++){
            const last = lastCaptureOrdered[index];
            const fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            const parent = resultCaptureOrdered[index - 1];
            const lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if (parent?.element !== lastParent?.element) break;
            // We need to check whether the old drop target can still be dropped on
            const argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            const feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!argsForLast.getIsSticky?.(feedback)) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push({
                ...last,
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            });
        }
        // return bubble ordered result
        return $c9c066c5732074b2$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("3zl3q", function(module, exports) {

$parcel$export(module.exports, "combine", () => $a6751ba2eb2acc9f$export$1be1fc439b849fdf);
function $a6751ba2eb2acc9f$export$1be1fc439b849fdf(...fns) {
    return function cleanup() {
        fns.forEach((fn)=>fn());
    };
}

});

parcelRegister("lzZrl", function(module, exports) {

$parcel$export(module.exports, "addAttribute", () => $e43023517e6b167a$export$5dcb5c23b6ba980a);
function $e43023517e6b167a$export$5dcb5c23b6ba980a(element, { attribute: attribute, value: value }) {
    element.setAttribute(attribute, value);
    return ()=>element.removeAttribute(attribute);
}

});


parcelRegister("7Q7eZ", function(module, exports) {

$parcel$export(module.exports, "makeMonitor", () => $f3636ae745ab6f9c$export$5dd4ed888d5b12ca);

var $jjNE9 = parcelRequire("jjNE9");
function $f3636ae745ab6f9c$export$5dd4ed888d5b12ca() {
    const registry = new Set();
    let dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        const entry = {
            ...args
        };
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $jjNE9.once)(cleanup);
    }
    function dispatchEvent({ eventName: eventName, payload: payload }) {
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            for (const monitor of registry)tryAddToActive(monitor);
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        const active = Array.from(dragging.active);
        for (const monitor of active)// A monitor can be removed by another monitor during an event.
        // We need to check that the monitor is still registered before calling it
        if (dragging.active.has(monitor)) // @ts-expect-error: I cannot get this type working!
        monitor[eventName]?.(payload);
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("6XFIM", function(module, exports) {

$parcel$export(module.exports, "isAndroid", () => $66dca49a44fee398$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $66dca49a44fee398$export$aceb3ed8b7f7bd2c);

var $jjNE9 = parcelRequire("jjNE9");
const $66dca49a44fee398$export$a11b0059900ceec8 = (0, $jjNE9.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
const $66dca49a44fee398$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $511ea0f8ed5a789e$export$fd3d00026297c0ad = 'text/plain';

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $8b5b4a812d80efb4$export$4c44a460f123106 = 'text/uri-list';

/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $dad94f2a683170ce$export$c9c4cc54e73b125d = 'application/vnd.pdnd';



parcelRegister("4hDdm", function(module, exports) {

$parcel$export(module.exports, "combine", () => (parcelRequire("3zl3q")).combine);

var $3zl3q = parcelRequire("3zl3q");

});

parcelRegister("22Gxp", function(module, exports) {

$parcel$export(module.exports, "useUID", () => $17ccc3ce11c8a1a0$export$87d05f07e65211f1);
$parcel$export(module.exports, "useUIDSeed", () => $17ccc3ce11c8a1a0$export$bb5ca5fba6fb4f1f);

var $5uXOq = parcelRequire("5uXOq");

var $7aHWJ = parcelRequire("7aHWJ");
var $17ccc3ce11c8a1a0$var$generateUID = function(context) {
    var quartz = context || (0, $7aHWJ.counter);
    var prefix = (0, $7aHWJ.getPrefix)(quartz);
    var id = (0, $7aHWJ.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $17ccc3ce11c8a1a0$var$useUIDState = function() {
    // @ts-ignore
    return $5uXOq.useState($17ccc3ce11c8a1a0$var$generateUID($5uXOq.useContext((0, $7aHWJ.source))));
};
var $17ccc3ce11c8a1a0$export$87d05f07e65211f1 = function() {
    var uid = $17ccc3ce11c8a1a0$var$useUIDState()[0].uid;
    return uid;
};
var $17ccc3ce11c8a1a0$export$bb5ca5fba6fb4f1f = function() {
    var gen = $17ccc3ce11c8a1a0$var$useUIDState()[0].gen;
    return gen;
};

});
parcelRegister("7aHWJ", function(module, exports) {

$parcel$export(module.exports, "counter", () => $538b8e680858bf13$export$e575061ef2a070eb);
$parcel$export(module.exports, "source", () => $538b8e680858bf13$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "getId", () => $538b8e680858bf13$export$218c8c3169c024d2);
$parcel$export(module.exports, "getPrefix", () => $538b8e680858bf13$export$36e24695f02d4503);

var $5uXOq = parcelRequire("5uXOq");

var $8e3lA = parcelRequire("8e3lA");
var $538b8e680858bf13$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = '';
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $8e3lA.generateUID)()
    };
};
var $538b8e680858bf13$export$e575061ef2a070eb = $538b8e680858bf13$export$1921362e86c73c88();
var $538b8e680858bf13$export$b4d5da5f34fb77ad = $5uXOq.createContext($538b8e680858bf13$export$1921362e86c73c88());
var $538b8e680858bf13$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $538b8e680858bf13$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : '';
};

});
parcelRegister("8e3lA", function(module, exports) {

$parcel$export(module.exports, "generateUID", () => $5fd23a338f882896$export$bdbb4cbb3078e58d);
$parcel$export(module.exports, "uid", () => $5fd23a338f882896$export$e2a22331486dcca0);
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $5fd23a338f882896$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-" + index : "val-" + item;
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var $5fd23a338f882896$export$e2a22331486dcca0 = $5fd23a338f882896$export$bdbb4cbb3078e58d();

});



parcelRegister("7uUwQ", function(module, exports) {
/**
 * This allows you to work with object hierarchies that have been frozen
 * with Object.freeze().  "get" operations can use the normal JS syntax,
 * but operations that modify the data will have to return partial copies of
 * the structure. The portions of the structure that did not change will
 * === their previous values.
 *
 * Inspired by clojure/mori and Immutable.js
 */ "use strict";
var $57572f31ed5f364f$var$i = module.exports;
// we only care about objects or arrays for now
function $57572f31ed5f364f$var$weCareAbout(val) {
    return null !== val && (Array.isArray(val) || // This will skip objects created with `new Foo()`
    // and objects created with `Object.create(proto)`
    // The benefit is ignoring DOM elements and event emitters,
    // which are often circular.
    $57572f31ed5f364f$var$isObjectLike(val));
}
function $57572f31ed5f364f$var$isObjectLike(val) {
    return typeof val === "object" && val.constructor === Object && Object.getPrototypeOf(val) === Object.prototype;
}
function $57572f31ed5f364f$var$arrayClone(arr) {
    var index = 0, length = arr.length, result = Array(length);
    for(; index < length; index += 1)result[index] = arr[index];
    return result;
}
function $57572f31ed5f364f$var$objClone(obj) {
    var index = 0, keys = Object.keys(obj), length = keys.length, key, result = {};
    for(; index < length; index += 1){
        key = keys[index];
        result[key] = obj[key];
    }
    return result;
}
function $57572f31ed5f364f$var$clone(coll) {
    if (Array.isArray(coll)) return $57572f31ed5f364f$var$arrayClone(coll);
    else return $57572f31ed5f364f$var$objClone(coll);
}
function $57572f31ed5f364f$var$freezeIfNeeded(coll) {
    $57572f31ed5f364f$var$weCareAbout(coll) && Object.isFrozen(coll);
    return coll;
}
function $57572f31ed5f364f$var$_freeze(coll) {
    return coll;
}
function $57572f31ed5f364f$var$baseFreeze(coll, prevNodes) {
    if (prevNodes.some(function(node) {
        return node === coll;
    })) throw new Error("object has a reference cycle");
    Object.freeze(coll);
    prevNodes.push(coll);
    Object.keys(coll).forEach(function(key) {
        var prop = coll[key];
        if ($57572f31ed5f364f$var$weCareAbout(prop)) $57572f31ed5f364f$var$baseFreeze(prop, prevNodes);
    });
    prevNodes.pop();
    return coll;
}
/**
 * recrursively freeze an object and all its child objects
 * @param  {Object|Array} coll
 * @return {Object|Array}
 */ module.exports.freeze = function freeze(coll) {
    return coll;
};
/**
 * recursively un-freeze an object, by cloning frozen collections
 * @param  {[type]} coll [description]
 * @return {[type]}      [description]
 */ module.exports.thaw = function thaw(coll) {
    if ($57572f31ed5f364f$var$weCareAbout(coll) && Object.isFrozen(coll)) {
        var newColl = $57572f31ed5f364f$var$clone(coll);
        Object.keys(newColl).forEach(function(key) {
            newColl[key] = thaw(newColl[key]);
        });
        return newColl;
    }
    return coll;
};
/**
 * set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {String|Number} key   Key or index
 * @param  {Object}        value
 * @return {Object|Array}        new object hierarchy with modifications
 */ module.exports.assoc = function assoc(coll, key, value) {
    if (coll[key] === value) return $57572f31ed5f364f$var$_freeze(coll);
    var newObj = $57572f31ed5f364f$var$clone(coll);
    newObj[key] = $57572f31ed5f364f$var$freezeIfNeeded(value);
    return $57572f31ed5f364f$var$_freeze(newObj);
};
module.exports.set = module.exports.assoc;
/**
 * un-set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {String|Number} key  Key or Index
 * @return {Object|Array}       New object or array
 */ module.exports.dissoc = function dissoc(coll, key) {
    var newObj = $57572f31ed5f364f$var$clone(coll);
    delete newObj[key];
    return $57572f31ed5f364f$var$_freeze(newObj);
};
module.exports.unset = module.exports.dissoc;
/**
 * set a value deep in a hierarchical structure
 * @param  {Object|Array} coll
 * @param  {Array}        path    A list of keys to traverse
 * @param  {Object}       value
 * @return {Object|Array}       new object hierarchy with modifications
 */ module.exports.assocIn = function assocIn(coll, path, value) {
    var key0 = path[0];
    if (path.length === 1) // simplest case is a 1-element array.  Just a simple assoc.
    return $57572f31ed5f364f$var$i.assoc(coll, key0, value);
    else // break the problem down.  Assoc this object with the first key
    // and the result of assocIn with the rest of the keys
    return $57572f31ed5f364f$var$i.assoc(coll, key0, assocIn(coll[key0] || {}, path.slice(1), value));
};
module.exports.setIn = module.exports.assocIn;
/**
 * get an object from a hierachy based on an array of keys
 * @param  {Object|Array} coll
 * @param  {Array}        path    list of keys
 * @return {Object}       value, or undefined
 */ function $57572f31ed5f364f$var$baseGet(coll, path) {
    return (path || []).reduce(function(curr, key) {
        if (!curr) return;
        return curr[key];
    }, coll);
}
module.exports.getIn = $57572f31ed5f364f$var$baseGet;
/**
 * Update a value in a hierarchy
 * @param  {Object|Array}   coll
 * @param  {Array}          path     list of keys
 * @param  {Function} callback The existing value with be passed to this.
 *                             Return the new value to set
 * @return {Object|Array}      new object hierarchy with modifications
 */ module.exports.updateIn = function updateIn(coll, path, callback) {
    var existingVal = $57572f31ed5f364f$var$baseGet(coll, path);
    return $57572f31ed5f364f$var$i.assocIn(coll, path, callback(existingVal));
};
// generate wrappers for the mutative array methods
[
    "push",
    "unshift",
    "pop",
    "shift",
    "reverse",
    "sort"
].forEach(function(methodName) {
    module.exports[methodName] = function(arr, val) {
        var newArr = $57572f31ed5f364f$var$arrayClone(arr);
        newArr[methodName]($57572f31ed5f364f$var$freezeIfNeeded(val));
        return $57572f31ed5f364f$var$_freeze(newArr);
    };
    module.exports[methodName].displayName = "icepick." + methodName;
});
// splice is special because it is variadic
module.exports.splice = function splice(arr /*, args*/ ) {
    var newArr = $57572f31ed5f364f$var$arrayClone(arr), args = $57572f31ed5f364f$var$rest(arguments).map($57572f31ed5f364f$var$freezeIfNeeded);
    newArr.splice.apply(newArr, args);
    return $57572f31ed5f364f$var$_freeze(newArr);
};
// slice is non-mutative
module.exports.slice = function slice(arr, arg1, arg2) {
    var newArr = arr.slice(arg1, arg2);
    return $57572f31ed5f364f$var$_freeze(newArr);
};
[
    "map",
    "filter"
].forEach(function(methodName) {
    module.exports[methodName] = function(fn, arr) {
        var newArr = arr[methodName](fn);
        return $57572f31ed5f364f$var$_freeze(newArr);
    };
    module.exports[methodName].displayName = "icepick." + methodName;
});
module.exports.extend = module.exports.assign = function assign() {
    var newObj = $57572f31ed5f364f$var$rest(arguments).reduce($57572f31ed5f364f$var$singleAssign, arguments[0]);
    return $57572f31ed5f364f$var$_freeze(newObj);
};
function $57572f31ed5f364f$var$singleAssign(obj1, obj2) {
    return Object.keys(obj2).reduce(function(obj, key) {
        return $57572f31ed5f364f$var$i.assoc(obj, key, obj2[key]);
    }, obj1);
}
module.exports.merge = $57572f31ed5f364f$var$merge;
function $57572f31ed5f364f$var$merge(target, source, resolver) {
    if (target == null || source == null) return target;
    return Object.keys(source).reduce(function(obj, key) {
        var sourceVal = source[key];
        var targetVal = obj[key];
        var resolvedSourceVal = resolver ? resolver(targetVal, sourceVal, key) : sourceVal;
        if ($57572f31ed5f364f$var$weCareAbout(sourceVal) && $57572f31ed5f364f$var$weCareAbout(targetVal)) {
            // if they are both frozen and reference equal, assume they are deep equal
            if (Object.isFrozen(resolvedSourceVal) && Object.isFrozen(targetVal), resolvedSourceVal === targetVal) return obj;
            if (Array.isArray(sourceVal)) return $57572f31ed5f364f$var$i.assoc(obj, key, resolvedSourceVal);
            // recursively merge pairs of objects
            return $57572f31ed5f364f$var$assocIfDifferent(obj, key, $57572f31ed5f364f$var$merge(targetVal, resolvedSourceVal, resolver));
        }
        // primitive values, stuff with prototypes
        return $57572f31ed5f364f$var$assocIfDifferent(obj, key, resolvedSourceVal);
    }, target);
}
function $57572f31ed5f364f$var$assocIfDifferent(target, key, value) {
    if (target[key] === value) return target;
    return $57572f31ed5f364f$var$i.assoc(target, key, value);
}
function $57572f31ed5f364f$var$_slice(array, start) {
    var begin = start || 0;
    var len = array.length;
    len -= begin;
    len = len < 0 ? 0 : len;
    var result = new Array(len);
    for(var i = 0; i < len; i += 1)result[i] = array[i + begin];
    return result;
}
function $57572f31ed5f364f$var$rest(args) {
    return $57572f31ed5f364f$var$_slice(args, 1);
}
var $57572f31ed5f364f$var$chainProto = {
    value: function value() {
        return this.val;
    },
    thru: function thru(fn) {
        this.val = $57572f31ed5f364f$var$freezeIfNeeded(fn(this.val));
        return this;
    }
};
Object.keys(module.exports).forEach(function(methodName) {
    $57572f31ed5f364f$var$chainProto[methodName] = function() {
        var args = $57572f31ed5f364f$var$_slice(arguments);
        args.unshift(this.val);
        this.val = module.exports[methodName].apply(null, args);
        return this;
    };
});
module.exports.chain = function chain(val) {
    var wrapped = Object.create($57572f31ed5f364f$var$chainProto);
    wrapped.val = val;
    return wrapped;
};
// for testing
module.exports._weCareAbout = $57572f31ed5f364f$var$weCareAbout;
module.exports._slice = $57572f31ed5f364f$var$_slice;

});

parcelRegister("bSOOm", function(module, exports) {

$parcel$export(module.exports, "ExperienceTrackerContext", () => $0be6218364f10f40$export$a7b0697657ed8bd0);

var $5uXOq = parcelRequire("5uXOq");
const $0be6218364f10f40$export$a7b0697657ed8bd0 = (0, $5uXOq.createContext)({
    abort () {},
    fail () {},
    start () {},
    succeed () {},
    stopOnError () {},
    subscribe () {
        return ()=>{};
    }
});

});

parcelRegister("eCZ6m", function(module, exports) {

$parcel$export(module.exports, "getAggEndpoint", () => $3d812b79ec4c2140$export$fd126d8de571b77d);
$parcel$export(module.exports, "getRequestBody", () => $3d812b79ec4c2140$export$55bce18df99af758);

var $6cAn5 = parcelRequire("6cAn5");
const $3d812b79ec4c2140$var$branchSlug = typeof $6cAn5 !== 'undefined' && $6cAn5.env ? undefined : undefined;
const $3d812b79ec4c2140$var$aggPathname = `/gateway/api/graphql${$3d812b79ec4c2140$var$branchSlug ? `/${$3d812b79ec4c2140$var$branchSlug}/graphql` : ''}`;
const $3d812b79ec4c2140$export$fd126d8de571b77d = (request, cacheConfig = {})=>{
    let endpoint = $3d812b79ec4c2140$var$aggPathname;
    if (cacheConfig.metadata?.META_SLOW_ENDPOINT) endpoint = `${endpoint}/slow`;
    if (request.id != null) endpoint = `${endpoint}/pq/${request.id}`;
    return `${endpoint}?operation=${request.name}`;
};
const $3d812b79ec4c2140$export$55bce18df99af758 = (request, variables)=>{
    const requestBody = {
        operationName: request.name,
        variables: variables
    };
    return JSON.stringify(requestBody);
};

});

parcelRegister("4pgHP", function(module, exports) {

$parcel$export(module.exports, "startCapturingExtensions", () => $2dde2e1ea361345d$export$8656ba3981c6f6c1);
$parcel$export(module.exports, "stopCapturingExtensions", () => $2dde2e1ea361345d$export$f16fa6040161f056);
$parcel$export(module.exports, "putExtensions", () => $2dde2e1ea361345d$export$17dc47fdf278de21);
$parcel$export(module.exports, "getExtensions", () => $2dde2e1ea361345d$export$7c6ea4184129ef74);
const $2dde2e1ea361345d$var$OperationExtensionsMap = {};
const $2dde2e1ea361345d$export$8656ba3981c6f6c1 = (operationName)=>{
    $2dde2e1ea361345d$var$OperationExtensionsMap[operationName] = $2dde2e1ea361345d$var$OperationExtensionsMap[operationName] || [];
};
const $2dde2e1ea361345d$export$f16fa6040161f056 = (operationName)=>{
    $2dde2e1ea361345d$var$OperationExtensionsMap[operationName] = undefined;
};
const $2dde2e1ea361345d$export$17dc47fdf278de21 = (operationName, extension)=>{
    if (extension !== undefined) {
        const extensionsForOperation = $2dde2e1ea361345d$var$OperationExtensionsMap[operationName];
        if (extensionsForOperation !== undefined) extensionsForOperation.push(extension);
    }
};
const $2dde2e1ea361345d$export$7c6ea4184129ef74 = (operationName)=>$2dde2e1ea361345d$var$OperationExtensionsMap[operationName] || [];

});

parcelRegister("5Wobd", function(module, exports) {

$parcel$export(module.exports, "startCapturingTraceIds", () => $4d54017c044669f2$export$a2bcb2fac360646c);
$parcel$export(module.exports, "stopCapturingTraceIds", () => $4d54017c044669f2$export$559128bdc4352001);
$parcel$export(module.exports, "addTraceId", () => $4d54017c044669f2$export$fcaa732775f12226);
$parcel$export(module.exports, "getTraceIds", () => $4d54017c044669f2$export$5113e470f5c95670);
const $4d54017c044669f2$var$OperationTraceIdMap = {};
const $4d54017c044669f2$export$a2bcb2fac360646c = (operationName)=>{
    $4d54017c044669f2$var$OperationTraceIdMap[operationName] = $4d54017c044669f2$var$OperationTraceIdMap[operationName] || [];
};
const $4d54017c044669f2$export$559128bdc4352001 = (operationName)=>{
    $4d54017c044669f2$var$OperationTraceIdMap[operationName] = undefined;
};
const $4d54017c044669f2$export$fcaa732775f12226 = (operationName, traceId)=>{
    if (traceId !== undefined) {
        const traceIdsForOperation = $4d54017c044669f2$var$OperationTraceIdMap[operationName];
        if (traceIdsForOperation !== undefined) traceIdsForOperation.push(traceId);
    }
};
const $4d54017c044669f2$export$5113e470f5c95670 = (operationName)=>$4d54017c044669f2$var$OperationTraceIdMap[operationName] || [];

});

parcelRegister("aB8eX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.batchActions = $7b73c06d66cb3e3d$var$batchActions;
module.exports.enableBatching = $7b73c06d66cb3e3d$var$enableBatching;
module.exports.batchDispatchMiddleware = $7b73c06d66cb3e3d$var$batchDispatchMiddleware;
var $7b73c06d66cb3e3d$var$BATCH = module.exports.BATCH = 'BATCHING_REDUCER.BATCH';
function $7b73c06d66cb3e3d$var$batchActions(actions) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7b73c06d66cb3e3d$var$BATCH;
    return {
        type: type,
        meta: {
            batch: true
        },
        payload: actions
    };
}
function $7b73c06d66cb3e3d$var$enableBatching(reduce) {
    return function batchingReducer(state, action) {
        if (action && action.meta && action.meta.batch) return action.payload.reduce(batchingReducer, state);
        return reduce(state, action);
    };
}
function $7b73c06d66cb3e3d$var$batchDispatchMiddleware(store) {
    function dispatchChildActions(store, action) {
        if (action.meta && action.meta.batch) action.payload.forEach(function(childAction) {
            dispatchChildActions(store, childAction);
        });
        else store.dispatch(action);
    }
    return function(next) {
        return function(action) {
            if (action && action.meta && action.meta.batch) dispatchChildActions(store, action);
            return next(action);
        };
    };
}

});

parcelRegister("korqb", function(module, exports) {
!function(e, t) {
    t(module.exports);
}(module.exports, function(e) {
    "use strict";
    function t(e, t) {
        e.super_ = t, e.prototype = Object.create(t.prototype, {
            constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        });
    }
    function r(e, t) {
        Object.defineProperty(this, "kind", {
            value: e,
            enumerable: !0
        }), t && t.length && Object.defineProperty(this, "path", {
            value: t,
            enumerable: !0
        });
    }
    function n(e, t, r) {
        n.super_.call(this, "E", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "rhs", {
            value: r,
            enumerable: !0
        });
    }
    function o(e, t) {
        o.super_.call(this, "N", e), Object.defineProperty(this, "rhs", {
            value: t,
            enumerable: !0
        });
    }
    function i(e, t) {
        i.super_.call(this, "D", e), Object.defineProperty(this, "lhs", {
            value: t,
            enumerable: !0
        });
    }
    function a(e, t, r) {
        a.super_.call(this, "A", e), Object.defineProperty(this, "index", {
            value: t,
            enumerable: !0
        }), Object.defineProperty(this, "item", {
            value: r,
            enumerable: !0
        });
    }
    function f(e, t, r) {
        var n = e.slice((r || t) + 1 || e.length);
        return e.length = t < 0 ? e.length + t : t, e.push.apply(e, n), e;
    }
    function u(e) {
        var t = "undefined" == typeof e ? "undefined" : N(e);
        return "object" !== t ? t : e === Math ? "math" : null === e ? "null" : Array.isArray(e) ? "array" : "[object Date]" === Object.prototype.toString.call(e) ? "date" : "function" == typeof e.toString && /^\/.*\//.test(e.toString()) ? "regexp" : "object";
    }
    function l(e, t, r, c, s, d, p) {
        s = s || [], p = p || [];
        var g = s.slice(0);
        if ("undefined" != typeof d) {
            if (c) {
                if ("function" == typeof c && c(g, d)) return;
                if ("object" === ("undefined" == typeof c ? "undefined" : N(c))) {
                    if (c.prefilter && c.prefilter(g, d)) return;
                    if (c.normalize) {
                        var h = c.normalize(g, d, e, t);
                        h && (e = h[0], t = h[1]);
                    }
                }
            }
            g.push(d);
        }
        "regexp" === u(e) && "regexp" === u(t) && (e = e.toString(), t = t.toString());
        var y = "undefined" == typeof e ? "undefined" : N(e), v = "undefined" == typeof t ? "undefined" : N(t), b = "undefined" !== y || p && p[p.length - 1].lhs && p[p.length - 1].lhs.hasOwnProperty(d), m = "undefined" !== v || p && p[p.length - 1].rhs && p[p.length - 1].rhs.hasOwnProperty(d);
        if (!b && m) r(new o(g, t));
        else if (!m && b) r(new i(g, e));
        else if (u(e) !== u(t)) r(new n(g, e, t));
        else if ("date" === u(e) && e - t !== 0) r(new n(g, e, t));
        else if ("object" === y && null !== e && null !== t) {
            if (p.filter(function(t) {
                return t.lhs === e;
            }).length) e !== t && r(new n(g, e, t));
            else {
                if (p.push({
                    lhs: e,
                    rhs: t
                }), Array.isArray(e)) {
                    var w;
                    e.length;
                    for(w = 0; w < e.length; w++)w >= t.length ? r(new a(g, w, new i(void 0, e[w]))) : l(e[w], t[w], r, c, g, w, p);
                    for(; w < t.length;)r(new a(g, w, new o(void 0, t[w++])));
                } else {
                    var x = Object.keys(e), S = Object.keys(t);
                    x.forEach(function(n, o) {
                        var i = S.indexOf(n);
                        i >= 0 ? (l(e[n], t[n], r, c, g, n, p), S = f(S, i)) : l(e[n], void 0, r, c, g, n, p);
                    }), S.forEach(function(e) {
                        l(void 0, t[e], r, c, g, e, p);
                    });
                }
                p.length = p.length - 1;
            }
        } else e !== t && ("number" === y && isNaN(e) && isNaN(t) || r(new n(g, e, t)));
    }
    function c(e, t, r, n) {
        return n = n || [], l(e, t, function(e) {
            e && n.push(e);
        }, r), n.length ? n : void 0;
    }
    function s(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    s(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    delete o[r.path[n]];
                    break;
                case "E":
                case "N":
                    o[r.path[n]] = r.rhs;
            }
        } else switch(r.kind){
            case "A":
                s(e[t], r.index, r.item);
                break;
            case "D":
                e = f(e, t);
                break;
            case "E":
            case "N":
                e[t] = r.rhs;
        }
        return e;
    }
    function d(e, t, r) {
        if (e && t && r && r.kind) {
            for(var n = e, o = -1, i = r.path ? r.path.length - 1 : 0; ++o < i;)"undefined" == typeof n[r.path[o]] && (n[r.path[o]] = "number" == typeof r.path[o] ? [] : {}), n = n[r.path[o]];
            switch(r.kind){
                case "A":
                    s(r.path ? n[r.path[o]] : n, r.index, r.item);
                    break;
                case "D":
                    delete n[r.path[o]];
                    break;
                case "E":
                case "N":
                    n[r.path[o]] = r.rhs;
            }
        }
    }
    function p(e, t, r) {
        if (r.path && r.path.length) {
            var n, o = e[t], i = r.path.length - 1;
            for(n = 0; n < i; n++)o = o[r.path[n]];
            switch(r.kind){
                case "A":
                    p(o[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    o[r.path[n]] = r.lhs;
                    break;
                case "E":
                    o[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete o[r.path[n]];
            }
        } else switch(r.kind){
            case "A":
                p(e[t], r.index, r.item);
                break;
            case "D":
                e[t] = r.lhs;
                break;
            case "E":
                e[t] = r.lhs;
                break;
            case "N":
                e = f(e, t);
        }
        return e;
    }
    function g(e, t, r) {
        if (e && t && r && r.kind) {
            var n, o, i = e;
            for(o = r.path.length - 1, n = 0; n < o; n++)"undefined" == typeof i[r.path[n]] && (i[r.path[n]] = {}), i = i[r.path[n]];
            switch(r.kind){
                case "A":
                    p(i[r.path[n]], r.index, r.item);
                    break;
                case "D":
                    i[r.path[n]] = r.lhs;
                    break;
                case "E":
                    i[r.path[n]] = r.lhs;
                    break;
                case "N":
                    delete i[r.path[n]];
            }
        }
    }
    function h(e, t, r) {
        if (e && t) {
            var n = function(n) {
                r && !r(e, t, n) || d(e, t, n);
            };
            l(e, t, n);
        }
    }
    function y(e) {
        return "color: " + F[e].color + "; font-weight: bold";
    }
    function v(e) {
        var t = e.kind, r = e.path, n = e.lhs, o = e.rhs, i = e.index, a = e.item;
        switch(t){
            case "E":
                return [
                    r.join("."),
                    n,
                    "\u2192",
                    o
                ];
            case "N":
                return [
                    r.join("."),
                    o
                ];
            case "D":
                return [
                    r.join(".")
                ];
            case "A":
                return [
                    r.join(".") + "[" + i + "]",
                    a
                ];
            default:
                return [];
        }
    }
    function b(e, t, r, n) {
        var o = c(e, t);
        try {
            n ? r.groupCollapsed("diff") : r.group("diff");
        } catch (e) {
            r.log("diff");
        }
        o ? o.forEach(function(e) {
            var t = e.kind, n = v(e);
            r.log.apply(r, [
                "%c " + F[t].text,
                y(t)
            ].concat(P(n)));
        }) : r.log("\u2014\u2014 no diff \u2014\u2014");
        try {
            r.groupEnd();
        } catch (e) {
            r.log("\u2014\u2014 diff end \u2014\u2014 ");
        }
    }
    function m(e, t, r, n) {
        switch("undefined" == typeof e ? "undefined" : N(e)){
            case "object":
                return "function" == typeof e[n] ? e[n].apply(e, P(r)) : e[n];
            case "function":
                return e(t);
            default:
                return e;
        }
    }
    function w(e) {
        var t = e.timestamp, r = e.duration;
        return function(e, n, o) {
            var i = [
                "action"
            ];
            return i.push("%c" + String(e.type)), t && i.push("%c@ " + n), r && i.push("%c(in " + o.toFixed(2) + " ms)"), i.join(" ");
        };
    }
    function x(e, t) {
        var r = t.logger, n = t.actionTransformer, o = t.titleFormatter, i = void 0 === o ? w(t) : o, a = t.collapsed, f = t.colors, u = t.level, l = t.diff, c = "undefined" == typeof t.titleFormatter;
        e.forEach(function(o, s) {
            var d = o.started, p = o.startedTime, g = o.action, h = o.prevState, y = o.error, v = o.took, w = o.nextState, x = e[s + 1];
            x && (w = x.prevState, v = x.started - d);
            var S = n(g), k = "function" == typeof a ? a(function() {
                return w;
            }, g, o) : a, j = D(p), E = f.title ? "color: " + f.title(S) + ";" : "", A = [
                "color: gray; font-weight: lighter;"
            ];
            A.push(E), t.timestamp && A.push("color: gray; font-weight: lighter;"), t.duration && A.push("color: gray; font-weight: lighter;");
            var O = i(S, j, v);
            try {
                k ? f.title && c ? r.groupCollapsed.apply(r, [
                    "%c " + O
                ].concat(A)) : r.groupCollapsed(O) : f.title && c ? r.group.apply(r, [
                    "%c " + O
                ].concat(A)) : r.group(O);
            } catch (e) {
                r.log(O);
            }
            var N = m(u, S, [
                h
            ], "prevState"), P = m(u, S, [
                S
            ], "action"), C = m(u, S, [
                y,
                h
            ], "error"), F = m(u, S, [
                w
            ], "nextState");
            if (N) {
                if (f.prevState) {
                    var L = "color: " + f.prevState(h) + "; font-weight: bold";
                    r[N]("%c prev state", L, h);
                } else r[N]("prev state", h);
            }
            if (P) {
                if (f.action) {
                    var T = "color: " + f.action(S) + "; font-weight: bold";
                    r[P]("%c action    ", T, S);
                } else r[P]("action    ", S);
            }
            if (y && C) {
                if (f.error) {
                    var M = "color: " + f.error(y, h) + "; font-weight: bold;";
                    r[C]("%c error     ", M, y);
                } else r[C]("error     ", y);
            }
            if (F) {
                if (f.nextState) {
                    var _ = "color: " + f.nextState(w) + "; font-weight: bold";
                    r[F]("%c next state", _, w);
                } else r[F]("next state", w);
            }
            l && b(h, w, r, k);
            try {
                r.groupEnd();
            } catch (e) {
                r.log("\u2014\u2014 log end \u2014\u2014");
            }
        });
    }
    function S() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = Object.assign({}, L, e), r = t.logger, n = t.stateTransformer, o = t.errorTransformer, i = t.predicate, a = t.logErrors, f = t.diffPredicate;
        if ("undefined" == typeof r) return function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        if (e.getState && e.dispatch) return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"), function() {
            return function(e) {
                return function(t) {
                    return e(t);
                };
            };
        };
        var u = [];
        return function(e) {
            var r = e.getState;
            return function(e) {
                return function(l) {
                    if ("function" == typeof i && !i(r, l)) return e(l);
                    var c = {};
                    u.push(c), c.started = O.now(), c.startedTime = new Date, c.prevState = n(r()), c.action = l;
                    var s = void 0;
                    if (a) try {
                        s = e(l);
                    } catch (e) {
                        c.error = o(e);
                    }
                    else s = e(l);
                    c.took = O.now() - c.started, c.nextState = n(r());
                    var d = t.diff && "function" == typeof f ? f(r, l) : t.diff;
                    if (x(u, Object.assign({}, t, {
                        diff: d
                    })), u.length = 0, c.error) throw c.error;
                    return s;
                };
            };
        };
    }
    var k, j, E = function(e, t) {
        return new Array(t + 1).join(e);
    }, A = function(e, t) {
        return E("0", t - e.toString().length) + e;
    }, D = function(e) {
        return A(e.getHours(), 2) + ":" + A(e.getMinutes(), 2) + ":" + A(e.getSeconds(), 2) + "." + A(e.getMilliseconds(), 3);
    }, O = "undefined" != typeof performance && null !== performance && "function" == typeof performance.now ? performance : Date, N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, P = function(e) {
        if (Array.isArray(e)) {
            for(var t = 0, r = Array(e.length); t < e.length; t++)r[t] = e[t];
            return r;
        }
        return Array.from(e);
    }, C = [];
    k = "object" === ("undefined" == typeof $parcel$global ? "undefined" : N($parcel$global)) && $parcel$global ? $parcel$global : "undefined" != typeof window ? window : {}, j = k.DeepDiff, j && C.push(function() {
        "undefined" != typeof j && k.DeepDiff === c && (k.DeepDiff = j, j = void 0);
    }), t(n, r), t(o, r), t(i, r), t(a, r), Object.defineProperties(c, {
        diff: {
            value: c,
            enumerable: !0
        },
        observableDiff: {
            value: l,
            enumerable: !0
        },
        applyDiff: {
            value: h,
            enumerable: !0
        },
        applyChange: {
            value: d,
            enumerable: !0
        },
        revertChange: {
            value: g,
            enumerable: !0
        },
        isConflict: {
            value: function() {
                return "undefined" != typeof j;
            },
            enumerable: !0
        },
        noConflict: {
            value: function() {
                return C && (C.forEach(function(e) {
                    e();
                }), C = null), c;
            },
            enumerable: !0
        }
    });
    var F = {
        E: {
            color: "#2196F3",
            text: "CHANGED:"
        },
        N: {
            color: "#4CAF50",
            text: "ADDED:"
        },
        D: {
            color: "#F44336",
            text: "DELETED:"
        },
        A: {
            color: "#2196F3",
            text: "ARRAY:"
        }
    }, L = {
        level: "log",
        logger: console,
        logErrors: !0,
        collapsed: void 0,
        predicate: void 0,
        duration: !1,
        timestamp: !0,
        stateTransformer: function(e) {
            return e;
        },
        actionTransformer: function(e) {
            return e;
        },
        errorTransformer: function(e) {
            return e;
        },
        colors: {
            title: function() {
                return "inherit";
            },
            prevState: function() {
                return "#9E9E9E";
            },
            action: function() {
                return "#03A9F4";
            },
            nextState: function() {
                return "#4CAF50";
            },
            error: function() {
                return "#F20404";
            }
        },
        diff: !1,
        diffPredicate: void 0,
        transformer: void 0
    }, T = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.dispatch, r = e.getState;
        return "function" == typeof t || "function" == typeof r ? S()({
            dispatch: t,
            getState: r
        }) : void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n");
    };
    e.defaults = L, e.createLogger = S, e.logger = T, e.default = T, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

});

parcelRegister("ifg6x", function(module, exports) {

var $4CZTG = parcelRequire("4CZTG");
/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */ var $d4861eb268113e50$var$partition = $4CZTG(function(result, value, key) {
    result[key ? 0 : 1].push(value);
}, function() {
    return [
        [],
        []
    ];
});
module.exports = $d4861eb268113e50$var$partition;

});
parcelRegister("4CZTG", function(module, exports) {

var $hBvrS = parcelRequire("hBvrS");

var $fqzo0 = parcelRequire("fqzo0");

var $bxDef = parcelRequire("bxDef");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $35eab98708747af8$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $8LQ84(collection) ? $hBvrS : $fqzo0, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $bxDef(iteratee, 2), accumulator);
    };
}
module.exports = $35eab98708747af8$var$createAggregator;

});
parcelRegister("hBvrS", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $cd0e496a488f8bed$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $cd0e496a488f8bed$var$arrayAggregator;

});

parcelRegister("fqzo0", function(module, exports) {

var $e7pfQ = parcelRequire("e7pfQ");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $b3b4bba991f8eee5$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $e7pfQ(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $b3b4bba991f8eee5$var$baseAggregator;

});
parcelRegister("e7pfQ", function(module, exports) {

var $hDnyx = parcelRequire("hDnyx");

var $bogqY = parcelRequire("bogqY");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $a4754f2fa2dabe99$var$baseEach = $bogqY($hDnyx);
module.exports = $a4754f2fa2dabe99$var$baseEach;

});
parcelRegister("hDnyx", function(module, exports) {

var $et7t4 = parcelRequire("et7t4");

var $66FNL = parcelRequire("66FNL");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $cd6859e7c62c7d41$var$baseForOwn(object, iteratee) {
    return object && $et7t4(object, iteratee, $66FNL);
}
module.exports = $cd6859e7c62c7d41$var$baseForOwn;

});

parcelRegister("bogqY", function(module, exports) {

var $hTJwX = parcelRequire("hTJwX");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $84aeaf14b55f70e4$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$hTJwX(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $84aeaf14b55f70e4$var$createBaseEach;

});





parcelRegister("5euJh", function(module, exports) {

$parcel$export(module.exports, "getATLContextDomain", () => $4999809f6856da20$export$b5ce351acdc48c2a);
$parcel$export(module.exports, "getATLContextUrl", () => $4999809f6856da20$export$45d6512913ef41b4);


var $k8H7R = parcelRequire("k8H7R");

var $6hv9b = parcelRequire("6hv9b");
function $4999809f6856da20$export$8d21e34596265fa2(data) {
    if (!data || Object.keys(data).length < 1) throw new Error('Data are not available');
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    globalThis.ATL_CONTEXT_DOMAIN = data;
}
function $4999809f6856da20$var$isValidDomainKey(domainKey) {
    if (!(0, $6hv9b.AllowedDomains).includes(domainKey)) return false;
    return true;
}
function $4999809f6856da20$export$b5ce351acdc48c2a(domain, environment) {
    // Validate this is a valid domain
    if (!$4999809f6856da20$var$isValidDomainKey(domain)) throw new Error(`Domain ${domain} is not supported.
      Supported domains: ${(0, $6hv9b.AllowedDomains).join(', ')}`);
    // First priority, always return the global context if the product has onboarded
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    const data = globalThis.ATL_CONTEXT_DOMAIN;
    if (data) return data[domain];
    const [env, perimeter] = environment ?? $4999809f6856da20$export$509d18a5fd824839();
    // Second priority, return if there is a full domain override
    const override = (0, $k8H7R.fullDomainOverride)[domain];
    if (override) return(// Exact match preferred
    override[perimeter]?.[env] ?? override[0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f][0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9] // Fallback to mandatory commercial production
    );
    // Third priority, join the subdomain
    const tld = (0, $k8H7R.domainMap)[perimeter]?.[env] ?? (0, $k8H7R.domainMap)[0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f][0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9];
    const subdomain = (0, $k8H7R.subdomainOverride)[domain] ?? domain;
    return `${subdomain}.${tld}`;
}
function $4999809f6856da20$export$45d6512913ef41b4(domain) {
    return `${globalThis.location.protocol}//${$4999809f6856da20$export$b5ce351acdc48c2a(domain)}`;
}
function $4999809f6856da20$export$509d18a5fd824839() {
    const hostname = globalThis.location?.hostname;
    if (!hostname) // default if no location available
    return [
        (0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9),
        (0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)
    ];
    // *.atlassian-fex.com
    if (hostname.match(/atlassian-fex\.com/)) return [
        (0, $5f2d1e7b8a614058$export$a739cd5aac835909),
        (0, $5f2d1e7b8a614058$export$bd6b5a7802d76127)
    ];
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (hostname.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $5f2d1e7b8a614058$export$a739cd5aac835909),
        (0, $5f2d1e7b8a614058$export$ce553301d55c2fd8)
    ];
    // *.atlassian-stg-fedm.net
    if (hostname.match(/atlassian-stg-fedm\.net/)) return [
        (0, $5f2d1e7b8a614058$export$a739cd5aac835909),
        (0, $5f2d1e7b8a614058$export$ce553301d55c2fd8)
    ];
    // *.atlassian-us-gov-mod.com OR *.atlassian-us-gov-mod.net
    if (hostname.match(/atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9),
        (0, $5f2d1e7b8a614058$export$ce553301d55c2fd8)
    ];
    // *.stg.atlassian.com OR *.stg.internal.atlassian.com
    if (hostname.match(/stg(\.internal)?\.atlassian\.com/)) return [
        (0, $5f2d1e7b8a614058$export$a739cd5aac835909),
        (0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)
    ];
    // *.jira-dev.com
    if (hostname.match(/jira-dev\.com/)) return [
        (0, $5f2d1e7b8a614058$export$a739cd5aac835909),
        (0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)
    ];
    // default fallthrough
    return [
        (0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9),
        (0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)
    ];
}

});
const $5f2d1e7b8a614058$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $5f2d1e7b8a614058$export$f005e2e9f707cb5f = 'commercial';
const $5f2d1e7b8a614058$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $5f2d1e7b8a614058$export$a739cd5aac835909 = 'stg';
const $5f2d1e7b8a614058$export$42dd0cdd351a4a9 = 'prod';
const $5f2d1e7b8a614058$export$404582bc18fe4d9e = 'dev';

parcelRegister("k8H7R", function(module, exports) {

$parcel$export(module.exports, "domainMap", () => $85d3c71d4c30886b$export$6836b090dbaa813a);
$parcel$export(module.exports, "subdomainOverride", () => $85d3c71d4c30886b$export$c6ab20d0ac4d06b2);
$parcel$export(module.exports, "fullDomainOverride", () => $85d3c71d4c30886b$export$4723232b625f823e);

const $85d3c71d4c30886b$export$6836b090dbaa813a = {
    [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
        [(0, $5f2d1e7b8a614058$export$a739cd5aac835909)]: 'stg.atlassian.com',
        [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'atlassian.com'
    },
    [(0, $5f2d1e7b8a614058$export$bd6b5a7802d76127)]: {
        [(0, $5f2d1e7b8a614058$export$a739cd5aac835909)]: 'atlassian-fex.com'
    },
    [(0, $5f2d1e7b8a614058$export$ce553301d55c2fd8)]: {
        [(0, $5f2d1e7b8a614058$export$a739cd5aac835909)]: 'stg.atlassian-us-gov-mod.com',
        [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'atlassian-us-gov-mod.com'
    }
};
const $85d3c71d4c30886b$export$c6ab20d0ac4d06b2 = {};
const $85d3c71d4c30886b$export$4723232b625f823e = {
    analytics: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'analytics.atlassian.com'
        }
    },
    // Marketing site
    confluence: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'confluence.atlassian.com'
        }
    },
    // Atlassian design system documentation
    design: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'design.atlassian.com'
        }
    },
    // Old staff intranet (now hello.atlassian.net)
    extranet: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'extranet.atlassian.com'
        }
    },
    // Go links
    go: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'go.atlassian.com'
        }
    },
    my: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'my.atlassian.com'
        }
    },
    schema: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'schema.atlassian.com'
        }
    },
    start: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'start.atlassian.com',
            [(0, $5f2d1e7b8a614058$export$a739cd5aac835909)]: 'start.stg.atlassian.com'
        },
        [(0, $5f2d1e7b8a614058$export$ce553301d55c2fd8)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'start.atlassian-us-gov-mod.com',
            [(0, $5f2d1e7b8a614058$export$a739cd5aac835909)]: 'start.stg.atlassian-us-gov-mod.com'
        }
    },
    surveys: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'surveys.atlassian.com'
        }
    },
    'wac-cdn': {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'wac-cdn.atlassian.com'
        }
    },
    integrations: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'integrations.atlassian.com'
        }
    },
    permalink: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'permalink.atlassian.com'
        }
    },
    id: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'id.atlassian.com',
            [(0, $5f2d1e7b8a614058$export$a739cd5aac835909)]: 'id.stg.internal.atlassian.com',
            [(0, $5f2d1e7b8a614058$export$404582bc18fe4d9e)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $5f2d1e7b8a614058$export$ce553301d55c2fd8)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'id.atlassian-us-gov-mod.com',
            [(0, $5f2d1e7b8a614058$export$a739cd5aac835909)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    },
    support: {
        [(0, $5f2d1e7b8a614058$export$f005e2e9f707cb5f)]: {
            [(0, $5f2d1e7b8a614058$export$42dd0cdd351a4a9)]: 'support.atlassian.com'
        }
    }
};

});

parcelRegister("6hv9b", function(module, exports) {

$parcel$export(module.exports, "AllowedDomains", () => $3e2a7375a344cb09$export$b450288891b9771b);
/* *NOTE*: please ensure any changes made to Perimeter and DomainKey type is copied in typings/atl-context.globals.d.ts */ const $3e2a7375a344cb09$export$b450288891b9771b = [
    'admin',
    'analytics',
    'api',
    'api.media',
    'api-private',
    'as',
    'atl-global',
    'atlaskit',
    'auth',
    'automation',
    'cassi.internal',
    'cc-import-sources.services',
    'confluence',
    'confluence-chats-integr.services',
    'confluence-cloud-bamboo.internal',
    'confluence-questions.services',
    'data-portal.internal',
    'design',
    'developer',
    'extranet',
    'go',
    'id',
    'id-mail-assets',
    'integrations',
    'ja',
    'jira',
    'jsd-widget',
    'jsd-widget-staging',
    'marketplace',
    'my',
    'my-reminders.services',
    'partners',
    'permalink',
    'permalink.stg',
    'schema',
    'start',
    'support',
    'surveys',
    'team',
    'wac-cdn',
    'xxid',
    'home'
];

});


parcelRegister("2I8bw", function(module, exports) {

$parcel$export(module.exports, "getInstance", () => $1a9f4d6c6e9968ea$export$8bedcca5bbd73999);

var $5euJh = parcelRequire("5euJh");

var $6WW6B = parcelRequire("6WW6B");

var $kBAuL = parcelRequire("kBAuL");
const $1a9f4d6c6e9968ea$var$redirect = ()=>{
    const identity = (0, $5euJh.getATLContextDomain)('id');
    // Hardcoding to Jira as this will be the only adopter of this service for now.
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(window.location.href)}`;
    window.location.assign(redirectUrl);
};
const $1a9f4d6c6e9968ea$var$DEFAULT_ENDPOINT = '/gateway/api/session/heartbeat';
const $1a9f4d6c6e9968ea$var$DEFAULT_IDLE_TIME = 60000;
const $1a9f4d6c6e9968ea$var$timeIsBeforeNow = (dateTime)=>{
    return !!(dateTime && dateTime.getTime() <= Date.now());
};
const $1a9f4d6c6e9968ea$var$HeartbeatService = ()=>{
    let timer;
    let heartBeatInterval;
    let nextCallTimestamp;
    let sessionExpiryTimestamp;
    let initialized = false;
    let authenticated = false;
    let userActive = true;
    let tabActive = true;
    const isAuthenticated = ()=>{
        return authenticated;
    };
    const isInitialized = ()=>{
        return initialized;
    };
    const init = ()=>{
        // Initial heartbeat
        beat();
        heartBeatInterval = setupHeartbeatInterval();
        timer = setupBrowserInteractionTime();
    };
    const cleanup = ()=>{
        clearHeartbeatInterval();
        clearBrowserInteractionTime();
    };
    const beat = async ()=>{
        try {
            const response = await (0, $kBAuL.postHeartbeat)($1a9f4d6c6e9968ea$var$DEFAULT_ENDPOINT, $1a9f4d6c6e9968ea$var$redirect);
            if (!initialized) initialized = true;
            if (response) {
                const { nextCallTimestamp: nextCallT, sessionExpiryTime: sessionExpiryT } = response;
                nextCallTimestamp = new Date(nextCallT);
                sessionExpiryTimestamp = sessionExpiryT ? new Date(sessionExpiryT) : undefined;
                authenticated = true;
            }
        } catch (error) {
            authenticated = false;
            clearHeartbeatInterval();
        }
    };
    const setupHeartbeatInterval = ()=>setInterval(()=>{
            if ($1a9f4d6c6e9968ea$var$timeIsBeforeNow(sessionExpiryTimestamp) || userActive && tabActive && $1a9f4d6c6e9968ea$var$timeIsBeforeNow(nextCallTimestamp)) beat();
        }, 10000);
    const clearHeartbeatInterval = ()=>{
        clearInterval(heartBeatInterval);
        heartBeatInterval = undefined;
    };
    const setupBrowserInteractionTime = ()=>{
        const timer = new (0, $6WW6B.default)({
            idleTimeoutMs: $1a9f4d6c6e9968ea$var$DEFAULT_IDLE_TIME,
            stopTimerOnTabchange: false,
            browserTabActiveCallbacks: [
                ()=>tabActive = true
            ],
            browserTabInactiveCallbacks: [
                ()=>tabActive = false
            ],
            idleCallbacks: [
                ()=>{
                    // Beat once when the user goes idle and the tab is active
                    if (tabActive) beat();
                    userActive = false;
                }
            ],
            activeCallbacks: [
                ()=>userActive = true
            ]
        });
        timer.startTimer();
        return timer;
    };
    const clearBrowserInteractionTime = ()=>{
        timer && timer.destroy();
        timer = undefined;
    };
    return {
        isAuthenticated: isAuthenticated,
        isInitialized: isInitialized,
        init: init,
        cleanup: cleanup
    };
};
let $1a9f4d6c6e9968ea$var$instance = null;
const $1a9f4d6c6e9968ea$export$8bedcca5bbd73999 = ()=>{
    if (!$1a9f4d6c6e9968ea$var$instance) {
        $1a9f4d6c6e9968ea$var$instance = $1a9f4d6c6e9968ea$var$HeartbeatService();
        $1a9f4d6c6e9968ea$var$instance.init();
    }
    return $1a9f4d6c6e9968ea$var$instance;
};

});
parcelRegister("6WW6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $02c9d75fd1e73e43$export$2e2bcd8739ae039);

var $34ck9 = parcelRequire("34ck9");
const $02c9d75fd1e73e43$var$windowIdleEvents = [
    'scroll',
    'resize'
];
const $02c9d75fd1e73e43$var$documentIdleEvents = [
    'wheel',
    'keydown',
    'keyup',
    'mousedown',
    'mousemove',
    'touchstart',
    'touchmove',
    'click',
    'contextmenu'
];
class $02c9d75fd1e73e43$export$2e2bcd8739ae039 {
    constructor({ timeIntervalEllapsedCallbacks: timeIntervalEllapsedCallbacks = [], absoluteTimeEllapsedCallbacks: absoluteTimeEllapsedCallbacks = [], checkCallbacksIntervalMs: checkCallbacksIntervalMs = 100, browserTabInactiveCallbacks: browserTabInactiveCallbacks = [], idleCallbacks: idleCallbacks = [], stopTimerOnTabchange: stopTimerOnTabchange = true, activeCallbacks: activeCallbacks = [], browserTabActiveCallbacks: browserTabActiveCallbacks = [], idleTimeoutMs: idleTimeoutMs = 3000 }){
        this.onBrowserTabInactive = ()=>{
            // if running pause timer
            if (this.isRunning() && this.stopTimerOnTabchange) this.stopTimer();
            this.browserTabInactiveCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
        };
        this.onBrowserTabActive = ()=>{
            // if not running start timer
            if (!this.isRunning()) this.startTimer();
            this.browserTabActiveCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
        };
        this.onBrowserActiveChange = ()=>{
            if (document.visibilityState === 'visible') this.onBrowserTabActive();
            else this.onBrowserTabInactive();
        };
        this.onTimePassed = ()=>{
            // check all callbacks time and if passed execute callback
            this.absoluteTimeEllapsedCallbacks.forEach(({ callback: callback, pending: pending, timeInMilliseconds: timeInMilliseconds }, index)=>{
                if (pending && timeInMilliseconds <= this.getTimeInMilliseconds()) {
                    callback(this.getTimeInMilliseconds());
                    this.absoluteTimeEllapsedCallbacks[index].pending = false;
                }
            });
            this.timeIntervalEllapsedCallbacks.forEach(({ callback: callback, timeInMilliseconds: timeInMilliseconds, multiplier: multiplier }, index)=>{
                if (timeInMilliseconds <= this.getTimeInMilliseconds()) {
                    callback(this.getTimeInMilliseconds());
                    this.timeIntervalEllapsedCallbacks[index].timeInMilliseconds = multiplier(timeInMilliseconds);
                }
            });
            if (this.currentIdleTimeMs >= this.idleTimeoutMs && this.isRunning()) {
                this.idle = true;
                this.stopTimer();
                this.idleCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
            } else this.currentIdleTimeMs += this.checkCallbacksIntervalMs;
        };
        this.resetIdleTime = ()=>{
            if (this.idle) this.startTimer();
            this.activeCallbacks.forEach((fn)=>fn(this.getTimeInMilliseconds()));
            this.idle = false;
            this.currentIdleTimeMs = 0;
        };
        this.registerEventListeners = ()=>{
            const documentListenerOptions = {
                passive: true
            };
            const windowListenerOptions = {
                ...documentListenerOptions,
                capture: true
            };
            document.addEventListener('visibilitychange', this.onBrowserActiveChange);
            const throttleResetIdleTime = (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(this.resetIdleTime, 2000, {
                leading: true,
                trailing: false
            });
            $02c9d75fd1e73e43$var$windowIdleEvents.forEach((event)=>{
                window.addEventListener(event, throttleResetIdleTime, windowListenerOptions);
            });
            $02c9d75fd1e73e43$var$documentIdleEvents.forEach((event)=>document.addEventListener(event, throttleResetIdleTime, documentListenerOptions));
        };
        this.unregisterEventListeners = ()=>{
            document.removeEventListener('visibilitychange', this.onBrowserActiveChange);
            $02c9d75fd1e73e43$var$windowIdleEvents.forEach((event)=>window.removeEventListener(event, this.resetIdleTime));
            $02c9d75fd1e73e43$var$documentIdleEvents.forEach((event)=>document.removeEventListener(event, this.resetIdleTime));
        };
        this.checkCallbacksOnInterval = ()=>{
            this.checkCallbackIntervalId = window.setInterval(()=>{
                this.onTimePassed();
            }, this.checkCallbacksIntervalMs);
        };
        this.startTimer = ()=>{
            if (!this.checkCallbackIntervalId) this.checkCallbacksOnInterval();
            const last = this.times[this.times.length - 1];
            if (last && last.stop === null) return;
            this.times.push({
                start: performance.now(),
                stop: null
            });
            this.running = true;
        };
        this.stopTimer = ()=>{
            if (!this.times.length) return;
            this.times[this.times.length - 1].stop = performance.now();
            this.running = false;
        };
        this.addTimeIntervalEllapsedCallback = (timeIntervalEllapsedCallback)=>{
            this.timeIntervalEllapsedCallbacks.push(timeIntervalEllapsedCallback);
        };
        this.addAbsoluteTimeEllapsedCallback = (absoluteTimeEllapsedCallback)=>{
            this.absoluteTimeEllapsedCallbacks.push(absoluteTimeEllapsedCallback);
        };
        this.addBrowserTabInactiveCallback = (browserTabInactiveCallback)=>{
            this.browserTabInactiveCallbacks.push(browserTabInactiveCallback);
        };
        this.addBrowserTabActiveCallback = (browserTabActiveCallback)=>{
            this.browserTabActiveCallbacks.push(browserTabActiveCallback);
        };
        this.addIdleCallback = (inactiveCallback)=>{
            this.idleCallbacks.push(inactiveCallback);
        };
        this.addActiveCallback = (activeCallback)=>{
            this.activeCallbacks.push(activeCallback);
        };
        this.getTimeInMilliseconds = ()=>{
            return this.times.reduce((acc, current)=>{
                if (current.stop) acc = acc + (current.stop - current.start);
                else acc = acc + (performance.now() - current.start);
                return acc;
            }, 0);
        };
        this.isRunning = ()=>{
            return this.running;
        };
        this.isIdle = ()=>{
            return this.idle;
        };
        this.reset = ()=>{
            this.times = [];
        };
        this.destroy = ()=>{
            this.unregisterEventListeners();
            if (this.checkCallbackIntervalId) window.clearInterval(this.checkCallbackIntervalId);
        };
        this.running = false;
        this.times = [];
        this.idle = false;
        this.currentIdleTimeMs = 0;
        this.marks = {};
        this.measures = {};
        this.stopTimerOnTabchange = stopTimerOnTabchange;
        this.browserTabActiveCallbacks = browserTabActiveCallbacks;
        this.browserTabInactiveCallbacks = browserTabInactiveCallbacks;
        this.checkCallbacksIntervalMs = checkCallbacksIntervalMs;
        this.idleTimeoutMs = idleTimeoutMs;
        this.timeIntervalEllapsedCallbacks = timeIntervalEllapsedCallbacks;
        this.absoluteTimeEllapsedCallbacks = absoluteTimeEllapsedCallbacks;
        this.idleCallbacks = idleCallbacks;
        this.activeCallbacks = activeCallbacks;
        this.registerEventListeners();
    }
    mark(key) {
        if (!this.marks[key]) this.marks[key] = [];
        this.marks[key].push({
            time: this.getTimeInMilliseconds()
        });
    }
    getMarks(name) {
        if (this.marks[name].length < 1) return;
        return this.marks[name];
    }
    measure(name, startMarkName, endMarkName) {
        const startMarks = this.marks[startMarkName];
        const startMark = startMarks[startMarks.length - 1];
        const endMarks = this.marks[endMarkName];
        const endMark = endMarks[endMarks.length - 1];
        if (!this.measures[name]) this.measures[name] = [];
        this.measures[name].push({
            name: name,
            startTime: startMark.time,
            duration: endMark.time - startMark.time
        });
    }
    getMeasures(name) {
        if (!this.measures[name] && this.measures[name].length < 1) return;
        return this.measures[name];
    }
}

});
parcelRegister("34ck9", function(module, exports) {

var $lFKmC = parcelRequire("lFKmC");

var $k0qYG = parcelRequire("k0qYG");
/** Error message constants. */ var $23bb4e171ff15bc1$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $23bb4e171ff15bc1$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($23bb4e171ff15bc1$var$FUNC_ERROR_TEXT);
    if ($k0qYG(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $lFKmC(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $23bb4e171ff15bc1$var$throttle;

});


parcelRegister("kBAuL", function(module, exports) {

$parcel$export(module.exports, "postHeartbeat", () => $7cff47c821db2dad$export$931f43089f67754c);
const $7cff47c821db2dad$var$RETRY_HTTP_CODES = [
    408,
    500,
    502,
    503,
    504,
    522,
    524
];
function $7cff47c821db2dad$var$timeout(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
async function $7cff47c821db2dad$var$fetchRetry(url, options = {}, retries = 5, backoff = 300) {
    const response = await fetch(url, options);
    if (response.ok || response.status === 401) return response;
    if (retries > 0 && $7cff47c821db2dad$var$RETRY_HTTP_CODES.includes(response.status)) {
        await $7cff47c821db2dad$var$timeout(backoff);
        return await $7cff47c821db2dad$var$fetchRetry(url, options, retries - 1, backoff * 2);
    } else return Promise.reject(response);
}
const $7cff47c821db2dad$export$931f43089f67754c = async (endpoint, onAuthenticationFailed, onBadRequest)=>{
    try {
        const response = await $7cff47c821db2dad$var$fetchRetry(endpoint, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response && response.ok) return response.json();
        if (response && response.status === 401 && onAuthenticationFailed) {
            onAuthenticationFailed();
            return;
        }
    } catch (e) {
        const errorResponse = e;
        if (errorResponse.status === 400) {
            onBadRequest?.();
            return Promise.reject(errorResponse);
        }
        if ($7cff47c821db2dad$var$RETRY_HTTP_CODES.includes(errorResponse.status)) console.warn('Heartbeat: Retried 5x, stopped to call api');
    }
};

});


parcelRegister("4U1PW", function(module, exports) {

$parcel$export(module.exports, "createClient", () => $391dd11e177a8b61$export$5d730b7aed1a3eb0);
/**
 *
 * client
 *
 */ 
var $l7Jgj = parcelRequire("l7Jgj");

var $7Tywk = parcelRequire("7Tywk");
var $391dd11e177a8b61$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $391dd11e177a8b61$var$__await ? (this.v = v, this) : new $391dd11e177a8b61$var$__await(v);
};
var $391dd11e177a8b61$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $391dd11e177a8b61$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $391dd11e177a8b61$export$5d730b7aed1a3eb0(options) {
    const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries) {
        let retryDelay = 1000; // start with 1s delay
        for(let i = 0; i < retries; i++)retryDelay *= 2;
        await new Promise((resolve)=>setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
            Math.floor(Math.random() * 2700 + 300)));
    }, shouldRetry: shouldRetry = $391dd11e177a8b61$var$isLikeCloseEvent, isFatalConnectionProblem: isFatalConnectionProblem, on: on, webSocketImpl: webSocketImpl, generateID: /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID = function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
    let ws;
    if (webSocketImpl) {
        if (!$391dd11e177a8b61$var$isWebSocket(webSocketImpl)) throw new Error('Invalid WebSocket implementation provided');
        ws = webSocketImpl;
    } else if (typeof WebSocket !== 'undefined') ws = WebSocket;
    else if (typeof $parcel$global !== 'undefined') ws = $parcel$global.WebSocket || // @ts-expect-error: Support more browsers
    $parcel$global.MozWebSocket;
    else if (typeof window !== 'undefined') ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    // websocket status emitter, subscriptions are handled differently
    const emitter = (()=>{
        const message = (()=>{
            const listeners = {};
            return {
                on (id, listener) {
                    listeners[id] = listener;
                    return ()=>{
                        delete listeners[id];
                    };
                },
                emit (message) {
                    var _a;
                    if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                }
            };
        })();
        const listeners = {
            connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                on.connecting
            ] : [],
            opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                on.opened
            ] : [],
            connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                on.connected
            ] : [],
            ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                on.ping
            ] : [],
            pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                on.pong
            ] : [],
            message: (on === null || on === void 0 ? void 0 : on.message) ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                on.closed
            ] : [],
            error: (on === null || on === void 0 ? void 0 : on.error) ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on (event, listener) {
                const l = listeners[event];
                l.push(listener);
                return ()=>{
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit (event, ...args) {
                // we copy the listeners so that unlistens dont "pull the rug under our feet"
                for (const listener of [
                    ...listeners[event]
                ])// @ts-expect-error: The args should fit
                listener(...args);
            }
        };
    })();
    // invokes the callback either when an error or closed event is emitted,
    // first one that gets called prevails, other emissions are ignored
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on('error', (err)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on('closed', (event)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(event);
            })
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        // clear the lazy close timeout immediatelly so that close gets debounced
        // see: https://github.com/enisdenjo/graphql-ws/issues/388
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                if (retrying) {
                    await retryWait(retries);
                    // subscriptions might complete while waiting for retry
                    if (!locks) {
                        connecting = undefined;
                        return denied({
                            code: 1000,
                            reason: 'All Subscriptions Gone'
                        });
                    }
                    retries++;
                }
                emitter.emit('connecting');
                const socket = new WebSocketImpl(typeof url === 'function' ? await url() : url, (0, $l7Jgj.GRAPHQL_TRANSPORT_WS_PROTOCOL));
                let connectionAckTimeout, queuedPing;
                function enqueuePing() {
                    if (isFinite(keepAlive) && keepAlive > 0) {
                        clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                        queuedPing = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) {
                                socket.send((0, $l7Jgj.stringifyMessage)({
                                    type: (0, $l7Jgj.MessageType).Ping
                                }));
                                emitter.emit('ping', false, undefined);
                            }
                        }, keepAlive);
                    }
                }
                errorOrClosed((errOrEvent)=>{
                    connecting = undefined;
                    clearTimeout(connectionAckTimeout);
                    clearTimeout(queuedPing);
                    denied(errOrEvent);
                    if ($391dd11e177a8b61$var$isLikeCloseEvent(errOrEvent) && errOrEvent.code === 4499) {
                        socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below
                        socket.onerror = null;
                        socket.onclose = null;
                    }
                });
                socket.onerror = (err)=>emitter.emit('error', err);
                socket.onclose = (event)=>emitter.emit('closed', event);
                socket.onopen = async ()=>{
                    try {
                        emitter.emit('opened', socket);
                        const payload = typeof connectionParams === 'function' ? await connectionParams() : connectionParams;
                        // connectionParams might take too long causing the server to kick off the client
                        // the necessary error/close event is already reported - simply stop execution
                        if (socket.readyState !== WebSocketImpl.OPEN) return;
                        socket.send((0, $l7Jgj.stringifyMessage)(payload ? {
                            type: (0, $l7Jgj.MessageType).ConnectionInit,
                            payload: payload
                        } : {
                            type: (0, $l7Jgj.MessageType).ConnectionInit
                        }, replacer));
                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                            socket.close((0, $l7Jgj.CloseCode).ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                        }, connectionAckWaitTimeout);
                        enqueuePing(); // enqueue ping (noop if disabled)
                    } catch (err) {
                        emitter.emit('error', err);
                        socket.close((0, $l7Jgj.CloseCode).InternalClientError, (0, $7Tywk.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Internal client error'));
                    }
                };
                let acknowledged = false;
                socket.onmessage = ({ data: data })=>{
                    try {
                        const message = (0, $l7Jgj.parseMessage)(data, reviver);
                        emitter.emit('message', message);
                        if (message.type === 'ping' || message.type === 'pong') {
                            emitter.emit(message.type, true, message.payload); // received
                            if (message.type === 'pong') enqueuePing(); // enqueue next ping (noop if disabled)
                            else if (!disablePong) {
                                // respond with pong on ping
                                socket.send((0, $l7Jgj.stringifyMessage)(message.payload ? {
                                    type: (0, $l7Jgj.MessageType).Pong,
                                    payload: message.payload
                                } : {
                                    type: (0, $l7Jgj.MessageType).Pong
                                }));
                                emitter.emit('pong', false, message.payload);
                            }
                            return; // ping and pongs can be received whenever
                        }
                        if (acknowledged) return; // already connected and acknowledged
                        if (message.type !== (0, $l7Jgj.MessageType).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                        clearTimeout(connectionAckTimeout);
                        acknowledged = true;
                        emitter.emit('connected', socket, message.payload); // connected = socket opened + acknowledged
                        retrying = false; // future lazy connects are not retries
                        retries = 0; // reset the retries on connect
                        connected([
                            socket,
                            new Promise((_, reject)=>errorOrClosed(reject))
                        ]);
                    } catch (err) {
                        socket.onmessage = null; // stop reading messages as soon as reading breaks once
                        emitter.emit('error', err);
                        socket.close((0, $l7Jgj.CloseCode).BadResponse, (0, $7Tywk.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                    }
                };
            })()));
        // if the provided socket is in a closing state, wait for the throw on close
        if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
        let release = ()=>{
        // releases this connection
        };
        const released = new Promise((resolve)=>release = resolve);
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(()=>{
                    if (!locks) {
                        // and if no more locks are present, complete the connection
                        const complete = ()=>socket.close(1000, 'Normal Closure');
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                        // then complete if the socket is still open.
                        lazyCloseTimeout = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) complete();
                        }, lazyCloseTimeoutMs);
                        else // otherwise complete immediately
                        complete();
                    }
                }),
                // or
                throwOnClose
            ])
        ];
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
        // some close codes are worth reporting immediately
        if ($391dd11e177a8b61$var$isLikeCloseEvent(errOrCloseEvent) && ($391dd11e177a8b61$var$isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, $l7Jgj.CloseCode).InternalServerError,
            (0, $l7Jgj.CloseCode).InternalClientError,
            (0, $l7Jgj.CloseCode).BadRequest,
            (0, $l7Jgj.CloseCode).BadResponse,
            (0, $l7Jgj.CloseCode).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, $l7Jgj.CloseCode).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, $l7Jgj.CloseCode).SubscriberAlreadyExists,
            (0, $l7Jgj.CloseCode).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        // client was disposed, no retries should proceed regardless
        if (disposed) return false;
        // normal closure (possibly all subscriptions have completed)
        // if no locks were acquired in the meantime, shouldnt try again
        if ($391dd11e177a8b61$var$isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
        // retries are not allowed or we tried to many times, report error
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        // throw non-retryable connection problems
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        // @deprecated throw fatal connection problems immediately
        if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
        // looks good, start retrying
        return retrying = true;
    }
    // in non-lazy (hot?) mode always hold one connection lock to persist the socket
    if (!lazy) (async ()=>{
        locks++;
        for(;;)try {
            const [, , throwOnClose] = await connect();
            await throwOnClose; // will always throw because releaser is not used
        } catch (errOrCloseEvent) {
            try {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            } catch (errOrCloseEvent) {
                // report thrown error, no further retries
                return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
            }
        }
    })();
    return {
        on: emitter.on,
        subscribe (payload, sink) {
            const id = generateID(payload);
            let done = false, errored = false, releaser = ()=>{
                // for handling completions before connect
                locks--;
                done = true;
            };
            (async ()=>{
                locks++;
                for(;;)try {
                    const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                    // if done while waiting for connect, release the connection lock right away
                    if (done) return release();
                    const unlisten = emitter.onMessage(id, (message)=>{
                        switch(message.type){
                            case (0, $l7Jgj.MessageType).Next:
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                                sink.next(message.payload);
                                return;
                            case (0, $l7Jgj.MessageType).Error:
                                errored = true, done = true;
                                sink.error(message.payload);
                                releaser();
                                return;
                            case (0, $l7Jgj.MessageType).Complete:
                                done = true;
                                releaser(); // release completes the sink
                                return;
                        }
                    });
                    socket.send((0, $l7Jgj.stringifyMessage)({
                        id: id,
                        type: (0, $l7Jgj.MessageType).Subscribe,
                        payload: payload
                    }, replacer));
                    releaser = ()=>{
                        if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                        socket.send((0, $l7Jgj.stringifyMessage)({
                            id: id,
                            type: (0, $l7Jgj.MessageType).Complete
                        }, replacer));
                        locks--;
                        done = true;
                        release();
                    };
                    // either the releaser will be called, connection completed and
                    // the promise resolved or the socket closed and the promise rejected.
                    // whatever happens though, we want to stop listening for messages
                    await waitForReleaseOrThrowOnClose.finally(unlisten);
                    return; // completed, shouldnt try again
                } catch (errOrCloseEvent) {
                    if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
                }
            })().then(()=>{
                // delivering either an error or a complete terminates the sequence
                if (!errored) sink.complete();
            }) // resolves on release or normal closure
            .catch((err)=>{
                sink.error(err);
            }); // rejects on close events and errors
            return ()=>{
                // dispose only of active subscriptions
                if (!done) releaser();
            };
        },
        iterate (request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: ()=>{
                // noop
                }
            };
            const dispose = this.subscribe(request, {
                next (val) {
                    pending.push(val);
                    deferred.resolve();
                },
                error (err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete () {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            const iterator = function iterator() {
                return $391dd11e177a8b61$var$__asyncGenerator(this, arguments, function* iterator_1() {
                    for(;;){
                        if (!pending.length) // only wait if there are no pending messages available
                        yield $391dd11e177a8b61$var$__await(new Promise((resolve)=>deferred.resolve = resolve));
                        // first flush
                        while(pending.length)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        yield yield $391dd11e177a8b61$var$__await(pending.shift());
                        // then error
                        if (deferred.error) throw deferred.error;
                        // or complete
                        if (deferred.done) return yield $391dd11e177a8b61$var$__await(void 0);
                    }
                });
            }();
            iterator.throw = async (err)=>{
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return {
                    done: true,
                    value: undefined
                };
            };
            iterator.return = async ()=>{
                dispose();
                return {
                    done: true,
                    value: undefined
                };
            };
            return iterator;
        },
        async dispose () {
            disposed = true;
            if (connecting) {
                // if there is a connection, close it
                const [socket] = await connecting;
                socket.close(1000, 'Normal Closure');
            }
        },
        terminate () {
            if (connecting) // only if there is a connection
            emitter.emit('closed', {
                code: 4499,
                reason: 'Terminated',
                wasClean: false
            });
        }
    };
}
function $391dd11e177a8b61$var$isLikeCloseEvent(val) {
    return (0, $7Tywk.isObject)(val) && 'code' in val && 'reason' in val;
}
function $391dd11e177a8b61$var$isFatalInternalCloseCode(code) {
    if ([
        1000,
        1001,
        1006,
        1005,
        1012,
        1013,
        1014
    ].includes(code)) return false;
    // all other internal errors are fatal
    return code >= 1000 && code <= 1999;
}
function $391dd11e177a8b61$var$isWebSocket(val) {
    return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
}

});
parcelRegister("l7Jgj", function(module, exports) {

$parcel$export(module.exports, "GRAPHQL_TRANSPORT_WS_PROTOCOL", () => $f60d5c8886e0651e$export$5c0a4edfedc7c457);
$parcel$export(module.exports, "CloseCode", () => $f60d5c8886e0651e$export$777128f41f6616ec);
$parcel$export(module.exports, "MessageType", () => $f60d5c8886e0651e$export$80edbf15fa61a4db);
$parcel$export(module.exports, "parseMessage", () => $f60d5c8886e0651e$export$f2f615077a189f21);
$parcel$export(module.exports, "stringifyMessage", () => $f60d5c8886e0651e$export$77896e5b47bfd50b);
/**
 *
 * common
 *
 */ 
var $7Tywk = parcelRequire("7Tywk");
const $f60d5c8886e0651e$export$5c0a4edfedc7c457 = 'graphql-transport-ws';
const $f60d5c8886e0651e$export$ec743af8bb66f3be = 'graphql-ws';
var $f60d5c8886e0651e$export$777128f41f6616ec;
(function(CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
    /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})($f60d5c8886e0651e$export$777128f41f6616ec || ($f60d5c8886e0651e$export$777128f41f6616ec = {}));
var $f60d5c8886e0651e$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
})($f60d5c8886e0651e$export$80edbf15fa61a4db || ($f60d5c8886e0651e$export$80edbf15fa61a4db = {}));
function $f60d5c8886e0651e$export$c17861b159b1b673(val) {
    if (!(0, $7Tywk.isObject)(val)) throw new Error(`Message is expected to be an object, but got ${(0, $7Tywk.extendedTypeof)(val)}`);
    if (!val.type) throw new Error(`Message is missing the 'type' property`);
    if (typeof val.type !== 'string') throw new Error(`Message is expects the 'type' property to be a string, but got ${(0, $7Tywk.extendedTypeof)(val.type)}`);
    switch(val.type){
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.ConnectionInit:
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.ConnectionAck:
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.Ping:
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.Pong:
            if (val.payload != null && !(0, $7Tywk.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            break;
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.Subscribe:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $7Tywk.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $7Tywk.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $7Tywk.extendedTypeof)(val.payload)}`);
            if (typeof val.payload.query !== 'string') throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${(0, $7Tywk.extendedTypeof)(val.payload.query)}`);
            if (val.payload.variables != null && !(0, $7Tywk.isObject)(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${(0, $7Tywk.extendedTypeof)(val.payload.variables)}`);
            if (val.payload.operationName != null && (0, $7Tywk.extendedTypeof)(val.payload.operationName) !== 'string') throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${(0, $7Tywk.extendedTypeof)(val.payload.operationName)}`);
            if (val.payload.extensions != null && !(0, $7Tywk.isObject)(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${(0, $7Tywk.extendedTypeof)(val.payload.extensions)}`);
            break;
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.Next:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $7Tywk.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $7Tywk.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $7Tywk.extendedTypeof)(val.payload)}`);
            break;
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.Error:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $7Tywk.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $7Tywk.areGraphQLErrors)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            break;
        case $f60d5c8886e0651e$export$80edbf15fa61a4db.Complete:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $7Tywk.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            break;
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
function $f60d5c8886e0651e$export$9e0e49e75fa7d548(val) {
    try {
        $f60d5c8886e0651e$export$c17861b159b1b673(val);
        return true;
    } catch (_a) {
        return false;
    }
}
function $f60d5c8886e0651e$export$f2f615077a189f21(data, reviver) {
    return $f60d5c8886e0651e$export$c17861b159b1b673(typeof data === 'string' ? JSON.parse(data, reviver) : data);
}
function $f60d5c8886e0651e$export$77896e5b47bfd50b(msg, replacer) {
    $f60d5c8886e0651e$export$c17861b159b1b673(msg);
    return JSON.stringify(msg, replacer);
}

});
parcelRegister("7Tywk", function(module, exports) {

$parcel$export(module.exports, "extendedTypeof", () => $5bf872794d14d281$export$573326049e1b1c6b);
$parcel$export(module.exports, "isObject", () => $5bf872794d14d281$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "areGraphQLErrors", () => $5bf872794d14d281$export$e6262fbc2e92290);
$parcel$export(module.exports, "limitCloseReason", () => $5bf872794d14d281$export$2937fa0c8dddae54);
/** @private */ function $5bf872794d14d281$export$573326049e1b1c6b(val) {
    if (val === null) return 'null';
    if (Array.isArray(val)) return 'array';
    return typeof val;
}
function $5bf872794d14d281$export$a6cdc56e425d0d0a(val) {
    return $5bf872794d14d281$export$573326049e1b1c6b(val) === 'object';
}
function $5bf872794d14d281$export$edb10ab8dd75a915(val) {
    return typeof Object(val)[Symbol.asyncIterator] === 'function';
}
function $5bf872794d14d281$export$92bd080471bc30f1(val) {
    return $5bf872794d14d281$export$a6cdc56e425d0d0a(val) && typeof Object(val)[Symbol.asyncIterator] === 'function' && typeof val.return === 'function';
}
function $5bf872794d14d281$export$e6262fbc2e92290(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every((ob)=>'message' in ob);
}
function $5bf872794d14d281$export$2937fa0c8dddae54(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}

});



parcelRegister("6LmWt", function(module, exports) {

$parcel$export(module.exports, "getDefaultRelayEnvironmentConfig", () => $61f65a0ea311dd12$export$6c790f07f4ef6a59);

var $eiowN = parcelRequire("eiowN");

var $65GpI = parcelRequire("65GpI");

var $iJZ8l = parcelRequire("iJZ8l");

var $dj5to = parcelRequire("dj5to");

var $3Z1I9 = parcelRequire("3Z1I9");

var $iExP6 = parcelRequire("iExP6");
const $61f65a0ea311dd12$var$createStore = (source, options)=>{
    (0, $eiowN.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
    return new (0, (/*@__PURE__*/$parcel$interopDefault($65GpI)))(source, options);
};
const $61f65a0ea311dd12$export$6c790f07f4ef6a59 = ({ log: log, requiredFieldLogger: requiredFieldLogger, network: network })=>({
        configName: 'Atlassian Graphql Gateway',
        network: network || (0, $3Z1I9.network),
        store: $61f65a0ea311dd12$var$createStore(new (0, $eiowN.RecordSource)(), {
            log: log ?? undefined,
            getDataID: (0, $iJZ8l.default)
        }),
        log: log,
        relayFieldLogger: requiredFieldLogger,
        getDataID: (0, $iJZ8l.default),
        scheduler: (0, $iExP6.default),
        missingFieldHandlers: (0, $dj5to.default)
    });

});
parcelRegister("65GpI", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $46f41c2f1ec2be63$var$_interopRequireDefault = $7gV6J.default;

var $46f41c2f1ec2be63$var$_createForOfIteratorHelper2 = $46f41c2f1ec2be63$var$_interopRequireDefault((parcelRequire("8utPl")));

var $46f41c2f1ec2be63$var$_defineProperty2 = $46f41c2f1ec2be63$var$_interopRequireDefault((parcelRequire("2KFWS")));

var $g6Qtb = parcelRequire("g6Qtb");
var $46f41c2f1ec2be63$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $g6Qtb.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $46f41c2f1ec2be63$var$assertInternalActorIdentifier = $g6Qtb.assertInternalActorIdentifier;
parcelRequire("259Mc");

var $1zFTi = parcelRequire("1zFTi");

var $h7JIX = parcelRequire("h7JIX");

var $4FKGD = parcelRequire("4FKGD");

var $jeujn = parcelRequire("jeujn");

var $ja41X = parcelRequire("ja41X");

var $9miei = parcelRequire("9miei");

var $5DcbW = parcelRequire("5DcbW");

var $hWkm3 = parcelRequire("hWkm3");

var $dfBRB = parcelRequire("dfBRB");

var $dfBRB = parcelRequire("dfBRB");
var $46f41c2f1ec2be63$var$ROOT_ID = $dfBRB.ROOT_ID, $46f41c2f1ec2be63$var$ROOT_TYPE = $dfBRB.ROOT_TYPE;

var $edMta = parcelRequire("edMta");
var $46f41c2f1ec2be63$var$LiveResolverCache = $edMta.LiveResolverCache, $46f41c2f1ec2be63$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = $edMta.RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, $46f41c2f1ec2be63$var$getUpdatedDataIDs = $edMta.getUpdatedDataIDs;

var $aE1Lc = parcelRequire("aE1Lc");
var $46f41c2f1ec2be63$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $46f41c2f1ec2be63$var$LiveResolverStore = /*#__PURE__*/ function() {
    function LiveResolverStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa, _options$treatMissing, _options$shouldProces;
        (0, $46f41c2f1ec2be63$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $46f41c2f1ec2be63$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $1zFTi;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $4FKGD;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $46f41c2f1ec2be63$var$LiveResolverCache(function() {
            return _this._getMutableRecordSource();
        }, this);
        this._storeSubscriptions = new $hWkm3(options === null || options === void 0 ? void 0 : options.log, this._resolverCache);
        this._updatedRecordIDs = new Set();
        this._treatMissingFieldsAsNull = (_options$treatMissing = options === null || options === void 0 ? void 0 : options.treatMissingFieldsAsNull) !== null && _options$treatMissing !== void 0 ? _options$treatMissing : false;
        this._actorIdentifier = options === null || options === void 0 ? void 0 : options.actorIdentifier;
        this._shouldProcessClientComponents = (_options$shouldProces = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents) !== null && _options$shouldProces !== void 0 ? _options$shouldProces : false;
        $46f41c2f1ec2be63$var$initializeRecordSource(this._recordSource);
    }
    var _proto = LiveResolverStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(recordID) {
        return this._resolverCache.getLiveResolverPromise(recordID);
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        if (this.__log != null) this.__log({
            name: 'liveresolver.batch.start'
        });
        try {
            this._resolverCache.batchLiveStateUpdates(callback);
        } finally{
            if (this.__log != null) this.__log({
                name: 'liveresolver.batch.end'
            });
        }
    };
    _proto.check = function check(operation, options) {
        var _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $46f41c2f1ec2be63$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $46f41c2f1ec2be63$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $h7JIX.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $46f41c2f1ec2be63$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents);
        return $46f41c2f1ec2be63$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var source = this.getSource();
        var snapshot = $9miei.read(source, selector, this._resolverCache);
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $46f41c2f1ec2be63$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'LiveResolverStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $jeujn.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        var invalidationState = {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
        return invalidationState;
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, $46f41c2f1ec2be63$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $aE1Lc(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $ja41X.create(this.getSource());
    };
    _proto.restore = function restore() {
        var optimisticSource = this._optimisticSource;
        !optimisticSource && $aE1Lc(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        var optimisticIDs = $ja41X.getOptimisticRecordIDs(optimisticSource);
        this._resolverCache.unsubscribeFromLiveResolverRecords(optimisticIDs);
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
        this._resolverCache.invalidateResolverRecords(optimisticIDs);
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        top: while(true){
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $46f41c2f1ec2be63$var$_createForOfIteratorHelper2["default"])(this._roots.values()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var operation = _step2.value.operation;
                    var selector = operation.root;
                    $5DcbW.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) continue top;
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var log = this.__log;
            if (log != null) log({
                name: 'store.gc',
                references: references
            });
            if (references.size === 0) this._recordSource.clear();
            else {
                var storeIDs = this._recordSource.getRecordIDs();
                for(var ii = 0; ii < storeIDs.length; ii++){
                    var dataID = storeIDs[ii];
                    if (!references.has(dataID)) {
                        var record = this._recordSource.get(dataID);
                        if (record != null) {
                            var maybeResolverSubscription = $jeujn.getValue(record, $46f41c2f1ec2be63$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
                            if (maybeResolverSubscription != null) maybeResolverSubscription();
                        }
                        this._recordSource.remove(dataID);
                    }
                }
            }
            return;
        }
    };
    _proto.__getNormalizationOptions = function __getNormalizationOptions(path) {
        return {
            path: path,
            getDataID: this._getDataID,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            actorIdentifier: this._actorIdentifier
        };
    };
    _proto.__notifyUpdatedSubscribers = function __notifyUpdatedSubscribers(updatedRecords) {
        var nextUpdatedRecordIDs = $46f41c2f1ec2be63$var$getUpdatedDataIDs(updatedRecords);
        var prevUpdatedRecordIDs = this._updatedRecordIDs;
        this._updatedRecordIDs = nextUpdatedRecordIDs;
        this.notify();
        this._updatedRecordIDs = prevUpdatedRecordIDs;
    };
    return LiveResolverStore;
}();
function $46f41c2f1ec2be63$var$initializeRecordSource(target) {
    if (!target.has($46f41c2f1ec2be63$var$ROOT_ID)) {
        var rootRecord = $jeujn.create($46f41c2f1ec2be63$var$ROOT_ID, $46f41c2f1ec2be63$var$ROOT_TYPE);
        target.set($46f41c2f1ec2be63$var$ROOT_ID, rootRecord);
    }
}
function $46f41c2f1ec2be63$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $jeujn.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $jeujn.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $jeujn.setValue(nextRecord, $dfBRB.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $jeujn.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $46f41c2f1ec2be63$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $46f41c2f1ec2be63$var$LiveResolverStore;

});
parcelRegister("edMta", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $a5a7e09f792afd36$var$_interopRequireDefault = $7gV6J.default;

var $a5a7e09f792afd36$var$_createForOfIteratorHelper2 = $a5a7e09f792afd36$var$_interopRequireDefault((parcelRequire("8utPl")));

var $b2CqU = parcelRequire("b2CqU");

var $7AO8k = parcelRequire("7AO8k");
var $a5a7e09f792afd36$var$RELAY_LIVE_RESOLVER = $7AO8k.RELAY_LIVE_RESOLVER;

var $brVAm = parcelRequire("brVAm");

var $dFCzs = parcelRequire("dFCzs");

var $dgkLD = parcelRequire("dgkLD");
var $a5a7e09f792afd36$var$generateClientID = $dgkLD.generateClientID, $a5a7e09f792afd36$var$generateClientObjectClientID = $dgkLD.generateClientObjectClientID;

var $jeujn = parcelRequire("jeujn");

var $hqAuM = parcelRequire("hqAuM");
var $a5a7e09f792afd36$var$createNormalizationSelector = $hqAuM.createNormalizationSelector;

var $67IX0 = parcelRequire("67IX0");

var $ggNiN = parcelRequire("ggNiN");
var $a5a7e09f792afd36$var$normalize = $ggNiN.normalize;

var $dfBRB = parcelRequire("dfBRB");
var $a5a7e09f792afd36$var$RELAY_RESOLVER_ERROR_KEY = $dfBRB.RELAY_RESOLVER_ERROR_KEY, $a5a7e09f792afd36$var$RELAY_RESOLVER_INVALIDATION_KEY = $dfBRB.RELAY_RESOLVER_INVALIDATION_KEY, $a5a7e09f792afd36$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $dfBRB.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, $a5a7e09f792afd36$var$RELAY_RESOLVER_SNAPSHOT_KEY = $dfBRB.RELAY_RESOLVER_SNAPSHOT_KEY, $a5a7e09f792afd36$var$RELAY_RESOLVER_VALUE_KEY = $dfBRB.RELAY_RESOLVER_VALUE_KEY, $a5a7e09f792afd36$var$getStorageKey = $dfBRB.getStorageKey;

var $24A8O = parcelRequire("24A8O");

var $1ct6Z = parcelRequire("1ct6Z");

var $9a00R = parcelRequire("9a00R");
var $a5a7e09f792afd36$var$isSuspenseSentinel = $9a00R.isSuspenseSentinel;

var $aE1Lc = parcelRequire("aE1Lc");
parcelRequire("1srSR");
var $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = '__resolverLiveStateSubscription';
var $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_VALUE = '__resolverLiveStateValue';
var $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_DIRTY = '__resolverLiveStateDirty';
var $a5a7e09f792afd36$var$RELAY_RESOLVER_RECORD_TYPENAME = '__RELAY_RESOLVER__';
var $a5a7e09f792afd36$var$MODEL_PROPERTY_NAME = '__relay_model_instance';
function $a5a7e09f792afd36$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $a5a7e09f792afd36$var$LiveResolverCache = /*#__PURE__*/ function() {
    function LiveResolverCache(getRecordSource, store) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
        this._store = store;
        this._handlingBatch = false;
        this._liveResolverBatchRecordSource = null;
    }
    var _proto = LiveResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = $a5a7e09f792afd36$var$expectRecord(recordSource, recordID);
        var storageKey = $a5a7e09f792afd36$var$getStorageKey(field, variables);
        var linkedID = $jeujn.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        var updatedDataIDs;
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            if (linkedRecord != null) $a5a7e09f792afd36$var$maybeUnsubscribeFromLiveState(linkedRecord);
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $a5a7e09f792afd36$var$generateClientID(recordID, storageKey);
            linkedRecord = $jeujn.create(linkedID, $a5a7e09f792afd36$var$RELAY_RESOLVER_RECORD_TYPENAME);
            var evaluationResult = evaluate();
            $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            if (field.kind === $a5a7e09f792afd36$var$RELAY_LIVE_RESOLVER) {
                if (evaluationResult.resolverResult != null) {
                    !(evaluationResult.error == null) && $aE1Lc(false);
                    var liveState = evaluationResult.resolverResult;
                    updatedDataIDs = this._setLiveStateValue(linkedRecord, linkedID, liveState, field, variables);
                } else var _evaluationResult$sna;
            } else updatedDataIDs = this._setResolverValue(linkedRecord, evaluationResult.resolverResult, field, variables);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = $a5a7e09f792afd36$var$expectRecord(recordSource, recordID);
            var nextRecord = $jeujn.clone(currentRecord);
            $jeujn.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna2;
                var fragmentStorageKey = $a5a7e09f792afd36$var$getStorageKey(field.fragment, variables);
                var resolverID = $a5a7e09f792afd36$var$generateClientID(recordID, fragmentStorageKey);
                $a5a7e09f792afd36$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $a5a7e09f792afd36$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna2 = evaluationResult.snapshot) === null || _evaluationResult$sna2 === void 0 ? void 0 : _evaluationResult$sna2.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $a5a7e09f792afd36$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        } else if (field.kind === $a5a7e09f792afd36$var$RELAY_LIVE_RESOLVER && $jeujn.getValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_DIRTY)) {
            var _linkedID2;
            linkedID = (_linkedID2 = linkedID) !== null && _linkedID2 !== void 0 ? _linkedID2 : $a5a7e09f792afd36$var$generateClientID(recordID, storageKey);
            linkedRecord = $jeujn.clone(linkedRecord);
            var _liveState = $jeujn.getValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
            if (!$1ct6Z(_liveState)) $aE1Lc(false);
            updatedDataIDs = this._setLiveResolverValue(linkedRecord, _liveState, field, variables);
            $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
            recordSource.set(linkedID, linkedRecord);
        }
        var answer = this._getResolverValue(linkedRecord);
        var snapshot = $jeujn.getValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $jeujn.getValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_ERROR_KEY);
        var suspenseID = null;
        if ($a5a7e09f792afd36$var$isSuspenseSentinel(answer)) {
            var _linkedID3;
            suspenseID = (_linkedID3 = linkedID) !== null && _linkedID3 !== void 0 ? _linkedID3 : $a5a7e09f792afd36$var$generateClientID(recordID, storageKey);
        }
        return [
            answer,
            linkedID,
            error,
            snapshot,
            suspenseID,
            updatedDataIDs
        ];
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(liveStateID) {
        var recordSource = this._getRecordSource();
        var liveStateRecord = recordSource.get(liveStateID);
        !(liveStateRecord != null) && $aE1Lc(false);
        var liveState = $jeujn.getValue(liveStateRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
        return new Promise(function(resolve) {
            var unsubscribe = liveState.subscribe(function() {
                unsubscribe();
                resolve();
            });
        });
    };
    _proto._setLiveStateValue = function _setLiveStateValue(linkedRecord, linkedID, liveState, field, variables) {
        var handler = this._makeLiveStateHandler(linkedID);
        var unsubscribe = liveState.subscribe(handler);
        $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_VALUE, liveState);
        var updatedDataIDs = this._setLiveResolverValue(linkedRecord, liveState, field, variables);
        $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
        $jeujn.setValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, unsubscribe);
        return updatedDataIDs;
    };
    _proto._makeLiveStateHandler = function _makeLiveStateHandler(linkedID) {
        var _this = this;
        return function() {
            var currentSource = _this._getRecordSource();
            var currentRecord = currentSource.get(linkedID);
            if (!currentRecord) return;
            if (!$jeujn.hasValue(currentRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_VALUE)) return;
            var nextRecord = $jeujn.clone(currentRecord);
            $jeujn.setValue(nextRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, true);
            _this._setLiveResolverUpdate(linkedID, nextRecord);
        };
    };
    _proto._setLiveResolverUpdate = function _setLiveResolverUpdate(linkedId, record) {
        if (this._handlingBatch) {
            if (this._liveResolverBatchRecordSource == null) this._liveResolverBatchRecordSource = $67IX0.create();
            this._liveResolverBatchRecordSource.set(linkedId, record);
        } else {
            var nextSource = $67IX0.create();
            nextSource.set(linkedId, record);
            this._store.publish(nextSource);
            this._store.notify();
        }
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        !!this._handlingBatch && $aE1Lc(false);
        this._handlingBatch = true;
        try {
            callback();
        } finally{
            if (this._liveResolverBatchRecordSource != null) {
                this._store.publish(this._liveResolverBatchRecordSource);
                this._store.notify();
            }
            this._liveResolverBatchRecordSource = null;
            this._handlingBatch = false;
        }
    };
    _proto._setLiveResolverValue = function _setLiveResolverValue(resolverRecord, liveValue, field, variables) {
        var value = null;
        var resolverError = null;
        try {
            value = liveValue.read();
        } catch (e) {
            resolverError = e;
        }
        $jeujn.setValue(resolverRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_ERROR_KEY, resolverError);
        return this._setResolverValue(resolverRecord, value, field, variables);
    };
    _proto._setResolverValue = function _setResolverValue(resolverRecord, value, field, variables) {
        var normalizationInfo = field.normalizationInfo;
        var updatedDataIDs = null;
        if (value != null && normalizationInfo != null && !$a5a7e09f792afd36$var$isSuspenseSentinel(value)) {
            var resolverValue;
            var prevOutputTypeRecordIDs = $24A8O(resolverRecord);
            var nextOutputTypeRecordIDs = new Set();
            var currentSource = this._getRecordSource();
            if (normalizationInfo.plural) {
                !Array.isArray(value) && $aE1Lc(false);
                resolverValue = [];
                var nextSource = $67IX0.create();
                for(var ii = 0; ii < value.length; ii++){
                    var currentValue = value[ii];
                    if (currentValue == null) continue;
                    !(typeof currentValue === 'object') && $aE1Lc(false);
                    var typename = $a5a7e09f792afd36$var$getConcreteTypename(normalizationInfo, currentValue);
                    var outputTypeDataID = $a5a7e09f792afd36$var$generateClientObjectClientID(typename, $jeujn.getDataID(resolverRecord), ii);
                    var source = this._normalizeOutputTypeValue(outputTypeDataID, currentValue, variables, normalizationInfo, [
                        field.path,
                        String(ii)
                    ], typename);
                    var _iterator2 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(source.getRecordIDs()), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var recordID = _step2.value;
                            nextSource.set(recordID, $a5a7e09f792afd36$var$expectRecord(source, recordID));
                            nextOutputTypeRecordIDs.add(recordID);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    resolverValue.push(outputTypeDataID);
                }
                updatedDataIDs = $a5a7e09f792afd36$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs);
            } else {
                !(typeof value === 'object') && $aE1Lc(false);
                var _typename = $a5a7e09f792afd36$var$getConcreteTypename(normalizationInfo, value);
                var _outputTypeDataID = $a5a7e09f792afd36$var$generateClientObjectClientID(_typename, $jeujn.getDataID(resolverRecord));
                var _nextSource = this._normalizeOutputTypeValue(_outputTypeDataID, value, variables, normalizationInfo, [
                    field.path
                ], _typename);
                var _iterator3 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(_nextSource.getRecordIDs()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _recordID = _step3.value;
                        nextOutputTypeRecordIDs.add(_recordID);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                resolverValue = _outputTypeDataID;
                updatedDataIDs = $a5a7e09f792afd36$var$updateCurrentSource(currentSource, _nextSource, prevOutputTypeRecordIDs);
            }
            $jeujn.setValue(resolverRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, nextOutputTypeRecordIDs);
            $dFCzs(resolverValue);
            $jeujn.setValue(resolverRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_VALUE_KEY, resolverValue);
        } else {
            $dFCzs(value);
            $jeujn.setValue(resolverRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_VALUE_KEY, value);
        }
        return updatedDataIDs;
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        this._store.__notifyUpdatedSubscribers(updatedDataIDs);
    };
    _proto._getResolverValue = function _getResolverValue(resolverRecord) {
        return $jeujn.getValue(resolverRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_VALUE_KEY);
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            updatedDataIDs.add(recordID);
            var fragmentSet = this._recordIDToResolverIDs.get(recordID);
            if (fragmentSet == null) continue;
            var _iterator4 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(fragmentSet), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var fragment = _step4.value;
                    if (!visited.has(fragment)) {
                        var recordSet = this._resolverIDToRecordIDs.get(fragment);
                        if (recordSet == null) continue;
                        var _iterator5 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(recordSet), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var anotherRecordID = _step5.value;
                                $a5a7e09f792afd36$var$markInvalidatedResolverRecord(anotherRecordID, recordSource);
                                if (!visited.has(anotherRecordID)) recordsToVisit.push(anotherRecordID);
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                    }
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    _proto._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$jeujn.getValue(record, $a5a7e09f792afd36$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $jeujn.getValue(record, $a5a7e09f792afd36$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $b2CqU(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($brVAm.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $jeujn.clone(record);
            $jeujn.setValue(nextRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($jeujn.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto._normalizeOutputTypeValue = function _normalizeOutputTypeValue(outputTypeDataID, value, variables, normalizationInfo, fieldPath, typename) {
        var source = $67IX0.create();
        switch(normalizationInfo.kind){
            case 'OutputType':
                var record = $jeujn.create(outputTypeDataID, typename);
                source.set(outputTypeDataID, record);
                var selector = $a5a7e09f792afd36$var$createNormalizationSelector(normalizationInfo.normalizationNode, outputTypeDataID, variables);
                var normalizationOptions = this._store.__getNormalizationOptions(fieldPath);
                return $a5a7e09f792afd36$var$normalize(source, selector, value, normalizationOptions).source;
            case 'WeakModel':
                var _record = $jeujn.create(outputTypeDataID, typename);
                $jeujn.setValue(_record, $a5a7e09f792afd36$var$MODEL_PROPERTY_NAME, value);
                source.set(outputTypeDataID, _record);
                return source;
            default:
                normalizationInfo.kind;
                $aE1Lc(false);
        }
    };
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        var key = $a5a7e09f792afd36$var$generateClientObjectClientID(typeName, id);
        var recordSource = this._getRecordSource();
        if (!recordSource.has(key)) {
            var newRecord = $jeujn.create(key, typeName);
            $jeujn.setValue(newRecord, 'id', id);
            recordSource.set(key, newRecord);
        }
        return key;
    };
    _proto.unsubscribeFromLiveResolverRecords = function unsubscribeFromLiveResolverRecords(invalidatedDataIDs) {
        return $a5a7e09f792afd36$var$unsubscribeFromLiveResolverRecordsImpl(this._getRecordSource(), invalidatedDataIDs);
    };
    _proto.invalidateResolverRecords = function invalidateResolverRecords(invalidatedDataIDs) {
        if (invalidatedDataIDs.size === 0) return;
        var _iterator6 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step6;
        try {
            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                var dataID = _step6.value;
                var record = this._getRecordSource().get(dataID);
                if (record != null && $a5a7e09f792afd36$var$isResolverRecord(record)) this._getRecordSource()["delete"](dataID);
            }
        } catch (err) {
            _iterator6.e(err);
        } finally{
            _iterator6.f();
        }
    };
    return LiveResolverCache;
}();
function $a5a7e09f792afd36$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs) {
    var updatedDataIDs = new Set();
    if (prevOutputTypeRecordIDs != null) {
        var _iterator7 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(prevOutputTypeRecordIDs), _step7;
        try {
            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                var recordID = _step7.value;
                if (!nextSource.has(recordID)) {
                    updatedDataIDs.add(recordID);
                    currentSource.remove(recordID);
                }
            }
        } catch (err) {
            _iterator7.e(err);
        } finally{
            _iterator7.f();
        }
    }
    var _iterator8 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(nextSource.getRecordIDs()), _step8;
    try {
        for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
            var _recordID2 = _step8.value;
            var nextRecord = $a5a7e09f792afd36$var$expectRecord(nextSource, _recordID2);
            if (currentSource.has(_recordID2)) {
                var currentRecord = $a5a7e09f792afd36$var$expectRecord(currentSource, _recordID2);
                var updatedRecord = $jeujn.update(currentRecord, nextRecord);
                if (updatedRecord !== currentRecord) {
                    updatedDataIDs.add(_recordID2);
                    currentSource.set(_recordID2, updatedRecord);
                    $a5a7e09f792afd36$var$markInvalidatedLinkedResolverRecords(currentRecord, currentSource);
                }
            } else currentSource.set(_recordID2, nextRecord);
        }
    } catch (err) {
        _iterator8.e(err);
    } finally{
        _iterator8.f();
    }
    return updatedDataIDs;
}
function $a5a7e09f792afd36$var$getAllLinkedRecordIds(record) {
    var linkedRecordIDs = new Set();
    $jeujn.getFields(record).forEach(function(field) {
        if ($jeujn.hasLinkedRecordID(record, field)) {
            var linkedRecordID = $jeujn.getLinkedRecordID(record, field);
            if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
        } else if ($jeujn.hasLinkedRecordIDs(record, field)) {
            var _RelayModernRecord$ge;
            (_RelayModernRecord$ge = $jeujn.getLinkedRecordIDs(record, field)) === null || _RelayModernRecord$ge === void 0 || _RelayModernRecord$ge.forEach(function(linkedRecordID) {
                if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
            });
        }
    });
    return linkedRecordIDs;
}
function $a5a7e09f792afd36$var$markInvalidatedResolverRecord(dataID, recordSource) {
    var record = recordSource.get(dataID);
    if (!record) return;
    var nextRecord = $jeujn.clone(record);
    $jeujn.setValue(nextRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
    recordSource.set(dataID, nextRecord);
}
function $a5a7e09f792afd36$var$markInvalidatedLinkedResolverRecords(record, recordSource) {
    var currentLinkedDataIDs = $a5a7e09f792afd36$var$getAllLinkedRecordIds(record);
    var _iterator9 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(currentLinkedDataIDs), _step9;
    try {
        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
            var recordID = _step9.value;
            var _record2 = recordSource.get(recordID);
            if (_record2 != null && $a5a7e09f792afd36$var$isResolverRecord(_record2)) $a5a7e09f792afd36$var$markInvalidatedResolverRecord(recordID, recordSource);
        }
    } catch (err) {
        _iterator9.e(err);
    } finally{
        _iterator9.f();
    }
}
function $a5a7e09f792afd36$var$unsubscribeFromLiveResolverRecordsImpl(recordSource, invalidatedDataIDs) {
    if (invalidatedDataIDs.size === 0) return;
    var _iterator10 = (0, $a5a7e09f792afd36$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step10;
    try {
        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
            var dataID = _step10.value;
            var record = recordSource.get(dataID);
            if (record != null && $a5a7e09f792afd36$var$isResolverRecord(record)) $a5a7e09f792afd36$var$maybeUnsubscribeFromLiveState(record);
        }
    } catch (err) {
        _iterator10.e(err);
    } finally{
        _iterator10.f();
    }
}
function $a5a7e09f792afd36$var$isResolverRecord(record) {
    return $jeujn.getType(record) === $a5a7e09f792afd36$var$RELAY_RESOLVER_RECORD_TYPENAME;
}
function $a5a7e09f792afd36$var$maybeUnsubscribeFromLiveState(linkedRecord) {
    var previousUnsubscribe = $jeujn.getValue(linkedRecord, $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
    if (previousUnsubscribe != null) previousUnsubscribe();
}
function $a5a7e09f792afd36$var$expectRecord(source, recordID) {
    var record = source.get(recordID);
    !(record != null) && $aE1Lc(false);
    return record;
}
function $a5a7e09f792afd36$var$getUpdatedDataIDs(updatedRecords) {
    return updatedRecords;
}
function $a5a7e09f792afd36$var$getConcreteTypename(normalizationInfo, currentValue) {
    var _normalizationInfo$co;
    var typename = (_normalizationInfo$co = normalizationInfo.concreteType) !== null && _normalizationInfo$co !== void 0 ? _normalizationInfo$co : currentValue.__typename;
    !(typename != null) && $aE1Lc(false);
    return typename;
}
module.exports = {
    LiveResolverCache: $a5a7e09f792afd36$var$LiveResolverCache,
    getUpdatedDataIDs: $a5a7e09f792afd36$var$getUpdatedDataIDs,
    RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY: $a5a7e09f792afd36$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY
};

});
parcelRegister("1ct6Z", function(module, exports) {
'use strict';
function $0dfd7e67afc3bafd$var$isLiveStateValue(v) {
    return v != null && typeof v === 'object' && typeof v.read === 'function' && typeof v.subscribe === 'function';
}
module.exports = $0dfd7e67afc3bafd$var$isLiveStateValue;

});



parcelRegister("iJZ8l", function(module, exports) {

$parcel$export(module.exports, "default", () => $b125dd4fe380c966$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $k43Wt = parcelRequire("k43Wt");
const $b125dd4fe380c966$var$idTypeMap = new Map();
function $b125dd4fe380c966$export$2e2bcd8739ae039(fieldValue, typeName) {
    const { id: id } = fieldValue;
    if (id == null) return undefined;
    if ((0, $VSDnB.fg)('platform_log_relay_duplicate_identifiers')) {
        const idString = String(id);
        if ($b125dd4fe380c966$var$idTypeMap.has(idString)) {
            const entry = $b125dd4fe380c966$var$idTypeMap.get(idString);
            if (entry) {
                const { typeName: existingTypeName, hasLoggedConflict: hasLoggedConflict } = entry;
                if (existingTypeName !== typeName && !hasLoggedConflict) {
                    (0, $k43Wt.safeWarnWithoutCustomerData)('relaydataid.generator', `RelayDataID: conflicting type names for the same ID: ${idString} with type names: ${existingTypeName} and ${typeName}.`, {
                        id: idString,
                        types: `${existingTypeName}, ${typeName}`
                    });
                    entry.hasLoggedConflict = true;
                }
            }
        } else $b125dd4fe380c966$var$idTypeMap.set(idString, {
            typeName: typeName,
            hasLoggedConflict: false
        });
    }
    return `${String(id)}:::::${typeName}`;
}

});
parcelRegister("k43Wt", function(module, exports) {

$parcel$export(module.exports, "safeWarnWithoutCustomerData", () => $6955024b7a0709f2$export$b8c037155fd57aaf);
const $6955024b7a0709f2$var$defaultOptions = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, text/javascript, */*'
    }
};
const $6955024b7a0709f2$var$isProduction = ()=>true;
const $6955024b7a0709f2$var$MAX_REQUESTS_PER_INTERVAL = 5;
const $6955024b7a0709f2$var$INTERVAL_MS = 1000;
let $6955024b7a0709f2$var$requestQueue = [];
let $6955024b7a0709f2$var$isProcessingQueue = false;
const $6955024b7a0709f2$var$processQueue = ()=>{
    if ($6955024b7a0709f2$var$isProcessingQueue) return;
    $6955024b7a0709f2$var$isProcessingQueue = true;
    const processNextBatch = ()=>{
        if ($6955024b7a0709f2$var$requestQueue.length === 0) {
            $6955024b7a0709f2$var$isProcessingQueue = false;
            return;
        }
        const batch = $6955024b7a0709f2$var$requestQueue.splice(0, $6955024b7a0709f2$var$MAX_REQUESTS_PER_INTERVAL);
        batch.forEach(({ body: body, endpoint: endpoint })=>{
            fetch(endpoint, {
                ...$6955024b7a0709f2$var$defaultOptions,
                method: 'POST',
                body: body
            });
        });
        setTimeout(processNextBatch, $6955024b7a0709f2$var$INTERVAL_MS);
    };
    processNextBatch();
};
const $6955024b7a0709f2$var$sendToServerBatched = (body, endpoint)=>{
    $6955024b7a0709f2$var$requestQueue.push({
        body: body,
        endpoint: endpoint
    });
    // Start processing the logging queue if not already started
    $6955024b7a0709f2$var$processQueue();
};
const $6955024b7a0709f2$var$sendToConsole = (body, endpoint, level, message, eventType, event)=>{
    // eslint-disable-next-line no-console
    console[level]('%c%s %c(POST %s)\n%cMessage\n%c%s\n\n%cEvent body\n%c%s\n\n%cException object and Stack trace (expand to jump to source)\n', 'font-size: 14px; font-weight: bold;', level.toUpperCase(), 'font-size: 10px; font-family: monospace;', endpoint, 'font-family: sans-serif; font-weight: bold; font-size: 12px', 'font-family: sans-serif; font-weight: initial;', message, 'font-family: sans-serif; font-weight: bold;', 'font-family: monospace; font-weight: initial;', body, 'font-family: sans-serif; font-size: 12px; font-weight: bold;', event);
    const currentWindow = window;
    if (!$6955024b7a0709f2$var$isProduction() && currentWindow.Cypress) {
        if (!currentWindow.cypressSafeErrorsLog) currentWindow.cypressSafeErrorsLog = [];
        currentWindow.cypressSafeErrorsLog.push({
            body: body,
            endpoint: endpoint,
            level: level,
            message: message
        });
    }
    if (eventType !== 'object') {
        const errorMessage = `Invalid log API usage: expected event of type 'object', but was ${eventType}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    if (typeof body !== 'string') {
        const errorMessage = `Invalid log API usage: expected event of type 'string', but was ${eventType}; message will be replaced by: ${String(message)}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    return Promise.resolve();
};
const $6955024b7a0709f2$var$transformData = (location, message, event)=>{
    return {
        sentFrom: location,
        message: String(message),
        event: event,
        buildKey: window?.BUILD_KEY,
        logTime: new Date().toISOString()
    };
};
const $6955024b7a0709f2$var$sendData = (level, location, message, event = {})=>{
    const data = $6955024b7a0709f2$var$transformData(location, message, event);
    const body = JSON.stringify(data);
    const endpoint = `/rest/internal/2/log/safe/${level}`;
    if ($6955024b7a0709f2$var$isProduction()) return $6955024b7a0709f2$var$sendToServerBatched(body, endpoint);
    return $6955024b7a0709f2$var$sendToConsole(body, endpoint, level, message, typeof event, event);
};
const $6955024b7a0709f2$export$b8c037155fd57aaf = (location, message, event)=>{
    $6955024b7a0709f2$var$sendData('warn', location, message, event);
};

});


parcelRegister("dj5to", function(module, exports) {

$parcel$export(module.exports, "default", () => $e597542b503a321e$export$2e2bcd8739ae039);

var $6oLWS = parcelRequire("6oLWS");

var $iJZ8l = parcelRequire("iJZ8l");
const $e597542b503a321e$var$isCustomFilter = (filterId)=>/^\d+$/.test(filterId);
const $e597542b503a321e$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $e597542b503a321e$export$77232ec02db7a24a = {
    handle: (field, record, argValues)=>{
        // https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/
        // This lets relay know that a query of
        // JiraQuery.filter(id: ID!)
        // can return:
        //   - a JiraCustomFilter object
        //   - a JiraSystemFilter object
        // determined by the type encoded within the id field (which is an ARI type).
        // By providing the id that relay would refer to those objects by, it is able to check it's
        // store to see if they are already fetched, and avoid refetching them if it is unnecessary
        if (record != null && record.getType() === 'JiraQuery' && field.name === 'filter' && argValues.id != null) {
            const { id: id } = argValues;
            const filterId = (0, $6oLWS.JiraFilterAri).parse(id).filterId;
            if ($e597542b503a321e$var$isCustomFilter(filterId)) return (0, $iJZ8l.default)({
                id: id
            }, 'JiraCustomFilter');
            if ($e597542b503a321e$var$isSystemFilter(filterId)) return (0, $iJZ8l.default)({
                id: id
            }, 'JiraSystemFilter');
            return undefined;
        }
        return undefined;
    },
    kind: 'linked'
};
const $e597542b503a321e$var$MissingFieldHandlers = [
    $e597542b503a321e$export$77232ec02db7a24a
];
var $e597542b503a321e$export$2e2bcd8739ae039 = $e597542b503a321e$var$MissingFieldHandlers;

});
parcelRegister("6oLWS", function(module, exports) {

$parcel$export(module.exports, "JiraFilterAri", () => $4a8a2d9043bc2fd6$export$3cfb6cc809e835bd);

var $TjnT5 = parcelRequire("TjnT5");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/filter/manifest.ts
var $4a8a2d9043bc2fd6$var$jiraFilterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $TjnT5.JiraFilterAriResourceOwner),
    resourceType: (0, $TjnT5.JiraFilterAriResourceType),
    resourceIdSlug: "activation/{activationId}/{filterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        filterId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/filter/index.ts
var $4a8a2d9043bc2fd6$export$3cfb6cc809e835bd = class _JiraFilterAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._filterId = opts.resourceIdSegmentValues.filterId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get filterId() {
        return this._filterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4a8a2d9043bc2fd6$var$jiraFilterAriStaticOpts.qualifier,
            platformQualifier: $4a8a2d9043bc2fd6$var$jiraFilterAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4a8a2d9043bc2fd6$var$jiraFilterAriStaticOpts.resourceOwner,
            resourceType: $4a8a2d9043bc2fd6$var$jiraFilterAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.filterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                filterId: opts.filterId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $4a8a2d9043bc2fd6$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $4a8a2d9043bc2fd6$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            filterId: this.filterId
        };
    }
};

});
parcelRegister("TjnT5", function(module, exports) {

$parcel$export(module.exports, "JiraFilterAriResourceOwner", () => $0a642c7bb6f094f8$export$e6199848f52f1119);
$parcel$export(module.exports, "JiraFilterAriResourceType", () => $0a642c7bb6f094f8$export$3c64de4ae038e3ae);
// src/jira/filter/types.ts
var $0a642c7bb6f094f8$export$e6199848f52f1119 = "jira", $0a642c7bb6f094f8$export$3c64de4ae038e3ae = "filter";

});

parcelRegister("3NoER", function(module, exports) {

$parcel$export(module.exports, "RegisteredAri", () => $2c391344730fcde6$export$579ee78b1dcf0a11);

var $h29WZ = parcelRequire("h29WZ");
// src/core/registered-ari.ts
var $2c391344730fcde6$export$579ee78b1dcf0a11 = class extends (0, $h29WZ.Ari) {
    static check(maybeAri) {
        try {
            return this.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return (0, $h29WZ.AnyAri).parse(this.toString());
    }
};

});
parcelRegister("h29WZ", function(module, exports) {

$parcel$export(module.exports, "Ari", () => $c66a5785daf9f236$export$3a4885701291260b);
$parcel$export(module.exports, "AnyAri", () => $c66a5785daf9f236$export$44a7af7122933d6b);

var $gYPG7 = parcelRequire("gYPG7");
// src/core/ari.ts
var $c66a5785daf9f236$export$3a4885701291260b = class {
    constructor(opts){
        this._ati = (0, $gYPG7.Ati).create({
            platformQualifier: opts.platformQualifier || "cloud",
            resourceOwner: opts.resourceOwner,
            resourceType: opts.resourceType
        }), this._cloudId = opts.cloudId !== "" ? opts.cloudId : void 0, this._resourceId = opts.resourceId;
    }
    get platformQualifier() {
        return this._ati.platformQualifier;
    }
    get cloudId() {
        return this._cloudId;
    }
    get resourceOwner() {
        return this._ati.resourceOwner;
    }
    get resourceType() {
        return this._ati.resourceType;
    }
    get resourceId() {
        return this._resourceId;
    }
    get ati() {
        return this._ati;
    }
    equals(other) {
        return this.toString() === other.toString();
    }
    toString() {
        return `ari:${this.platformQualifier}:${this.resourceOwner}:${this.cloudId || ""}:${this.resourceType}/${this.resourceId}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this.platformQualifier,
            resourceOwner: this.resourceOwner,
            cloudId: this.cloudId,
            resourceType: this.resourceType,
            resourceId: this.resourceId
        };
    }
};
// src/any-ari.ts
var $c66a5785daf9f236$export$44a7af7122933d6b = class _AnyAri extends $c66a5785daf9f236$export$3a4885701291260b {
    constructor(opts){
        super(opts);
    }
    static create(ariOpts, ariStaticOpts) {
        let ariOptsWithDefaults = {
            ...ariOpts,
            resourceIdSegmentValues: {}
        }, validatedOpts = (0, $gYPG7.AriParser).fromOpts(ariOptsWithDefaults, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static parse(maybeAri, ariStaticOpts) {
        let validatedOpts = (0, $gYPG7.AriParser).fromString(maybeAri, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static check(maybeAri) {
        try {
            return _AnyAri.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return this;
    }
};

});
parcelRegister("gYPG7", function(module, exports) {

$parcel$export(module.exports, "AriParser", () => $c5ca562dc52f9aa4$export$4c3a8cde7a55740b);
$parcel$export(module.exports, "Ati", () => $c5ca562dc52f9aa4$export$ab4b293d0121b8ee);

var $fo7u7 = parcelRequire("fo7u7");

var $ed4UU = parcelRequire("ed4UU");
// src/core/rules/cloud-id.ts
function $c5ca562dc52f9aa4$var$validateCloudId(cloudId, format = new RegExp("^[a-zA-Z0-9_\\-.]{0,255}$")) {
    if (!cloudId.match(format)) throw new (0, $ed4UU.ValidationError)(`Invalid cloud ID, expected ID of format ${format}.`);
}
// src/core/rules/resource-id.ts
function $c5ca562dc52f9aa4$var$validateResourceId(id, format = new RegExp("[!a-zA-Z0-9\\-_.~@:;{}=]+(/[!a-zA-Z0-9\\-_.~@:;{}=]+)*" /* ANY_RESOURCE_ID */ ), key = "resourceId") {
    let formatWithCarets = new RegExp(`^${format.source}$`);
    if (!id.match(formatWithCarets)) throw new (0, $ed4UU.ValidationError)(`Invalid ${key} - ${id}, expected ID of format ${formatWithCarets}.`);
}
// src/core/rules/resource-id-segments.ts
function $c5ca562dc52f9aa4$var$validateResourceIdSegments(resourceIdSegmentValues, resourceIdSegmentFormats) {
    Object.entries(resourceIdSegmentValues).forEach(([resourceIdKey, resourceIdValue])=>{
        $c5ca562dc52f9aa4$var$validateResourceId(resourceIdValue, resourceIdSegmentFormats == null ? void 0 : resourceIdSegmentFormats[resourceIdKey], resourceIdKey);
    });
}
// src/core/rules/resource-owner.ts
function $c5ca562dc52f9aa4$var$validateResourceOwner(owner, expectedResourceOwner) {
    if (expectedResourceOwner && owner !== expectedResourceOwner) throw new (0, $ed4UU.ValidationError)(`Invalid resource owner - ${owner}, expected ${expectedResourceOwner}.`);
}
// src/core/rules/resource-type.ts
function $c5ca562dc52f9aa4$var$validateResourceType(type, expectedResourceType) {
    if (expectedResourceType && type !== expectedResourceType) throw new (0, $ed4UU.ValidationError)(`Invalid resource type - ${type}, expected ${expectedResourceType}.`);
}
// src/core/parser/ari.ts
var $c5ca562dc52f9aa4$var$NUMBER_OF_ARI_SEGMENTS = 5, $c5ca562dc52f9aa4$export$4c3a8cde7a55740b = class extends (0, $fo7u7.BaseParser) {
    static fromString(maybeAri, ariProperties) {
        let segments = this.getIdentifierSegments(maybeAri, $c5ca562dc52f9aa4$var$NUMBER_OF_ARI_SEGMENTS), [qualifier, platformQualifier, resourceOwner, cloudId, resourceTypeAndId] = segments, [resourceType, ...resourceIdSegments] = resourceTypeAndId.split("/"), maybeAriDerivedProperties = {
            qualifier: qualifier,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            resourceId: resourceIdSegments.join("/"),
            resourceIdSegmentValues: ariProperties != null && ariProperties.resourceIdSlug ? this.ariSegmentValuesFromSlug(ariProperties.resourceIdSlug, resourceIdSegments.join("/"), Object.keys(ariProperties.resourceIdSegmentFormats)) : {}
        };
        return this.fromOpts(maybeAriDerivedProperties, ariProperties);
    }
    static fromOpts(maybeAriOpts, ariProperties) {
        let { qualifier: qualifier = "ari", platformQualifier: platformQualifier = "cloud", resourceOwner: resourceOwner, cloudId: cloudId, resourceId: resourceId, resourceIdSegmentValues: resourceIdSegmentValues, resourceType: resourceType } = maybeAriOpts;
        return (0, $fo7u7.validateAriQualifier)(qualifier), (0, $fo7u7.validatePlatformQualifier)(platformQualifier), $c5ca562dc52f9aa4$var$validateCloudId(maybeAriOpts.cloudId || "", ariProperties == null ? void 0 : ariProperties.cloudId), $c5ca562dc52f9aa4$var$validateResourceOwner(resourceOwner, ariProperties == null ? void 0 : ariProperties.resourceOwner), $c5ca562dc52f9aa4$var$validateResourceType(resourceType, ariProperties == null ? void 0 : ariProperties.resourceType), $c5ca562dc52f9aa4$var$validateResourceIdSegments(resourceIdSegmentValues, ariProperties == null ? void 0 : ariProperties.resourceIdSegmentFormats), {
            qualifier: qualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceId: resourceId,
            resourceIdSegmentValues: resourceIdSegmentValues
        };
    }
    static ariSegmentValuesFromSlug(slug, incomingSegments, expectedKeys) {
        let regexpResult = new RegExp("^" + slug.replace(/\{(.*?)\}/g, "(?<$1>.*?)") + "$").exec(incomingSegments);
        if (!regexpResult) throw new (0, $ed4UU.ValidationError)(`Segment '${incomingSegments}' don't match expected slug: ${slug}`);
        return expectedKeys.forEach((expectedKey)=>{
            var _a;
            if (!((_a = regexpResult.groups) != null && _a[expectedKey])) throw new (0, $ed4UU.ValidationError)(`No value supplied for '${expectedKey}' based on slug ${slug}`);
        }), regexpResult.groups || {};
    }
};
// src/core/parser/ati.ts
var $c5ca562dc52f9aa4$var$NUMBER_OF_ATI_SEGMENTS = 4, $c5ca562dc52f9aa4$var$AtiParser = class extends (0, $fo7u7.BaseParser) {
    static fromString(inputStr, atiOpts) {
        let segments = this.getIdentifierSegments(inputStr, $c5ca562dc52f9aa4$var$NUMBER_OF_ATI_SEGMENTS), [qualifier = "ati", platformQualifier = "cloud", resourceOwner, resourceType] = segments;
        return (0, $fo7u7.validateAtiQualifier)(qualifier), (0, $fo7u7.validatePlatformQualifier)(platformQualifier), $c5ca562dc52f9aa4$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $c5ca562dc52f9aa4$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
    static fromOpts(maybeAtiOpts, atiOpts) {
        let { qualifier: qualifier, platformQualifier: platformQualifier, resourceOwner: resourceOwner, resourceType: resourceType } = maybeAtiOpts;
        return (0, $fo7u7.validateAtiQualifier)(qualifier), (0, $fo7u7.validatePlatformQualifier)(platformQualifier), $c5ca562dc52f9aa4$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $c5ca562dc52f9aa4$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
};
// src/ati.ts
var $c5ca562dc52f9aa4$export$ab4b293d0121b8ee = class _Ati {
    constructor(platformQualifier, resourceOwner, resourceType){
        this._platformQualifier = platformQualifier, this._resourceOwner = resourceOwner, this._resourceType = resourceType;
    }
    get platformQualifier() {
        return this._platformQualifier;
    }
    get resourceOwner() {
        return this._resourceOwner;
    }
    get resourceType() {
        return this._resourceType;
    }
    static create(opts) {
        return new _Ati(opts.platformQualifier || "cloud", opts.resourceOwner, opts.resourceType);
    }
    static parse(maybeAti, atiOpts) {
        let opts = $c5ca562dc52f9aa4$var$AtiParser.fromString(maybeAti, atiOpts);
        return new _Ati(opts.platformQualifier, opts.resourceOwner, opts.resourceType);
    }
    toString() {
        return `ati:${this.platformQualifier}:${this.resourceOwner}:${this.resourceType}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this._platformQualifier,
            resourceOwner: this._resourceOwner,
            resourceType: this._resourceType
        };
    }
};

});
parcelRegister("fo7u7", function(module, exports) {

$parcel$export(module.exports, "validatePlatformQualifier", () => $b33ee73cfb749d69$export$4f6e8fa90a16fdc4);
$parcel$export(module.exports, "validateAtiQualifier", () => $b33ee73cfb749d69$export$da331df28ad1f3d9);
$parcel$export(module.exports, "validateAriQualifier", () => $b33ee73cfb749d69$export$822bcd2b6f6774a1);
$parcel$export(module.exports, "BaseParser", () => $b33ee73cfb749d69$export$3d09a5c28ff3e040);

var $ed4UU = parcelRequire("ed4UU");
// src/core/rules/platform-qualifier.ts
function $b33ee73cfb749d69$export$4f6e8fa90a16fdc4(qualifier) {
    if (qualifier !== "cloud" && qualifier !== "third-party") throw new (0, $ed4UU.ValidationError)(`Identifier must have a qualifier of 'cloud' or 'third-party'. Received: ${qualifier}`);
}
// src/core/rules/qualifier.ts
function $b33ee73cfb749d69$export$da331df28ad1f3d9(qualifier) {
    if (qualifier !== "ati") throw new (0, $ed4UU.ValidationError)(`ATI must have a qualifier of 'ati'. Received: ${qualifier}`);
}
function $b33ee73cfb749d69$export$822bcd2b6f6774a1(qualifier) {
    if (qualifier !== "ari") throw new (0, $ed4UU.ValidationError)(`ARI must have a qualifier of 'ari'. Received: ${qualifier}`);
}
function $b33ee73cfb749d69$export$277c2bbc487e609d(qualifier) {
    if (qualifier !== "arm") throw new (0, $ed4UU.ValidationError)(`ARM must have a qualifier of 'arm'. Received: ${qualifier}`);
}
// src/core/parser/base.ts
var $b33ee73cfb749d69$var$NUMBER_OF_BASE_SEGMENTS = 5, $b33ee73cfb749d69$var$SEGMENT_SEPARATOR = ":", $b33ee73cfb749d69$export$3d09a5c28ff3e040 = class {
    static getIdentifierSegments(inputStr, numberOfSegmentsRequired) {
        let allSegments = inputStr.split($b33ee73cfb749d69$var$SEGMENT_SEPARATOR);
        if (allSegments.length < numberOfSegmentsRequired) throw new (0, $ed4UU.ValidationError)(`Input string must have ${numberOfSegmentsRequired} segments.`);
        if (allSegments.length > numberOfSegmentsRequired) {
            let segments = allSegments.slice(0, $b33ee73cfb749d69$var$NUMBER_OF_BASE_SEGMENTS - 1), segmentsForResourceId = allSegments.slice($b33ee73cfb749d69$var$NUMBER_OF_BASE_SEGMENTS - 1, allSegments.length);
            return [
                ...segments,
                segmentsForResourceId.join($b33ee73cfb749d69$var$SEGMENT_SEPARATOR)
            ];
        }
        return allSegments;
    }
};

});
parcelRegister("ed4UU", function(module, exports) {

$parcel$export(module.exports, "ValidationError", () => $a58617fff8cdca9e$export$2191b9da168c6cf0);
// src/errors.ts
var $a58617fff8cdca9e$export$2191b9da168c6cf0 = class extends Error {
};

});







parcelRegister("3Z1I9", function(module, exports) {

$parcel$export(module.exports, "network", () => $d27a06de13f76964$export$21fcfd9d5c6ebbd4);

var $eiowN = parcelRequire("eiowN");

var $eCZ6m = parcelRequire("eCZ6m");

var $fuqQp = parcelRequire("fuqQp");
function $d27a06de13f76964$var$fetchQuery(request, variables, cacheConfig) {
    const endpoint = (0, $eCZ6m.getAggEndpoint)(request, cacheConfig);
    const body = (0, $eCZ6m.getRequestBody)(request, variables);
    return fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            // Add authentication and other headers here
            'content-type': 'application/json',
            'X-ExperimentalApi': (0, $fuqQp.RelayExperimentalApis).join(',')
        },
        body: body
    }).then((response)=>{
        return response.json();
    });
}
const $d27a06de13f76964$export$21fcfd9d5c6ebbd4 = (0, $eiowN.Network).create($d27a06de13f76964$var$fetchQuery);

});
parcelRegister("fuqQp", function(module, exports) {

$parcel$export(module.exports, "RelayExperimentalApis", () => $844757ca53e86821$export$ebe3a775ce3053a5);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
const $844757ca53e86821$export$ebe3a775ce3053a5 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs'
];

});


parcelRegister("iExP6", function(module, exports) {

$parcel$export(module.exports, "default", () => $42dcb07af95a04bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$42dcb07af95a04bd$export$2e2bcd8739ae039 = {
    cancel: ()=>{},
    schedule: (fn)=>{
        // react 16.x
        if (// `unstable_batchedUpdates` is defined in all currently supported versions
        // but could be removed in the future.
        // This check is defensive and not currently necessary.
        typeof (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).unstable_batchedUpdates === 'function' && // The version export was only introduced in `react-dom@16.13.0`
        // but we need to support `react-dom@^16.8.0`
        // so we need to handle when the version is `undefined`
        (typeof (0, $7nsd3.version) === 'undefined' || (0, $7nsd3.version).startsWith('16'))) (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).unstable_batchedUpdates(()=>{
            fn();
        });
        else if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).startTransition === 'function') // @ts-ignore-error React.startTransition does not exist in react-16
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).startTransition(()=>{
            fn();
        });
        else fn();
        return '';
    }
};

});


parcelRegister("1ciso", function(module, exports) {

$parcel$export(module.exports, "useUFOTransitionCompleter", () => $438df80413aa7a79$export$369f0ded13ce6c50);
$parcel$export(module.exports, "default", () => $438df80413aa7a79$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $5gx4p = parcelRequire("5gx4p");

var $fe1wc = parcelRequire("fe1wc");

var $tcn7E = parcelRequire("tcn7E");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $9AgLs = parcelRequire("9AgLs");

var $g2MbB = parcelRequire("g2MbB");
function $438df80413aa7a79$var$traceUFOTransition(ufoName, routeName = ufoName) {
    const pressInteractionsList = (0, $fe1wc.getDoNotAbortActivePressInteractionOnTransition)();
    const interaction = (0, $bFU4G.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, $bFU4G.abortAll)('transition', ufoName ?? undefined);
    if (ufoName) {
        (0, $9AgLs.default).current = ufoName;
        const rate = (0, $fe1wc.getInteractionRate)(ufoName, 'transition');
        if ((0, $5gx4p.default)(rate)) {
            const newId = (0, $7Jxgt.v4)();
            (0, $g2MbB.setInteractionActiveTrace)(newId);
            (0, $1u4q7.DefaultInteractionID).current = newId;
            (0, $bFU4G.addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, $tcn7E.getActiveTrace)());
        }
    }
}
function $438df80413aa7a79$export$369f0ded13ce6c50() {
    const interactionId = (0, $5uXOq.useContext)((0, $1u4q7.default));
    const capturedInteractionId = interactionId.current;
    (0, $5uXOq.useEffect)(()=>{
        // If we have a current interaction set...
        if (capturedInteractionId != null) {
            let cancel = requestAnimationFrame(()=>{
                cancel = requestAnimationFrame(()=>{
                    if (capturedInteractionId === interactionId.current) (0, $bFU4G.tryComplete)(capturedInteractionId);
                });
            });
            (0, $bFU4G.addOnCancelCallback)(capturedInteractionId, ()=>{
                cancelAnimationFrame(cancel);
            });
        }
    }, [
        capturedInteractionId,
        interactionId
    ]);
}
var $438df80413aa7a79$export$2e2bcd8739ae039 = $438df80413aa7a79$var$traceUFOTransition;

});
parcelRegister("9AgLs", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8d26e69bb020063$export$2e2bcd8739ae039);
// The UFORouteName object is a global singleton
const $c8d26e69bb020063$var$UFORouteName = {
    current: null
};
var $c8d26e69bb020063$export$2e2bcd8739ae039 = $c8d26e69bb020063$var$UFORouteName;

});

parcelRegister("g2MbB", function(module, exports) {

$parcel$export(module.exports, "setInteractionActiveTrace", () => $ccb60b9a6e8b8304$export$f2e521e495a88544);

var $tcn7E = parcelRequire("tcn7E");

var $hIIZV = parcelRequire("hIIZV");
function $ccb60b9a6e8b8304$export$f2e521e495a88544(newId) {
    (0, $tcn7E.setActiveTrace)(newId.replace(/-/g, ''), (0, $hIIZV.generateSpanId)(), 'transition');
}

});
parcelRegister("hIIZV", function(module, exports) {

$parcel$export(module.exports, "generateSpanId", () => $633f98d7288c3c20$export$295213bc4d0c54ad);
function $633f98d7288c3c20$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});



parcelRegister("1AZST", function(module, exports) {

$parcel$export(module.exports, "GlobalPageLoadExperience", () => $58d2d6be5127a354$export$bf7c1e56255f1467);

var $gjd6t = parcelRequire("gjd6t");

var $4wnip = parcelRequire("4wnip");

var $atdLB = parcelRequire("atdLB");

var $8OuDJ = parcelRequire("8OuDJ");
class $58d2d6be5127a354$var$UFOGlobalPageLoadExperience extends (0, $4wnip.UFOAbstractExperience) {
    startPageLoad(id, initial = false, startTime) {
        const result = super.start(initial ? 0 : (0, $4wnip.perfNowOrTimestamp)(startTime));
        this.setPageLoadId(id);
        this.initial = initial;
        return result;
    }
    updateConfig(config) {
        Object.assign(this.config, config);
    }
    setPageLoadId(id) {
        this.loadingPageLoadId = id;
    }
    async getId() {
        return this.loadingPageLoadId;
    }
    async exportData() {
        const data = await super.exportData();
        return {
            ...data,
            initial: this.initial
        };
    }
    constructor(...args){
        super(...args), this.loadingPageLoadId = 'UNKNOWN', this.type = (0, $atdLB.ExperienceTypes).Load, this.performanceType = (0, $atdLB.ExperiencePerformanceTypes).PageLoad, this.initial = true;
    }
}
const $58d2d6be5127a354$export$bf7c1e56255f1467 = new $58d2d6be5127a354$var$UFOGlobalPageLoadExperience('UFO_GLOBAL_PAGE_LOAD', {
    type: (0, $atdLB.ExperienceTypes).Load,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageLoad,
    // this should come from global config
    until: (0, $gjd6t.untilAll)([
        {
            category: (0, $8OuDJ.PageSegmentExperienceTypes).PRODUCT
        }
    ])
});

});
parcelRegister("gjd6t", function(module, exports) {

$parcel$export(module.exports, "untilAll", () => $8203c6dc9cf3beaa$export$44695628831598be);

var $eoXiD = parcelRequire("eoXiD");

var $lc9Xi = parcelRequire("lc9Xi");
const $8203c6dc9cf3beaa$var$isUntilExperience = (until)=>{
    return until.experience !== undefined;
};
const $8203c6dc9cf3beaa$var$isUntilCategory = (until)=>{
    return until.category !== undefined;
};
const $8203c6dc9cf3beaa$export$44695628831598be = (deps)=>()=>{
        const notMet = [
            ...deps
        ];
        return (data)=>{
            if (notMet.length > 0) {
                const doneIndexes = notMet.reduce((acc, dep, i)=>{
                    // validation logic
                    if ($8203c6dc9cf3beaa$var$isUntilExperience(dep) && dep.experience.uuid === data.uuid) acc.push(i);
                    else if ($8203c6dc9cf3beaa$var$isUntilCategory(dep) && dep.category === data.category) acc.push(i);
                    return acc;
                }, []);
                const priorityStateFound = data.state === (0, $lc9Xi.UFOExperienceState).ABORTED || data.state === (0, $lc9Xi.UFOExperienceState).FAILED;
                if (priorityStateFound) {
                    notMet.length = 0;
                    return {
                        done: true,
                        state: data.state
                    };
                }
                doneIndexes.reverse().forEach((i)=>{
                    notMet.splice(i, 1);
                });
                (0, $eoXiD.ufolog)('untilAll deps left:', notMet.length, notMet);
                if (notMet.length === 0) return {
                    done: true,
                    state: (0, $lc9Xi.UFOExperienceState).SUCCEEDED
                };
            }
            return {
                done: false
            };
        };
    };

});
parcelRegister("lc9Xi", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $afba37b3d9fab1f5$export$81b70111112841a0);
const $afba37b3d9fab1f5$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});


parcelRegister("4wnip", function(module, exports) {

$parcel$export(module.exports, "perfNowOrTimestamp", () => $feec6df92685c668$export$c753e8669d30c8ad);
$parcel$export(module.exports, "UFOAbstractExperience", () => $feec6df92685c668$export$d31c89db257648c);

var $7Jxgt = parcelRequire("7Jxgt");


var $8Nn2p = parcelRequire("8Nn2p");

var $iJHxx = parcelRequire("iJHxx");

var $eoXiD = parcelRequire("eoXiD");

var $3aRrh = parcelRequire("3aRrh");

var $fSTSz = parcelRequire("fSTSz");

var $ijH9f = parcelRequire("ijH9f");

var $lc9Xi = parcelRequire("lc9Xi");

var $aqfim = parcelRequire("aqfim");

var $atdLB = parcelRequire("atdLB");
const $feec6df92685c668$var$getPageVisibleState = ()=>{
    return !(0, $8Nn2p.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $fSTSz.PageVisibleState).VISIBLE : (0, $fSTSz.PageVisibleState).HIDDEN;
};
const $feec6df92685c668$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $ijH9f.roundPerfNow)();
};
class $feec6df92685c668$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $lc9Xi.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $fSTSz.PageVisibleState).MIXED;
            (0, $3aRrh.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $feec6df92685c668$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $atdLB.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $eoXiD.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $aqfim.canTransition)(this.state, newState)) {
            (0, $eoXiD.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $lc9Xi.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $feec6df92685c668$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $7Jxgt.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $feec6df92685c668$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $iJHxx.getGlobalEventStream)().push((0, $iJHxx.unsubscribeEvent)((0, $fSTSz.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $eoXiD.ufolog)('this.parent', this.parent);
                (0, $iJHxx.getGlobalEventStream)().push((0, $iJHxx.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $eoXiD.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $eoXiD.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $lc9Xi.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $feec6df92685c668$var$getPageVisibleState();
            (0, $3aRrh.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $eoXiD.ufolog)('subscribed', this.id);
                (0, $iJHxx.getGlobalEventStream)().push((0, $iJHxx.subscribeEvent)((0, $fSTSz.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $fSTSz.FMP_MARK) && name !== (0, $fSTSz.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $eoXiD.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $feec6df92685c668$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $lc9Xi.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $fSTSz.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $fSTSz.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $eoXiD.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $3aRrh.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $lc9Xi.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $lc9Xi.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $lc9Xi.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $eoXiD.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $356a3e48ee714997$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $356a3e48ee714997$export$2295b861f318254a = '0.1.5';

parcelRegister("ijH9f", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $0b1119ad19ca6f95$export$5f490af6b2b115cf);
const $0b1119ad19ca6f95$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("aqfim", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $1ad4fd296053ba67$export$178881f329fdb81f);

var $lc9Xi = parcelRequire("lc9Xi");
const $1ad4fd296053ba67$var$UFOStateAvailableTransitions = {
    [(0, $lc9Xi.UFOExperienceState).NOT_STARTED.id]: [
        (0, $lc9Xi.UFOExperienceState).STARTED.id
    ],
    [(0, $lc9Xi.UFOExperienceState).STARTED.id]: [
        (0, $lc9Xi.UFOExperienceState).IN_PROGRESS.id,
        (0, $lc9Xi.UFOExperienceState).BLOCKED.id,
        (0, $lc9Xi.UFOExperienceState).SUCCEEDED.id,
        (0, $lc9Xi.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $lc9Xi.UFOExperienceState).FAILED.id,
        (0, $lc9Xi.UFOExperienceState).ABORTED.id
    ],
    [(0, $lc9Xi.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $lc9Xi.UFOExperienceState).BLOCKED.id,
        (0, $lc9Xi.UFOExperienceState).SUCCEEDED.id,
        (0, $lc9Xi.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $lc9Xi.UFOExperienceState).FAILED.id,
        (0, $lc9Xi.UFOExperienceState).ABORTED.id
    ],
    [(0, $lc9Xi.UFOExperienceState).BLOCKED.id]: [
        (0, $lc9Xi.UFOExperienceState).RECOVERED.id,
        (0, $lc9Xi.UFOExperienceState).ABORTED.id
    ],
    [(0, $lc9Xi.UFOExperienceState).RECOVERED.id]: [
        (0, $lc9Xi.UFOExperienceState).STARTED.id,
        (0, $lc9Xi.UFOExperienceState).SUCCEEDED.id,
        (0, $lc9Xi.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $lc9Xi.UFOExperienceState).FAILED.id,
        (0, $lc9Xi.UFOExperienceState).ABORTED.id
    ],
    [(0, $lc9Xi.UFOExperienceState).SUCCEEDED.id]: [
        (0, $lc9Xi.UFOExperienceState).STARTED.id
    ],
    [(0, $lc9Xi.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $lc9Xi.UFOExperienceState).SUCCEEDED.id,
        (0, $lc9Xi.UFOExperienceState).FAILED.id,
        (0, $lc9Xi.UFOExperienceState).ABORTED.id
    ],
    [(0, $lc9Xi.UFOExperienceState).FAILED.id]: [
        (0, $lc9Xi.UFOExperienceState).STARTED.id
    ],
    [(0, $lc9Xi.UFOExperienceState).ABORTED.id]: [
        (0, $lc9Xi.UFOExperienceState).STARTED.id
    ]
};
const $1ad4fd296053ba67$export$178881f329fdb81f = (state1, state2)=>{
    return $1ad4fd296053ba67$var$UFOStateAvailableTransitions[state1.id] && $1ad4fd296053ba67$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});


parcelRegister("8OuDJ", function(module, exports) {

$parcel$export(module.exports, "PageSegmentExperienceTypes", () => $d503287aeff5c694$export$17d97452062ccf73);
const $d503287aeff5c694$export$17d97452062ccf73 = {
    NAVIGATION: 'NAVIGATION',
    PRODUCT: 'PRODUCT',
    COMPONENT: 'COMPONENT'
};

});


parcelRegister("dGrdR", function(module, exports) {

$parcel$export(module.exports, "metrics", () => $61d987f8a2b40232$export$b0c5c2fac8144e54);

var $e0JCa = parcelRequire("e0JCa");

var $FEKPs = parcelRequire("FEKPs");
const $61d987f8a2b40232$export$b0c5c2fac8144e54 = {
    pageLoad: $FEKPs.pageLoad,
    pageSegmentLoad: $FEKPs.pageSegmentLoad,
    interaction: $FEKPs.interaction,
    custom: $FEKPs.custom,
    concurrent: $e0JCa.concurrent
};

});
parcelRegister("e0JCa", function(module, exports) {

$parcel$export(module.exports, "concurrent", () => $50ff45ae01d4cc6c$export$370df09ecc3de059);

var $2OjhD = parcelRequire("2OjhD");

var $FEKPs = parcelRequire("FEKPs");
const $50ff45ae01d4cc6c$var$concurrentMetrics = {};
const $50ff45ae01d4cc6c$var$getKey = (config, type)=>`${type}--${config.key}`;
const $50ff45ae01d4cc6c$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $50ff45ae01d4cc6c$var$ensurePath = (config, type)=>{
    const key = $50ff45ae01d4cc6c$var$getKey(config, type);
    if (!(key in $50ff45ae01d4cc6c$var$concurrentMetrics)) $50ff45ae01d4cc6c$var$concurrentMetrics[key] = {};
};
const $50ff45ae01d4cc6c$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $50ff45ae01d4cc6c$var$getKey(config, type);
    if (concurrentKey in $50ff45ae01d4cc6c$var$concurrentMetrics && $50ff45ae01d4cc6c$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $50ff45ae01d4cc6c$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $50ff45ae01d4cc6c$var$concurrentMetrics)) $50ff45ae01d4cc6c$var$concurrentMetrics[concurrentKey] = {};
};
const $50ff45ae01d4cc6c$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $50ff45ae01d4cc6c$var$validateConfig(config);
    $50ff45ae01d4cc6c$var$ensurePath(config, type);
    const metricFromCache = $50ff45ae01d4cc6c$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $2OjhD.BMEventsType).INLINE_RESULT ? (0, $FEKPs.interaction) : (0, $FEKPs.custom);
    const metric = metricFactory(config);
    $50ff45ae01d4cc6c$var$concurrentMetrics[$50ff45ae01d4cc6c$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $50ff45ae01d4cc6c$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$50ff45ae01d4cc6c$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $2OjhD.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$50ff45ae01d4cc6c$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $2OjhD.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$50ff45ae01d4cc6c$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $2OjhD.BMEventsType).CUSTOM)
};

});
parcelRegister("FEKPs", function(module, exports) {

$parcel$export(module.exports, "pageLoad", () => $2453836fd9363fae$export$791d520f7e8058a5);
$parcel$export(module.exports, "pageSegmentLoad", () => $2453836fd9363fae$export$94114666844d5f66);
$parcel$export(module.exports, "interaction", () => $2453836fd9363fae$export$92473e6020ad89b4);
$parcel$export(module.exports, "custom", () => $2453836fd9363fae$export$4c00f665f0d4b443);

var $7WP2K = parcelRequire("7WP2K");

var $5jIc1 = parcelRequire("5jIc1");

var $5JtK5 = parcelRequire("5JtK5");

var $2OjhD = parcelRequire("2OjhD");
const $2453836fd9363fae$export$791d520f7e8058a5 = (config)=>{
    return new (0, $5jIc1.PageLoadMetric)({
        ...config,
        type: (0, $2OjhD.BMEventsType).PAGE_LOAD
    });
};
const $2453836fd9363fae$export$94114666844d5f66 = (config)=>{
    return new (0, $5JtK5.PageSegmentLoadMetric)({
        ...config,
        type: (0, $2OjhD.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $2453836fd9363fae$export$92473e6020ad89b4 = (config)=>{
    return new (0, $7WP2K.Metric)({
        ...config,
        type: (0, $2OjhD.BMEventsType).INLINE_RESULT
    });
};
const $2453836fd9363fae$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $7WP2K.Metric)({
        ...config,
        type: (0, $2OjhD.BMEventsType).CUSTOM
    });
};

});
parcelRegister("7WP2K", function(module, exports) {

$parcel$export(module.exports, "Metric", () => $8418d1a2eefca193$export$efdd3e096bc27746);

var $dNz07 = parcelRequire("dNz07");

var $9mLUv = parcelRequire("9mLUv");

var $faqZ3 = parcelRequire("faqZ3");
class $8418d1a2eefca193$export$efdd3e096bc27746 extends (0, $faqZ3.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $dNz07.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $9mLUv.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}

});

parcelRegister("5jIc1", function(module, exports) {

$parcel$export(module.exports, "PageLoadMetric", () => $c2cc5063230743d5$export$3c51073271a9eac3);

var $Y0qGc = parcelRequire("Y0qGc");

var $1a316 = parcelRequire("1a316");

var $dNz07 = parcelRequire("dNz07");

var $9mLUv = parcelRequire("9mLUv");

var $2OjhD = parcelRequire("2OjhD");

var $hjsyZ = parcelRequire("hjsyZ");

var $7cRo8 = parcelRequire("7cRo8");

var $3bF54 = parcelRequire("3bF54");
class $c2cc5063230743d5$export$3c51073271a9eac3 extends (0, $hjsyZ.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $7cRo8.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $7cRo8.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $7cRo8.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $hjsyZ.BasePageLoadMetric).FMP]) {
                const mark = (0, $Y0qGc.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $7cRo8.pageLoadMetaMetric).markFMP(mark);
            } else (0, $7cRo8.pageLoadMetaMetric).markFMP(this.marks[(0, $hjsyZ.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $dNz07.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $9mLUv.submitter).queue(data);
        (0, $1a316.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $7cRo8.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $7cRo8.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $7cRo8.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $9mLUv.submitter).config.configChunk;
        if (!configChunk?.[(0, $2OjhD.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $3bF54.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $9mLUv.submitter).queue(webVitalMetric.getData());
        (0, $1a316.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}

});
parcelRegister("3bF54", function(module, exports) {

$parcel$export(module.exports, "WebVitalsMetric", () => $e10632e38915f687$export$dc0d85d4d6503cd7);

var $2OjhD = parcelRequire("2OjhD");

var $faqZ3 = parcelRequire("faqZ3");
class $e10632e38915f687$export$dc0d85d4d6503cd7 extends (0, $faqZ3.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $2OjhD.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $faqZ3.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}

});


parcelRegister("5JtK5", function(module, exports) {

$parcel$export(module.exports, "PageSegmentLoadMetric", () => $868251c1eede1606$export$24c8bfcd77494cc1);

var $Y0qGc = parcelRequire("Y0qGc");

var $2OjhD = parcelRequire("2OjhD");

var $faqZ3 = parcelRequire("faqZ3");

var $7WP2K = parcelRequire("7WP2K");

var $7cRo8 = parcelRequire("7cRo8");
class $868251c1eede1606$export$24c8bfcd77494cc1 extends (0, $7WP2K.Metric) {
    static{
        this.FMP = 'fmp';
    }
    constructor(config){
        super(config), this.isInitial = true;
        this.config = config;
    }
    startFromPageLoad() {
        const pageLoadMetaData = (0, $7cRo8.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $868251c1eede1606$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($868251c1eede1606$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $7cRo8.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$868251c1eede1606$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $Y0qGc.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $2OjhD.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $faqZ3.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $faqZ3.MetricState).STARTED) (0, $7cRo8.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
}

});




parcelRegister("dGvGJ", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", () => $9f67c73d64e1d92a$export$281bff7f05488aa2, (v) => $9f67c73d64e1d92a$export$281bff7f05488aa2 = v);
$parcel$export(module.exports, "createSelectorCreator", () => $9f67c73d64e1d92a$export$5943f4447f6ef248, (v) => $9f67c73d64e1d92a$export$5943f4447f6ef248 = v);
$parcel$export(module.exports, "createStructuredSelector", () => $9f67c73d64e1d92a$export$75979cfcd91bf38f, (v) => $9f67c73d64e1d92a$export$75979cfcd91bf38f = v);
$parcel$export(module.exports, "createSelector", () => $9f67c73d64e1d92a$export$595d22ed68ca2841, (v) => $9f67c73d64e1d92a$export$595d22ed68ca2841 = v);
var $9f67c73d64e1d92a$export$1e511d4a378977f5;
var $9f67c73d64e1d92a$export$281bff7f05488aa2;
var $9f67c73d64e1d92a$export$5943f4447f6ef248;
var $9f67c73d64e1d92a$export$75979cfcd91bf38f;
var $9f67c73d64e1d92a$export$595d22ed68ca2841;
'use strict';
$9f67c73d64e1d92a$export$1e511d4a378977f5 = true;
$9f67c73d64e1d92a$export$281bff7f05488aa2 = $9f67c73d64e1d92a$var$defaultMemoize;
$9f67c73d64e1d92a$export$5943f4447f6ef248 = $9f67c73d64e1d92a$var$createSelectorCreator;
$9f67c73d64e1d92a$export$75979cfcd91bf38f = $9f67c73d64e1d92a$var$createStructuredSelector;
function $9f67c73d64e1d92a$var$defaultEqualityCheck(a, b) {
    return a === b;
}
function $9f67c73d64e1d92a$var$areArgumentsShallowlyEqual(equalityCheck, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false;
    // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
    var length = prev.length;
    for(var i = 0; i < length; i++){
        if (!equalityCheck(prev[i], next[i])) return false;
    }
    return true;
}
function $9f67c73d64e1d92a$var$defaultMemoize(func) {
    var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9f67c73d64e1d92a$var$defaultEqualityCheck;
    var lastArgs = null;
    var lastResult = null;
    // we reference arguments instead of spreading them for performance reasons
    return function() {
        if (!$9f67c73d64e1d92a$var$areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) // apply arguments instead of spreading for performance.
        lastResult = func.apply(null, arguments);
        lastArgs = arguments;
        return lastResult;
    };
}
function $9f67c73d64e1d92a$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep;
        }).join(', ');
        throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
    }
    return dependencies;
}
function $9f67c73d64e1d92a$var$createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptions[_key - 1] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var recomputations = 0;
        var resultFunc = funcs.pop();
        var dependencies = $9f67c73d64e1d92a$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(undefined, [
            function() {
                recomputations++;
                // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(memoizeOptions));
        // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = $9f67c73d64e1d92a$var$defaultMemoize(function() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            params.push(dependencies[i].apply(null, arguments));
            // apply arguments instead of spreading for performance.
            return memoizedResultFunc.apply(null, params);
        });
        selector.resultFunc = resultFunc;
        selector.recomputations = function() {
            return recomputations;
        };
        selector.resetRecomputations = function() {
            return recomputations = 0;
        };
        return selector;
    };
}
var $9f67c73d64e1d92a$var$createSelector = $9f67c73d64e1d92a$export$595d22ed68ca2841 = $9f67c73d64e1d92a$var$createSelectorCreator($9f67c73d64e1d92a$var$defaultMemoize);
function $9f67c73d64e1d92a$var$createStructuredSelector(selectors) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9f67c73d64e1d92a$var$createSelector;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
    var objectKeys = Object.keys(selectors);
    return selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
}

});

parcelRegister("jI6pi", function(module, exports) {

$parcel$export(module.exports, "addTimingFromPerformanceMark", () => $0d5c580691017430$export$758b9a33800fa436);
$parcel$export(module.exports, "getTimings", () => $0d5c580691017430$export$6d488733a547304);
const $0d5c580691017430$var$timings = [];
function $0d5c580691017430$export$758b9a33800fa436(name, startMark, stopMark, cleanStart = false, cleanStop = false) {
    $0d5c580691017430$var$timings.push({
        name: name,
        startMark: startMark,
        stopMark: stopMark,
        cleanStart: cleanStart,
        cleanStop: cleanStop
    });
}
function $0d5c580691017430$export$6d488733a547304() {
    const reportedTimingsObj = {};
    $0d5c580691017430$var$timings.forEach(({ name: name, startMark: startMark, stopMark: stopMark, cleanStart: cleanStart, cleanStop: cleanStop })=>{
        const startEntryList = performance.getEntriesByName(startMark);
        const stopEntryList = performance.getEntriesByName(stopMark);
        if (startEntryList?.length > 0 && stopEntryList?.length > 0) {
            const startEntry = startEntryList[startEntryList.length - 1];
            const stopEntry = stopEntryList[stopEntryList.length - 1];
            const { startTime: startTime } = startEntry;
            const duration = stopEntry.startTime - startTime;
            const timing = {
                startTime: Math.round(startTime),
                duration: Math.round(duration)
            };
            reportedTimingsObj[name] = timing;
        }
        if (cleanStart) performance.clearMarks(startMark);
        if (cleanStop) performance.clearMarks(stopMark);
    });
    return reportedTimingsObj;
}

});

parcelRegister("fKgem", function(module, exports) {
module.exports = $b767bdf46d56eeb2$var$defaultsPlugin;
function $b767bdf46d56eeb2$var$defaultsPlugin() {
    var defaultValues = {};
    return {
        defaults: defaults,
        get: get
    };
    function defaults(_, values) {
        defaultValues = values;
    }
    function get(super_fn, key) {
        var val = super_fn();
        return val !== undefined ? val : defaultValues[key];
    }
}

});

parcelRegister("bHibm", function(module, exports) {

$parcel$export(module.exports, "AtlBrowserStorageLocal", () => $77ca41164f368d83$export$c8cc3ffd3f2c1d2f);
$parcel$export(module.exports, "AtlBrowserStorageSession", () => $77ca41164f368d83$export$edbae459bdf957a5);
$parcel$export(module.exports, "findStorageTarget", () => $77ca41164f368d83$export$14921bfc334334c0);
$parcel$export(module.exports, "WebStorageType", () => (parcelRequire("3iwZ5")).WebStorageType);

var $gMWuT = parcelRequire("gMWuT");
var $ljmYJ = parcelRequire("ljmYJ");

var $Dyz2r = parcelRequire("Dyz2r");

var $8FFpF = parcelRequire("8FFpF");

var $3uyrZ = parcelRequire("3uyrZ");

var $3iwZ5 = parcelRequire("3iwZ5");

var $3KKvX = parcelRequire("3KKvX");
var $3jvQx = parcelRequire("3jvQx");
var $Ux8bG = parcelRequire("Ux8bG");
class $77ca41164f368d83$export$8e4a3cf07a10930b {
    constructor(storage, storageType){
        this.isAvailable = false;
        this.checkIfSetByPackage = async ({ itemKey: itemKey, isSetCallback: isSetCallback = ()=>{}, isNotSetCallback: isNotSetCallback = ()=>{} })=>{
            // As IDB is asynchronous in nature, when this in invoked, we need to rely on the callbacks
            // to actually do something with the result.
            try {
                const record = await (0, $3uyrZ.BSCIndexedDB).getRecord(itemKey);
                if (record) {
                    isSetCallback();
                    return true;
                } else {
                    isNotSetCallback();
                    return false;
                }
            } catch (e) {
                // If it fails to pull from IDB, we can't validate that it's been set by our package or not, so log the error
                // and assume it hasn't been set by our package. This will only impact our analytics correctness.
                (0, $Dyz2r.Logger).errorWithOperationalEvent({
                    action: 'usedCheckIfSetByPackageError',
                    message: `IDB lookup failed to check if item was set by package. ${e.message || ''}`,
                    attributes: {
                        itemKey: itemKey
                    }
                });
                isNotSetCallback();
                return false;
            }
        };
        this.storage = storage;
        this.storageType = storageType;
        this.isAvailable = this.isStorageAvailable();
    }
    get isWebStorageEnabled() {
        // Note: outside of user configuration, webStoragedEnabled is also feature gated by
        // 1. platform_moonjelly_bsc_master_killswitch
        // 2. platform_moonjelly_bsc_web_storage_killswitch
        if ((0, $gMWuT.getBscGlobalState)().webStorageEnabled) return true;
        (0, $Dyz2r.Logger).debug('WebStorage config is disabled, cannot proceed.');
        return false;
    }
    // Core API
    getItem(key) {
        if (!this.isWebStorageEnabled) return this.storage.getItem(key);
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $Dyz2r.Logger).warn(`${this.storageType} is unavailable. Failed to get item ${key}`);
            return null;
        }
        const retrievedItem = (0, $3KKvX.getStorageItem)(key, this.storageType, this.storage);
        return retrievedItem;
    }
    async setItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $Dyz2r.Logger).warn(`${this.storageType} is unavailable. Failed to set item ${key}`);
            return;
        }
        const globalStateProduct = (0, $gMWuT.getBscGlobalState)().product;
        const itemSetStatus = await (0, $3jvQx.setStorageItem)(key, value, this.storageType, globalStateProduct, this.storage);
        (0, $Dyz2r.Logger).debug(`${itemSetStatus === (0, $8FFpF.Status).SUCCESS ? 'Successfully' : 'Failed to'} set item ${key} with value ${value}`);
    }
    setStrictlyNecessaryItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $Dyz2r.Logger).warn(`${this.storageType} is unavailable. Failed to set strictly necessary item ${key}`);
            return;
        }
        const itemSetStatus = (0, $Ux8bG.setStrictlyNecessaryStorageItem)(key, value, this.storageType, this.storage);
        (0, $Dyz2r.Logger).debug(`${itemSetStatus === (0, $8FFpF.Status).SUCCESS ? 'Successfully' : 'Failed to'} set strictly necessary item ${key} with value ${value}`);
    }
    // Native Utilities
    removeItem(key) {
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $Dyz2r.Logger).warn(`${this.storageType} is unavailable. Failed to remove item ${key}`);
            return;
        }
        this.storage.removeItem(key);
    }
    key(index) {
        if (!this.isAvailable) return null;
        return this.storage.key(index);
    }
    length() {
        if (!this.isAvailable) return 0;
        return this.storage.length;
    }
    clear() {
        if (!this.isAvailable) return;
        this.storage.clear();
    }
    // Utilities
    isStorageAvailable() {
        if ((0, $ljmYJ.isSSR)()) return false;
        try {
            const x = '__storage_test__';
            this.storage.setItem(x, x);
            this.storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && // everything except Firefox
            (e.code === 22 || // Firefox
            e.code === 1014 || // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' || // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
            this.storage && this.storage.length !== 0;
        }
    }
}
const $77ca41164f368d83$export$c8cc3ffd3f2c1d2f = new $77ca41164f368d83$export$8e4a3cf07a10930b(window?.localStorage, (0, $3iwZ5.WebStorageType).LocalStorage);
const $77ca41164f368d83$export$edbae459bdf957a5 = new $77ca41164f368d83$export$8e4a3cf07a10930b(window?.sessionStorage, (0, $3iwZ5.WebStorageType).SessionStorage);
const $77ca41164f368d83$export$14921bfc334334c0 = (type)=>{
    return ({
        [(0, $3iwZ5.WebStorageType).LocalStorage]: $77ca41164f368d83$export$c8cc3ffd3f2c1d2f,
        [(0, $3iwZ5.WebStorageType).SessionStorage]: $77ca41164f368d83$export$edbae459bdf957a5
    })[type];
};

});
parcelRegister("gMWuT", function(module, exports) {

$parcel$export(module.exports, "getBscGlobalState", () => $d8e2f6a273855d4e$export$3b78a1ea01f5ec28);
$parcel$export(module.exports, "initializeGlobalState", () => $d8e2f6a273855d4e$export$882c4530c58781d8);

var $eYli8 = parcelRequire("eYli8");

var $VSDnB = parcelRequire("VSDnB");

var $8FFpF = parcelRequire("8FFpF");

var $ijunp = parcelRequire("ijunp");

var $Dyz2r = parcelRequire("Dyz2r");
let $d8e2f6a273855d4e$var$analyticsEnabledGlobalState;
let $d8e2f6a273855d4e$var$productGlobalState;
let $d8e2f6a273855d4e$var$perimeterGlobalState;
let $d8e2f6a273855d4e$var$webStorageControlsEnabledGlobalState;
let $d8e2f6a273855d4e$var$localConsentModeGlobalState;
let $d8e2f6a273855d4e$var$packageDebugModeEnabledGlobalState;
let $d8e2f6a273855d4e$var$allowUncategorizedCookiesInOverridesGlobalState;
let $d8e2f6a273855d4e$var$hasInitialized = false;
let $d8e2f6a273855d4e$var$cookiesCacheLoader;
let $d8e2f6a273855d4e$var$localStorageCacheLoader;
let $d8e2f6a273855d4e$var$sessionStorageCacheLoader;
let $d8e2f6a273855d4e$var$loadCache = async (storageType)=>{
    switch(storageType){
        case (0, $8FFpF.CategoryStorageType).Cookies:
            return await $d8e2f6a273855d4e$var$cookiesCacheLoader?.loadStorageControlsData();
        case (0, $8FFpF.CategoryStorageType).LocalStorage:
            return await $d8e2f6a273855d4e$var$localStorageCacheLoader?.loadStorageControlsData();
        case (0, $8FFpF.CategoryStorageType).SessionStorage:
            return await $d8e2f6a273855d4e$var$sessionStorageCacheLoader?.loadStorageControlsData();
        default:
            return undefined;
    }
};
const $d8e2f6a273855d4e$export$3b78a1ea01f5ec28 = ()=>{
    return {
        analyticsEnabled: $d8e2f6a273855d4e$var$analyticsEnabledGlobalState ?? true,
        product: $d8e2f6a273855d4e$var$productGlobalState,
        perimeter: $d8e2f6a273855d4e$var$perimeterGlobalState,
        webStorageEnabled: $d8e2f6a273855d4e$var$webStorageControlsEnabledGlobalState ?? false,
        localConsentMode: $d8e2f6a273855d4e$var$localConsentModeGlobalState ?? false,
        packageDebugMode: $d8e2f6a273855d4e$var$packageDebugModeEnabledGlobalState,
        allowUncategorizedCookiesInOverrides: $d8e2f6a273855d4e$var$allowUncategorizedCookiesInOverridesGlobalState ?? false,
        cookiesCacheLoader: $d8e2f6a273855d4e$var$cookiesCacheLoader,
        localStorageCacheLoader: $d8e2f6a273855d4e$var$localStorageCacheLoader,
        sessionStorageCacheLoader: $d8e2f6a273855d4e$var$sessionStorageCacheLoader,
        loadCache: $d8e2f6a273855d4e$var$loadCache,
        hasInitialized: $d8e2f6a273855d4e$var$hasInitialized
    };
};
const $d8e2f6a273855d4e$export$882c4530c58781d8 = ({ webStorageEnabled: webStorageEnabled, allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, localConsentMode: localConsentMode = false, product: product = 'all', perimeter: perimeter = 'commercial', analyticsEnabled: analyticsEnabled = true } = {})=>{
    (0, $Dyz2r.Logger).debug('Initialize global state invoked');
    // If the app provides a value for product only in one place,
    // we want that value to be sticky and to override the default if necessary
    if ((!$d8e2f6a273855d4e$var$productGlobalState || $d8e2f6a273855d4e$var$productGlobalState == null || $d8e2f6a273855d4e$var$productGlobalState === 'all') && product) $d8e2f6a273855d4e$var$productGlobalState = product;
    // Treating webStorageEnabled and allowUncategorizedCookiesInOverrides differently
    // because they are only passed through initializeControls and
    // we don't want it to be defaulted to false via a call from the ConsentBanner
    if (webStorageEnabled !== undefined && $d8e2f6a273855d4e$var$webStorageControlsEnabledGlobalState === undefined) $d8e2f6a273855d4e$var$webStorageControlsEnabledGlobalState = webStorageEnabled && !(0, $VSDnB.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $VSDnB.fg)('platform_moonjelly_bsc_web_storage_killswitch');
    if (allowUncategorizedCookiesInOverrides !== undefined && $d8e2f6a273855d4e$var$allowUncategorizedCookiesInOverridesGlobalState === undefined) $d8e2f6a273855d4e$var$allowUncategorizedCookiesInOverridesGlobalState = allowUncategorizedCookiesInOverrides;
    // All other state can only be initialized once and is defaulted if not passed on the first initialization
    if ($d8e2f6a273855d4e$var$hasInitialized) return;
    if (!(0, $VSDnB.fg)('fedramp-cookies-controls')) $d8e2f6a273855d4e$var$localConsentModeGlobalState = localConsentMode;
    else // Force local consent mode when in the FedRAMP Moderate perimeter because ConsentHub is
    // not hydrated in the perimeter as of this comment
    $d8e2f6a273855d4e$var$localConsentModeGlobalState = localConsentMode || perimeter === 'fedramp-moderate';
    $d8e2f6a273855d4e$var$analyticsEnabledGlobalState = analyticsEnabled;
    $d8e2f6a273855d4e$var$perimeterGlobalState = perimeter;
    $d8e2f6a273855d4e$var$cookiesCacheLoader = new (0, $ijunp.CacheLoader)((0, $8FFpF.CategoryStorageType).Cookies, perimeter);
    $d8e2f6a273855d4e$var$localStorageCacheLoader = new (0, $ijunp.CacheLoader)((0, $8FFpF.CategoryStorageType).LocalStorage, perimeter);
    $d8e2f6a273855d4e$var$sessionStorageCacheLoader = new (0, $ijunp.CacheLoader)((0, $8FFpF.CategoryStorageType).SessionStorage, perimeter);
    if ((0, $VSDnB.fg)('platform_moonjelly_bsc_debug_mode')) $d8e2f6a273855d4e$var$packageDebugModeEnabledGlobalState = Boolean((0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get('atl-bsc-debug-mode'));
    $d8e2f6a273855d4e$var$hasInitialized = true;
};
const $d8e2f6a273855d4e$export$f86e17381f699baf = ({ loadCache: overrideLoadCache, product: overrideProduct })=>{
    if (overrideLoadCache) $d8e2f6a273855d4e$var$loadCache = overrideLoadCache;
    if (overrideProduct) $d8e2f6a273855d4e$var$productGlobalState = overrideProduct;
};
const $d8e2f6a273855d4e$export$ac7c2edd09656c05 = ()=>{
    $d8e2f6a273855d4e$var$analyticsEnabledGlobalState = undefined;
    $d8e2f6a273855d4e$var$productGlobalState = undefined;
    $d8e2f6a273855d4e$var$webStorageControlsEnabledGlobalState = undefined;
    $d8e2f6a273855d4e$var$localConsentModeGlobalState = undefined;
    $d8e2f6a273855d4e$var$packageDebugModeEnabledGlobalState = undefined;
    $d8e2f6a273855d4e$var$allowUncategorizedCookiesInOverridesGlobalState = undefined;
    $d8e2f6a273855d4e$var$cookiesCacheLoader = undefined;
    $d8e2f6a273855d4e$var$localStorageCacheLoader = undefined;
    $d8e2f6a273855d4e$var$sessionStorageCacheLoader = undefined;
    $d8e2f6a273855d4e$var$hasInitialized = false;
};

});
parcelRegister("8FFpF", function(module, exports) {

$parcel$export(module.exports, "PreferenceCategory", () => $36d7d553dbfdd9f7$export$ba064dbfe4bb66d7);
$parcel$export(module.exports, "ConsentPreferenceV2", () => $36d7d553dbfdd9f7$export$cdef20bac194f235);
$parcel$export(module.exports, "ContextualConsentProperty", () => $36d7d553dbfdd9f7$export$fac80ad19b60e313);
$parcel$export(module.exports, "PrefetchedPreferenceState", () => $36d7d553dbfdd9f7$export$5d6594a0bba4ab8a);
$parcel$export(module.exports, "CategoryStorageType", () => $36d7d553dbfdd9f7$export$2506b012eb637f61);
$parcel$export(module.exports, "Status", () => $36d7d553dbfdd9f7$export$96e9906d6d93a972);
var $36d7d553dbfdd9f7$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var $36d7d553dbfdd9f7$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var $36d7d553dbfdd9f7$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var $36d7d553dbfdd9f7$export$4fda8eb914d6791c = /*#__PURE__*/ function(CachedKeysDataPropertyLegacy) {
    CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
    CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataPropertyLegacy["Cookies"] = "keys";
    CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataPropertyLegacy;
}({});
var $36d7d553dbfdd9f7$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
var $36d7d553dbfdd9f7$export$2506b012eb637f61 = /*#__PURE__*/ function(CategoryStorageType) {
    CategoryStorageType["Cookies"] = "Cookies";
    CategoryStorageType["LocalStorage"] = "LocalStorage";
    CategoryStorageType["SessionStorage"] = "SessionStorage";
    return CategoryStorageType;
}({});
var $36d7d553dbfdd9f7$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    return Status;
}({});
var $36d7d553dbfdd9f7$export$eefdbcf75990494a = /*#__PURE__*/ function(BSC_PACKAGE_KILLSWITCHES) {
    BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
    BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
    BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    BSC_PACKAGE_KILLSWITCHES["WEB_STORAGE_KILLSWITCH"] = "platform_moonjelly_bsc_web_storage_killswitch";
    return BSC_PACKAGE_KILLSWITCHES;
}({});

});

parcelRegister("ijunp", function(module, exports) {

$parcel$export(module.exports, "CacheLoader", () => $8f6d0a2fa14daa2d$export$e479342c697b82a9);

var $VSDnB = parcelRequire("VSDnB");

var $8FFpF = parcelRequire("8FFpF");

var $Dyz2r = parcelRequire("Dyz2r");

var $jWdBs = parcelRequire("jWdBs");
class $8f6d0a2fa14daa2d$export$e479342c697b82a9 {
    constructor(storageType, perimeter = 'commercial'){
        if (!(0, $VSDnB.fg)('fedramp-cookies-controls')) switch(storageType){
            case (0, $8FFpF.CategoryStorageType).Cookies:
                this.cacheUrl = (0, $jWdBs.COOKIE_CACHE_URL_COMMERCIAL_PROD);
                break;
            case (0, $8FFpF.CategoryStorageType).LocalStorage:
                this.cacheUrl = (0, $jWdBs.LOCAL_STORAGE_CACHE_URL_COMMERCIAL_PROD);
                break;
            case (0, $8FFpF.CategoryStorageType).SessionStorage:
                this.cacheUrl = (0, $jWdBs.SESSION_STORAGE_CACHE_URL_COMMERCIAL_PROD);
                break;
            default:
                this.cacheUrl = (0, $jWdBs.LEGACY_COOKIE_CACHE_URL_PROD);
        }
        else {
            // If a new perimeter type is added, but not supported by us yet, default to commercial URLs
            const cacheUrlLookup = (0, $jWdBs.CATEGORY_CACHE_URL_PERIMETER_LOOKUP)[perimeter] || (0, $jWdBs.COMMERCIAL_CATEGORY_CACHE_URL_LOOKUP);
            this.cacheUrl = cacheUrlLookup[storageType];
        }
    }
    clearStorageControlsDataCache() {
        this.localResponseCache = undefined;
        this.localResponsePromiseCache = undefined;
        this.localResponseJsonPromiseCache = undefined;
    }
    /**
	 * Unpacks the response promise from the categories CDN
	 *
	 * errors if that request was unsuccessful, returns the categories data otherwise
	 *
	 */ async handleCategoriesResponse(responsePromise) {
        if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
        const response = await responsePromise;
        if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
        // Checks if we've already fired the response.json() promise
        this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || response?.json();
        return this.localResponseJsonPromiseCache;
    }
    async loadStorageControlsData() {
        if (this.localResponseCache) return this.localResponseCache;
        else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
        try {
            if (!this.localResponsePromiseCache) {
                (0, $Dyz2r.Logger).debug(`Loading cache ${this.cacheUrl}`);
                // invoke CDN and cache the promise
                this.localResponsePromiseCache = fetch(this.cacheUrl);
            }
            // unpack response
            this.localResponseCache = await this.handleCategoriesResponse(this.localResponsePromiseCache);
            return this.localResponseCache;
        } catch (e) {
            (0, $Dyz2r.Logger).errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: e.message || ''
            });
            this.clearStorageControlsDataCache();
        }
    }
}

});
parcelRegister("Dyz2r", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $11d6f9521ae04599$export$efa9a398d6368992);
/* eslint-disable no-console */ 
var $VSDnB = parcelRequire("VSDnB");

var $3MsQ9 = parcelRequire("3MsQ9");

var $gMWuT = parcelRequire("gMWuT");
const $11d6f9521ae04599$var$LOG_PREFIX = '[browser-storage-controls]';
class $11d6f9521ae04599$export$efa9a398d6368992 {
    static info(message, metadata) {
        console.log(`${$11d6f9521ae04599$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static error(message, metadata) {
        console.error(`${$11d6f9521ae04599$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            (0, $3MsQ9.sendPackageOperationalEvent)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata ? JSON.stringify(metadata) : '');
    }
    static warn(message, metadata) {
        console.warn(`${$11d6f9521ae04599$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    /**
	 * Logger for additional debugging of the package. Debug logs are only sent when the
	 * atl-bsc-debug-mode cookie is set on the browser. This is evaluated via global state
	 */ static debug(message, metadata) {
        if ((0, $gMWuT.getBscGlobalState)().packageDebugMode && (0, $VSDnB.fg)('platform_moonjelly_bsc_debug_mode')) console.debug(`${$11d6f9521ae04599$var$LOG_PREFIX}: DEBUG ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
}

});
parcelRegister("3MsQ9", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsClient", () => $ab4acd6241b053c1$export$fde53e78fd93a54d);
$parcel$export(module.exports, "sendPackageOperationalEvent", () => $ab4acd6241b053c1$export$5bfe55348e7aebc1);
$parcel$export(module.exports, "sendUIEvent", () => $ab4acd6241b053c1$export$1aecf263098db667);
$parcel$export(module.exports, "sendScreenEvent", () => $ab4acd6241b053c1$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendTrackEvent", () => $ab4acd6241b053c1$export$1ba525b8a711eaac);

var $buAWB = parcelRequire("buAWB");
var $iZhen = parcelRequire("iZhen");

var $gMWuT = parcelRequire("gMWuT");

var $Dyz2r = parcelRequire("Dyz2r");

var $dNWuc = parcelRequire("dNWuc");

var $cSola = parcelRequire("cSola");
const $ab4acd6241b053c1$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.')) return (0, $iZhen.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $iZhen.envType).DEV;
    return (0, $iZhen.envType).PROD;
};
const $ab4acd6241b053c1$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $ab4acd6241b053c1$var$getProductFromDomain = (domain)=>{
    if (domain === 'https://trello.com') return 'trello';
    return null;
};
const $ab4acd6241b053c1$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $ab4acd6241b053c1$export$78d7c0236b4fece9(pathname);
    const domain = `${origin}${productPath}`;
    const product = $ab4acd6241b053c1$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
const $ab4acd6241b053c1$var$decorateEventAttributes = (attributes)=>{
    const { domain: domain, product: product } = $ab4acd6241b053c1$export$fce3dd735e04d566();
    return {
        packageName: $dNWuc.packageName,
        packageVersion: $dNWuc.packageVersion,
        domain: domain,
        product: (0, $gMWuT.getBscGlobalState)().product?.toLowerCase() ?? product,
        ...attributes && attributes
    };
};
const $ab4acd6241b053c1$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $gMWuT.getBscGlobalState)().analyticsEnabled) instance = new (0, $buAWB.default)({
                env: $ab4acd6241b053c1$var$getEnvironment(),
                product: 'atlassianCookies'
            }, {
                // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                // When set to false, the client will use a stargate proxy for the current URL to send events
                // to GAS. Said another way:
                // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                // false => events are sent to <the current domain>/gasv3/api/v1/batch
                //
                // By default, this should be set to false.  If you need to validate that analytics events
                // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                // won't be able to proxy to GAS via stargate.
                useLegacyUrl: false,
                disableCookiePersistence: true
            });
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            (0, $Dyz2r.Logger).error(`Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $gMWuT.getBscGlobalState)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $ab4acd6241b053c1$export$5bfe55348e7aebc1(properties) {
    (0, $cSola.withAnalyticsEventSampling)(properties.action, ()=>$ab4acd6241b053c1$export$fde53e78fd93a54d()?.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $ab4acd6241b053c1$var$decorateEventAttributes(properties.attributes)
        }));
}
function $ab4acd6241b053c1$export$1aecf263098db667(properties) {
    $ab4acd6241b053c1$export$fde53e78fd93a54d()?.sendUIEvent({
        ...properties,
        attributes: $ab4acd6241b053c1$var$decorateEventAttributes(properties.attributes)
    });
}
function $ab4acd6241b053c1$export$22a3b1671f38a193(properties) {
    $ab4acd6241b053c1$export$fde53e78fd93a54d()?.sendScreenEvent({
        ...properties,
        attributes: $ab4acd6241b053c1$var$decorateEventAttributes(properties.attributes)
    });
}
function $ab4acd6241b053c1$export$1ba525b8a711eaac(properties) {
    $ab4acd6241b053c1$export$fde53e78fd93a54d()?.sendTrackEvent({
        ...properties,
        attributes: $ab4acd6241b053c1$var$decorateEventAttributes(properties.attributes)
    });
}

});
parcelRegister("dNWuc", function(module, exports) {

$parcel$export(module.exports, "packageName", () => $c97fd3879a87db8b$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $c97fd3879a87db8b$export$91546b032799aa40);

var $6cAn5 = parcelRequire("6cAn5");
const $c97fd3879a87db8b$export$9345d7360ffe0722 = $6cAn5?.env._PACKAGE_NAME_ ?? '';
const $c97fd3879a87db8b$export$91546b032799aa40 = $6cAn5?.env._PACKAGE_VERSION_ ?? '';

});

parcelRegister("cSola", function(module, exports) {

$parcel$export(module.exports, "withAnalyticsEventSampling", () => $8a7d44aac8b41a46$export$67b6e87f323cb6ad);

var $8FFpF = parcelRequire("8FFpF");

var $gMWuT = parcelRequire("gMWuT");

var $lYuNP = parcelRequire("lYuNP");

var $ljmYJ = parcelRequire("ljmYJ");
const $8a7d44aac8b41a46$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1,
    usedAtlBrowserStorageGetItem: 100,
    usedAtlBrowserStorageGetItemError: 1,
    usedAtlBrowserStorageSetItem: 100,
    usedAtlBrowserStorageSetItemError: 1,
    usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
    usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
    usedCheckIfSetByPackageError: 1,
    renderConsentBannerError: 1,
    bannerAppearanceAfterDismissal: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $8a7d44aac8b41a46$var$localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function $8a7d44aac8b41a46$var$loadSamplingConfig() {
    if ((0, $lYuNP.cache).cachedSamplingConfig) return (0, $lYuNP.cache).cachedSamplingConfig;
    if ((0, $ljmYJ.isSSR)()) return undefined;
    const { loadCache: loadCache } = (0, $gMWuT.getBscGlobalState)();
    const controlsData = await loadCache((0, $8FFpF.CategoryStorageType).Cookies);
    const analyticsSamplingRatioConfigs = controlsData?.analyticsSamplingRatio;
    (0, $lYuNP.cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $8a7d44aac8b41a46$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($8a7d44aac8b41a46$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $8a7d44aac8b41a46$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $8a7d44aac8b41a46$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig ?? $8a7d44aac8b41a46$export$1138592b3c099377;
    const samplingRatio = samplingConfig?.[analyticsEventKey] !== undefined ? samplingConfig[analyticsEventKey] : $8a7d44aac8b41a46$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $8a7d44aac8b41a46$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
       ________
      /\       \
     /()\   ()  \
    /    \_______\
    \    /()     /
     \()/   ()  /
      \/_____()/
  */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $8a7d44aac8b41a46$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $8a7d44aac8b41a46$export$b286f5e8716d11ad(analyticsEventKey);
    $8a7d44aac8b41a46$export$dc2f0946255b3f89(ratio, cb);
}

});
parcelRegister("lYuNP", function(module, exports) {

$parcel$export(module.exports, "cache", () => $8cd0e183ff7dc01a$export$69a3209f1a06c04d);

var $3HP97 = parcelRequire("3HP97");
const $8cd0e183ff7dc01a$export$69a3209f1a06c04d = new (0, $3HP97.CachedSamplingConfig)();

});
parcelRegister("3HP97", function(module, exports) {

$parcel$export(module.exports, "CachedSamplingConfig", () => $44a8c306b7f02367$export$b886edaf6623554a);
class $44a8c306b7f02367$export$b886edaf6623554a {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
}

});


parcelRegister("ljmYJ", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $5603064d730f5120$export$48d7c418edadb60c);

var $buAWB = parcelRequire("buAWB");

var $VSDnB = parcelRequire("VSDnB");

var $Dyz2r = parcelRequire("Dyz2r");
const $5603064d730f5120$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $VSDnB.fg);
    const isMissingAnalyticsWebClient = !Boolean((0, $buAWB.default));
    // When rendering from the server document/window may not be available
    if (isMissingNecessaryBrowserUtils) (0, $Dyz2r.Logger).warn('Browser context is not available.');
    if (isMissingBooleanFF) (0, $Dyz2r.Logger).warn('Platform Feature Flag library is not available');
    if (!(0, $buAWB.default)) (0, $Dyz2r.Logger).warn('analytics-web-client is not available');
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};

});




parcelRegister("jWdBs", function(module, exports) {

$parcel$export(module.exports, "LEGACY_COOKIE_CACHE_URL_PROD", () => $84558f51b42056b1$export$194c34963e6f0bc6);
$parcel$export(module.exports, "COOKIE_CACHE_URL_COMMERCIAL_PROD", () => $84558f51b42056b1$export$b44048c6704cb5cb);
$parcel$export(module.exports, "LOCAL_STORAGE_CACHE_URL_COMMERCIAL_PROD", () => $84558f51b42056b1$export$c55beaf8e17d7be2);
$parcel$export(module.exports, "SESSION_STORAGE_CACHE_URL_COMMERCIAL_PROD", () => $84558f51b42056b1$export$e1db91db5e7e324f);
$parcel$export(module.exports, "COMMERCIAL_CATEGORY_CACHE_URL_LOOKUP", () => $84558f51b42056b1$export$218c59d0d43946aa);
$parcel$export(module.exports, "CATEGORY_CACHE_URL_PERIMETER_LOOKUP", () => $84558f51b42056b1$export$df45fb0af5b720ce);

var $8FFpF = parcelRequire("8FFpF");
const $84558f51b42056b1$export$194c34963e6f0bc6 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories.json';
const $84558f51b42056b1$export$b44048c6704cb5cb = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_COOKIE.json';
const $84558f51b42056b1$export$c55beaf8e17d7be2 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_LOCAL_STORAGE.json';
const $84558f51b42056b1$export$e1db91db5e7e324f = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_SESSION_STORAGE.json';
const $84558f51b42056b1$export$abf8d23e319d4d71 = 'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/categories_COOKIE.json';
const $84558f51b42056b1$export$de367b95fcc6730f = 'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/categories_LOCAL_STORAGE.json';
const $84558f51b42056b1$export$d5e6ad74bf291eaf = 'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/categories_SESSION_STORAGE.json';
const $84558f51b42056b1$export$218c59d0d43946aa = {
    [(0, $8FFpF.CategoryStorageType).Cookies]: $84558f51b42056b1$export$b44048c6704cb5cb,
    [(0, $8FFpF.CategoryStorageType).LocalStorage]: $84558f51b42056b1$export$c55beaf8e17d7be2,
    [(0, $8FFpF.CategoryStorageType).SessionStorage]: $84558f51b42056b1$export$e1db91db5e7e324f
};
const $84558f51b42056b1$export$df45fb0af5b720ce = {
    commercial: $84558f51b42056b1$export$218c59d0d43946aa,
    'fedramp-moderate': {
        [(0, $8FFpF.CategoryStorageType).Cookies]: $84558f51b42056b1$export$abf8d23e319d4d71,
        [(0, $8FFpF.CategoryStorageType).LocalStorage]: $84558f51b42056b1$export$de367b95fcc6730f,
        [(0, $8FFpF.CategoryStorageType).SessionStorage]: $84558f51b42056b1$export$d5e6ad74bf291eaf
    }
};

});



parcelRegister("3uyrZ", function(module, exports) {

$parcel$export(module.exports, "BSCIndexedDB", () => $dcdcaa8b6a3e20dd$export$36328b3bcbe4623a);

var $ljmYJ = parcelRequire("ljmYJ");

var $Dyz2r = parcelRequire("Dyz2r");
class $dcdcaa8b6a3e20dd$export$fde2a4e0e57f47e {
    constructor(dbName, storeName){
        this.db = null;
        this.isBooted = false;
        this.isAvailable = false;
        this.onConnectionErrorHandler = (reject)=>(event)=>{
                (0, $Dyz2r.Logger).warn('Error opening database.');
                reject(event);
            };
        this.onConnectionSuccessHandler = (connection, resolve)=>()=>{
                this.db = connection.result;
                resolve();
            };
        this.onConnectionUpgradeNeededHandler = (request)=>()=>{
                this.db = request.result;
                this.db.createObjectStore(this.storeName, {
                    keyPath: 'id'
                });
            };
        this.onGetRecordErrorHandler = (reject)=>()=>{
                const getErrorMessage = `Failed to perform a get transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $Dyz2r.Logger).warn(getErrorMessage);
                reject(getErrorMessage);
            };
        this.onGetRecordSuccessHandler = (getRequest, resolve)=>()=>{
                resolve(getRequest.result);
            };
        this.onSetRecordErrorHandler = (reject)=>()=>{
                const errorMessage = `Failed to perform a set transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $Dyz2r.Logger).warn(errorMessage);
                reject(errorMessage);
            };
        this.onSetRecordSuccessHandler = (resolve)=>()=>{
                resolve();
            };
        this.dbName = dbName;
        this.storeName = storeName;
        this.isAvailable = this.getIsDBAvailable();
        this.isBooted = false;
        this.bootUpPromiseCache = null;
    }
    async boot() {
        if (!this.isAvailable) {
            (0, $Dyz2r.Logger).warn('IndexedDB is not available');
            return;
        }
        if (this.isBooted) // Short circuit if we've already booted once
        return;
        // Only boot once, even if we've been called numerous times sequentially
        if (!this.bootUpPromiseCache) {
            this.bootUpPromiseCache = this.openDB();
            try {
                await this.bootUpPromiseCache;
                this.isBooted = true;
            } catch (e) {
                this.isBooted = false;
                (0, $Dyz2r.Logger).warn('Error booting up IndexedDB.');
                throw e;
            }
        }
    }
    getIsDBAvailable() {
        return !(0, $ljmYJ.isSSR)() && !!window.indexedDB;
    }
    async openDB() {
        return new Promise((resolve, reject)=>{
            let request = indexedDB.open(this.dbName, 2);
            request.onerror = this.onConnectionErrorHandler(reject);
            request.onsuccess = this.onConnectionSuccessHandler(request, resolve);
            request.onupgradeneeded = this.onConnectionUpgradeNeededHandler(request);
        });
    }
    async getRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) throw new Error('Database is not opened');
            let fetchTransaction = this.db.transaction([
                this.storeName
            ]);
            let recordStore = fetchTransaction.objectStore(this.storeName);
            const fetchedRecord = new Promise((resolve, reject)=>{
                let request = recordStore.get(recordKey);
                request.onerror = this.onGetRecordErrorHandler(reject);
                request.onsuccess = this.onGetRecordSuccessHandler(request, resolve);
            });
            return fetchedRecord;
        } catch (e) {
            (0, $Dyz2r.Logger).error(`Error fetching record from database. ${e.message || ''}`);
            throw e;
        }
    }
    async setRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) throw new Error('Database is not opened');
            const setRecord = new Promise((resolve, reject)=>{
                let setTransaction = this.db.transaction([
                    this.storeName
                ], 'readwrite');
                let objectStore = setTransaction.objectStore(this.storeName);
                const newAtlRecord = {
                    atlSetItem: 'SET-BY-PACKAGE',
                    id: recordKey
                };
                let request = objectStore.put(newAtlRecord);
                request.onerror = this.onSetRecordErrorHandler(reject);
                request.onsuccess = this.onSetRecordSuccessHandler(resolve);
            });
            return setRecord;
        } catch (e) {
            (0, $Dyz2r.Logger).warn(`Error setting record in database. ${e.message || ''}`);
            throw e;
        }
    }
}
const $dcdcaa8b6a3e20dd$export$36328b3bcbe4623a = new $dcdcaa8b6a3e20dd$export$fde2a4e0e57f47e('BSCIndexedDB', 'InternalStorageKeys');

});

parcelRegister("3iwZ5", function(module, exports) {

$parcel$export(module.exports, "WebStorageType", () => $18b68d89ab611c47$export$259e3a861f28589b);
var $18b68d89ab611c47$export$259e3a861f28589b = /*#__PURE__*/ function(WebStorageType) {
    WebStorageType["LocalStorage"] = "LocalStorage";
    WebStorageType["SessionStorage"] = "SessionStorage";
    return WebStorageType;
}({});

});

parcelRegister("3KKvX", function(module, exports) {

$parcel$export(module.exports, "getStorageItem", () => $623537d2033163f5$export$e612bb1301d659de);

var $3MsQ9 = parcelRequire("3MsQ9");

var $Dyz2r = parcelRequire("Dyz2r");
const $623537d2033163f5$export$e612bb1301d659de = (itemKey, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $3MsQ9.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageGetItem',
            attributes: eventAttributes
        });
        return browserStorage.getItem(itemKey);
    } catch (e) {
        (0, $Dyz2r.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageGetItemError',
            attributes: eventAttributes,
            message: `Failed to get ${storageType} item. ${e.message || ''}`
        });
        return null;
    }
};

});

parcelRegister("3jvQx", function(module, exports) {

$parcel$export(module.exports, "setStorageItem", () => $772d1d6fa1013d33$export$5ee8760f703d9d62);

var $3MsQ9 = parcelRequire("3MsQ9");

var $giZBC = parcelRequire("giZBC");

var $Dyz2r = parcelRequire("Dyz2r");

var $3uyrZ = parcelRequire("3uyrZ");

var $8FFpF = parcelRequire("8FFpF");

var $3iwZ5 = parcelRequire("3iwZ5");
const $772d1d6fa1013d33$export$5ee8760f703d9d62 = async (itemKey, value, storageType, productName, browserStorage)=>{
    // user belongs to an org that opted into cookies management and we should respect their preferences
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    const shouldSetItem = await (0, $giZBC.isProcessingAllowedByPreferences)({
        itemKey: itemKey,
        storageType: storageType === (0, $3iwZ5.WebStorageType).LocalStorage ? (0, $8FFpF.CategoryStorageType).LocalStorage : (0, $8FFpF.CategoryStorageType).SessionStorage,
        productName: productName
    });
    const eventAttributes = {
        wasRejected: !shouldSetItem,
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $3MsQ9.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetItem',
            attributes: eventAttributes
        });
        if (shouldSetItem) {
            // Store the item as a record in our IDB service to track that we've seen it before.
            // That way, when we can confirm/deny that this has been set by our service when we check again.
            // If it fails for some reason, it will be caught before actually setting the item
            await (0, $3uyrZ.BSCIndexedDB).setRecord(itemKey);
            browserStorage.setItem(itemKey, value);
            return (0, $8FFpF.Status).SUCCESS;
        } else return (0, $8FFpF.Status).BLOCKED;
    } catch (e) {
        (0, $Dyz2r.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetItemError',
            attributes: eventAttributes,
            message: `Failed to set ${storageType} item. ${e.message || ''}`
        });
        return (0, $8FFpF.Status).BLOCKED;
    }
};

});
parcelRegister("giZBC", function(module, exports) {

$parcel$export(module.exports, "isProcessingAllowedByPreferences", () => $c95606615c03285c$export$e7a3dca206fec6e2);
// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths

var $waH4c = parcelRequire("waH4c");

var $8FFpF = parcelRequire("8FFpF");

var $gMWuT = parcelRequire("gMWuT");
const $c95606615c03285c$export$2c141b1c00f3e482 = (itemKey, startsWith)=>{
    // Setup initial pattern step and position
    let currentStep = startsWith;
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        // The value of item character at the position
        const currentStepValue = currentStep[itemKey[position]];
        // If there is no match for item symbol in cache, this means there is no
        // pattern match for the item key
        if (currentStepValue === undefined) return null;
        // If current step value is a number, this means we reached the end of the pattern
        // and should return category number
        if (typeof currentStepValue === 'number') return currentStepValue;
        // Continue to going through pattern
        currentStep = currentStepValue;
        position++;
    }
    // No pattern match - all patterns longer or shorter than item key
    return null;
};
const $c95606615c03285c$export$c4a1dd71bbd8954c = (itemKey, endsWith)=>{
    // Return category number if str is found in the trie, otherwise return undefined
    const trieSearch = (str)=>{
        let currentStep = endsWith;
        let foundString = '';
        let terminalNumber;
        for(let i = 0; i < str.length; i++){
            const char = str[i];
            currentStep = currentStep[char];
            if (currentStep === undefined) break;
            foundString += char;
            if (typeof currentStep === 'number') {
                terminalNumber = currentStep;
                break;
            }
        }
        if (foundString === str) // Trie contained the complete string
        return terminalNumber;
        else // Trie did not contain the complete string
        return undefined;
    };
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        const remainderMatch = trieSearch(itemKey.slice(position));
        if (remainderMatch !== undefined) return remainderMatch;
        position++;
    }
    return null;
};
const $c95606615c03285c$export$69d5b68d01f4a366 = (itemKey, storageControlsData, productName)=>{
    const downcasedProduct = productName?.toLowerCase();
    let itemCategoryNumber = null;
    const { categories: categories, patterns: patterns } = storageControlsData;
    let productKeys = {
        ...storageControlsData['keys']['all'],
        ...downcasedProduct ? storageControlsData['keys'][downcasedProduct] : {}
    };
    const productStartsWithPatterns = {
        ...patterns.startsWith['all'],
        ...downcasedProduct ? patterns.startsWith[downcasedProduct] : {}
    };
    const productEndsWithPatterns = {
        ...patterns.endsWith['all'],
        ...downcasedProduct ? patterns.endsWith[downcasedProduct] : {}
    };
    // Find direct match in keys
    if (Object.keys(productKeys).includes(itemKey)) itemCategoryNumber = productKeys[itemKey];
    else {
        // Find pattern match or null
        itemCategoryNumber = $c95606615c03285c$export$2c141b1c00f3e482(itemKey, productStartsWithPatterns);
        if (itemCategoryNumber === null) itemCategoryNumber = $c95606615c03285c$export$c4a1dd71bbd8954c(itemKey, productEndsWithPatterns);
    }
    const numToCategoryMap = {
        [categories.STRICTLY_NECESSARY]: (0, $8FFpF.PreferenceCategory).StrictlyNecessary,
        [categories.FUNCTIONAL]: (0, $8FFpF.PreferenceCategory).Functional,
        [categories.ANALYTICS]: (0, $8FFpF.PreferenceCategory).Analytics,
        [categories.MARKETING]: (0, $8FFpF.PreferenceCategory).Marketing,
        [categories.UNKNOWN]: (0, $8FFpF.PreferenceCategory).Unknown
    };
    return itemCategoryNumber !== null ? numToCategoryMap[itemCategoryNumber] : null;
};
const $c95606615c03285c$export$ec8ce5237293e4a4 = async (itemKey, storageType, productName)=>{
    const storageControlsData = await (0, $gMWuT.getBscGlobalState)().loadCache(storageType);
    if (!storageControlsData) return null;
    else return $c95606615c03285c$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
};
const $c95606615c03285c$export$e7a3dca206fec6e2 = async ({ itemKey: itemKey, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, storageType: storageType, productName: productName })=>{
    let shouldProcessItem;
    const itemCategory = await $c95606615c03285c$export$ec8ce5237293e4a4(itemKey, storageType, productName);
    if (itemCategory === (0, $8FFpF.PreferenceCategory).StrictlyNecessary) shouldProcessItem = true;
    else {
        const preferences = await (0, $waH4c.getPreferences)();
        let hasPreferencesForCategory = false;
        if (!!preferences) {
            if (!!itemCategory) hasPreferencesForCategory = preferences[itemCategory];
        }
        shouldProcessItem = hasPreferencesForCategory;
    }
    if (shouldProcessItem) allowedCallback?.();
    else blockedCallback?.({
        itemHasCategory: itemCategory != null
    });
    return shouldProcessItem;
};

});
parcelRegister("waH4c", function(module, exports) {

$parcel$export(module.exports, "getPreferences", () => $8c176073ed5e2709$export$1de6a888ae076ff8);

var $gMWuT = parcelRequire("gMWuT");
var $ljmYJ = parcelRequire("ljmYJ");

var $21KEY = parcelRequire("21KEY");

var $jgJYT = parcelRequire("jgJYT");

var $4uHy1 = parcelRequire("4uHy1");

var $gHrGQ = parcelRequire("gHrGQ");
async function $8c176073ed5e2709$export$1de6a888ae076ff8() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $gMWuT.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $4uHy1.getCookie)((0, $21KEY.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $gHrGQ.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $4uHy1.getCookie)((0, $21KEY.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) {
            const consentToken = await (0, $jgJYT.getConsentToken)();
            if ((0, $ljmYJ.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $gHrGQ.unpackUserPreferencesCookie)(consentToken) : undefined;
        }
        return (0, $gHrGQ.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}

});
parcelRegister("21KEY", function(module, exports) {

$parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", () => $ef0dec1a357b404c$export$10d7db8e1a856fd8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", () => $ef0dec1a357b404c$export$435de28e5b000487);
$parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", () => $ef0dec1a357b404c$export$4b17acc0e875ba2a);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", () => $ef0dec1a357b404c$export$23a1e02c3c0b0d08);
$parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", () => $ef0dec1a357b404c$export$37073d560ecebada);
$parcel$export(module.exports, "ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY", () => $ef0dec1a357b404c$export$5dc0026db06844f3);
$parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", () => $ef0dec1a357b404c$export$b28b5d760fe14a21);
$parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", () => $ef0dec1a357b404c$export$4a12f9e99971760a);
$parcel$export(module.exports, "DEFAULT_PREFERENCES", () => $ef0dec1a357b404c$export$f0fd1d13ec1d48f2);
$parcel$export(module.exports, "V001_SCHEMA_KEY", () => $ef0dec1a357b404c$export$f95182b7aa141c57);
$parcel$export(module.exports, "V002_SCHEMA_KEY", () => $ef0dec1a357b404c$export$1f25427b34f9c405);
$parcel$export(module.exports, "V003_SCHEMA_KEY", () => $ef0dec1a357b404c$export$31deaeaebce525bb);

var $8FFpF = parcelRequire("8FFpF");
const $ef0dec1a357b404c$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $ef0dec1a357b404c$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $ef0dec1a357b404c$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $ef0dec1a357b404c$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $ef0dec1a357b404c$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $ef0dec1a357b404c$export$37073d560ecebada = 'atl-testing-consents';
const $ef0dec1a357b404c$export$5dc0026db06844f3 = 'atl-bsc-banner-dismissed-time';
const $ef0dec1a357b404c$export$b28b5d760fe14a21 = {
    [(0, $8FFpF.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $8FFpF.PreferenceCategory).Functional]: true,
    [(0, $8FFpF.PreferenceCategory).Marketing]: true,
    [(0, $8FFpF.PreferenceCategory).Analytics]: true,
    [(0, $8FFpF.PreferenceCategory).Unknown]: true
};
const $ef0dec1a357b404c$export$4a12f9e99971760a = {
    [(0, $8FFpF.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $8FFpF.PreferenceCategory).Functional]: false,
    [(0, $8FFpF.PreferenceCategory).Marketing]: false,
    [(0, $8FFpF.PreferenceCategory).Analytics]: false,
    [(0, $8FFpF.PreferenceCategory).Unknown]: false
};
const $ef0dec1a357b404c$export$f0fd1d13ec1d48f2 = {
    ...$ef0dec1a357b404c$export$4a12f9e99971760a,
    [(0, $8FFpF.ContextualConsentProperty).ConsentsAreDefault]: true,
    [(0, $8FFpF.ContextualConsentProperty).UserIsAuthenticated]: false,
    [(0, $8FFpF.ContextualConsentProperty).ConsentDataUnavailable]: true
};
const $ef0dec1a357b404c$export$f95182b7aa141c57 = '001';
const $ef0dec1a357b404c$export$1f25427b34f9c405 = '002';
const $ef0dec1a357b404c$export$31deaeaebce525bb = '003';

});

parcelRegister("jgJYT", function(module, exports) {

$parcel$export(module.exports, "getConsentToken", () => $cec0aa330286c26c$export$f1b8f2ca713fca08);

var $21KEY = parcelRequire("21KEY");

var $4uHy1 = parcelRequire("4uHy1");

var $j60lH = parcelRequire("j60lH");

var $2BKtx = parcelRequire("2BKtx");

var $9C321 = parcelRequire("9C321");
const $cec0aa330286c26c$export$f1b8f2ca713fca08 = async ()=>{
    const fallbackConsentToken = (0, $4uHy1.getCookie)((0, $21KEY.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const consentData = await (0, $9C321.getValidConsentData)(fallbackConsentToken);
    if (consentData) {
        const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenConsentToken = (0, $j60lH.overrideConsentTokenForLiveTesting)(consentToken);
        const testingConsentOverride = (0, $4uHy1.getCookie)((0, $21KEY.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, $2BKtx.setShouldShowBannerCookie)(potentiallyOverriddenConsentToken);
            (0, $2BKtx.setConsentTokenCookie)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, $2BKtx.setRequiredConsentCookies)(potentiallyOverriddenConsentToken, consentTimestamp);
        return consentToken;
    }
    return undefined;
};

});
parcelRegister("4uHy1", function(module, exports) {

$parcel$export(module.exports, "getCookie", () => $558963795707b831$export$4be65e66cfa2648a);

var $eYli8 = parcelRequire("eYli8");

var $VSDnB = parcelRequire("VSDnB");

var $3MsQ9 = parcelRequire("3MsQ9");

var $Dyz2r = parcelRequire("Dyz2r");
function $558963795707b831$export$4be65e66cfa2648a(key) {
    if ((0, $VSDnB.fg)('platform_moonjelly_bsc_master_killswitch')) // Get the cookie without package operational events
    // when master killswitch is enabled
    return key ? (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get();
    try {
        (0, $3MsQ9.sendPackageOperationalEvent)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).get();
    } catch (e) {
        (0, $Dyz2r.Logger).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}

});

parcelRegister("j60lH", function(module, exports) {

$parcel$export(module.exports, "overrideConsentTokenForLiveTesting", () => $e9046a37be8b2859$export$b5282052fc15e1ae);

var $21KEY = parcelRequire("21KEY");

var $4uHy1 = parcelRequire("4uHy1");
const $e9046a37be8b2859$export$b5282052fc15e1ae = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, $4uHy1.getCookie)((0, $21KEY.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};

});

parcelRegister("2BKtx", function(module, exports) {

$parcel$export(module.exports, "setConsentTokenCookie", () => $12571e54e3352b77$export$8e560d0760f733a2);
$parcel$export(module.exports, "setConsentTokenFallbackCookie", () => $12571e54e3352b77$export$133cd762b0f705a2);
$parcel$export(module.exports, "setShouldShowBannerCookie", () => $12571e54e3352b77$export$99ecece88c58d938);
$parcel$export(module.exports, "setRequiredConsentCookies", () => $12571e54e3352b77$export$b3365240280cb3c3);

var $fp1RH = parcelRequire("fp1RH");
var $Dyz2r = parcelRequire("Dyz2r");

var $21KEY = parcelRequire("21KEY");

var $bKAlw = parcelRequire("bKAlw");

var $7RRGT = parcelRequire("7RRGT");
const $12571e54e3352b77$export$8e560d0760f733a2 = (consentToken)=>{
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $7RRGT.setStrictlyNecessaryCookie)((0, $21KEY.ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
        expires: inTenMinutes,
        path: '/'
    });
    (0, $Dyz2r.Logger).debug(`Set Consent Token ${(0, $21KEY.ATLASSIAN_CONSENT_COOKIE_KEY)} ${consentToken}`);
};
const $12571e54e3352b77$export$133cd762b0f705a2 = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $7RRGT.setStrictlyNecessaryCookie)((0, $21KEY.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
        expires: inOneYear,
        path: '/'
    });
    (0, $Dyz2r.Logger).debug(`set fallback consent token: ${(0, $21KEY.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)} ${consentToken}`);
};
const $12571e54e3352b77$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, $bKAlw.getBannerVisibility)({
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    });
    const shouldShowBanner = (0, $fp1RH.getBitValueFromBool)(!!bannerVisibility);
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $7RRGT.setStrictlyNecessaryCookie)((0, $21KEY.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
        expires: inTenMinutes,
        path: '/'
    });
    (0, $Dyz2r.Logger).debug(`set shouldShowBannerCookie: ${(0, $21KEY.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)} ${shouldShowBanner}`);
};
const $12571e54e3352b77$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
    $12571e54e3352b77$export$8e560d0760f733a2(consentToken);
    $12571e54e3352b77$export$99ecece88c58d938(consentToken, consentTimestamps);
};

});
parcelRegister("fp1RH", function(module, exports) {

$parcel$export(module.exports, "getBitValueFromBool", () => $ef15319bdc068a40$export$929f1500428a1fc8);
$parcel$export(module.exports, "getBoolFromBitValue", () => $ef15319bdc068a40$export$27647458f3cf29d2);
const $ef15319bdc068a40$export$929f1500428a1fc8 = (value)=>{
    return Number(value).toString();
};
const $ef15319bdc068a40$export$27647458f3cf29d2 = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};

});

parcelRegister("bKAlw", function(module, exports) {

$parcel$export(module.exports, "getBannerVisibility", () => $1263eb185d4160b0$export$bfdb9f82a9194c1e);

var $ljmYJ = parcelRequire("ljmYJ");

var $fp1RH = parcelRequire("fp1RH");

var $21KEY = parcelRequire("21KEY");

var $bF6aU = parcelRequire("bF6aU");

var $4uHy1 = parcelRequire("4uHy1");

var $gHrGQ = parcelRequire("gHrGQ");
const $1263eb185d4160b0$var$getUserIsAuthenticatedBit = (consentToken)=>{
    const { isV002: isV002 } = (0, $gHrGQ.checkTokenVersionValidity)(consentToken);
    let userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        const legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
    }
    return userIsAuthenticatedBit;
};
const $1263eb185d4160b0$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $1263eb185d4160b0$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $fp1RH.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $bF6aU.checkIfTokenIsDefault)(fallbackConsentToken);
        const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
const $1263eb185d4160b0$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
    const tokenIsADefaultConsent = !!(0, $bF6aU.checkIfTokenIsDefault)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return $1263eb185d4160b0$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    const localOnlyUserHasConsented = (0, $bF6aU.hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
const $1263eb185d4160b0$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $1263eb185d4160b0$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $fp1RH.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $bF6aU.checkIfTokenIsDefault)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
        They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
        then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)

        UX Problem:
        Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
        But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
        is infrequent (either via Account Privacy Page or once this fallback expires in a year).

        Example:
        While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
        fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
        because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...

        We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
        to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
        persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.

        Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
        consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year

        Result: Show the banner again and hope we officially recapture consents this time around
      */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
const $1263eb185d4160b0$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
    // Handle default token flow
    const tokenIsADefaultConsent = !!(0, $bF6aU.checkIfTokenIsDefault)(consentToken);
    if (tokenIsADefaultConsent) return $1263eb185d4160b0$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        const showBannerIfStale = (0, $bF6aU.checkIfConsentsAreStale)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
const $1263eb185d4160b0$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents })=>{
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    const fallbackConsentToken = (0, $ljmYJ.isSSR)() ? fallbackConsents // When coming from SSR, we don't want to invoke `getCookie` since it will error
     : fallbackConsents || (0, $4uHy1.getCookie)((0, $21KEY.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    let userIsAuthenticatedBit = $1263eb185d4160b0$var$getUserIsAuthenticatedBit(consentToken);
    const isLoggedOutConsentToken = !(0, $fp1RH.getBoolFromBitValue)(userIsAuthenticatedBit);
    let isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = $1263eb185d4160b0$var$shouldShowBannerForLoggedOutUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = $1263eb185d4160b0$var$shouldShowBannerForLoggedInUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken,
        consentTimestamp: consentTimestamp
    });
    return isBannerVisible;
};

});
parcelRegister("bF6aU", function(module, exports) {

$parcel$export(module.exports, "hasLegacyV2TokenConsentedPreviously", () => $abdac33f3c79bf2f$export$42b0ca8aba2631e4);
$parcel$export(module.exports, "checkIfTokenIsDefault", () => $abdac33f3c79bf2f$export$497a647f0eb30ef4);
$parcel$export(module.exports, "serializeConsents", () => $abdac33f3c79bf2f$export$92ba0b2fe50f90df);
$parcel$export(module.exports, "deserializeConsents", () => $abdac33f3c79bf2f$export$bfa0c91662787fb0);
$parcel$export(module.exports, "getConsentTimestamp", () => $abdac33f3c79bf2f$export$13e4cff933f26b03);
$parcel$export(module.exports, "checkIfConsentsAreStale", () => $abdac33f3c79bf2f$export$3387347b75450ae1);
$parcel$export(module.exports, "StatusCodeError", () => $abdac33f3c79bf2f$export$a79c0ea3d7c2444a);

var $fp1RH = parcelRequire("fp1RH");

var $21KEY = parcelRequire("21KEY");

var $4uHy1 = parcelRequire("4uHy1");

var $8FFpF = parcelRequire("8FFpF");

var $hqc2A = parcelRequire("hqc2A");
const $abdac33f3c79bf2f$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV2Schema = version === (0, $21KEY.V002_SCHEMA_KEY);
    return isV2Schema;
};
const $abdac33f3c79bf2f$var$isLegacyV1Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV1Schema = version === (0, $21KEY.V001_SCHEMA_KEY);
    return isV1Schema;
};
const $abdac33f3c79bf2f$export$42b0ca8aba2631e4 = (consentToken)=>{
    if ($abdac33f3c79bf2f$var$isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        const consentedUnderGDPR = consentToken[8] === '1';
        const consentedUnderCPRA = consentToken[9] === '1';
        const consentedUnderLGPD = consentToken[10] === '1';
        const consentedUnderFADP = consentToken[11] === '1';
        const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
const $abdac33f3c79bf2f$export$497a647f0eb30ef4 = (consentToken)=>{
    const isLegacyV1ConsentToken = $abdac33f3c79bf2f$var$isLegacyV1Token(consentToken);
    const isLegacyV2ConsentToken = $abdac33f3c79bf2f$var$isLegacyGeoTargetingV2Token(consentToken);
    if (isLegacyV1ConsentToken) // We only add a legacy `atl-gdpr-consents` cookie if a user has consented,
    // so if we see a V1 token, we know it must be a set of valid consents
    // instead of default consents
    return false;
    if (isLegacyV2ConsentToken) {
        const legacyTokenHasConsents = $abdac33f3c79bf2f$export$42b0ca8aba2631e4(consentToken);
        return !legacyTokenHasConsents;
    }
    // Check 'isDefaultConsentBit' bit for V003 Schema tokens
    const isDefaultTokenV3 = (0, $fp1RH.getBoolFromBitValue)(consentToken[7]);
    return isDefaultTokenV3;
};
const $abdac33f3c79bf2f$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
    const version = (0, $21KEY.V003_SCHEMA_KEY);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    const serializedBits = Object.entries((0, $21KEY.DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $8FFpF.PreferenceCategory).StrictlyNecessary) return acc;
        if (key === (0, $8FFpF.ContextualConsentProperty).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            const userIsAuthed = !consentsUnavailable;
            return acc + (0, $fp1RH.getBitValueFromBool)(userIsAuthed);
        }
        if (key === (0, $8FFpF.ContextualConsentProperty).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, $fp1RH.getBitValueFromBool)(!!consentsUnavailable);
        return acc + (0, $fp1RH.getBitValueFromBool)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const $abdac33f3c79bf2f$export$42a0b3fb1e53e7b9 = (consents)=>{
    const version = (0, $21KEY.V003_SCHEMA_KEY);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, $fp1RH.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $hqc2A.ConsentHubKey).Functional)?.granted);
    const analyticsConsent = (0, $fp1RH.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $hqc2A.ConsentHubKey).Analytics)?.granted);
    const marketingConsent = (0, $fp1RH.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $hqc2A.ConsentHubKey).Marketing)?.granted);
    const unknownConsent = (0, $fp1RH.getBitValueFromBool)(!!consents.find((key)=>key.key === (0, $hqc2A.ConsentHubKey).Unknown)?.granted);
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    const isDefaultToken = 0;
    const userIsAuthenticated = 1;
    const consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join('');
};
const $abdac33f3c79bf2f$export$92ba0b2fe50f90df = ({ consents: consents })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, $4uHy1.getCookie)((0, $21KEY.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return $abdac33f3c79bf2f$export$c42e1a74e60f4d73(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return $abdac33f3c79bf2f$export$c42e1a74e60f4d73(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return $abdac33f3c79bf2f$export$42a0b3fb1e53e7b9(consents); // e.g. 0030110110
};
const $abdac33f3c79bf2f$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, $8FFpF.PreferenceCategory).StrictlyNecessary,
        (0, $8FFpF.PreferenceCategory).Functional,
        (0, $8FFpF.PreferenceCategory).Analytics,
        (0, $8FFpF.PreferenceCategory).Marketing,
        (0, $8FFpF.PreferenceCategory).Unknown
    ];
    const consentKeyMap = {
        [(0, $8FFpF.PreferenceCategory).StrictlyNecessary]: (0, $hqc2A.ConsentHubKey).StrictlyNecessary,
        [(0, $8FFpF.PreferenceCategory).Functional]: (0, $hqc2A.ConsentHubKey).Functional,
        [(0, $8FFpF.PreferenceCategory).Analytics]: (0, $hqc2A.ConsentHubKey).Analytics,
        [(0, $8FFpF.PreferenceCategory).Marketing]: (0, $hqc2A.ConsentHubKey).Marketing,
        [(0, $8FFpF.PreferenceCategory).Unknown]: (0, $hqc2A.ConsentHubKey).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const $abdac33f3c79bf2f$export$13e4cff933f26b03 = ({ consents: consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const $abdac33f3c79bf2f$export$3387347b75450ae1 = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
class $abdac33f3c79bf2f$export$a79c0ea3d7c2444a extends Error {
    constructor(message, status){
        super(message);
        this.status = status;
        Object.setPrototypeOf(this, $abdac33f3c79bf2f$export$a79c0ea3d7c2444a.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $abdac33f3c79bf2f$export$a79c0ea3d7c2444a);
        this.name = 'StatusCodeError';
    }
}

});
parcelRegister("hqc2A", function(module, exports) {

$parcel$export(module.exports, "ConsentHubKey", () => $2d8cccb1496bcaa8$export$31140359b1e505cf);
var $2d8cccb1496bcaa8$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});

});


parcelRegister("gHrGQ", function(module, exports) {

$parcel$export(module.exports, "checkTokenVersionValidity", () => $f95b7e0a4ae57e4e$export$64b31470e8522819);
$parcel$export(module.exports, "packUserPreferences", () => $f95b7e0a4ae57e4e$export$3199823fec979bd1);
$parcel$export(module.exports, "unpackUserPreferencesCookie", () => $f95b7e0a4ae57e4e$export$8d213cb390bab4fa);
$parcel$export(module.exports, "initialPreferencesAreMissing", () => $f95b7e0a4ae57e4e$export$67f70eb55341bd29);
$parcel$export(module.exports, "initializePreferencesData", () => $f95b7e0a4ae57e4e$export$7962405c3ca274b1);

var $gMWuT = parcelRequire("gMWuT");

var $fp1RH = parcelRequire("fp1RH");

var $21KEY = parcelRequire("21KEY");

var $bF6aU = parcelRequire("bF6aU");

var $8FFpF = parcelRequire("8FFpF");
const $f95b7e0a4ae57e4e$export$64b31470e8522819 = (consentToken)=>{
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, $21KEY.V001_SCHEMA_KEY) && consentToken.length === 7;
    const isV002 = version === (0, $21KEY.V002_SCHEMA_KEY) && consentToken.length === 12;
    const isV003 = version === (0, $21KEY.V003_SCHEMA_KEY) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    const isSupportedVersion = [
        (0, $21KEY.V001_SCHEMA_KEY),
        (0, $21KEY.V002_SCHEMA_KEY),
        (0, $21KEY.V003_SCHEMA_KEY)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002,
        isV003: isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const $f95b7e0a4ae57e4e$var$packPrefsVersion001 = (userPreferences)=>{
    const version = (0, $21KEY.V001_SCHEMA_KEY);
    return [
        version,
        (0, $fp1RH.getBitValueFromBool)(userPreferences.FUNCTIONAL),
        (0, $fp1RH.getBitValueFromBool)(userPreferences.ANALYTICS),
        (0, $fp1RH.getBitValueFromBool)(userPreferences.MARKETING),
        (0, $fp1RH.getBitValueFromBool)(userPreferences.UNKNOWN)
    ].join('');
};
const $f95b7e0a4ae57e4e$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, $8FFpF.PreferenceCategory).StrictlyNecessary]: true,
        [(0, $8FFpF.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $8FFpF.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $8FFpF.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $8FFpF.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const $f95b7e0a4ae57e4e$var$packPrefsVersion002 = (userPreferences)=>{
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    const version = (0, $21KEY.V003_SCHEMA_KEY);
    const hasConsentedPreviously = userPreferences[(0, $8FFpF.ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, $8FFpF.ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, $8FFpF.ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, $8FFpF.ConsentPreferenceV2).ConsentedUnderFADP];
    const isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    const existingConsentDataUnavailableBit = userPreferences[(0, $8FFpF.ContextualConsentProperty).ConsentDataUnavailable];
    const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.PreferenceCategory).Functional]),
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.PreferenceCategory).Analytics]),
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.PreferenceCategory).Marketing]),
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.PreferenceCategory).Unknown]),
        (0, $fp1RH.getBitValueFromBool)(isDefaultConsentBit),
        (0, $fp1RH.getBitValueFromBool)(userIsAuthenticatedBit),
        (0, $fp1RH.getBitValueFromBool)(existingConsentDataUnavailableBit)
    ].join('');
};
const $f95b7e0a4ae57e4e$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    const isADefaultConsentToken = (0, $bF6aU.checkIfTokenIsDefault)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    const consentDataUnavailable = userPreferencesCookie[7] === '1';
    const userIsDeemedAuthenticated = !consentDataUnavailable;
    return {
        ...$f95b7e0a4ae57e4e$var$unpackPrefsVersion003(userPreferencesCookie),
        [(0, $8FFpF.ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
        [(0, $8FFpF.ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
        [(0, $8FFpF.ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
    };
};
/* Schema Version 003
---------------------------------------------------
  - Format 0000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ const $f95b7e0a4ae57e4e$var$packPrefsVersion003 = (userPreferences)=>{
    const version = (0, $21KEY.V003_SCHEMA_KEY);
    return [
        version,
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.PreferenceCategory).Functional]),
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.PreferenceCategory).Analytics]),
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.PreferenceCategory).Marketing]),
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.PreferenceCategory).Unknown]),
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.ContextualConsentProperty).ConsentsAreDefault]),
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.ContextualConsentProperty).UserIsAuthenticated]),
        (0, $fp1RH.getBitValueFromBool)(userPreferences[(0, $8FFpF.ContextualConsentProperty).ConsentDataUnavailable])
    ].join('');
};
const $f95b7e0a4ae57e4e$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
    return {
        [(0, $8FFpF.PreferenceCategory).StrictlyNecessary]: true,
        [(0, $8FFpF.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $8FFpF.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $8FFpF.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $8FFpF.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
        [(0, $8FFpF.ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
        [(0, $8FFpF.ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
        [(0, $8FFpF.ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
    };
};
const $f95b7e0a4ae57e4e$var$V002SpecificBitKeys = [
    (0, $8FFpF.ContextualConsentProperty).ConsentDataUnavailable,
    (0, $8FFpF.ConsentPreferenceV2).ConsentedUnderGDPR,
    (0, $8FFpF.ConsentPreferenceV2).ConsentedUnderCPRA,
    (0, $8FFpF.ConsentPreferenceV2).ConsentedUnderLGPD,
    (0, $8FFpF.ConsentPreferenceV2).ConsentedUnderFADP
];
const $f95b7e0a4ae57e4e$var$V003SpecificBitKeys = [
    (0, $8FFpF.ContextualConsentProperty).ConsentsAreDefault,
    (0, $8FFpF.ContextualConsentProperty).UserIsAuthenticated,
    (0, $8FFpF.ContextualConsentProperty).ConsentDataUnavailable
];
function $f95b7e0a4ae57e4e$export$3199823fec979bd1(userPreferences) {
    if ((0, $gMWuT.getBscGlobalState)().localConsentMode) return $f95b7e0a4ae57e4e$var$packPrefsVersion001(userPreferences);
    const isV002 = $f95b7e0a4ae57e4e$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return $f95b7e0a4ae57e4e$var$packPrefsVersion002(userPreferences);
    const isV003 = $f95b7e0a4ae57e4e$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV003) return $f95b7e0a4ae57e4e$var$packPrefsVersion003(userPreferences);
    // Fallback to V001
    return $f95b7e0a4ae57e4e$var$packPrefsVersion001(userPreferences);
}
function $f95b7e0a4ae57e4e$export$8d213cb390bab4fa(userPreferencesCookie) {
    if ((0, $gMWuT.getBscGlobalState)().localConsentMode) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $21KEY.V001_SCHEMA_KEY)) return $f95b7e0a4ae57e4e$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $f95b7e0a4ae57e4e$export$64b31470e8522819(userPreferencesCookie);
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return $f95b7e0a4ae57e4e$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return $f95b7e0a4ae57e4e$var$unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return $f95b7e0a4ae57e4e$var$unpackPrefsVersion003(userPreferencesCookie);
}
const $f95b7e0a4ae57e4e$export$67f70eb55341bd29 = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const $f95b7e0a4ae57e4e$export$7962405c3ca274b1 = (initialPreferences)=>{
    if (initialPreferences !== (0, $8FFpF.PrefetchedPreferenceState).INTERNAL) {
        if ($f95b7e0a4ae57e4e$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = $f95b7e0a4ae57e4e$export$8d213cb390bab4fa(consentToken);
            return {
                prefs: unpackedExistingPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
            };
        }
        // This type guard protects the below casting of ConsentHubResponse ensuring we have the correct shape
        if (initialPreferences && 'consents' in initialPreferences) {
            const serializedPrefetchedConsentToken = (0, $bF6aU.serializeConsents)(initialPreferences);
            const unpackedPrefetchedPrefs = $f95b7e0a4ae57e4e$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
            return {
                prefs: unpackedPrefetchedPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
            };
        }
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    if (initialPreferences === (0, $8FFpF.PrefetchedPreferenceState).INTERNAL) return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: true
    };
    return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: false
    };
};

});


parcelRegister("7RRGT", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $e697b6ca6ca66a2d$export$93509ff9a62ee022);

var $eYli8 = parcelRequire("eYli8");

var $VSDnB = parcelRequire("VSDnB");

var $3MsQ9 = parcelRequire("3MsQ9");

var $Dyz2r = parcelRequire("Dyz2r");
const $e697b6ca6ca66a2d$export$93509ff9a62ee022 = (key, value, attributes)=>{
    if ((0, $VSDnB.fg)('platform_moonjelly_bsc_master_killswitch')) // Set the cookie without package operational events
    // when master killswitch is enabled
    (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).set(key, value, {
        ...attributes,
        'atl-set-cookie': true
    });
    else try {
        (0, $3MsQ9.sendPackageOperationalEvent)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $Dyz2r.Logger).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
    }
};

});


parcelRegister("9C321", function(module, exports) {

$parcel$export(module.exports, "getValidConsentData", () => $f9f5f5b5132e3785$export$c515de1cc9cebc71);

var $VSDnB = parcelRequire("VSDnB");

var $21KEY = parcelRequire("21KEY");

var $jhSue = parcelRequire("jhSue");

var $gHrGQ = parcelRequire("gHrGQ");
const $f9f5f5b5132e3785$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, $jhSue.fetchConsentPreferences)();
    let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
    let { isValid: isValid } = (0, $gHrGQ.checkTokenVersionValidity)(consentToken);
    if (isValid && consentHubInaccessible) {
        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
        // any previously set consents in the interim if we have them.
        consentToken = fallbackConsentToken;
        else if ((0, $VSDnB.fg)('platform_moonjelly_bsc_fallback_token_audit')) {
            const version = (0, $21KEY.V003_SCHEMA_KEY);
            const consents = consentToken.slice(3, 7);
            // V003 BSC bits set to reflect default consent token status, authenticated user status,
            // and unavailable consentHub records status)
            const serviceBits = '111';
            // Temporary: Sets a default token with V003 properties
            // when ConsentHub is inaccessible and there is not fallback token. This
            // will ensure the banner isn't shown when ConsentHub is down.
            consentToken = `${version}${consents}${serviceBits}`;
        } else // Temporary: Sets the default token to have true consentedUnderXXXX bits
        // when ConsentHub is inaccessible and there is not fallback token. This
        // will ensure the banner isn't shown when ConsentHub is down.
        consentToken = `${consentToken.slice(0, 8)}1111`;
    }
    return isValid ? {
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    } : undefined;
};

});
parcelRegister("jhSue", function(module, exports) {

$parcel$export(module.exports, "buildConsentPreferences", () => $356623899ad2d63f$export$bd9f5bcbf9cd947c);
$parcel$export(module.exports, "fetchConsentPreferences", () => $356623899ad2d63f$export$86467566615ab85e);
$parcel$export(module.exports, "saveConsentPreferences", () => $356623899ad2d63f$export$f8422650c3dec8b2);

var $Dyz2r = parcelRequire("Dyz2r");

var $bF6aU = parcelRequire("bF6aU");
const $356623899ad2d63f$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const $356623899ad2d63f$var$POST_CONSENTS_URL = `${$356623899ad2d63f$var$BASE_CONSENTS_URL}/user`;
const $356623899ad2d63f$var$GET_CONSENTS_URL = `${$356623899ad2d63f$var$POST_CONSENTS_URL}/consents/cookies`;
const $356623899ad2d63f$export$bd9f5bcbf9cd947c = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, $bF6aU.serializeConsents)(consentData);
        const consentTimestamp = (0, $bF6aU.getConsentTimestamp)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $bF6aU.serializeConsents)({}),
        consentHubInaccessible: true
    };
};
const $356623899ad2d63f$export$86467566615ab85e = async ()=>{
    const { origin: origin } = window.location;
    const getFromConsentHubURL = `${origin}${$356623899ad2d63f$var$GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return $356623899ad2d63f$export$bd9f5bcbf9cd947c(consentData);
    } catch (err) {
        (0, $Dyz2r.Logger).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return $356623899ad2d63f$export$bd9f5bcbf9cd947c();
    }
};
const $356623899ad2d63f$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const deserializedConsents = (0, $bF6aU.deserializeConsents)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action: action,
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const $356623899ad2d63f$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${$356623899ad2d63f$var$POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: $356623899ad2d63f$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        // 401 = User is unauthenticated
        // 5xx = ConsentHub is unavailable
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, $bF6aU.StatusCodeError)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, $Dyz2r.Logger).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};

});






parcelRegister("Ux8bG", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryStorageItem", () => $c4f157f4fba696fa$export$f1b0c189562aa9fd);

var $3MsQ9 = parcelRequire("3MsQ9");

var $Dyz2r = parcelRequire("Dyz2r");

var $8FFpF = parcelRequire("8FFpF");

var $3uyrZ = parcelRequire("3uyrZ");
const $c4f157f4fba696fa$export$f1b0c189562aa9fd = (itemKey, value, storageType, browserStorage)=>{
    // Flag disabled, allow all items.
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $3MsQ9.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItem',
            attributes: eventAttributes
        });
        // Store the item as a record in our IDB service to track that we've seen it before.
        // That way, when we can confirm/deny that this has been set by our service when we check again.
        // If it fails for some reason, it will be caught before actually setting the item
        // As setting Strictly Necessary requires synchronous operation, wait on the promise in an OG fashion
        (0, $3uyrZ.BSCIndexedDB).setRecord(itemKey).then(()=>{
        // NOTE: Should this just no-op/be removed? It already set and returned the item theoretically since this main func is sync
        }).catch((e)=>{
            // Rethrow to the above catch clause since this is async within a sync func
            throw new Error(e.message || '');
        });
        browserStorage.setItem(itemKey, value);
        return (0, $8FFpF.Status).SUCCESS;
    } catch (e) {
        (0, $Dyz2r.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItemError',
            attributes: eventAttributes,
            message: `Failed to set strictly necessary ${storageType} item. ${e.message || ''}`
        });
        return (0, $8FFpF.Status).FAILED;
    }
};

});


parcelRegister("kzObv", function(module, exports) {
var $efae012046e18468$var$namespace = 'expire_mixin';
module.exports = $efae012046e18468$var$expirePlugin;
function $efae012046e18468$var$expirePlugin() {
    var expirations = this.createStore(this.storage, null, this._namespacePrefix + $efae012046e18468$var$namespace);
    return {
        set: expire_set,
        get: expire_get,
        remove: expire_remove,
        getExpiration: getExpiration,
        removeExpiredKeys: removeExpiredKeys
    };
    function expire_set(super_fn, key, val, expiration) {
        if (!this.hasNamespace($efae012046e18468$var$namespace)) expirations.set(key, expiration);
        return super_fn();
    }
    function expire_get(super_fn, key) {
        if (!this.hasNamespace($efae012046e18468$var$namespace)) _checkExpiration.call(this, key);
        return super_fn();
    }
    function expire_remove(super_fn, key) {
        if (!this.hasNamespace($efae012046e18468$var$namespace)) expirations.remove(key);
        return super_fn();
    }
    function getExpiration(_, key) {
        return expirations.get(key);
    }
    function removeExpiredKeys(_) {
        var keys = [];
        this.each(function(val, key) {
            keys.push(key);
        });
        for(var i = 0; i < keys.length; i++)_checkExpiration.call(this, keys[i]);
    }
    function _checkExpiration(key) {
        var expiration = expirations.get(key, Number.MAX_VALUE);
        if (expiration <= new Date().getTime()) {
            this.raw.remove(key);
            expirations.remove(key);
        }
    }
}

});

parcelRegister("c4CII", function(module, exports) {

var $dgvY6 = parcelRequire("dgvY6");
var $8ca3e4c5fdf5089f$var$slice = $dgvY6.slice;
var $8ca3e4c5fdf5089f$var$pluck = $dgvY6.pluck;
var $8ca3e4c5fdf5089f$var$each = $dgvY6.each;
var $8ca3e4c5fdf5089f$var$bind = $dgvY6.bind;
var $8ca3e4c5fdf5089f$var$create = $dgvY6.create;
var $8ca3e4c5fdf5089f$var$isList = $dgvY6.isList;
var $8ca3e4c5fdf5089f$var$isFunction = $dgvY6.isFunction;
var $8ca3e4c5fdf5089f$var$isObject = $dgvY6.isObject;
module.exports = {
    createStore: $8ca3e4c5fdf5089f$var$createStore
};
var $8ca3e4c5fdf5089f$var$storeAPI = {
    version: '2.0.12',
    enabled: false,
    // get returns the value of the given key. If that value
    // is undefined, it returns optionalDefaultValue instead.
    get: function(key, optionalDefaultValue) {
        var data = this.storage.read(this._namespacePrefix + key);
        return this._deserialize(data, optionalDefaultValue);
    },
    // set will store the given value at key and returns value.
    // Calling set with value === undefined is equivalent to calling remove.
    set: function(key, value) {
        if (value === undefined) return this.remove(key);
        this.storage.write(this._namespacePrefix + key, this._serialize(value));
        return value;
    },
    // remove deletes the key and value stored at the given key.
    remove: function(key) {
        this.storage.remove(this._namespacePrefix + key);
    },
    // each will call the given callback once for each key-value pair
    // in this store.
    each: function(callback) {
        var self = this;
        this.storage.each(function(val, namespacedKey) {
            callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''));
        });
    },
    // clearAll will remove all the stored key-value pairs in this store.
    clearAll: function() {
        this.storage.clearAll();
    },
    // additional functionality that can't live in plugins
    // ---------------------------------------------------
    // hasNamespace returns true if this store instance has the given namespace.
    hasNamespace: function(namespace) {
        return this._namespacePrefix == '__storejs_' + namespace + '_';
    },
    // createStore creates a store.js instance with the first
    // functioning storage in the list of storage candidates,
    // and applies the the given mixins to the instance.
    createStore: function() {
        return $8ca3e4c5fdf5089f$var$createStore.apply(this, arguments);
    },
    addPlugin: function(plugin) {
        this._addPlugin(plugin);
    },
    namespace: function(namespace) {
        return $8ca3e4c5fdf5089f$var$createStore(this.storage, this.plugins, namespace);
    }
};
function $8ca3e4c5fdf5089f$var$_warn() {
    var _console = typeof console == 'undefined' ? null : console;
    if (!_console) return;
    var fn = _console.warn ? _console.warn : _console.log;
    fn.apply(_console, arguments);
}
function $8ca3e4c5fdf5089f$var$createStore(storages, plugins, namespace) {
    if (!namespace) namespace = '';
    if (storages && !$8ca3e4c5fdf5089f$var$isList(storages)) storages = [
        storages
    ];
    if (plugins && !$8ca3e4c5fdf5089f$var$isList(plugins)) plugins = [
        plugins
    ];
    var namespacePrefix = namespace ? '__storejs_' + namespace + '_' : '';
    var namespaceRegexp = namespace ? new RegExp('^' + namespacePrefix) : null;
    var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
    ;
    if (!legalNamespaces.test(namespace)) throw new Error('store.js namespaces can only have alphanumerics + underscores and dashes');
    var _privateStoreProps = {
        _namespacePrefix: namespacePrefix,
        _namespaceRegexp: namespaceRegexp,
        _testStorage: function(storage) {
            try {
                var testStr = '__storejs__test__';
                storage.write(testStr, testStr);
                var ok = storage.read(testStr) === testStr;
                storage.remove(testStr);
                return ok;
            } catch (e) {
                return false;
            }
        },
        _assignPluginFnProp: function(pluginFnProp, propName) {
            var oldFn = this[propName];
            this[propName] = function pluginFn() {
                var args = $8ca3e4c5fdf5089f$var$slice(arguments, 0);
                var self = this;
                // super_fn calls the old function which was overwritten by
                // this mixin.
                function super_fn() {
                    if (!oldFn) return;
                    $8ca3e4c5fdf5089f$var$each(arguments, function(arg, i) {
                        args[i] = arg;
                    });
                    return oldFn.apply(self, args);
                }
                // Give mixing function access to super_fn by prefixing all mixin function
                // arguments with super_fn.
                var newFnArgs = [
                    super_fn
                ].concat(args);
                return pluginFnProp.apply(self, newFnArgs);
            };
        },
        _serialize: function(obj) {
            return JSON.stringify(obj);
        },
        _deserialize: function(strVal, defaultVal) {
            if (!strVal) return defaultVal;
            // It is possible that a raw string value has been previously stored
            // in a storage without using store.js, meaning it will be a raw
            // string value instead of a JSON serialized string. By defaulting
            // to the raw string value in case of a JSON parse error, we allow
            // for past stored values to be forwards-compatible with store.js
            var val = '';
            try {
                val = JSON.parse(strVal);
            } catch (e) {
                val = strVal;
            }
            return val !== undefined ? val : defaultVal;
        },
        _addStorage: function(storage) {
            if (this.enabled) return;
            if (this._testStorage(storage)) {
                this.storage = storage;
                this.enabled = true;
            }
        },
        _addPlugin: function(plugin) {
            var self = this;
            // If the plugin is an array, then add all plugins in the array.
            // This allows for a plugin to depend on other plugins.
            if ($8ca3e4c5fdf5089f$var$isList(plugin)) {
                $8ca3e4c5fdf5089f$var$each(plugin, function(plugin) {
                    self._addPlugin(plugin);
                });
                return;
            }
            // Keep track of all plugins we've seen so far, so that we
            // don't add any of them twice.
            var seenPlugin = $8ca3e4c5fdf5089f$var$pluck(this.plugins, function(seenPlugin) {
                return plugin === seenPlugin;
            });
            if (seenPlugin) return;
            this.plugins.push(plugin);
            // Check that the plugin is properly formed
            if (!$8ca3e4c5fdf5089f$var$isFunction(plugin)) throw new Error('Plugins must be function values that return objects');
            var pluginProperties = plugin.call(this);
            if (!$8ca3e4c5fdf5089f$var$isObject(pluginProperties)) throw new Error('Plugins must return an object of function properties');
            // Add the plugin function properties to this store instance.
            $8ca3e4c5fdf5089f$var$each(pluginProperties, function(pluginFnProp, propName) {
                if (!$8ca3e4c5fdf5089f$var$isFunction(pluginFnProp)) throw new Error('Bad plugin property: ' + propName + ' from plugin ' + plugin.name + '. Plugins should only return functions.');
                self._assignPluginFnProp(pluginFnProp, propName);
            });
        },
        // Put deprecated properties in the private API, so as to not expose it to accidential
        // discovery through inspection of the store object.
        // Deprecated: addStorage
        addStorage: function(storage) {
            $8ca3e4c5fdf5089f$var$_warn('store.addStorage(storage) is deprecated. Use createStore([storages])');
            this._addStorage(storage);
        }
    };
    var store = $8ca3e4c5fdf5089f$var$create(_privateStoreProps, $8ca3e4c5fdf5089f$var$storeAPI, {
        plugins: []
    });
    store.raw = {};
    $8ca3e4c5fdf5089f$var$each(store, function(prop, propName) {
        if ($8ca3e4c5fdf5089f$var$isFunction(prop)) store.raw[propName] = $8ca3e4c5fdf5089f$var$bind(store, prop);
    });
    $8ca3e4c5fdf5089f$var$each(storages, function(storage) {
        store._addStorage(storage);
    });
    $8ca3e4c5fdf5089f$var$each(plugins, function(plugin) {
        store._addPlugin(plugin);
    });
    return store;
}

});
parcelRegister("dgvY6", function(module, exports) {
var $9a85913e079cf886$var$assign = $9a85913e079cf886$var$make_assign();
var $9a85913e079cf886$var$create = $9a85913e079cf886$var$make_create();
var $9a85913e079cf886$var$trim = $9a85913e079cf886$var$make_trim();
var $9a85913e079cf886$var$Global = typeof window !== 'undefined' ? window : $parcel$global;
module.exports = {
    assign: $9a85913e079cf886$var$assign,
    create: $9a85913e079cf886$var$create,
    trim: $9a85913e079cf886$var$trim,
    bind: $9a85913e079cf886$var$bind,
    slice: $9a85913e079cf886$var$slice,
    each: $9a85913e079cf886$var$each,
    map: $9a85913e079cf886$var$map,
    pluck: $9a85913e079cf886$var$pluck,
    isList: $9a85913e079cf886$var$isList,
    isFunction: $9a85913e079cf886$var$isFunction,
    isObject: $9a85913e079cf886$var$isObject,
    Global: $9a85913e079cf886$var$Global
};
function $9a85913e079cf886$var$make_assign() {
    if (Object.assign) return Object.assign;
    else return function shimAssign(obj, props1, props2, etc) {
        for(var i = 1; i < arguments.length; i++)$9a85913e079cf886$var$each(Object(arguments[i]), function(val, key) {
            obj[key] = val;
        });
        return obj;
    };
}
function $9a85913e079cf886$var$make_create() {
    if (Object.create) return function create(obj, assignProps1, assignProps2, etc) {
        var assignArgsList = $9a85913e079cf886$var$slice(arguments, 1);
        return $9a85913e079cf886$var$assign.apply(this, [
            Object.create(obj)
        ].concat(assignArgsList));
    };
    else {
        function F() {} // eslint-disable-line no-inner-declarations
        return function create(obj, assignProps1, assignProps2, etc) {
            var assignArgsList = $9a85913e079cf886$var$slice(arguments, 1);
            F.prototype = obj;
            return $9a85913e079cf886$var$assign.apply(this, [
                new F()
            ].concat(assignArgsList));
        };
    }
}
function $9a85913e079cf886$var$make_trim() {
    if (String.prototype.trim) return function trim(str) {
        return String.prototype.trim.call(str);
    };
    else return function trim(str) {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    };
}
function $9a85913e079cf886$var$bind(obj, fn) {
    return function() {
        return fn.apply(obj, Array.prototype.slice.call(arguments, 0));
    };
}
function $9a85913e079cf886$var$slice(arr, index) {
    return Array.prototype.slice.call(arr, index || 0);
}
function $9a85913e079cf886$var$each(obj, fn) {
    $9a85913e079cf886$var$pluck(obj, function(val, key) {
        fn(val, key);
        return false;
    });
}
function $9a85913e079cf886$var$map(obj, fn) {
    var res = $9a85913e079cf886$var$isList(obj) ? [] : {};
    $9a85913e079cf886$var$pluck(obj, function(v, k) {
        res[k] = fn(v, k);
        return false;
    });
    return res;
}
function $9a85913e079cf886$var$pluck(obj, fn) {
    if ($9a85913e079cf886$var$isList(obj)) for(var i = 0; i < obj.length; i++){
        if (fn(obj[i], i)) return obj[i];
    }
    else {
        for(var key in obj)if (obj.hasOwnProperty(key)) {
            if (fn(obj[key], key)) return obj[key];
        }
    }
}
function $9a85913e079cf886$var$isList(val) {
    return val != null && typeof val != 'function' && typeof val.length == 'number';
}
function $9a85913e079cf886$var$isFunction(val) {
    return val && ({}).toString.call(val) === '[object Function]';
}
function $9a85913e079cf886$var$isObject(val) {
    return val && ({}).toString.call(val) === '[object Object]';
}

});


parcelRegister("4Zgux", function(module, exports) {

var $dgvY6 = parcelRequire("dgvY6");
var $3a19a6cea530455f$var$Global = $dgvY6.Global;
module.exports = {
    name: 'localStorage',
    read: $3a19a6cea530455f$var$read,
    write: $3a19a6cea530455f$var$write,
    each: $3a19a6cea530455f$var$each,
    remove: $3a19a6cea530455f$var$remove,
    clearAll: $3a19a6cea530455f$var$clearAll
};
function $3a19a6cea530455f$var$localStorage() {
    return $3a19a6cea530455f$var$Global.localStorage;
}
function $3a19a6cea530455f$var$read(key) {
    return $3a19a6cea530455f$var$localStorage().getItem(key);
}
function $3a19a6cea530455f$var$write(key, data) {
    return $3a19a6cea530455f$var$localStorage().setItem(key, data);
}
function $3a19a6cea530455f$var$each(fn) {
    for(var i = $3a19a6cea530455f$var$localStorage().length - 1; i >= 0; i--){
        var key = $3a19a6cea530455f$var$localStorage().key(i);
        fn($3a19a6cea530455f$var$read(key), key);
    }
}
function $3a19a6cea530455f$var$remove(key) {
    return $3a19a6cea530455f$var$localStorage().removeItem(key);
}
function $3a19a6cea530455f$var$clearAll() {
    return $3a19a6cea530455f$var$localStorage().clear();
}

});

parcelRegister("2NjNT", function(module, exports) {
// memoryStorage is a useful last fallback to ensure that the store
// is functions (meaning store.get(), store.set(), etc will all function).
// However, stored values will not persist when the browser navigates to
// a new page or reloads the current page.
module.exports = {
    name: 'memoryStorage',
    read: $208f84ff41bcb720$var$read,
    write: $208f84ff41bcb720$var$write,
    each: $208f84ff41bcb720$var$each,
    remove: $208f84ff41bcb720$var$remove,
    clearAll: $208f84ff41bcb720$var$clearAll
};
var $208f84ff41bcb720$var$memoryStorage = {};
function $208f84ff41bcb720$var$read(key) {
    return $208f84ff41bcb720$var$memoryStorage[key];
}
function $208f84ff41bcb720$var$write(key, data) {
    $208f84ff41bcb720$var$memoryStorage[key] = data;
}
function $208f84ff41bcb720$var$each(callback) {
    for(var key in $208f84ff41bcb720$var$memoryStorage)if ($208f84ff41bcb720$var$memoryStorage.hasOwnProperty(key)) callback($208f84ff41bcb720$var$memoryStorage[key], key);
}
function $208f84ff41bcb720$var$remove(key) {
    delete $208f84ff41bcb720$var$memoryStorage[key];
}
function $208f84ff41bcb720$var$clearAll(key) {
    $208f84ff41bcb720$var$memoryStorage = {};
}

});

parcelRegister("84Tib", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $5e19965b98ae8a50$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $5e19965b98ae8a50$var$isBoolean(value) {
    return value === true || value === false || $fC1Kz(value) && $beQoo(value) == $5e19965b98ae8a50$var$boolTag;
}
module.exports = $5e19965b98ae8a50$var$isBoolean;

});

parcelRegister("duUGa", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $785cd7675432925d$export$c00d22927c60484a);

var $4wnip = parcelRequire("4wnip");
class $785cd7675432925d$export$c00d22927c60484a extends (0, $4wnip.UFOAbstractExperience) {
}

});

parcelRegister("dMEgP", function(module, exports) {

var $2MIs9 = parcelRequire("2MIs9");

var $66FNL = parcelRequire("66FNL");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $a08efee9347d14dc$var$values(object) {
    return object == null ? [] : $2MIs9(object, $66FNL(object));
}
module.exports = $a08efee9347d14dc$var$values;

});
parcelRegister("2MIs9", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $20728bee5205c23b$var$baseValues(object, props) {
    return $1nIHN(props, function(key) {
        return object[key];
    });
}
module.exports = $20728bee5205c23b$var$baseValues;

});


parcelRegister("ebyGx", function(module, exports) {

$parcel$export(module.exports, "extract", () => $a53cff7e93c16c2c$export$f9380c9a627682d3, (v) => $a53cff7e93c16c2c$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $a53cff7e93c16c2c$export$98e6a39c04603d36, (v) => $a53cff7e93c16c2c$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $a53cff7e93c16c2c$export$fac44ee5b035f737, (v) => $a53cff7e93c16c2c$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $a53cff7e93c16c2c$export$7a5253c0f62e0150, (v) => $a53cff7e93c16c2c$export$7a5253c0f62e0150 = v);
var $a53cff7e93c16c2c$export$f9380c9a627682d3;
var $a53cff7e93c16c2c$export$98e6a39c04603d36;
var $a53cff7e93c16c2c$export$fac44ee5b035f737;
var $a53cff7e93c16c2c$export$7a5253c0f62e0150;
'use strict';

var $2kldK = parcelRequire("2kldK");

var $9rcQv = parcelRequire("9rcQv");

var $aCrRe = parcelRequire("aCrRe");
function $a53cff7e93c16c2c$var$encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, index) {
                return value === null ? [
                    $a53cff7e93c16c2c$var$encode(key, opts),
                    '[',
                    index,
                    ']'
                ].join('') : [
                    $a53cff7e93c16c2c$var$encode(key, opts),
                    '[',
                    $a53cff7e93c16c2c$var$encode(index, opts),
                    ']=',
                    $a53cff7e93c16c2c$var$encode(value, opts)
                ].join('');
            };
        case 'bracket':
            return function(key, value) {
                return value === null ? $a53cff7e93c16c2c$var$encode(key, opts) : [
                    $a53cff7e93c16c2c$var$encode(key, opts),
                    '[]=',
                    $a53cff7e93c16c2c$var$encode(value, opts)
                ].join('');
            };
        default:
            return function(key, value) {
                return value === null ? $a53cff7e93c16c2c$var$encode(key, opts) : [
                    $a53cff7e93c16c2c$var$encode(key, opts),
                    '=',
                    $a53cff7e93c16c2c$var$encode(value, opts)
                ].join('');
            };
    }
}
function $a53cff7e93c16c2c$var$parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $a53cff7e93c16c2c$var$encode(value, opts) {
    if (opts.encode) return opts.strict ? $2kldK(value) : encodeURIComponent(value);
    return value;
}
function $a53cff7e93c16c2c$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    else if (typeof input === 'object') return $a53cff7e93c16c2c$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $a53cff7e93c16c2c$var$extract(str) {
    var queryStart = str.indexOf('?');
    if (queryStart === -1) return '';
    return str.slice(queryStart + 1);
}
function $a53cff7e93c16c2c$var$parse(str, opts) {
    opts = $9rcQv({
        arrayFormat: 'none'
    }, opts);
    var formatter = $a53cff7e93c16c2c$var$parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== 'string') return ret;
    str = str.trim().replace(/^[?#&]/, '');
    if (!str) return ret;
    str.split('&').forEach(function(param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : $aCrRe(val);
        formatter($aCrRe(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) // Sort object keys, not values
        result[key] = $a53cff7e93c16c2c$var$keysSorter(val);
        else result[key] = val;
        return result;
    }, Object.create(null));
}
$a53cff7e93c16c2c$export$f9380c9a627682d3 = $a53cff7e93c16c2c$var$extract;
$a53cff7e93c16c2c$export$98e6a39c04603d36 = $a53cff7e93c16c2c$var$parse;
$a53cff7e93c16c2c$export$fac44ee5b035f737 = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: 'none'
    };
    opts = $9rcQv(defaults, opts);
    if (opts.sort === false) opts.sort = function() {};
    var formatter = $a53cff7e93c16c2c$var$encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort(opts.sort).map(function(key) {
        var val = obj[key];
        if (val === undefined) return '';
        if (val === null) return $a53cff7e93c16c2c$var$encode(key, opts);
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) return;
                result.push(formatter(key, val2, result.length));
            });
            return result.join('&');
        }
        return $a53cff7e93c16c2c$var$encode(key, opts) + '=' + $a53cff7e93c16c2c$var$encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&') : '';
};
$a53cff7e93c16c2c$export$7a5253c0f62e0150 = function(str, opts) {
    return {
        url: str.split('?')[0] || '',
        query: $a53cff7e93c16c2c$var$parse($a53cff7e93c16c2c$var$extract(str), opts)
    };
};

});
parcelRegister("2kldK", function(module, exports) {
'use strict';
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};

});

parcelRegister("9rcQv", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $6df099941a738cfd$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $6df099941a738cfd$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $6df099941a738cfd$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $6df099941a738cfd$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $6df099941a738cfd$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $6df099941a738cfd$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $6df099941a738cfd$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($6df099941a738cfd$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($6df099941a738cfd$var$getOwnPropertySymbols) {
            symbols = $6df099941a738cfd$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($6df099941a738cfd$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("4zICj", function(module, exports) {

$parcel$export(module.exports, "choreographerFactory", () => $66410bab62c95f4d$export$55d2aeb17c4cfbe);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $TTRxY = parcelRequire("TTRxY");

var $atotX = parcelRequire("atotX");

var $2Mf0U = parcelRequire("2Mf0U");
var $cA3S0 = parcelRequire("cA3S0");
var $aUNbN = parcelRequire("aUNbN");
var $lVEk7 = parcelRequire("lVEk7");
var $bNT5z = parcelRequire("bNT5z");
var $gVhsA = parcelRequire("gVhsA");
var $8ekle = parcelRequire("8ekle");
var $kmPbm = parcelRequire("kmPbm");
var $by50B = parcelRequire("by50B");
var $9Pw7n = parcelRequire("9Pw7n");
function $66410bab62c95f4d$export$55d2aeb17c4cfbe(productId, env, metaMetricsData = {}, choreographerOptions = {
    enableChoreographer: true
}) {
    // Instantiate our plugin instance, passing the productId through for segmenting any messageId's from any other plugins
    const plugin = new (0, $atotX.ProductChoreographerPlugin)(productId, env, metaMetricsData);
    /**
	 * React hook that provides startMessage and stopMessage functions that call through the plugin API with the provided messageId, for easy assignment to React event handlers.
	 *
	 * @param messageId The messageId to be provided to the choreographer API whenever the startMessage and stopMessage callbacks are invoked.
	 * @param startCallback A callback to be used to set local state that determines whether a message should be shown, e.g. a callback to a useState setter, or that dispatches to a reducer function.
	 * @param stopCallback A callback to be used to set local state that determines whether a message should be hidden, e.g. a callback to a useState setter, or that dispatches to a reducer function.
	 * @returns An object with startMessage and stopMessage callbacks, which contain references to the messageId to be passed to the choreographer API, so that the consumer no longer needs to specify that at call time.
	 */ const useChoreographer = (messageId, { [(0, $TTRxY.MessageEventType).START]: startCallback, [(0, $TTRxY.MessageEventType).STOP]: stopCallback } = {})=>{
        const isMessageStarted = (0, $5uXOq.useRef)(false);
        const startRef = (0, $5uXOq.useRef)(startCallback);
        const stopRef = (0, $5uXOq.useRef)(stopCallback);
        // Callback that uses a ref to track any changes in the received startCallback parameter, so the caller doesn't have to worry about memoization
        const startMessageCallback = (0, $5uXOq.useCallback)(async (...args)=>{
            const didMessageStart = await startRef.current?.(...args) ?? true;
            isMessageStarted.current = didMessageStart;
            return didMessageStart;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes the plugin's startMessage function, for use in components.
        const startMessage = (0, $5uXOq.useCallback)((...args)=>{
            plugin.onStart(messageId, ()=>startMessageCallback(...args));
            return plugin.startMessage(messageId);
        }, [
            messageId,
            startMessageCallback
        ]);
        // Callback that uses a ref to track any changes in the received stopCallback parameter, so the caller doesn't have to worry about memoization
        const stopMessageCallback = (0, $5uXOq.useCallback)(async (...args)=>{
            const didMessageStop = await stopRef.current?.(...args) ?? true;
            isMessageStarted.current = !didMessageStop;
            return didMessageStop;
        }, [
            isMessageStarted
        ]);
        // Stable function reference that invokes the plugin's stopMessage function, for use in components.
        const stopMessage = (0, $5uXOq.useCallback)((...args)=>{
            if (isMessageStarted.current) {
                plugin.onStop(messageId, ()=>stopMessageCallback(...args));
                return plugin.stopMessage(messageId);
            }
            return Promise.resolve((0, $TTRxY.MessageDeliveryStatus).STOPPED);
        }, [
            isMessageStarted,
            messageId,
            stopMessageCallback
        ]);
        // Stable function reference that invokes whichever start or stop handler is appropriate for the message's current display state.
        // Tracking this state with a ref allows us to know the current display state in real-time, so that potentially subsequent calls
        // can be made to toggle its state, without requiring tracking a useState value and requiring rerenders to update the callback
        // with the latest display state, and without generating false blocked messages from cached/outdated toggleMessage references.
        const toggleMessage = (0, $5uXOq.useCallback)(()=>{
            return isMessageStarted.current ? stopMessage() : startMessage();
        }, [
            isMessageStarted,
            startMessage,
            stopMessage
        ]);
        // Syncs any incoming startCallback and stopCallback functions as the latest version to be invoked when a startMessage or stopMessage call is issued through the choreographer API
        (0, $5uXOq.useLayoutEffect)(()=>{
            startRef.current = startCallback;
            stopRef.current = stopCallback;
        }, [
            startCallback,
            stopCallback
        ]);
        /**
		 * At component mount, we want to default a start and stop function, which invokes these functions with no additional parameters,
		 * just to supply some sane defaults. If startMessage or stopMessage are called explicitly, they can optionally supply some extra
		 * parameters, at which point, a just-in-time registration of a new callback version will be supplied to the choreographer, which
		 * will proxy those parameter through to the target state-setter functions. But if they are not called explicitly, such as in the
		 * case where a message is started and never stopped, and is timed out from the Choreographer, we want to have a default version
		 * available to execute against.
		 *
		 * At component unmount, stop the current message, if it's displayed, and unsubscribe the stop callback for this messageId within
		 * the plugin.
		 */ (0, $5uXOq.useLayoutEffect)(()=>{
            plugin.on(messageId, {
                start: async ()=>{
                    return await startMessage() === (0, $TTRxY.MessageDeliveryStatus).STARTED;
                },
                stop: async ()=>{
                    return await stopMessage() === (0, $TTRxY.MessageDeliveryStatus).STOPPED;
                }
            });
            return ()=>{
                // If unsubscribing, fire the stopMessageCallback one last time to ensure the component can clear the local state responsible for displaying its message
                stopMessage(messageId);
                plugin.off(messageId);
            };
        }, [
            messageId,
            startMessage,
            stopMessage
        ]);
        // Return the wrapped startMessage and stopMessage functions to the consumer, which will route their requests through the choreographer API with the messageId proxied straight through on behalf of the caller
        return (0, $5uXOq.useMemo)(()=>({
                startMessage: startMessage,
                stopMessage: stopMessage,
                toggleMessage: toggleMessage
            }), [
            startMessage,
            stopMessage,
            toggleMessage
        ]);
    };
    const shouldBeChoreographed = (props)=>{
        if ((0, $VSDnB.fg)('post-office_move_shouldbechoreographed')) return plugin.shouldBeChoreographed(props, choreographerOptions);
        return (0, $kmPbm.shouldBeChoreographed)(props, choreographerOptions);
    };
    const useChoreographedRender = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
        const [shouldRender, setShouldRender] = (0, $5uXOq.useState)(false);
        const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
            start: ()=>setShouldRender(true),
            stop: ()=>setShouldRender(false)
        });
        (0, $5uXOq.useLayoutEffect)(()=>{
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition?.(disposition);
            };
            const stopMessageAsync = async ()=>{
                const disposition = await stopMessage();
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>void stopMessageAsync();
        }, [
            messageId,
            onMessageDisposition,
            startMessage,
            stopMessage
        ]);
        return shouldRender;
    };
    const withChoreographedRender = (Component)=>{
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, ...props }) {
            const shouldRender = useChoreographedRender({
                messageId: messageId,
                onMessageDisposition: onMessageDisposition
            });
            if (shouldRender) // Need to cast "props" as unknown to avoid TS error because it can't infer that
            // Omit<ChoreographedComponentProps & T, "messageId" | "onMessageDisposition"> is the same as T
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...props
            });
            return null;
        }
        ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
        return ChoreographedComponent;
    };
    const withChoreographedToggle = (Component, toggleableProp)=>{
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest }) {
            // Need to cast "rest" as unknown to avoid TS error because it can't infer that
            // Omit<ChoreographedComponentProps & T, "messageId" | "onMessageDisposition"> is the same as T
            const props = rest;
            const toggleablePropValue = props[toggleableProp];
            const [shouldRender, setShouldRender] = (0, $5uXOq.useState)(false);
            const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer(messageId, {
                start: ()=>setShouldRender(true),
                stop: ()=>setShouldRender(false)
            });
            (0, $5uXOq.useLayoutEffect)(()=>{
                const startMessageAsync = async ()=>{
                    const disposition = await startMessage();
                    onMessageDisposition?.(disposition);
                };
                const stopMessageAsync = async ()=>{
                    const disposition = await stopMessage();
                    onMessageDisposition?.(disposition);
                };
                if (toggleablePropValue && !shouldRender) startMessageAsync();
                else if (!toggleablePropValue && shouldRender) stopMessageAsync();
                return ()=>{
                    if (!toggleablePropValue && shouldRender) stopMessageAsync();
                };
            }, [
                messageId,
                onMessageDisposition,
                shouldRender,
                startMessage,
                stopMessage,
                toggleablePropValue
            ]);
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...props,
                [toggleableProp]: shouldRender
            });
        }
        return ChoreographedComponent;
    };
    function wrapWithFactoryFunctions(MaybeChoreographedComponent) {
        function Component(props) {
            return /*#__PURE__*/ (0, $2OMIu.jsx)(MaybeChoreographedComponent, {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedRender: withChoreographedRender
            });
        }
        Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
        return Component;
    }
    function wrapWithToggleFactoryFunctions(MaybeChoreographedComponent) {
        function Component(props) {
            return /*#__PURE__*/ (0, $2OMIu.jsx)(MaybeChoreographedComponent, {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        Component.displayName = MaybeChoreographedComponent.displayName = `ChoreographerFactory(${MaybeChoreographedComponent.displayName})`;
        return Component;
    }
    const AutoDismissFlag = wrapWithFactoryFunctions((0, $2Mf0U.AutoDismissFlag));
    const Banner = wrapWithFactoryFunctions((0, $cA3S0.Banner));
    const Flag = wrapWithFactoryFunctions((0, $aUNbN.Flag));
    const Modal = wrapWithFactoryFunctions((0, $bNT5z.Modal));
    const Popper = wrapWithFactoryFunctions((0, $gVhsA.Popper));
    const Spotlight = wrapWithFactoryFunctions((0, $by50B.Spotlight));
    const SpotlightCard = wrapWithFactoryFunctions((0, $9Pw7n.SpotlightCard));
    const InlineDialog = wrapWithToggleFactoryFunctions((0, $lVEk7.InlineDialog));
    // Would ideally like to use wrapWithToggleFactoryFunctions here, but the Popup component's props is a union
    // type, and that for some reason causes ToggleableChoreographerUtilities to be passed through to the
    // consumer-exposed Popup component's prop type, which is not what we want, so we'll just wrap it manually here
    const Popup = function() {
        function WrappedPopup(props) {
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8ekle.Popup), {
                ...props,
                shouldBeChoreographed: shouldBeChoreographed,
                withChoreographedToggle: withChoreographedToggle
            });
        }
        WrappedPopup.displayName = `ChoreographerFactory(${(0, $8ekle.Popup).displayName})`;
        return WrappedPopup;
    }();
    // Return these items from the factory function for use within React products
    return {
        plugin: plugin,
        useChoreographer: useChoreographer,
        shouldBeChoreographed: shouldBeChoreographed,
        useChoreographedRender: useChoreographedRender,
        withChoreographedRender: withChoreographedRender,
        withChoreographedToggle: withChoreographedToggle,
        AutoDismissFlag: AutoDismissFlag,
        Banner: Banner,
        Flag: Flag,
        InlineDialog: InlineDialog,
        Modal: Modal,
        Popper: Popper,
        Popup: Popup,
        Spotlight: Spotlight,
        SpotlightCard: SpotlightCard
    };
}

});
parcelRegister("atotX", function(module, exports) {

$parcel$export(module.exports, "ProductChoreographerPlugin", () => $5652f56fa664d481$export$44bee9c9373d59fb);

var $4YUjU = parcelRequire("4YUjU");
class $5652f56fa664d481$export$44bee9c9373d59fb extends (0, $4YUjU.ChoreographerPlugin) {
    constructor(product, env, metaMetricsData = {}){
        super(product, env, metaMetricsData);
    }
}

});

parcelRegister("2Mf0U", function(module, exports) {

$parcel$export(module.exports, "AutoDismissFlag", () => $2d28883873c8f74f$export$9879a8e0db317538);

var $fWXJB = parcelRequire("fWXJB");

var $kmPbm = parcelRequire("kmPbm");
const $2d28883873c8f74f$export$9879a8e0db317538 = (0, $kmPbm.wrapComponentForChoreographer)((0, $fWXJB.default));

});

parcelRegister("cA3S0", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $403a80a08d6d2f6a$export$3b4e64e77073e307);

var $lkmWu = parcelRequire("lkmWu");

var $kmPbm = parcelRequire("kmPbm");
const $403a80a08d6d2f6a$export$3b4e64e77073e307 = (0, $kmPbm.wrapComponentForChoreographer)((0, $lkmWu.default));

});

parcelRegister("aUNbN", function(module, exports) {

$parcel$export(module.exports, "Flag", () => $4e5c7ea548d20989$export$48ea269755562084);

var $epfFv = parcelRequire("epfFv");

var $kmPbm = parcelRequire("kmPbm");
const $4e5c7ea548d20989$export$48ea269755562084 = (0, $kmPbm.wrapComponentForChoreographer)((0, $epfFv.default));

});

parcelRegister("lVEk7", function(module, exports) {

$parcel$export(module.exports, "InlineDialog", () => $c56e25d30c4b39ec$export$c7313f750e9cbc9d);

var $ctg8C = parcelRequire("ctg8C");

var $kmPbm = parcelRequire("kmPbm");
const $c56e25d30c4b39ec$export$c7313f750e9cbc9d = (0, $kmPbm.wrapToggleableComponentForChoreographer)((0, $ctg8C.default), 'isOpen');

});

parcelRegister("bNT5z", function(module, exports) {

$parcel$export(module.exports, "Modal", () => $0650c9f08266e4ad$export$2b77a92f1a5ad772);

var $1R1Ge = parcelRequire("1R1Ge");

var $kmPbm = parcelRequire("kmPbm");
const $0650c9f08266e4ad$export$2b77a92f1a5ad772 = (0, $kmPbm.wrapComponentForChoreographer)((0, $1R1Ge.default));

});

parcelRegister("gVhsA", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $bdc96b866a7df877$export$badac9ada3a0bdf9);

var $4oNEb = parcelRequire("4oNEb");

var $kmPbm = parcelRequire("kmPbm");
const $bdc96b866a7df877$export$badac9ada3a0bdf9 = (0, $kmPbm.wrapComponentForChoreographer)((0, $4oNEb.Popper));

});

parcelRegister("8ekle", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $fda7f9cfac28a5c8$export$129a32eedafa97c5);

var $1I7E8 = parcelRequire("1I7E8");

var $kmPbm = parcelRequire("kmPbm");
const $fda7f9cfac28a5c8$export$129a32eedafa97c5 = (0, $kmPbm.wrapToggleableComponentForChoreographer)((0, $1I7E8.Popup), 'isOpen');

});

parcelRegister("by50B", function(module, exports) {

$parcel$export(module.exports, "Spotlight", () => $13a98b6d24c00d08$export$1033c28b5e1c2deb);

var $7gs1W = parcelRequire("7gs1W");

var $kmPbm = parcelRequire("kmPbm");
const $13a98b6d24c00d08$export$1033c28b5e1c2deb = (0, $kmPbm.wrapComponentForChoreographer)((0, $7gs1W.default));

});

parcelRegister("9Pw7n", function(module, exports) {

$parcel$export(module.exports, "SpotlightCard", () => $ae524700441ee7eb$export$14710e13fc01d383);

var $5ujeO = parcelRequire("5ujeO");

var $kmPbm = parcelRequire("kmPbm");
const $ae524700441ee7eb$export$14710e13fc01d383 = (0, $kmPbm.wrapComponentForChoreographer)((0, $5ujeO.default));

});


parcelRegister("dI393", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1o9RP = parcelRequire("1o9RP");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $9fb1d2f148532de5$var$_interopRequireDefault($1o9RP).default;
    }
});
function $9fb1d2f148532de5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("1o9RP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $102fafc31c1e58cf$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");
function $102fafc31c1e58cf$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $102fafc31c1e58cf$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $102fafc31c1e58cf$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $102fafc31c1e58cf$var$NodeResolver = function(_Component) {
    $102fafc31c1e58cf$var$_inherits(NodeResolver, _Component);
    function NodeResolver() {
        $102fafc31c1e58cf$var$_classCallCheck(this, NodeResolver);
        return $102fafc31c1e58cf$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
    }
    $102fafc31c1e58cf$var$_createClass(NodeResolver, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.innerRef((0, $7nsd3.findDOMNode)(this));
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: 'render',
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}($5uXOq.Component);
module.exports.default = $102fafc31c1e58cf$var$NodeResolver;

});


parcelRegister("ao4Ml", function(module, exports) {

$parcel$export(module.exports, "default", () => $78ffda35a3cd2a5c$export$2e2bcd8739ae039);

var $cIaXu = parcelRequire("cIaXu");

var $78ffda35a3cd2a5c$export$2e2bcd8739ae039 = (0, $cIaXu.default);

});
parcelRegister("cIaXu", function(module, exports) {

$parcel$export(module.exports, "default", () => $9412183d03dc0dc5$export$2e2bcd8739ae039);

var $ddEsc = parcelRequire("ddEsc");

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $iK0nX = parcelRequire("iK0nX");

var $1jdvF = parcelRequire("1jdvF");
var $9412183d03dc0dc5$var$FocusLockCombination = /*#__PURE__*/ $5uXOq.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $5uXOq.createElement((0, $iK0nX.default), (0, $bS32t.default)({
        sideCar: (0, $1jdvF.default),
        ref: ref
    }, props));
});
var $9412183d03dc0dc5$var$_ref = (0, $iK0nX.default).propTypes || {}, $9412183d03dc0dc5$var$sideCar = $9412183d03dc0dc5$var$_ref.sideCar, $9412183d03dc0dc5$var$propTypes = (0, $ddEsc.default)($9412183d03dc0dc5$var$_ref, [
    "sideCar"
]);
$9412183d03dc0dc5$var$FocusLockCombination.propTypes = {};
var $9412183d03dc0dc5$export$2e2bcd8739ae039 = $9412183d03dc0dc5$var$FocusLockCombination;

});
parcelRegister("iK0nX", function(module, exports) {

$parcel$export(module.exports, "default", () => $da4cd26ce8b7c545$export$2e2bcd8739ae039);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");


var $26Cgu = parcelRequire("26Cgu");

var $3Du7S = parcelRequire("3Du7S");

var $hs7HE = parcelRequire("hs7HE");

var $i2hbO = parcelRequire("i2hbO");

var $lTS5V = parcelRequire("lTS5V");
var $da4cd26ce8b7c545$var$emptyArray = [];
var $da4cd26ce8b7c545$var$FocusLock = /*#__PURE__*/ $5uXOq.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $5uXOq.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $5uXOq.useRef();
    var isActive = $5uXOq.useRef(false);
    var originalFocusedElement = $5uXOq.useRef(null);
    var _React$useState2 = $5uXOq.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $da4cd26ce8b7c545$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $5uXOq.useState({}), id = _React$useState3[0];
    var onActivation = $5uXOq.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $5uXOq.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $5uXOq.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $5uXOq.useCallback(function(event) {
        if (isActive.current) (0, $i2hbO.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $i2hbO.mediumBlur).useMedium;
    var setObserveNode = $5uXOq.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $bS32t.default)((_extends2 = {}, _extends2[$26Cgu.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$26Cgu.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $3Du7S.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $5uXOq.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $5uXOq.createElement($5uXOq.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $5uXOq.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $hs7HE.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $5uXOq.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $hs7HE.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $5uXOq.createElement(SideCar, {
        id: id,
        sideCar: (0, $i2hbO.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $5uXOq.createElement(Container, (0, $bS32t.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $5uXOq.createElement((0, $lTS5V.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $5uXOq.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $hs7HE.hiddenGuard)
    }));
});
$da4cd26ce8b7c545$var$FocusLock.propTypes = {};
var $da4cd26ce8b7c545$export$2e2bcd8739ae039 = $da4cd26ce8b7c545$var$FocusLock;

});
parcelRegister("26Cgu", function(module, exports) {

$parcel$export(module.exports, "FOCUS_GROUP", () => $1889d2ef999b3988$export$4f9a06cb7441a087);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $1889d2ef999b3988$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_ALLOW", () => $1889d2ef999b3988$export$54ecf528c58f9ef6);
$parcel$export(module.exports, "FOCUS_AUTO", () => $1889d2ef999b3988$export$70e9b4a1820af101);
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", () => $1889d2ef999b3988$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $1889d2ef999b3988$export$4f9a06cb7441a087 = 'data-focus-lock';
var $1889d2ef999b3988$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $1889d2ef999b3988$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $1889d2ef999b3988$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $1889d2ef999b3988$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("3Du7S", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", () => $2a5c6201d8713c67$export$74665b213cb5c4cf);

var $5uXOq = parcelRequire("5uXOq");

var $dv0OY = parcelRequire("dv0OY");

var $5Gf1j = parcelRequire("5Gf1j");
const $2a5c6201d8713c67$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
const $2a5c6201d8713c67$var$currentValues = new WeakMap();
function $2a5c6201d8713c67$export$74665b213cb5c4cf(refs, defaultValue) {
    const callbackRef = (0, $5Gf1j.useCallbackRef)(defaultValue || null, (newValue)=>refs.forEach((ref)=>(0, $dv0OY.assignRef)(ref, newValue)));
    // handle refs changes - added or removed
    $2a5c6201d8713c67$var$useIsomorphicLayoutEffect(()=>{
        const oldValue = $2a5c6201d8713c67$var$currentValues.get(callbackRef);
        if (oldValue) {
            const prevRefs = new Set(oldValue);
            const nextRefs = new Set(refs);
            const current = callbackRef.current;
            prevRefs.forEach((ref)=>{
                if (!nextRefs.has(ref)) (0, $dv0OY.assignRef)(ref, null);
            });
            nextRefs.forEach((ref)=>{
                if (!prevRefs.has(ref)) (0, $dv0OY.assignRef)(ref, current);
            });
        }
        $2a5c6201d8713c67$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("dv0OY", function(module, exports) {

$parcel$export(module.exports, "assignRef", () => $9d3eceb3bd1bde87$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9d3eceb3bd1bde87$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("5Gf1j", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", () => $422c86adb7367c4f$export$25bec8c6f54ee79a);

var $5uXOq = parcelRequire("5uXOq");
function $422c86adb7367c4f$export$25bec8c6f54ee79a(initialValue, callback) {
    const [ref] = (0, $5uXOq.useState)(()=>({
            // value
            value: initialValue,
            callback: // last callback
            callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    const last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        }));
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("hs7HE", function(module, exports) {

$parcel$export(module.exports, "hiddenGuard", () => $cb4b06d97dec25c1$export$b8c7b07253306600);

var $5uXOq = parcelRequire("5uXOq");

var $cb4b06d97dec25c1$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $cb4b06d97dec25c1$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $5uXOq.createElement($5uXOq.Fragment, null, /*#__PURE__*/ $5uXOq.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $cb4b06d97dec25c1$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $5uXOq.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $cb4b06d97dec25c1$export$b8c7b07253306600
    }));
};
$cb4b06d97dec25c1$var$InFocusGuard.propTypes = {};
var $cb4b06d97dec25c1$export$2e2bcd8739ae039 = $cb4b06d97dec25c1$var$InFocusGuard;

});

parcelRegister("i2hbO", function(module, exports) {

$parcel$export(module.exports, "mediumFocus", () => $d215bf5dba6c52c4$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $d215bf5dba6c52c4$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $d215bf5dba6c52c4$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $d215bf5dba6c52c4$export$892cbf28e5518020);

var $bzFTo = parcelRequire("bzFTo");
var $d215bf5dba6c52c4$export$5733e022b1d538cb = (0, $bzFTo.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $d215bf5dba6c52c4$export$b3e9a9312f73723c = (0, $bzFTo.createMedium)();
var $d215bf5dba6c52c4$export$3a1d52767cbc07b8 = (0, $bzFTo.createMedium)();
var $d215bf5dba6c52c4$export$892cbf28e5518020 = (0, $bzFTo.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});
parcelRegister("bzFTo", function(module, exports) {

$parcel$export(module.exports, "createMedium", () => $86d3758a1af7e127$export$9ffbfcaf067b02c6);
$parcel$export(module.exports, "createSidecarMedium", () => $86d3758a1af7e127$export$e13ec7dd7a14088d);
function $86d3758a1af7e127$var$ItoI(a) {
    return a;
}
function $86d3758a1af7e127$var$innerCreateMedium(defaults, middleware = $86d3758a1af7e127$var$ItoI) {
    let buffer = [];
    let assigned = false;
    const medium = {
        read () {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium (data) {
            const item = middleware(data, assigned);
            buffer.push(item);
            return ()=>{
                buffer = buffer.filter((x)=>x !== item);
            };
        },
        assignSyncMedium (cb) {
            assigned = true;
            while(buffer.length){
                const cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: (x)=>cb(x),
                filter: ()=>buffer
            };
        },
        assignMedium (cb) {
            assigned = true;
            let pendingQueue = [];
            if (buffer.length) {
                const cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            const executeQueue = ()=>{
                const cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            const cycle = ()=>Promise.resolve().then(executeQueue);
            cycle();
            buffer = {
                push: (x)=>{
                    pendingQueue.push(x);
                    cycle();
                },
                filter: (filter)=>{
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $86d3758a1af7e127$export$9ffbfcaf067b02c6(defaults, middleware = $86d3758a1af7e127$var$ItoI) {
    return $86d3758a1af7e127$var$innerCreateMedium(defaults, middleware);
}
function $86d3758a1af7e127$export$e13ec7dd7a14088d(options = {}) {
    const medium = $86d3758a1af7e127$var$innerCreateMedium(null);
    medium.options = {
        async: true,
        ssr: false,
        ...options
    };
    return medium;
}

});


parcelRegister("lTS5V", function(module, exports) {

$parcel$export(module.exports, "focusScope", () => $ff18b21b414ba800$export$f5272e9b1168239c);

var $5uXOq = parcelRequire("5uXOq");
var $ff18b21b414ba800$export$f5272e9b1168239c = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});


parcelRegister("1jdvF", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f420b8ec0f9848e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $6mqio = parcelRequire("6mqio");

var $j4988 = parcelRequire("j4988");
var $2RQOj = parcelRequire("2RQOj");
var $1q0r0 = parcelRequire("1q0r0");
var $5x9g9 = parcelRequire("5x9g9");
var $jl7aa = parcelRequire("jl7aa");parcelRequire("cCk2L");
var $9wlSW = parcelRequire("9wlSW");

var $1mLS6 = parcelRequire("1mLS6");

var $i2hbO = parcelRequire("i2hbO");
var $0f420b8ec0f9848e$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $0f420b8ec0f9848e$var$isFreeFocus = function isFreeFocus() {
    return $0f420b8ec0f9848e$var$focusOnBody() || (0, $jl7aa.focusIsHidden)();
};
var $0f420b8ec0f9848e$var$lastActiveTrap = null;
var $0f420b8ec0f9848e$var$lastActiveFocus = null;
var $0f420b8ec0f9848e$var$lastPortaledElement = null;
var $0f420b8ec0f9848e$var$focusWasOutsideWindow = false;
var $0f420b8ec0f9848e$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $0f420b8ec0f9848e$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($0f420b8ec0f9848e$var$lastActiveTrap.whiteList || $0f420b8ec0f9848e$var$defaultWhitelist)(activeElement);
};
var $0f420b8ec0f9848e$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $0f420b8ec0f9848e$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $0f420b8ec0f9848e$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $0f420b8ec0f9848e$var$lastPortaledElement && $0f420b8ec0f9848e$var$lastPortaledElement.portaledElement === element;
};
function $0f420b8ec0f9848e$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $0f420b8ec0f9848e$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($0f420b8ec0f9848e$var$focusWasOutsideWindow);
    return $0f420b8ec0f9848e$var$focusWasOutsideWindow === 'meanwhile';
};
var $0f420b8ec0f9848e$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $0f420b8ec0f9848e$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $0f420b8ec0f9848e$var$checkInHost(activeElement, area, area);
    });
};
var $0f420b8ec0f9848e$var$activateTrap = function activateTrap() {
    var result = false;
    if ($0f420b8ec0f9848e$var$lastActiveTrap) {
        var _lastActiveTrap = $0f420b8ec0f9848e$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $0f420b8ec0f9848e$var$lastPortaledElement && $0f420b8ec0f9848e$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $1mLS6.extractRef)).filter(Boolean));
            if (!activeElement || $0f420b8ec0f9848e$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $0f420b8ec0f9848e$var$focusWasOutside(crossFrame) || !$0f420b8ec0f9848e$var$isFreeFocus() || !$0f420b8ec0f9848e$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $5x9g9.focusInside)(workingArea) || activeElement && $0f420b8ec0f9848e$var$withinHost(activeElement, workingArea) || $0f420b8ec0f9848e$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$0f420b8ec0f9848e$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $9wlSW.moveFocusInside)(workingArea, $0f420b8ec0f9848e$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $0f420b8ec0f9848e$var$lastPortaledElement = {};
                        }
                    }
                    $0f420b8ec0f9848e$var$focusWasOutsideWindow = false;
                    $0f420b8ec0f9848e$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $2RQOj.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $0f420b8ec0f9848e$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $0f420b8ec0f9848e$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $0f420b8ec0f9848e$var$onTrap = function onTrap(event) {
    if ($0f420b8ec0f9848e$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $0f420b8ec0f9848e$var$onBlur = function onBlur() {
    return (0, $1mLS6.deferAction)($0f420b8ec0f9848e$var$activateTrap);
};
var $0f420b8ec0f9848e$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $0f420b8ec0f9848e$var$recordPortal(currentNode, source);
};
var $0f420b8ec0f9848e$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $0f420b8ec0f9848e$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        onBlur: $0f420b8ec0f9848e$var$onBlur,
        onFocus: $0f420b8ec0f9848e$var$onFocus
    }, children);
};
$0f420b8ec0f9848e$var$FocusTrap.propTypes = {};
var $0f420b8ec0f9848e$var$onWindowBlur = function onWindowBlur() {
    $0f420b8ec0f9848e$var$focusWasOutsideWindow = 'just';
    (0, $1mLS6.deferAction)(function() {
        $0f420b8ec0f9848e$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $0f420b8ec0f9848e$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $0f420b8ec0f9848e$var$onTrap);
    document.addEventListener('focusout', $0f420b8ec0f9848e$var$onBlur);
    window.addEventListener('blur', $0f420b8ec0f9848e$var$onWindowBlur);
};
var $0f420b8ec0f9848e$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $0f420b8ec0f9848e$var$onTrap);
    document.removeEventListener('focusout', $0f420b8ec0f9848e$var$onBlur);
    window.removeEventListener('blur', $0f420b8ec0f9848e$var$onWindowBlur);
};
function $0f420b8ec0f9848e$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
var $0f420b8ec0f9848e$var$focusLockAPI = {
    moveFocusInside: (0, $9wlSW.moveFocusInside),
    focusInside: (0, $5x9g9.focusInside),
    focusNextElement: (0, $1q0r0.focusNextElement),
    focusPrevElement: (0, $1q0r0.focusPrevElement),
    focusFirstElement: (0, $1q0r0.focusFirstElement),
    focusLastElement: (0, $1q0r0.focusLastElement),
    captureFocusRestore: (0, $j4988.captureFocusRestore)
};
function $0f420b8ec0f9848e$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$0f420b8ec0f9848e$var$lastActiveTrap) $0f420b8ec0f9848e$var$attachHandler();
    var lastTrap = $0f420b8ec0f9848e$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $0f420b8ec0f9848e$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $0f420b8ec0f9848e$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($0f420b8ec0f9848e$var$focusLockAPI);
        $0f420b8ec0f9848e$var$activateTrap(true);
        (0, $1mLS6.deferAction)($0f420b8ec0f9848e$var$activateTrap);
    } else {
        $0f420b8ec0f9848e$var$detachHandler();
        $0f420b8ec0f9848e$var$lastActiveFocus = null;
    }
}
(0, $i2hbO.mediumFocus).assignSyncMedium($0f420b8ec0f9848e$var$onFocus);
(0, $i2hbO.mediumBlur).assignMedium($0f420b8ec0f9848e$var$onBlur);
(0, $i2hbO.mediumEffect).assignMedium(function(cb) {
    return cb($0f420b8ec0f9848e$var$focusLockAPI);
});
var $0f420b8ec0f9848e$export$2e2bcd8739ae039 = (0, $6mqio.default)($0f420b8ec0f9848e$var$reducePropsToState, $0f420b8ec0f9848e$var$handleStateChangeOnClient)($0f420b8ec0f9848e$var$FocusWatcher);

});
parcelRegister("6mqio", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a1931e6e98edb22$export$2e2bcd8739ae039);

var $2jS8g = parcelRequire("2jS8g");

var $eHiP8 = parcelRequire("eHiP8");

var $5uXOq = parcelRequire("5uXOq");
function $4a1931e6e98edb22$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $2jS8g.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $5uXOq.PureComponent));
        (0, $eHiP8.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $4a1931e6e98edb22$export$2e2bcd8739ae039 = $4a1931e6e98edb22$var$withSideEffect;

});
parcelRegister("eHiP8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab33aeddc06e5aed$export$2e2bcd8739ae039);

var $586Rz = parcelRequire("586Rz");
function $ab33aeddc06e5aed$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $586Rz.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("586Rz", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bc305fa7a392472$export$2e2bcd8739ae039);

var $eKtAb = parcelRequire("eKtAb");

var $kGKYI = parcelRequire("kGKYI");
function $3bc305fa7a392472$export$2e2bcd8739ae039(t) {
    var i = (0, $kGKYI.default)(t, "string");
    return "symbol" == (0, $eKtAb.default)(i) ? i : i + "";
}

});
parcelRegister("eKtAb", function(module, exports) {

$parcel$export(module.exports, "default", () => $abcc4f12e9e8c580$export$2e2bcd8739ae039);
function $abcc4f12e9e8c580$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $abcc4f12e9e8c580$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $abcc4f12e9e8c580$export$2e2bcd8739ae039(o);
}

});

parcelRegister("kGKYI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0fc2bce6211f5a4$export$2e2bcd8739ae039);

var $eKtAb = parcelRequire("eKtAb");
function $f0fc2bce6211f5a4$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $eKtAb.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $eKtAb.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("j4988", function(module, exports) {

$parcel$export(module.exports, "captureFocusRestore", () => $de15791afd27bb83$export$d357db6e554ff59a);

var $l1lpg = parcelRequire("l1lpg");
function $de15791afd27bb83$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $de15791afd27bb83$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $de15791afd27bb83$var$weakRef(currentElement),
            parent: $de15791afd27bb83$var$weakRef(currentElement.parentElement),
            left: $de15791afd27bb83$var$weakRef(currentElement.previousElementSibling),
            right: $de15791afd27bb83$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $de15791afd27bb83$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $de15791afd27bb83$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $l1lpg.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $de15791afd27bb83$export$d357db6e554ff59a = function(targetElement) {
    var location = $de15791afd27bb83$export$5061a7725be48ff9(targetElement);
    return function() {
        return $de15791afd27bb83$var$restoreFocusTo(location);
    };
};

});
parcelRegister("l1lpg", function(module, exports) {

$parcel$export(module.exports, "filterAutoFocusable", () => $03f3013918b31c29$export$2f70373d403a5d2b);
$parcel$export(module.exports, "getTabbableNodes", () => $03f3013918b31c29$export$3738e313571e2ad2);
$parcel$export(module.exports, "getFocusableNodes", () => $03f3013918b31c29$export$493d05a3a8e6532d);
$parcel$export(module.exports, "parentAutofocusables", () => $03f3013918b31c29$export$dc26309a71d1ce47);
$parcel$export(module.exports, "contains", () => $03f3013918b31c29$export$2344b14b097df817);

var $649lM = parcelRequire("649lM");

var $jlIIa = parcelRequire("jlIIa");

var $hPwd3 = parcelRequire("hPwd3");

var $detSP = parcelRequire("detSP");
var $03f3013918b31c29$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $649lM.toArray)(nodes).filter(function(node) {
        return (0, $jlIIa.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $jlIIa.notHiddenInput)(node);
    });
};
var $03f3013918b31c29$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $649lM.toArray)(nodes).filter(function(node) {
        return (0, $jlIIa.isAutoFocusAllowedCached)(cache, node);
    });
};
var $03f3013918b31c29$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $hPwd3.orderByTabIndex)($03f3013918b31c29$export$6266a5cd5915dc33((0, $detSP.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $03f3013918b31c29$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $hPwd3.orderByTabIndex)($03f3013918b31c29$export$6266a5cd5915dc33((0, $detSP.getFocusables)(topNodes), visibilityCache), false);
};
var $03f3013918b31c29$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $03f3013918b31c29$export$6266a5cd5915dc33((0, $detSP.getParentAutofocusables)(topNode), visibilityCache);
};
var $03f3013918b31c29$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $03f3013918b31c29$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $649lM.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $03f3013918b31c29$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $03f3013918b31c29$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("649lM", function(module, exports) {

$parcel$export(module.exports, "toArray", () => $46aa5e8f7fb698d8$export$45b10814cc054894);
$parcel$export(module.exports, "asArray", () => $46aa5e8f7fb698d8$export$75093a47a9fa838d);
$parcel$export(module.exports, "getFirst", () => $46aa5e8f7fb698d8$export$bcd7afcd904dce14);
/*
IE11 support
 */ var $46aa5e8f7fb698d8$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $46aa5e8f7fb698d8$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $46aa5e8f7fb698d8$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("jlIIa", function(module, exports) {

$parcel$export(module.exports, "isVisibleCached", () => $e162a936fc2d012a$export$3c9dc299685ad160);
$parcel$export(module.exports, "isAutoFocusAllowedCached", () => $e162a936fc2d012a$export$bcaa50628f6a736e);
$parcel$export(module.exports, "getDataset", () => $e162a936fc2d012a$export$698b339b0c8edae3);
$parcel$export(module.exports, "isRadioElement", () => $e162a936fc2d012a$export$9d74f6fbc6f469d0);
$parcel$export(module.exports, "notHiddenInput", () => $e162a936fc2d012a$export$8197b0ea56b3b055);
$parcel$export(module.exports, "isGuard", () => $e162a936fc2d012a$export$d94b8b58ec2f30eb);
$parcel$export(module.exports, "isNotAGuard", () => $e162a936fc2d012a$export$602e5a0d338d7750);
$parcel$export(module.exports, "isDefined", () => $e162a936fc2d012a$export$4e62c701997796c1);

var $26Cgu = parcelRequire("26Cgu");
var $e162a936fc2d012a$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $e162a936fc2d012a$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $e162a936fc2d012a$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $e162a936fc2d012a$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $e162a936fc2d012a$var$isVisibleUncached = function(node, checkParent) {
    return !node || $e162a936fc2d012a$var$isTopNode(node) || !$e162a936fc2d012a$var$isElementHidden(node) && !$e162a936fc2d012a$var$isInert(node) && checkParent($e162a936fc2d012a$var$getParentNode(node));
};
var $e162a936fc2d012a$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $e162a936fc2d012a$var$isVisibleUncached(node, $e162a936fc2d012a$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $e162a936fc2d012a$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$e162a936fc2d012a$var$isTopNode(node) ? $e162a936fc2d012a$export$b8550e27de209d85(node) ? checkParent($e162a936fc2d012a$var$getParentNode(node)) : false : true;
};
var $e162a936fc2d012a$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $e162a936fc2d012a$var$isAutoFocusAllowedUncached(node, $e162a936fc2d012a$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $e162a936fc2d012a$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $e162a936fc2d012a$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $e162a936fc2d012a$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $e162a936fc2d012a$export$9d74f6fbc6f469d0 = function(node) {
    return $e162a936fc2d012a$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $e162a936fc2d012a$export$8197b0ea56b3b055 = function(node) {
    return !(($e162a936fc2d012a$export$88a6ceeed5737ba3(node) || $e162a936fc2d012a$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $e162a936fc2d012a$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $26Cgu.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $e162a936fc2d012a$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $e162a936fc2d012a$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $e162a936fc2d012a$export$602e5a0d338d7750 = function(node) {
    return !$e162a936fc2d012a$export$d94b8b58ec2f30eb(node);
};
var $e162a936fc2d012a$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("hPwd3", function(module, exports) {

$parcel$export(module.exports, "orderByTabIndex", () => $cfb02f3dbbab37c3$export$cb40ee071f0d5226);

var $649lM = parcelRequire("649lM");
var $cfb02f3dbbab37c3$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $cfb02f3dbbab37c3$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $cfb02f3dbbab37c3$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $649lM.toArray)(nodes).map(function(node, index) {
        var tabIndex = $cfb02f3dbbab37c3$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($cfb02f3dbbab37c3$export$350ee6c095d98996);
};

});

parcelRegister("detSP", function(module, exports) {

$parcel$export(module.exports, "getFocusables", () => $9a23c35cb23add47$export$f6768025e418420e);
$parcel$export(module.exports, "getParentAutofocusables", () => $9a23c35cb23add47$export$853fa94d922e78b9);

var $26Cgu = parcelRequire("26Cgu");

var $649lM = parcelRequire("649lM");

var $h8JFa = parcelRequire("h8JFa");
var $9a23c35cb23add47$var$queryTabbables = (0, $h8JFa.tabbables).join(',');
var $9a23c35cb23add47$var$queryGuardTabbables = "".concat($9a23c35cb23add47$var$queryTabbables, ", [data-focus-guard]");
var $9a23c35cb23add47$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $649lM.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $9a23c35cb23add47$var$queryGuardTabbables : $9a23c35cb23add47$var$queryTabbables) ? [
            child
        ] : [], $9a23c35cb23add47$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $9a23c35cb23add47$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $9a23c35cb23add47$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $9a23c35cb23add47$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $9a23c35cb23add47$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $9a23c35cb23add47$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $649lM.toArray)(parent.parentNode.querySelectorAll($9a23c35cb23add47$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $9a23c35cb23add47$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $26Cgu.FOCUS_AUTO), "]"));
    return (0, $649lM.toArray)(parentFocus).map(function(node) {
        return $9a23c35cb23add47$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("h8JFa", function(module, exports) {

$parcel$export(module.exports, "tabbables", () => $c7a69abaf19a3f41$export$8555f4622e95784);
/**
 * list of the object to be considered as focusable
 */ var $c7a69abaf19a3f41$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});




parcelRegister("2RQOj", function(module, exports) {

$parcel$export(module.exports, "expandFocusableNodes", () => $21697f119bba8faa$export$f89ac71e91767111);

var $1kBVR = parcelRequire("1kBVR");

var $jlIIa = parcelRequire("jlIIa");

var $3jtrL = parcelRequire("3jtrL");

var $hPwd3 = parcelRequire("hPwd3");

var $detSP = parcelRequire("detSP");
var $21697f119bba8faa$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $1kBVR.getAllAffectedNodes)(topNode).filter((0, $jlIIa.isNotAGuard));
    var commonParent = (0, $3jtrL.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $hPwd3.orderByTabIndex)((0, $detSP.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $detSP.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $jlIIa.isGuard)(node)
        };
    });
};

});
parcelRegister("1kBVR", function(module, exports) {

$parcel$export(module.exports, "getAllAffectedNodes", () => $0f851546d68da0ab$export$7e87c4720b9b279b);

var $26Cgu = parcelRequire("26Cgu");

var $649lM = parcelRequire("649lM");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $0f851546d68da0ab$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $0f851546d68da0ab$var$getTopParent = function(node) {
    return node.parentNode ? $0f851546d68da0ab$var$getTopParent(node.parentNode) : node;
};
var $0f851546d68da0ab$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $649lM.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $26Cgu.FOCUS_GROUP));
        acc.push.apply(acc, group ? $0f851546d68da0ab$var$filterNested((0, $649lM.toArray)($0f851546d68da0ab$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $26Cgu.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $26Cgu.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("3jtrL", function(module, exports) {

$parcel$export(module.exports, "getTopCommonParent", () => $2699fcfa1a3b19bb$export$a9a7252b5f2e280e);
$parcel$export(module.exports, "allParentAutofocusables", () => $2699fcfa1a3b19bb$export$8f99714c70a37db1);

var $l1lpg = parcelRequire("l1lpg");

var $649lM = parcelRequire("649lM");
var $2699fcfa1a3b19bb$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $2699fcfa1a3b19bb$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $2699fcfa1a3b19bb$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $2699fcfa1a3b19bb$var$getParents(nodeA);
    var parentsB = $2699fcfa1a3b19bb$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $2699fcfa1a3b19bb$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $649lM.asArray)(baseActiveElement);
    var leftEntries = (0, $649lM.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $2699fcfa1a3b19bb$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $2699fcfa1a3b19bb$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $l1lpg.contains)(common, topCommon)) topCommon = common;
                else topCommon = $2699fcfa1a3b19bb$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $2699fcfa1a3b19bb$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $l1lpg.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("1q0r0", function(module, exports) {

$parcel$export(module.exports, "focusNextElement", () => $10888e6d50ae918b$export$3b0237e8566c8d65);
$parcel$export(module.exports, "focusPrevElement", () => $10888e6d50ae918b$export$33b47db07a82b2fb);
$parcel$export(module.exports, "focusFirstElement", () => $10888e6d50ae918b$export$2a791d8097a66406);
$parcel$export(module.exports, "focusLastElement", () => $10888e6d50ae918b$export$6a79073ddabfd6c3);

var $jfQb7 = parcelRequire("jfQb7");

var $l1lpg = parcelRequire("l1lpg");

var $649lM = parcelRequire("649lM");
var $10888e6d50ae918b$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $649lM.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $l1lpg.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $l1lpg.getTabbableNodes)(shards, new Map()) : (0, $l1lpg.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $10888e6d50ae918b$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $l1lpg.getTabbableNodes)((0, $649lM.asArray)(shards), new Map()) : (0, $l1lpg.getFocusableNodes)((0, $649lM.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $10888e6d50ae918b$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $10888e6d50ae918b$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $10888e6d50ae918b$var$defaultOptions(options);
    var solution = $10888e6d50ae918b$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $jfQb7.focusOn)(target.node, newOptions.focusOptions);
};
var $10888e6d50ae918b$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $10888e6d50ae918b$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $10888e6d50ae918b$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $10888e6d50ae918b$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $10888e6d50ae918b$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $10888e6d50ae918b$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $jfQb7.focusOn)(node.node, options.focusOptions);
};
var $10888e6d50ae918b$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $10888e6d50ae918b$var$pickBoundary(scope, options, 'first');
};
var $10888e6d50ae918b$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $10888e6d50ae918b$var$pickBoundary(scope, options, 'last');
};

});
parcelRegister("jfQb7", function(module, exports) {

$parcel$export(module.exports, "focusOn", () => $e047e48fcca0b3b0$export$c12b3da842c43a8);
var $e047e48fcca0b3b0$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("5x9g9", function(module, exports) {

$parcel$export(module.exports, "focusInside", () => $4077379349d4c74a$export$20115f8da7baa6fa);

var $l1lpg = parcelRequire("l1lpg");

var $1kBVR = parcelRequire("1kBVR");

var $649lM = parcelRequire("649lM");

var $33cOt = parcelRequire("33cOt");
var $4077379349d4c74a$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $4077379349d4c74a$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $649lM.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $4077379349d4c74a$var$focusInFrame(node, activeElement);
    }));
};
var $4077379349d4c74a$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $33cOt.getActiveElement)((0, $649lM.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $1kBVR.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $l1lpg.contains)(node, activeElement) || $4077379349d4c74a$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("33cOt", function(module, exports) {

$parcel$export(module.exports, "getActiveElement", () => $238b9756ed43b48b$export$cd4e5573fbe2b576);
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $513Q1 = parcelRequire("513Q1");
var $238b9756ed43b48b$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $238b9756ed43b48b$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $513Q1.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $238b9756ed43b48b$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("513Q1", function(module, exports) {

$parcel$export(module.exports, "safeProbe", () => $3a7005e711f25367$export$78d20aae35adef88);
var $3a7005e711f25367$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("jl7aa", function(module, exports) {

$parcel$export(module.exports, "focusIsHidden", () => $e14588ebb2dd3a92$export$be6b21806d3fd485);

var $26Cgu = parcelRequire("26Cgu");

var $l1lpg = parcelRequire("l1lpg");

var $649lM = parcelRequire("649lM");

var $33cOt = parcelRequire("33cOt");
var $e14588ebb2dd3a92$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $33cOt.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $649lM.toArray)(inDocument.querySelectorAll("[".concat((0, $26Cgu.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $l1lpg.contains)(node, activeElement);
    });
};

});

parcelRegister("cCk2L", function(module, exports) {

$parcel$export(module.exports, "moveFocusInside", () => (parcelRequire("9wlSW")).moveFocusInside);

var $26Cgu = parcelRequire("26Cgu");

var $5x9g9 = parcelRequire("5x9g9");

var $jl7aa = parcelRequire("jl7aa");


var $2RQOj = parcelRequire("2RQOj");

var $9wlSW = parcelRequire("9wlSW");

var $j4988 = parcelRequire("j4988");

var $1q0r0 = parcelRequire("1q0r0");

var $l1lpg = parcelRequire("l1lpg");
/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $92f894e236277f1c$export$1a988e7317c65621 = $26Cgu;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $92f894e236277f1c$var$deprecated_default_moveFocusInside = (0, $9wlSW.moveFocusInside);
var $92f894e236277f1c$export$2e2bcd8739ae039 //
 = $92f894e236277f1c$var$deprecated_default_moveFocusInside;

});
parcelRegister("9wlSW", function(module, exports) {

$parcel$export(module.exports, "moveFocusInside", () => $6ee8142619db9ef1$export$cd599851e879a025);

var $jfQb7 = parcelRequire("jfQb7");

var $kKJqK = parcelRequire("kKJqK");
var $6ee8142619db9ef1$var$guardCount = 0;
var $6ee8142619db9ef1$var$lockDisabled = false;
var $6ee8142619db9ef1$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $kKJqK.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($6ee8142619db9ef1$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($6ee8142619db9ef1$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $6ee8142619db9ef1$var$lockDisabled = true;
            setTimeout(function() {
                $6ee8142619db9ef1$var$lockDisabled = false;
            }, 1);
            return;
        }
        $6ee8142619db9ef1$var$guardCount++;
        (0, $jfQb7.focusOn)(focusable.node, options.focusOptions);
        $6ee8142619db9ef1$var$guardCount--;
    }
};

});
parcelRegister("kKJqK", function(module, exports) {

$parcel$export(module.exports, "focusSolver", () => $f1bb580dea56dbbd$export$305758c744b57f6f);

var $6e7nq = parcelRequire("6e7nq");

var $l1lpg = parcelRequire("l1lpg");

var $1kBVR = parcelRequire("1kBVR");

var $649lM = parcelRequire("649lM");

var $6QUqp = parcelRequire("6QUqp");

var $33cOt = parcelRequire("33cOt");

var $jlIIa = parcelRequire("jlIIa");

var $3jtrL = parcelRequire("3jtrL");
var $f1bb580dea56dbbd$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $jlIIa.isDefined));
};
var $f1bb580dea56dbbd$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $33cOt.getActiveElement)((0, $649lM.asArray)(topNode).length > 0 ? document : (0, $649lM.getFirst)(topNode).ownerDocument);
    var entries = (0, $1kBVR.getAllAffectedNodes)(topNode).filter((0, $jlIIa.isNotAGuard));
    var commonParent = (0, $3jtrL.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $l1lpg.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $jlIIa.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $l1lpg.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $f1bb580dea56dbbd$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $6e7nq.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $6e7nq.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $6QUqp.pickAutofocus)(anyFocusable, innerTabbable, (0, $3jtrL.allParentAutofocusables)(entries, visibilityCache)) || (0, $6QUqp.pickAutofocus)(anyFocusable, innerFocusables, (0, $3jtrL.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("6e7nq", function(module, exports) {

$parcel$export(module.exports, "NEW_FOCUS", () => $4889c5c91be25c0a$export$85710b12cf912438);
$parcel$export(module.exports, "newFocus", () => $4889c5c91be25c0a$export$65842178e9bb4205);

var $2aoIt = parcelRequire("2aoIt");

var $ee0vg = parcelRequire("ee0vg");

var $jlIIa = parcelRequire("jlIIa");
var $4889c5c91be25c0a$export$85710b12cf912438 = 'NEW_FOCUS';
var $4889c5c91be25c0a$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $jlIIa.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $4889c5c91be25c0a$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $4889c5c91be25c0a$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $2aoIt.correctNodes)(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $ee0vg.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $ee0vg.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("2aoIt", function(module, exports) {

$parcel$export(module.exports, "correctNode", () => $193fb011be33b1b6$export$5261662167ad7ced);
$parcel$export(module.exports, "correctNodes", () => $193fb011be33b1b6$export$4a5a72a7124e45f9);

var $jlIIa = parcelRequire("jlIIa");
var $193fb011be33b1b6$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $jlIIa.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $193fb011be33b1b6$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $jlIIa.isRadioElement)(node) && node.name) return $193fb011be33b1b6$var$findSelectedRadio(node, nodes);
    return node;
};
var $193fb011be33b1b6$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($193fb011be33b1b6$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("ee0vg", function(module, exports) {

$parcel$export(module.exports, "pickFirstFocus", () => $a5b2c367f9c3daa0$export$f4e86cfa0679b9cc);
$parcel$export(module.exports, "pickFocusable", () => $a5b2c367f9c3daa0$export$e06728ee87c96122);

var $2aoIt = parcelRequire("2aoIt");
var $a5b2c367f9c3daa0$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $2aoIt.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $a5b2c367f9c3daa0$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $2aoIt.correctNode)(node, nodes));
};

});


parcelRegister("6QUqp", function(module, exports) {

$parcel$export(module.exports, "pickAutofocus", () => $4fd35e3fd3ef884c$export$cfb742983e257555);

var $l1lpg = parcelRequire("l1lpg");

var $ee0vg = parcelRequire("ee0vg");

var $jlIIa = parcelRequire("jlIIa");
var $4fd35e3fd3ef884c$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $jlIIa.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $4fd35e3fd3ef884c$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $l1lpg.filterAutoFocusable)(nodes.filter($4fd35e3fd3ef884c$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $ee0vg.pickFirstFocus)(autoFocusable);
    return (0, $ee0vg.pickFirstFocus)((0, $l1lpg.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("1mLS6", function(module, exports) {

$parcel$export(module.exports, "deferAction", () => $0fecfad02351d8b0$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $0fecfad02351d8b0$export$c613fed06e332533);
function $0fecfad02351d8b0$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $0fecfad02351d8b0$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $0fecfad02351d8b0$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("cwc7f", function(module, exports) {

$parcel$export(module.exports, "default", () => $91d1df2d50ef438b$export$2e2bcd8739ae039);

var $iK0nX = parcelRequire("iK0nX");






var $91d1df2d50ef438b$export$2e2bcd8739ae039 = (0, $iK0nX.default);

});

parcelRegister("2alJM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dejU7 = parcelRequire("dejU7");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $193d608c8a4c8c43$var$_interopRequireDefault($dejU7).default;
    }
});

var $fUXdf = parcelRequire("fUXdf");
Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $fUXdf.TouchScrollable;
    }
});
function $193d608c8a4c8c43$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("dejU7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9a1c05b159231ce4$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5uXOq = parcelRequire("5uXOq");
var $9a1c05b159231ce4$var$_react2 = $9a1c05b159231ce4$var$_interopRequireDefault($5uXOq);

var $lv4Ny = parcelRequire("lv4Ny");

var $fUXdf = parcelRequire("fUXdf");

var $bdRWg = parcelRequire("bdRWg");
var $9a1c05b159231ce4$var$_withLockSheet2 = $9a1c05b159231ce4$var$_interopRequireDefault($bdRWg);

var $fjsmD = parcelRequire("fjsmD");
var $9a1c05b159231ce4$var$_withTouchListeners2 = $9a1c05b159231ce4$var$_interopRequireDefault($fjsmD);

var $1sALq = parcelRequire("1sALq");
function $9a1c05b159231ce4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9a1c05b159231ce4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9a1c05b159231ce4$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9a1c05b159231ce4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $9a1c05b159231ce4$var$ScrollLock = function(_PureComponent) {
    $9a1c05b159231ce4$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $9a1c05b159231ce4$var$_classCallCheck(this, ScrollLock);
        return $9a1c05b159231ce4$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $9a1c05b159231ce4$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$lv4Ny.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $9a1c05b159231ce4$var$_react2.default.createElement($fUXdf.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($5uXOq.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $9a1c05b159231ce4$var$compose = (0, $1sALq.pipe)($9a1c05b159231ce4$var$_withTouchListeners2.default, $9a1c05b159231ce4$var$_withLockSheet2.default);
var $9a1c05b159231ce4$var$SheetLock = $9a1c05b159231ce4$var$compose($9a1c05b159231ce4$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $9a1c05b159231ce4$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $9a1c05b159231ce4$var$_react2.default.createElement($9a1c05b159231ce4$var$SheetLock, props) : props.children;
};
$9a1c05b159231ce4$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $9a1c05b159231ce4$var$LockToggle;

});
parcelRegister("lv4Ny", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("fUXdf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $b96a046705879057$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $b96a046705879057$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5uXOq = parcelRequire("5uXOq");

var $lv4Ny = parcelRequire("lv4Ny");

var $1sALq = parcelRequire("1sALq");
function $b96a046705879057$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $b96a046705879057$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b96a046705879057$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b96a046705879057$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $b96a046705879057$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $b96a046705879057$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $b96a046705879057$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $b96a046705879057$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $b96a046705879057$var$_possibleConstructorReturn(_this, _ret);
    }
    $b96a046705879057$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$lv4Ny.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $1sALq.preventInertiaScroll, $1sALq.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $1sALq.allowTouchMove, $1sALq.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$lv4Ny.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $1sALq.preventInertiaScroll, $1sALq.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $1sALq.allowTouchMove, $1sALq.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $b96a046705879057$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $5uXOq.cloneElement)(children, $b96a046705879057$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($5uXOq.PureComponent);

});
parcelRegister("1sALq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $1104ec85449a533c$var$preventTouchMove;
module.exports.allowTouchMove = $1104ec85449a533c$var$allowTouchMove;
module.exports.preventInertiaScroll = $1104ec85449a533c$var$preventInertiaScroll;
module.exports.isTouchDevice = $1104ec85449a533c$var$isTouchDevice;
module.exports.camelToKebab = $1104ec85449a533c$var$camelToKebab;
module.exports.parse = $1104ec85449a533c$var$parse;
module.exports.getPadding = $1104ec85449a533c$var$getPadding;
module.exports.getWindowHeight = $1104ec85449a533c$var$getWindowHeight;
module.exports.getDocumentHeight = $1104ec85449a533c$var$getDocumentHeight;
module.exports.makeStyleTag = $1104ec85449a533c$var$makeStyleTag;
module.exports.injectStyles = $1104ec85449a533c$var$injectStyles;
module.exports.insertStyleTag = $1104ec85449a533c$var$insertStyleTag;

var $lv4Ny = parcelRequire("lv4Ny");
var $1104ec85449a533c$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $1104ec85449a533c$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $1104ec85449a533c$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $1104ec85449a533c$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $1104ec85449a533c$var$isTouchDevice() {
    if (!$lv4Ny.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $1104ec85449a533c$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $1104ec85449a533c$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $1104ec85449a533c$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $1104ec85449a533c$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($1104ec85449a533c$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $1104ec85449a533c$var$getPadding() {
    if (!$lv4Ny.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $1104ec85449a533c$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($lv4Ny.canUseDOM) return window.innerHeight * multiplier;
}
function $1104ec85449a533c$var$getDocumentHeight() {
    if ($lv4Ny.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $1104ec85449a533c$var$makeStyleTag() {
    if (!$lv4Ny.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $1104ec85449a533c$var$injectStyles(tag, css) {
    if (!$lv4Ny.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $1104ec85449a533c$var$insertStyleTag(tag) {
    if (!$lv4Ny.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});


parcelRegister("bdRWg", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $82babfbe1d9118db$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $82babfbe1d9118db$var$withLockSheet;

var $5uXOq = parcelRequire("5uXOq");
var $82babfbe1d9118db$var$_react2 = $82babfbe1d9118db$var$_interopRequireDefault($5uXOq);

var $1sALq = parcelRequire("1sALq");
function $82babfbe1d9118db$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $82babfbe1d9118db$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $82babfbe1d9118db$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $82babfbe1d9118db$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $82babfbe1d9118db$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $82babfbe1d9118db$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $82babfbe1d9118db$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $82babfbe1d9118db$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $1sALq.makeStyleTag)();
                if (!sheet) return;
                (0, $1sALq.injectStyles)(sheet, styles);
                (0, $1sALq.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $1sALq.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $1sALq.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $82babfbe1d9118db$var$_possibleConstructorReturn(_this, _ret);
        }
        $82babfbe1d9118db$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $82babfbe1d9118db$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($5uXOq.PureComponent);
}

});

parcelRegister("fjsmD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b25ea1e2c8dc8373$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $b25ea1e2c8dc8373$var$withTouchListeners;

var $5uXOq = parcelRequire("5uXOq");
var $b25ea1e2c8dc8373$var$_react2 = $b25ea1e2c8dc8373$var$_interopRequireDefault($5uXOq);

var $lv4Ny = parcelRequire("lv4Ny");

var $1sALq = parcelRequire("1sALq");
function $b25ea1e2c8dc8373$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b25ea1e2c8dc8373$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b25ea1e2c8dc8373$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b25ea1e2c8dc8373$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $b25ea1e2c8dc8373$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $b25ea1e2c8dc8373$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $b25ea1e2c8dc8373$var$_classCallCheck(this, TouchProvider);
            return $b25ea1e2c8dc8373$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $b25ea1e2c8dc8373$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$lv4Ny.canUseDOM || !(0, $1sALq.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $1sALq.preventTouchMove, $1sALq.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$lv4Ny.canUseDOM || !(0, $1sALq.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $1sALq.preventTouchMove, $1sALq.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $b25ea1e2c8dc8373$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($5uXOq.PureComponent);
}

});



parcelRegister("61IPU", function(module, exports) {

$parcel$export(module.exports, "monitorForExternal", () => (parcelRequire("iPCNN")).monitorForExternal);
$parcel$export(module.exports, "dropTargetForExternal", () => (parcelRequire("iPCNN")).dropTargetForExternal);

var $iPCNN = parcelRequire("iPCNN");

});
parcelRegister("iPCNN", function(module, exports) {

$parcel$export(module.exports, "dropTargetForExternal", () => $f377df4064e10188$export$9edc779df9a85289);
$parcel$export(module.exports, "monitorForExternal", () => $f377df4064e10188$export$bb1740f3194979c1);

var $cBeZP = parcelRequire("cBeZP");

var $iiVLC = parcelRequire("iiVLC");

var $6XFIM = parcelRequire("6XFIM");

var $e2Xjq = parcelRequire("e2Xjq");

var $h5V4I = parcelRequire("h5V4I");


function $f377df4064e10188$export$a8e56a860d7957c7({ type: type, value: value }) {
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $dad94f2a683170ce$export$c9c4cc54e73b125d)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $511ea0f8ed5a789e$export$fd3d00026297c0ad) && value === (0, $6XFIM.androidFallbackText)) return false;
    return true;
}
function $f377df4064e10188$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter((type)=>$f377df4064e10188$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        }));
}
function $f377df4064e10188$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter((item)=>item.kind === 'file' || $f377df4064e10188$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        }));
}
let $f377df4064e10188$var$didDragStartLocally = false;
const $f377df4064e10188$var$adapter = (0, $iiVLC.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $cBeZP.bind)(window, {
            type: 'dragenter',
            listener (event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($f377df4064e10188$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $e2Xjq.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                const types = $f377df4064e10188$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                const locked = {
                    types: types,
                    items: [],
                    getStringData: ()=>null
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload (event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            const items = $f377df4064e10188$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            const nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData (mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    const value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$f377df4064e10188$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $f377df4064e10188$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $f377df4064e10188$var$adapter.dropTarget(args);
}
function $f377df4064e10188$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $f377df4064e10188$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $f377df4064e10188$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    const idle = {
        type: 'idle'
    };
    let state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $f377df4064e10188$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $cBeZP.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            },
            ...(0, $h5V4I.getBindingsForBrokenDrags)({
                onDragEnd: clear
            })
        ], // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $cBeZP.bind)(window, {
        type: 'dragstart',
        listener () {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $f377df4064e10188$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})();

});
parcelRegister("e2Xjq", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindow", () => $ad99df0f18a6cc64$export$d1c6f249e893cdf4);

var $bYN8w = parcelRequire("bYN8w");

var $6aABs = parcelRequire("6aABs");

var $apnEk = parcelRequire("apnEk");

var $9Mj6M = parcelRequire("9Mj6M");
function $ad99df0f18a6cc64$export$d1c6f249e893cdf4({ dragEnter: dragEnter }) {
    const { type: type, relatedTarget: relatedTarget } = dragEnter;
    if (type !== 'dragenter') return false;
    if ((0, $6aABs.isSafari)()) return (0, $apnEk.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
	 * 🦊 Exception: `iframe` in Firefox (`125.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 * (foreign element)
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is an element inside the child `iframe`
	 * (foreign element)
	 */ if ((0, $bYN8w.isFirefox)()) return (0, $9Mj6M.isFromAnotherWindow)(relatedTarget);
    /**
	 * 🌏 Exception: `iframe` in Chrome (`124.0`)
	 *
	 * Case 1: parent `window` → child `iframe`
	 * `relatedTarget` is `null` *(standard check)*
	 *
	 * Case 2: child `iframe` → parent `window`
	 * `relatedTarget` is the `iframe` element in the parent `window`
	 */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});



parcelRegister("dOXu7", function(module, exports) {

$parcel$export(module.exports, "monitorForTextSelection", () => (parcelRequire("eU6JV")).monitorForTextSelection);

var $eU6JV = parcelRequire("eU6JV");

});
parcelRegister("eU6JV", function(module, exports) {

$parcel$export(module.exports, "monitorForTextSelection", () => $6ec1b195aeff981f$export$2e178e3647f5e6e9);

var $cBeZP = parcelRequire("cBeZP");

var $8d5CE = parcelRequire("8d5CE");

var $iiVLC = parcelRequire("iiVLC");

var $3zl3q = parcelRequire("3zl3q");

var $6aABs = parcelRequire("6aABs");



function $6ec1b195aeff981f$var$findTextNode(event) {
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $6aABs.isSafari)()) return null;
    /**
	 * According to the spec, `event.target` should be the `Text` node that
	 * the drag started from when dragging a text selection.
	 *
	 * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
	 *
	 * However, in Safari the closest `HTMLElement` is returned.
	 * So we need to figure out if text is dragging ourselves.
	 *
	 * → https://bugs.webkit.org/show_bug.cgi?id=268959
	 */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!event.dataTransfer?.getData((0, $511ea0f8ed5a789e$export$fd3d00026297c0ad))) return null;
    /**
	 * Grab the first Text node and use that.
	 * Only doing a single level search as that is all we need for this bug.
	 */ const text = Array.from(event.target.childNodes).find((node)=>node.nodeType === Node.TEXT_NODE);
    return text ?? null;
}
const $6ec1b195aeff981f$var$honeyPotFix = (0, $8d5CE.makeHoneyPotFix)();
const $6ec1b195aeff981f$var$adapter = (0, $iiVLC.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $3zl3q.combine)($6ec1b195aeff981f$var$honeyPotFix.bindEvents(), (0, $cBeZP.bind)(window, {
            type: 'dragstart',
            listener (event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $dad94f2a683170ce$export$c9c4cc54e73b125d))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $511ea0f8ed5a789e$export$fd3d00026297c0ad))) return;
                const target = $6ec1b195aeff981f$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                const payload = {
                    target: // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target,
                    plain: event.dataTransfer.getData((0, $511ea0f8ed5a789e$export$fd3d00026297c0ad)),
                    HTML: event.dataTransfer.getData((0, $832d2a5d5849f305$export$338a9f6c7a1f02b0))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $6ec1b195aeff981f$var$honeyPotFix.getOnPostDispatch()
});
function $6ec1b195aeff981f$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $6ec1b195aeff981f$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $6ec1b195aeff981f$var$adapter.registerUsage();
})();
function $6ec1b195aeff981f$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $6ec1b195aeff981f$var$adapter.monitor(args);
}

});
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $832d2a5d5849f305$export$338a9f6c7a1f02b0 = 'text/html';



parcelRegister("fGOj2", function(module, exports) {

var $ku1fk = parcelRequire("ku1fk");
var $b6c1ccfb8fc1be45$var$listeningFocusTrap = null;
function $b6c1ccfb8fc1be45$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $b6c1ccfb8fc1be45$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($b6c1ccfb8fc1be45$var$listeningFocusTrap) $b6c1ccfb8fc1be45$var$listeningFocusTrap.pause();
        $b6c1ccfb8fc1be45$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $b6c1ccfb8fc1be45$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $b6c1ccfb8fc1be45$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $b6c1ccfb8fc1be45$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $b6c1ccfb8fc1be45$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $b6c1ccfb8fc1be45$var$tryFocus(lastTabbableNode);
            return $b6c1ccfb8fc1be45$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $b6c1ccfb8fc1be45$var$tryFocus(firstTabbableNode);
        $b6c1ccfb8fc1be45$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $ku1fk(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $b6c1ccfb8fc1be45$var$tryFocus(lastTabbableNode);
        $b6c1ccfb8fc1be45$var$tryFocus(firstTabbableNode);
    }
}
function $b6c1ccfb8fc1be45$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $b6c1ccfb8fc1be45$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $b6c1ccfb8fc1be45$var$focusTrap;

});
parcelRegister("ku1fk", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $ee97937178da774c$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $ee97937178da774c$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});


parcelRegister("k9tnV", function(module, exports) {

$parcel$export(module.exports, "default", () => $eabb711d482d792e$export$2e2bcd8739ae039);

var $5pMPR = parcelRequire("5pMPR");
function $eabb711d482d792e$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $eabb711d482d792e$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = 'auto';
    var canSmoothScroll = 'scrollBehavior' in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $eabb711d482d792e$var$getOptions(options) {
    if (options === false) return {
        block: 'end',
        inline: 'nearest'
    };
    if ($eabb711d482d792e$var$isOptionsObject(options)) return options;
    return {
        block: 'start',
        inline: 'nearest'
    };
}
function $eabb711d482d792e$var$scrollIntoView(target, options) {
    var targetIsDetached = !target.ownerDocument.documentElement.contains(target);
    if ($eabb711d482d792e$var$isOptionsObject(options) && typeof options.behavior === 'function') return options.behavior(targetIsDetached ? [] : (0, $5pMPR.default)(target, options));
    if (targetIsDetached) return;
    var computeOptions = $eabb711d482d792e$var$getOptions(options);
    return $eabb711d482d792e$var$defaultBehavior((0, $5pMPR.default)(target, computeOptions), computeOptions.behavior);
}
var $eabb711d482d792e$export$2e2bcd8739ae039 = $eabb711d482d792e$var$scrollIntoView;

});
parcelRegister("5pMPR", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f152b3d7b173718$export$2e2bcd8739ae039);
function $3f152b3d7b173718$var$isElement(el) {
    return el != null && typeof el === 'object' && el.nodeType === 1;
}
function $3f152b3d7b173718$var$canOverflow(overflow, skipOverflowHiddenElements) {
    if (skipOverflowHiddenElements && overflow === 'hidden') return false;
    return overflow !== 'visible' && overflow !== 'clip';
}
function $3f152b3d7b173718$var$getFrameElement(el) {
    if (!el.ownerDocument || !el.ownerDocument.defaultView) return null;
    return el.ownerDocument.defaultView.frameElement;
}
function $3f152b3d7b173718$var$isHiddenByFrame(el) {
    var frame = $3f152b3d7b173718$var$getFrameElement(el);
    if (!frame) return false;
    return frame.clientHeight < el.scrollHeight || frame.clientWidth < el.scrollWidth;
}
function $3f152b3d7b173718$var$isScrollable(el, skipOverflowHiddenElements) {
    if (el.clientHeight < el.scrollHeight || el.clientWidth < el.scrollWidth) {
        var style = getComputedStyle(el, null);
        return $3f152b3d7b173718$var$canOverflow(style.overflowY, skipOverflowHiddenElements) || $3f152b3d7b173718$var$canOverflow(style.overflowX, skipOverflowHiddenElements) || $3f152b3d7b173718$var$isHiddenByFrame(el);
    }
    return false;
}
function $3f152b3d7b173718$var$alignNearest(scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, scrollingBorderStart, scrollingBorderEnd, elementEdgeStart, elementEdgeEnd, elementSize) {
    if (elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd || elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd) return 0;
    if (elementEdgeStart <= scrollingEdgeStart && elementSize <= scrollingSize || elementEdgeEnd >= scrollingEdgeEnd && elementSize >= scrollingSize) return elementEdgeStart - scrollingEdgeStart - scrollingBorderStart;
    if (elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize || elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize) return elementEdgeEnd - scrollingEdgeEnd + scrollingBorderEnd;
    return 0;
}
var $3f152b3d7b173718$export$2e2bcd8739ae039 = function(target, options) {
    var scrollMode = options.scrollMode, block = options.block, inline = options.inline, boundary = options.boundary, skipOverflowHiddenElements = options.skipOverflowHiddenElements;
    var checkBoundary = typeof boundary === 'function' ? boundary : function(node) {
        return node !== boundary;
    };
    if (!$3f152b3d7b173718$var$isElement(target)) throw new TypeError('Invalid target');
    var scrollingElement = document.scrollingElement || document.documentElement;
    var frames = [];
    var cursor = target;
    while($3f152b3d7b173718$var$isElement(cursor) && checkBoundary(cursor)){
        cursor = cursor.parentNode;
        if (cursor === scrollingElement) {
            frames.push(cursor);
            break;
        }
        if (cursor === document.body && $3f152b3d7b173718$var$isScrollable(cursor) && !$3f152b3d7b173718$var$isScrollable(document.documentElement)) continue;
        if ($3f152b3d7b173718$var$isScrollable(cursor, skipOverflowHiddenElements)) frames.push(cursor);
    }
    var viewportWidth = window.visualViewport ? visualViewport.width : innerWidth;
    var viewportHeight = window.visualViewport ? visualViewport.height : innerHeight;
    var viewportX = window.scrollX || pageXOffset;
    var viewportY = window.scrollY || pageYOffset;
    var _target$getBoundingCl = target.getBoundingClientRect(), targetHeight = _target$getBoundingCl.height, targetWidth = _target$getBoundingCl.width, targetTop = _target$getBoundingCl.top, targetRight = _target$getBoundingCl.right, targetBottom = _target$getBoundingCl.bottom, targetLeft = _target$getBoundingCl.left;
    var targetBlock = block === 'start' || block === 'nearest' ? targetTop : block === 'end' ? targetBottom : targetTop + targetHeight / 2;
    var targetInline = inline === 'center' ? targetLeft + targetWidth / 2 : inline === 'end' ? targetRight : targetLeft;
    var computations = [];
    for(var index = 0; index < frames.length; index++){
        var frame = frames[index];
        var _frame$getBoundingCli = frame.getBoundingClientRect(), height = _frame$getBoundingCli.height, width = _frame$getBoundingCli.width, top = _frame$getBoundingCli.top, right = _frame$getBoundingCli.right, bottom = _frame$getBoundingCli.bottom, left = _frame$getBoundingCli.left;
        if (scrollMode === 'if-needed' && targetTop >= 0 && targetLeft >= 0 && targetBottom <= viewportHeight && targetRight <= viewportWidth && targetTop >= top && targetBottom <= bottom && targetLeft >= left && targetRight <= right) return computations;
        var frameStyle = getComputedStyle(frame);
        var borderLeft = parseInt(frameStyle.borderLeftWidth, 10);
        var borderTop = parseInt(frameStyle.borderTopWidth, 10);
        var borderRight = parseInt(frameStyle.borderRightWidth, 10);
        var borderBottom = parseInt(frameStyle.borderBottomWidth, 10);
        var blockScroll = 0;
        var inlineScroll = 0;
        var scrollbarWidth = 'offsetWidth' in frame ? frame.offsetWidth - frame.clientWidth - borderLeft - borderRight : 0;
        var scrollbarHeight = 'offsetHeight' in frame ? frame.offsetHeight - frame.clientHeight - borderTop - borderBottom : 0;
        if (scrollingElement === frame) {
            if (block === 'start') blockScroll = targetBlock;
            else if (block === 'end') blockScroll = targetBlock - viewportHeight;
            else if (block === 'nearest') blockScroll = $3f152b3d7b173718$var$alignNearest(viewportY, viewportY + viewportHeight, viewportHeight, borderTop, borderBottom, viewportY + targetBlock, viewportY + targetBlock + targetHeight, targetHeight);
            else blockScroll = targetBlock - viewportHeight / 2;
            if (inline === 'start') inlineScroll = targetInline;
            else if (inline === 'center') inlineScroll = targetInline - viewportWidth / 2;
            else if (inline === 'end') inlineScroll = targetInline - viewportWidth;
            else inlineScroll = $3f152b3d7b173718$var$alignNearest(viewportX, viewportX + viewportWidth, viewportWidth, borderLeft, borderRight, viewportX + targetInline, viewportX + targetInline + targetWidth, targetWidth);
            blockScroll = Math.max(0, blockScroll + viewportY);
            inlineScroll = Math.max(0, inlineScroll + viewportX);
        } else {
            if (block === 'start') blockScroll = targetBlock - top - borderTop;
            else if (block === 'end') blockScroll = targetBlock - bottom + borderBottom + scrollbarHeight;
            else if (block === 'nearest') blockScroll = $3f152b3d7b173718$var$alignNearest(top, bottom, height, borderTop, borderBottom + scrollbarHeight, targetBlock, targetBlock + targetHeight, targetHeight);
            else blockScroll = targetBlock - (top + height / 2) + scrollbarHeight / 2;
            if (inline === 'start') inlineScroll = targetInline - left - borderLeft;
            else if (inline === 'center') inlineScroll = targetInline - (left + width / 2) + scrollbarWidth / 2;
            else if (inline === 'end') inlineScroll = targetInline - right + borderRight + scrollbarWidth;
            else inlineScroll = $3f152b3d7b173718$var$alignNearest(left, right, width, borderLeft, borderRight + scrollbarWidth, targetInline, targetInline + targetWidth, targetWidth);
            var scrollLeft = frame.scrollLeft, scrollTop = frame.scrollTop;
            blockScroll = Math.max(0, Math.min(scrollTop + blockScroll, frame.scrollHeight - height + scrollbarHeight));
            inlineScroll = Math.max(0, Math.min(scrollLeft + inlineScroll, frame.scrollWidth - width + scrollbarWidth));
            targetBlock += scrollTop - blockScroll;
            targetInline += scrollLeft - inlineScroll;
        }
        computations.push({
            el: frame,
            top: blockScroll,
            left: inlineScroll
        });
    }
    return computations;
};

});


parcelRegister("8r6xd", function(module, exports) {

$parcel$export(module.exports, "PendoChoreographerPlugin", () => $53b1d602a69e9a6f$export$3390a677f4025523);

var $TTRxY = parcelRequire("TTRxY");

var $4YUjU = parcelRequire("4YUjU");
class $53b1d602a69e9a6f$export$3390a677f4025523 extends (0, $4YUjU.ChoreographerPlugin) {
    constructor(envType, metaMetricsData = {}){
        super((0, $TTRxY.ProductIds).PENDO, envType, metaMetricsData), this.currentMessageId = '', this.getPendoConfig = (pendoConfig)=>{
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const pendoPlugin = this;
            return {
                ...pendoConfig,
                guides: {
                    ...pendoConfig.guides ?? {},
                    globalScripts: [
                        ...pendoConfig.guides?.globalScripts ?? [],
                        {
                            beforeMount (evnt) {
                                if (pendoPlugin.state.isDisabled) evnt.cancel = true;
                                else {
                                    pendoPlugin.currentMessageId = evnt.step.id;
                                    pendoPlugin.on(pendoPlugin.currentMessageId, {});
                                    pendoPlugin.startMessage(pendoPlugin.currentMessageId);
                                }
                            },
                            unmounted () {
                                pendoPlugin.stopMessage(pendoPlugin.currentMessageId);
                            }
                        }
                    ]
                }
            };
        };
    }
    isDisplayingMessage() {
        return Boolean(window.pendo?.getActiveGuide?.());
    }
}

});

parcelRegister("lD23V", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbeed703bb1aba42$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $fbeed703bb1aba42$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("8Ec39", function(module, exports) {

$parcel$export(module.exports, "default", () => $114f26125c89a833$export$2e2bcd8739ae039);

var $ge1SS = parcelRequire("ge1SS");
var $114f26125c89a833$export$2e2bcd8739ae039 = (0, $ge1SS.default);

});
parcelRegister("ge1SS", function(module, exports) {

$parcel$export(module.exports, "default", () => $72b82d0e3dab161a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gg6CF = parcelRequire("gg6CF");

var $7Jxgt = parcelRequire("7Jxgt");

var $5gx4p = parcelRequire("5gx4p");

var $fe1wc = parcelRequire("fe1wc");

var $tcn7E = parcelRequire("tcn7E");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $9AgLs = parcelRequire("9AgLs");

var $kdJVm = parcelRequire("kdJVm");

var $aBI5P = parcelRequire("aBI5P");
let $72b82d0e3dab161a$var$tryCompleteHandle;

const $72b82d0e3dab161a$var$AsyncSegmentHighlight = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("dOOv1")).then((module)=>({
            default: module.SegmentHighlight
        })));
function $72b82d0e3dab161a$export$2e2bcd8739ae039({ name: segmentName, children: children, mode: mode = 'single' }) {
    const parentContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const segmentIdMap = (0, $5uXOq.useMemo)(()=>{
        if (!parentContext?.segmentIdMap) return new Map();
        return parentContext.segmentIdMap;
    }, [
        parentContext
    ]);
    const segmentId = (0, $5uXOq.useMemo)(()=>{
        if (mode === 'single') return (0, $kdJVm.default)();
        if (segmentIdMap.has(segmentName)) return segmentIdMap.get(segmentName);
        const newSegmentId = (0, $kdJVm.default)();
        segmentIdMap.set(segmentName, newSegmentId);
        return newSegmentId;
    }, [
        mode,
        segmentName,
        segmentIdMap
    ]);
    const labelStack = (0, $5uXOq.useMemo)(()=>parentContext?.labelStack ? [
            ...parentContext.labelStack,
            {
                name: segmentName,
                segmentId: segmentId
            }
        ] : [
            {
                name: segmentName,
                segmentId: segmentId
            }
        ], [
        parentContext,
        segmentName,
        segmentId
    ]);
    const interactionId = (0, $5uXOq.useContext)((0, $1u4q7.default));
    const interactionContext = (0, $5uXOq.useMemo)(()=>{
        let lastCompleteEndTime = 0;
        function complete(endTime = performance.now()) {
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    const capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($72b82d0e3dab161a$var$tryCompleteHandle) cancelAnimationFrame?.($72b82d0e3dab161a$var$tryCompleteHandle);
                    const onComplete = ()=>{
                        if (capturedInteractionId === interactionId.current) {
                            const isPageVisible = globalThis?.document?.visibilityState === 'visible';
                            const canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            if (isPageVisible && canDoRAF) $72b82d0e3dab161a$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                $72b82d0e3dab161a$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                    if (capturedInteractionId === interactionId.current) (0, $bFU4G.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $bFU4G.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    };
                    (0, $gg6CF.unstable_scheduleCallback)((0, $gg6CF.unstable_NormalPriority), onComplete);
                }
            }
        }
        function _internalHold(labelStack, name, experimental = false) {
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name, experimental);
                else {
                    const capturedInteractionId = interactionId.current;
                    const disposeHold = (0, $bFU4G.addHold)(interactionId.current, labelStack, name, experimental);
                    return ()=>{
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $bFU4G.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $bFU4G.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return {
            ...parentContext,
            labelStack: labelStack,
            complete: complete
        };
        return {
            labelStack: labelStack,
            segmentIdMap: segmentIdMap,
            hold (name = 'unknown') {
                return this._internalHold(this.labelStack, name);
            },
            holdExperimental (name = 'unknown') {
                return this._internalHold(this.labelStack, name, true);
            },
            addHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress (name = 'unknown', timestamp) {
                if (interactionId.current != null) (0, $bFU4G.abortByNewInteraction)(interactionId.current, name);
                const rate = (0, $fe1wc.getInteractionRate)(name, 'press');
                if ((0, $5gx4p.default)(rate)) {
                    const startTimestamp = timestamp ?? performance.now();
                    const newId = (0, $7Jxgt.v4)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, $tcn7E.setInteractionActiveTrace)(newId, 'press');
                    (0, $bFU4G.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, $9AgLs.default).current, (0, $tcn7E.getActiveTrace)());
                }
            },
            retainQuery (info) {
                if (interactionId.current != null) (0, $bFU4G.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload (moduleId, timestamp) {
                if (interactionId.current != null) (0, $bFU4G.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad (identifier, start, end) {
                if (interactionId.current != null) {
                    const { labelStack: labelStack = [] } = this;
                    (0, $bFU4G.addSpan)(interactionId.current, 'bundle_load', identifier, labelStack, start, end);
                }
            },
            addMark (name, timestamp) {
                if (interactionId.current != null) {
                    const time = timestamp ?? performance.now();
                    (0, $bFU4G.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData (customData) {
                if (interactionId.current != null) (0, $bFU4G.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings (customTimings) {
                if (interactionId.current != null) (0, $bFU4G.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex (apdexInfo) {
                if (interactionId.current != null) {
                    const { key: key, stopTime: stopTime, startTime: startTime } = apdexInfo;
                    (0, $bFU4G.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender (phase, actualDuration, baseDuration, startTime, commitTime) {
                if (interactionId.current !== null) {
                    (0, $bFU4G.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    (0, $aBI5P.default)(()=>{
                        const paintedTime = performance.now();
                        this.complete(paintedTime);
                    });
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        segmentIdMap,
        interactionId
    ]);
    const hasMounted = (0, $5uXOq.useRef)(false);
    const onRender = (0, $5uXOq.useCallback)((_id, phase, actualDuration, baseDuration, startTime, commitTime)=>{
        // Manually keep track of mount-phase, and ensure that every segment is always mounted at least once
        if ((0, $fe1wc.getConfig)()?.manuallyTrackReactProfilerMounts && !hasMounted.current) {
            interactionContext.onRender('mount', actualDuration, baseDuration, startTime, commitTime);
            hasMounted.current = true;
        } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $bFU4G.addSegment)(labelStack);
        return ()=>{
            (0, $bFU4G.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    const reactProfilerId = (0, $5uXOq.useMemo)(()=>labelStack.map((l)=>l.name).join('/'), [
        labelStack
    ]);
    const enableSegmentHighlighting = (0, $fe1wc.getConfig)()?.enableSegmentHighlighting;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1tcYS.default).Provider, {
        value: interactionContext,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Profiler), {
            id: reactProfilerId,
            onRender: onRender,
            children: [
                children,
                enableSegmentHighlighting && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($72b82d0e3dab161a$var$AsyncSegmentHighlight, {
                        segmentName: segmentName
                    })
                })
            ]
        })
    });
}
$72b82d0e3dab161a$export$2e2bcd8739ae039.displayName = 'UFOSegment';

});
parcelRegister("kdJVm", function(module, exports) {

$parcel$export(module.exports, "default", () => $20e4b4beffd8665a$export$2e2bcd8739ae039);
function $20e4b4beffd8665a$var$generateId(length = 7) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}
var $20e4b4beffd8665a$export$2e2bcd8739ae039 = $20e4b4beffd8665a$var$generateId;

});

parcelRegister("aBI5P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e966289ce908b8f9$export$2e2bcd8739ae039);
function $e966289ce908b8f9$var$scheduleOnPaint(callback) {
    if (globalThis.document?.visibilityState !== 'visible') {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(()=>{
        window.scheduler.postTask(callback, {
            priority: 'user-visible'
        });
    });
    else if (typeof requestAnimationFrame !== 'undefined') // Fallback to using double requestAnimationFrame
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            callback();
        });
    });
}
var $e966289ce908b8f9$export$2e2bcd8739ae039 = $e966289ce908b8f9$var$scheduleOnPaint;

});

parcelRegister("dOOv1", function(module, exports) {

let $a0f71df7efd623f2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a0f71df7efd623f2$var$load("6533T").then(()=>parcelRequire('2AmUl'));

});
parcelRegister("28QjX", function(module, exports) {
"use strict";


let $18f4e9fbd43d4c3b$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve(id), maxShards));
    };
module.exports = $18f4e9fbd43d4c3b$var$load;

});
parcelRegister("kPuw4", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2, (v) => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $f2a03df3e93d4e79$export$2bf9932c19d6a5d2;
var $f2a03df3e93d4e79$export$1d37a31d51d1e3ed;
var $f2a03df3e93d4e79$export$b4cd98d62f81485f;
var $f2a03df3e93d4e79$export$108ff8fc702e621f;
var $f2a03df3e93d4e79$export$f6f4188f9108e61;
"use strict";
let $f2a03df3e93d4e79$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $f2a03df3e93d4e79$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $f2a03df3e93d4e79$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $f2a03df3e93d4e79$var$removeTrailingShard(subdomain) {
    if (!$f2a03df3e93d4e79$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $f2a03df3e93d4e79$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$f2a03df3e93d4e79$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $f2a03df3e93d4e79$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $f2a03df3e93d4e79$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $f2a03df3e93d4e79$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $f2a03df3e93d4e79$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$f2a03df3e93d4e79$var$globalKeyName]) return url;
    return $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards);
}
$f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = $f2a03df3e93d4e79$var$shardUrl;
$f2a03df3e93d4e79$export$1d37a31d51d1e3ed = $f2a03df3e93d4e79$var$shardUrlUnchecked;
$f2a03df3e93d4e79$export$b4cd98d62f81485f = $f2a03df3e93d4e79$var$getDomainShardIndex;
$f2a03df3e93d4e79$export$108ff8fc702e621f = $f2a03df3e93d4e79$var$applyShardToDomain;
$f2a03df3e93d4e79$export$f6f4188f9108e61 = $f2a03df3e93d4e79$var$globalKeyName;

});

parcelRegister("dy9lH", function(module, exports) {

$parcel$export(module.exports, "register", () => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf, (v) => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $9dd5b3e06d7b5702$export$f7ad0328861e2f03, (v) => $9dd5b3e06d7b5702$export$f7ad0328861e2f03 = v);
var $9dd5b3e06d7b5702$export$6503ec6e8aabbaf;
var $9dd5b3e06d7b5702$export$f7ad0328861e2f03;
"use strict";
var $9dd5b3e06d7b5702$var$mapping = new Map();
function $9dd5b3e06d7b5702$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$9dd5b3e06d7b5702$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $9dd5b3e06d7b5702$var$resolve(id) {
    var resolved = $9dd5b3e06d7b5702$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$9dd5b3e06d7b5702$export$6503ec6e8aabbaf = $9dd5b3e06d7b5702$var$register;
$9dd5b3e06d7b5702$export$f7ad0328861e2f03 = $9dd5b3e06d7b5702$var$resolve;

});





parcelRegister("bPTaj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5939bd216791b87$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");
var $c5939bd216791b87$export$2e2bcd8739ae039 = (InnerComponent)=>{
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class EngagementEventsWrapper extends (0, $5uXOq.Component) {
        UNSAFE_componentWillMount() {
            this.fireEvent('shown');
        }
        componentWillUnmount() {
            this.fireEvent('hidden');
        }
        fireEvent(action, properties = {}) {
            const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                ...properties
            });
            analyticsEvent.update({
                ekMessageId: messageId,
                ekVariationId: variationId,
                ekComponentId: componentId,
                ekComponentType: componentType,
                ekIsLast: isLast
            });
            analyticsEvent.fire('engagement');
        }
        render() {
            return /*#__PURE__*/ (0, $2OMIu.jsx)(InnerComponent, {
                ...this.props,
                fireClickEvent: this.fireClickEvent
            });
        }
        constructor(...args){
            super(...args), this.fireClickEvent = (clickType)=>{
                this.fireEvent('click', {
                    clickType: clickType
                });
            };
        }
    }
    return (0, $cb25w.default)()(EngagementEventsWrapper);
};

});

parcelRegister("f9Hff", function(module, exports) {

$parcel$export(module.exports, "default", () => $c73ca19cb8d0c3f2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");
var $c73ca19cb8d0c3f2$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        const current = state.current;
        if (current && isTargetComponent(current)) {
            let message;
            switch(current.componentType){
                case 'contextualSurvey':
                    message = {
                        ...current,
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    };
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    function getComponentType() {
        return componentType;
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class StoreWrapper extends (0, $5uXOq.Component) {
        static{
            this.contextTypes = {
                subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func,
                setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func
            };
        }
        UNSAFE_componentWillMount() {
            if (this.canSubscribe()) this.unsubscribe = this.subscribeToStore();
            if (this.canSetConfig()) this.removeConfig = this.setChoreographerConfig();
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.props?.engagementId !== nextProps?.engagementId && this.removeConfig && this.canSetConfig()) {
                this.removeConfig();
                this.removeConfig = this.setChoreographerConfig(nextProps);
            } else if ((this.props?.messageType !== nextProps?.messageType || this.props?.onMessageDisposition !== nextProps?.onMessageDisposition) && this.canSetConfig()) this.setChoreographerConfig(nextProps);
        }
        componentWillUnmount() {
            if (this.unsubscribe) this.unsubscribe();
            if (this.removeConfig) this.removeConfig();
        }
        canSetConfig() {
            return this.context && this.context.setComponentConfig;
        }
        setChoreographerConfig(props = this.props) {
            return this.context.setComponentConfig(getComponentType(), {
                messageType: props.messageType,
                onMessageDisposition: props.onMessageDisposition
            }, props.engagementId);
        }
        canSubscribe() {
            return this.context && this.context.subscribeEngagementState;
        }
        subscribeToStore() {
            return this.context.subscribeEngagementState(this.onStoreChange);
        }
        render() {
            const { children: children, engagementId: engagementId } = this.props;
            const { message: message } = this.state;
            if (!message) {
                if (componentType === 'inlineDialog') return children || null;
                return null;
            }
            if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
            const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
            // Key is useful here to make sure that when the currently active
            // messages changes, the old component is unmounted (therefore
            // firing an analytic event for hiding the component) and mounting
            // a new component for the new message (firing a shown event for
            // the new message). Not using key would allow React to apply an
            // optimization that would reuse the current component for a new
            // message which would not call the normal mount and unmount
            // lifecycle methods.
            return /*#__PURE__*/ (0, $2OMIu.jsx)(InnerComponent, {
                ...this.props,
                ...message
            }, messageKey);
        }
        constructor(...args){
            super(...args), this.state = {
                message: null
            }, this.onStoreChange = (state)=>{
                this.setState(computeNewState(state));
            };
        }
    }
    return StoreWrapper;
};

});

parcelRegister("02CEF", function(module, exports) {

$parcel$export(module.exports, "buttonActionTypes", () => $88face119c13f52b$export$e7d79186651244da);
const $88face119c13f52b$export$e7d79186651244da = {
    LINK: 'link',
    DISMISS: 'dismiss'
};

});

parcelRegister("9pLR7", function(module, exports) {

$parcel$export(module.exports, "default", () => $8be30f37f56f96d5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
class $8be30f37f56f96d5$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    render() {
        const { html: html } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}

});

parcelRegister("96nTn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a12211dcade02141$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");

var $1LSM6 = parcelRequire("1LSM6");

var $gOOK6 = parcelRequire("gOOK6");
function $a12211dcade02141$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $gOOK6.useSafeIntl)();
    const messages = (0, $1LSM6.useMessages)(intl.locale, loaderFn);
    /**
	 * IntlProvider does not inherit from upstream IntlProviders,
	 * we lookup messages in the context and pass them downstream
	 * This prevents the missing messages error
	 */ const mergedMessages = (0, $5uXOq.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});
parcelRegister("1LSM6", function(module, exports) {

$parcel$export(module.exports, "useMessages", () => $8b0c0f17bd7df50e$export$4d17e2d9c5348842);

var $5uXOq = parcelRequire("5uXOq");

var $mqPQ8 = parcelRequire("mqPQ8");
const $8b0c0f17bd7df50e$export$4d17e2d9c5348842 = (locale, loaderFn)=>{
    const [localeState, setLocaleState] = (0, $5uXOq.useState)((0, $mqPQ8.DEFAULT_LOCALE_STATE));
    (0, $5uXOq.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
};

});
parcelRegister("mqPQ8", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE_STATE", () => $ca64c7c64c62f0c7$export$79618bef82c02d4c);
const $ca64c7c64c62f0c7$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};

});


parcelRegister("gOOK6", function(module, exports) {

$parcel$export(module.exports, "useSafeIntl", () => $75954c8addb89719$export$f752ac21ea3960a5);

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $hTtGr = parcelRequire("hTtGr");
var $8RXs9 = parcelRequire("8RXs9");

var $mqPQ8 = parcelRequire("mqPQ8");
// Prevents memory leaks
const $75954c8addb89719$var$cache = (0, $hTtGr.createIntlCache)();
const $75954c8addb89719$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $5uXOq.useContext)((0, $8RXs9.Context));
    if (!context) return (0, $i5FdW.createIntl)((0, $mqPQ8.DEFAULT_LOCALE_STATE), $75954c8addb89719$var$cache);
    return context;
};

});


parcelRegister("bWGt6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b260dd1704e65ee$export$2e2bcd8739ae039);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $bS0aY = parcelRequire("bS0aY");

var $f8Sb3 = parcelRequire("f8Sb3");

var $2cWYv = parcelRequire("2cWYv");

var $7PpcK = parcelRequire("7PpcK");

var $lDKn9 = parcelRequire("lDKn9");
var $8b260dd1704e65ee$var$testOmitPropsOnStringTag = (0, $bS0aY.default);
var $8b260dd1704e65ee$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $8b260dd1704e65ee$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $8b260dd1704e65ee$var$testOmitPropsOnStringTag : $8b260dd1704e65ee$var$testOmitPropsOnComponent;
};
var $8b260dd1704e65ee$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $8b260dd1704e65ee$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $8b260dd1704e65ee$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $2cWYv.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $lDKn9.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $2cWYv.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $8b260dd1704e65ee$var$createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $8b260dd1704e65ee$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $8b260dd1704e65ee$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $f8Sb3.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = (0, $5uXOq.useContext)((0, $f8Sb3.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $2cWYv.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $7PpcK.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $8b260dd1704e65ee$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $5uXOq.createElement)($8b260dd1704e65ee$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ (0, $5uXOq.createElement)(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $bS32t.default)({}, options, nextOptions, {
                shouldForwardProp: $8b260dd1704e65ee$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};
var $8b260dd1704e65ee$export$2e2bcd8739ae039 = $8b260dd1704e65ee$var$createStyled;

});
parcelRegister("bS0aY", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a44dfccbb21331d$export$2e2bcd8739ae039);

var $g3OeT = parcelRequire("g3OeT");
var $8a44dfccbb21331d$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $8a44dfccbb21331d$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $g3OeT.default)(function(prop) {
    return $8a44dfccbb21331d$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("g3OeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb13e59ea669960c$export$2e2bcd8739ae039);
function $bb13e59ea669960c$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("fHeZc", function(module, exports) {

$parcel$export(module.exports, "AlignIcon", () => $1006659b46e58275$export$70a0c2f5862937b6);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ec5353656036cfa8eb0abafa5d91cd5d>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $1006659b46e58275$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z"/>
</svg>
`;
function $1006659b46e58275$export$70a0c2f5862937b6({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $1006659b46e58275$var$svg,
        label: label || 'Align',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("3Aqws", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $e3ca2e1e207b2e0a$export$be58b4326e23250f);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hxoiH = parcelRequire("hxoiH");
const $e3ca2e1e207b2e0a$var$styles = {
    root: "_1e0c1o8l"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $e3ca2e1e207b2e0a$var$lightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $e3ca2e1e207b2e0a$var$darkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ const $e3ca2e1e207b2e0a$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $e3ca2e1e207b2e0a$export$be58b4326e23250f({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: customIconColor }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        // If the label is provided an empty string, we want to remove the element from the accessibility tree.
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $bwpsq.default)([
            $e3ca2e1e207b2e0a$var$styles.root,
            $e3ca2e1e207b2e0a$var$sizeMap[size],
            colorMode === 'light' ? $e3ca2e1e207b2e0a$var$lightAppearanceMap[appearance] : $e3ca2e1e207b2e0a$var$darkAppearanceMap[appearance]
        ])
    });
}

});


parcelRegister("2mHJn", function(module, exports) {

$parcel$export(module.exports, "AlignLogoCS", () => $fcc16c395c5ffe24$export$8b5103382c06639c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3686fc7eada0812378df251a2acffc68>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $fcc16c395c5ffe24$var$svg = `<svg height="100%" viewBox="0 0 106 32">
    <g clip-path="url(#clip0_95640_16151)">
        <path fill="var(--text-color, #1e1f21)" d="M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37"/>
        <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <path fill="var(--icon-color, #101214)" d="M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z"/>
    </g>
    <defs>
        <clipPath id="clip0_95640_16151">
            <path fill="var(--icon-color, white)" d="M0 0h106v32H0z"/>
        </clipPath>
    </defs>
</svg>
`;
function $fcc16c395c5ffe24$export$8b5103382c06639c({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $fcc16c395c5ffe24$var$svg,
        label: label || 'Align',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("mfib2", function(module, exports) {

$parcel$export(module.exports, "LogoWrapper", () => $7f732cdd59e88d7f$export$f827d3c5a9c3f644);
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hxoiH = parcelRequire("hxoiH");
const $7f732cdd59e88d7f$var$styles = {
    root: "_1e0c1o8l _vwz4idpf"
}; // These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
const $7f732cdd59e88d7f$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
const $7f732cdd59e88d7f$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $7f732cdd59e88d7f$var$lightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv _1wyc1fxt",
    neutral: "_1b3i1e01 _9aea1fkg _1wyc1e01",
    inverse: "_1b3i5a6q _9aeau67f _1wycu67f",
    legacy: "_1b3iu67f _9aeadoyu _1wycu67f"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $7f732cdd59e88d7f$var$darkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv _1wyc1fxt",
    neutral: "_1b3i1gvk _9aea8hz0 _1wyc1gvk",
    inverse: "_1b3iu67f _9aea5a6q _1wyc5a6q",
    legacy: "_1b3iu67f _9aeadoyu _1wycu67f"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
function $7f732cdd59e88d7f$export$f827d3c5a9c3f644({ appearance: appearance = 'brand', size: size = 'small', svg: svg, customThemeSvg: customThemeSvg, label: label, testId: userDefinedTestId, iconColor: customIconColor, textColor: customTextColor }) {
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        "aria-label": label,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $bwpsq.default)([
            $7f732cdd59e88d7f$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $7f732cdd59e88d7f$var$logoTextColorMap[colorMode ?? 'light'],
            $7f732cdd59e88d7f$var$sizeMap[size],
            colorMode === 'light' ? $7f732cdd59e88d7f$var$lightAppearanceMap[appearance] : $7f732cdd59e88d7f$var$darkAppearanceMap[appearance]
        ])
    });
}

});


parcelRegister("1rnXN", function(module, exports) {

$parcel$export(module.exports, "AnalyticsIcon", () => $ae7a06763fb57536$export$af3460f51ce3602a);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::36b174d9d09c8f2405cd04b33db260b0>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $ae7a06763fb57536$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z"/>
</svg>
`;
function $ae7a06763fb57536$export$af3460f51ce3602a({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $ae7a06763fb57536$var$svg,
        label: label || 'Analytics',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jGxRu", function(module, exports) {

$parcel$export(module.exports, "AnalyticsLogoCS", () => $fd868963a8ad6811$export$f0bac2b7ac3e3504);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d543bfb4dd3d23c316cf61c078f1ed0e>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $fd868963a8ad6811$var$svg = `<svg height="100%" viewBox="0 0 161 32">
    <g clip-path="url(#clip0_95640_16115)">
        <path fill="var(--text-color, #1e1f21)" d="M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>
        <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <g fill="var(--icon-color, #101214)" clip-path="url(#clip1_95640_16115)">
            <path d="M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z"/>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_95640_16115">
            <path fill="var(--icon-color, white)" d="M0 0h160.667v32H0z"/>
        </clipPath>
        <clipPath id="clip1_95640_16115">
            <path fill="var(--icon-color, white)" d="M2 2h28v28H2z"/>
        </clipPath>
    </defs>
</svg>
`;
function $fd868963a8ad6811$export$f0bac2b7ac3e3504({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $fd868963a8ad6811$var$svg,
        label: label || 'Analytics',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bfgl4", function(module, exports) {

$parcel$export(module.exports, "AssetsIcon", () => $ed432c7714773bbf$export$d89497e7f33ca6f5);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8b071b94f261be1c33a58eb6ceaf0dfa>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $ed432c7714773bbf$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"/>
</svg>
`;
const $ed432c7714773bbf$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729"/>
</svg>
`;
function $ed432c7714773bbf$export$d89497e7f33ca6f5({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $ed432c7714773bbf$var$svg,
        customThemeSvg: $ed432c7714773bbf$var$customThemeSvg,
        iconColor: iconColor,
        label: label || 'Assets',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9rNhS", function(module, exports) {

$parcel$export(module.exports, "AssetsLogoCS", () => $f4008322a619311d$export$81c47abe19675c4c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d2a0752f78c2e6a21b44dc2f38489557>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $f4008322a619311d$var$svg = `<svg height="100%" viewBox="0 0 126 32">
    <g clip-path="url(#clip0_95164_16514)">
        <path fill="var(--text-color, #1e1f21)" d="M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>
        <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25" clip-rule="evenodd"/>
        <path fill="var(--icon-color, #101214)" d="M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z"/>
    </g>
    <defs>
        <clipPath id="clip0_95164_16514">
            <path fill="var(--icon-color, white)" d="M0 0h126v32H0z"/>
        </clipPath>
    </defs>
</svg>
`;
function $f4008322a619311d$export$81c47abe19675c4c({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $f4008322a619311d$var$svg,
        label: label || 'Assets',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lAZCM", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", () => $1433366fe21bdea1$export$5fc1066e677788d4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::576782a6bbd9d5e76898e2aeff7cd858>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $1433366fe21bdea1$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582"/>
</svg>
`;
const $1433366fe21bdea1$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z"/>
</svg>
`;
function $1433366fe21bdea1$export$5fc1066e677788d4({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $1433366fe21bdea1$var$svg,
        customThemeSvg: $1433366fe21bdea1$var$customThemeSvg,
        iconColor: iconColor,
        label: label || 'Bitbucket',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2yaWx", function(module, exports) {

$parcel$export(module.exports, "BitbucketLogoCS", () => $2b8725025c03f905$export$f7ef5e5488e4b430);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fecdd32ce24e02885c2d58061eaf09dd>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $2b8725025c03f905$var$svg = `<svg height="100%" viewBox="0 0 166 32">
    <g clip-path="url(#clip0_95164_15510)">
        <path fill="var(--text-color, #1e1f21)" d="M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z"/>
        <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <path fill="var(--icon-color, #101214)" d="m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771"/>
    </g>
    <defs>
        <clipPath id="clip0_95164_15510">
            <path fill="var(--icon-color, white)" d="M0 0h165.333v32H0z"/>
        </clipPath>
    </defs>
</svg>
`;
function $2b8725025c03f905$export$f7ef5e5488e4b430({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $2b8725025c03f905$var$svg,
        label: label || 'Bitbucket',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jqlpc", function(module, exports) {

$parcel$export(module.exports, "ChatIcon", () => $6acb2a9c1b2e7e0b$export$52cd484a7ef4f2b9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f8c318f87babff6eaf9780ecaaf52cc5>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $6acb2a9c1b2e7e0b$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.125 16.5h8.125V6H5.75v13zM12 12.125a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75m4-.875a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0m-7.125.875a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75" clip-rule="evenodd"/>
</svg>
`;
function $6acb2a9c1b2e7e0b$export$52cd484a7ef4f2b9({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $6acb2a9c1b2e7e0b$var$svg,
        label: label || 'Chat',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7FJrV", function(module, exports) {

$parcel$export(module.exports, "ChatLogoCS", () => $5001220616a758e9$export$a529e78951cd6709);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14b103b123a53021b60f4687c729e734>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $5001220616a758e9$var$svg = `<svg height="100%" viewBox="0 0 102 32">
    <g clip-path="url(#clip0_95164_16369)">
        <path fill="var(--text-color, #1e1f21)" d="M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.65m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
        <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M24.167 21.834h-10.5l-5.833 3.5v-17.5h16.333zm-12.25-5.833a1.167 1.167 0 1 0 0-2.334 1.167 1.167 0 0 0 0 2.334M16 16a1.167 1.167 0 1 0 0-2.334A1.167 1.167 0 0 0 16 16m5.25-1.167a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.333 0" clip-rule="evenodd"/>
    </g>
    <defs>
        <clipPath id="clip0_95164_16369">
            <path fill="var(--icon-color, white)" d="M0 0h102v32H0z"/>
        </clipPath>
    </defs>
</svg>
`;
function $5001220616a758e9$export$a529e78951cd6709({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $5001220616a758e9$var$svg,
        label: label || 'Chat',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5nbLn", function(module, exports) {

$parcel$export(module.exports, "CompassIcon", () => $e82fb65f5281281d$export$f7857fe64d7161d9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4a38db27be8b23378822aab42e29bd2d>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $e82fb65f5281281d$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z"/>
</svg>
`;
function $e82fb65f5281281d$export$f7857fe64d7161d9({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $e82fb65f5281281d$var$svg,
        label: label || 'Compass',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7ul58", function(module, exports) {

$parcel$export(module.exports, "CompassLogoCS", () => $e2fe6aba6a18017b$export$a16f50a81d183ce);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f3e4de50345025ad6fe2cdadb8b8243>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $e2fe6aba6a18017b$var$svg = `<svg height="100%" viewBox="0 0 162 32">
    <g clip-path="url(#clip0_95164_15528)">
        <path fill="var(--text-color, #1e1f21)" d="M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
        <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <path fill="var(--icon-color, #101214)" d="M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z"/>
    </g>
    <defs>
        <clipPath id="clip0_95164_15528">
            <path fill="var(--icon-color, white)" d="M0 0h162v32H0z"/>
        </clipPath>
    </defs>
</svg>
`;
function $e2fe6aba6a18017b$export$a16f50a81d183ce({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $e2fe6aba6a18017b$var$svg,
        label: label || 'Compass',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1U4EY", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $6fa7705f627142aa$export$68f3db7f6af48bcb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::acd1c4594664a494fed4e891c6a97bca>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $6fa7705f627142aa$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673"/>
</svg>
`;
const $6fa7705f627142aa$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135"/>
</svg>
`;
function $6fa7705f627142aa$export$68f3db7f6af48bcb({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $6fa7705f627142aa$var$svg,
        customThemeSvg: $6fa7705f627142aa$var$customThemeSvg,
        iconColor: iconColor,
        label: label || 'Confluence',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3kVGJ", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLogoCS", () => $a375c3a1c8ffe3bd$export$a88b0b0da9ef63ce);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::acd95a158c4d9053886b7ab10ef58b63>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $a375c3a1c8ffe3bd$var$svg = `<svg height="100%" viewBox="0 0 188 32">
    <g clip-path="url(#clip0_95164_15560)">
        <path fill="var(--text-color, #1e1f21)" d="M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
        <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <g clip-path="url(#clip1_95164_15560)">
            <path fill="var(--icon-color, white)" d="M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823"/>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_95164_15560">
            <path fill="var(--icon-color, white)" d="M0 0h188v32H0z"/>
        </clipPath>
        <clipPath id="clip1_95164_15560">
            <path fill="var(--icon-color, white)" d="M7.708 8.125h16.506v15.78H7.708z"/>
        </clipPath>
    </defs>
</svg>
`;
function $a375c3a1c8ffe3bd$export$a88b0b0da9ef63ce({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $a375c3a1c8ffe3bd$var$svg,
        label: label || 'Confluence',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2HThS", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceManagementIcon", () => $e34734ab954d32d0$export$6da5aa77c402ba0f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::de4c777ada2f4fd8a38cc2cd7726cc9d>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $e34734ab954d32d0$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z"/>
</svg>
`;
const $e34734ab954d32d0$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5"/>
</svg>
`;
function $e34734ab954d32d0$export$6da5aa77c402ba0f({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $e34734ab954d32d0$var$svg,
        customThemeSvg: $e34734ab954d32d0$var$customThemeSvg,
        iconColor: iconColor,
        label: label || 'Customer Service Management',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gHS4Z", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceManagementLogoCS", () => $72f47babb8ea4053$export$f597f0f7fadce0b9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed09626b9c41e05007b442e56c912883>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $72f47babb8ea4053$var$svg = `<svg height="100%" viewBox="0 0 456 32">
    <g clip-path="url(#clip0_95164_16556)">
        <path fill="var(--text-color, #1e1f21)" d="M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
        <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <path fill="var(--icon-color, #101214)" d="M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z"/>
    </g>
    <defs>
        <clipPath id="clip0_95164_16556">
            <path fill="var(--icon-color, white)" d="M0 0h456v32H0z"/>
        </clipPath>
    </defs>
</svg>
`;
function $72f47babb8ea4053$export$f597f0f7fadce0b9({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $72f47babb8ea4053$var$svg,
        label: label || 'Customer Service Management',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fC06l", function(module, exports) {

$parcel$export(module.exports, "FocusIcon", () => $c0bc43fc9853e2d5$export$1e02e7298035a77c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7695c574d946df26362aaf05476b47ad>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $c0bc43fc9853e2d5$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z"/>
</svg>
`;
function $c0bc43fc9853e2d5$export$1e02e7298035a77c({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $c0bc43fc9853e2d5$var$svg,
        label: label || 'Focus',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2NokP", function(module, exports) {

$parcel$export(module.exports, "FocusLogoCS", () => $e2b4eca1d7efed1a$export$3a6e8b37e069a69d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b849b4594ffa3907bf580ea28085f408>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $e2b4eca1d7efed1a$var$svg = `<svg height="100%" viewBox="0 0 117 32">
    <g clip-path="url(#clip0_95164_15893)">
        <path fill="var(--text-color, #1e1f21)" d="M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z"/>
        <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <path fill="var(--icon-color, #101214)" d="M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z"/>
    </g>
    <defs>
        <clipPath id="clip0_95164_15893">
            <path fill="var(--icon-color, white)" d="M0 0h116.667v32H0z"/>
        </clipPath>
    </defs>
</svg>
`;
function $e2b4eca1d7efed1a$export$3a6e8b37e069a69d({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $e2b4eca1d7efed1a$var$svg,
        label: label || 'Focus',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8bDjo", function(module, exports) {

$parcel$export(module.exports, "GoalsIcon", () => $412d439e1eec0fbe$export$9eb74917ea768ed4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c003b830838de14b130e7182bc74ee04>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $412d439e1eec0fbe$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0" clip-rule="evenodd"/>
</svg>
`;
function $412d439e1eec0fbe$export$9eb74917ea768ed4({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $412d439e1eec0fbe$var$svg,
        label: label || 'Goals',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("21FPI", function(module, exports) {

$parcel$export(module.exports, "GoalsLogoCS", () => $a5ee9dd1ddf3188e$export$c527a545aa426db3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::60e0116d8236792eec217bd12f698ad5>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $a5ee9dd1ddf3188e$var$svg = `<svg height="100%" viewBox="0 0 116 32">
    <g clip-path="url(#clip0_95164_16292)">
        <path fill="var(--text-color, #1e1f21)" d="M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z"/>
        <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <g fill="var(--icon-color, #101214)" clip-path="url(#clip1_95164_16292)">
            <path d="M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0"/>
            <path fill-rule="evenodd" d="M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0" clip-rule="evenodd"/>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_95164_16292">
            <path fill="var(--icon-color, white)" d="M0 0h116v32H0z"/>
        </clipPath>
        <clipPath id="clip1_95164_16292">
            <path fill="var(--icon-color, white)" d="M1 1h30v30H1z"/>
        </clipPath>
    </defs>
</svg>
`;
function $a5ee9dd1ddf3188e$export$c527a545aa426db3({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $a5ee9dd1ddf3188e$var$svg,
        label: label || 'Goals',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("73Rot", function(module, exports) {

$parcel$export(module.exports, "GuardIcon", () => $507fa3a1f8d9d869$export$3f95fcfdc25a741d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03847eb0ce9d464c771c8c581ad4355d>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $507fa3a1f8d9d869$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649"/>
</svg>
`;
function $507fa3a1f8d9d869$export$3f95fcfdc25a741d({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $507fa3a1f8d9d869$var$svg,
        label: label || 'Guard',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1UvCn", function(module, exports) {

$parcel$export(module.exports, "GuardLogoCS", () => $320e63935029f55b$export$2b896c4d595a4331);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::127ec38aa9d24ae13be7c481a9d01843>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $320e63935029f55b$var$svg = `<svg height="100%" viewBox="0 0 120 32">
    <g clip-path="url(#clip0_95164_15870)">
        <path fill="var(--text-color, #1e1f21)" d="M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z"/>
        <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <g clip-path="url(#clip1_95164_15870)">
            <path fill="var(--icon-color, #101214)" d="M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778"/>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_95164_15870">
            <path fill="var(--icon-color, white)" d="M0 0h120v32H0z"/>
        </clipPath>
        <clipPath id="clip1_95164_15870">
            <path fill="var(--icon-color, white)" d="M7.5 8h16.999v16.64H7.5z"/>
        </clipPath>
    </defs>
</svg>
`;
function $320e63935029f55b$export$2b896c4d595a4331({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $320e63935029f55b$var$svg,
        label: label || 'Guard',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bfGwn", function(module, exports) {

$parcel$export(module.exports, "HomeIcon", () => $5a75e14950a910c2$export$92c8767b874048d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2860c989e0c8d8d851ff77c7e75968f8>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $5a75e14950a910c2$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z"/>
</svg>
`;
function $5a75e14950a910c2$export$92c8767b874048d({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $5a75e14950a910c2$var$svg,
        label: label || 'Home',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2uTAv", function(module, exports) {

$parcel$export(module.exports, "HomeLogoCS", () => $9c2e8eb94f595d6d$export$8b6b7f1b1b2367d3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bfc730d2047c42f054c5cf695fd8c96b>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $9c2e8eb94f595d6d$var$svg = `<svg height="100%" viewBox="0 0 121 32">
    <g clip-path="url(#clip0_95164_16185)">
        <path fill="var(--text-color, #1e1f21)" d="M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z"/>
        <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <g clip-path="url(#clip1_95164_16185)">
            <path fill="var(--icon-color, #101214)" d="M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z"/>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_95164_16185">
            <path fill="var(--icon-color, white)" d="M0 0h120.667v32H0z"/>
        </clipPath>
        <clipPath id="clip1_95164_16185">
            <path fill="var(--icon-color, white)" d="M1 1h30v30H1z"/>
        </clipPath>
    </defs>
</svg>
`;
function $9c2e8eb94f595d6d$export$8b6b7f1b1b2367d3({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $9c2e8eb94f595d6d$var$svg,
        label: label || 'Home',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9f2LI", function(module, exports) {

$parcel$export(module.exports, "HubIcon", () => $6a1d2c4800f7b305$export$80b8b269d8b5014e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5dc8a1bcaf0404b083596df9c9819260>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $6a1d2c4800f7b305$var$svg = `<svg height="100%" viewBox="0 0 32 32">
    <g clip-path="url(#clip0_95164_16219)">
        <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <g clip-path="url(#clip1_95164_16219)">
            <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z" clip-rule="evenodd"/>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_95164_16219">
            <path fill="var(--icon-color, white)" d="M0 0h32v32H0z"/>
        </clipPath>
        <clipPath id="clip1_95164_16219">
            <path fill="var(--icon-color, white)" d="M2 2h28v28H2z"/>
        </clipPath>
    </defs>
</svg>
`;
function $6a1d2c4800f7b305$export$80b8b269d8b5014e({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $6a1d2c4800f7b305$var$svg,
        label: label || 'Hub',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4IGxH", function(module, exports) {

$parcel$export(module.exports, "HubLogoCS", () => $21502c3e5423dbce$export$7a38180641471460);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0f187c31a24907ba6d108df9efedfdc4>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $21502c3e5423dbce$var$svg = `<svg height="100%" viewBox="0 0 95 32">
    <g clip-path="url(#clip0_95164_16218)">
        <path fill="var(--text-color, #1e1f21)" d="M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z"/>
        <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <g clip-path="url(#clip1_95164_16218)">
            <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z" clip-rule="evenodd"/>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_95164_16218">
            <path fill="var(--icon-color, white)" d="M0 0h94.667v32H0z"/>
        </clipPath>
        <clipPath id="clip1_95164_16218">
            <path fill="var(--icon-color, white)" d="M2 2h28v28H2z"/>
        </clipPath>
    </defs>
</svg>
`;
function $21502c3e5423dbce$export$7a38180641471460({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $21502c3e5423dbce$var$svg,
        label: label || 'Hub',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kaR8K", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", () => $be2c9fe02cc4b142$export$c4b5b1f965d8b3eb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e37aba516b7cebea69cb0cb5f4be950b>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $be2c9fe02cc4b142$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z"/>
</svg>
`;
const $be2c9fe02cc4b142$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z"/>
</svg>
`;
function $be2c9fe02cc4b142$export$c4b5b1f965d8b3eb({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $be2c9fe02cc4b142$var$svg,
        customThemeSvg: $be2c9fe02cc4b142$var$customThemeSvg,
        iconColor: iconColor,
        label: label || 'Jira',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dBdWm", function(module, exports) {

$parcel$export(module.exports, "JiraLogoCS", () => $5d0603fe90babeed$export$bf4c5f97b468e8d6);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff698a1467e436e0803032991e303774>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $5d0603fe90babeed$var$svg = `<svg height="100%" viewBox="0 0 83 32">
    <g clip-path="url(#clip0_95164_15593)">
        <path fill="var(--text-color, #1e1f21)" d="M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
        <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <g clip-path="url(#clip1_95164_15593)">
            <path fill="var(--icon-color, white)" d="M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z"/>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_95164_15593">
            <path fill="var(--icon-color, white)" d="M0 0h82.667v32H0z"/>
        </clipPath>
        <clipPath id="clip1_95164_15593">
            <path fill="var(--icon-color, white)" d="M5.491 6.927h20.13v20.285H5.49z"/>
        </clipPath>
    </defs>
</svg>
`;
function $5d0603fe90babeed$export$bf4c5f97b468e8d6({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $5d0603fe90babeed$var$svg,
        label: label || 'Jira',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gTrd0", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $9298817d8a027e01$export$21bfbeb62fdcce8d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::226cbae280a7685d453e97832e87475f>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $9298817d8a027e01$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#c97cf4)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z"/>
</svg>
`;
const $9298817d8a027e01$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228"/>
</svg>
`;
function $9298817d8a027e01$export$21bfbeb62fdcce8d({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $9298817d8a027e01$var$svg,
        customThemeSvg: $9298817d8a027e01$var$customThemeSvg,
        iconColor: iconColor,
        label: label || 'Jira Product Discovery',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4AvrM", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryLogoCS", () => $74d08439d72e064e$export$602140a6a10b02bf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6664c66d9ad9369b2e719a2eb006614b>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $74d08439d72e064e$var$svg = `<svg height="100%" viewBox="0 0 327 32">
    <g clip-path="url(#clip0_95164_15622)">
        <path fill="var(--text-color, #1e1f21)" d="M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
        <path fill="var(--tile-color,#c97cf4)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <g clip-path="url(#clip1_95164_15622)">
            <path fill="var(--icon-color, #101214)" d="M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z"/>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_95164_15622">
            <path fill="var(--icon-color, white)" d="M0 0h326.667v32H0z"/>
        </clipPath>
        <clipPath id="clip1_95164_15622">
            <path fill="var(--icon-color, white)" d="M6.375 6.958h19.063v19.063H6.375z"/>
        </clipPath>
    </defs>
</svg>
`;
function $74d08439d72e064e$export$602140a6a10b02bf({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $74d08439d72e064e$var$svg,
        label: label || 'Jira Product Discovery',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("goJA6", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementIcon", () => $b7bf9194809d8218$export$3c6158790f5e01c4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30b2aaddadad34df0e24aba5e3001ce0>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $b7bf9194809d8218$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z"/>
</svg>
`;
const $b7bf9194809d8218$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z"/>
</svg>
`;
function $b7bf9194809d8218$export$3c6158790f5e01c4({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $b7bf9194809d8218$var$svg,
        customThemeSvg: $b7bf9194809d8218$var$customThemeSvg,
        iconColor: iconColor,
        label: label || 'Jira Service Management',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("a6Ztu", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementLogoCS", () => $d4764390a8501a61$export$de148263c75d2bc1);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a212fa101c3ea73fc9f91ee34c1e7983>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $d4764390a8501a61$var$svg = `<svg height="100%" viewBox="0 0 372 32">
    <g clip-path="url(#clip0_95164_15661)">
        <path fill="var(--text-color, #1e1f21)" d="M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
        <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <g clip-path="url(#clip1_95164_15661)">
            <path fill="var(--icon-color, #101214)" d="M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z"/>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_95164_15661">
            <path fill="var(--icon-color, white)" d="M0 0h371.333v32H0z"/>
        </clipPath>
        <clipPath id="clip1_95164_15661">
            <path fill="var(--icon-color, white)" d="M6.792 5.167h18.352v21.45H6.792z"/>
        </clipPath>
    </defs>
</svg>
`;
function $d4764390a8501a61$export$de148263c75d2bc1({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $d4764390a8501a61$var$svg,
        label: label || 'Jira Service Management',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9bk6s", function(module, exports) {

$parcel$export(module.exports, "LoomIcon", () => $17fa971fcc6756de$export$8d789f76fde3e05);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45fb01729507897b65d9692911ccb9ec>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $17fa971fcc6756de$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
function $17fa971fcc6756de$export$8d789f76fde3e05({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $17fa971fcc6756de$var$svg,
        label: label || 'Loom',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5oFQV", function(module, exports) {

$parcel$export(module.exports, "LoomLogoCS", () => $f76e4e9542154d71$export$78c0b4d8be34c9b2);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6504c06f860ac2df7ce45bda8086751b>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $f76e4e9542154d71$var$svg = `<svg height="100%" viewBox="0 0 103 32">
    <g clip-path="url(#clip0_95164_15717)">
        <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593"/>
        <path fill="var(--text-color, #1e1f21)" d="M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19"/>
    </g>
    <defs>
        <clipPath id="clip0_95164_15717">
            <path fill="var(--icon-color, white)" d="M0 0h102.667v32H0z"/>
        </clipPath>
    </defs>
</svg>
`;
function $f76e4e9542154d71$export$78c0b4d8be34c9b2({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $f76e4e9542154d71$var$svg,
        label: label || 'Loom',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lV2o9", function(module, exports) {

$parcel$export(module.exports, "OpsgenieIcon", () => $b5b863bb7a5d2bd5$export$eeccc49dc7a12d9f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0bad699fc2aacb51820b76c79014fef6>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $b5b863bb7a5d2bd5$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848"/>
</svg>
`;
function $b5b863bb7a5d2bd5$export$eeccc49dc7a12d9f({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $b5b863bb7a5d2bd5$var$svg,
        label: label || 'Opsgenie',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bqqsC", function(module, exports) {

$parcel$export(module.exports, "OpsgenieLogoCS", () => $efcbe7d536e260bd$export$a5b9122e89b32ad3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ee7561acf88534c9d42e29f104aaf7cb>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $efcbe7d536e260bd$var$svg = `<svg height="100%" viewBox="0 0 164 32">
    <g clip-path="url(#clip0_95164_15759)">
        <path fill="var(--text-color, #1e1f21)" d="M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7"/>
        <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <g clip-path="url(#clip1_95164_15759)">
            <path fill="var(--icon-color, #101214)" d="M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001"/>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_95164_15759">
            <path fill="var(--icon-color, white)" d="M0 0h164v32H0z"/>
        </clipPath>
        <clipPath id="clip1_95164_15759">
            <path fill="var(--icon-color, white)" d="M7.333 5.979h17.532v20.042H7.333z"/>
        </clipPath>
    </defs>
</svg>
`;
function $efcbe7d536e260bd$export$a5b9122e89b32ad3({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $efcbe7d536e260bd$var$svg,
        label: label || 'Opsgenie',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hT1xk", function(module, exports) {

$parcel$export(module.exports, "ProjectsIcon", () => $73551489ac46d8d3$export$5ed3e1bb3b04fc02);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::223e52d00e4a359e527726e7fa117871>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $73551489ac46d8d3$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546" clip-rule="evenodd"/>
</svg>
`;
function $73551489ac46d8d3$export$5ed3e1bb3b04fc02({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $73551489ac46d8d3$var$svg,
        label: label || 'Projects',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("brnv4", function(module, exports) {

$parcel$export(module.exports, "ProjectsLogoCS", () => $fcb1daa101a38a0b$export$e3d1678155aaab99);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6dad9779ebf6bf1426d4eed9e99ad6e8>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $fcb1daa101a38a0b$var$svg = `<svg height="100%" viewBox="0 0 145 32">
    <g clip-path="url(#clip0_95164_16253)">
        <path fill="var(--text-color, #1e1f21)" d="M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z"/>
        <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <g clip-path="url(#clip1_95164_16253)">
            <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21" clip-rule="evenodd"/>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_95164_16253">
            <path fill="var(--icon-color, white)" d="M0 0h144.667v32H0z"/>
        </clipPath>
        <clipPath id="clip1_95164_16253">
            <path fill="var(--icon-color, white)" d="M1 1h30v30H1z"/>
        </clipPath>
    </defs>
</svg>
`;
function $fcb1daa101a38a0b$export$e3d1678155aaab99({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $fcb1daa101a38a0b$var$svg,
        label: label || 'Projects',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4UzOa", function(module, exports) {

$parcel$export(module.exports, "RovoIcon", () => $12f09a060db500a6$export$e23ae35269442b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3aa77b6ddabca5e9372e6a86f4f961f5>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $12f09a060db500a6$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z"/>
    <path fill="var(--icon-color, white)" d="M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691"/>
</svg>
`;
function $12f09a060db500a6$export$e23ae35269442b4f({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $12f09a060db500a6$var$svg,
        label: label || 'Rovo',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hPpJi", function(module, exports) {

$parcel$export(module.exports, "RovoLogoCS", () => $251d9f3e4096d100$export$b0e15f0a1c9f4c55);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f7dbb170b406f9fd8cb9e7293ac8d9b5>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $251d9f3e4096d100$var$svg = `<svg height="100%" viewBox="0 0 106 32">
    <g clip-path="url(#clip0_95164_15848)">
        <path fill="var(--text-color, #1e1f21)" d="M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26"/>
        <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <path fill="var(--icon-color, white)" d="M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z"/>
        <path fill="var(--icon-color, white)" d="m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1"/>
    </g>
    <defs>
        <clipPath id="clip0_95164_15848">
            <path fill="var(--icon-color, white)" d="M0 0h106v32H0z"/>
        </clipPath>
    </defs>
</svg>
`;
function $251d9f3e4096d100$export$b0e15f0a1c9f4c55({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $251d9f3e4096d100$var$svg,
        label: label || 'Rovo',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1SZyt", function(module, exports) {

$parcel$export(module.exports, "SearchIcon", () => $ddf3e32e1d9cd2af$export$82eafebb825fc23f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e5213addb1c82ecbf71aafa9d7ce123>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $ddf3e32e1d9cd2af$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M5 10.688a5.69 5.69 0 0 0 5.697 5.687c1.01 0 1.958-.262 2.78-.723L16.832 19 19 16.834l-3.347-3.341c.471-.828.74-1.785.74-2.806A5.69 5.69 0 0 0 10.697 5 5.69 5.69 0 0 0 5 10.688m2.191 0c0 1.932 1.57 3.5 3.506 3.5a3.503 3.503 0 0 0 3.505-3.5c0-1.933-1.57-3.5-3.505-3.5a3.503 3.503 0 0 0-3.506 3.5" clip-rule="evenodd"/>
</svg>
`;
function $ddf3e32e1d9cd2af$export$82eafebb825fc23f({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $ddf3e32e1d9cd2af$var$svg,
        label: label || 'Search',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2jGfv", function(module, exports) {

$parcel$export(module.exports, "SearchLogoCS", () => $005b50ba88c822ea$export$fa08cbfe393f2a68);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c77b5c4d482b6339b6829caff0e64249>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $005b50ba88c822ea$var$svg = `<svg height="100%" viewBox="0 0 130 32">
    <g clip-path="url(#clip0_95164_16402)">
        <path fill="var(--text-color, #1e1f21)" d="M128.82 16.35v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.04 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10H88v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>
        <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M7.127 14.833a7.583 7.583 0 0 0 11.286 6.62l4.464 4.464 2.887-2.888-4.455-4.455a7.583 7.583 0 1 0-14.181-3.74m2.917 0a4.667 4.667 0 1 0 9.333 0 4.667 4.667 0 0 0-9.333 0" clip-rule="evenodd"/>
    </g>
    <defs>
        <clipPath id="clip0_95164_16402">
            <path fill="var(--icon-color, white)" d="M0 0h129.333v32H0z"/>
        </clipPath>
    </defs>
</svg>
`;
function $005b50ba88c822ea$export$fa08cbfe393f2a68({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $005b50ba88c822ea$var$svg,
        label: label || 'Search',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eBJoK", function(module, exports) {

$parcel$export(module.exports, "StatuspageIcon", () => $94a4d06313b2019a$export$f3f5aa321d88adf9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0f64a5f9f74cb2080aa4aec25e7de1aa>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $94a4d06313b2019a$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68"/>
</svg>
`;
function $94a4d06313b2019a$export$f3f5aa321d88adf9({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $94a4d06313b2019a$var$svg,
        label: label || 'Statuspage',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("nORLU", function(module, exports) {

$parcel$export(module.exports, "StatuspageLogoCS", () => $3cd5bf637a1beac7$export$2bc88a281410ffa7);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4608db16bbcecc31d39c5cf034c04a4d>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $3cd5bf637a1beac7$var$svg = `<svg height="100%" viewBox="0 0 192 32">
    <g clip-path="url(#clip0_95164_15788)">
        <path fill="var(--text-color, #1e1f21)" d="M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>
        <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <path fill="var(--icon-color, #101214)" d="M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927"/>
    </g>
    <defs>
        <clipPath id="clip0_95164_15788">
            <path fill="var(--icon-color, white)" d="M0 0h192v32H0z"/>
        </clipPath>
    </defs>
</svg>
`;
function $3cd5bf637a1beac7$export$2bc88a281410ffa7({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $3cd5bf637a1beac7$var$svg,
        label: label || 'Statuspage',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9qVs1", function(module, exports) {

$parcel$export(module.exports, "StudioIcon", () => $31157aae3ffcc592$export$290a0f24614cde9f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::faf0a8375a64f8adb843627d3dccab09>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $31157aae3ffcc592$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M10.7 11.222V19h7.8v-7.778z"/>
    <path fill="var(--icon-color, #101214)" d="M14.6 7.609 10.05 5 5.5 7.609v5.217l3.64 2.087V9.667h5.46z"/>
</svg>
`;
function $31157aae3ffcc592$export$290a0f24614cde9f({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $31157aae3ffcc592$var$svg,
        label: label || 'Studio',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hwsmG", function(module, exports) {

$parcel$export(module.exports, "StudioLogoCS", () => $c4b7e7bc06913bfa$export$273fd56580e523ae);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe87c721d102eccd1412f133dd03dbfb>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $c4b7e7bc06913bfa$var$svg = `<svg height="100%" viewBox="0 0 124 32">
    <g clip-path="url(#clip0_95164_16436)">
        <path fill="var(--text-color, #1e1f21)" d="M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.17 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>
        <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <path fill="var(--icon-color, #101214)" d="M14.125 14.125V24.75H24.75V14.125z"/>
        <path fill="var(--icon-color, #101214)" d="M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z"/>
    </g>
    <defs>
        <clipPath id="clip0_95164_16436">
            <path fill="var(--icon-color, white)" d="M0 0h124v32H0z"/>
        </clipPath>
    </defs>
</svg>
`;
function $c4b7e7bc06913bfa$export$273fd56580e523ae({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $c4b7e7bc06913bfa$var$svg,
        label: label || 'Studio',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3qLnv", function(module, exports) {

$parcel$export(module.exports, "TalentIcon", () => $ff7454606f8af4ad$export$4b05688514531169);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d8594fbf1ebf0a8df3ba8a057aba92f>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $ff7454606f8af4ad$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786" clip-rule="evenodd"/>
</svg>
`;
function $ff7454606f8af4ad$export$4b05688514531169({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $ff7454606f8af4ad$var$svg,
        label: label || 'Talent',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jgBfM", function(module, exports) {

$parcel$export(module.exports, "TalentLogoCS", () => $ac0a73f781472dd2$export$1b3979d995ebbc6e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::223bda849fa2fa9295bfd840ceab32ab>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $ac0a73f781472dd2$var$svg = `<svg height="100%" viewBox="0 0 122 32">
    <g clip-path="url(#clip0_95164_16472)">
        <path fill="var(--text-color, #1e1f21)" d="M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>
        <g clip-path="url(#clip1_95164_16472)">
            <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
            <path fill="var(--icon-color, #101214)" d="m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714"/>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_95164_16472">
            <path fill="var(--icon-color, white)" d="M0 0h121.333v32H0z"/>
        </clipPath>
        <clipPath id="clip1_95164_16472">
            <path fill="var(--icon-color, white)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        </clipPath>
    </defs>
</svg>
`;
function $ac0a73f781472dd2$export$1b3979d995ebbc6e({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $ac0a73f781472dd2$var$svg,
        label: label || 'Talent',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("by9zw", function(module, exports) {

$parcel$export(module.exports, "TeamsIcon", () => $1ccce0d623457e70$export$1bcbc9c337da86da);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e38bea8c9c417da71284391abf39612>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $1ccce0d623457e70$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63"/>
</svg>
`;
function $1ccce0d623457e70$export$1bcbc9c337da86da({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $1ccce0d623457e70$var$svg,
        label: label || 'Teams',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("etsRd", function(module, exports) {

$parcel$export(module.exports, "TeamsLogoCS", () => $305292115a918aae$export$bfd8d1c4da84ce71);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7d6d4dd5b99fd1a99e48e2df72a01704>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $305292115a918aae$var$svg = `<svg height="100%" viewBox="0 0 127 32">
    <g clip-path="url(#clip0_95164_16333)">
        <path fill="var(--text-color, #1e1f21)" d="M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>
        <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <path fill="var(--icon-color, #101214)" d="M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08"/>
    </g>
    <defs>
        <clipPath id="clip0_95164_16333">
            <path fill="var(--icon-color, white)" d="M0 0h126.667v32H0z"/>
        </clipPath>
    </defs>
</svg>
`;
function $305292115a918aae$export$bfd8d1c4da84ce71({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $305292115a918aae$var$svg,
        label: label || 'Teams',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5d7aC", function(module, exports) {

$parcel$export(module.exports, "TrelloIcon", () => $0cc15d0ef866b8cf$export$4384da9b8b140bf4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::33273be5800a76008256021251d285d4>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Aqws = parcelRequire("3Aqws");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $0cc15d0ef866b8cf$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1558bc)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z"/>
</svg>
`;
const $0cc15d0ef866b8cf$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z"/>
</svg>
`;
function $0cc15d0ef866b8cf$export$4384da9b8b140bf4({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Aqws.IconWrapper), {
        svg: $0cc15d0ef866b8cf$var$svg,
        customThemeSvg: $0cc15d0ef866b8cf$var$customThemeSvg,
        iconColor: iconColor,
        label: label || 'Trello',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ckUdG", function(module, exports) {

$parcel$export(module.exports, "TrelloLogoCS", () => $74926a871a12b0ba$export$1b13139dfc0336af);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cc8656771ce2ab5fef245612cea9f1e>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $74926a871a12b0ba$var$svg = `<svg height="100%" viewBox="0 0 113 32">
    <g clip-path="url(#clip0_95164_15820)">
        <path fill="var(--text-color, #1e1f21)" d="M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>
        <path fill="var(--tile-color,#1558bc)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <path fill="var(--icon-color, white)" d="M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z"/>
    </g>
    <defs>
        <clipPath id="clip0_95164_15820">
            <path fill="var(--icon-color, white)" d="M0 0h112.667v32H0z"/>
        </clipPath>
    </defs>
</svg>
`;
function $74926a871a12b0ba$export$1b13139dfc0336af({ size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $74926a871a12b0ba$var$svg,
        label: label || 'Trello',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7Z8dX", function(module, exports) {

$parcel$export(module.exports, "RovoPostMessagePubsubListener", () => $1067642daa65eae6$export$e5e1a9c59c299631);
$parcel$export(module.exports, "useRovoPostMessageToPubsub", () => $1067642daa65eae6$export$5340cc94dd0ecbea);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $hjiMw = parcelRequire("hjiMw");
const $1067642daa65eae6$export$cabfb6cc8c48b099 = 'rovo-post-message';
const $1067642daa65eae6$export$25a11ea4740a334 = 'rovo-post-message-ack';
// allow subdomains of these domains
const $1067642daa65eae6$var$allowedSubdomains = [
    '.jira-dev.com',
    '.atlassian.com',
    '.atlassian.net',
    '.atl-paas.net'
];
const $1067642daa65eae6$var$allowedOrigins = [
    'bitbucket.org',
    'trello.com'
];
const $1067642daa65eae6$export$c9fe6aef04e3544f = (origin)=>{
    if (!origin) return false;
    const url = new URL(origin);
    const hostname = url.hostname;
    return hostname === 'localhost' || url.protocol === 'https:' && ($1067642daa65eae6$var$allowedSubdomains.some((subdomain)=>hostname.endsWith(subdomain)) || $1067642daa65eae6$var$allowedOrigins.includes(hostname));
};
const $1067642daa65eae6$export$e5e1a9c59c299631 = ()=>{
    const publish = (0, $hjiMw.usePublish)('ai-mate');
    (0, $5uXOq.useEffect)(()=>{
        const handlerUnbind = (0, $cBeZP.bind)(window, {
            type: 'message',
            listener: (event)=>{
                if (!$1067642daa65eae6$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType === $1067642daa65eae6$export$cabfb6cc8c48b099) {
                    const eventData = event.data;
                    const ackPayload = {
                        eventType: $1067642daa65eae6$export$25a11ea4740a334,
                        payloadId: eventData.payloadId
                    };
                    event.source?.postMessage(ackPayload);
                    publish(event.data.payload);
                }
            }
        });
        return handlerUnbind;
    }, [
        publish
    ]);
    return null;
};
const $1067642daa65eae6$var$TIMEOUT_WAIT_FOR_ACK = 100;
const $1067642daa65eae6$export$5340cc94dd0ecbea = ()=>{
    const onAcknowledgeTimeoutTimeoutRef = (0, $5uXOq.useRef)(null);
    const [isWaitingForAck, setIsWaitingForAck] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        const handlerUnbind = (0, $cBeZP.bind)(window, {
            type: 'message',
            // handler for acknowledgment from parent
            listener: (event)=>{
                if (!$1067642daa65eae6$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType !== $1067642daa65eae6$export$25a11ea4740a334 || onAcknowledgeTimeoutTimeoutRef.current === null) return;
                const eventData = event.data;
                // if the parent acknowledges different payload (e.g. from different hook instance)
                // disregard the event
                if (eventData.payloadId !== onAcknowledgeTimeoutTimeoutRef.current.lastPayloadId) return;
                // Clear the onAcknowledgeTimeoutTimeout if acknowledgment is received
                clearTimeout(onAcknowledgeTimeoutTimeoutRef.current.timeout);
                onAcknowledgeTimeoutTimeoutRef.current = null;
                setIsWaitingForAck(false);
            }
        });
        return handlerUnbind;
    }, []);
    const publishWithPostMessage = (0, $5uXOq.useCallback)(({ targetWindow: targetWindow = window.parent, payload: payload, onAcknowledgeTimeout: onAcknowledgeTimeout })=>{
        if (!targetWindow) return;
        const payloadId = Math.floor(Math.random() * 1e6).toString();
        targetWindow.postMessage({
            eventType: $1067642daa65eae6$export$cabfb6cc8c48b099,
            payload: payload,
            payloadId: payloadId
        }, '*');
        // waiting for acknowledgment from parent
        // if no acknowledgment is received, call onAcknowledgeTimeout
        setIsWaitingForAck(true);
        const timeout = window.setTimeout(()=>{
            onAcknowledgeTimeout({
                payload: payload
            });
            onAcknowledgeTimeoutTimeoutRef.current = null;
            setIsWaitingForAck(false);
        }, $1067642daa65eae6$var$TIMEOUT_WAIT_FOR_ACK);
        onAcknowledgeTimeoutTimeoutRef.current = {
            timeout: timeout,
            lastPayloadId: payloadId
        };
    }, []);
    return {
        publishWithPostMessage: publishWithPostMessage,
        isWaitingForAck: isWaitingForAck
    };
};

});
parcelRegister("hjiMw", function(module, exports) {

$parcel$export(module.exports, "useSubscribe", () => $775f1109619c4156$export$d3d523392640272);
$parcel$export(module.exports, "useSubscribeAll", () => $775f1109619c4156$export$2570c8aa24b6d327);
$parcel$export(module.exports, "usePublish", () => $775f1109619c4156$export$d55c81786220731c);
$parcel$export(module.exports, "Subscriber", () => $775f1109619c4156$export$60959659b2c22881);

var $5uXOq = parcelRequire("5uXOq");
const $775f1109619c4156$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed'
]);
const $775f1109619c4156$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = events.length.toString();
        const subExists = events.some(({ id: id })=>id === subId);
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callback,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const payload = publishQueue[topic];
                callback(payload);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        /**
		 * Log that this Topic received a published event, regardless of whether it has subscribers or not.
		 * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
		 */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$775f1109619c4156$var$ignoredTriggerLatestEvents.has(payload.type)) publishQueue[topic] = payload;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(payload));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue
    };
};
const $775f1109619c4156$var$pubSub = $775f1109619c4156$var$createPubSub();
const $775f1109619c4156$var$usePubSub = ()=>{
    return $775f1109619c4156$var$pubSub;
};
const $775f1109619c4156$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
    const { subscribe: subscribe } = $775f1109619c4156$var$usePubSub();
    const callbackRef = (0, $5uXOq.useRef)(callback);
    callbackRef.current = callback;
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic
    ]);
};
const $775f1109619c4156$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $775f1109619c4156$var$usePubSub();
    const callbackRef = (0, $5uXOq.useRef)(callback);
    callbackRef.current = callback;
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $775f1109619c4156$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $775f1109619c4156$var$usePubSub();
    (0, $5uXOq.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $775f1109619c4156$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $775f1109619c4156$var$usePubSub();
    const publishFn = (0, $5uXOq.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $775f1109619c4156$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount })=>{
    $775f1109619c4156$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest
    }, onEvent);
    $775f1109619c4156$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};

});


parcelRegister("eIMrK", function(module, exports) {

$parcel$export(module.exports, "createCache", () => $26949c89be85980a$export$cf6fa0bbcc94b912);
function $26949c89be85980a$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}

});

parcelRegister("ce6VA", function(module, exports) {

$parcel$export(module.exports, "PreloadableJSResource", () => $0aceca9655b1ea8e$export$4fe5fba5bb1d3c09);

var $eYVtd = parcelRequire("eYVtd");
function $0aceca9655b1ea8e$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $eYVtd.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}

});
parcelRegister("eYVtd", function(module, exports) {

$parcel$export(module.exports, "JSResource", () => $0077c3a5c33c2d5c$export$148e45a6d4b4d65);

var $s9uRx = parcelRequire("s9uRx");

var $kqVcd = parcelRequire("kqVcd");

var $c8s79 = parcelRequire("c8s79");
function $0077c3a5c33c2d5c$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName, modulePath: modulePath, priority: priority } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $kqVcd.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $kqVcd.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners)listener.onError?.(error);
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModulePath () {
            return modulePath;
        },
        getPriority () {
            return priority;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $s9uRx.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $kqVcd.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $c8s79.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError?.(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}

});
parcelRegister("s9uRx", function(module, exports) {

$parcel$export(module.exports, "generateId", () => $7b3c882236d08e62$export$567fc7097e064344);
let $7b3c882236d08e62$var$id = 100000;
function $7b3c882236d08e62$export$567fc7097e064344() {
    $7b3c882236d08e62$var$id += 1;
    return $7b3c882236d08e62$var$id.toString();
}

});

parcelRegister("kqVcd", function(module, exports) {

$parcel$export(module.exports, "eventEmitter", () => $c1231136395d7ade$export$10dc3edfc20c8ff);
function $c1231136395d7ade$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $c1231136395d7ade$export$10dc3edfc20c8ff = $c1231136395d7ade$var$createEventEmitter();

});

parcelRegister("c8s79", function(module, exports) {

$parcel$export(module.exports, "isJSModuleWithDefaultExport", () => $e831db33fb49cb12$export$3b514faac3ba993c);
function $e831db33fb49cb12$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}

});



parcelRegister("j74qU", function(module, exports) {

$parcel$export(module.exports, "eocFetch", () => $e038c50dbacfc9f4$export$212b9c60150b5a0a);

var $VSDnB = parcelRequire("VSDnB");

var $tcn7E = parcelRequire("tcn7E");

var $bFU4G = parcelRequire("bFU4G");

var $aI12f = parcelRequire("aI12f");

var $030R0 = parcelRequire("030R0");
const $e038c50dbacfc9f4$export$212b9c60150b5a0a = (input, init)=>{
    let headers = init?.headers ?? {};
    let body = init?.body;
    // If there is no Content-Type we should add application/json
    // and if the body is not in the BodyInit format we should stringify it
    // Native fetch accepts headers as [['key1','value1'],['key2', 'value2']] so we don't want to modify header or body in this case
    if (!(window.Blob && body instanceof Blob || window.Int8Array && body instanceof Int8Array || window.Uint8Array && body instanceof Uint8Array || window.Uint8ClampedArray && body instanceof Uint8ClampedArray || window.Int16Array && body instanceof Int16Array || window.Uint16Array && body instanceof Uint16Array || window.Int32Array && body instanceof Int32Array || window.Uint32Array && body instanceof Uint32Array || window.Float32Array && body instanceof Float32Array || window.Float64Array && body instanceof Float64Array || window.ArrayBuffer && body instanceof ArrayBuffer || window.BigInt64Array && body instanceof BigInt64Array || window.BigUint64Array && body instanceof BigUint64Array || window.FormData && body instanceof FormData || window.URLSearchParams && body instanceof URLSearchParams || window.ReadableStream && body instanceof ReadableStream || window.Array && headers instanceof Array || typeof body === 'string') && headers['Content-Type'] === undefined && headers['content-type'] === undefined) {
        body = JSON.stringify(body);
        headers['Content-Type'] = 'application/json';
    }
    if (typeof input === 'string') {
        input = (0, $030R0.withPrefix)(input, init);
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('trace_id_header_update_in_the_eoc_fetch')) headers = {
            ...(0, $tcn7E.getActiveTraceHttpRequestHeaders)(input),
            ...headers
        };
    } else {
        input = {
            ...input,
            url: (0, $030R0.withPrefix)(input.url, init)
        };
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('trace_id_header_update_in_the_eoc_fetch')) headers = {
            ...(0, $tcn7E.getActiveTraceHttpRequestHeaders)(input.url),
            ...headers
        };
    }
    const errorTransformer = init?.errorTransformer ?? (0, $030R0.defaultErrorTransformer);
    const startTime = performance.now();
    return fetch(input, {
        headers: headers,
        ...init,
        body: body
    }).catch((error)=>{
        throw new (0, $aI12f.NetworkError)(error.name, error);
    }).then((response)=>{
        if (!response.ok) throw new (0, $aI12f.HTTPError)(response);
        const sanitizedUrl = (0, $030R0.sanitizeUrlString)((0, $030R0.getRequestUrl)(input));
        (0, $bFU4G.addSpanToAll)('fetch', sanitizedUrl, [
            {
                name: 'network'
            }
        ], startTime, performance.now());
        switch(init?.responseType){
            case undefined:
            case 'json':
                return response.json();
            case 'blob':
                return response.blob();
            case 'text':
                return response.text();
            case 'headers':
                return response;
        }
    }).catch((error)=>{
        if ((0, $aI12f.isNetworkError)(error)) {
            // Put it through the transformer and throw it when ready. Note that
            // it is still safe to throw in the transformer, it will just chain up
            // on the following handlers as usual.
            const transformerResult = errorTransformer(error);
            if (transformerResult instanceof Promise) return transformerResult.then((finalError)=>{
                throw finalError;
            });
            else throw transformerResult;
        }
        throw error;
    });
};

});
parcelRegister("aI12f", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $c2cf5dfa0e96b9de$export$bae979e68e4dc802);
$parcel$export(module.exports, "HTTPError", () => $c2cf5dfa0e96b9de$export$aa9d629c530f62a7);
$parcel$export(module.exports, "StreamedHTTPError", () => $c2cf5dfa0e96b9de$export$c30b5b02747d791c);
$parcel$export(module.exports, "isHTTPError", () => $c2cf5dfa0e96b9de$export$6b7a49ce9c98a2f);
$parcel$export(module.exports, "isNetworkError", () => $c2cf5dfa0e96b9de$export$476aa014e2fd89d5);
$parcel$export(module.exports, "isStreamedHTTPError", () => $c2cf5dfa0e96b9de$export$4f52fcea95c8f97d);

var $60Rff = parcelRequire("60Rff");
class $c2cf5dfa0e96b9de$export$bae979e68e4dc802 extends Error {
    constructor(name, cause){
        super('Network Error!'), this.name = name, this.cause = cause;
    }
}
class $c2cf5dfa0e96b9de$export$aa9d629c530f62a7 extends $c2cf5dfa0e96b9de$export$bae979e68e4dc802 {
    constructor(response){
        // It is important to note that this can be shown to the user if the
        // default transformer is not used for some reason and the thrown error's
        // message is left as is.
        super((0, $60Rff.ERROR_NAMES).HTTPError);
        this.message = `HTTP Status Error: ${response.status} ${response.statusText}`;
        this.response = response;
    }
}
class $c2cf5dfa0e96b9de$export$c30b5b02747d791c extends $c2cf5dfa0e96b9de$export$aa9d629c530f62a7 {
    constructor(cause, data, message){
        super(cause.response), this.cause = cause, this.data = data, this.message = message;
        this.message = message;
        this.name = (0, $60Rff.ERROR_NAMES).StreamedHTTPError;
    }
}
const $c2cf5dfa0e96b9de$export$6b7a49ce9c98a2f = (candidate)=>candidate instanceof $c2cf5dfa0e96b9de$export$aa9d629c530f62a7 || [
        (0, $60Rff.ERROR_NAMES).HTTPError,
        (0, $60Rff.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $c2cf5dfa0e96b9de$export$476aa014e2fd89d5 = (candidate)=>candidate instanceof $c2cf5dfa0e96b9de$export$bae979e68e4dc802 || [
        (0, $60Rff.ERROR_NAMES).NetworkError,
        (0, $60Rff.ERROR_NAMES).HTTPError,
        (0, $60Rff.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $c2cf5dfa0e96b9de$export$4f52fcea95c8f97d = (candidate)=>candidate instanceof $c2cf5dfa0e96b9de$export$c30b5b02747d791c || candidate?.name === (0, $60Rff.ERROR_NAMES).StreamedHTTPError;

});
parcelRegister("60Rff", function(module, exports) {

$parcel$export(module.exports, "ERROR_NAMES", () => $3500a6ac498ab4f6$export$daceac3b97803ce1);
var $3500a6ac498ab4f6$export$daceac3b97803ce1 = /*#__PURE__*/ function(ERROR_NAMES) {
    ERROR_NAMES["HTTPError"] = "HTTPError";
    ERROR_NAMES["StreamedHTTPError"] = "StreamedHTTPError";
    ERROR_NAMES["NetworkError"] = "NetworkError";
    return ERROR_NAMES;
}({});

});


parcelRegister("030R0", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $bc491f1610486b68$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "withPrefix", () => $bc491f1610486b68$export$44188c5f179c4553);
$parcel$export(module.exports, "defaultErrorTransformer", () => $bc491f1610486b68$export$270fcc0e5df09fdd);
$parcel$export(module.exports, "jsmErrorTransformer", () => $bc491f1610486b68$export$994cc82144d28ded);
$parcel$export(module.exports, "getRequestUrl", () => $bc491f1610486b68$export$14619c0eed01a470);
$parcel$export(module.exports, "sanitizeUrlString", () => $bc491f1610486b68$export$ceb09b958e605eff);

var $gIuON = parcelRequire("gIuON");

var $aI12f = parcelRequire("aI12f");

let $bc491f1610486b68$var$metaCloudId;
let $bc491f1610486b68$var$isJSMAvailable = true;
function $bc491f1610486b68$export$c47913ca32a5c6f7(name) {
    const globalVariable = window ?? $parcel$global;
    if ((0, $gIuON.isServer)() && globalVariable.ssr__metadata) return globalVariable.ssr__metadata[name];
    if ($bc491f1610486b68$var$metaCloudId) return $bc491f1610486b68$var$metaCloudId;
    if ($bc491f1610486b68$var$isJSMAvailable) {
        const element = document.querySelector(`meta[name="${name}"]`);
        $bc491f1610486b68$var$metaCloudId = element?.getAttribute('content') ?? undefined;
        $bc491f1610486b68$var$isJSMAvailable = !!$bc491f1610486b68$var$metaCloudId;
    }
    return $bc491f1610486b68$var$metaCloudId;
}
function $bc491f1610486b68$export$5a75f4aeb58ba80f(id) {
    $bc491f1610486b68$var$metaCloudId = id;
}
function $bc491f1610486b68$export$44188c5f179c4553(input, init) {
    if (init?.exactUrl) return input;
    // If current env is not opsgenie, we will add cloud id to base url of request.
    if (window.__OG__) return '/webapi' + input;
    const cloudId = $bc491f1610486b68$export$c47913ca32a5c6f7('ajs-cloud-id');
    if (cloudId) return (0, $2021409bef50eca5$export$3414665826fa030e) + cloudId + input;
    return input;
}
// https://www.rfc-editor.org/rfc/rfc9110.html#section-8.3
// This is not a full implementation, but should skip any unknown parameters
// and match the charset if it exists. In case there are multiple (which shouldn't) we still
// match the first occurence. If only application/json is returned, utf-8 is
// assumed as we will try to parse it as utf-8 json. This is probably our best
// guess without too much effort here.
const $bc491f1610486b68$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8))))/i;
const $bc491f1610486b68$export$270fcc0e5df09fdd = (e)=>{
    if (e instanceof (0, $aI12f.HTTPError)) {
        const contentType = e.response.headers.get('Content-Type');
        // The content type is application/json, and it is highly likely utf-8 encoded
        if (contentType && $bc491f1610486b68$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $aI12f.StreamedHTTPError)(e, data, data.errorMessage ?? data.message));
        // For anything else, try to interpret it as utf8 text as best effort.
        return e.response.text().then((message)=>new (0, $aI12f.StreamedHTTPError)(e, message, message));
    }
    return e;
};
const $bc491f1610486b68$export$994cc82144d28ded = (error)=>{
    if (error instanceof (0, $aI12f.HTTPError)) {
        const contentType = error.response.headers.get('Content-Type');
        if (contentType && $bc491f1610486b68$var$mediaTypeRegex.test(contentType)) return error.response.json().then((data)=>new (0, $aI12f.StreamedHTTPError)(error, data, data.errorMessages.join(',')));
        return error.response.text().then((message)=>new (0, $aI12f.StreamedHTTPError)(error, message, message));
    }
    return error;
};
const $bc491f1610486b68$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
const $bc491f1610486b68$export$ceb09b958e605eff = (url)=>{
    const urlWithoutQueryParams = url.replace(/\?.*$/, '');
    const urlWithoutUUIDs = urlWithoutQueryParams.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(-[0-9a-f]{13})?/gi, '<uuid>');
    return urlWithoutUUIDs;
};

});
parcelRegister("gIuON", function(module, exports) {

$parcel$export(module.exports, "isServer", () => $a110d4649f6250fb$export$6acf61af03e62db);
const $a110d4649f6250fb$export$6acf61af03e62db = ()=>{
    try {
        //@ts-ignore: It defined from webpack on the Jira
        return false;
    } catch (error) {
        return globalThis.false ?? false;
    }
};

});

const $2021409bef50eca5$export$3414665826fa030e = '/gateway/api/jsm/ops/web/';



parcelRegister("9glig", function(module, exports) {

var $hlchF = parcelRequire("hlchF");

var $1nIHN = parcelRequire("1nIHN");

var $bxDef = parcelRequire("bxDef");

var $g7i7g = parcelRequire("g7i7g");
/** Error message constants. */ var $6be62026d39b34ea$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that iterates over `pairs` and invokes the corresponding
 * function of the first predicate to return truthy. The predicate-function
 * pairs are invoked with the `this` binding and arguments of the created
 * function.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {Array} pairs The predicate-function pairs.
 * @returns {Function} Returns the new composite function.
 * @example
 *
 * var func = _.cond([
 *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
 *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
 *   [_.stubTrue,                      _.constant('no match')]
 * ]);
 *
 * func({ 'a': 1, 'b': 2 });
 * // => 'matches A'
 *
 * func({ 'a': 0, 'b': 1 });
 * // => 'matches B'
 *
 * func({ 'a': '1', 'b': '2' });
 * // => 'no match'
 */ function $6be62026d39b34ea$var$cond(pairs) {
    var length = pairs == null ? 0 : pairs.length, toIteratee = $bxDef;
    pairs = !length ? [] : $1nIHN(pairs, function(pair) {
        if (typeof pair[1] != 'function') throw new TypeError($6be62026d39b34ea$var$FUNC_ERROR_TEXT);
        return [
            toIteratee(pair[0]),
            pair[1]
        ];
    });
    return $g7i7g(function(args) {
        var index = -1;
        while(++index < length){
            var pair = pairs[index];
            if ($hlchF(pair[0], this, args)) return $hlchF(pair[1], this, args);
        }
    });
}
module.exports = $6be62026d39b34ea$var$cond;

});

parcelRegister("hMlwW", function(module, exports) {
/**
 * This method returns `true`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `true`.
 * @example
 *
 * _.times(2, _.stubTrue);
 * // => [true, true]
 */ function $cf179ed6624748c2$var$stubTrue() {
    return true;
}
module.exports = $cf179ed6624748c2$var$stubTrue;

});

parcelRegister("I5fLT", function(module, exports) {

$parcel$export(module.exports, "useAccountLinks", () => $52b23487f27441d5$export$2afde6c526be23b9);

var $lemjl = parcelRequire("lemjl");
function $52b23487f27441d5$export$2afde6c526be23b9({ email: email, identityEnvironment: identityEnvironment, application: application, continueUrl: continueUrl, logOutContinueUrl: logOutContinueUrl, isLoggedOut: isLoggedOut, disableSwitchAccountLink: disableSwitchAccountLink }) {
    const { baseUrl: baseUrl } = (0, $lemjl.resolveEnvironment)(identityEnvironment);
    const applicationParam = `application=${encodeURIComponent(application)}`;
    const continueParam = `continue=${encodeURIComponent(continueUrl)}`;
    const logOutContinueParam = logOutContinueUrl ? `continue=${encodeURIComponent(logOutContinueUrl)}` : continueParam;
    const manageProfileUrl = `${baseUrl}/manage-profile`;
    const manageProfileLink = email ? `${baseUrl}/login?${applicationParam}&continue=${encodeURIComponent(manageProfileUrl)}&prompt=none&login_hint=${encodeURIComponent(email)}` : manageProfileUrl;
    return {
        manageProfileLink: manageProfileLink,
        switchAccountLink: disableSwitchAccountLink ? undefined : `${baseUrl}/login?${applicationParam}&${continueParam}&prompt=select_account`,
        logOutLink: `${baseUrl}/logout?${applicationParam}&${logOutContinueParam}` + (disableSwitchAccountLink ? '' : '&prompt=none'),
        logInLink: isLoggedOut ? `${baseUrl}/login?${applicationParam}&${continueParam}` : undefined
    };
}

});
parcelRegister("lemjl", function(module, exports) {

$parcel$export(module.exports, "resolveEnvironment", () => $5988642e4801aeb0$export$eabfcea451f48b90);
/**
 * An Identity environment to integrate with. Either a `"dev"`, `"fedex"`, `"staging"` or
 * `"prod"` for real Identity environments, or an `EnvironmentConfig` object for
 * using a fake environment (e.g. for local dev).
 */ const $5988642e4801aeb0$var$environmentConfigs = {
    dev: {
        baseUrl: 'https://id.dev.internal.atlassian.com'
    },
    fedex: {
        baseUrl: 'https://id.atlassian-fex.com'
    },
    staging: {
        baseUrl: 'https://id.stg.internal.atlassian.com'
    },
    'staging-fedramp-moderate': {
        baseUrl: 'https://id.stg.atlassian-us-gov-mod.com'
    },
    prod: {
        baseUrl: 'https://id.atlassian.com'
    },
    'prod-fedramp-moderate': {
        baseUrl: 'https://id.atlassian-us-gov-mod.com'
    }
};
function $5988642e4801aeb0$export$eabfcea451f48b90(identityEnvironment) {
    if (typeof identityEnvironment === 'string') return $5988642e4801aeb0$var$environmentConfigs[identityEnvironment];
    else return identityEnvironment;
}

});


parcelRegister("8NZjk", function(module, exports) {

$parcel$export(module.exports, "AccountMenuIntlProvider", () => $ba982ee9af94b9bc$export$6c1f1571e3dd1b34);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $5ZCUE = parcelRequire("5ZCUE");
const $ba982ee9af94b9bc$export$6c1f1571e3dd1b34 = ({ children: children })=>{
    const { locale: locale } = (0, $koVbs.default)();
    const messages = $ba982ee9af94b9bc$var$useMessages(locale);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: locale,
        messages: messages,
        children: children
    });
};
const $ba982ee9af94b9bc$var$useMessages = (locale)=>{
    const [messages, setMessages] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        if (/^en(-US)?$/i.exec(locale)) // Use fallback messages, which are already US English
        setMessages(undefined);
        else {
            let cancelled = false;
            $ba982ee9af94b9bc$var$loadMessages(locale).catch((_error)=>undefined) // TODO: Log error somehow (analytics?)
            .then((messages)=>{
                if (!cancelled) setMessages(messages);
            });
            return ()=>{
                cancelled = true;
            };
        }
    }, [
        locale,
        setMessages
    ]);
    return messages;
};
const $ba982ee9af94b9bc$var$loadMessages = async (locale)=>{
    let [language, region = ''] = locale.split('-', 2);
    language = language.toLowerCase();
    region = region.toUpperCase();
    return (await ((0, $5ZCUE.default)[`${language}_${region}`] || (0, $5ZCUE.default)[language])?.())?.default;
};

});
parcelRegister("5ZCUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7372768e0fc82eee$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by scripts/generate-i18n-index.ts.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index.
 */ 










































const $7372768e0fc82eee$var$lazyMessages = {
    cs: ()=>(parcelRequire("dg8vg")),
    cs_CZ: ()=>(parcelRequire("aPzeH")),
    da: ()=>(parcelRequire("joO78")),
    da_DK: ()=>(parcelRequire("aTL8U")),
    de: ()=>(parcelRequire("b6U8D")),
    de_DE: ()=>(parcelRequire("4BRjM")),
    en_GB: ()=>(parcelRequire("bi58P")),
    en_ZZ: ()=>(parcelRequire("j4b54")),
    es: ()=>(parcelRequire("gtHb1")),
    fi: ()=>(parcelRequire("aHsth")),
    fi_FI: ()=>(parcelRequire("jCRyS")),
    fr: ()=>(parcelRequire("5M2v4")),
    fr_FR: ()=>(parcelRequire("b5smI")),
    hu: ()=>(parcelRequire("iRPPk")),
    hu_HU: ()=>(parcelRequire("73FOZ")),
    it: ()=>(parcelRequire("cp0v0")),
    it_IT: ()=>(parcelRequire("fuPrz")),
    ja: ()=>(parcelRequire("cTa25")),
    ja_JP: ()=>(parcelRequire("bFB2v")),
    ko: ()=>(parcelRequire("4GDtF")),
    ko_KR: ()=>(parcelRequire("7JZZW")),
    nb: ()=>(parcelRequire("dfkGl")),
    nb_NO: ()=>(parcelRequire("f8G56")),
    nl: ()=>(parcelRequire("iuAyS")),
    nl_NL: ()=>(parcelRequire("6oDEt")),
    pl: ()=>(parcelRequire("Xr554")),
    pl_PL: ()=>(parcelRequire("IHcuD")),
    pt_BR: ()=>(parcelRequire("g4qqM")),
    ru: ()=>(parcelRequire("eHXys")),
    ru_RU: ()=>(parcelRequire("cLJff")),
    sv: ()=>(parcelRequire("eZGv3")),
    sv_SE: ()=>(parcelRequire("dbY0e")),
    th: ()=>(parcelRequire("ffign")),
    th_TH: ()=>(parcelRequire("1qVPX")),
    tr: ()=>(parcelRequire("lga5v")),
    tr_TR: ()=>(parcelRequire("7YbCt")),
    uk: ()=>(parcelRequire("ehr7b")),
    uk_UA: ()=>(parcelRequire("9qnRD")),
    vi: ()=>(parcelRequire("35biF")),
    vi_VN: ()=>(parcelRequire("lA13H")),
    zh: ()=>(parcelRequire("lUau8")),
    zh_CN: ()=>(parcelRequire("eLMj9")),
    zh_TW: ()=>(parcelRequire("lYmnt"))
};
var $7372768e0fc82eee$export$2e2bcd8739ae039 = $7372768e0fc82eee$var$lazyMessages;

});
parcelRegister("dg8vg", function(module, exports) {

let $9a735d90eed33ea5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9a735d90eed33ea5$var$load("6xsCn").then(()=>parcelRequire('be02C'));

});

parcelRegister("aPzeH", function(module, exports) {

let $7e29ffeeab6fd4f4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7e29ffeeab6fd4f4$var$load("bm3Jf").then(()=>parcelRequire('fEJZa'));

});

parcelRegister("joO78", function(module, exports) {

let $e1f721d41cff64b2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e1f721d41cff64b2$var$load("1dkiR").then(()=>parcelRequire('aOZ9H'));

});

parcelRegister("aTL8U", function(module, exports) {

let $7ef39bfd9a939d11$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7ef39bfd9a939d11$var$load("a1RPQ").then(()=>parcelRequire('45iy5'));

});

parcelRegister("b6U8D", function(module, exports) {

let $816bcd2373458453$var$load = (parcelRequire("28QjX"))(4);
module.exports = $816bcd2373458453$var$load("2aCrc").then(()=>parcelRequire('bkd7P'));

});

parcelRegister("4BRjM", function(module, exports) {

let $35b3f9f8068f299a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $35b3f9f8068f299a$var$load("2CfMk").then(()=>parcelRequire('9uLfO'));

});

parcelRegister("bi58P", function(module, exports) {

let $83855d1a23bef9eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $83855d1a23bef9eb$var$load("enkb5").then(()=>parcelRequire('4deUn'));

});

parcelRegister("j4b54", function(module, exports) {

let $de16fc72a670fd1d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $de16fc72a670fd1d$var$load("u5NS4").then(()=>parcelRequire('5hPMC'));

});

parcelRegister("gtHb1", function(module, exports) {

let $bff0d8c31adda1e7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bff0d8c31adda1e7$var$load("3ikXM").then(()=>parcelRequire('3Nhdd'));

});

parcelRegister("aHsth", function(module, exports) {

let $7ca40155eb6cb6e6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7ca40155eb6cb6e6$var$load("d80uG").then(()=>parcelRequire('dQ2b1'));

});

parcelRegister("jCRyS", function(module, exports) {

let $e49b1d244219186b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e49b1d244219186b$var$load("cTfSM").then(()=>parcelRequire('8KVwU'));

});

parcelRegister("5M2v4", function(module, exports) {

let $43435ff008b696f6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $43435ff008b696f6$var$load("54XZx").then(()=>parcelRequire('cJg6M'));

});

parcelRegister("b5smI", function(module, exports) {

let $81262a1f3711af3a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $81262a1f3711af3a$var$load("3OwB4").then(()=>parcelRequire('7Cp6N'));

});

parcelRegister("iRPPk", function(module, exports) {

let $dbc560f506db244c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dbc560f506db244c$var$load("2Ck49").then(()=>parcelRequire('S4yUH'));

});

parcelRegister("73FOZ", function(module, exports) {

let $523941129f8f2796$var$load = (parcelRequire("28QjX"))(4);
module.exports = $523941129f8f2796$var$load("7TFLj").then(()=>parcelRequire('7zGoD'));

});

parcelRegister("cp0v0", function(module, exports) {

let $907834ee7774558a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $907834ee7774558a$var$load("7sQIY").then(()=>parcelRequire('5i7M2'));

});

parcelRegister("fuPrz", function(module, exports) {

let $b481900215fa50bb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b481900215fa50bb$var$load("fERvE").then(()=>parcelRequire('43bOU'));

});

parcelRegister("cTa25", function(module, exports) {

let $9622675cd474bd69$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9622675cd474bd69$var$load("55BcE").then(()=>parcelRequire('6xXDZ'));

});

parcelRegister("bFB2v", function(module, exports) {

let $87f041510c7f7c13$var$load = (parcelRequire("28QjX"))(4);
module.exports = $87f041510c7f7c13$var$load("caNVK").then(()=>parcelRequire('4k0qc'));

});

parcelRegister("4GDtF", function(module, exports) {

let $3699b512ff7af082$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3699b512ff7af082$var$load("kWsEM").then(()=>parcelRequire('hiq6X'));

});

parcelRegister("7JZZW", function(module, exports) {

let $5a2cd3e910c09a58$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5a2cd3e910c09a58$var$load("bIh6w").then(()=>parcelRequire('9iT7G'));

});

parcelRegister("dfkGl", function(module, exports) {

let $9a4cb8111299ddef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9a4cb8111299ddef$var$load("tpsMe").then(()=>parcelRequire('ay7Tg'));

});

parcelRegister("f8G56", function(module, exports) {

let $b0583ed4814d620f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b0583ed4814d620f$var$load("7veoT").then(()=>parcelRequire('emQME'));

});

parcelRegister("iuAyS", function(module, exports) {

let $d76763b465a1bf51$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d76763b465a1bf51$var$load("hUeST").then(()=>parcelRequire('og1G8'));

});

parcelRegister("6oDEt", function(module, exports) {

let $4a83bdfd30d488ad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4a83bdfd30d488ad$var$load("g3oWc").then(()=>parcelRequire('blySf'));

});

parcelRegister("Xr554", function(module, exports) {

let $0b2a8483d3881654$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0b2a8483d3881654$var$load("4wfhj").then(()=>parcelRequire('az1yO'));

});

parcelRegister("IHcuD", function(module, exports) {

let $08659ee54416608d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $08659ee54416608d$var$load("e0n0c").then(()=>parcelRequire('dH96e'));

});

parcelRegister("g4qqM", function(module, exports) {

let $bb3185b28b36dcd9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bb3185b28b36dcd9$var$load("480TZ").then(()=>parcelRequire('ivYay'));

});

parcelRegister("eHXys", function(module, exports) {

let $ab53472bbaa677bd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ab53472bbaa677bd$var$load("7dBw2").then(()=>parcelRequire('82gce'));

});

parcelRegister("cLJff", function(module, exports) {

let $94bcf888f2439264$var$load = (parcelRequire("28QjX"))(4);
module.exports = $94bcf888f2439264$var$load("ihWrE").then(()=>parcelRequire('jwhuy'));

});

parcelRegister("eZGv3", function(module, exports) {

let $aea7bacde8cc784f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $aea7bacde8cc784f$var$load("lniNU").then(()=>parcelRequire('29C6m'));

});

parcelRegister("dbY0e", function(module, exports) {

let $99aad8bbb6bcbac5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $99aad8bbb6bcbac5$var$load("6nsC3").then(()=>parcelRequire('9c5wb'));

});

parcelRegister("ffign", function(module, exports) {

let $b1966c6396a75b9f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b1966c6396a75b9f$var$load("9y9OJ").then(()=>parcelRequire('coREq'));

});

parcelRegister("1qVPX", function(module, exports) {

let $10b515660e435076$var$load = (parcelRequire("28QjX"))(4);
module.exports = $10b515660e435076$var$load("hEl7z").then(()=>parcelRequire('9ajce'));

});

parcelRegister("lga5v", function(module, exports) {

let $f7a2eacd4a960559$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f7a2eacd4a960559$var$load("80pzY").then(()=>parcelRequire('4bIqg'));

});

parcelRegister("7YbCt", function(module, exports) {

let $5cd726641dc26979$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5cd726641dc26979$var$load("f95gj").then(()=>parcelRequire('ggsS6'));

});

parcelRegister("ehr7b", function(module, exports) {

let $a657afa9e93b3d97$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a657afa9e93b3d97$var$load("2S8nC").then(()=>parcelRequire('cupFd'));

});

parcelRegister("9qnRD", function(module, exports) {

let $6dc90da9be6d6872$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6dc90da9be6d6872$var$load("eYFe9").then(()=>parcelRequire('eMuwP'));

});

parcelRegister("35biF", function(module, exports) {

let $23ea9ab556f13770$var$load = (parcelRequire("28QjX"))(4);
module.exports = $23ea9ab556f13770$var$load("2GiCZ").then(()=>parcelRequire('ij9vB'));

});

parcelRegister("lA13H", function(module, exports) {

let $fb5dc7fe191d635a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fb5dc7fe191d635a$var$load("1QCBh").then(()=>parcelRequire('huT3J'));

});

parcelRegister("lUau8", function(module, exports) {

let $ff26f60bf8a6e852$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ff26f60bf8a6e852$var$load("2WqLS").then(()=>parcelRequire('bcwNS'));

});

parcelRegister("eLMj9", function(module, exports) {

let $ac0aed70268de9d2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ac0aed70268de9d2$var$load("eqBJY").then(()=>parcelRequire('aUjDR'));

});

parcelRegister("lYmnt", function(module, exports) {

let $0420c881413c373d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0420c881413c373d$var$load("l28up").then(()=>parcelRequire('ecDM5'));

});



parcelRegister("7pImm", function(module, exports) {

$parcel$export(module.exports, "AccountMenuLoggedOutStateNav3", () => $01c9ad3322260504$export$5e6158d2118ae4aa);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8Pko5 = parcelRequire("8Pko5");

var $pkYLA = parcelRequire("pkYLA");

var $71IBF = parcelRequire("71IBF");

var $kHCo7 = parcelRequire("kHCo7");

var $cvjqp = parcelRequire("cvjqp");
const $01c9ad3322260504$export$5e6158d2118ae4aa = ({ testId: testId, logInLink: logInLink })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Pko5.Profile), {
        testId: testId,
        href: logInLink,
        onClick: (event, analytics)=>{
            analytics.update({
                actionSubjectId: 'logInLink'
            }).fire((0, $kHCo7.NAVIGATION_CHANNEL));
        },
        tooltip: (0, $cvjqp.logInTooltip),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($pkYLA))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($71IBF)))
        })
    });

});
parcelRegister("kHCo7", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $898ad1755d1c196d$export$515664faa1398f37);
$parcel$export(module.exports, "ANALYTICS_CONTEXT", () => $898ad1755d1c196d$export$3cbe56a0cabcff38);
const $898ad1755d1c196d$export$515664faa1398f37 = 'navigation';
const $898ad1755d1c196d$export$3cbe56a0cabcff38 = {
    source: 'atlassianAccountMenu',
    componentName: 'atlassianAccountMenu',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};

});

parcelRegister("cvjqp", function(module, exports) {

$parcel$export(module.exports, "logInTooltip", () => $eaae2451158aa9d2$export$b495e6c63a3a03c1);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
const $eaae2451158aa9d2$export$b495e6c63a3a03c1 = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
    id: "identity.account-menu.account-menu-logged-out-state.log-in",
    defaultMessage: "Log in",
    description: "Tooltip for log in button when user is logged out"
});

});


parcelRegister("dBl98", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e6f224f96f6af0c$export$2e2bcd8739ae039);
function $9e6f224f96f6af0c$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $9e6f224f96f6af0c$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $9e6f224f96f6af0c$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $9e6f224f96f6af0c$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $9e6f224f96f6af0c$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $9e6f224f96f6af0c$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $9e6f224f96f6af0c$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $9e6f224f96f6af0c$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $9e6f224f96f6af0c$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $9e6f224f96f6af0c$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $9e6f224f96f6af0c$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $9e6f224f96f6af0c$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $9e6f224f96f6af0c$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $9e6f224f96f6af0c$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $9e6f224f96f6af0c$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $9e6f224f96f6af0c$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $9e6f224f96f6af0c$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $9e6f224f96f6af0c$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $9e6f224f96f6af0c$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $9e6f224f96f6af0c$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $9e6f224f96f6af0c$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $9e6f224f96f6af0c$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $9e6f224f96f6af0c$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $9e6f224f96f6af0c$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $9e6f224f96f6af0c$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $9e6f224f96f6af0c$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $9e6f224f96f6af0c$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $9e6f224f96f6af0c$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $9e6f224f96f6af0c$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $9e6f224f96f6af0c$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $9e6f224f96f6af0c$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $9e6f224f96f6af0c$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $9e6f224f96f6af0c$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $9e6f224f96f6af0c$var$fromHex_1 = $9e6f224f96f6af0c$var$fromHex, $9e6f224f96f6af0c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $9e6f224f96f6af0c$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $9e6f224f96f6af0c$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $9e6f224f96f6af0c$var$fromRgb_1 = $9e6f224f96f6af0c$var$fromRgb, $9e6f224f96f6af0c$var$fromCssRgb_1 = $9e6f224f96f6af0c$var$fromCssRgb, $9e6f224f96f6af0c$var$fromHsl_1 = $9e6f224f96f6af0c$var$fromHsl, $9e6f224f96f6af0c$var$fromCssHsl_1 = $9e6f224f96f6af0c$var$fromCssHsl, $9e6f224f96f6af0c$var$fromHsv_1 = $9e6f224f96f6af0c$var$fromHsv, $9e6f224f96f6af0c$var$fromCmyk_1 = $9e6f224f96f6af0c$var$fromCmyk, $9e6f224f96f6af0c$var$fromYiq_1 = $9e6f224f96f6af0c$var$fromYiq, $9e6f224f96f6af0c$var$fromXYZ_1 = $9e6f224f96f6af0c$var$fromXYZ, $9e6f224f96f6af0c$var$fromxyY_1 = $9e6f224f96f6af0c$var$fromxyY, $9e6f224f96f6af0c$var$fromLms_1 = $9e6f224f96f6af0c$var$fromLms, $9e6f224f96f6af0c$var$fromCieLab_1 = $9e6f224f96f6af0c$var$fromCieLab, $9e6f224f96f6af0c$var$fromCieLuv_1 = $9e6f224f96f6af0c$var$fromCieLuv, $9e6f224f96f6af0c$var$fromCieLch_1 = $9e6f224f96f6af0c$var$fromCieLch, $9e6f224f96f6af0c$var$fromHsluv = $9e6f224f96f6af0c$var$fromCieLch$1, $9e6f224f96f6af0c$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $9e6f224f96f6af0c$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $9e6f224f96f6af0c$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $9e6f224f96f6af0c$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $9e6f224f96f6af0c$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $9e6f224f96f6af0c$var$fromHsluv
    }
}, $9e6f224f96f6af0c$var$adapt_1 = $9e6f224f96f6af0c$var$adapt, $9e6f224f96f6af0c$var$adjacent_1 = $9e6f224f96f6af0c$var$adjacent, $9e6f224f96f6af0c$var$brightness_1 = $9e6f224f96f6af0c$var$brightness, $9e6f224f96f6af0c$var$complementary_1 = $9e6f224f96f6af0c$var$complementary, $9e6f224f96f6af0c$var$contrast_1 = $9e6f224f96f6af0c$var$contrast, $9e6f224f96f6af0c$var$contrastRatio_1 = $9e6f224f96f6af0c$var$contrastRatio, $9e6f224f96f6af0c$var$convert_1 = $9e6f224f96f6af0c$var$convert, $9e6f224f96f6af0c$var$difference_1 = $9e6f224f96f6af0c$var$difference, $9e6f224f96f6af0c$var$fade_1 = $9e6f224f96f6af0c$var$fade, $9e6f224f96f6af0c$var$greyscale_1 = $9e6f224f96f6af0c$var$greyscale, $9e6f224f96f6af0c$var$hue_1 = $9e6f224f96f6af0c$var$hue, $9e6f224f96f6af0c$var$invert_1 = $9e6f224f96f6af0c$var$invert, $9e6f224f96f6af0c$var$invertLightness_1 = $9e6f224f96f6af0c$var$invertLightness, $9e6f224f96f6af0c$var$mid_1 = $9e6f224f96f6af0c$var$mid, $9e6f224f96f6af0c$var$multiply_1 = $9e6f224f96f6af0c$var$multiply, $9e6f224f96f6af0c$var$saturation_1 = $9e6f224f96f6af0c$var$saturation, $9e6f224f96f6af0c$var$sepia_1 = $9e6f224f96f6af0c$var$sepia, $9e6f224f96f6af0c$var$shade_1 = $9e6f224f96f6af0c$var$shade, $9e6f224f96f6af0c$var$temperature_1 = $9e6f224f96f6af0c$var$temperature, $9e6f224f96f6af0c$var$tetrad_1 = $9e6f224f96f6af0c$var$tetrad, $9e6f224f96f6af0c$var$triad_1 = $9e6f224f96f6af0c$var$triad, $9e6f224f96f6af0c$var$index$2 = {
    adapt: $9e6f224f96f6af0c$var$adapt_1,
    adjacent: $9e6f224f96f6af0c$var$adjacent_1,
    brightness: $9e6f224f96f6af0c$var$brightness_1,
    complementary: $9e6f224f96f6af0c$var$complementary_1,
    contrast: $9e6f224f96f6af0c$var$contrast_1,
    contrastRatio: $9e6f224f96f6af0c$var$contrastRatio_1,
    convert: $9e6f224f96f6af0c$var$convert_1,
    difference: $9e6f224f96f6af0c$var$difference_1,
    fade: $9e6f224f96f6af0c$var$fade_1,
    greyscale: $9e6f224f96f6af0c$var$greyscale_1,
    hue: $9e6f224f96f6af0c$var$hue_1,
    invert: $9e6f224f96f6af0c$var$invert_1,
    invertLightness: $9e6f224f96f6af0c$var$invertLightness_1,
    mid: $9e6f224f96f6af0c$var$mid_1,
    multiply: $9e6f224f96f6af0c$var$multiply_1,
    saturation: $9e6f224f96f6af0c$var$saturation_1,
    sepia: $9e6f224f96f6af0c$var$sepia_1,
    shade: $9e6f224f96f6af0c$var$shade_1,
    temperature: $9e6f224f96f6af0c$var$temperature_1,
    tetrad: $9e6f224f96f6af0c$var$tetrad_1,
    triad: $9e6f224f96f6af0c$var$triad_1
}, $9e6f224f96f6af0c$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $9e6f224f96f6af0c$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $9e6f224f96f6af0c$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($9e6f224f96f6af0c$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $9e6f224f96f6af0c$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($9e6f224f96f6af0c$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $9e6f224f96f6af0c$var$api_1 = $9e6f224f96f6af0c$var$api, $9e6f224f96f6af0c$var$helpers = {
    getIlluminant: function(r) {
        return $9e6f224f96f6af0c$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $9e6f224f96f6af0c$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $9e6f224f96f6af0c$var$index)if ($9e6f224f96f6af0c$var$index.hasOwnProperty(e) && $9e6f224f96f6af0c$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $9e6f224f96f6af0c$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $9e6f224f96f6af0c$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $9e6f224f96f6af0c$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $9e6f224f96f6af0c$var$constants, s));
            default:
                return null;
        }
    }
}, $9e6f224f96f6af0c$var$helpers_1 = $9e6f224f96f6af0c$var$helpers, $9e6f224f96f6af0c$var$dependencies = {
    conversions: $9e6f224f96f6af0c$var$index,
    operations: $9e6f224f96f6af0c$var$index$2,
    helpers: $9e6f224f96f6af0c$var$helpers_1
}, $9e6f224f96f6af0c$var$entry = $9e6f224f96f6af0c$var$api_1($9e6f224f96f6af0c$var$dependencies, $9e6f224f96f6af0c$var$constants);
var $9e6f224f96f6af0c$export$2e2bcd8739ae039 = $9e6f224f96f6af0c$var$entry;

});

parcelRegister("eUECn", function(module, exports) {

$parcel$export(module.exports, "AccountMenuTriggerNav3", () => $315290d9faf728a7$export$89d857133932d6aa);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $koVbs = parcelRequire("koVbs");

var $8Pko5 = parcelRequire("8Pko5");

var $7FST0 = parcelRequire("7FST0");

var $ezSxh = parcelRequire("ezSxh");

var $c36kZ = parcelRequire("c36kZ");
function $315290d9faf728a7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $315290d9faf728a7$var$imgStyles = {
    name: "qlds6h",
    styles: "border-radius:50%;width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};
const $315290d9faf728a7$export$89d857133932d6aa = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ picture: picture, email: email, trustPicture: trustPicture = false, ...props }, ref)=>{
    const intl = (0, $koVbs.default)();
    const state = (0, $ezSxh.useImageState)(picture || '');
    const tooltip = intl.formatMessage((0, $c36kZ.messages).triggerTooltip);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8Pko5.Profile), {
        ...props,
        ref: ref,
        tooltip: email || tooltip,
        icon: picture && (trustPicture || state === 'loaded') ? /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
            css: $315290d9faf728a7$var$imgStyles,
            src: picture,
            alt: tooltip
        }) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7FST0))), {
            color: "currentColor",
            label: tooltip,
            LEGACY_size: "medium",
            spacing: "spacious"
        })
    });
});

});
parcelRegister("ezSxh", function(module, exports) {

$parcel$export(module.exports, "useImageState", () => $18b3dc2a6224905c$export$2c1df3428fc3264c);

var $5uXOq = parcelRequire("5uXOq");
const $18b3dc2a6224905c$export$2c1df3428fc3264c = (src)=>{
    const [state, setState] = (0, $5uXOq.useState)('pending');
    const imgRef = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        if (!imgRef.current) {
            imgRef.current = new Image();
            imgRef.current.onload = ()=>setState('loaded');
            imgRef.current.onerror = ()=>setState('error');
        }
        setState('pending');
        imgRef.current.src = src;
    }, [
        src
    ]);
    return state;
};

});

parcelRegister("c36kZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a31c075742ae57a6$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a31c075742ae57a6$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    triggerTooltip: {
        id: 'identity.account-menu.account-menu-popup.skeleton.tooltip',
        defaultMessage: 'Account',
        description: 'Tooltip and alt-text for the account menu item'
    }
});

});


parcelRegister("eufEc", function(module, exports) {

$parcel$export(module.exports, "JSResourceForInteraction", () => $2236bb2e85f415e3$export$e83743682263315a);

var $eIMrK = parcelRequire("eIMrK");

var $ce6VA = parcelRequire("ce6VA");

var $iyWSs = parcelRequire("iyWSs");
const $2236bb2e85f415e3$var$cache = (0, $eIMrK.createCache)(new Map());
function $2236bb2e85f415e3$export$e83743682263315a(loader, opts) {
    return $2236bb2e85f415e3$var$cache.get(opts.moduleId, ()=>(0, $ce6VA.PreloadableJSResource)(()=>(0, $iyWSs.postTask)(loader, {
                priority: 'user-visible'
            }), opts));
}

});

parcelRegister("fEDBv", function(module, exports) {

$parcel$export(module.exports, "createEntryPoint", () => $9a10ed1d48ab8caa$export$fa00dd5c1a75592f);
/* eslint-disable @typescript-eslint/ban-types */ function $9a10ed1d48ab8caa$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}

});

parcelRegister("6EBh3", function(module, exports) {

$parcel$export(module.exports, "AccountMenuContent", () => $174fca08ce98c8fc$export$49c2771125e1e9f1);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");


var $2NMNM = parcelRequire("2NMNM");

var $6q3np = parcelRequire("6q3np");

var $k2tiP = parcelRequire("k2tiP");

var $fptva = parcelRequire("fptva");

var $1bKdn = parcelRequire("1bKdn");

var $bxqXD = parcelRequire("bxqXD");

var $dNE6G = parcelRequire("dNE6G");

var $d9wnW = parcelRequire("d9wnW");

var $3Z96c = parcelRequire("3Z96c");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $k5uoT = parcelRequire("k5uoT");

var $kHCo7 = parcelRequire("kHCo7");

var $1j5Ak = parcelRequire("1j5Ak");

var $chqbk = parcelRequire("chqbk");

var $bWGt6 = parcelRequire("bWGt6");
const $174fca08ce98c8fc$export$49c2771125e1e9f1 = ({ testId: testId, closePopup: closePopup, name: name, picture: picture, email: email, managedBy: managedBy, manageProfileLink: manageProfileLink, viewProfileLink: viewProfileLink, onViewProfileClick: onViewProfileClick, switchAccountLink: switchAccountLink, logOutLink: logOutLink, onThemeChange: onThemeChange, currentTheme: currentTheme, extraMenuItems: extraMenuItems = null })=>{
    const themeSwitcherProps = onThemeChange && currentTheme;
    const shouldRenderProfileThemeSwitcherSection = Boolean(viewProfileLink || manageProfileLink || themeSwitcherProps);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($174fca08ce98c8fc$var$Container, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eZUJu.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9UCCQ.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1j5Ak.AccountDetails), {
        testId: testId && `${testId}--details`,
        name: name,
        picture: picture,
        email: email,
        managedBy: managedBy
    })), shouldRenderProfileThemeSwitcherSection && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9UCCQ.default), null, viewProfileLink && /*#__PURE__*/ (0, $f8Sb3.jsx)($174fca08ce98c8fc$var$ViewProfileLink, {
        onClick: onViewProfileClick,
        testId: testId && `${testId}--view-profile`,
        href: viewProfileLink,
        closePopup: closePopup
    }), manageProfileLink && /*#__PURE__*/ (0, $f8Sb3.jsx)($174fca08ce98c8fc$var$ManageProfileLink, {
        testId: testId && `${testId}--manage-profile`,
        href: manageProfileLink,
        closePopup: closePopup
    }), themeSwitcherProps && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $chqbk.ThemeSwitcher), {
        testId: testId && `${testId}--theme-switcher`,
        onThemeChange: onThemeChange,
        currentTheme: currentTheme
    })), extraMenuItems, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9UCCQ.default), {
        hasSeparator: shouldRenderProfileThemeSwitcherSection
    }, switchAccountLink && /*#__PURE__*/ (0, $f8Sb3.jsx)($174fca08ce98c8fc$var$SwitchAccountLink, {
        testId: testId && `${testId}--switch-account`,
        href: switchAccountLink,
        closePopup: closePopup
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)($174fca08ce98c8fc$var$LogOutLink, {
        testId: testId && `${testId}--log-out`,
        href: logOutLink,
        closePopup: closePopup
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $174fca08ce98c8fc$var$Container = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "evherry0"
})({
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: (0, $k5uoT.gridSize)() * 38
});
const $174fca08ce98c8fc$var$ViewProfileLink = ({ testId: testId, href: href, onClick: onClick, closePopup: closePopup })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($174fca08ce98c8fc$var$Link, {
        testId: testId,
        href: href,
        onClick: onClick,
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bKdn))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium",
            LEGACY_fallbackIcon: (0, $dNE6G.default)
        }),
        closePopup: closePopup,
        actionSubjectId: "viewProfileLink"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        id: "identity.account-menu.account-details.view-profile-tooltip",
        defaultMessage: "Profile",
        description: "Text shown when hovering over profile information"
    }));
const $174fca08ce98c8fc$var$ManageProfileLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($174fca08ce98c8fc$var$Link, {
        testId: testId,
        href: href,
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k2tiP))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium"
        }),
        closePopup: closePopup,
        actionSubjectId: "manageProfileLink",
        target: "_blank",
        rel: "noopener"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        id: "identity.account-menu.account-details.manage-profile-link",
        defaultMessage: "Account settings",
        description: "Text for link to account management page"
    }));
const $174fca08ce98c8fc$var$SwitchAccountLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($174fca08ce98c8fc$var$Link, {
        testId: testId,
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fptva))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium",
            LEGACY_fallbackIcon: (0, $bxqXD.default)
        }),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "switchAccountLink"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        id: "identity.account-menu.account-menu-content.switch-account-button",
        defaultMessage: "Switch account",
        description: "Label for button in account menu to switch to another another account"
    }));
const $174fca08ce98c8fc$var$LogOutLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($174fca08ce98c8fc$var$Link, {
        testId: testId,
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6q3np))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "medium",
            LEGACY_fallbackIcon: (0, $d9wnW.default)
        }),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "logOutLink"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        id: "identity.account-menu.account-menu-content.log-out-button",
        defaultMessage: "Log out",
        description: "Label for button in account menu to log out"
    }));
const $174fca08ce98c8fc$var$Link = ({ testId: testId, closePopup: closePopup, icon: icon, href: href, onClick: onClick, actionSubjectId: actionSubjectId, children: children, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            action: 'clicked',
            actionSubject: 'menuLinkItem',
            actionSubjectId: actionSubjectId
        });
        const clone = analyticsEvent.clone();
        if (clone) clone.fire((0, $kHCo7.NAVIGATION_CHANNEL));
        onClick?.(event, analyticsEvent);
        closePopup?.(event);
    }, [
        createAnalyticsEvent,
        onClick,
        closePopup,
        actionSubjectId
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3Z96c.default), {
        testId: testId,
        iconBefore: icon,
        href: href,
        onClick: handleClick,
        ...props
    }, children);
};

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';

parcelRegister("1j5Ak", function(module, exports) {

$parcel$export(module.exports, "AccountDetails", () => $44d42378b5c841d1$export$66e04d0aacdb3b2);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");

var $1bKdn = parcelRequire("1bKdn");

var $dNE6G = parcelRequire("dNE6G");

var $dS3PR = parcelRequire("dS3PR");


var $k5uoT = parcelRequire("k5uoT");

var $aOl2M = parcelRequire("aOl2M");

var $9FNiA = parcelRequire("9FNiA");

var $bWGt6 = parcelRequire("bWGt6");
function $44d42378b5c841d1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $44d42378b5c841d1$export$66e04d0aacdb3b2 = ({ testId: testId, name: name, picture: picture, email: email, managedBy: managedBy })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($44d42378b5c841d1$var$Container, {
        "data-testid": testId
    }, managedBy && /*#__PURE__*/ (0, $f8Sb3.jsx)($44d42378b5c841d1$var$ManagedBy, null, /*#__PURE__*/ (0, $f8Sb3.jsx)($44d42378b5c841d1$var$PersonIconWrapper, null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bKdn))), {
        color: "currentColor",
        label: "",
        LEGACY_size: "small",
        LEGACY_fallbackIcon: (0, $dNE6G.default)
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        id: "identity.account-menu.account-menu-details.managed-account",
        defaultMessage: "This account is managed by <b>{managedBy}</b>",
        description: "Label showing the user which organisation manages their Atlassian account",
        values: {
            b: (text)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dS3PR.default), {
                    as: "strong",
                    size: "small",
                    color: "inherit"
                }, text),
            managedBy: managedBy
        }
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)($44d42378b5c841d1$var$Content, {
        hasHeader: !!managedBy
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($44d42378b5c841d1$var$Profile, {
        testId: testId,
        name: name,
        picture: picture,
        email: email
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44d42378b5c841d1$var$Container = /*#__PURE__*/ (0, $bWGt6.default)("section", {
    target: "e3lis067"
})({
    display: 'flex',
    flexDirection: 'column',
    margin: `0 ${"var(--ds-space-100, 8px)"}`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44d42378b5c841d1$var$ManagedBy = /*#__PURE__*/ (0, $bWGt6.default)("small", {
    target: "e3lis066"
})({
    display: 'box',
    margin: '0px',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-100, 8px)"}`,
    textAlign: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $k5uoT.borderRadius)()}px ${(0, $k5uoT.borderRadius)()}px 0 0`,
    background: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
    color: "var(--ds-text-subtle, #44546F)"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44d42378b5c841d1$var$PersonIconWrapper = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e3lis065"
})({
    name: "1d1sf9j",
    styles: "margin-right:var(--ds-space-050, 4px);& > span{width:12px;height:12px;}"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44d42378b5c841d1$var$Content = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e3lis064"
})({
    display: 'flex',
    flexDirection: 'column',
    background: `var(--ds-surface-sunken, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ hasHeader: hasHeader })=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: hasHeader ? `0 0 ${(0, $k5uoT.borderRadius)()}px ${(0, $k5uoT.borderRadius)()}px` : `${(0, $k5uoT.borderRadius)()}px`
    }));
const $44d42378b5c841d1$var$Profile = ({ name: name, email: email, picture: picture, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($44d42378b5c841d1$var$ProfileWrapper, null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aOl2M.ProfilePicture), {
        src: picture,
        size: (0, $k5uoT.gridSize)() * 8,
        testId: testId && `${testId}--picture`
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)($44d42378b5c841d1$var$NameAndEmail, null, /*#__PURE__*/ (0, $f8Sb3.jsx)($44d42378b5c841d1$var$DisplayName, {
        "data-testid": testId && `${testId}--name`
    }, name || /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9FNiA.SkeletonText), {
        length: "6em"
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)($44d42378b5c841d1$var$EmailAddress, {
        "data-testid": testId && `${testId}--email`
    }, email || /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9FNiA.SkeletonText), {
        length: "10em"
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44d42378b5c841d1$var$ProfileWrapper = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e3lis063"
})({
    display: 'flex',
    flexDirection: 'row',
    margin: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"}`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44d42378b5c841d1$var$NameAndEmail = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e3lis062"
})({
    display: 'flex',
    flexDirection: 'column',
    margin: `auto 0 auto ${"var(--ds-space-200, 16px)"}`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44d42378b5c841d1$var$DisplayName = /*#__PURE__*/ (0, $bWGt6.default)("h3", {
    target: "e3lis061"
})({
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
    margin: 0
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44d42378b5c841d1$var$EmailAddress = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e3lis060"
})({
    name: "1e1erj1",
    styles: "margin-top:var(--ds-space-025, 2px);color:var(--ds-text-subtlest, #626F86);font-weight:var(--ds-font-weight-regular, 400)"
});

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("aOl2M", function(module, exports) {

$parcel$export(module.exports, "ProfilePicture", () => $7e3ebb52190c5aa0$export$2d75367b6e042d67);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $7FST0 = parcelRequire("7FST0");


var $ezSxh = parcelRequire("ezSxh");
function $7e3ebb52190c5aa0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7e3ebb52190c5aa0$var$imgStyles = {
    name: "1b6qxg",
    styles: "display:block;border-radius:50%"
};
const $7e3ebb52190c5aa0$export$2d75367b6e042d67 = ({ testId: testId, src: src, size: size, className: className })=>{
    const state = (0, $ezSxh.useImageState)(src || '');
    const displayImage = src && state === 'loaded';
    const displayFallback = src && state === 'error';
    const displaySkeleton = !displayImage && !displayFallback;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $f8Sb3.css)({
            width: size,
            height: size,
            ...displaySkeleton && {
                borderRadius: '50%',
                backgroundColor: `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$8d43898f60b96a82})`
            },
            '& svg, & img': {
                width: size,
                height: size
            }
        })
    }, displayImage && /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        "data-testid": testId && `${testId}--img`,
        src: src,
        css: $7e3ebb52190c5aa0$var$imgStyles,
        alt: ""
    }), displayFallback && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7FST0))), {
        spacing: "spacious",
        testId: testId && `${testId}--fallback`,
        label: "",
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`,
        LEGACY_secondaryColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
    }));
};

});

parcelRegister("9FNiA", function(module, exports) {

$parcel$export(module.exports, "SkeletonText", () => $bc870af4b63b46f6$export$cb6ddd830302c2a8);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
const $bc870af4b63b46f6$export$cb6ddd830302c2a8 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ej73sxo0"
})({
    display: 'inline-block',
    height: '1em',
    borderRadius: '0.5em',
    backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
({ length: length })=>({
        width: length
    }));

});


parcelRegister("chqbk", function(module, exports) {

$parcel$export(module.exports, "ThemeSwitcher", () => $c95b2c70e6cea885$export$9d63163ee2173b37);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $BLPHT = parcelRequire("BLPHT");
var $a5n5E = parcelRequire("a5n5E");

var $3uzfU = parcelRequire("3uzfU");

var $826f6 = parcelRequire("826f6");

var $ex8Nz = parcelRequire("ex8Nz");

var $kJpBP = parcelRequire("kJpBP");

var $VSDnB = parcelRequire("VSDnB");

var $alVRE = parcelRequire("alVRE");

var $cImN7 = parcelRequire("cImN7");

var $9DQk8 = parcelRequire("9DQk8");

var $bWGt6 = parcelRequire("bWGt6");
function $c95b2c70e6cea885$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c95b2c70e6cea885$export$9d63163ee2173b37 = ({ testId: testId, onThemeChange: onThemeChange, currentTheme: currentTheme })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
        testId: testId,
        placement: "auto-start",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
                ref: triggerRef,
                onClick: (event)=>event.stopPropagation(),
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($826f6))), {
                    color: "currentColor",
                    label: "",
                    LEGACY_fallbackIcon: (0, $ex8Nz.default)
                }),
                iconAfter: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3uzfU))), {
                    color: "currentColor",
                    label: "",
                    size: "small"
                }),
                ...props,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    id: "identity.account-menu.theme-switcher.theme-button",
                    defaultMessage: "Theme",
                    description: "Label for button in the account menu to switch to a different theme"
                })
            }),
        shouldRenderToParent: (0, $VSDnB.fg)('should-render-to-parent-should-be-true-identity-ki'),
        children: $c95b2c70e6cea885$var$themeOptions.map(({ label: label, value: value, thumbnail: thumbnail })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $a5n5E.default), {
                testId: `${testId}--radio-${value}`,
                id: value,
                onClick: ()=>onThemeChange(value),
                isSelected: currentTheme === value,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)($c95b2c70e6cea885$var$RadioLabelContainer, {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                            src: thumbnail,
                            width: 64,
                            height: 48,
                            alt: ""
                        }),
                        label
                    ]
                })
            }, value))
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c95b2c70e6cea885$var$RadioLabelContainer = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1q43w0o0"
})({
    name: "ql53ha",
    styles: "display:flex;align-items:center;gap:var(--ds-space-150, 12px)"
});
const $c95b2c70e6cea885$var$messages = (0, $7VHMR.defineMessages)({
    light: {
        id: 'identity.account-menu.theme-switcher.light.option',
        defaultMessage: 'Light',
        description: 'Label for the theme switcher light option'
    },
    dark: {
        id: 'identity.account-menu.theme-switcher.dark.option',
        defaultMessage: 'Dark',
        description: 'Label for the theme switcher dark option'
    },
    matchBrowser: {
        id: 'identity.account-menu.theme-switcher.match-browser.option',
        defaultMessage: 'Match browser',
        description: 'Label for the theme switcher match browser option'
    }
});
const $c95b2c70e6cea885$var$themeOptions = [
    {
        label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$c95b2c70e6cea885$var$messages.light
        }),
        value: 'light',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($cImN7)))
    },
    {
        label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$c95b2c70e6cea885$var$messages.dark
        }),
        value: 'dark',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($alVRE)))
    },
    {
        label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$c95b2c70e6cea885$var$messages.matchBrowser
        }),
        value: 'auto',
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($9DQk8)))
    }
];

});
parcelRegister("alVRE", function(module, exports) {
module.exports = new URL("dark-mode.fd95cecc.svg", import.meta.url).toString();

});

parcelRegister("cImN7", function(module, exports) {
module.exports = new URL("light-mode.9ae6186d.svg", import.meta.url).toString();

});

parcelRegister("9DQk8", function(module, exports) {
module.exports = new URL("match-browser.defc82cb.svg", import.meta.url).toString();

});



parcelRegister("hYRTO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c991245d2b4e078$export$2e2bcd8739ae039);

var $4yzdo = parcelRequire("4yzdo");
var $4c991245d2b4e078$export$2e2bcd8739ae039 = (0, $4yzdo.default);

});
parcelRegister("4yzdo", function(module, exports) {

$parcel$export(module.exports, "default", () => $622bc2f4e61c3830$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fNobW = parcelRequire("fNobW");

var $3IRJU = parcelRequire("3IRJU");
var $kkxr3 = parcelRequire("kkxr3");
function $622bc2f4e61c3830$export$2e2bcd8739ae039({ name: name, children: children, fallback: fallback = null }) {
    const waitContext = (0, $5uXOq.useContext)((0, $kkxr3.WaitContext));
    const shouldHold = !waitContext || !!waitContext.currentValue();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3IRJU.LazySuspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                fallback,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fNobW.default), {
                    name: name,
                    hold: shouldHold
                })
            ]
        }),
        name: name,
        children: children
    });
}

});
parcelRegister("fNobW", function(module, exports) {

$parcel$export(module.exports, "default", () => $545cc6aa0f2abe1d$export$2e2bcd8739ae039);

var $eUQkk = parcelRequire("eUQkk");
var $545cc6aa0f2abe1d$export$2e2bcd8739ae039 = (0, $eUQkk.default);

});
parcelRegister("eUQkk", function(module, exports) {

$parcel$export(module.exports, "default", () => $934d1a8b664b9601$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");
const $934d1a8b664b9601$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $5uXOq.useEffect) : (0, $5uXOq.useLayoutEffect);
/**
 * Custom hook to track changes to the interaction ID.
 * Uses a subscription system to automatically update when the interaction ID changes.
 */ function $934d1a8b664b9601$var$useInteractionIdValue() {
    const interactionId = (0, $5uXOq.useContext)((0, $1u4q7.default));
    const [currentId, setCurrentId] = (0, $5uXOq.useState)(interactionId?.current || null);
    $934d1a8b664b9601$var$useLayoutEffectSAFE(()=>{
        setCurrentId(interactionId?.current || null);
        const unsubscribe = (0, $1u4q7.subscribeToInteractionIdChanges)((newId)=>{
            setCurrentId(newId);
        });
        return unsubscribe;
    }, [
        interactionId
    ]);
    return currentId;
}
function $934d1a8b664b9601$export$2e2bcd8739ae039({ children: children, name: name, hold: hold = true, experimental: experimental = false }) {
    const currentInteractionId = $934d1a8b664b9601$var$useInteractionIdValue();
    // react-18: useId instead
    const context = (0, $5uXOq.useContext)((0, $1tcYS.default));
    $934d1a8b664b9601$var$useLayoutEffectSAFE(()=>{
        if (hold && context != null) {
            if (experimental && context.holdExperimental) return context.holdExperimental(name);
            return context.hold(name);
        }
    }, [
        hold,
        context,
        name,
        currentInteractionId
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    }) : null;
}

});


parcelRegister("3IRJU", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => $3a440dc8cf81cf35$export$256c542058532d6f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $3a440dc8cf81cf35$var$isNodeEnvironment = ()=>{
    return typeof window === 'undefined' || window.name === 'nodejs';
};
const $3a440dc8cf81cf35$var$LazySuspenseContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {}),
    setFallback: ()=>{
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    },
    name: ''
});
const $3a440dc8cf81cf35$var$DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
    const { fallback: fallback, setFallback: setFallback } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($3a440dc8cf81cf35$var$LazySuspenseContext);
    (0, $5uXOq.useLayoutEffect)(()=>{
        return ()=>{
            if (!outsideSuspense) setFallback(null);
        };
    }, [
        outsideSuspense,
        setFallback
    ]);
    return children(outsideSuspense ? null : fallback);
};
$3a440dc8cf81cf35$var$DynamicFallback.displayName = 'DynamicFallback';
const $3a440dc8cf81cf35$export$256c542058532d6f = ({ fallback: fallback, children: children, name: name })=>{
    const [hydrationFallback, setHydrationFallback] = (0, $5uXOq.useState)(null);
    const mountedRef = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            fallback: fallback,
            setFallback: (newFallback)=>{
                if (hydrationFallback === newFallback) return;
                setHydrationFallback(newFallback);
            },
            name: name
        }), [
        fallback,
        hydrationFallback,
        name
    ]);
    const renderFallback = (outsideSuspense)=>/*#__PURE__*/ (0, $2OMIu.jsx)($3a440dc8cf81cf35$var$DynamicFallback, {
            outsideSuspense: outsideSuspense,
            children: (resolvedFallback)=>outsideSuspense && hydrationFallback ? hydrationFallback : resolvedFallback
        });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3a440dc8cf81cf35$var$LazySuspenseContext.Provider, {
        value: contextValue,
        children: $3a440dc8cf81cf35$var$isNodeEnvironment() ? children : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: renderFallback(false),
                    children: children
                }),
                (!mountedRef.current || hydrationFallback) && renderFallback(true)
            ]
        })
    });
};
$3a440dc8cf81cf35$export$256c542058532d6f.displayName = 'LazySuspense';

});

parcelRegister("kkxr3", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => $68c2fcae5074d5f5$export$9ba3fe09d15de47b);

var $5uXOq = parcelRequire("5uXOq");
const $68c2fcae5074d5f5$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $5uXOq.createContext)({
    subscribe: ()=>()=>{},
    currentValue: ()=>1
});

});



parcelRegister("lbWm4", function(module, exports) {

var $fmP8r = parcelRequire("fmP8r");

var $e7pfQ = parcelRequire("e7pfQ");

var $2KOtB = parcelRequire("2KOtB");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $f6d7e42845d7fe59$var$forEach(collection, iteratee) {
    var func = $8LQ84(collection) ? $fmP8r : $e7pfQ;
    return func(collection, $2KOtB(iteratee));
}
module.exports = $f6d7e42845d7fe59$var$forEach;

});
parcelRegister("2KOtB", function(module, exports) {

var $etyzk = parcelRequire("etyzk");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $20170833518d35fe$var$castFunction(value) {
    return typeof value == 'function' ? value : $etyzk;
}
module.exports = $20170833518d35fe$var$castFunction;

});


parcelRegister("3T6Xo", function(module, exports) {

var $gDRiW = parcelRequire("gDRiW");
/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $2d4be7a7064f22f9$var$kebabCase = $gDRiW(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
module.exports = $2d4be7a7064f22f9$var$kebabCase;

});

parcelRegister("c74za", function(module, exports) {

var $dgvY6 = parcelRequire("dgvY6");
var $8d19ae39f7480d44$var$Global = $dgvY6.Global;
module.exports = {
    name: 'sessionStorage',
    read: $8d19ae39f7480d44$var$read,
    write: $8d19ae39f7480d44$var$write,
    each: $8d19ae39f7480d44$var$each,
    remove: $8d19ae39f7480d44$var$remove,
    clearAll: $8d19ae39f7480d44$var$clearAll
};
function $8d19ae39f7480d44$var$sessionStorage() {
    return $8d19ae39f7480d44$var$Global.sessionStorage;
}
function $8d19ae39f7480d44$var$read(key) {
    return $8d19ae39f7480d44$var$sessionStorage().getItem(key);
}
function $8d19ae39f7480d44$var$write(key, data) {
    return $8d19ae39f7480d44$var$sessionStorage().setItem(key, data);
}
function $8d19ae39f7480d44$var$each(fn) {
    for(var i = $8d19ae39f7480d44$var$sessionStorage().length - 1; i >= 0; i--){
        var key = $8d19ae39f7480d44$var$sessionStorage().key(i);
        fn($8d19ae39f7480d44$var$read(key), key);
    }
}
function $8d19ae39f7480d44$var$remove(key) {
    return $8d19ae39f7480d44$var$sessionStorage().removeItem(key);
}
function $8d19ae39f7480d44$var$clearAll() {
    return $8d19ae39f7480d44$var$sessionStorage().clear();
}

});

parcelRegister("hqTkp", function(module, exports) {

var $55pzo = parcelRequire("55pzo");

var $g7i7g = parcelRequire("g7i7g");

var $f3SOL = parcelRequire("f3SOL");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $cb0fc8686550aa11$var$without = $g7i7g(function(array, values) {
    return $f3SOL(array) ? $55pzo(array, values) : [];
});
module.exports = $cb0fc8686550aa11$var$without;

});
parcelRegister("55pzo", function(module, exports) {

var $ijRUK = parcelRequire("ijRUK");

var $fUP98 = parcelRequire("fUP98");

var $dA3tP = parcelRequire("dA3tP");

var $1nIHN = parcelRequire("1nIHN");

var $cW28x = parcelRequire("cW28x");

var $40I25 = parcelRequire("40I25");
/** Used as the size to enable large array optimizations. */ var $3b41410a547f22d2$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $3b41410a547f22d2$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $fUP98, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $1nIHN(values, $cW28x(iteratee));
    if (comparator) {
        includes = $dA3tP;
        isCommon = false;
    } else if (values.length >= $3b41410a547f22d2$var$LARGE_ARRAY_SIZE) {
        includes = $40I25;
        isCommon = false;
        values = new $ijRUK(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $3b41410a547f22d2$var$baseDifference;

});


parcelRegister("f4cXA", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("5uXOq")));
})(module.exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("e7WVN", function(module, exports) {

$parcel$export(module.exports, "setInteractionError", () => $e56ceeea538fc730$export$5b689ca7b019e89f);

var $bFU4G = parcelRequire("bFU4G");
function $e56ceeea538fc730$export$5b689ca7b019e89f(interactionName, error) {
    const interaction = (0, $bFU4G.getActiveInteraction)();
    if (!interaction) return;
    if (interaction.ufoName !== interactionName) return;
    (0, $bFU4G.addError)(interaction.id, error.name, null, 'Manual interaction error', error.errorMessage, undefined, true);
}

});

parcelRegister("eTXmK", function(module, exports) {

$parcel$export(module.exports, "default", () => $21211904d99073e5$export$2e2bcd8739ae039);

var $7Jxgt = parcelRequire("7Jxgt");

var $5gx4p = parcelRequire("5gx4p");

var $fe1wc = parcelRequire("fe1wc");

var $tcn7E = parcelRequire("tcn7E");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $9AgLs = parcelRequire("9AgLs");
function $21211904d99073e5$var$traceUFOPress(name, timestamp) {
    const rate = (0, $fe1wc.getInteractionRate)(name, 'press');
    const pressInteractionsList = (0, $fe1wc.getDoNotAbortActivePressInteraction)();
    if (pressInteractionsList?.includes(name)) {
        const interaction = (0, $bFU4G.getActiveInteraction)();
        if (interaction?.ufoName !== 'unknown' && interaction?.type === 'press') return;
    }
    if ((0, $5gx4p.default)(rate)) {
        (0, $bFU4G.abortAll)('new_interaction', name);
        const startTimestamp = timestamp ?? performance.now();
        const newId = (0, $7Jxgt.v4)();
        // covered experiences with tracing instrumentation:
        // inline-result.inline-card-create-submit
        (0, $tcn7E.setInteractionActiveTrace)(newId, 'press');
        (0, $1u4q7.DefaultInteractionID).current = newId;
        (0, $bFU4G.addNewInteraction)(newId, name, 'press', startTimestamp, rate, [], (0, $9AgLs.default).current, (0, $tcn7E.getActiveTrace)());
    }
}
var $21211904d99073e5$export$2e2bcd8739ae039 = $21211904d99073e5$var$traceUFOPress;

});

parcelRegister("bWn3s", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $8b16fea90e636ddb$export$c9058316764c140e);

var $dv0OY = parcelRequire("dv0OY");

var $3XwZB = parcelRequire("3XwZB");
function $8b16fea90e636ddb$export$c9058316764c140e(refs) {
    return (0, $3XwZB.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $dv0OY.assignRef)(ref, newValue)));
}

});
parcelRegister("3XwZB", function(module, exports) {

$parcel$export(module.exports, "createCallbackRef", () => $2e2079715de82b22$export$35a19128eb4acba4);
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $2e2079715de82b22$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}

});


parcelRegister("1RztZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bf212dd22a18c20$export$2e2bcd8739ae039);
// eslint-disable-next-line import/no-extraneous-dependencies

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8GsOl = parcelRequire("8GsOl");


var $iufeS = parcelRequire("iufeS");

var $8RXs9 = parcelRequire("8RXs9");

var $5SFp9 = parcelRequire("5SFp9");

var $kxFlx = parcelRequire("kxFlx");

var $i28qQ = parcelRequire("i28qQ");

var $fVnbM = parcelRequire("fVnbM");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");
const $9bf212dd22a18c20$var$sucessWrapperStyles = (0, $8CUq3.xcss)({
    width: '26px',
    height: '26px',
    borderRadius: '100%',
    padding: 'space.0',
    // @ts-ignore --https://product-fabric.atlassian.net/browse/DSP-20920
    backgroundColor: "var(--ds-icon-success, #22A06B)",
    color: 'color.text.inverse',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $9bf212dd22a18c20$var$discoveryWrapperStyles = (0, $8CUq3.xcss)({
    width: '26px',
    height: '26px',
    borderRadius: '100%',
    padding: 'space.0',
    // @ts-ignore --https://product-fabric.atlassian.net/browse/DSP-20920
    backgroundColor: "var(--ds-icon-discovery, #8270DB)",
    color: 'color.text.inverse',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
var $9bf212dd22a18c20$export$2e2bcd8739ae039 = (0, $8RXs9.default)(({ isOpen: isOpen, title: title, completed: completed, onClick: onClick, onDismiss: onDismiss, intl: intl })=>{
    const hasDismissButton = typeof onDismiss === 'function';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $iufeS.ChecklistButtonWrapper), {
        isOpen: isOpen,
        hasDismissButton: hasDismissButton,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $iufeS.ChecklistButton), {
                completed: Boolean(completed),
                onClick: onClick,
                hasDismissButton: hasDismissButton,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8GsOl))), {
                        LEGACY_size: "medium",
                        color: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                        spacing: "spacious",
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iufeS.ButtonTitle), {
                        children: title
                    })
                ]
            }),
            hasDismissButton && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                onClick: onDismiss,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                style: (0, $iufeS.dismissButtonInlineStyles),
                "aria-label": intl.formatMessage((0, $5SFp9.default).dismissButtonAria, {
                    title: title
                }),
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                    children: (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5ILhZ.default), {
                        xcss: completed ? $9bf212dd22a18c20$var$sucessWrapperStyles : $9bf212dd22a18c20$var$discoveryWrapperStyles,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))), {
                            color: "currentColor",
                            label: '',
                            size: "small"
                        })
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kxFlx))), {
                        label: "",
                        LEGACY_size: "large",
                        color: completed ? `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G500})` : `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$exports).P500})`,
                        LEGACY_secondaryColor: completed ? `var(--ds-background-accent-green-subtlest, ${(0, $829f609a65d26a98$exports).G50})` : `var(--ds-background-accent-purple-subtlest, ${(0, $829f609a65d26a98$exports).P50})`,
                        "aria-hidden": "true"
                    })
                }),
                testId: 'checklist-button--dismiss-button'
            })
        ]
    });
});

});
parcelRegister("iufeS", function(module, exports) {

$parcel$export(module.exports, "ChecklistButton", () => $b5ea09f653dd0ddf$export$39831ffcddfb39de);
$parcel$export(module.exports, "ButtonTitle", () => $b5ea09f653dd0ddf$export$c72d460b11e49d5c);
$parcel$export(module.exports, "ChecklistButtonWrapper", () => $b5ea09f653dd0ddf$export$728120c5a1ef2e80);
$parcel$export(module.exports, "dismissButtonInlineStyles", () => $b5ea09f653dd0ddf$export$a66679212d4257fd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

function $b5ea09f653dd0ddf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b5ea09f653dd0ddf$var$buttonTitleStyles = (0, $8CUq3.xcss)({
    font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    color: 'color.text.inverse',
    margin: '0',
    paddingLeft: 'space.050',
    paddingRight: 'space.100'
});
const $b5ea09f653dd0ddf$export$39831ffcddfb39de = ({ children: children, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        onClick: props.onClick,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $f8Sb3.css)({
            borderRadius: '24px',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            border: 'none',
            outline: 'none',
            whiteSpace: 'nowrap',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: props.completed ? `var(--ds-background-success-bold, ${(0, $829f609a65d26a98$exports).G400})` : `var(--ds-background-discovery-bold, ${(0, $829f609a65d26a98$exports).P300})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: props.hasDismissButton ? `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-500, 40px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}` : `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`,
            boxShadow: `var(--ds-shadow-overlay, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `0 8px 16px -4px ${(0, $829f609a65d26a98$exports).N50A}, 0 0 1px ${(0, $829f609a65d26a98$exports).N60A}`})`,
            transition: 'all 0.8s ease-in-out',
            display: 'inline-flex',
            alignItems: 'center',
            overflow: 'hidden',
            '&:hover': {
                cursor: 'pointer'
            }
        })
    }, children);
const $b5ea09f653dd0ddf$export$c72d460b11e49d5c = ({ children: children })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        as: "h3",
        xcss: $b5ea09f653dd0ddf$var$buttonTitleStyles
    }, children);
const $b5ea09f653dd0ddf$var$fade = {
    name: "74uqaf",
    styles: "from{opacity:0;}to{opacity:1;}@keyframes fade{from{opacity:0;}to{opacity:1;}}animation:fade 0.6s ease-in-out"
};
const $b5ea09f653dd0ddf$var$getChecklistButtonWrapperDisplay = (props)=>{
    if (props.isOpen) {
        if (props.hasDismissButton) return 'inline-block';
        else // TODO: Check if we can simplify this logic, and have inline-block always
        // need to check confluence
        return 'block';
    } else return 'none';
};
const $b5ea09f653dd0ddf$export$728120c5a1ef2e80 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        props.hasDismissButton && `position: relative;`, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: $b5ea09f653dd0ddf$var$getChecklistButtonWrapperDisplay(props)
        }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        $b5ea09f653dd0ddf$var$fade)
    }, children);
const $b5ea09f653dd0ddf$export$a66679212d4257fd = {
    position: 'absolute',
    right: "var(--ds-space-075, 6px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    top: '50%',
    transform: 'translateY(-50%)',
    borderRadius: '50%',
    width: '34px',
    height: '34px'
};

});

parcelRegister("5SFp9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e1592727319fa87$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0e1592727319fa87$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dismissButtonAria: {
        id: 'growth-checklist.dismissButtonAria',
        defaultMessage: 'Dismiss {title}',
        description: 'Text for screen readers only to describe that this will dismiss the button.'
    }
});

});


parcelRegister("bdDiz", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(typeof self !== 'undefined' ? self : module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 3);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var RushaCore = __webpack_require__(5);
            var _require = __webpack_require__(1), toHex = _require.toHex, ceilHeapSize = _require.ceilHeapSize;
            var conv = __webpack_require__(6);
            // Calculate the length of buffer that the sha1 routine uses
            // including the padding.
            var padlen = function(len) {
                for(len += 9; len % 64 > 0; len += 1);
                return len;
            };
            var padZeroes = function(bin, len) {
                var h8 = new Uint8Array(bin.buffer);
                var om = len % 4, align = len - om;
                switch(om){
                    case 0:
                        h8[align + 3] = 0;
                    case 1:
                        h8[align + 2] = 0;
                    case 2:
                        h8[align + 1] = 0;
                    case 3:
                        h8[align + 0] = 0;
                }
                for(var i = (len >> 2) + 1; i < bin.length; i++)bin[i] = 0;
            };
            var padData = function(bin, chunkLen, msgLen) {
                bin[chunkLen >> 2] |= 0x80 << 24 - (chunkLen % 4 << 3);
                // To support msgLen >= 2 GiB, use a float division when computing the
                // high 32-bits of the big-endian message length in bits.
                bin[((chunkLen >> 2) + 2 & -16) + 14] = msgLen / 536870912 | 0;
                bin[((chunkLen >> 2) + 2 & -16) + 15] = msgLen << 3;
            };
            var getRawDigest = function(heap, padMaxChunkLen) {
                var io = new Int32Array(heap, padMaxChunkLen + 320, 5);
                var out = new Int32Array(5);
                var arr = new DataView(out.buffer);
                arr.setInt32(0, io[0], false);
                arr.setInt32(4, io[1], false);
                arr.setInt32(8, io[2], false);
                arr.setInt32(12, io[3], false);
                arr.setInt32(16, io[4], false);
                return out;
            };
            var Rusha = function() {
                function Rusha(chunkSize) {
                    _classCallCheck(this, Rusha);
                    chunkSize = chunkSize || 65536;
                    if (chunkSize % 64 > 0) throw new Error('Chunk size must be a multiple of 128 bit');
                    this._offset = 0;
                    this._maxChunkLen = chunkSize;
                    this._padMaxChunkLen = padlen(chunkSize);
                    // The size of the heap is the sum of:
                    // 1. The padded input message size
                    // 2. The extended space the algorithm needs (320 byte)
                    // 3. The 160 bit state the algoritm uses
                    this._heap = new ArrayBuffer(ceilHeapSize(this._padMaxChunkLen + 320 + 20));
                    this._h32 = new Int32Array(this._heap);
                    this._h8 = new Int8Array(this._heap);
                    this._core = new RushaCore({
                        Int32Array: Int32Array
                    }, {}, this._heap);
                }
                Rusha.prototype._initState = function _initState(heap, padMsgLen) {
                    this._offset = 0;
                    var io = new Int32Array(heap, padMsgLen + 320, 5);
                    io[0] = 1732584193;
                    io[1] = -271733879;
                    io[2] = -1732584194;
                    io[3] = 271733878;
                    io[4] = -1009589776;
                };
                Rusha.prototype._padChunk = function _padChunk(chunkLen, msgLen) {
                    var padChunkLen = padlen(chunkLen);
                    var view = new Int32Array(this._heap, 0, padChunkLen >> 2);
                    padZeroes(view, chunkLen);
                    padData(view, chunkLen, msgLen);
                    return padChunkLen;
                };
                Rusha.prototype._write = function _write(data, chunkOffset, chunkLen, off) {
                    conv(data, this._h8, this._h32, chunkOffset, chunkLen, off || 0);
                };
                Rusha.prototype._coreCall = function _coreCall(data, chunkOffset, chunkLen, msgLen, finalize) {
                    var padChunkLen = chunkLen;
                    this._write(data, chunkOffset, chunkLen);
                    if (finalize) padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                };
                Rusha.prototype.rawDigest = function rawDigest(str) {
                    var msgLen = str.byteLength || str.length || str.size || 0;
                    this._initState(this._heap, this._padMaxChunkLen);
                    var chunkOffset = 0, chunkLen = this._maxChunkLen;
                    for(chunkOffset = 0; msgLen > chunkOffset + chunkLen; chunkOffset += chunkLen)this._coreCall(str, chunkOffset, chunkLen, msgLen, false);
                    this._coreCall(str, chunkOffset, msgLen - chunkOffset, msgLen, true);
                    return getRawDigest(this._heap, this._padMaxChunkLen);
                };
                Rusha.prototype.digest = function digest(str) {
                    return toHex(this.rawDigest(str).buffer);
                };
                Rusha.prototype.digestFromString = function digestFromString(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromBuffer = function digestFromBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromArrayBuffer = function digestFromArrayBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.resetState = function resetState() {
                    this._initState(this._heap, this._padMaxChunkLen);
                    return this;
                };
                Rusha.prototype.append = function append(chunk) {
                    var chunkOffset = 0;
                    var chunkLen = chunk.byteLength || chunk.length || chunk.size || 0;
                    var turnOffset = this._offset % this._maxChunkLen;
                    var inputLen = void 0;
                    this._offset += chunkLen;
                    while(chunkOffset < chunkLen){
                        inputLen = Math.min(chunkLen - chunkOffset, this._maxChunkLen - turnOffset);
                        this._write(chunk, chunkOffset, inputLen, turnOffset);
                        turnOffset += inputLen;
                        chunkOffset += inputLen;
                        if (turnOffset === this._maxChunkLen) {
                            this._core.hash(this._maxChunkLen, this._padMaxChunkLen);
                            turnOffset = 0;
                        }
                    }
                    return this;
                };
                Rusha.prototype.getState = function getState() {
                    var turnOffset = this._offset % this._maxChunkLen;
                    var heap = void 0;
                    if (!turnOffset) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        heap = io.buffer.slice(io.byteOffset, io.byteOffset + io.byteLength);
                    } else heap = this._heap.slice(0);
                    return {
                        offset: this._offset,
                        heap: heap
                    };
                };
                Rusha.prototype.setState = function setState(state) {
                    this._offset = state.offset;
                    if (state.heap.byteLength === 20) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        io.set(new Int32Array(state.heap));
                    } else this._h32.set(new Int32Array(state.heap));
                    return this;
                };
                Rusha.prototype.rawEnd = function rawEnd() {
                    var msgLen = this._offset;
                    var chunkLen = msgLen % this._maxChunkLen;
                    var padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                    var result = getRawDigest(this._heap, this._padMaxChunkLen);
                    this._initState(this._heap, this._padMaxChunkLen);
                    return result;
                };
                Rusha.prototype.end = function end() {
                    return toHex(this.rawEnd().buffer);
                };
                return Rusha;
            }();
            module1.exports = Rusha;
            module1.exports._core = RushaCore;
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            /* eslint-env commonjs, browser */ //
            // toHex
            //
            var precomputedHex = new Array(256);
            for(var i = 0; i < 256; i++)precomputedHex[i] = (i < 0x10 ? '0' : '') + i.toString(16);
            module1.exports.toHex = function(arrayBuffer) {
                var binarray = new Uint8Array(arrayBuffer);
                var res = new Array(arrayBuffer.byteLength);
                for(var _i = 0; _i < res.length; _i++)res[_i] = precomputedHex[binarray[_i]];
                return res.join('');
            };
            //
            // ceilHeapSize
            //
            module1.exports.ceilHeapSize = function(v) {
                // The asm.js spec says:
                // The heap object's byteLength must be either
                // 2^n for n in [12, 24) or 2^24 * n for n ≥ 1.
                // Also, byteLengths smaller than 2^16 are deprecated.
                var p = 0;
                // If v is smaller than 2^16, the smallest possible solution
                // is 2^16.
                if (v <= 65536) return 65536;
                // If v < 2^24, we round up to 2^n,
                // otherwise we round up to 2^24 * n.
                if (v < 16777216) {
                    for(p = 1; p < v; p = p << 1);
                } else {
                    for(p = 16777216; p < v; p += 16777216);
                }
                return p;
            };
            //
            // isDedicatedWorkerScope
            //
            module1.exports.isDedicatedWorkerScope = function(self1) {
                var isRunningInWorker = 'WorkerGlobalScope' in self1 && self1 instanceof self1.WorkerGlobalScope;
                var isRunningInSharedWorker = 'SharedWorkerGlobalScope' in self1 && self1 instanceof self1.SharedWorkerGlobalScope;
                var isRunningInServiceWorker = 'ServiceWorkerGlobalScope' in self1 && self1 instanceof self1.ServiceWorkerGlobalScope;
                // Detects whether we run inside a dedicated worker or not.
                //
                // We can't just check for `DedicatedWorkerGlobalScope`, since IE11
                // has a bug where it only supports `WorkerGlobalScope`.
                //
                // Therefore, we consider us as running inside a dedicated worker
                // when we are running inside a worker, but not in a shared or service worker.
                //
                // When new types of workers are introduced, we will need to adjust this code.
                return isRunningInWorker && !isRunningInSharedWorker && !isRunningInServiceWorker;
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, worker */ module1.exports = function() {
                var Rusha = __webpack_require__(0);
                var hashData = function(hasher, data, cb) {
                    try {
                        return cb(null, hasher.digest(data));
                    } catch (e) {
                        return cb(e);
                    }
                };
                var hashFile = function(hasher, readTotal, blockSize, file, cb) {
                    var reader = new self.FileReader();
                    reader.onloadend = function onloadend() {
                        if (reader.error) return cb(reader.error);
                        var buffer = reader.result;
                        readTotal += reader.result.byteLength;
                        try {
                            hasher.append(buffer);
                        } catch (e) {
                            cb(e);
                            return;
                        }
                        if (readTotal < file.size) hashFile(hasher, readTotal, blockSize, file, cb);
                        else cb(null, hasher.end());
                    };
                    reader.readAsArrayBuffer(file.slice(readTotal, readTotal + blockSize));
                };
                var workerBehaviourEnabled = true;
                self.onmessage = function(event) {
                    if (!workerBehaviourEnabled) return;
                    var data = event.data.data, file = event.data.file, id = event.data.id;
                    if (typeof id === 'undefined') return;
                    if (!file && !data) return;
                    var blockSize = event.data.blockSize || 4194304;
                    var hasher = new Rusha(blockSize);
                    hasher.resetState();
                    var done = function(err, hash) {
                        if (!err) self.postMessage({
                            id: id,
                            hash: hash
                        });
                        else self.postMessage({
                            id: id,
                            error: err.name
                        });
                    };
                    if (data) hashData(hasher, data, done);
                    if (file) hashFile(hasher, 0, blockSize, file, done);
                };
                return function() {
                    workerBehaviourEnabled = false;
                };
            };
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, browser */ var work = __webpack_require__(4);
            var Rusha = __webpack_require__(0);
            var createHash = __webpack_require__(7);
            var runWorker = __webpack_require__(2);
            var _require = __webpack_require__(1), isDedicatedWorkerScope = _require.isDedicatedWorkerScope;
            var isRunningInDedicatedWorker = typeof self !== 'undefined' && isDedicatedWorkerScope(self);
            Rusha.disableWorkerBehaviour = isRunningInDedicatedWorker ? runWorker() : function() {};
            Rusha.createWorker = function() {
                var worker = work(/*require.resolve*/ 2);
                var terminate = worker.terminate;
                worker.terminate = function() {
                    URL.revokeObjectURL(worker.objectURL);
                    terminate.call(worker);
                };
                return worker;
            };
            Rusha.createHash = createHash;
            module1.exports = Rusha;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            function webpackBootstrapFunc(modules) {
                /******/ // The module cache
                /******/ var installedModules = {};
                /******/ // The require function
                /******/ function __webpack_require__(moduleId) {
                    /******/ // Check if module is in cache
                    /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
                    /******/ // Create a new module (and put it into the cache)
                    /******/ var module1 = installedModules[moduleId] = {
                        /******/ i: moduleId,
                        /******/ l: false,
                        /******/ exports: {}
                    };
                    /******/ // Execute the module function
                    /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
                    /******/ // Flag the module as loaded
                    /******/ module1.l = true;
                    /******/ // Return the exports of the module
                    /******/ return module1.exports;
                /******/ }
                /******/ // expose the modules object (__webpack_modules__)
                /******/ __webpack_require__.m = modules;
                /******/ // expose the module cache
                /******/ __webpack_require__.c = installedModules;
                /******/ // identity function for calling harmony imports with the correct context
                /******/ __webpack_require__.i = function(value) {
                    return value;
                };
                /******/ // define getter function for harmony exports
                /******/ __webpack_require__.d = function(exports, name, getter) {
                    /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                        /******/ configurable: false,
                        /******/ enumerable: true,
                        /******/ get: getter
                    });
                /******/ };
                /******/ // define __esModule on exports
                /******/ __webpack_require__.r = function(exports) {
                    /******/ Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                /******/ };
                /******/ // getDefaultExport function for compatibility with non-harmony modules
                /******/ __webpack_require__.n = function(module1) {
                    /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                        return module1['default'];
                    } : /******/ function getModuleExports() {
                        return module1;
                    };
                    /******/ __webpack_require__.d(getter, 'a', getter);
                    /******/ return getter;
                /******/ };
                /******/ // Object.prototype.hasOwnProperty.call
                /******/ __webpack_require__.o = function(object, property) {
                    return Object.prototype.hasOwnProperty.call(object, property);
                };
                /******/ // __webpack_public_path__
                /******/ __webpack_require__.p = "/";
                /******/ // on error function for async loading
                /******/ __webpack_require__.oe = function(err) {
                    console.error(err);
                    throw err;
                };
                var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE);
                return f.default || f // try to call default if defined to also support babel esmodule exports
                ;
            }
            var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+';
            var dependencyRegExp = '\\((\/\\*.*?\\*\/)?\s?.*?(' + moduleNameReqExp + ').*?\\)' // additional chars when output.pathinfo is true
            ;
            // http://stackoverflow.com/a/2593661/130442
            function quoteRegExp(str) {
                return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
            }
            function getModuleDependencies(sources, module1, queueName) {
                var retval = {};
                retval[queueName] = [];
                var fnString = module1.toString();
                var wrapperSignature = fnString.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);
                if (!wrapperSignature) return retval;
                var webpackRequireName = wrapperSignature[1];
                // main bundle deps
                var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g');
                var match;
                while(match = re.exec(fnString)){
                    if (match[3] === 'dll-reference') continue;
                    retval[queueName].push(match[3]);
                }
                // dll deps
                re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g');
                while(match = re.exec(fnString)){
                    if (!sources[match[2]]) {
                        retval[queueName].push(match[1]);
                        sources[match[2]] = __webpack_require__(match[1]).m;
                    }
                    retval[match[2]] = retval[match[2]] || [];
                    retval[match[2]].push(match[4]);
                }
                return retval;
            }
            function hasValuesInQueues(queues) {
                var keys = Object.keys(queues);
                return keys.reduce(function(hasValues, key) {
                    return hasValues || queues[key].length > 0;
                }, false);
            }
            function getRequiredModules(sources, moduleId) {
                var modulesQueue = {
                    main: [
                        moduleId
                    ]
                };
                var requiredModules = {
                    main: []
                };
                var seenModules = {
                    main: {}
                };
                while(hasValuesInQueues(modulesQueue)){
                    var queues = Object.keys(modulesQueue);
                    for(var i = 0; i < queues.length; i++){
                        var queueName = queues[i];
                        var queue = modulesQueue[queueName];
                        var moduleToCheck = queue.pop();
                        seenModules[queueName] = seenModules[queueName] || {};
                        if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue;
                        seenModules[queueName][moduleToCheck] = true;
                        requiredModules[queueName] = requiredModules[queueName] || [];
                        requiredModules[queueName].push(moduleToCheck);
                        var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName);
                        var newModulesKeys = Object.keys(newModules);
                        for(var j = 0; j < newModulesKeys.length; j++){
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || [];
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]]);
                        }
                    }
                }
                return requiredModules;
            }
            module1.exports = function(moduleId, options) {
                options = options || {};
                var sources = {
                    main: __webpack_require__.m
                };
                var requiredModules = options.all ? {
                    main: Object.keys(sources)
                } : getRequiredModules(sources, moduleId);
                var src = '';
                Object.keys(requiredModules).filter(function(m) {
                    return m !== 'main';
                }).forEach(function(module1) {
                    var entryModule = 0;
                    while(requiredModules[module1][entryModule])entryModule++;
                    requiredModules[module1].push(entryModule);
                    sources[module1][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })';
                    src = src + 'var ' + module1 + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module1].map(function(id) {
                        return '' + JSON.stringify(id) + ': ' + sources[module1][id].toString();
                    }).join(',') + '});\n';
                });
                src = src + '(' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function(id) {
                    return '' + JSON.stringify(id) + ': ' + sources.main[id].toString();
                }).join(',') + '})(self);';
                var blob = new window.Blob([
                    src
                ], {
                    type: 'text/javascript'
                });
                if (options.bare) return blob;
                var URL1 = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var workerUrl = URL1.createObjectURL(blob);
                var worker = new window.Worker(workerUrl);
                worker.objectURL = workerUrl;
                return worker;
            };
        /***/ },
        /* 5 */ /***/ function(module1, exports) {
            // The low-level RushCore module provides the heart of Rusha,
            // a high-speed sha1 implementation working on an Int32Array heap.
            // At first glance, the implementation seems complicated, however
            // with the SHA1 spec at hand, it is obvious this almost a textbook
            // implementation that has a few functions hand-inlined and a few loops
            // hand-unrolled.
            module1.exports = function RushaCore(stdlib$846, foreign$847, heap$848) {
                'use asm';
                var H$849 = new stdlib$846.Int32Array(heap$848);
                function hash$850(k$851, x$852) {
                    // k in bytes
                    k$851 = k$851 | 0;
                    x$852 = x$852 | 0;
                    var i$853 = 0, j$854 = 0, y0$855 = 0, z0$856 = 0, y1$857 = 0, z1$858 = 0, y2$859 = 0, z2$860 = 0, y3$861 = 0, z3$862 = 0, y4$863 = 0, z4$864 = 0, t0$865 = 0, t1$866 = 0;
                    y0$855 = H$849[x$852 + 320 >> 2] | 0;
                    y1$857 = H$849[x$852 + 324 >> 2] | 0;
                    y2$859 = H$849[x$852 + 328 >> 2] | 0;
                    y3$861 = H$849[x$852 + 332 >> 2] | 0;
                    y4$863 = H$849[x$852 + 336 >> 2] | 0;
                    for(i$853 = 0; (i$853 | 0) < (k$851 | 0); i$853 = i$853 + 64 | 0){
                        z0$856 = y0$855;
                        z1$858 = y1$857;
                        z2$860 = y2$859;
                        z3$862 = y3$861;
                        z4$864 = y4$863;
                        for(j$854 = 0; (j$854 | 0) < 64; j$854 = j$854 + 4 | 0){
                            t1$866 = H$849[i$853 + j$854 >> 2] | 0;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | ~y1$857 & y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1518500249 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[k$851 + j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 64 | 0; (j$854 | 0) < (k$851 + 80 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | ~y1$857 & y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1518500249 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 80 | 0; (j$854 | 0) < (k$851 + 160 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 ^ y2$859 ^ y3$861) | 0) + ((t1$866 + y4$863 | 0) + 1859775393 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 160 | 0; (j$854 | 0) < (k$851 + 240 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 & y2$859 | y1$857 & y3$861 | y2$859 & y3$861) | 0) + ((t1$866 + y4$863 | 0) - 1894007588 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        for(j$854 = k$851 + 240 | 0; (j$854 | 0) < (k$851 + 320 | 0); j$854 = j$854 + 4 | 0){
                            t1$866 = (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) << 1 | (H$849[j$854 - 12 >> 2] ^ H$849[j$854 - 32 >> 2] ^ H$849[j$854 - 56 >> 2] ^ H$849[j$854 - 64 >> 2]) >>> 31;
                            t0$865 = ((y0$855 << 5 | y0$855 >>> 27) + (y1$857 ^ y2$859 ^ y3$861) | 0) + ((t1$866 + y4$863 | 0) - 899497514 | 0) | 0;
                            y4$863 = y3$861;
                            y3$861 = y2$859;
                            y2$859 = y1$857 << 30 | y1$857 >>> 2;
                            y1$857 = y0$855;
                            y0$855 = t0$865;
                            H$849[j$854 >> 2] = t1$866;
                        }
                        y0$855 = y0$855 + z0$856 | 0;
                        y1$857 = y1$857 + z1$858 | 0;
                        y2$859 = y2$859 + z2$860 | 0;
                        y3$861 = y3$861 + z3$862 | 0;
                        y4$863 = y4$863 + z4$864 | 0;
                    }
                    H$849[x$852 + 320 >> 2] = y0$855;
                    H$849[x$852 + 324 >> 2] = y1$857;
                    H$849[x$852 + 328 >> 2] = y2$859;
                    H$849[x$852 + 332 >> 2] = y3$861;
                    H$849[x$852 + 336 >> 2] = y4$863;
                }
                return {
                    hash: hash$850
                };
            };
        /***/ },
        /* 6 */ /***/ function(module1, exports) {
            var _this = this;
            /* eslint-env commonjs, browser */ var reader = void 0;
            if (typeof self !== 'undefined' && typeof self.FileReaderSync !== 'undefined') reader = new self.FileReaderSync();
            // Convert a binary string and write it to the heap.
            // A binary string is expected to only contain char codes < 256.
            var convStr = function(str, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = str.charCodeAt(start + 3);
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = str.charCodeAt(start + 2);
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = str.charCodeAt(start + 1);
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = str.charCodeAt(start);
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2] = str.charCodeAt(start + i) << 24 | str.charCodeAt(start + i + 1) << 16 | str.charCodeAt(start + i + 2) << 8 | str.charCodeAt(start + i + 3);
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = str.charCodeAt(start + j + 2);
                    case 2:
                        H8[off + j + 2 | 0] = str.charCodeAt(start + j + 1);
                    case 1:
                        H8[off + j + 3 | 0] = str.charCodeAt(start + j);
                }
            };
            // Convert a buffer or array and write it to the heap.
            // The buffer or array is expected to only contain elements < 256.
            var convBuf = function(buf, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = buf[start + 3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[start + 2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[start + 1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[start];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[start + i] << 24 | buf[start + i + 1] << 16 | buf[start + i + 2] << 8 | buf[start + i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[start + j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[start + j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[start + j];
                }
            };
            var convBlob = function(blob, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                var buf = new Uint8Array(reader.readAsArrayBuffer(blob.slice(start, start + len)));
                switch(om){
                    case 0:
                        H8[off] = buf[3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[0];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[i] << 24 | buf[i + 1] << 16 | buf[i + 2] << 8 | buf[i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[j];
                }
            };
            module1.exports = function(data, H8, H32, start, len, off) {
                if (typeof data === 'string') return convStr(data, H8, H32, start, len, off);
                if (data instanceof Array) return convBuf(data, H8, H32, start, len, off);
                // Safely doing a Buffer check using "this" to avoid Buffer polyfill to be included in the dist
                if (_this && _this.Buffer && _this.Buffer.isBuffer(data)) return convBuf(data, H8, H32, start, len, off);
                if (data instanceof ArrayBuffer) return convBuf(new Uint8Array(data), H8, H32, start, len, off);
                if (data.buffer instanceof ArrayBuffer) return convBuf(new Uint8Array(data.buffer, data.byteOffset, data.byteLength), H8, H32, start, len, off);
                if (data instanceof Blob) return convBlob(data, H8, H32, start, len, off);
                throw new Error('Unsupported data type.');
            };
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var Rusha = __webpack_require__(0);
            var _require = __webpack_require__(1), toHex = _require.toHex;
            var Hash = function() {
                function Hash() {
                    _classCallCheck(this, Hash);
                    this._rusha = new Rusha();
                    this._rusha.resetState();
                }
                Hash.prototype.update = function update(data) {
                    this._rusha.append(data);
                    return this;
                };
                Hash.prototype.digest = function digest(encoding) {
                    var digest = this._rusha.rawEnd().buffer;
                    if (!encoding) return digest;
                    if (encoding === 'hex') return toHex(digest);
                    throw new Error('unsupported digest encoding');
                };
                return Hash;
            }();
            module1.exports = function() {
                return new Hash();
            };
        /***/ }
    ]);
});

});

parcelRegister("8XFbn", function(module, exports) {

$parcel$export(module.exports, "getHamsKey", () => $c47c0dbfbddbf4a9$export$291d012eb0744b34);
const $c47c0dbfbddbf4a9$var$ProductKeyToHAMSMap = {
    ['confluence']: 'confluence',
    ['jira']: 'jira-software',
    ['jira-product-discovery']: 'jira-product-discovery',
    ['jira-service-management']: 'jira-servicedesk'
};
const $c47c0dbfbddbf4a9$export$291d012eb0744b34 = (product)=>{
    return $c47c0dbfbddbf4a9$var$ProductKeyToHAMSMap[product];
};

});

parcelRegister("6Csk1", function(module, exports) {

var $hsOo6 = parcelRequire("hsOo6");

var $4NkAS = parcelRequire("4NkAS");

var $9MM2g = parcelRequire("9MM2g");

var $hTJwX = parcelRequire("hTJwX");

var $evszO = parcelRequire("evszO");

var $66FNL = parcelRequire("66FNL");
/** Used for built-in method references. */ var $4d1c42d4f14298ee$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4d1c42d4f14298ee$var$hasOwnProperty = $4d1c42d4f14298ee$var$objectProto.hasOwnProperty;
/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */ var $4d1c42d4f14298ee$var$assign = $9MM2g(function(object, source) {
    if ($evszO(source) || $hTJwX(source)) {
        $4NkAS(source, $66FNL(source), object);
        return;
    }
    for(var key in source)if ($4d1c42d4f14298ee$var$hasOwnProperty.call(source, key)) $hsOo6(object, key, source[key]);
});
module.exports = $4d1c42d4f14298ee$var$assign;

});

parcelRegister("jFnH8", function(module, exports) {

$parcel$export(module.exports, "Behaviours", () => (parcelRequire("cJg0i")).Behaviours);
$parcel$export(module.exports, "TargetTabs", () => (parcelRequire("cJg0i")).TargetTabs);
$parcel$export(module.exports, "Prompts", () => (parcelRequire("cJg0i")).Prompts);
$parcel$export(module.exports, "createProvisioningPageExtensions", () => (parcelRequire("gP7sO")).createProvisioningPageExtensions);
$parcel$export(module.exports, "createProvisioningApiExtensions", () => (parcelRequire("jiQLJ")).createProvisioningApiExtensions);
$parcel$export(module.exports, "createRecommendationContextExtensions", () => (parcelRequire("bG1bs")).createRecommendationContextExtensions);

var $cJg0i = parcelRequire("cJg0i");

var $b1Kvi = parcelRequire("b1Kvi");

var $fh3Yg = parcelRequire("fh3Yg");

var $jaORC = parcelRequire("jaORC");

var $gP7sO = parcelRequire("gP7sO");

var $jiQLJ = parcelRequire("jiQLJ");

var $bG1bs = parcelRequire("bG1bs");

var $9xYqG = parcelRequire("9xYqG");

});
parcelRegister("cJg0i", function(module, exports) {

$parcel$export(module.exports, "Behaviours", () => $5fe0e6234d117982$export$993d0f36af4bf76f);
$parcel$export(module.exports, "TargetTabs", () => $5fe0e6234d117982$export$c57f0d43fd595f43);
$parcel$export(module.exports, "Prompts", () => $5fe0e6234d117982$export$d1609d6291f3d60d);
const $5fe0e6234d117982$export$696c71818ae3f184 = {
    FREE: 'free',
    STANDARD: 'standard',
    PREMIUM: 'premium',
    ESSENTIALS: 'essentials',
    ENTERPRISE: 'enterprise'
};
const $5fe0e6234d117982$export$993d0f36af4bf76f = {
    LAND: 'land',
    CLOSE: 'close'
};
const $5fe0e6234d117982$export$c57f0d43fd595f43 = {
    SAME: 'same',
    NEW: 'new'
};
const $5fe0e6234d117982$export$d1609d6291f3d60d = {
    NEXT: 'next',
    CLOSE: 'close',
    GO_TO_PRODUCT: 'go-to-product',
    RETURN_TO_PRODUCT: 'return-to-product'
};

});

parcelRegister("b1Kvi", function(module, exports) {

var $9xYqG = parcelRequire("9xYqG");

var $cJg0i = parcelRequire("cJg0i");
const $ad4411e35d2d8c65$export$196a138f6d49c2bb = [
    'edition'
];
const $ad4411e35d2d8c65$export$28c762e8047316d8 = (0, $9xYqG.createProductExtensions)($ad4411e35d2d8c65$export$196a138f6d49c2bb);

});
parcelRegister("9xYqG", function(module, exports) {

$parcel$export(module.exports, "createProductExtensions", () => $7b705e4156365c5d$export$42e62ee12e8ced48);
parcelRequire("jWY5k");
var $a0mnO = parcelRequire("a0mnO");
const $7b705e4156365c5d$export$9143c254bff9f7b7 = (object, propertyNames)=>propertyNames.reduce((accumulator, property)=>{
        const value = object[property];
        if (value !== undefined) accumulator[property] = value;
        return accumulator;
    }, {});
const $7b705e4156365c5d$export$42e62ee12e8ced48 = (extensionsWhitelist)=>(options)=>{
        const filteredOptions = $7b705e4156365c5d$export$9143c254bff9f7b7(options, extensionsWhitelist);
        return new (0, $a0mnO.CrossFlowExtensions)(filteredOptions);
    };
const $7b705e4156365c5d$export$86a865d89ef3c690 = (...extensions)=>{
    const combinedOptions = Object.assign({}, ...extensions);
    return new (0, $a0mnO.CrossFlowExtensions)(combinedOptions);
};

});
parcelRegister("jWY5k", function(module, exports) {

$parcel$export(module.exports, "CrossFlowExtensions", () => (parcelRequire("a0mnO")).CrossFlowExtensions);
$parcel$export(module.exports, "Targets", () => (parcelRequire("eGnH0")).Targets);

var $a0mnO = parcelRequire("a0mnO");

var $eGnH0 = parcelRequire("eGnH0");

});
parcelRegister("a0mnO", function(module, exports) {

$parcel$export(module.exports, "CrossFlowExtensions", () => $4d8edd1cb612639e$export$a5e53d1dcbd6eb61);
class $4d8edd1cb612639e$export$a5e53d1dcbd6eb61 {
    constructor(options){
        Object.assign(this, options);
        Object.freeze(this);
    }
}

});

parcelRegister("eGnH0", function(module, exports) {

$parcel$export(module.exports, "Targets", () => $f1c0dfa9569fbb1b$export$59a8eb9cff113544);
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ const $f1c0dfa9569fbb1b$export$59a8eb9cff113544 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    JIRA_CUSTOMER_SERVICE: 'jira-customer-service',
    BITBUCKET: 'bitbucket.ondemand',
    TRELLO: 'trello',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    /**
	 * @private
	 * @deprecated Use ATLAS instead
	 */ TEAM_CENTRAL: 'townsquare',
    ATLAS: 'townsquare',
    /**
	 * @private
	 * @deprecated
	 */ AVOCADO: 'avocado',
    ANALYTICS: 'atlassian-analytics-free',
    COMPASS: 'compass',
    LOOM: 'loom',
    ROVO: 'rovo.ondemand'
};

});




parcelRegister("fh3Yg", function(module, exports) {

var $9xYqG = parcelRequire("9xYqG");

var $cJg0i = parcelRequire("cJg0i");
const $353da589146b832d$export$390f3b1f433f2095 = [
    'edition',
    'migrationSourceUuid',
    'grantAccessTo'
];
const $353da589146b832d$export$386012fe624cad4 = (0, $9xYqG.createProductExtensions)($353da589146b832d$export$390f3b1f433f2095);

});

parcelRegister("jaORC", function(module, exports) {

var $9xYqG = parcelRequire("9xYqG");

var $cJg0i = parcelRequire("cJg0i");
const $638bae63202e03ae$export$c41268b4369999ed = [
    'edition',
    'migrationSourceUuid'
];
const $638bae63202e03ae$export$a60e4abab2cc3b2b = (0, $9xYqG.createProductExtensions)($638bae63202e03ae$export$c41268b4369999ed);

});

parcelRegister("gP7sO", function(module, exports) {

$parcel$export(module.exports, "createProvisioningPageExtensions", () => $57002cfa239290dc$export$f05508383d0ca130);

var $9xYqG = parcelRequire("9xYqG");
const $57002cfa239290dc$export$99f81e179e225ceb = [
    'provisioningPageOptions'
];
const $57002cfa239290dc$export$f05508383d0ca130 = (options)=>(0, $9xYqG.createProductExtensions)($57002cfa239290dc$export$99f81e179e225ceb)({
        provisioningPageOptions: options
    });

});

parcelRegister("jiQLJ", function(module, exports) {

$parcel$export(module.exports, "createProvisioningApiExtensions", () => $8f278686bdd56b47$export$530ae557c94159b9);

var $9xYqG = parcelRequire("9xYqG");
const $8f278686bdd56b47$export$bba48927994d7f26 = [
    'provisioningApiParams'
];
const $8f278686bdd56b47$export$530ae557c94159b9 = (options)=>(0, $9xYqG.createProductExtensions)($8f278686bdd56b47$export$bba48927994d7f26)({
        provisioningApiParams: options
    });

});

parcelRegister("bG1bs", function(module, exports) {

$parcel$export(module.exports, "createRecommendationContextExtensions", () => $e4df05e4385e1ca7$export$d1baeed0bd0517aa);

var $9xYqG = parcelRequire("9xYqG");
const $e4df05e4385e1ca7$export$4227e3a27cbd377 = [
    'recommendationContext'
];
const $e4df05e4385e1ca7$export$d1baeed0bd0517aa = (options)=>(0, $9xYqG.createProductExtensions)($e4df05e4385e1ca7$export$4227e3a27cbd377)({
        recommendationContext: options
    });

});


parcelRegister("bHpB9", function(module, exports) {

$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("7wLxr")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("7wLxr")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("7wLxr")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("lEtNM")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("lEtNM")).Reasons);

var $7wLxr = parcelRequire("7wLxr");

var $lEtNM = parcelRequire("lEtNM");

});
parcelRegister("7wLxr", function(module, exports) {

$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => $df7415e1fd91aa6d$export$c0ddec072762f62a);
$parcel$export(module.exports, "useCrossFlow", () => $df7415e1fd91aa6d$export$6e7a10fe635a0dfc);
$parcel$export(module.exports, "withCrossFlow", () => $df7415e1fd91aa6d$export$655b6c19a0daddb8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $aMvxT = parcelRequire("aMvxT");

var $8lCrJ = parcelRequire("8lCrJ");

var $lEtNM = parcelRequire("lEtNM");
const $df7415e1fd91aa6d$var$LATEST_VERSION = (0, $8lCrJ.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $df7415e1fd91aa6d$var$CrossFlowContext = /*#__PURE__*/ (0, $5uXOq.createContext)(()=>({
        isEnabled: false,
        reason: (0, $lEtNM.Reasons).NO_PROVIDER
    }));
const $df7415e1fd91aa6d$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $8lCrJ.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $aMvxT.createAPIv0)(onOpen),
                    apiV1: (0, $8lCrJ.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $lEtNM.Reasons).NO_API_SUPPORT
                };
        }
    };
const $df7415e1fd91aa6d$export$c0ddec072762f62a = ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $5uXOq.useMemo)(()=>$df7415e1fd91aa6d$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($df7415e1fd91aa6d$var$CrossFlowContext.Provider, {
        value: negotiateApi,
        children: children
    });
};
const $df7415e1fd91aa6d$export$6e7a10fe635a0dfc = ()=>{
    const negotiateApi = (0, $5uXOq.useContext)($df7415e1fd91aa6d$var$CrossFlowContext);
    return (0, $5uXOq.useMemo)(()=>negotiateApi($df7415e1fd91aa6d$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $df7415e1fd91aa6d$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (props)=>{
        const crossFlow = $df7415e1fd91aa6d$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}

});
parcelRegister("aMvxT", function(module, exports) {

$parcel$export(module.exports, "createAPIv0", () => $626f88795be3264e$export$9ff7368ac93fcf2d);
const $626f88795be3264e$export$a4ad2735b021c132 = 0;
const $626f88795be3264e$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });

});

parcelRegister("8lCrJ", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $b436661ee398aae0$export$a4ad2735b021c132);
$parcel$export(module.exports, "createAPIv1", () => $b436661ee398aae0$export$8fd5792fc468459f);
const $b436661ee398aae0$export$a4ad2735b021c132 = 1;
const $b436661ee398aae0$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });

});

parcelRegister("lEtNM", function(module, exports) {

$parcel$export(module.exports, "Journeys", () => $19f792998fd3f757$export$3411873bfd520bb6);
$parcel$export(module.exports, "Reasons", () => $19f792998fd3f757$export$da2d4f2f250d6f84);
const $19f792998fd3f757$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $19f792998fd3f757$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};

});



parcelRegister("6WDs0", function(module, exports) {

$parcel$export(module.exports, "isOptoutAllMessages", () => $e81fc56506ae3b33$export$aa440d3a24a2d79a);
$parcel$export(module.exports, "useIsOptoutAllMessages", () => $e81fc56506ae3b33$export$7d4c6b519725ba3b);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

const $e81fc56506ae3b33$var$getTraceId = (response)=>{
    const traceIdHeader = [
        'atl-traceid',
        'x-trace-id'
    ].find((header)=>response.headers?.has(header));
    return traceIdHeader === undefined ? undefined : response.headers.get(traceIdHeader) ?? undefined;
};
class $e81fc56506ae3b33$var$FetchError extends Error {
    constructor(statusCode, message, traceId, originalResponse){
        super(message || `Fetch call failed with status code: ${statusCode}`);
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.originalResponse = originalResponse;
        this.skipSentry = statusCode === 401;
        if (traceId) this.traceId = traceId;
    }
}
const $e81fc56506ae3b33$var$getDevHostname = ()=>{
    const envDns = undefined;
    return typeof envDns === 'string' && envDns.trim() ? envDns.trim() : 'localhost';
};
const $e81fc56506ae3b33$var$getProxyServerPort = ()=>{
    return 9000;
};
const $e81fc56506ae3b33$var$LOCAL_URL = new URL(`${'http'}://${$e81fc56506ae3b33$var$getDevHostname()}:${$e81fc56506ae3b33$var$getProxyServerPort()}`);
const $e81fc56506ae3b33$var$getReroutableURL = (pathOrURL)=>{
    var e;
    return pathOrURL;
};
const $e81fc56506ae3b33$var$defaultOptions = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ]
    }
};
let $e81fc56506ae3b33$var$cachedFetches = {};
const $e81fc56506ae3b33$var$fetchJsonWithCache = (url, options = {})=>{
    let fetchPromise = $e81fc56506ae3b33$var$cachedFetches[url];
    if (fetchPromise) return fetchPromise;
    fetchPromise = fetch($e81fc56506ae3b33$var$getReroutableURL(url), {
        ...$e81fc56506ae3b33$var$defaultOptions,
        ...options
    });
    $e81fc56506ae3b33$var$cachedFetches[url] = fetchPromise;
    return fetchPromise;
};
const $e81fc56506ae3b33$var$fetchJson = (url, options = {})=>$e81fc56506ae3b33$var$fetchJsonWithCache(url, options).then((response)=>{
        if (!response.ok) {
            const traceId = $e81fc56506ae3b33$var$getTraceId(response);
            if (traceId !== undefined && traceId.length > 0) throw new $e81fc56506ae3b33$var$FetchError(response.status, `Fetch call failed with status code: ${response.status}`, traceId, response);
            else throw new $e81fc56506ae3b33$var$FetchError(response.status, undefined, undefined, response);
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return response.clone().json();
    });
const $e81fc56506ae3b33$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $e81fc56506ae3b33$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
let $e81fc56506ae3b33$var$siteOptoutStatuses = {};
let $e81fc56506ae3b33$var$siteUserOptoutStatuses = {};
const $e81fc56506ae3b33$export$d2adf65b87e47523 = ()=>{
    $e81fc56506ae3b33$var$siteOptoutStatuses = {};
    $e81fc56506ae3b33$var$siteUserOptoutStatuses = {};
    $e81fc56506ae3b33$var$cachedFetches = {};
};
const $e81fc56506ae3b33$var$parseOptoutTraitStatus = (attributes, attributeName)=>{
    const optoutValue = attributes.find(({ name: name })=>name === attributeName)?.value;
    return optoutValue ? 'is-opted-out' : 'no-opt-out';
};
const $e81fc56506ae3b33$var$parseSiteOptoutTraitStatus = (attributes)=>{
    return $e81fc56506ae3b33$var$parseOptoutTraitStatus(attributes, (0, $438968cdd3ba0b0e$export$a4c96b4ef1bf8976));
};
const $e81fc56506ae3b33$var$parseSiteUserOptoutTraitStatus = (attributes)=>{
    return $e81fc56506ae3b33$var$parseOptoutTraitStatus(attributes, (0, $438968cdd3ba0b0e$export$f64870f8abb59f0b));
};
const $e81fc56506ae3b33$var$fetchSiteTraitData = async (cloudId)=>{
    if (Boolean($e81fc56506ae3b33$var$siteOptoutStatuses[cloudId])) return {
        optoutStatus: $e81fc56506ae3b33$var$siteOptoutStatuses[cloudId],
        cache: true
    };
    try {
        const { attributes: attributes } = await $e81fc56506ae3b33$var$fetchJson($e81fc56506ae3b33$var$getPersonalizationSiteTraitsUrl(cloudId), {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'x-atlassian-mau-ignore': 'true'
            }
        });
        $e81fc56506ae3b33$var$siteOptoutStatuses[cloudId] = $e81fc56506ae3b33$var$parseSiteOptoutTraitStatus(attributes);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching site personalization:', error);
        $e81fc56506ae3b33$var$siteOptoutStatuses[cloudId] = 'error';
        throw error;
    }
    return {
        optoutStatus: $e81fc56506ae3b33$var$siteOptoutStatuses[cloudId],
        cache: false
    };
};
const $e81fc56506ae3b33$var$fetchSiteUserTraitData = async (cloudId, userId)=>{
    if (Boolean($e81fc56506ae3b33$var$siteUserOptoutStatuses[cloudId]?.[userId])) return {
        optoutStatus: $e81fc56506ae3b33$var$siteUserOptoutStatuses[cloudId]?.[userId],
        cache: true
    };
    try {
        const { attributes: attributes } = await $e81fc56506ae3b33$var$fetchJson($e81fc56506ae3b33$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId), {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'x-atlassian-mau-ignore': 'true'
            }
        });
        $e81fc56506ae3b33$var$siteUserOptoutStatuses[cloudId] = {
            ...$e81fc56506ae3b33$var$siteUserOptoutStatuses[cloudId] ?? {},
            [userId]: $e81fc56506ae3b33$var$parseSiteUserOptoutTraitStatus(attributes)
        };
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching site user personalization:', error);
        $e81fc56506ae3b33$var$siteUserOptoutStatuses[cloudId] = {
            ...$e81fc56506ae3b33$var$siteUserOptoutStatuses[cloudId] ?? {},
            [userId]: 'error'
        };
        throw error;
    }
    return {
        optoutStatus: $e81fc56506ae3b33$var$siteUserOptoutStatuses[cloudId][userId],
        cache: false
    };
};
/**
 * | Site / Site user | initial      | is-opted-out | no-opt-out   | error        |
 * |------------------|--------------|--------------|--------------|--------------|
 * | initial          | initial      | is-opted-out | initial      | initial      |
 * | is-opted-out     | is-opted-out | is-opted-out | is-opted-out | is-opted-out |
 * | no-opt-out       | initial      | is-opted-out | no-opt-out   | error        |
 * | error            | initial      | is-opted-out | error        | error        |
 * @param siteOptoutValue
 * @param siteUserOptoutValue
 */ const $e81fc56506ae3b33$var$combineOptoutValue = (siteOptoutValue, siteUserOptoutValue)=>{
    const matrix = {
        initial: {
            initial: 'initial',
            'is-opted-out': 'is-opted-out',
            'no-opt-out': 'initial',
            error: 'initial'
        },
        'is-opted-out': {
            initial: 'is-opted-out',
            'is-opted-out': 'is-opted-out',
            'no-opt-out': 'is-opted-out',
            error: 'is-opted-out'
        },
        'no-opt-out': {
            initial: 'initial',
            'is-opted-out': 'is-opted-out',
            'no-opt-out': 'no-opt-out',
            error: 'error'
        },
        error: {
            initial: 'initial',
            'is-opted-out': 'is-opted-out',
            'no-opt-out': 'error',
            error: 'error'
        }
    };
    return matrix[siteOptoutValue][siteUserOptoutValue] || 'initial';
};
const $e81fc56506ae3b33$var$fireTrackAnalytics = (analyticsEvent, eventName, attributes)=>{
    const clonedEvent = analyticsEvent.clone();
    if (clonedEvent) {
        const [actionSubject, action] = eventName.split(' ');
        clonedEvent.update({
            eventType: (0, $438968cdd3ba0b0e$export$947dac6c72b26f81),
            actionSubject: actionSubject,
            action: action,
            attributes: {
                ...clonedEvent.payload?.attributes ?? {},
                ...attributes ?? {}
            }
        });
        clonedEvent.fire((0, $438968cdd3ba0b0e$export$85183a312807388d));
    }
};
const $e81fc56506ae3b33$export$9af97c6b33df5bae = async (touchpointId, cloudId, analyticsEvent)=>{
    let optoutStatus = 'initial';
    try {
        const fetchResult = await $e81fc56506ae3b33$var$fetchSiteTraitData(cloudId);
        optoutStatus = fetchResult.optoutStatus;
        if (!fetchResult.cache && analyticsEvent) $e81fc56506ae3b33$var$fireTrackAnalytics(analyticsEvent, (0, $438968cdd3ba0b0e$export$5ede056addcc7dcf), {
            cloudId: cloudId,
            touchpointId: touchpointId,
            optoutStatus: optoutStatus
        });
    } catch (error) {
        if (analyticsEvent) $e81fc56506ae3b33$var$fireTrackAnalytics(analyticsEvent, (0, $438968cdd3ba0b0e$export$a16c0f38ba8f83e8), {
            error: error instanceof $e81fc56506ae3b33$var$FetchError ? error.message : 'Unknown error',
            traceId: error instanceof $e81fc56506ae3b33$var$FetchError ? error.traceId : undefined,
            cloudId: cloudId,
            touchpointId: touchpointId,
            optoutStatus: optoutStatus
        });
        return {
            optoutStatus: 'error'
        };
    }
    return {
        optoutStatus: optoutStatus
    };
};
const $e81fc56506ae3b33$export$a9e7c50f402a03d2 = async (touchpointId, cloudId, userId, analyticsEvent)=>{
    let optoutStatus = 'initial';
    try {
        const fetchResult = await $e81fc56506ae3b33$var$fetchSiteUserTraitData(cloudId, userId);
        optoutStatus = fetchResult.optoutStatus;
        if (!fetchResult.cache && analyticsEvent) $e81fc56506ae3b33$var$fireTrackAnalytics(analyticsEvent, (0, $438968cdd3ba0b0e$export$2b6f8d7fd154b638), {
            cloudId: cloudId,
            userId: userId,
            touchpointId: touchpointId,
            optoutStatus: optoutStatus
        });
    } catch (error) {
        if (analyticsEvent) $e81fc56506ae3b33$var$fireTrackAnalytics(analyticsEvent, (0, $438968cdd3ba0b0e$export$74a38b22acdaeea2), {
            error: error instanceof $e81fc56506ae3b33$var$FetchError ? error.message : 'Unknown error',
            traceId: error instanceof $e81fc56506ae3b33$var$FetchError ? error.traceId : undefined,
            cloudId: cloudId,
            userId: userId,
            touchpointId: touchpointId,
            optoutStatus: optoutStatus
        });
        return {
            optoutStatus: 'error'
        };
    }
    return {
        optoutStatus: optoutStatus
    };
};
const $e81fc56506ae3b33$export$aa440d3a24a2d79a = async (touchpointId, cloudId, userId, analyticsEvent)=>{
    if (userId) {
        const [siteOptoutPayload, siteUserOptoutPayload] = await Promise.all([
            $e81fc56506ae3b33$export$9af97c6b33df5bae(touchpointId, cloudId, analyticsEvent),
            $e81fc56506ae3b33$export$a9e7c50f402a03d2(touchpointId, cloudId, userId, analyticsEvent)
        ]);
        return {
            optoutStatus: $e81fc56506ae3b33$var$combineOptoutValue(siteOptoutPayload.optoutStatus, siteUserOptoutPayload.optoutStatus)
        };
    }
    return $e81fc56506ae3b33$export$9af97c6b33df5bae(touchpointId, cloudId, analyticsEvent);
};
const $e81fc56506ae3b33$export$ef6308b7e747ceec = (touchpointId, cloudId, options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [optoutStatus, setOptoutStatus] = (0, $5uXOq.useState)('initial');
    const isDisabled = options?.isDisabled ?? false;
    (0, $5uXOq.useEffect)(()=>{
        if (!isDisabled) $e81fc56506ae3b33$export$9af97c6b33df5bae(touchpointId, cloudId, createAnalyticsEvent({})).then(({ optoutStatus: status })=>{
            setOptoutStatus(status);
        });
    }, [
        cloudId,
        isDisabled,
        touchpointId,
        createAnalyticsEvent
    ]);
    return {
        optoutStatus: optoutStatus
    };
};
const $e81fc56506ae3b33$export$e5b57ebc3eed2ecb = (touchpointId, cloudId, userId, options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [optoutStatus, setOptoutStatus] = (0, $5uXOq.useState)('initial');
    const isDisabled = options?.isDisabled ?? false;
    (0, $5uXOq.useEffect)(()=>{
        if (!isDisabled) $e81fc56506ae3b33$export$a9e7c50f402a03d2(touchpointId, cloudId, userId, createAnalyticsEvent({})).then(({ optoutStatus: status })=>{
            setOptoutStatus(status);
        });
    }, [
        cloudId,
        userId,
        isDisabled,
        touchpointId,
        createAnalyticsEvent
    ]);
    return {
        optoutStatus: optoutStatus
    };
};
const $e81fc56506ae3b33$export$7d4c6b519725ba3b = (touchpointId, cloudId, userId, options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [optoutStatus, setOptoutStatus] = (0, $5uXOq.useState)('initial');
    const isDisabled = options?.isDisabled ?? false;
    (0, $5uXOq.useEffect)(()=>{
        if (!isDisabled) $e81fc56506ae3b33$export$aa440d3a24a2d79a(touchpointId, cloudId, userId, createAnalyticsEvent({})).then(({ optoutStatus: status })=>{
            setOptoutStatus(status);
        });
    }, [
        cloudId,
        userId,
        isDisabled,
        touchpointId,
        createAnalyticsEvent
    ]);
    return {
        optoutStatus: optoutStatus
    };
};

});
const $438968cdd3ba0b0e$export$a4c96b4ef1bf8976 = 'optout_all_messages';
const $438968cdd3ba0b0e$export$f64870f8abb59f0b = 'optout_all_messages_user';
const $438968cdd3ba0b0e$export$48e1d3fa57b0a2d5 = 'optoutAllMessages';
const $438968cdd3ba0b0e$export$5ede056addcc7dcf = `${$438968cdd3ba0b0e$export$48e1d3fa57b0a2d5}.fetchSiteOptout succeeded`;
const $438968cdd3ba0b0e$export$a16c0f38ba8f83e8 = `${$438968cdd3ba0b0e$export$48e1d3fa57b0a2d5}.fetchSiteOptout failed`;
const $438968cdd3ba0b0e$export$2b6f8d7fd154b638 = `${$438968cdd3ba0b0e$export$48e1d3fa57b0a2d5}.fetchSiteUserOptout succeeded`;
const $438968cdd3ba0b0e$export$74a38b22acdaeea2 = `${$438968cdd3ba0b0e$export$48e1d3fa57b0a2d5}.fetchSiteUserOptout failed`;
const $438968cdd3ba0b0e$export$85183a312807388d = 'postOffice';
const $438968cdd3ba0b0e$export$947dac6c72b26f81 = 'track';


parcelRegister("cmVQ7", function(module, exports) {

$parcel$export(module.exports, "useFireCrossFlowAnalyticsEvents", () => $b1a1530bf65c0c61$export$c2095165ae2bdcda);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $iDfVE = parcelRequire("iDfVE");

var $jAXLO = parcelRequire("jAXLO");
function $b1a1530bf65c0c61$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $5uXOq.useRef)();
    const firedViewedUIEventId = (0, $5uXOq.useRef)();
    const mapToCcpProductKeys = (0, $5uXOq.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $iDfVE.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $iDfVE.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $5uXOq.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $jAXLO.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $jAXLO.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $5uXOq.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $jAXLO.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $jAXLO.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $5uXOq.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $jAXLO.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $jAXLO.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}

});
parcelRegister("iDfVE", function(module, exports) {

$parcel$export(module.exports, "FIRST_PARTY_CCP_PRODUCT_IDS", () => $b9514a810cbf7271$export$6c053e1694ef181c);
$parcel$export(module.exports, "SURFACE_ANALYTICS_PRODUCT_MAP", () => $b9514a810cbf7271$export$54e3fc09a2a3347a);
const $b9514a810cbf7271$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551'
};
const $b9514a810cbf7271$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551'
};
const $b9514a810cbf7271$export$6c053e1694ef181c = {
    prod: $b9514a810cbf7271$export$31048cb2a0753b12,
    staging: $b9514a810cbf7271$export$9d8f18312db80469
};
const $b9514a810cbf7271$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905'
    }
};

});

parcelRegister("jAXLO", function(module, exports) {

$parcel$export(module.exports, "CROSS_FLOW_CHANNEL", () => $dc2b00b588a8d355$export$c536a7e29a0739b8);
$parcel$export(module.exports, "eventTypes", () => $dc2b00b588a8d355$export$285f3d0989f9023f);
const $dc2b00b588a8d355$export$c536a7e29a0739b8 = 'crossFlow';
var $dc2b00b588a8d355$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});

});


parcelRegister("s7Ri8", function(module, exports) {

var $ck5fJ = parcelRequire("ck5fJ");

var $a1YLW = parcelRequire("a1YLW");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */ function $0548b62ea127d690$var$shuffle(collection) {
    var func = $8LQ84(collection) ? $ck5fJ : $a1YLW;
    return func(collection);
}
module.exports = $0548b62ea127d690$var$shuffle;

});
parcelRegister("ck5fJ", function(module, exports) {

var $jHlUS = parcelRequire("jHlUS");

var $ifvdh = parcelRequire("ifvdh");
/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */ function $8f8b6d61b1553b58$var$arrayShuffle(array) {
    return $ifvdh($jHlUS(array));
}
module.exports = $8f8b6d61b1553b58$var$arrayShuffle;

});
parcelRegister("ifvdh", function(module, exports) {

var $diicZ = parcelRequire("diicZ");
/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */ function $d491d6fac47da618$var$shuffleSelf(array, size) {
    var index = -1, length = array.length, lastIndex = length - 1;
    size = size === undefined ? length : size;
    while(++index < size){
        var rand = $diicZ(index, lastIndex), value = array[rand];
        array[rand] = array[index];
        array[index] = value;
    }
    array.length = size;
    return array;
}
module.exports = $d491d6fac47da618$var$shuffleSelf;

});
parcelRegister("diicZ", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9adb14a65c3f9737$var$nativeFloor = Math.floor, $9adb14a65c3f9737$var$nativeRandom = Math.random;
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */ function $9adb14a65c3f9737$var$baseRandom(lower, upper) {
    return lower + $9adb14a65c3f9737$var$nativeFloor($9adb14a65c3f9737$var$nativeRandom() * (upper - lower + 1));
}
module.exports = $9adb14a65c3f9737$var$baseRandom;

});



parcelRegister("a1YLW", function(module, exports) {

var $ifvdh = parcelRequire("ifvdh");

var $dMEgP = parcelRequire("dMEgP");
/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */ function $74d923783422b512$var$baseShuffle(collection) {
    return $ifvdh($dMEgP(collection));
}
module.exports = $74d923783422b512$var$baseShuffle;

});


parcelRegister("6eBRn", function(module, exports) {
/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */ function $48a16b14c2519b21$var$fromPairs(pairs) {
    var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
    while(++index < length){
        var pair = pairs[index];
        result[pair[0]] = pair[1];
    }
    return result;
}
module.exports = $48a16b14c2519b21$var$fromPairs;

});

parcelRegister("1w9F2", function(module, exports) {

$parcel$export(module.exports, "EditionAwareness", () => $54026fbd3f0eaacb$export$a55b02efe3d62583);

var $2OMIu = parcelRequire("2OMIu");

var $9Arxj = parcelRequire("9Arxj");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $VSDnB = parcelRequire("VSDnB");

var $fNobW = parcelRequire("fNobW");

var $8Ec39 = parcelRequire("8Ec39");

var $jPg2q = parcelRequire("jPg2q");

var $jZw3S = parcelRequire("jZw3S");

var $3FEPM = parcelRequire("3FEPM");

var $iRG8u = parcelRequire("iRG8u");

var $jnVcb = parcelRequire("jnVcb");

var $lNbsr = parcelRequire("lNbsr");

var $4o6si = parcelRequire("4o6si");

var $56xSH = parcelRequire("56xSH");

var $2VfNT = parcelRequire("2VfNT");

var $gsZRM = parcelRequire("gsZRM");
function $54026fbd3f0eaacb$var$getBillingSourceSystem(typename) {
    switch(typename){
        case 'CcpEntitlement':
            return 'CCP';
        case 'HamsEntitlement':
            return 'HAMS';
    }
}
/**
 * Edition awareness is used to communicate to customers about the current edition they have and if they should
 * - Add payment details
 * - Upgrade their edition
 *
 * This component deals with creating the context which is then used throughout the package to:
 * - Track analytics
 * - Know which product/edition/cloud id is being used
 * - Know when to show/hide the button
 */ function $54026fbd3f0eaacb$var$EditionAwarenessImpl(props) {
    const { cloudId: cloudId, product: product, edition: edition, accountId: accountId, userRoles: userRolesFromProduct, environment: environment, siteTraits: siteTraits = [], canRender: canRender, isInReverseTrial: isInReverseTrialFromProduct, onOpenOnboardingMenu: onOpenOnboardingMenu, premiumFeatureHighlightToggle: premiumFeatureHighlightToggle, shouldAutoOpen: shouldAutoOpen, onAutoOpen: onAutoOpen, PremiumWrapper: PremiumWrapper } = props;
    const { isSpotlightActive: isSpotlightActive, handleSetSpotlight: handleSetSpotlight } = (0, $4o6si.useSpotlight)();
    const queryConfig = (0, $jnVcb.getQueryConfig)(product, edition, cloudId, accountId);
    const data = (0, $8Uumt.useLazyLoadQuery)((0, $9Arxj.default), queryConfig);
    const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
    const isInvoiceable = entitlement?.subscription?.accountDetails?.invoiceGroup?.invoiceable;
    const isConfigurePaymentAvailable = entitlement?.subscription?.accountDetails?.invoiceGroup?.experienceCapabilities?.configurePaymentV2?.isAvailableToUser === true;
    const addPaymentDetailsExperienceUrl = entitlement?.subscription?.accountDetails?.invoiceGroup?.experienceCapabilities?.configurePaymentV2?.experienceUrl;
    const canAddPaymentDetails = Boolean(isConfigurePaymentAvailable && addPaymentDetailsExperienceUrl);
    const trialTimeLeft = entitlement?.subscription?.trial?.timeLeft ?? undefined;
    const trialDaysLeft = (0, $jPg2q.getTrialDaysLeft)(trialTimeLeft);
    const trialStartTimestamp = entitlement?.subscription?.trial?.startTimestamp;
    const trialStartDate = (0, $5uXOq.useMemo)(()=>trialStartTimestamp ? new Date(trialStartTimestamp) : undefined, [
        trialStartTimestamp
    ]);
    const trialEndTimestamp = entitlement?.subscription?.trial?.endTimestamp;
    const trialEndDate = (0, $5uXOq.useMemo)(()=>trialEndTimestamp ? new Date(trialEndTimestamp) : undefined, [
        trialEndTimestamp
    ]);
    const trialLengthDays = entitlement?.offering?.trial?.lengthDays ?? undefined;
    const isInTrial = Boolean(trialDaysLeft && trialDaysLeft > 0);
    const isInPredunning = entitlement?.preDunning?.status === 'IN_PRE_DUNNING' && !isInvoiceable;
    const isInReverseTrial = (isInTrial || isInPredunning) && (isInReverseTrialFromProduct !== undefined ? isInReverseTrialFromProduct : false);
    const isChangeOfferingAvailable = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser;
    const changeOfferingToStandardExperienceUrl = entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl;
    const canUpgrade = Boolean(isChangeOfferingAvailable && changeOfferingToStandardExperienceUrl);
    const billingSourceSystem = $54026fbd3f0eaacb$var$getBillingSourceSystem(entitlement?.__typename);
    const isInCollection = (0, $5uXOq.useMemo)(()=>{
        const collectionEntitlement = entitlement?.relatesFromEntitlements?.find((item)=>item?.relationshipType === 'COLLECTION');
        return !!collectionEntitlement?.entitlementId;
    }, [
        entitlement?.relatesFromEntitlements
    ]);
    const collectionType = isInCollection ? 'Teamwork Collection' : null;
    const userRoles = (0, $5uXOq.useMemo)(()=>{
        const roles = [
            ...userRolesFromProduct || []
        ];
        if (data?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.transactionAccount?.isCurrentUserBillingAdmin) roles.push('BILLING_ADMIN');
        return roles;
    }, [
        data?.tenantContexts,
        userRolesFromProduct
    ]);
    const userEmail = data?.user?.email;
    // We need to use the `latestUsageForChargeElement` to get the licensed user count for both free and trialing customers
    const licensedUsersRaw = entitlement?.latestUsageForChargeElement;
    // Assumes that there are always at least one assigned user to cover scenarios
    const licensedUsers = Math.max(licensedUsersRaw || 0, 1);
    const storageUsageInGB = (0, $5uXOq.useMemo)(()=>{
        if (data.jira?.attachmentStorageUsed && [
            'jira',
            'jira-service-management',
            'jira-product-discovery'
        ].includes(product)) return (0, $jZw3S.bytesToGigabytes)(data.jira.attachmentStorageUsed);
        if (data.confluence_storage?.bytesUsed && product === 'confluence') return (0, $jZw3S.bytesToGigabytes)(data.confluence_storage.bytesUsed);
        return undefined;
    }, [
        data.jira?.attachmentStorageUsed,
        data.confluence_storage?.bytesUsed,
        product
    ]);
    const siteTraitsForContext = (0, $5uXOq.useMemo)(()=>(0, $lNbsr.getSiteTraitValues)(siteTraits), [
        siteTraits
    ]);
    const automationFreeLimitStatus = (0, $5uXOq.useMemo)(()=>(0, $VSDnB.fg)('growth_automation_limits_kill_switch') ? (0, $iRG8u.getAutomationFreeLimitStatus)({
            product: product,
            edition: edition,
            isInTrial: isInTrial,
            ...siteTraitsForContext
        }) : null, [
        product,
        edition,
        isInTrial,
        siteTraitsForContext
    ]);
    const context = (0, $5uXOq.useMemo)(()=>{
        return {
            cloudId: cloudId,
            product: product,
            edition: edition,
            isInvoiceable: isInvoiceable,
            canAddPaymentDetails: canAddPaymentDetails,
            addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl,
            trialDaysLeft: trialDaysLeft,
            trialLengthDays: trialLengthDays,
            trialStartDate: trialStartDate,
            trialEndDate: trialEndDate,
            isInTrial: isInTrial,
            isInPredunning: isInPredunning,
            isInReverseTrial: isInReverseTrial,
            canUpgrade: canUpgrade,
            changeOfferingToStandardExperienceUrl: changeOfferingToStandardExperienceUrl,
            isInCollection: isInCollection,
            collectionType: collectionType,
            userRoles: userRoles,
            userEmail: userEmail,
            billingSourceSystem: billingSourceSystem,
            environment: environment,
            licensedUsers: licensedUsers,
            storageUsageInGB: storageUsageInGB,
            ...siteTraitsForContext,
            automationFreeLimitStatus: automationFreeLimitStatus,
            isSpotlightActive: isSpotlightActive,
            handleSetSpotlight: handleSetSpotlight,
            onOpenOnboardingMenu: onOpenOnboardingMenu,
            premiumFeatureHighlightToggle: premiumFeatureHighlightToggle,
            shouldAutoOpen: shouldAutoOpen,
            onAutoOpen: onAutoOpen,
            PremiumWrapper: PremiumWrapper
        };
    }, [
        cloudId,
        product,
        edition,
        isInvoiceable,
        canAddPaymentDetails,
        addPaymentDetailsExperienceUrl,
        trialDaysLeft,
        trialLengthDays,
        trialStartDate,
        trialEndDate,
        isInTrial,
        isInPredunning,
        isInReverseTrial,
        canUpgrade,
        changeOfferingToStandardExperienceUrl,
        isInCollection,
        collectionType,
        userRoles,
        userEmail,
        billingSourceSystem,
        environment,
        licensedUsers,
        storageUsageInGB,
        siteTraitsForContext,
        automationFreeLimitStatus,
        isSpotlightActive,
        handleSetSpotlight,
        onOpenOnboardingMenu,
        premiumFeatureHighlightToggle,
        shouldAutoOpen,
        onAutoOpen,
        PremiumWrapper
    ]);
    if (!canRender) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fNobW.default), {
        name: "edition-awareness-waiting-on-product"
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3FEPM.EditionAwarenessContext).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2VfNT.ErrorBoundary), {
            product: product,
            edition: edition,
            id: "audience-and-timing",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $56xSH.AudienceAndTiming), {}),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gsZRM.Spotlight), {})
            ]
        })
    });
}
function $54026fbd3f0eaacb$export$a55b02efe3d62583(props) {
    const { product: product, edition: edition } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Ec39.default), {
        name: "edition-awareness-platform",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2VfNT.ErrorBoundary), {
            product: product,
            edition: edition,
            id: "edition-awareness",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($54026fbd3f0eaacb$var$EditionAwarenessImpl, {
                    ...props
                })
            })
        })
    });
}

});
parcelRegister("9Arxj", function(module, exports) {

$parcel$export(module.exports, "default", () => $372fb9728b391b1f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dfa77fe36f8162f551af8e206d566691>>
 * @relayHash 7a30033e87b7184373b0efdce25d44dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 72f0888f8f453d24db37f17eef905e8c0dab61e0e06f4a1bf55f9cbc74743a6a
const $372fb9728b391b1f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "applicationKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "chargeElement"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entitlementFilter"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckBillingAdmin"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForChangeOffering"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForChargeQuantities"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForCollection"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForStorageUsageConfluence"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForStorageUsageJira"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForTrial"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldCheckForUserEmail"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkip"
    }, v15 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v16 = {
        "condition": "shouldCheckForStorageUsageJira",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "applicationKey",
                                "variableName": "applicationKey"
                            },
                            v15 /*: any*/ 
                        ],
                        "kind": "ScalarField",
                        "name": "attachmentStorageUsed"
                    }
                ]
            }
        ]
    }, v17 = {
        "condition": "shouldCheckForStorageUsageConfluence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v15 /*: any*/ 
                ],
                "concreteType": "ConfluenceStorage",
                "kind": "LinkedField",
                "name": "confluence_storage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "bytesUsed"
                    }
                ]
            }
        ]
    }, v18 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v19 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v20 = [
        {
            "kind": "Variable",
            "name": "where",
            "variableName": "entitlementFilter"
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v22 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Standard"
        }
    ], v23 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v24 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v25 = {
        "condition": "shouldCheckForChargeQuantities",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "chargeElement",
                        "variableName": "chargeElement"
                    }
                ],
                "kind": "ScalarField",
                "name": "latestUsageForChargeElement"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "status"
    }, v27 = {
        "kind": "ScalarField",
        "name": "timeLeft"
    }, v28 = {
        "kind": "ScalarField",
        "name": "startTimestamp"
    }, v29 = {
        "kind": "ScalarField",
        "name": "endTimestamp"
    }, v30 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v31 = {
        "kind": "ScalarField",
        "name": "lengthDays"
    }, v32 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    }, v33 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    }, v34 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v35 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v36 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "email"
            }
        ],
        "type": "AtlassianAccountUser"
    }, v37 = {
        "kind": "ScalarField",
        "name": "id"
    }, v38 = [
        v37 /*: any*/ 
    ], v39 = {
        "kind": "InlineFragment",
        "selections": v38 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editionAwarenessQuery",
            "selections": [
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v18 /*: any*/ ,
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "args": v19 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v20 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                {
                                                    "condition": "shouldCheckForChangeOffering",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "experienceCapabilities",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "args": v22 /*: any*/ ,
                                                                    "kind": "LinkedField",
                                                                    "name": "changeOfferingV2",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ 
                                                                    ],
                                                                    "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v25 /*: any*/ ,
                                                {
                                                    "condition": "shouldCheckForTrial",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "preDunning",
                                                            "plural": false,
                                                            "selections": [
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "subscription",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "trial",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v29 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "accountDetails",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "invoiceGroup",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v30 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "experienceCapabilities",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "configurePaymentV2",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v24 /*: any*/ ,
                                                                                                v23 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "offering",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "trial",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v31 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldCheckBillingAdmin",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "transactionAccount",
                                                            "plural": false,
                                                            "selections": [
                                                                v32 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldCheckForCollection",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "relatesFromEntitlements",
                                                            "plural": true,
                                                            "selections": [
                                                                v33 /*: any*/ ,
                                                                v34 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldCheckForUserEmail",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v35 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v36 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v12 /*: any*/ ,
                v14 /*: any*/ ,
                v8 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ ,
                v9 /*: any*/ ,
                v11 /*: any*/ ,
                v1 /*: any*/ ,
                v10 /*: any*/ ,
                v0 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editionAwarenessQuery",
            "selections": [
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v18 /*: any*/ ,
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "args": v19 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlementInfo",
                                    "plural": false,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        {
                                            "args": v20 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                {
                                                    "condition": "shouldCheckForChangeOffering",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "experienceCapabilities",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                {
                                                                    "args": v22 /*: any*/ ,
                                                                    "kind": "LinkedField",
                                                                    "name": "changeOfferingV2",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ 
                                                                    ],
                                                                    "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v25 /*: any*/ ,
                                                {
                                                    "condition": "shouldCheckForTrial",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "preDunning",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "subscription",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "trial",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v29 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "accountDetails",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "invoiceGroup",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "experienceCapabilities",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "configurePaymentV2",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v21 /*: any*/ ,
                                                                                                v24 /*: any*/ ,
                                                                                                v23 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v38 /*: any*/ ,
                                                                                    "type": "CcpInvoiceGroup"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v38 /*: any*/ ,
                                                                    "type": "CcpSubscription"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "offering",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "trial",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ ,
                                                                        v31 /*: any*/ 
                                                                    ]
                                                                },
                                                                v39 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldCheckBillingAdmin",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "transactionAccount",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                v32 /*: any*/ ,
                                                                v39 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "shouldCheckForCollection",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "relatesFromEntitlements",
                                                            "plural": true,
                                                            "selections": [
                                                                v21 /*: any*/ ,
                                                                v33 /*: any*/ ,
                                                                v34 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v37 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldCheckForUserEmail",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v35 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v21 /*: any*/ ,
                                v36 /*: any*/ ,
                                v37 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "72f0888f8f453d24db37f17eef905e8c0dab61e0e06f4a1bf55f9cbc74743a6a",
            "metadata": {},
            "name": "editionAwarenessQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$372fb9728b391b1f$var$node.hash = "a5f51f83d12f4c0f1a8d1448a72ac404";
var $372fb9728b391b1f$export$2e2bcd8739ae039 = $372fb9728b391b1f$var$node;

});

parcelRegister("jPg2q", function(module, exports) {

$parcel$export(module.exports, "getTrialDaysLeft", () => $b1eb2d6f233fa996$export$954628993bf3188e);
$parcel$export(module.exports, "getTrialDaysLeftFromTrialEndTime", () => $b1eb2d6f233fa996$export$165abb069513be0e);
const $b1eb2d6f233fa996$var$MILLISECOND_IN_A_DAY = 86400000;
function $b1eb2d6f233fa996$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / $b1eb2d6f233fa996$var$MILLISECOND_IN_A_DAY);
}
function $b1eb2d6f233fa996$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $b1eb2d6f233fa996$export$954628993bf3188e(trialEndTime - Date.now());
}

});

parcelRegister("jZw3S", function(module, exports) {

$parcel$export(module.exports, "bytesToGigabytes", () => $944df11c6a805ec8$export$6f25243957146989);
/**
 * Most storage measurements are in gigabytes
 */ function $944df11c6a805ec8$export$6f25243957146989(bytes) {
    return bytes / 1000000000;
}

});

parcelRegister("3FEPM", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessContext", () => $2761dbba4f066eb6$export$ac3ca8c46f19a73f);
$parcel$export(module.exports, "useEditionAwareness", () => $2761dbba4f066eb6$export$5a5baedfe8151ce);

var $5uXOq = parcelRequire("5uXOq");
const $2761dbba4f066eb6$export$ac3ca8c46f19a73f = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
function $2761dbba4f066eb6$export$5a5baedfe8151ce() {
    const context = (0, $5uXOq.useContext)($2761dbba4f066eb6$export$ac3ca8c46f19a73f);
    if (!context) throw new Error('Missing context, please ensure this is used within EditionAwarenessContext');
    return context;
}

});

parcelRegister("iRG8u", function(module, exports) {

$parcel$export(module.exports, "AUTOMATION_USAGE_FREE_LIMIT", () => $dd5bf778af69c092$export$7296becdbc8d7810);
$parcel$export(module.exports, "AUTOMATION_USAGE_STANDARD_LIMIT", () => $dd5bf778af69c092$export$5a0f9f37fb711f37);
$parcel$export(module.exports, "getAutomationFreeLimitStatus", () => $dd5bf778af69c092$export$5f347675b43b787f);
$parcel$export(module.exports, "getProjectedAutomationUsage", () => $dd5bf778af69c092$export$5c4f4d557a0ee678);

var $6D6zP = parcelRequire("6D6zP");

var $9wcjZ = parcelRequire("9wcjZ");
const $dd5bf778af69c092$export$7296becdbc8d7810 = 100;
const $dd5bf778af69c092$export$5a0f9f37fb711f37 = 1700;
const $dd5bf778af69c092$export$b3d11e30afa46646 = 0.8 * $dd5bf778af69c092$export$7296becdbc8d7810;
const $dd5bf778af69c092$export$5f347675b43b787f = ({ edition: edition, product: product, isInTrial: isInTrial, automationUsage: automationUsage, lastAutomationFreeLimitBreachDate: lastAutomationFreeLimitBreachDate = null })=>{
    if ((edition === 'free' || edition === 'standard' && isInTrial) && product === 'jira') {
        if ($dd5bf778af69c092$export$5ff23a30e22aeec2(automationUsage, lastAutomationFreeLimitBreachDate)) return 'BREACHED';
        if ($dd5bf778af69c092$var$isAutomationProjectedToBreach(automationUsage, edition)) return 'PROJECTED_TO_BREACH';
        if ($dd5bf778af69c092$var$hasBreachedAutomationUsagePreviousMonth(lastAutomationFreeLimitBreachDate)) return 'BREACHED_PREVIOUS_MONTH';
    }
    return null;
};
const $dd5bf778af69c092$export$5c4f4d557a0ee678 = (automationUsage)=>{
    const today = new Date();
    const dayOfMonth = today.getDate();
    return automationUsage / dayOfMonth * (0, $6D6zP.default)(today);
};
const $dd5bf778af69c092$var$isAutomationProjectedToBreach = (automationUsage, edition)=>{
    // Already breached the limit, no need to project
    if (automationUsage >= $dd5bf778af69c092$export$7296becdbc8d7810) return false;
    const projectedUsage = $dd5bf778af69c092$export$5c4f4d557a0ee678(automationUsage);
    if (edition === 'free') return projectedUsage >= $dd5bf778af69c092$export$7296becdbc8d7810 && automationUsage >= $dd5bf778af69c092$export$b3d11e30afa46646;
    return projectedUsage >= $dd5bf778af69c092$export$7296becdbc8d7810;
};
const $dd5bf778af69c092$export$5ff23a30e22aeec2 = (automationUsage, lastAutomationFreeLimitBreachDate)=>{
    return lastAutomationFreeLimitBreachDate && automationUsage >= $dd5bf778af69c092$export$7296becdbc8d7810 && (0, $9wcjZ.default)(new Date(), lastAutomationFreeLimitBreachDate);
};
const $dd5bf778af69c092$var$hasBreachedAutomationUsagePreviousMonth = (lastAutomationFreeLimitBreachDate)=>{
    if (!lastAutomationFreeLimitBreachDate) return false;
    const now = new Date();
    // Date constructor handles overflow on the last month correctly
    const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    return (0, $9wcjZ.default)(lastAutomationFreeLimitBreachDate, lastMonth);
};

});

parcelRegister("jnVcb", function(module, exports) {

$parcel$export(module.exports, "getQueryConfig", () => $a6b373558895e639$export$bac5bb66ae1b635d);

var $VSDnB = parcelRequire("VSDnB");

var $eDHw9 = parcelRequire("eDHw9");

var $iENAf = parcelRequire("iENAf");

var $8XFbn = parcelRequire("8XFbn");
function $a6b373558895e639$export$bac5bb66ae1b635d(product, edition, cloudId, accountId) {
    const isStandardTrialsUserAndStorageLimitBreakersEnabledJira = product === 'jira' && edition === 'standard' && (0, $VSDnB.fg)('jira_edition_awareness_standard_trials_gate');
    const isStandardTrialsUserAndStorageLimitBreakersEnabledConnie = product === 'confluence' && edition === 'standard' && (0, $VSDnB.fg)('connie_edition_awareness_standard_trials_gate');
    const isStandardTrialsUserAndStorageLimitBreakersEnabled = isStandardTrialsUserAndStorageLimitBreakersEnabledJira || isStandardTrialsUserAndStorageLimitBreakersEnabledConnie;
    const isCollectionEabEnabled = (product === 'jira' || product === 'confluence') && (0, $VSDnB.fg)('teamwork_collection_ea_modal');
    const isBillingAdminEnabled = (product === 'jira' || product === 'confluence') && (0, $VSDnB.fg)('should_check_billing_admin_ea_query_config_gate');
    return {
        shouldSkip: product === 'jira-product-discovery' && (0, $VSDnB.fg)('jpd_disable_edition_awareness'),
        shouldCheckForChangeOffering: edition === 'free',
        shouldCheckForTrial: edition === 'premium' || edition === 'standard',
        cloudId: cloudId,
        productKey: (0, $8XFbn.getHamsKey)(product),
        shouldCheckForChargeQuantities: edition === 'free' || isStandardTrialsUserAndStorageLimitBreakersEnabled,
        // The entitlement filter ensures that we apply the `inTrialOrPreDunning` only when an entitlement is
        // on a non free edition. The filter is based on the trial end timestamp inside of TCS, this means that
        // if a customer downgrades their product to free while on a trial, then they will only show up
        // if inTrialOrPreDunning is set to true as the filter assumes they are still on trial.
        entitlementFilter: edition !== 'free' ? {
            inTrialOrPreDunning: true
        } : null,
        chargeElement: (0, $eDHw9.getChargeElementKey)(product),
        shouldCheckBillingAdmin: isBillingAdminEnabled,
        shouldCheckForCollection: isCollectionEabEnabled,
        shouldCheckForStorageUsageJira: isStandardTrialsUserAndStorageLimitBreakersEnabledJira,
        applicationKey: (0, $iENAf.getJiraApplicationKey)(product) ?? 'JIRA_SOFTWARE',
        shouldCheckForStorageUsageConfluence: isStandardTrialsUserAndStorageLimitBreakersEnabledConnie,
        // AccountID is a required value, but the condition will ensure it is not used if undefined/null
        accountId: accountId ?? '',
        shouldCheckForUserEmail: !!accountId && product === 'jira' && edition === 'standard'
    };
}

});
parcelRegister("eDHw9", function(module, exports) {

$parcel$export(module.exports, "getChargeElementKey", () => $94eee0f9af6c569f$export$58e4e89574623b4);
const $94eee0f9af6c569f$var$PRODUCT_TO_CHARGE_ELEMENT = {
    ['confluence']: 'user',
    ['jira']: 'user',
    ['jira-product-discovery']: 'user',
    ['jira-service-management']: 'agent'
};
const $94eee0f9af6c569f$export$58e4e89574623b4 = (product)=>{
    return $94eee0f9af6c569f$var$PRODUCT_TO_CHARGE_ELEMENT[product];
};

});

parcelRegister("iENAf", function(module, exports) {

$parcel$export(module.exports, "getJiraApplicationKey", () => $452974a9bca5e81e$export$2fd6994252e4887f);
// We're explicitly excluding 'confluence' from this mapping as it's handled separately
const $452974a9bca5e81e$var$PRODUCT_TO_JIRA_APPLICATION_KEY = {
    ['jira']: 'JIRA_SOFTWARE',
    ['jira-product-discovery']: 'JIRA_PRODUCT_DISCOVERY',
    ['jira-service-management']: 'JIRA_SERVICE_DESK'
};
const $452974a9bca5e81e$export$2fd6994252e4887f = (product)=>{
    return $452974a9bca5e81e$var$PRODUCT_TO_JIRA_APPLICATION_KEY[product];
};

});


parcelRegister("lNbsr", function(module, exports) {

$parcel$export(module.exports, "getSiteTraitValues", () => $c58975f008d8a6ba$export$2a16c85f3c5d2302);
const $c58975f008d8a6ba$export$2a16c85f3c5d2302 = (traits)=>{
    if (traits.length === 0) return {
        siteType: null,
        automationUsage: 0,
        lastAutomationFreeLimitBreachDate: null
    };
    const siteTypeTrait = traits.find((trait)=>trait.name === 'growth_discount_cohort');
    const automationUsageTrait = traits.find((trait)=>trait.name === 'growth_automation_limits_usage');
    const lastAutomationFreeLimitBreachDateTrait = traits.find((trait)=>trait.name === 'growth_automation_limits_usage_breach_date');
    let siteType = null;
    if (siteTypeTrait) {
        if (siteTypeTrait.value === 'EDU' || siteTypeTrait.value === 'ORG') siteType = siteTypeTrait.value;
        else siteType = 'UNKNOWN';
    }
    const automationUsage = automationUsageTrait && automationUsageTrait.value !== undefined && !isNaN(Number(automationUsageTrait.value)) ? Number(automationUsageTrait.value) : 0;
    const lastAutomationFreeLimitBreachDate = lastAutomationFreeLimitBreachDateTrait && typeof lastAutomationFreeLimitBreachDateTrait.value === 'string' && !isNaN(Date.parse(lastAutomationFreeLimitBreachDateTrait.value)) ? new Date(lastAutomationFreeLimitBreachDateTrait.value) : null;
    return {
        siteType: siteType,
        automationUsage: automationUsage,
        lastAutomationFreeLimitBreachDate: lastAutomationFreeLimitBreachDate
    };
};

});

parcelRegister("4o6si", function(module, exports) {

$parcel$export(module.exports, "useSpotlight", () => $0e54fa392d9bd459$export$cc7026713a353975);

var $5uXOq = parcelRequire("5uXOq");
function $0e54fa392d9bd459$export$cc7026713a353975() {
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(false);
    const handleSetSpotlight = (0, $5uXOq.useCallback)((isActive)=>{
        setIsSpotlightActive(isActive);
    }, [
        setIsSpotlightActive
    ]);
    return {
        isSpotlightActive: isSpotlightActive,
        handleSetSpotlight: handleSetSpotlight
    };
}

});

parcelRegister("56xSH", function(module, exports) {

$parcel$export(module.exports, "AudienceAndTiming", () => $96342859ab580836$export$d288e6ad7a0cf9f8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $fK9DC = parcelRequire("fK9DC");

var $3FEPM = parcelRequire("3FEPM");

var $5Shw2 = parcelRequire("5Shw2");
/**
 * One off event which tracks when a customer is eligible/ineligible for edition awareness
 */ function $96342859ab580836$var$useTrackAudienceAndTiming(isEligible) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fK9DC.useAnalytics)();
    const hasSent = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'operational',
            actionSubject: 'audienceAndTiming',
            actionSubjectId: 'editionAwareness',
            action: 'checked',
            attributes: {
                isEligible: isEligible
            }
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        isEligible
    ]);
}
/**
 * Tracks when a user should see the edition awareness experience
 */ function $96342859ab580836$var$Analytics({ children: children }) {
    $96342859ab580836$var$useTrackAudienceAndTiming(true);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: children
    });
}
/**
 * Just sends ineligibility info through a `eligibilityCriteria checked` event.
 * This exists so we can optionally render this component
 */ function $96342859ab580836$var$IneligibleAnalytics() {
    $96342859ab580836$var$useTrackAudienceAndTiming(false);
    return null;
}
function $96342859ab580836$export$d288e6ad7a0cf9f8() {
    const { product: product, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, canUpgrade: canUpgrade, isInvoiceable: isInvoiceable, canAddPaymentDetails: canAddPaymentDetails } = (0, $3FEPM.useEditionAwareness)();
    const isInTrialOrPredunning = isInTrial || isInPredunning;
    const shouldSeeButton = (0, $5uXOq.useMemo)(()=>{
        if (product === 'jira-product-discovery' && (0, $VSDnB.fg)('jpd_disable_edition_awareness')) return false;
        if (edition === 'free' && canUpgrade) return true;
        if (edition === 'standard' && isInTrialOrPredunning && isInvoiceable === false && canAddPaymentDetails) return true;
        if (edition === 'premium' && [
            'jira',
            'jira-service-management'
        ].includes(product) && isInTrialOrPredunning && isInvoiceable === false && canAddPaymentDetails) return true;
        if (product === 'confluence' && edition === 'premium' && isInTrialOrPredunning) // Confluence will always show the button for premium while a customer is in a trial or in predunning
        // If the customer can add payment, that is checked as part of rendering the dialog (as the dialog
        // will still show to the customer if they can not add payment details)
        return true;
        return false;
    }, [
        product,
        edition,
        canUpgrade,
        isInTrialOrPredunning,
        isInvoiceable,
        canAddPaymentDetails
    ]);
    if (!shouldSeeButton) {
        if (edition === 'free' || isInTrialOrPredunning) // We're only firing the ineligible analytics when we could've shown the button, not all instances
        // this is to ensure we don't send the event on every page load
        return /*#__PURE__*/ (0, $2OMIu.jsx)($96342859ab580836$var$IneligibleAnalytics, {});
        return null;
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)($96342859ab580836$var$Analytics, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Shw2.ActionsAndContent), {})
    });
}

});
parcelRegister("fK9DC", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $ed4593ed7d38e43c$export$85183a312807388d);
$parcel$export(module.exports, "getAttributesFromContexts", () => $ed4593ed7d38e43c$export$d97c97ed77ff09e8);
$parcel$export(module.exports, "defaultAttributes", () => $ed4593ed7d38e43c$export$38cd8db2db178f58);
$parcel$export(module.exports, "useAnalytics", () => $ed4593ed7d38e43c$export$e955abb82869dc84);

var $5uXOq = parcelRequire("5uXOq");

var $e8KHW = parcelRequire("e8KHW");

var $1SrMX = parcelRequire("1SrMX");
var $2NMNM = parcelRequire("2NMNM");

var $iEN9D = parcelRequire("iEN9D");

var $3FEPM = parcelRequire("3FEPM");
const $ed4593ed7d38e43c$export$85183a312807388d = (0, $e8KHW.FabricChannel).growth;
const $ed4593ed7d38e43c$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    return context.reduce((acc, x)=>{
        if (x.attributes) return {
            ...acc,
            ...x.attributes
        };
        return {
            ...acc,
            ...x ?? {}
        };
    }, {});
};
const $ed4593ed7d38e43c$export$38cd8db2db178f58 = {
    packageName: '@atlassian/edition-awareness',
    source: 'editionAwareness',
    featureId: 'edition-awareness',
    growthPillar: 'BUY'
};
function $ed4593ed7d38e43c$export$e955abb82869dc84() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const editionAwarenessContext = (0, $3FEPM.useEditionAwareness)();
    const experimentMeta = (0, $5uXOq.useMemo)(()=>{
        // I wanted to reference the utility function but,
        // that file imports AtlBrowserStorageLocal which makes the VR tests to fail with timeout, even if is not executed on runtime
        //if (isFreeEduOrOrgSite(editionAwarenessContext)) {
        //Only add the metadata when the site may be eligible for the experiment
        if (editionAwarenessContext.edition === 'free' && (editionAwarenessContext.siteType === 'EDU' || editionAwarenessContext.siteType === 'ORG')) return [
            {
                key: 'offer_edu_org_discount',
                cohort: (0, $iEN9D.default).getExperimentValue('offer_edu_org_discount', 'cohort', 'not-enrolled'),
                siteType: editionAwarenessContext.siteType
            }
        ];
        return [];
    }, [
        editionAwarenessContext
    ]);
    const sendAnalyticsEvent = (0, $5uXOq.useCallback)((payload)=>{
        const editionAwarenessContextAttributes = {
            // Required properties
            cloudId: editionAwarenessContext.cloudId,
            product: editionAwarenessContext.product,
            currentProductEdition: editionAwarenessContext.edition,
            // Payment properties
            isInvoiceable: editionAwarenessContext.isInvoiceable,
            canAddPaymentDetails: editionAwarenessContext.canAddPaymentDetails,
            addPaymentDetailsExperienceUrl: editionAwarenessContext.addPaymentDetailsExperienceUrl,
            // Trial properties
            trialDaysLeft: editionAwarenessContext.trialDaysLeft,
            trialLengthDays: editionAwarenessContext.trialLengthDays,
            trialEndDate: editionAwarenessContext.trialEndDate,
            isInTrial: editionAwarenessContext.isInTrial,
            isInPredunning: editionAwarenessContext.isInPredunning,
            isInReverseTrial: editionAwarenessContext.isInReverseTrial,
            trialOfferingName: editionAwarenessContext.trialOfferingName,
            // Upgrade properties
            canUpgrade: editionAwarenessContext.canUpgrade,
            changeOfferingToStandardExperienceUrl: editionAwarenessContext.changeOfferingToStandardExperienceUrl,
            // Entitlement properties
            isInCollection: editionAwarenessContext.isInCollection,
            collectionType: editionAwarenessContext.collectionType,
            // User permissions properties
            userRoles: editionAwarenessContext.userRoles,
            userEmail: editionAwarenessContext.userEmail,
            // Site properties
            billingSourceSystem: editionAwarenessContext.billingSourceSystem,
            licensedUsers: editionAwarenessContext.licensedUsers,
            storageUsageInGB: editionAwarenessContext.storageUsageInGB,
            // Site traits
            siteType: editionAwarenessContext.siteType,
            automationUsage: editionAwarenessContext.automationUsage,
            lastAutomationFreeLimitBreachDate: editionAwarenessContext.lastAutomationFreeLimitBreachDate,
            automationFreeLimitStatus: editionAwarenessContext.automationFreeLimitStatus,
            // Capabilities
            isSpotlightActive: editionAwarenessContext.isSpotlightActive,
            shouldAutoOpen: editionAwarenessContext.shouldAutoOpen
        };
        if (payload instanceof (0, $1SrMX.default)) {
            const contextAttributes = $ed4593ed7d38e43c$export$d97c97ed77ff09e8(payload.context);
            payload.update({
                ...payload.payload,
                attributes: {
                    ...contextAttributes,
                    ...$ed4593ed7d38e43c$export$38cd8db2db178f58,
                    ...payload.payload.attributes,
                    ...editionAwarenessContextAttributes,
                    experimentMeta: experimentMeta
                }
            }).fire($ed4593ed7d38e43c$export$85183a312807388d);
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                attributes: {
                    ...$ed4593ed7d38e43c$export$38cd8db2db178f58,
                    ...payload.attributes,
                    ...editionAwarenessContextAttributes,
                    experimentMeta: experimentMeta
                }
            });
            const contextAttributes = $ed4593ed7d38e43c$export$d97c97ed77ff09e8(event.context);
            event.update({
                attributes: {
                    ...contextAttributes,
                    ...event.payload.attributes
                }
            }).fire($ed4593ed7d38e43c$export$85183a312807388d);
        }
    }, [
        createAnalyticsEvent,
        editionAwarenessContext,
        experimentMeta
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent
    };
}
function $ed4593ed7d38e43c$export$b901544a79a3bbad({ name: name, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = $ed4593ed7d38e43c$export$e955abb82869dc84();
    const hasSent = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'screen',
            name: name,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        name,
        attributes
    ]);
    return null;
}

});

parcelRegister("5Shw2", function(module, exports) {

$parcel$export(module.exports, "ActionsAndContent", () => $3482a278540e0814$export$3bec899b1babe0fe);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $iEN9D = parcelRequire("iEN9D");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $fLNQI = parcelRequire("fLNQI");

var $fK9DC = parcelRequire("fK9DC");

var $3FEPM = parcelRequire("3FEPM");

var $dTcX5 = parcelRequire("dTcX5");

var $3Ic4Z = parcelRequire("3Ic4Z");

var $d1IFL = parcelRequire("d1IFL");

var $kbMGT = parcelRequire("kbMGT");

var $lLXXb = parcelRequire("lLXXb");

var $fs8rz = parcelRequire("fs8rz");

var $7f9lz = parcelRequire("7f9lz");

var $lgKHV = parcelRequire("lgKHV");

var $e4jK3 = parcelRequire("e4jK3");

var $cqUnB = parcelRequire("cqUnB");

var $atpKp = parcelRequire("atpKp");

var $bdE46 = parcelRequire("bdE46");

var $dWrfe = parcelRequire("dWrfe");

var $58xN9 = parcelRequire("58xN9");

var $jsUoM = parcelRequire("jsUoM");

var $70SOi = parcelRequire("70SOi");

var $5yG9d = parcelRequire("5yG9d");
const $3482a278540e0814$var$AddPaymentLink = ({ href: href })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "@atlassian/edition-awareness.link.add-payment-tooltip",
            defaultMessage: "Add payment details to keep your subscription",
            description: "Tooltip for add payment details button"
        }),
        position: "bottom",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5yG9d.EditionAwarenessLink), {
            href: href,
            target: "_blank",
            touchpointIntent: "addPaymentDetails",
            linkId: "predunning"
        })
    });
};
const $3482a278540e0814$var$JiraStandardTrialOverviewLink = ()=>{
    const { cloudId: cloudId, environment: environment, billingSourceSystem: billingSourceSystem, userEmail: userEmail, automationFreeLimitStatus: automationFreeLimitStatus } = (0, $3FEPM.useEditionAwareness)();
    const fireExperimentExposureEvent = (0, $fLNQI.useFeatureExposedAnalytics)();
    const fireAutomationFreeLimitExperimentExposure = (0, $5uXOq.useCallback)(()=>{
        if (automationFreeLimitStatus) {
            const automationLimitsCohort = (0, $iEN9D.default).getExperimentValue('growth_automation_limits_experiment', 'cohort', 'not-enrolled');
            fireExperimentExposureEvent('growth_automation_limits_experiment', automationLimitsCohort, 'tako');
        }
    }, [
        automationFreeLimitStatus,
        fireExperimentExposureEvent
    ]);
    // This information should always be available, given the prior checks to get here
    if (!environment || !billingSourceSystem || !userEmail) return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$NoAction, {});
    const rawJstoUrl = `${(0, $lLXXb.WAC_URL)[environment]}/software/jira?ref=edition_awareness_standard_trial_` + `${billingSourceSystem.toLowerCase()}&cloudSiteId=${cloudId}`;
    const jstoUrl = (0, $dTcX5.getLoggedInPage)(userEmail, rawJstoUrl);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "@atlassian/edition-awareness.link.jira-standard-trial-overview-tooltip",
            defaultMessage: "More about your trial and how to pay",
            description: "Tooltip for trial information button"
        }),
        position: "bottom",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5yG9d.EditionAwarenessLink), {
            href: jstoUrl,
            target: "_blank",
            touchpointIntent: "addPaymentDetails",
            linkId: "jsto",
            onClick: fireAutomationFreeLimitExperimentExposure
        })
    });
};
/**
 * Sends an event when there is no action available for the customer to render. This is an error state
 * which means that audience and timing has passed a customer as eligible when they shouldn't have.
 *
 * Next iteration on this would be to return a safe default action for all customers
 */ function $3482a278540e0814$var$NoAction() {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fK9DC.useAnalytics)();
    const hasSent = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'operational',
            actionSubject: 'actionsAndContent',
            actionSubjectId: 'editionAwareness',
            action: 'missed'
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent
    ]);
    return null;
}
function $3482a278540e0814$var$FreeEdition() {
    const context = (0, $3FEPM.useEditionAwareness)();
    const { product: product, siteType: siteType, isInCollection: isInCollection, userRoles: userRoles, automationFreeLimitStatus: automationFreeLimitStatus } = context;
    const fireExperimentExposureEvent = (0, $fLNQI.useFeatureExposedAnalytics)();
    if ([
        'jira',
        'confluence'
    ].includes(product) && isInCollection && userRoles?.includes('BILLING_ADMIN') && (0, $VSDnB.fg)('teamwork_collection_ea_modal')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $atpKp.PlanSelectionPageModal), {
        type: "twc"
    });
    if ((0, $d1IFL.isEligibleForEduDiscount)(context)) {
        const cohort = (0, $iEN9D.default).getExperimentValue('offer_edu_org_discount', 'cohort', 'not-enrolled');
        fireExperimentExposureEvent('offer_edu_org_discount', cohort, 'tako');
        if (cohort === 'variation') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7f9lz.EducationalDiscountModal), {});
    }
    if ((0, $VSDnB.fg)('growth_automation_limits_kill_switch')) {
        if (automationFreeLimitStatus) {
            // These two statuses change the button content, and we need to fire exposure
            const fireExperimentExposure = automationFreeLimitStatus === 'BREACHED' || automationFreeLimitStatus === 'PROJECTED_TO_BREACH';
            const cohort = (0, $iEN9D.default).getExperimentValue('growth_automation_limits_experiment', 'cohort', 'not-enrolled', {
                fireExperimentExposure: fireExperimentExposure
            });
            if (fireExperimentExposure) fireExperimentExposureEvent('growth_automation_limits_experiment', cohort, 'tako');
            if (cohort === 'variation') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fs8rz.AutomationFreeLimitModal), {});
        }
    }
    if (product === 'jira' && // We're excluding the edu experiment cohort from seeing the refresh experiment
    siteType !== 'EDU' && siteType !== 'ORG' && (0, $iEN9D.default).getExperimentValue('jira_free_ea_modal_refresh', 'cohort', 'not-enrolled', {
        // We only want to fire the exposure when they view the modal.
        // The control experience is still inside of the product.
        fireExperimentExposure: false
    }) === 'variation') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4jK3.FreeToStandardRefreshModal), {});
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lgKHV.FreeToStandardModal), {});
}
function $3482a278540e0814$var$StandardEdition() {
    const context = (0, $3FEPM.useEditionAwareness)();
    const { product: product, isInTrial: isInTrial, isInPredunning: isInPredunning, isInvoiceable: isInvoiceable, canAddPaymentDetails: canAddPaymentDetails, isInCollection: isInCollection, userRoles: userRoles, addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl, automationFreeLimitStatus: automationFreeLimitStatus } = context;
    const fireExperimentExposureEvent = (0, $fLNQI.useFeatureExposedAnalytics)();
    if ((0, $VSDnB.fg)('growth_automation_limits_kill_switch')) {
        if (automationFreeLimitStatus) {
            const cohort = (0, $iEN9D.default).getExperimentValue('growth_automation_limits_experiment', 'cohort', 'not-enrolled', {
                fireExperimentExposure: false
            });
            if (cohort === 'variation') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fs8rz.AutomationFreeLimitModal), {});
        }
    }
    if ([
        'jira',
        'confluence'
    ].includes(product) && isInCollection && userRoles?.includes('BILLING_ADMIN') && (0, $VSDnB.fg)('teamwork_collection_ea_modal')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $atpKp.PlanSelectionPageModal), {
        type: "twc"
    });
    if ((isInTrial || isInPredunning) && isInvoiceable === false && canAddPaymentDetails) {
        if (// Only eligible for Confluence and Jira
        (0, $kbMGT.isEligibleForStandardTrialsUserAndStorageLimitBreakers)(context)) {
            const abExperimentKey = product === 'jira' ? 'jira_edition_awareness_standard_trials' : 'connie_edition_awareness_standard_trials';
            const abCohort = (0, $iEN9D.default).getExperimentValue(abExperimentKey, 'cohort', 'not-enrolled');
            fireExperimentExposureEvent(abExperimentKey, abCohort, 'luna');
            if (abCohort === 'treatment') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $70SOi.StandardTrialLimitBreakersModal), {});
        }
        if (isInTrial && (product === 'jira-service-management' || product === 'jira-product-discovery')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jsUoM.StandardAddPaymentModal), {});
        // Jira Standard - Site admins get routed to JSTO, others to payment popup
        if (product === 'jira' && isInTrial && userRoles?.includes('SITE_ADMIN')) return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$JiraStandardTrialOverviewLink, {});
        if (product === 'jira' && isInTrial && !userRoles?.includes('SITE_ADMIN')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cqUnB.PaymentDetailsPopup), {});
        if (product === 'confluence') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jsUoM.StandardAddPaymentModal), {});
        if (addPaymentDetailsExperienceUrl && isInPredunning && [
            'jira',
            'jira-service-management',
            'jira-product-discovery'
        ].includes(product)) return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$AddPaymentLink, {
            href: addPaymentDetailsExperienceUrl
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$NoAction, {});
}
function $3482a278540e0814$var$PremiumEdition() {
    const context = (0, $3FEPM.useEditionAwareness)();
    const fireExperimentExposureEvent = (0, $fLNQI.useFeatureExposedAnalytics)();
    const { product: product, isInTrial: isInTrial, isInPredunning: isInPredunning, isInReverseTrial: isInReverseTrial, isInCollection: isInCollection, addPaymentDetailsExperienceUrl: addPaymentDetailsExperienceUrl, userRoles: userRoles } = context;
    // make sure twc is always shown first before jira reverse trial
    // otherwise, jira reverse trial will be shown with collection
    if ([
        'jira',
        'confluence'
    ].includes(product) && isInCollection && userRoles?.includes('BILLING_ADMIN') && (0, $VSDnB.fg)('teamwork_collection_ea_modal')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $atpKp.PlanSelectionPageModal), {
        type: "twc"
    });
    if (product === 'jira' && (isInTrial || isInPredunning) && isInReverseTrial && userRoles?.includes('BILLING_ADMIN') && (0, $VSDnB.fg)('jira_reverse_trial_ea_updates_during_trial_gate')) {
        const rtCohort = (0, $iEN9D.default).getExperimentValue('jira_reverse_trial_ea_updates_during_trial', 'cohort', 'not-enrolled');
        fireExperimentExposureEvent('jira_reverse_trial_ea_updates_during_trial', rtCohort, 'transmuters');
        if (rtCohort === 'variation') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $atpKp.PlanSelectionPageModal), {
            type: "reverse-trial"
        });
    }
    if (product === 'jira' && isInTrial && isInReverseTrial && addPaymentDetailsExperienceUrl) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $58xN9.ReverseTrialPopupDialog), {});
    if (product === 'jira' && isInTrial && !isInReverseTrial && addPaymentDetailsExperienceUrl) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cqUnB.PaymentDetailsPopup), {});
    if (isInPredunning && [
        'jira',
        'jira-service-management'
    ].includes(product) && addPaymentDetailsExperienceUrl) return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$AddPaymentLink, {
        href: addPaymentDetailsExperienceUrl
    });
    if ((0, $3Ic4Z.isEligibleForConfluenceBuyReverseTrialExperiment)(context) && (0, $VSDnB.fg)('growth_confluence_buy_reverse_trials_fg')) {
        const abCohort = (0, $iEN9D.default).getExperimentValue('growth_confluence_buy_reverse_trials_ab', 'cohort', 'not-enrolled');
        fireExperimentExposureEvent('growth_confluence_buy_reverse_trials_ab', abCohort, 'luna');
        if (abCohort === 'variation') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $atpKp.PlanSelectionPageModal), {
            type: "reverse-trial"
        });
    }
    if (product === 'confluence' && (isInTrial || isInPredunning)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWrfe.PremiumPopup), {});
    if (isInTrial && product === 'jira-service-management') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bdE46.PremiumAddPaymentModal), {});
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$NoAction, {});
}
function $3482a278540e0814$export$3bec899b1babe0fe() {
    const { edition: edition } = (0, $3FEPM.useEditionAwareness)();
    if (edition === 'free') return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$FreeEdition, {});
    if (edition === 'standard') return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$StandardEdition, {});
    if (edition === 'premium') return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$PremiumEdition, {});
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3482a278540e0814$var$NoAction, {});
}

});
parcelRegister("fLNQI", function(module, exports) {

$parcel$export(module.exports, "FeatureExposedAnalytics", () => $056bd2b126c27fc8$export$b12ce465f015026c);
$parcel$export(module.exports, "useFeatureExposedAnalytics", () => $056bd2b126c27fc8$export$5218ddb3d9c658c0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fK9DC = parcelRequire("fK9DC");
function $056bd2b126c27fc8$export$b12ce465f015026c({ flagKey: flagKey, cohort: cohort, growthInitiative: growthInitiative, attributes: attributes, children: children }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fK9DC.useAnalytics)();
    const hasSent = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'exposed',
            actionSubject: 'feature',
            attributes: {
                ...attributes,
                flagKey: flagKey,
                cohort: cohort,
                growthInitiative: growthInitiative
            }
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        flagKey,
        cohort,
        growthInitiative,
        attributes
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
}
const $056bd2b126c27fc8$export$5218ddb3d9c658c0 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fK9DC.useAnalytics)();
    const sentFlagKeys = (0, $5uXOq.useRef)([]);
    const fireExperimentExposureEvent = (0, $5uXOq.useCallback)((flagKey, cohort, growthInitiative, attributes)=>{
        if (sentFlagKeys.current.includes(flagKey)) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'exposed',
            actionSubject: 'feature',
            attributes: {
                ...attributes,
                flagKey: flagKey,
                cohort: cohort,
                growthInitiative: growthInitiative
            }
        });
        sentFlagKeys.current.push(flagKey);
    }, [
        sendAnalyticsEvent
    ]);
    return fireExperimentExposureEvent;
};

});

parcelRegister("dTcX5", function(module, exports) {

$parcel$export(module.exports, "getLoggedInPage", () => $140e3340cc71a8c9$export$30ac0f723bd6cc08);

var $5euJh = parcelRequire("5euJh");
function $140e3340cc71a8c9$export$30ac0f723bd6cc08(userEmail, pageUrl) {
    const encodedPageUrl = encodeURIComponent(pageUrl);
    const encodedUserEmail = encodeURIComponent(userEmail);
    // This URL will take them through the login flow (if necessary) then redirect them to the given (encoded) `pageUrl`.
    return `https://${(0, $5euJh.getATLContextDomain)('id')}/login?continue=${encodedPageUrl}&login_hint=${encodedUserEmail}&prompt=none`;
}

});

parcelRegister("3Ic4Z", function(module, exports) {

$parcel$export(module.exports, "isEligibleForConfluenceBuyReverseTrialExperiment", () => $b3340c22ef929c7d$export$d8e323470f628b52);
function $b3340c22ef929c7d$export$d8e323470f628b52(context) {
    const { product: product, edition: edition, isInvoiceable: isInvoiceable, isInReverseTrial: isInReverseTrial, isInTrial: isInTrial, isInPredunning: isInPredunning, isInCollection: isInCollection, billingSourceSystem: billingSourceSystem } = context;
    return Boolean(!isInCollection && product === 'confluence' && edition === 'premium' && (isInTrial || isInPredunning) && isInReverseTrial && isInvoiceable === false && billingSourceSystem === 'CCP');
}

});

parcelRegister("d1IFL", function(module, exports) {

$parcel$export(module.exports, "isEligibleForEduDiscount", () => $4b0d670097b8546c$export$331edc99898f4a8e);
//import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls';

const $4b0d670097b8546c$export$331edc99898f4a8e = (context)=>{
    return $4b0d670097b8546c$export$f52e80ca0459b360(context) && $4b0d670097b8546c$export$eb0afc9e31269a96();
};
const $4b0d670097b8546c$export$f52e80ca0459b360 = (context)=>{
    const { edition: edition, siteType: siteType } = context;
    return edition === 'free' && (siteType === 'EDU' || siteType === 'ORG');
};
const $4b0d670097b8546c$export$eb0afc9e31269a96 = ()=>{
    // AtlBrowserStorageLocal even if is not executed, by just calling this file fails the VR test,
    //  until we have a fix, we can use the native one
    //AtlBrowserStorageLocal.getItem(PLATFORM_EDUCATIONAL_DISCOUNT_DISMISSED) !== 'true'
    try {
        return localStorage.getItem((0, $3fb654ba49d4caff$export$c5bc624b59af1952)) !== 'true';
    } catch (e) {
        return false;
    }
};

});
const $3fb654ba49d4caff$export$c5bc624b59af1952 = '__storejs_platform_educational_discount_dismissed';


parcelRegister("kbMGT", function(module, exports) {

$parcel$export(module.exports, "isEligibleForStandardTrialsUserAndStorageLimitBreakers", () => $e7554578a34e8a16$export$4ade6028e006f174);

var $VSDnB = parcelRequire("VSDnB");
function $e7554578a34e8a16$export$4ade6028e006f174(context) {
    const { product: product, edition: edition, isInTrial: isInTrial, isInPredunning: isInPredunning, isInvoiceable: isInvoiceable, licensedUsers: licensedUsers, canAddPaymentDetails: canAddPaymentDetails, trialDaysLeft: trialDaysLeft, storageUsageInGB: storageUsageInGB } = context;
    const isOnFirstTrialDay = !!(trialDaysLeft && trialDaysLeft === 14);
    const isOverUserLimit = !!(licensedUsers && licensedUsers > 10);
    const isOverStorageUsageLimit = !!(storageUsageInGB && storageUsageInGB > 2);
    if (product === 'confluence' && edition === 'standard' && (0, $VSDnB.fg)('connie_edition_awareness_standard_trials_gate')) return !!((isInTrial || isInPredunning) && isInvoiceable === false && canAddPaymentDetails && !isOnFirstTrialDay && (isOverUserLimit || isOverStorageUsageLimit));
    if (product === 'jira' && edition === 'standard' && (0, $VSDnB.fg)('jira_edition_awareness_standard_trials_gate')) return !!(isInTrial && isInvoiceable === false && canAddPaymentDetails && !isOnFirstTrialDay && (isOverUserLimit || isOverStorageUsageLimit));
    return false;
}

});

parcelRegister("lLXXb", function(module, exports) {

$parcel$export(module.exports, "WAC_URL", () => $065c6db6ca32f41a$export$5e8c8041aa206ba5);
const $065c6db6ca32f41a$export$5e8c8041aa206ba5 = {
    prod: 'https://www.atlassian.com',
    staging: 'https://wac.stg.internal.atlassian.com',
    dev: 'https://wac.stg.internal.atlassian.com',
    local: 'https://wac.stg.internal.atlassian.com'
};

});

parcelRegister("fs8rz", function(module, exports) {

$parcel$export(module.exports, "AutomationFreeLimitModal", () => $bb6ee23f729ff8f3$export$b124b7369c64df7c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3FEPM = parcelRequire("3FEPM");

var $fqeRg = parcelRequire("fqeRg");

var $iVcuU = parcelRequire("iVcuU");

var $7ed0c = parcelRequire("7ed0c");
function $bb6ee23f729ff8f3$export$b124b7369c64df7c() {
    const { edition: edition } = (0, $3FEPM.useEditionAwareness)();
    const DIALOG_CONFIG = (0, $5uXOq.useMemo)(()=>{
        if (edition === 'free') return 0, $iVcuU.FREE_DIALOG_CONFIG;
        else if (edition === 'standard') return 0, $iVcuU.STANDARD_DIALOG_CONFIG;
        throw new Error(`Unsupported edition: ${edition}`);
    }, [
        edition
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqeRg.ModalEntryPoint), {
        entryPoint: (0, $7ed0c.default),
        dialogConfig: DIALOG_CONFIG
    });
}

});
parcelRegister("fqeRg", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPoint", () => $5bda78b2de6a2af6$export$50a5ec7edfae079b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $6mahi = parcelRequire("6mahi");

var $2xaXo = parcelRequire("2xaXo");

var $MN7ms = parcelRequire("MN7ms");

var $g30DT = parcelRequire("g30DT");

var $5yG9d = parcelRequire("5yG9d");
function $5bda78b2de6a2af6$export$50a5ec7edfae079b(props) {
    const { dialogConfig: dialogConfig, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: dialogConfig,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($5bda78b2de6a2af6$var$ModalEntryPointInner, {
            ...rest
        })
    });
}
function $5bda78b2de6a2af6$var$ModalEntryPointInner(props) {
    const { entryPointProps: entryPointProps, ...rest } = props;
    const onError = (0, $MN7ms.useEntrypointErrorAnalytics)();
    const onCloseDialog = (0, $g30DT.useOnCloseDialog)();
    const onClose = (0, $5uXOq.useCallback)((extraInformation)=>{
        let attributes;
        if (extraInformation && typeof extraInformation === 'object' && 'triggeredBy' in extraInformation) attributes = {
            triggeredBy: extraInformation.triggeredBy
        };
        onCloseDialog(attributes);
        entryPointProps?.onClose?.();
    }, [
        entryPointProps,
        onCloseDialog
    ]);
    const finalEntryPointProps = (0, $5uXOq.useMemo)(()=>({
            ...entryPointProps,
            onClose: onClose
        }), [
        entryPointProps,
        onClose
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6mahi.ModalContextProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2xaXo.ModalTrigger), {
            ...rest,
            entryPointProps: finalEntryPointProps,
            onError: onError,
            children: ({ ref: ref })=>{
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5yG9d.EditionAwarenessButton), {
                    ref: ref
                });
            }
        })
    });
}

});
parcelRegister("6mahi", function(module, exports) {

$parcel$export(module.exports, "ModalContextProvider", () => $5faabe7a692a3c55$export$7c9538f5f3c365e9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $6ekCG = parcelRequire("6ekCG");
const $5faabe7a692a3c55$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $5uXOq.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $5uXOq.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $5faabe7a692a3c55$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $5uXOq.useRef)(1);
    const [modals, setModals] = (0, $5uXOq.useState)([]);
    const modalContext = (0, $5uXOq.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6ekCG.ModalContext).Provider, {
        value: modalContext,
        children: [
            children,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
                children: modals.map((modal)=>/*#__PURE__*/ (0, $2OMIu.jsx)($5faabe7a692a3c55$var$RenderModal, {
                        modal: modal
                    }, modal.key))
            })
        ]
    });
}

});
parcelRegister("6ekCG", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $820bf6641e73d83c$export$ab57792b9b6974a6);

var $5uXOq = parcelRequire("5uXOq");
const $820bf6641e73d83c$export$ab57792b9b6974a6 = (0, $5uXOq.createContext)({
    openModal: ()=>{
        throw new Error("To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-point-modal-context/ModalContextProvider';");
    }
});

});


parcelRegister("2xaXo", function(module, exports) {

$parcel$export(module.exports, "ModalTrigger", () => $e8a9a19812664108$export$fb10b32cfe19f1e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3Du7S = parcelRequire("3Du7S");

var $iwwXK = parcelRequire("iwwXK");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $414Wj = parcelRequire("414Wj");

var $f1OUK = parcelRequire("f1OUK");

var $6ekCG = parcelRequire("6ekCG");

var $7F2yO = parcelRequire("7F2yO");

var $kKgGa = parcelRequire("kKgGa");

var $e2pRJ = parcelRequire("e2pRJ");
const $e8a9a19812664108$var$emptyEntryPointParams = {};
const $e8a9a19812664108$var$emptyEntryPointProps = {};
function $e8a9a19812664108$export$fb10b32cfe19f1e({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError }) {
    const { openModal: openModal } = (0, $5uXOq.useContext)((0, $6ekCG.ModalContext));
    const environmentProvider = (0, $e2pRJ.useRelayEnvironmentProvider)();
    const { ModalErrorFallback: ModalErrorFallback } = (0, $f1OUK.useEntryPointConfig)();
    const metricName = (0, $5uXOq.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $e8a9a19812664108$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = (extraInformation)=>{
                entryPointProps?.onClose?.(extraInformation);
                closeModal();
                dispose();
            };
            const defaultFallback = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                        children: title ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                            children: title
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $414Wj.default), {
                            grow: "fill",
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7QSqG.default), {
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {}),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {}),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $juxqI.default), {})
                ]
            });
            const container = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kKgGa.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, $2OMIu.jsx)(ModalErrorFallback, {
                        error: error
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError?.({
                        error: error,
                        errorInfo: errorInfo
                    });
                    closeModal();
                },
                fallback: Fallback ? /*#__PURE__*/ (0, $2OMIu.jsx)(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $e8a9a19812664108$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1R1Ge.default), {
                ...modalProps,
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress,
                children: container
            });
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        entryPointProps,
        ModalErrorFallback,
        onError
    ]);
    const triggerRef = (0, $7F2yO.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const mergedRef = (0, $3Du7S.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}

});
parcelRegister("f1OUK", function(module, exports) {

$parcel$export(module.exports, "initEntryPointConfig", () => $925e23725d503f1a$export$93a6801f9db838c4);
$parcel$export(module.exports, "useEntryPointConfig", () => $925e23725d503f1a$export$dfa96f26176fa91f);

var $hYRTO = parcelRequire("hYRTO");

var $8Ec39 = parcelRequire("8Ec39");
const $925e23725d503f1a$var$DefaultUFOSegmentComponent = (0, $8Ec39.default);
const $925e23725d503f1a$var$entryPointConfig = {
    PlaceholderComponent: (0, $hYRTO.default),
    UFOSegmentComponent: $925e23725d503f1a$var$DefaultUFOSegmentComponent,
    ModalErrorFallback: ()=>null
};
function $925e23725d503f1a$export$93a6801f9db838c4(overrides) {
    Object.assign($925e23725d503f1a$var$entryPointConfig, overrides);
    return $925e23725d503f1a$var$entryPointConfig;
}
function $925e23725d503f1a$export$dfa96f26176fa91f() {
    return $925e23725d503f1a$var$entryPointConfig;
}

});

parcelRegister("7F2yO", function(module, exports) {

$parcel$export(module.exports, "usePressablePreloadRef", () => $5e83173393ec1687$export$1ff47f24e06a5d2d);

var $5uXOq = parcelRequire("5uXOq");
const $5e83173393ec1687$var$PRELOAD_MAX_AGE = 300000; // 5 mins
const $5e83173393ec1687$var$TIME_TO_INTENT = 200;
function $5e83173393ec1687$export$1ff47f24e06a5d2d({ load: load, onLoad: onLoad, onBeforeLoad: onBeforeLoad }) {
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const clickListener = ()=>{
            clearPreloadTimeouts();
            if (onBeforeLoad) onBeforeLoad();
            onLoad(loadReference());
        };
        const mouseDownListener = ()=>{
            clearPreloadTimeouts();
            loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $5e83173393ec1687$var$PRELOAD_MAX_AGE);
            }, $5e83173393ec1687$var$TIME_TO_INTENT);
        };
        el.addEventListener('click', clickListener);
        el.addEventListener('mousedown', mouseDownListener);
        el.addEventListener('mouseenter', preloadReference);
        el.addEventListener('mouseleave', cancelPreload);
        return ()=>{
            cancelPreload();
            el.removeEventListener('click', clickListener);
            el.removeEventListener('mousedown', mouseDownListener);
            el.removeEventListener('mouseenter', preloadReference);
            el.removeEventListener('mouseleave', cancelPreload);
        };
    }, [
        load,
        onBeforeLoad,
        onLoad
    ]);
    return ref;
}

});

parcelRegister("kKgGa", function(module, exports) {

$parcel$export(module.exports, "InternalEntryPointContainer", () => $bbe4ac5c77ca0739$export$5d4dc37edd8a3adb);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $8Uumt = parcelRequire("8Uumt");

var $jMqau = parcelRequire("jMqau");

var $f1OUK = parcelRequire("f1OUK");
function $bbe4ac5c77ca0739$export$5d4dc37edd8a3adb({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent, UFOSegmentComponent: UFOSegmentComponent } = (0, $f1OUK.useEntryPointConfig)();
    const onError = (0, $5uXOq.useCallback)((error, errorInfo)=>{
        onErrorLocal?.({
            error: error,
            errorInfo: errorInfo
        });
        (0, $jMqau.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
    }, [
        onErrorLocal,
        id
    ]);
    const FallbackComponent = (0, $5uXOq.useCallback)(({ error: error })=>{
        return errorFallback ? errorFallback({
            error: error
        }) : null;
    }, [
        errorFallback
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(UFOSegmentComponent, {
        name: id,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
            FallbackComponent: FallbackComponent,
            onError: onError,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(PlaceholderComponent, {
                name: placeholderName ?? 'internal-internal-entry-point-container',
                fallback: fallback,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Uumt.EntryPointContainer), {
                    entryPointReference: entryPointReference,
                    props: runtimeProps
                })
            })
        })
    });
}

});

parcelRegister("e2pRJ", function(module, exports) {

$parcel$export(module.exports, "RelayEnvironmentProvider", () => $f61a6caac921ade0$export$43b1f3e917d65526);
$parcel$export(module.exports, "useRelayEnvironmentProvider", () => $f61a6caac921ade0$export$e237a628f59c9f4e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $6LmWt = parcelRequire("6LmWt");
const $f61a6caac921ade0$var$environment = new (0, $eiowN.Environment)((0, $6LmWt.getDefaultRelayEnvironmentConfig)({}));
const $f61a6caac921ade0$export$43b1f3e917d65526 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Uumt.RelayEnvironmentProvider), {
        environment: $f61a6caac921ade0$var$environment,
        children: children
    });
};
const $f61a6caac921ade0$export$2f6292af3d34630d = ({ children: children })=>{
    const isRelayPresent = (0, $5uXOq.useContext)((0, $8Uumt.ReactRelayContext));
    if (isRelayPresent) return children;
    return /*#__PURE__*/ (0, $2OMIu.jsx)($f61a6caac921ade0$export$43b1f3e917d65526, {
        children: children
    });
};
function $f61a6caac921ade0$export$e237a628f59c9f4e() {
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});


parcelRegister("MN7ms", function(module, exports) {

$parcel$export(module.exports, "useEntrypointErrorAnalytics", () => $888a121fdcf492fb$export$f2e26e89f653216c);

var $5uXOq = parcelRequire("5uXOq");

var $fK9DC = parcelRequire("fK9DC");
function $888a121fdcf492fb$export$f2e26e89f653216c() {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fK9DC.useAnalytics)();
    const handleOnError = (0, $5uXOq.useCallback)(({ error: error, errorInfo: errorInfo })=>{
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            attributes: {
                error: error.message,
                errorStack: error.stack,
                errorName: error.name,
                errorComponentStack: errorInfo.componentStack,
                id: 'entrypointError'
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    return handleOnError;
}

});

parcelRegister("g30DT", function(module, exports) {

$parcel$export(module.exports, "useOnCloseDialog", () => $c8225d0f211d8e2d$export$bdf52d4393ceb609);

var $5uXOq = parcelRequire("5uXOq");

var $fK9DC = parcelRequire("fK9DC");
const $c8225d0f211d8e2d$export$bdf52d4393ceb609 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fK9DC.useAnalytics)();
    return (0, $5uXOq.useCallback)((attributes)=>{
        sendAnalyticsEvent({
            action: 'closed',
            actionSubject: 'dialog',
            actionSubjectId: 'editionAwarenessDialog',
            attributes: attributes
        });
    }, [
        sendAnalyticsEvent
    ]);
};

});

parcelRegister("5yG9d", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessButton", () => $a39e25505699b400$export$57ddd9301662f8e4);
$parcel$export(module.exports, "EditionAwarenessLink", () => $a39e25505699b400$export$1bf8122badfd728c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $iEN9D = parcelRequire("iEN9D");

var $bOVbW = parcelRequire("bOVbW");

var $i7S2n = parcelRequire("i7S2n");

var $34Rrn = parcelRequire("34Rrn");

var $8uiXJ = parcelRequire("8uiXJ");

var $lLCVr = parcelRequire("lLCVr");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $hkdaM = parcelRequire("hkdaM");

var $fK9DC = parcelRequire("fK9DC");

var $1QnZd = parcelRequire("1QnZd");

var $WqpJ2 = parcelRequire("WqpJ2");
const $a39e25505699b400$var$buttonStyles = (0, $8CUq3.xcss)({
    borderWidth: 'border.width',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    borderStyle: 'solid',
    backgroundColor: 'elevation.surface',
    borderRadius: 'border.radius.100',
    paddingInline: 'space.150',
    paddingBlock: 'space.050',
    minHeight: '32px',
    color: 'color.text',
    transitionProperty: 'color, background-color',
    transitionDuration: '200ms',
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    textDecoration: 'none',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        textDecoration: 'none',
        color: 'color.text'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        textDecoration: 'none'
    }
});
const $a39e25505699b400$var$defaultStyles = (0, $8CUq3.xcss)({
    color: 'color.text.brand',
    borderColor: 'color.border.brand',
    ':hover': {
        color: 'color.text.brand'
    }
});
const $a39e25505699b400$var$discoveryStyles = (0, $8CUq3.xcss)({
    color: 'color.text.discovery',
    borderColor: 'color.border.discovery',
    ':hover': {
        backgroundColor: 'color.background.accent.purple.subtlest.hovered',
        color: 'color.text.discovery'
    },
    ':active': {
        backgroundColor: 'color.background.accent.purple.subtlest.pressed',
        color: 'color.text.discovery'
    }
});
const $a39e25505699b400$var$warningStyles = (0, $8CUq3.xcss)({
    borderColor: 'color.border.warning'
});
const $a39e25505699b400$var$dangerStyles = (0, $8CUq3.xcss)({
    borderColor: 'color.border.danger'
});
const $a39e25505699b400$var$dismissibleStyles = (0, $8CUq3.xcss)({
    color: 'color.text.discovery',
    borderColor: 'color.border.discovery',
    borderTopRightRadius: '0',
    borderBottomRightRadius: '0',
    ':hover': {
        color: 'color.text.discovery',
        backgroundColor: 'color.background.accent.purple.subtlest.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.accent.purple.subtlest.pressed',
        textDecoration: 'none'
    }
});
const $a39e25505699b400$var$iconStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    userSelect: 'none'
});
function $a39e25505699b400$var$Icon({ appearance: appearance, icon: icon, color: color }) {
    if (icon === 'warning') {
        const defaultColor = appearance === 'danger' ? "var(--ds-icon-danger, #C9372C)" : "var(--ds-icon-warning, #E56910)";
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($34Rrn))), {
            label: "",
            color: color ?? defaultColor,
            size: "small"
        });
    }
    if (icon === 'credit-card') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i7S2n))), {
        label: "",
        color: color ?? "var(--ds-icon-discovery, #8270DB)",
        LEGACY_size: "small"
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bOVbW))), {
        label: "",
        color: color ?? "var(--ds-icon-discovery, #8270DB)"
    });
}
const $a39e25505699b400$export$57ddd9301662f8e4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function({ onClick: onClick, ...rest }, ref) {
    const buttonContent = (0, $1QnZd.useButtonContent)();
    if (buttonContent === null) throw new Error('The button content is null, please check the context');
    const { text: text, icon: icon, appearance: appearance = 'default', isDismissible: isDismissible, isEducationDiscount: isEducationDiscount } = buttonContent;
    const hasCustomTheme = (0, $lLCVr.useHasCustomTheme)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fK9DC.useAnalytics)();
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            type: 'button',
            icon: icon,
            appearance: appearance,
            isEducationDiscount: isEducationDiscount
        }), [
        icon,
        appearance,
        isEducationDiscount
    ]);
    const handleOnClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        onClick?.(e, analyticsEvent);
        const updatedAnalyticsEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editionAwareness',
                attributes: analyticsAttributes
            }));
        sendAnalyticsEvent(updatedAnalyticsEvent);
    }, [
        onClick,
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    if (hasCustomTheme) // When there's a custom theme applied we just return a button which gets styled by the theme
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $8uiXJ.Button), {
        ...rest,
        ref: ref,
        onClick: handleOnClick,
        iconBefore: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($a39e25505699b400$var$Icon, {
                appearance: appearance,
                icon: icon,
                color: "currentColor"
            }),
        children: [
            text,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hkdaM.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5ILhZ.default), {
        ...rest,
        ref: ref,
        xcss: [
            $a39e25505699b400$var$buttonStyles,
            appearance === 'default' && (0, $iEN9D.default).getExperimentValue('ea_discovery_colors', 'cohort', 'not-enrolled') !== 'variation' && $a39e25505699b400$var$defaultStyles,
            appearance === 'default' && (0, $iEN9D.default).getExperimentValue('ea_discovery_colors', 'cohort', 'not-enrolled') === 'variation' && $a39e25505699b400$var$discoveryStyles,
            appearance === 'warning' && $a39e25505699b400$var$warningStyles,
            appearance === 'danger' && $a39e25505699b400$var$dangerStyles,
            isDismissible && $a39e25505699b400$var$dismissibleStyles
        ],
        onClick: handleOnClick,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: $a39e25505699b400$var$iconStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($a39e25505699b400$var$Icon, {
                    appearance: appearance,
                    icon: icon
                })
            }),
            text,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hkdaM.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
});
const $a39e25505699b400$export$1bf8122badfd728c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function({ onClick: onClick, href: href, touchpointIntent: touchpointIntent, linkId: linkId, ...rest }, ref) {
    const buttonContent = (0, $1QnZd.useButtonContent)();
    if (buttonContent === null) throw new Error('The button content is null, please check the context');
    const { text: text, icon: icon, appearance: appearance = 'default' } = buttonContent;
    const hasCustomTheme = (0, $lLCVr.useHasCustomTheme)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fK9DC.useAnalytics)();
    const { origin: origin, url: tracedUrl } = (0, $WqpJ2.useTracedUrl)(href);
    if (!tracedUrl) throw new Error('The link url is undefined, please check the context');
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            type: 'link',
            icon: icon,
            appearance: appearance,
            touchpointIntent: touchpointIntent,
            linkId: linkId,
            ...origin.toAnalyticsAttributes()
        }), [
        icon,
        appearance,
        touchpointIntent,
        linkId,
        origin
    ]);
    const handleOnClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        onClick?.(e, analyticsEvent);
        const updatedAnalyticsEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editionAwareness',
                attributes: analyticsAttributes
            }));
        sendAnalyticsEvent(updatedAnalyticsEvent);
    }, [
        onClick,
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    if (hasCustomTheme) // When there's a custom theme applied we just return a button which gets styled by the theme
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $8uiXJ.LinkButton), {
        ...rest,
        href: tracedUrl,
        ref: ref,
        onClick: handleOnClick,
        iconBefore: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($a39e25505699b400$var$Icon, {
                appearance: appearance,
                icon: icon,
                color: "currentColor"
            }),
        children: [
            text,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hkdaM.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jhmo0.default), {
        ...rest,
        href: tracedUrl,
        ref: ref,
        xcss: [
            $a39e25505699b400$var$buttonStyles,
            appearance === 'default' && (0, $iEN9D.default).getExperimentValue('ea_discovery_colors', 'cohort', 'not-enrolled') !== 'variation' && $a39e25505699b400$var$defaultStyles,
            appearance === 'default' && (0, $iEN9D.default).getExperimentValue('ea_discovery_colors', 'cohort', 'not-enrolled') === 'variation' && $a39e25505699b400$var$discoveryStyles,
            appearance === 'warning' && $a39e25505699b400$var$warningStyles,
            appearance === 'danger' && $a39e25505699b400$var$dangerStyles
        ],
        onClick: handleOnClick,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: $a39e25505699b400$var$iconStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($a39e25505699b400$var$Icon, {
                    appearance: appearance,
                    icon: icon
                })
            }),
            text,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hkdaM.UiViewedEvent), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
});

});
parcelRegister("hkdaM", function(module, exports) {

$parcel$export(module.exports, "UiViewedEvent", () => $3c394ebe94e56f51$export$d0a9edec5c713764);

var $5uXOq = parcelRequire("5uXOq");

var $fK9DC = parcelRequire("fK9DC");
function $3c394ebe94e56f51$export$d0a9edec5c713764({ actionSubjectId: actionSubjectId, actionSubject: actionSubject, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fK9DC.useAnalytics)();
    const hasSent = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        actionSubject,
        actionSubjectId,
        attributes
    ]);
    return null;
}

});

parcelRegister("1QnZd", function(module, exports) {

$parcel$export(module.exports, "useButtonContent", () => $a7f04c3b22ba77ca$export$c810aba6284fa97d);

var $koVbs = parcelRequire("koVbs");

var $iEN9D = parcelRequire("iEN9D");

var $VSDnB = parcelRequire("VSDnB");

var $cTqug = parcelRequire("cTqug");

var $3FEPM = parcelRequire("3FEPM");

var $3Ic4Z = parcelRequire("3Ic4Z");

var $d1IFL = parcelRequire("d1IFL");

var $9o45M = parcelRequire("9o45M");

var $kbMGT = parcelRequire("kbMGT");

var $1afMW = parcelRequire("1afMW");
// TODO: `licensedUserLimit` should be fetched from the server
const $a7f04c3b22ba77ca$var$PRODUCT_LIMITS_MAP = {
    'jira-product-discovery': {
        licensedUserLimit: 3,
        warningUserLimit: 2
    },
    jira: {
        licensedUserLimit: 10,
        warningUserLimit: 7
    },
    confluence: {
        licensedUserLimit: 10,
        warningUserLimit: 3
    },
    'jira-service-management': {
        licensedUserLimit: 3,
        warningUserLimit: 2
    }
};
function $a7f04c3b22ba77ca$var$getFreeContent({ context: context, formatMessage: formatMessage }) {
    const { licensedUsers: licensedUsers, product: product, automationFreeLimitStatus: automationFreeLimitStatus } = context;
    const limits = $a7f04c3b22ba77ca$var$PRODUCT_LIMITS_MAP[product];
    // Education offer has a higher priority than all the other messages
    if ((0, $d1IFL.isEligibleForEduDiscount)(context) && (0, $iEN9D.default).getExperimentValue('offer_edu_org_discount', 'cohort', 'not-enrolled') === 'variation') return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.education-offer',
            defaultMessage: 'Education discount',
            description: 'Informs the user that they may be are eligible for an education offer which is a discount on all products'
        }),
        appearance: 'default',
        icon: 'gem',
        isEducationDiscount: true
    };
    // Is eligible for automation limits
    if ((0, $VSDnB.fg)('growth_automation_limits_kill_switch')) {
        if (automationFreeLimitStatus) {
            if (automationFreeLimitStatus === 'BREACHED' && (0, $iEN9D.default).getExperimentValue('growth_automation_limits_experiment', 'cohort', 'not-enrolled') === 'variation') return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.automation-limits-breached',
                    defaultMessage: 'Limit reached',
                    description: 'Informs the user that they have breached their automation limits'
                }),
                appearance: 'danger',
                icon: 'warning'
            };
            if (automationFreeLimitStatus === 'PROJECTED_TO_BREACH' && (0, $iEN9D.default).getExperimentValue('growth_automation_limits_experiment', 'cohort', 'not-enrolled') === 'variation') // If the automation usage is projected to breach, we show a warning
            return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.automation-near-limit',
                    defaultMessage: 'Near limit',
                    description: 'Informs the user that they are about to breach their automation limits'
                }),
                appearance: 'warning',
                icon: 'warning'
            };
        }
    }
    if ([
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ].includes(product) && licensedUsers) {
        if (licensedUsers >= limits.licensedUserLimit) return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.no-users-left',
                defaultMessage: 'No {product, select, jpd {creators} jsm {agents} jira {users} confluence {users} other {users}} left',
                description: 'Informs the user that there are no licensed users left and they may need to upgrade their product'
            }, {
                product: (0, $cTqug.getProductForTranslation)(product)
            }),
            appearance: product !== 'confluence' ? 'danger' : 'warning',
            icon: 'warning'
        };
        if (licensedUsers >= limits.warningUserLimit) return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.limited-users-left',
                defaultMessage: 'Limited {product, select, jpd {creators} jsm {agents} jira {users} confluence {users} other {users}} left',
                description: 'Informs the user that there are limited licensed users left before they need to upgrade their product'
            }, {
                product: (0, $cTqug.getProductForTranslation)(product)
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    let text = formatMessage({
        id: '@atlassian/edition-awareness.button.upgrade',
        defaultMessage: 'Upgrade',
        description: 'Informs the user that they can upgrade their product'
    });
    if (product === 'confluence' && licensedUsers && licensedUsers >= limits.warningUserLimit) // Confluence has its own variety when compared to the `userLimits` feature
    return {
        text: text,
        appearance: 'warning',
        icon: 'warning'
    };
    return {
        text: text,
        appearance: 'default',
        icon: 'gem'
    };
}
function $a7f04c3b22ba77ca$var$getTrialContent({ context: context, formatMessage: formatMessage }) {
    const { product: product, edition: edition, trialDaysLeft: trialDaysLeft, trialLengthDays: trialLengthDays, isInReverseTrial: isInReverseTrial, isInCollection: isInCollection, userRoles: userRoles } = context;
    let appearance = 'default';
    let icon = 'gem';
    const daysLeftText = formatMessage({
        id: '@atlassian/edition-awareness.button.daysLeft',
        defaultMessage: '{trialDaysLeft, plural, one {# day} other {# days}} left',
        description: 'Informs the user how many days they have left in trial'
    }, {
        trialDaysLeft: trialDaysLeft
    });
    if (product === 'jira' && (0, $kbMGT.isEligibleForStandardTrialsUserAndStorageLimitBreakers)(context) && (0, $iEN9D.default).getExperimentValue('jira_edition_awareness_standard_trials', 'cohort', 'not-enrolled') === 'treatment') return {
        text: daysLeftText,
        appearance: trialDaysLeft && trialDaysLeft <= 3 ? 'danger' : 'warning',
        icon: 'warning'
    };
    if (product === 'confluence' && (0, $kbMGT.isEligibleForStandardTrialsUserAndStorageLimitBreakers)(context) && (0, $iEN9D.default).getExperimentValue('connie_edition_awareness_standard_trials', 'cohort', 'not-enrolled') === 'treatment') return {
        text: daysLeftText,
        appearance: 'warning',
        icon: 'warning'
    };
    if ([
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ].includes(product)) {
        // Trial Countdown Experiment
        const trialCountdownExperimentEnabled = (0, $1afMW.isEligibleForTrialCountdown)(context) && (0, $iEN9D.default).getExperimentValue('jira_edition_awareness_trial_countdown', 'isEnabled', false);
        // If trial is 3 days or less, swap the button to the warning state
        if (trialCountdownExperimentEnabled && !!trialDaysLeft && trialDaysLeft <= 3) {
            appearance = 'warning';
            icon = 'warning';
        }
        // If trial is still in its first half, show trial message instead of trial days left
        const isInFirstHalfOfTrial = Boolean(trialCountdownExperimentEnabled && trialDaysLeft && trialLengthDays && trialDaysLeft > Math.ceil(trialLengthDays / 2));
        if (!isInCollection && edition === 'premium' && product === 'jira' && isInReverseTrial && userRoles?.includes('BILLING_ADMIN') && (0, $VSDnB.fg)('jira_reverse_trial_ea_updates_during_trial_gate')) {
            if ((0, $iEN9D.default).getExperimentValue('jira_reverse_trial_ea_updates_during_trial', 'cohort', 'not-enrolled') === 'variation') {
                appearance = 'default';
                icon = 'gem';
                if (isInFirstHalfOfTrial) return {
                    text: formatMessage({
                        id: '@atlassian/edition-awareness.button.see-plans',
                        defaultMessage: 'See plans',
                        description: 'Informs the user that they are able to see plans'
                    }),
                    appearance: appearance,
                    icon: icon
                };
                if (trialCountdownExperimentEnabled && !!trialDaysLeft && trialDaysLeft <= 3) {
                    appearance = 'warning';
                    icon = 'warning';
                }
            }
        }
        if (isInFirstHalfOfTrial) {
            if (edition === 'premium') return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.premium-trial',
                    defaultMessage: 'Premium trial',
                    description: 'Informs the user that they are on a premium trial'
                }),
                appearance: appearance,
                icon: icon
            };
            if (edition === 'standard') return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.standard-trial',
                    defaultMessage: 'Standard trial',
                    description: 'Informs the user that they are on a standard trial'
                }),
                appearance: appearance,
                icon: icon
            };
        }
    }
    if ((0, $3Ic4Z.isEligibleForConfluenceBuyReverseTrialExperiment)(context) && (0, $VSDnB.fg)('growth_confluence_buy_reverse_trials_fg')) {
        const abCohort = (0, $iEN9D.default).getExperimentValue('growth_confluence_buy_reverse_trials_ab', 'cohort', 'not-enrolled');
        if (abCohort === 'variation') {
            appearance = 'default';
            icon = 'gem';
            if (trialDaysLeft && trialDaysLeft > 15) return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.see-plans.cbrt',
                    defaultMessage: 'See plans',
                    description: 'Informs the user that they are able to see plans'
                }),
                appearance: appearance,
                icon: icon
            };
            if (trialDaysLeft && trialDaysLeft <= 3) {
                appearance = 'warning';
                icon = 'warning';
            }
            return {
                text: formatMessage({
                    id: '@atlassian/edition-awareness.button.see-plans.cbrt.final',
                    defaultMessage: '{trialDaysLeft, plural, =1 {# day} other {# days}} left',
                    description: 'Indicates to the user how many days they have left in trial'
                }, {
                    trialDaysLeft: trialDaysLeft
                }),
                appearance: appearance,
                icon: icon
            };
        }
    }
    return {
        text: daysLeftText,
        appearance: appearance,
        icon: icon
    };
}
function $a7f04c3b22ba77ca$var$getPredunningContent({ context: context, formatMessage: formatMessage }) {
    const { edition: edition, product: product, isInReverseTrial: isInReverseTrial, userRoles: userRoles } = context;
    let appearance = 'default';
    let icon = 'credit-card';
    if ((0, $kbMGT.isEligibleForStandardTrialsUserAndStorageLimitBreakers)(context) && (0, $iEN9D.default).getExperimentValue(product === 'jira' ? 'jira_edition_awareness_standard_trials' : 'connie_edition_awareness_standard_trials', 'cohort', 'not-enrolled') === 'treatment') {
        appearance = 'warning';
        icon = 'warning';
    }
    if (product === 'jira' && edition === 'premium' && isInReverseTrial && userRoles?.includes('BILLING_ADMIN') && (0, $VSDnB.fg)('jira_reverse_trial_ea_updates_during_trial_gate')) {
        if ((0, $iEN9D.default).getExperimentValue('jira_reverse_trial_ea_updates_during_trial', 'cohort', 'not-enrolled') === 'variation') return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.choose-plans.not-final',
                defaultMessage: 'Choose a plan',
                description: 'Informs the user that they are able to choose a plan'
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    if ((0, $3Ic4Z.isEligibleForConfluenceBuyReverseTrialExperiment)(context) && (0, $VSDnB.fg)('growth_confluence_buy_reverse_trials_fg')) {
        if ((0, $iEN9D.default).getExperimentValue('growth_confluence_buy_reverse_trials_ab', 'cohort', 'not-enrolled') === 'variation') return {
            text: formatMessage({
                id: '@atlassian/edition-awareness.button.see-plans.final',
                defaultMessage: 'Choose a plan',
                description: 'Informs the user that they are able to choose a plan'
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.addPaymentDetails',
            defaultMessage: 'Add payment details',
            description: 'Informs the user how many days they have left in trial'
        }),
        appearance: appearance,
        icon: icon
    };
}
function $a7f04c3b22ba77ca$export$c810aba6284fa97d() {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const context = (0, $3FEPM.useEditionAwareness)();
    const { edition: edition, isInPredunning: isInPredunning, isInTrial: isInTrial } = context;
    if (edition === 'free') return $a7f04c3b22ba77ca$var$getFreeContent({
        context: context,
        formatMessage: formatMessage
    });
    if (isInTrial) return $a7f04c3b22ba77ca$var$getTrialContent({
        context: context,
        formatMessage: formatMessage
    });
    if (isInPredunning) return $a7f04c3b22ba77ca$var$getPredunningContent({
        context: context,
        formatMessage: formatMessage
    });
    if ((0, $9o45M.isEligibleForStandardToPremium)(context)) return {
        text: formatMessage({
            id: '@atlassian/edition-awareness.button.upgrade.standard-to-premium',
            defaultMessage: 'Upgrade',
            description: 'Informs the user that they can upgrade their product'
        }),
        appearance: 'default',
        icon: 'gem',
        isDismissible: true
    };
    return null;
}

});
parcelRegister("cTqug", function(module, exports) {

$parcel$export(module.exports, "getProductForTranslation", () => $a9f0f14d955225c0$export$fd45d905638d9909);
const $a9f0f14d955225c0$var$PRODUCT_TO_TRANSLATION_KEY = {
    jira: 'jira',
    'jira-service-management': 'jsm',
    'jira-product-discovery': 'jpd',
    confluence: 'confluence'
};
function $a9f0f14d955225c0$export$fd45d905638d9909(product) {
    return $a9f0f14d955225c0$var$PRODUCT_TO_TRANSLATION_KEY[product];
}

});

parcelRegister("9o45M", function(module, exports) {

$parcel$export(module.exports, "isEligibleForStandardToPremium", () => $5564c251c9100eb3$export$d58c0da339bf36d9);

var $VSDnB = parcelRequire("VSDnB");
function $5564c251c9100eb3$export$d58c0da339bf36d9({ product: product, edition: edition, userRoles: userRoles, trialOfferingName: trialOfferingName }) {
    if (edition === 'standard' && userRoles?.includes('SITE_ADMIN') && trialOfferingName === 'premium') {
        if (product === 'jira' && (0, $VSDnB.fg)('edition_awareness_upsell_jira_fg')) return true;
        if (product === 'jira-service-management' && (0, $VSDnB.fg)('edition_awareness_upsell_jsm_fg')) return true;
        if (product === 'confluence' && (0, $VSDnB.fg)('edition_awareness_standard_upsell_confluence_ab_fg')) return true;
    }
    return false;
}

});

parcelRegister("1afMW", function(module, exports) {

$parcel$export(module.exports, "isEligibleForTrialCountdown", () => $704eb02e2a7cd5f7$export$947e3549c8b868b2);
function $704eb02e2a7cd5f7$export$947e3549c8b868b2({ isInTrial: isInTrial, isInPredunning: isInPredunning, trialDaysLeft: trialDaysLeft, trialLengthDays: trialLengthDays, billingSourceSystem: billingSourceSystem }) {
    return Boolean(isInTrial && !isInPredunning && trialDaysLeft && trialLengthDays && billingSourceSystem === 'CCP');
}

});


parcelRegister("WqpJ2", function(module, exports) {

$parcel$export(module.exports, "useTracedUrl", () => $55bd0a2d6197e971$export$5eea7bde9861e87b);

var $5uXOq = parcelRequire("5uXOq");

var $2gQ83 = parcelRequire("2gQ83");

var $3FEPM = parcelRequire("3FEPM");
const $55bd0a2d6197e971$var$PRODUCT_TO_ORIGIN = {
    ['confluence']: 'confluence',
    ['jira']: 'jira',
    ['jira-product-discovery']: 'jira',
    ['jira-service-management']: 'jira'
};
function $55bd0a2d6197e971$export$5eea7bde9861e87b(untracedUrl) {
    const { product: product } = (0, $3FEPM.useEditionAwareness)();
    const origin = (0, $5uXOq.useMemo)(()=>new (0, $2gQ83.default)({
            product: $55bd0a2d6197e971$var$PRODUCT_TO_ORIGIN[product]
        }), [
        product
    ]);
    const url = (0, $5uXOq.useMemo)(()=>untracedUrl ? origin.addToUrl(untracedUrl) : undefined, [
        untracedUrl,
        origin
    ]);
    return {
        url: url,
        origin: origin
    };
}

});



parcelRegister("iVcuU", function(module, exports) {

$parcel$export(module.exports, "FREE_DIALOG_CONFIG", () => $b9942c80cc77f1e8$export$212eac90358facd0);
$parcel$export(module.exports, "STANDARD_DIALOG_CONFIG", () => $b9942c80cc77f1e8$export$e42f11d536a45036);
const $b9942c80cc77f1e8$export$212eac90358facd0 = {
    touchpointIntent: 'startTrial',
    dialogId: 'automation-free-limit-modal',
    dialogType: 'modal'
};
const $b9942c80cc77f1e8$export$e42f11d536a45036 = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'automation-free-limit-modal',
    dialogType: 'modal'
};

});

parcelRegister("7ed0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $862be7909cc88863$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $862be7909cc88863$var$AutomationLimitsEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("brsaa")), {
        moduleId: "fda1ad3d",
        priority: "interaction",
        moduleId: 'edition-awareness-automation-free-limit-modal'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});
var $862be7909cc88863$export$2e2bcd8739ae039 = $862be7909cc88863$var$AutomationLimitsEntryPoint;

});
parcelRegister("brsaa", function(module, exports) {

let $85480fe3812e0ab9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $85480fe3812e0ab9$var$load("ffQaD"),
    $85480fe3812e0ab9$var$load("kvRbA"),
    $85480fe3812e0ab9$var$load("fHQec")
]).then(()=>parcelRequire('bkuHu'));

});



parcelRegister("7f9lz", function(module, exports) {

$parcel$export(module.exports, "EducationalDiscountModal", () => $ea09eb44c81c0acd$export$de2b13100dac8ba0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3FEPM = parcelRequire("3FEPM");

var $8XFbn = parcelRequire("8XFbn");

var $fqeRg = parcelRequire("fqeRg");

var $ddn5Q = parcelRequire("ddn5Q");

var $am19W = parcelRequire("am19W");
function $ea09eb44c81c0acd$export$de2b13100dac8ba0() {
    const { product: product, cloudId: cloudId } = (0, $3FEPM.useEditionAwareness)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $8XFbn.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqeRg.ModalEntryPoint), {
        entryPoint: (0, $am19W.default),
        entryPointParams: entryPointParams,
        dialogConfig: (0, $ddn5Q.DIALOG_CONFIG)
    });
}

});
parcelRegister("ddn5Q", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $54cad9aa55c4620d$export$3b6761b6086f6dfd);
const $54cad9aa55c4620d$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'educational-discount-modal',
    dialogType: 'modal'
};

});

parcelRegister("am19W", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e226df5b3f8617d$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $45cOQ = parcelRequire("45cOQ");

const $4e226df5b3f8617d$var$EducationalDiscountModalEntryPoint = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("2spW9")), {
        moduleId: "a0292cb1",
        priority: "interaction",
        moduleId: 'edition-awareness-educational-discount-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                educationalDiscountModalQuery: {
                    parameters: $45cOQ.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});
var $4e226df5b3f8617d$export$2e2bcd8739ae039 = $4e226df5b3f8617d$var$EducationalDiscountModalEntryPoint;

});
parcelRegister("45cOQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5e52c62d51a6d66$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<71fc22eea8452b41c41f32d4f8e71017>>
 * @relayHash 236c7751dd3ef5300ca437d3bf117c6b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6dd9cff085430f8433189997e10042f7abf9d72162fee59cd9792a463a46fcd8

var $eiowN = parcelRequire("eiowN");
const $c5e52c62d51a6d66$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "educationalDiscountModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "educationalDiscountModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6dd9cff085430f8433189997e10042f7abf9d72162fee59cd9792a463a46fcd8",
            "metadata": {},
            "name": "educationalDiscountModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c5e52c62d51a6d66$var$node.hash = "4d9eb09412065e0af10ae7b23d3bb374";
(0, $eiowN.PreloadableQueryRegistry).set($c5e52c62d51a6d66$var$node.params.id, $c5e52c62d51a6d66$var$node);
var $c5e52c62d51a6d66$export$2e2bcd8739ae039 = $c5e52c62d51a6d66$var$node;

});

parcelRegister("2spW9", function(module, exports) {

let $1ca250d37a88a4f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1ca250d37a88a4f5$var$load("ffQaD"),
    $1ca250d37a88a4f5$var$load("kvRbA"),
    $1ca250d37a88a4f5$var$load("ewcLP")
]).then(()=>parcelRequire('7Wrli'));

});



parcelRegister("lgKHV", function(module, exports) {

$parcel$export(module.exports, "FreeToStandardModal", () => $c4d0a4da93571358$export$61689b501c3b79e6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3FEPM = parcelRequire("3FEPM");

var $iENAf = parcelRequire("iENAf");

var $4olyx = parcelRequire("4olyx");

var $8XFbn = parcelRequire("8XFbn");

var $fqeRg = parcelRequire("fqeRg");

var $gN6W6 = parcelRequire("gN6W6");

var $fXwec = parcelRequire("fXwec");

var $b23Cd = parcelRequire("b23Cd");
function $c4d0a4da93571358$export$61689b501c3b79e6() {
    const { product: product, cloudId: cloudId } = (0, $3FEPM.useEditionAwareness)();
    const jiraApplicationKey = (0, $iENAf.getJiraApplicationKey)(product);
    const projectType = (0, $4olyx.getJiraProjectTypeKey)(product);
    const { abCohort: abCohort } = (0, $b23Cd.useNBEAExperiment)({
        fireExperimentExposure: false,
        product: product
    });
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $8XFbn.getHamsKey)(product),
            // Fallback to any valid value since this means that we're not using jira
            jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
            // Fallback to any valid value since this means that we're not using jira
            projectType: projectType ?? 'SOFTWARE',
            isJira: product === 'jira' || product === 'jira-product-discovery' || product === 'jira-service-management',
            isConfluence: product === 'confluence',
            shouldIncludeGUPS: product === 'confluence' && (abCohort === 'control' || abCohort === 'treatment')
        }), [
        abCohort,
        cloudId,
        product,
        projectType,
        jiraApplicationKey
    ]);
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: 'x-large',
            autoFocus: false
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqeRg.ModalEntryPoint), {
        entryPoint: (0, $fXwec.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $gN6W6.DIALOG_CONFIG)
    });
}

});
parcelRegister("4olyx", function(module, exports) {

$parcel$export(module.exports, "getJiraProjectTypeKey", () => $b06333016913fe73$export$600268f282087736);
// We're explicitly excluding 'confluence' from this mapping as it's handled separately
const $b06333016913fe73$var$PRODUCT_TO_JIRA_PROJECT_TYPE_KEY = {
    ['jira']: 'SOFTWARE',
    ['jira-product-discovery']: 'PRODUCT_DISCOVERY',
    ['jira-service-management']: 'SERVICE_DESK'
};
const $b06333016913fe73$export$600268f282087736 = (product)=>{
    return $b06333016913fe73$var$PRODUCT_TO_JIRA_PROJECT_TYPE_KEY[product];
};

});

parcelRegister("gN6W6", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $22959ca1017ed740$export$3b6761b6086f6dfd);
const $22959ca1017ed740$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'free-to-standard-modal',
    dialogType: 'modal'
};

});

parcelRegister("fXwec", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $e34d4951d8f800e7$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $dSYrV = parcelRequire("dSYrV");

const $e34d4951d8f800e7$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("exEcE")), {
        moduleId: "afc4323d",
        priority: "interaction",
        moduleId: 'edition-awareness-free-to-standard-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey, projectType: projectType, jiraApplicationKey: jiraApplicationKey, isJira: isJira, isConfluence: isConfluence, shouldIncludeGUPS: shouldIncludeGUPS })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                freeToStandardModalQuery: {
                    parameters: $dSYrV.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey,
                        jiraApplicationKey: jiraApplicationKey,
                        projectType: projectType,
                        isJira: isJira,
                        isConfluence: isConfluence,
                        shouldIncludeGUPS: shouldIncludeGUPS
                    }
                }
            }
        })
});

});
parcelRegister("dSYrV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff2d91492ecbde13$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7f3ee4383ec9a738cdc6ed1e3e398fc4>>
 * @relayHash 90906a68f1d9de998a00e00947d783c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e96cda97495fe99137aa59772c0761c1ad1697ea434dfb04eed5dfc8f45af31b

var $eiowN = parcelRequire("eiowN");
const $ff2d91492ecbde13$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hamsProductKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConfluence"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJira"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraApplicationKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectType"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeGUPS"
    }, v7 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v9 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Premium"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v11 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v13 = {
        "condition": "isConfluence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v11 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "cql",
                        "value": "type=user"
                    },
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100
                    }
                ],
                "concreteType": "ConfluenceSearchConnection",
                "kind": "LinkedField",
                "name": "confluence_searchUser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConfluenceSearchResponse",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "ConfluencePerson",
                                "kind": "LinkedField",
                                "name": "confluencePerson",
                                "plural": false,
                                "selections": [
                                    v12 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                    },
                                    {
                                        "concreteType": "Icon",
                                        "kind": "LinkedField",
                                        "name": "profilePicture",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "path"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ConfluenceStorage",
                "kind": "LinkedField",
                "name": "confluence_storage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isUnlimited"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesUsed"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesLimit"
                    }
                ]
            }
        ]
    }, v14 = {
        "condition": "shouldIncludeGUPS",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "tenantId",
                        "variableName": "cloudId"
                    }
                ],
                "concreteType": "GrowthUnifiedProfileResult",
                "kind": "LinkedField",
                "name": "growthUnifiedProfile_getUnifiedProfile",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "GrowthUnifiedProfileSiteDetails",
                        "kind": "LinkedField",
                        "name": "sites",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "GrowthUnifiedProfileProductDetails",
                                "kind": "LinkedField",
                                "name": "products",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "productName"
                                    },
                                    {
                                        "concreteType": "GrowthUnifiedProfileProductNBE",
                                        "kind": "LinkedField",
                                        "name": "nbeRecommendation",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "edition"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "recommendationDate"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v15 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "jiraApplicationKey"
        },
        v11 /*: any*/ 
    ], v16 = {
        "args": v15 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageAllowed"
    }, v17 = {
        "args": v15 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageUsed"
    }, v18 = {
        "args": v15 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageIsUnlimited"
    }, v19 = [
        v11 /*: any*/ ,
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v20 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v22 = {
        "kind": "ScalarField",
        "name": "name"
    }, v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v24 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "freeToStandardModalQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "condition": "isConfluence",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "alias": "changeOfferingPremium",
                                                            "args": v9 /*: any*/ ,
                                                            "kind": "LinkedField",
                                                            "name": "changeOfferingV2",
                                                            "plural": false,
                                                            "selections": [
                                                                v10 /*: any*/ 
                                                            ],
                                                            "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                {
                                    "args": v19 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v20 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v12 /*: any*/ ,
                                                                                v21 /*: any*/ ,
                                                                                v22 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "freeToStandardModalQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v23 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                {
                                                    "condition": "isConfluence",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "alias": "changeOfferingPremium",
                                                            "args": v9 /*: any*/ ,
                                                            "kind": "LinkedField",
                                                            "name": "changeOfferingV2",
                                                            "plural": false,
                                                            "selections": [
                                                                v23 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ],
                                                            "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v24 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                {
                                    "args": v19 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v20 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v23 /*: any*/ ,
                                                                                v12 /*: any*/ ,
                                                                                v21 /*: any*/ ,
                                                                                v22 /*: any*/ ,
                                                                                v24 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        },
                                                        v24 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e96cda97495fe99137aa59772c0761c1ad1697ea434dfb04eed5dfc8f45af31b",
            "metadata": {},
            "name": "freeToStandardModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ff2d91492ecbde13$var$node.hash = "5e382e6ce80e83f893e5415c561a687b";
(0, $eiowN.PreloadableQueryRegistry).set($ff2d91492ecbde13$var$node.params.id, $ff2d91492ecbde13$var$node);
var $ff2d91492ecbde13$export$2e2bcd8739ae039 = $ff2d91492ecbde13$var$node;

});

parcelRegister("exEcE", function(module, exports) {

let $a963553b0328d510$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a963553b0328d510$var$load("ffQaD"),
    $a963553b0328d510$var$load("kvRbA"),
    $a963553b0328d510$var$load("gxp3Q")
]).then(()=>parcelRequire('66CjE'));

});


parcelRegister("b23Cd", function(module, exports) {

$parcel$export(module.exports, "useNBEAExperiment", () => $6ea5fa5220a3b73f$export$d8f75705812ce676);

var $iEN9D = parcelRequire("iEN9D");

var $VSDnB = parcelRequire("VSDnB");
const $6ea5fa5220a3b73f$export$d8f75705812ce676 = ({ fireExperimentExposure: fireExperimentExposure = false, product: product })=>{
    const abExperimentKey = 'confluence_next_best_edition_recommend';
    let abCohort = 'not-enrolled';
    if (product === 'confluence' && (0, $VSDnB.fg)('edition_awareness_confluence_next_best_rec_fg')) abCohort = (0, $iEN9D.default).getExperimentValue(abExperimentKey, 'cohort', 'not-enrolled', {
        fireExperimentExposure: fireExperimentExposure
    });
    return {
        abExperimentKey: abExperimentKey,
        abCohort: abCohort
    };
};

});


parcelRegister("e4jK3", function(module, exports) {

$parcel$export(module.exports, "FreeToStandardRefreshModal", () => $c7fcfff8f84c4b82$export$bb3f0c07c7eb1cc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3FEPM = parcelRequire("3FEPM");

var $4olyx = parcelRequire("4olyx");

var $fqeRg = parcelRequire("fqeRg");

var $1bkFQ = parcelRequire("1bkFQ");

var $1WdVX = parcelRequire("1WdVX");
function $c7fcfff8f84c4b82$export$bb3f0c07c7eb1cc() {
    const { product: product, cloudId: cloudId } = (0, $3FEPM.useEditionAwareness)();
    const projectType = (0, $4olyx.getJiraProjectTypeKey)(product);
    if (!projectType) throw new Error('Tried to render free to standard refresh dialog for unsupported product');
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectType: projectType
        }), [
        cloudId,
        projectType
    ]);
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: 932,
            height: 500,
            autoFocus: false
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqeRg.ModalEntryPoint), {
        entryPoint: (0, $1WdVX.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $1bkFQ.DIALOG_CONFIG)
    });
}

});
parcelRegister("1bkFQ", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $5d32a81bccddd3dd$export$3b6761b6086f6dfd);
const $5d32a81bccddd3dd$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'free-to-standard-refresh-modal',
    dialogType: 'modal'
};

});

parcelRegister("1WdVX", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $d3c8576a99d2f07b$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $85x9Q = parcelRequire("85x9Q");

const $d3c8576a99d2f07b$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("dnKaE")), {
        moduleId: "b8007f47",
        priority: "interaction",
        moduleId: 'edition-awareness-free-to-standard-refresh-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, projectType: projectType })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                freeToStandardRefreshModalQuery: {
                    parameters: $85x9Q.default,
                    variables: {
                        cloudId: cloudId,
                        projectType: projectType
                    }
                }
            }
        })
});

});
parcelRegister("85x9Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $7995c9f2836cb32c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bcad1347ec5d911979066311575d1def>>
 * @relayHash 076bb6c4d9d049c1aa218840c9dfadc1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2e787304b75e454ca0c1651c155b7a855b7719b06c5e57941f7042940c5d3694

var $eiowN = parcelRequire("eiowN");
const $7995c9f2836cb32c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectType"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "freeToStandardRefreshModalQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v2 /*: any*/ ,
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "assignableUsers(first:10)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "freeToStandardRefreshModalQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v2 /*: any*/ ,
                                                    "concreteType": "JiraAssignableUsersConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignableUsers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAssignableUsersEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "__typename"
                                                                        },
                                                                        v3 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        v6 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "assignableUsers(first:10)"
                                                },
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2e787304b75e454ca0c1651c155b7a855b7719b06c5e57941f7042940c5d3694",
            "metadata": {},
            "name": "freeToStandardRefreshModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7995c9f2836cb32c$var$node.hash = "add28ab8fceeba3e37a636585af2dd9f";
(0, $eiowN.PreloadableQueryRegistry).set($7995c9f2836cb32c$var$node.params.id, $7995c9f2836cb32c$var$node);
var $7995c9f2836cb32c$export$2e2bcd8739ae039 = $7995c9f2836cb32c$var$node;

});

parcelRegister("dnKaE", function(module, exports) {

let $9be13ce74bec4aa0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9be13ce74bec4aa0$var$load("ffQaD"),
    $9be13ce74bec4aa0$var$load("kvRbA"),
    $9be13ce74bec4aa0$var$load("4xNyz")
]).then(()=>parcelRequire('koKC7'));

});



parcelRegister("cqUnB", function(module, exports) {

$parcel$export(module.exports, "PaymentDetailsPopup", () => $c706820ec700ea6d$export$7d88b723086482e8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $jdrEY = parcelRequire("jdrEY");

var $g3dmM = parcelRequire("g3dmM");

var $7370u = parcelRequire("7370u");
function $c706820ec700ea6d$export$7d88b723086482e8() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdrEY.PopupEntryPoint), {
        entryPoint: (0, $7370u.entryPoint),
        placement: 'bottom-start',
        dialogConfig: (0, $g3dmM.DIALOG_CONFIG)
    });
}

});
parcelRegister("jdrEY", function(module, exports) {

$parcel$export(module.exports, "PopupEntryPoint", () => $372cc0fa708c4601$export$e14c42e99b209c4d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $dC5iT = parcelRequire("dC5iT");

var $eZJjh = parcelRequire("eZJjh");

var $epiY4 = parcelRequire("epiY4");

var $MN7ms = parcelRequire("MN7ms");

var $g30DT = parcelRequire("g30DT");

var $5yG9d = parcelRequire("5yG9d");
function $372cc0fa708c4601$export$e14c42e99b209c4d(props) {
    const { dialogConfig: dialogConfig, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: dialogConfig,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($372cc0fa708c4601$export$dece147acb9eddff, {
            ...rest
        })
    });
}
function $372cc0fa708c4601$export$dece147acb9eddff(props) {
    const { onClose: onClose, ...rest } = props;
    const onError = (0, $MN7ms.useEntrypointErrorAnalytics)();
    const onCloseDialog = (0, $g30DT.useOnCloseDialog)();
    const onClosePopup = (0, $5uXOq.useCallback)((event, currentLevel)=>{
        onClose?.(event, currentLevel);
        onCloseDialog();
    }, [
        onClose,
        onCloseDialog
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epiY4.PopupTrigger), {
        ...rest,
        shouldFitContainer: false,
        trigger: ({ ref: ref })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5yG9d.EditionAwarenessButton), {
                ref: ref
            }),
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)($372cc0fa708c4601$var$PopupFallback, {}),
        onError: onError,
        onClose: onClosePopup
    });
}
const $372cc0fa708c4601$var$PopupFallback = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        padding: "space.200",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {})
    });

});
parcelRegister("epiY4", function(module, exports) {

$parcel$export(module.exports, "PopupTrigger", () => $781807c7b62182e7$export$95d4acdbab2fc6ef);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $bWn3s = parcelRequire("bWn3s");

var $1I7E8 = parcelRequire("1I7E8");

var $eZJjh = parcelRequire("eZJjh");

var $7F2yO = parcelRequire("7F2yO");

var $kKgGa = parcelRequire("kKgGa");

var $e2pRJ = parcelRequire("e2pRJ");

var $h5nmx = parcelRequire("h5nmx");
const $781807c7b62182e7$var$emptyEntryPointParams = {};
const $781807c7b62182e7$var$emptyEntryPointProps = {};
function $781807c7b62182e7$export$95d4acdbab2fc6ef({ trigger: trigger, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, onClose: onClose, ...popupProps }) {
    const environmentProvider = (0, $e2pRJ.useRelayEnvironmentProvider)();
    const id = (0, $5uXOq.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [content, setContent] = (0, $5uXOq.useState)(null);
    const handleOpen = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    const handleClose = (0, $5uXOq.useCallback)((event, currentLevel)=>{
        setIsOpen(false);
        onClose?.(event, currentLevel);
    }, [
        onClose
    ]);
    const triggerCloseRef = (0, $h5nmx.useClickToCloseRef)({
        isOpen: isOpen,
        handleClose: handleClose
    });
    const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $781807c7b62182e7$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing popup
        if (isOpen) return;
        handleOpen();
        setContent(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kKgGa.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: fallback || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {}),
            errorFallback: errorFallback,
            runtimeProps: {
                ...entryPointProps ?? $781807c7b62182e7$var$emptyEntryPointProps,
                onClose: handleClose
            },
            onError: onError
        }));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        fallback,
        errorFallback,
        handleOpen,
        onError,
        handleClose
    ]);
    const triggerRef = (0, $7F2yO.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>{
        const mergedRef = (0, $bWn3s.mergeRefs)([
            triggerRef,
            triggerProps.ref,
            triggerCloseRef
        ]);
        return trigger({
            ...triggerProps,
            ref: mergedRef
        });
    }, [
        trigger,
        triggerRef,
        triggerCloseRef
    ]);
    const popupContent = (0, $5uXOq.useCallback)(()=>{
        return content;
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.Popup), {
        ...popupProps,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent
    });
}

});
parcelRegister("h5nmx", function(module, exports) {

$parcel$export(module.exports, "useClickToCloseRef", () => $650ad7aa5b0bf102$export$46ec6629f411921d);

var $5uXOq = parcelRequire("5uXOq");
function $650ad7aa5b0bf102$export$46ec6629f411921d({ isOpen: isOpen, handleClose: handleClose }) {
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const clickListener = ()=>{
            if (isOpen) handleClose(null);
        };
        el.addEventListener('click', clickListener);
        return ()=>{
            el.removeEventListener('click', clickListener);
        };
    }, [
        isOpen,
        handleClose
    ]);
    return ref;
}

});



parcelRegister("g3dmM", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $0057c556402c3c24$export$3b6761b6086f6dfd);
const $0057c556402c3c24$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'payment-details-popup',
    dialogType: 'pop-up'
};

});

parcelRegister("7370u", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $a5bda9579c6f7760$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $a5bda9579c6f7760$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("izlhj")), {
        moduleId: "43cb1037",
        priority: "interaction",
        moduleId: 'edition-awareness-payment-details-popup'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});

});
parcelRegister("izlhj", function(module, exports) {

let $d84c004fa51cf061$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d84c004fa51cf061$var$load("ffQaD"),
    $d84c004fa51cf061$var$load("kvRbA"),
    $d84c004fa51cf061$var$load("i5Bkm")
]).then(()=>parcelRequire('kVUzD'));

});



parcelRegister("atpKp", function(module, exports) {

$parcel$export(module.exports, "PlanSelectionPageModal", () => $ce74530d6b1db893$export$d906ffa5ff65562d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3FEPM = parcelRequire("3FEPM");

var $8XFbn = parcelRequire("8XFbn");

var $fqeRg = parcelRequire("fqeRg");

var $1wEVF = parcelRequire("1wEVF");

var $ljWQH = parcelRequire("ljWQH");
const $ce74530d6b1db893$var$MODAL_CONFIGS = {
    twc: {
        width: '968px',
        height: '808px'
    },
    'reverse-trial': {
        width: '990px',
        height: '771px'
    }
};
function $ce74530d6b1db893$export$d906ffa5ff65562d({ type: type }) {
    const { cloudId: cloudId, product: product } = (0, $3FEPM.useEditionAwareness)();
    const { width: width, height: height } = $ce74530d6b1db893$var$MODAL_CONFIGS[type];
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $8XFbn.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            type: type
        }), [
        type
    ]);
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: width,
            height: height,
            autoFocus: false,
            shouldScrollInViewport: false,
            shouldCloseOnEscape: true
        }), [
        width,
        height
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqeRg.ModalEntryPoint), {
        entryPointProps: entryPointProps,
        entryPoint: (0, $ljWQH.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $1wEVF.DIALOG_CONFIG)
    });
}

});
parcelRegister("1wEVF", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $6b62bad7ae06882e$export$3b6761b6086f6dfd);
const $6b62bad7ae06882e$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'plan-selection-page-modal',
    dialogType: 'modal'
};

});

parcelRegister("ljWQH", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $b28200a9b93857a3$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $aRF9e = parcelRequire("aRF9e");

const $b28200a9b93857a3$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("gZ5Gl")), {
        moduleId: "d069ac51",
        priority: "interaction",
        moduleId: 'edition-awareness-plan-selection-page-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                planSelectionPageModalQuery: {
                    parameters: $aRF9e.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("aRF9e", function(module, exports) {

$parcel$export(module.exports, "default", () => $064a43783816dbc4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4a2c299c3370e776909144f2aeddf21a>>
 * @relayHash f8efbc82dcbdf8e7ea9e842b687fdc1e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 139c0d7db1e5c65a657e8eba68202a4fd9b24e66331526d96b03609175ad4f45

var $eiowN = parcelRequire("eiowN");
const $064a43783816dbc4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "planSelectionPageModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "planSelectionPageModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "139c0d7db1e5c65a657e8eba68202a4fd9b24e66331526d96b03609175ad4f45",
            "metadata": {},
            "name": "planSelectionPageModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$064a43783816dbc4$var$node.hash = "5856634e7757286e019aec8f127ddc46";
(0, $eiowN.PreloadableQueryRegistry).set($064a43783816dbc4$var$node.params.id, $064a43783816dbc4$var$node);
var $064a43783816dbc4$export$2e2bcd8739ae039 = $064a43783816dbc4$var$node;

});

parcelRegister("gZ5Gl", function(module, exports) {

let $c5d6c03172c827a4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c5d6c03172c827a4$var$load("9LElu").then(()=>parcelRequire('g8r1P'));

});



parcelRegister("bdE46", function(module, exports) {

$parcel$export(module.exports, "PremiumAddPaymentModal", () => $e6561e3823a84fc0$export$45cd24e1ba5c2588);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fqeRg = parcelRequire("fqeRg");

var $eRhfr = parcelRequire("eRhfr");

var $ftYGE = parcelRequire("ftYGE");
function $e6561e3823a84fc0$export$45cd24e1ba5c2588() {
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: 968,
            height: 576,
            autoFocus: false
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqeRg.ModalEntryPoint), {
        entryPoint: (0, $ftYGE.entryPoint),
        modalProps: modalProps,
        dialogConfig: (0, $eRhfr.DIALOG_CONFIG)
    });
}

});
parcelRegister("eRhfr", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $19087ac5445cd394$export$3b6761b6086f6dfd);
const $19087ac5445cd394$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'premium-add-payment-modal',
    dialogType: 'modal'
};

});

parcelRegister("ftYGE", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $07083e40bfb36ce7$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $07083e40bfb36ce7$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("cB5uS")), {
        moduleId: "f32031a2",
        priority: "interaction",
        moduleId: 'edition-awareness-premium-add-payment-modal'
    }),
    getPreloadProps: ()=>({
            entryPoints: {},
            extraProps: {},
            queries: {}
        })
});

});
parcelRegister("cB5uS", function(module, exports) {

let $92bd3453407f76f2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $92bd3453407f76f2$var$load("c2T49").then(()=>parcelRequire('lHPtr'));

});



parcelRegister("dWrfe", function(module, exports) {

$parcel$export(module.exports, "PremiumPopup", () => $382e4b9628fbf4f9$export$831a974b36144ba6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3FEPM = parcelRequire("3FEPM");

var $8XFbn = parcelRequire("8XFbn");

var $jdrEY = parcelRequire("jdrEY");

var $jAe9B = parcelRequire("jAe9B");

var $k3H5P = parcelRequire("k3H5P");

var $kgS3o = parcelRequire("kgS3o");
const $382e4b9628fbf4f9$export$831a974b36144ba6 = ()=>{
    const { cloudId: cloudId, product: product, PremiumWrapper: PremiumWrapper, trialDaysLeft: trialDaysLeft, userRoles: userRoles, shouldAutoOpen: shouldAutoOpen, onAutoOpen: onAutoOpen, isInTrial: isInTrial, isInReverseTrial: isInReverseTrial } = (0, $3FEPM.useEditionAwareness)();
    const [isPremiumModalOpen, setIsPremiumModalOpen] = (0, $5uXOq.useState)(false);
    const handleClosePremiumModal = (0, $5uXOq.useCallback)(()=>setIsPremiumModalOpen(false), []);
    const handleOpenPremiumModal = (0, $5uXOq.useCallback)(()=>setIsPremiumModalOpen(true), []);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $8XFbn.getHamsKey)(product)
        }), [
        product,
        cloudId
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            handleOpenPremiumModal: handleOpenPremiumModal
        }), [
        handleOpenPremiumModal
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        // This will reset the auto open state from product
        onAutoOpen?.();
    }, [
        onAutoOpen
    ]);
    if (!PremiumWrapper) // Shouldn't happen, but if it does then we can at least still show the customer a dialog
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: shouldAutoOpen ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jAe9B.AutoOpenPopupTrigger), {
            entryPoint: (0, $kgS3o.entryPoint),
            entryPointParams: entryPointParams,
            entryPointProps: entryPointProps,
            placement: 'bottom-start',
            onClose: onClose,
            dialogConfig: (0, $k3H5P.DIALOG_CONFIG)
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdrEY.PopupEntryPoint), {
            entryPoint: (0, $kgS3o.entryPoint),
            entryPointParams: entryPointParams,
            entryPointProps: entryPointProps,
            placement: 'bottom-start',
            onClose: onClose,
            dialogConfig: (0, $k3H5P.DIALOG_CONFIG)
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(PremiumWrapper, {
            isInTrial: Boolean(isInTrial),
            isInReverseTrial: Boolean(isInReverseTrial),
            trialDaysLeft: trialDaysLeft,
            isSiteAdmin: !!userRoles?.includes('SITE_ADMIN'),
            isPremiumModalOpen: isPremiumModalOpen,
            onClosePremiumModal: handleClosePremiumModal,
            children: shouldAutoOpen ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jAe9B.AutoOpenPopupTrigger), {
                entryPoint: (0, $kgS3o.entryPoint),
                entryPointParams: entryPointParams,
                entryPointProps: entryPointProps,
                placement: 'bottom-start',
                onClose: onClose,
                dialogConfig: (0, $k3H5P.DIALOG_CONFIG)
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdrEY.PopupEntryPoint), {
                entryPoint: (0, $kgS3o.entryPoint),
                entryPointParams: entryPointParams,
                entryPointProps: entryPointProps,
                placement: 'bottom-start',
                onClose: onClose,
                dialogConfig: (0, $k3H5P.DIALOG_CONFIG)
            })
        })
    });
};

});
parcelRegister("jAe9B", function(module, exports) {

$parcel$export(module.exports, "AutoOpenPopupTrigger", () => $ddc140c934736ab7$export$6189e5bf9171fa04);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $daJ0i = parcelRequire("daJ0i");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");

var $eZJjh = parcelRequire("eZJjh");

var $kKgGa = parcelRequire("kKgGa");

var $e2pRJ = parcelRequire("e2pRJ");

var $MN7ms = parcelRequire("MN7ms");

var $g30DT = parcelRequire("g30DT");

var $5yG9d = parcelRequire("5yG9d");
const $ddc140c934736ab7$var$emptyEntryPointParams = {};
const $ddc140c934736ab7$var$emptyEntryPointProps = {};
function $ddc140c934736ab7$export$6189e5bf9171fa04(props) {
    const { dialogConfig: dialogConfig, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: dialogConfig,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($ddc140c934736ab7$var$AutoOpenPopupTriggerInner, {
            ...rest
        })
    });
}
/**
 * THIS IS A TEMPORARY IMPLEMENTATION, WILL BE REMOVED IN THE FUTURE
 * NOT RECOMMENDED FOR USE ANYWHERE ELSE
 * Supports the auto-open functionality for the Confluence Premium Popup
 */ function $ddc140c934736ab7$var$AutoOpenPopupTriggerInner({ entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorFallback: errorFallback, onClose: onClose, ...popupProps }) {
    const environmentProvider = (0, $e2pRJ.useRelayEnvironmentProvider)();
    const onError = (0, $MN7ms.useEntrypointErrorAnalytics)();
    const onDismiss = (0, $g30DT.useOnCloseDialog)();
    const id = (0, $5uXOq.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [content, setContent] = (0, $5uXOq.useState)(null);
    const handleOpen = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    const handleClose = (0, $5uXOq.useCallback)((event, currentLevel)=>{
        setIsOpen(false);
        onClose?.(event, currentLevel);
        onDismiss();
    }, [
        onClose,
        onDismiss
    ]);
    const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $ddc140c934736ab7$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when closing popup
        if (isOpen) return;
        handleOpen();
        setContent(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kKgGa.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: /*#__PURE__*/ (0, $2OMIu.jsx)($ddc140c934736ab7$var$PopupFallback, {}),
            errorFallback: errorFallback,
            runtimeProps: entryPointProps || $ddc140c934736ab7$var$emptyEntryPointProps,
            onError: onError
        }));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        errorFallback,
        handleOpen,
        onError
    ]);
    const handleToggleAndLoad = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) {
            handleClose(null);
            return;
        }
        handleOpen();
        onLoad({
            reference: load()
        });
    }, [
        isOpen,
        handleOpen,
        onLoad,
        load,
        handleClose
    ]);
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5yG9d.EditionAwarenessButton), {
            ...triggerProps,
            ref: triggerProps.ref,
            onClick: handleToggleAndLoad
        });
    }, [
        handleToggleAndLoad
    ]);
    const popupContent = (0, $5uXOq.useCallback)(()=>{
        return content;
    }, [
        content
    ]);
    const hasRun = (0, $5uXOq.useRef)(false);
    // Auto-open on load
    (0, $5uXOq.useEffect)(()=>{
        if (!hasRun.current) {
            handleToggleAndLoad?.();
            hasRun.current = true;
        }
    }, [
        handleToggleAndLoad
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.Popup), {
        ...popupProps,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent,
        shouldFitContainer: false
    });
}
const $ddc140c934736ab7$var$PopupFallback = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        padding: "space.200",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {})
    });

});

parcelRegister("k3H5P", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $eade7cb58c8ed02d$export$3b6761b6086f6dfd);
const $eade7cb58c8ed02d$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'premium-popup',
    dialogType: 'pop-up'
};

});

parcelRegister("kgS3o", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $6a5994877fa72183$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $1ACT3 = parcelRequire("1ACT3");

const $6a5994877fa72183$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("2QHah")), {
        moduleId: "d68a8af6",
        priority: "interaction",
        moduleId: 'edition-awareness-premium-popup'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                confluencePremiumPopupQuery: {
                    parameters: $1ACT3.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("1ACT3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dcd2f09a194e47c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5821fe529cfc22897c2985ff0ad736c4>>
 * @relayHash f5958739e09e5411147f112f6550ea59
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 477817a92613a7818d8c6b7b9c49bbc1517b2ca7a3bc41a318aaf8920c59e4c7

var $eiowN = parcelRequire("eiowN");
const $3dcd2f09a194e47c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "confluencePremiumPopupQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "confluencePremiumPopupQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "477817a92613a7818d8c6b7b9c49bbc1517b2ca7a3bc41a318aaf8920c59e4c7",
            "metadata": {},
            "name": "confluencePremiumPopupQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3dcd2f09a194e47c$var$node.hash = "42c226cd7fc904c05729c90bcaaed23e";
(0, $eiowN.PreloadableQueryRegistry).set($3dcd2f09a194e47c$var$node.params.id, $3dcd2f09a194e47c$var$node);
var $3dcd2f09a194e47c$export$2e2bcd8739ae039 = $3dcd2f09a194e47c$var$node;

});

parcelRegister("2QHah", function(module, exports) {

let $2131ebb92007b44e$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2131ebb92007b44e$var$load("ffQaD"),
    $2131ebb92007b44e$var$load("kvRbA"),
    $2131ebb92007b44e$var$load("jLxjG")
]).then(()=>parcelRequire('d4aet'));

});



parcelRegister("58xN9", function(module, exports) {

$parcel$export(module.exports, "ReverseTrialPopupDialog", () => $e48cce26789d8014$export$436172fa0e71e289);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3FEPM = parcelRequire("3FEPM");

var $8XFbn = parcelRequire("8XFbn");

var $jdrEY = parcelRequire("jdrEY");

var $3tndl = parcelRequire("3tndl");

var $ibJH7 = parcelRequire("ibJH7");
function $e48cce26789d8014$export$436172fa0e71e289() {
    const { product: product, cloudId: cloudId } = (0, $3FEPM.useEditionAwareness)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $8XFbn.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdrEY.PopupEntryPoint), {
        entryPoint: (0, $ibJH7.entryPoint),
        entryPointParams: entryPointParams,
        placement: 'bottom-end',
        dialogConfig: (0, $3tndl.DIALOG_CONFIG)
    });
}

});
parcelRegister("3tndl", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $39d2e9c6d06ffc4a$export$3b6761b6086f6dfd);
const $39d2e9c6d06ffc4a$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'reverse-trial-popup',
    dialogType: 'pop-up'
};

});

parcelRegister("ibJH7", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $f3acead4efc37e67$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $d1LfD = parcelRequire("d1LfD");

const $f3acead4efc37e67$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("6KmS1")), {
        moduleId: "38aee5f9",
        priority: "interaction",
        moduleId: 'edition-awareness-reverse-trial-popup'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                reverseTrialPopupQuery: {
                    parameters: $d1LfD.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("d1LfD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9acc660f1511759$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9e7ab9d82c11f650f2bdc01edf024c90>>
 * @relayHash fb387ee4c17d62b6ce4867baf6061884
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe23b73929c26e3fa0b23fad14fc6c713c94abcd8a87983ce3d62e052dbade3b

var $eiowN = parcelRequire("eiowN");
const $e9acc660f1511759$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Free"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "reverseTrialPopupQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Free\")"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "reverseTrialPopupQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Free\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fe23b73929c26e3fa0b23fad14fc6c713c94abcd8a87983ce3d62e052dbade3b",
            "metadata": {},
            "name": "reverseTrialPopupQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e9acc660f1511759$var$node.hash = "7149df0cbb7841476e95591ab561c360";
(0, $eiowN.PreloadableQueryRegistry).set($e9acc660f1511759$var$node.params.id, $e9acc660f1511759$var$node);
var $e9acc660f1511759$export$2e2bcd8739ae039 = $e9acc660f1511759$var$node;

});

parcelRegister("6KmS1", function(module, exports) {

let $4e98c7889c05bb28$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $4e98c7889c05bb28$var$load("ffQaD"),
    $4e98c7889c05bb28$var$load("kvRbA"),
    $4e98c7889c05bb28$var$load("9BU0W")
]).then(()=>parcelRequire('dLHdH'));

});



parcelRegister("jsUoM", function(module, exports) {

$parcel$export(module.exports, "StandardAddPaymentModal", () => $5bdc306376eb84f8$export$e7d982549be9547c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3FEPM = parcelRequire("3FEPM");

var $eDHw9 = parcelRequire("eDHw9");

var $iENAf = parcelRequire("iENAf");

var $4olyx = parcelRequire("4olyx");

var $8XFbn = parcelRequire("8XFbn");

var $fqeRg = parcelRequire("fqeRg");

var $9fEJL = parcelRequire("9fEJL");

var $i6c6V = parcelRequire("i6c6V");
function $5bdc306376eb84f8$export$e7d982549be9547c() {
    const { product: product, cloudId: cloudId } = (0, $3FEPM.useEditionAwareness)();
    const projectType = (0, $4olyx.getJiraProjectTypeKey)(product);
    const jiraApplicationKey = (0, $iENAf.getJiraApplicationKey)(product);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $8XFbn.getHamsKey)(product),
            chargeElement: (0, $eDHw9.getChargeElementKey)(product),
            // Fallback to any valid value since this means that we're not using jira
            jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
            // Fallback to any valid value since this means that we're not using jira
            projectType: projectType ?? 'SOFTWARE',
            isJira: product === 'jira' || product === 'jira-product-discovery' || product === 'jira-service-management',
            isConfluence: product === 'confluence'
        }), [
        cloudId,
        product,
        projectType,
        jiraApplicationKey
    ]);
    const modalProps = (0, $5uXOq.useMemo)(()=>{
        if (product === 'confluence') return {
            width: 1000,
            height: 600,
            autoFocus: false
        };
        return {
            width: 968,
            height: 576,
            autoFocus: false
        };
    }, [
        product
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqeRg.ModalEntryPoint), {
        entryPoint: (0, $i6c6V.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $9fEJL.DIALOG_CONFIG)
    });
}

});
parcelRegister("9fEJL", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $0143b4b130c65af7$export$3b6761b6086f6dfd);
const $0143b4b130c65af7$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'standard-add-payment-modal',
    dialogType: 'modal'
};

});

parcelRegister("i6c6V", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $d8ecac50f1a5c7ce$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $jBMqI = parcelRequire("jBMqI");

const $d8ecac50f1a5c7ce$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("cxubx")), {
        moduleId: "8a2449b3",
        priority: "interaction",
        moduleId: 'edition-awareness-standard-add-payment-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey, projectType: projectType, chargeElement: chargeElement, jiraApplicationKey: jiraApplicationKey, isJira: isJira, isConfluence: isConfluence })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                standardAddPaymentModalQuery: {
                    parameters: $jBMqI.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey,
                        chargeElement: chargeElement,
                        projectType: projectType,
                        jiraApplicationKey: jiraApplicationKey,
                        isJira: isJira,
                        isConfluence: isConfluence
                    }
                }
            }
        })
});

});
parcelRegister("jBMqI", function(module, exports) {

$parcel$export(module.exports, "default", () => $07fd2fa68d1faaf7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3b3d06950d8808c536cc8274ff85d913>>
 * @relayHash 4e0cde97decbb0067683335eca19adf4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 94cab309f37bdbb58e4045588cb7e4d01d70a5df8d4a21aa077c3abac0417a53

var $eiowN = parcelRequire("eiowN");
const $07fd2fa68d1faaf7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "chargeElement"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hamsProductKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConfluence"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJira"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraApplicationKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectType"
    }, v7 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v9 = {
        "args": [
            {
                "kind": "Variable",
                "name": "chargeElement",
                "variableName": "chargeElement"
            }
        ],
        "kind": "ScalarField",
        "name": "latestUsageForChargeElement"
    }, v10 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v12 = {
        "condition": "isConfluence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v10 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "cql",
                        "value": "type=user"
                    },
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100
                    }
                ],
                "concreteType": "ConfluenceSearchConnection",
                "kind": "LinkedField",
                "name": "confluence_searchUser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConfluenceSearchResponse",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "ConfluencePerson",
                                "kind": "LinkedField",
                                "name": "confluencePerson",
                                "plural": false,
                                "selections": [
                                    v11 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "displayName"
                                    },
                                    {
                                        "concreteType": "Icon",
                                        "kind": "LinkedField",
                                        "name": "profilePicture",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "path"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ConfluenceStorage",
                "kind": "LinkedField",
                "name": "confluence_storage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isUnlimited"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesUsed"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bytesLimit"
                    }
                ]
            }
        ]
    }, v13 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "jiraApplicationKey"
        },
        v10 /*: any*/ 
    ], v14 = {
        "args": v13 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageAllowed"
    }, v15 = {
        "args": v13 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageUsed"
    }, v16 = {
        "args": v13 /*: any*/ ,
        "kind": "ScalarField",
        "name": "attachmentStorageIsUnlimited"
    }, v17 = [
        v10 /*: any*/ ,
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "types.0",
                            "variableName": "projectType"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "types"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v18 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v19 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v20 = {
        "kind": "ScalarField",
        "name": "name"
    }, v21 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v22 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "standardAddPaymentModalQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v12 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                {
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v18 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v20 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "standardAddPaymentModalQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v21 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v22 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v12 /*: any*/ ,
                {
                    "condition": "isJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                {
                                    "args": v17 /*: any*/ ,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": v18 /*: any*/ ,
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v20 /*: any*/ ,
                                                                                v22 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:10)"
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "94cab309f37bdbb58e4045588cb7e4d01d70a5df8d4a21aa077c3abac0417a53",
            "metadata": {},
            "name": "standardAddPaymentModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$07fd2fa68d1faaf7$var$node.hash = "2ddf382d33e70366163b253ba6606c4b";
(0, $eiowN.PreloadableQueryRegistry).set($07fd2fa68d1faaf7$var$node.params.id, $07fd2fa68d1faaf7$var$node);
var $07fd2fa68d1faaf7$export$2e2bcd8739ae039 = $07fd2fa68d1faaf7$var$node;

});

parcelRegister("cxubx", function(module, exports) {

let $920ffb3cdf8a8bd9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $920ffb3cdf8a8bd9$var$load("ffQaD"),
    $920ffb3cdf8a8bd9$var$load("kvRbA"),
    $920ffb3cdf8a8bd9$var$load("a2OZ9")
]).then(()=>parcelRequire('TcFHL'));

});



parcelRegister("70SOi", function(module, exports) {

$parcel$export(module.exports, "StandardTrialLimitBreakersModal", () => $a75bb0018d8c9fca$export$5c6029d6bd848fe3);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3FEPM = parcelRequire("3FEPM");

var $iENAf = parcelRequire("iENAf");

var $4olyx = parcelRequire("4olyx");

var $fqeRg = parcelRequire("fqeRg");

var $nFmXe = parcelRequire("nFmXe");

var $dFJHz = parcelRequire("dFJHz");
function $a75bb0018d8c9fca$export$5c6029d6bd848fe3() {
    const { product: product, cloudId: cloudId } = (0, $3FEPM.useEditionAwareness)();
    const jiraApplicationKey = (0, $iENAf.getJiraApplicationKey)(product);
    const projectType = (0, $4olyx.getJiraProjectTypeKey)(product);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
            projectType: projectType ?? 'SOFTWARE',
            shouldIncludeIfProductIsConfluence: product === 'confluence',
            shouldIncludeIfProductIsJiraSoftware: product === 'jira'
        }), [
        cloudId,
        product,
        projectType,
        jiraApplicationKey
    ]);
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: 'x-large',
            autoFocus: false
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqeRg.ModalEntryPoint), {
        entryPoint: (0, $dFJHz.entryPoint),
        entryPointParams: entryPointParams,
        modalProps: modalProps,
        dialogConfig: (0, $nFmXe.DIALOG_CONFIG)
    });
}

});
parcelRegister("nFmXe", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $602ce1708c3fd603$export$3b6761b6086f6dfd);
const $602ce1708c3fd603$export$3b6761b6086f6dfd = {
    touchpointIntent: 'addPaymentDetails',
    dialogId: 'standard-trial-limit-breakers-modal',
    dialogType: 'modal'
};

});

parcelRegister("dFJHz", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $a96ee1e53514afa0$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $5CNWf = parcelRequire("5CNWf");

const $a96ee1e53514afa0$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("9QBYK")), {
        moduleId: "bd9500f5",
        priority: "interaction",
        moduleId: 'edition-awareness-standard-trial-limit-breakers-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, jiraApplicationKey: jiraApplicationKey, projectType: projectType, shouldIncludeIfProductIsConfluence: shouldIncludeIfProductIsConfluence, shouldIncludeIfProductIsJiraSoftware: shouldIncludeIfProductIsJiraSoftware })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                standardTrialLimitBreakersModalQuery: {
                    parameters: $5CNWf.default,
                    variables: {
                        cloudId: cloudId,
                        jiraApplicationKey: jiraApplicationKey,
                        projectType: projectType,
                        shouldIncludeIfProductIsConfluence: shouldIncludeIfProductIsConfluence,
                        shouldIncludeIfProductIsJiraSoftware: shouldIncludeIfProductIsJiraSoftware
                    }
                }
            }
        })
});

});
parcelRegister("5CNWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0a9915ede77cf73$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5b5daae3b2e5c7f370af984ee874175f>>
 * @relayHash 159aeb2dbeae4cea01c89f69877eb716
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f0270c0bbe7a563912c010111dfd2d666b4229d8e3dd0527df152a6c0d02e5bd

var $eiowN = parcelRequire("eiowN");
const $d0a9915ede77cf73$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraApplicationKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldIncludeIfProductIsConfluence"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldIncludeIfProductIsJiraSoftware"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "applicationKey",
            "variableName": "jiraApplicationKey"
        },
        v1 /*: any*/ 
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "standardTrialLimitBreakersModalQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "jiraApplicationKey",
                            "variableName": "jiraApplicationKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectType",
                            "variableName": "projectType"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldIncludeIfProductIsConfluence",
                            "variableName": "shouldIncludeIfProductIsConfluence"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldIncludeIfProductIsJiraSoftware",
                            "variableName": "shouldIncludeIfProductIsJiraSoftware"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "limitBreakersModal_AtlassianEditionAwareness"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "standardTrialLimitBreakersModalQuery",
            "selections": [
                {
                    "condition": "shouldIncludeIfProductIsConfluence",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v1 /*: any*/ 
                            ],
                            "concreteType": "ConfluenceStorage",
                            "kind": "LinkedField",
                            "name": "confluence_storage",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isUnlimited"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "bytesLimit"
                                }
                            ]
                        },
                        {
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "cql",
                                    "value": "type=user"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 200
                                }
                            ],
                            "concreteType": "ConfluenceSearchConnection",
                            "kind": "LinkedField",
                            "name": "confluence_searchUser",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceSearchResponse",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluencePerson",
                                            "kind": "LinkedField",
                                            "name": "confluencePerson",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "displayName"
                                                },
                                                {
                                                    "concreteType": "Icon",
                                                    "kind": "LinkedField",
                                                    "name": "profilePicture",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "path"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldIncludeIfProductIsJiraSoftware",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "attachmentStorageAllowed"
                                },
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "attachmentStorageIsUnlimited"
                                },
                                {
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "fields": [
                                                {
                                                    "items": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "types.0",
                                                            "variableName": "projectType"
                                                        }
                                                    ],
                                                    "kind": "ListValue",
                                                    "name": "types"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "filter"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 10
                                        }
                                    ],
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "allJiraProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 20
                                                                }
                                                            ],
                                                            "concreteType": "JiraAssignableUsersConnection",
                                                            "kind": "LinkedField",
                                                            "name": "assignableUsers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAssignableUsersEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "__typename"
                                                                                },
                                                                                v2 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "name"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "picture"
                                                                                },
                                                                                v4 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "assignableUsers(first:20)"
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f0270c0bbe7a563912c010111dfd2d666b4229d8e3dd0527df152a6c0d02e5bd",
            "metadata": {},
            "name": "standardTrialLimitBreakersModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d0a9915ede77cf73$var$node.hash = "70fbc764ea31e18b35433affd71b9531";
(0, $eiowN.PreloadableQueryRegistry).set($d0a9915ede77cf73$var$node.params.id, $d0a9915ede77cf73$var$node);
var $d0a9915ede77cf73$export$2e2bcd8739ae039 = $d0a9915ede77cf73$var$node;

});

parcelRegister("9QBYK", function(module, exports) {

let $72b66e2c0c28b9bf$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $72b66e2c0c28b9bf$var$load("ffQaD"),
    $72b66e2c0c28b9bf$var$load("kvRbA"),
    $72b66e2c0c28b9bf$var$load("amhyI")
]).then(()=>parcelRequire('gkPa8'));

});





parcelRegister("2VfNT", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $17101b2a8b1e705a$export$e926676385687eaf);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $1tcYS = parcelRequire("1tcYS");

var $bFU4G = parcelRequire("bFU4G");

var $gLHhx = parcelRequire("gLHhx");
const $17101b2a8b1e705a$export$e926676385687eaf = ({ children: children, product: product, edition: edition, id: id })=>{
    const handleOnError = (0, $gLHhx.useErrorAnalytics)({
        product: product,
        edition: edition,
        id: id
    });
    const ufoContext = (0, $1tcYS.useInteractionContext)();
    const onError = (0, $5uXOq.useCallback)((error)=>{
        const interaction = (0, $bFU4G.getActiveInteraction)();
        handleOnError(error);
        if (interaction && ufoContext) (0, $bFU4G.addError)(interaction?.id, error.name, ufoContext?.labelStack, 'interaction error', error.message, error.stack);
        else (0, $bFU4G.addErrorToAll)(`ErrorBoundary:${id}`, ufoContext?.labelStack || null, 'interaction error', error.message);
    }, [
        handleOnError,
        id,
        ufoContext
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        onError: onError,
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {}),
        children: children
    });
};

});
parcelRegister("gLHhx", function(module, exports) {

$parcel$export(module.exports, "useErrorAnalytics", () => $1ccc13a3ba7b3e4a$export$e2d4523bbccd2343);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $fK9DC = parcelRequire("fK9DC");
/**
 * This hook is designed to be used before contexts are initialized to avoid circular dependencies.
 */ function $1ccc13a3ba7b3e4a$var$useOperationalFailureAnalytics({ product: product, edition: edition }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((attributes)=>{
        const event = createAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            attributes: {
                ...(0, $fK9DC.defaultAttributes),
                product: product,
                currentProductEdition: edition,
                ...attributes
            }
        });
        const contextAttributes = (0, $fK9DC.getAttributesFromContexts)(event.context);
        event.update({
            attributes: {
                ...contextAttributes,
                ...event.payload.attributes
            }
        }).fire((0, $fK9DC.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        product,
        edition
    ]);
}
/**
 * These are errors which we ignore from SLO reporting to ensure we reporting on errors we can action
 */ const $1ccc13a3ba7b3e4a$var$nonSLOErrors = [
    /**
	 * These occur when the fetch request fails (usually this is because the users network is offline)
	 *
	 * This is usually thrown from inside of the products fetch handler
	 * e.g. jira/src/packages/platform/utils/fetch/src/utils/requests.tsx adds the handler which throws this error to every fetch request
	 */ /failed to fetch/i,
    /**
	 * These occur when the fetch request fails due to a server response (e.g. 401 due to the user needing to reauthenticate their session)
	 * e.g. jira/src/packages/platform/utils/fetch/src/utils/requests.tsx adds the handler which throws server errors after parsing the response headers
	 */ /Error server response:/i
];
function $1ccc13a3ba7b3e4a$var$isSLOError(error) {
    // Just checks that none of our non slo errors match the error
    return !$1ccc13a3ba7b3e4a$var$nonSLOErrors.some((msg)=>msg.test(error.message));
}
function $1ccc13a3ba7b3e4a$export$e2d4523bbccd2343({ product: product, edition: edition, id: id }) {
    const sendOperationalFailure = $1ccc13a3ba7b3e4a$var$useOperationalFailureAnalytics({
        product: product,
        edition: edition
    });
    return (0, $5uXOq.useCallback)((error)=>{
        sendOperationalFailure({
            error: error.message,
            errorStack: error.stack,
            errorName: error.name,
            id: id ?? 'unknownErrorId',
            isSLOError: $1ccc13a3ba7b3e4a$var$isSLOError(error)
        });
    }, [
        sendOperationalFailure,
        id
    ]);
}
function $1ccc13a3ba7b3e4a$export$45aafd752da9ba22({ product: product, edition: edition }) {
    const sendOperationalFailure = $1ccc13a3ba7b3e4a$var$useOperationalFailureAnalytics({
        product: product,
        edition: edition
    });
    return (0, $5uXOq.useCallback)((dataValidationError)=>{
        sendOperationalFailure({
            dataValidationError: dataValidationError,
            id: 'dataValidationError'
        });
    }, [
        sendOperationalFailure
    ]);
}

});


parcelRegister("gsZRM", function(module, exports) {

$parcel$export(module.exports, "Spotlight", () => $f936fed46fee814e$export$1033c28b5e1c2deb);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $7gs1W = parcelRequire("7gs1W");
var $1QiBP = parcelRequire("1QiBP");

var $3FEPM = parcelRequire("3FEPM");

var $9o45M = parcelRequire("9o45M");
function $f936fed46fee814e$export$1033c28b5e1c2deb() {
    const context = (0, $3FEPM.useEditionAwareness)();
    const { product: product, isSpotlightActive: isSpotlightActive, handleSetSpotlight: handleSetSpotlight } = context;
    const handleDismissSpotlight = (0, $5uXOq.useCallback)(()=>{
        handleSetSpotlight?.(false);
    }, [
        handleSetSpotlight
    ]);
    if ((0, $9o45M.isEligibleForStandardToPremium)(context)) {
        const target = product === 'confluence' ? 'nav-profile' : 'profile-spotlight';
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1QiBP.default), {
            children: isSpotlightActive && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7gs1W.default), {
                actions: [
                    {
                        onClick: handleDismissSpotlight,
                        text: 'Got it'
                    }
                ],
                target: target,
                targetRadius: 3,
                dialogWidth: 275,
                targetBgColor: "var(--ds-elevation-surface-current, #FFFFFF)",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    id: "@atlassian/edition-awareness.spotlight.message",
                    defaultMessage: "Not ready to upgrade? Return to your profile when you're ready.",
                    description: "Message to show in the spotlight on the profile menu icon when the user dismisses the EA pill and is eligible for standard to premium upsell"
                })
            }, target)
        });
    }
    return null;
}

});


parcelRegister("ksvM4", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessUpsell", () => $a619047c1df66de2$export$148b30c5d238daaa);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $iEN9D = parcelRequire("iEN9D");

var $8Ec39 = parcelRequire("8Ec39");

var $e2pRJ = parcelRequire("e2pRJ");

var $fLNQI = parcelRequire("fLNQI");

var $3FEPM = parcelRequire("3FEPM");

var $RKWjF = parcelRequire("RKWjF");

var $9o45M = parcelRequire("9o45M");

var $4o6si = parcelRequire("4o6si");

var $hWEZj = parcelRequire("hWEZj");

var $2VfNT = parcelRequire("2VfNT");

var $gsZRM = parcelRequire("gsZRM");
/**
 * Edition awareness upsell is an experimental EA implementtiona that has to be exported as its own component to avoid making ccp calls which are alerting VC90 mertics
 *
 * This component deals with creating the context which is then used throughout the package to:
 * - Track analytics
 * - Know which product/edition/cloud id is being used
 * - Know when to show/hide the button
 */ function $a619047c1df66de2$var$EditionAwarenessUpsellImpl({ edition: edition, product: product, cloudId: cloudId, userRoles: userRoles, hasDismissedButton: hasDismissedButton, onDismissButton: onDismissButton, navVersion: navVersion }) {
    const { isSpotlightActive: isSpotlightActive, handleSetSpotlight: handleSetSpotlight } = (0, $4o6si.useSpotlight)();
    const trialOfferingName = (0, $RKWjF.getTrialOfferingName)(product, edition);
    const context = (0, $5uXOq.useMemo)(()=>{
        return {
            cloudId: cloudId,
            product: product,
            edition: edition,
            userRoles: userRoles,
            hasDismissedButton: hasDismissedButton,
            onDismissButton: onDismissButton,
            isSpotlightActive: isSpotlightActive,
            handleSetSpotlight: handleSetSpotlight,
            trialOfferingName: trialOfferingName
        };
    }, [
        cloudId,
        product,
        edition,
        userRoles,
        hasDismissedButton,
        onDismissButton,
        isSpotlightActive,
        handleSetSpotlight,
        trialOfferingName
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3FEPM.EditionAwarenessContext).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $daJ0i.default), {
            data: {
                navVersion: navVersion,
                hasDismissedButton: hasDismissedButton
            },
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)($a619047c1df66de2$var$StandardEdition, {}),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gsZRM.Spotlight), {})
            ]
        })
    });
}
function $a619047c1df66de2$export$148b30c5d238daaa(props) {
    const { product: product, edition: edition } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e2pRJ.RelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Ec39.default), {
            name: "edition-awareness-upsell",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2VfNT.ErrorBoundary), {
                product: product,
                edition: edition,
                id: "edition-awareness-upsell",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($a619047c1df66de2$var$EditionAwarenessUpsellImpl, {
                        ...props
                    })
                })
            })
        })
    });
}
function $a619047c1df66de2$var$StandardEdition() {
    const context = (0, $3FEPM.useEditionAwareness)();
    const { product: product, hasDismissedButton: hasDismissedButton } = context;
    if ((0, $9o45M.isEligibleForStandardToPremium)(context) && !hasDismissedButton) {
        const experimentKey = product === 'confluence' ? 'edition_awareness_standard_upsell_confluence_ab' : 'edition_awareness_upsell_jira_ab';
        const cohort = (0, $iEN9D.default).getExperimentValue(experimentKey, 'cohort', 'not-enrolled');
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                cohort === 'control' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fLNQI.FeatureExposedAnalytics), {
                    flagKey: experimentKey,
                    cohort: cohort
                }),
                cohort === 'treatment' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fLNQI.FeatureExposedAnalytics), {
                    flagKey: experimentKey,
                    cohort: cohort,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hWEZj.StandardToPremiumModal), {})
                })
            ]
        });
    }
    return null;
}

});
parcelRegister("RKWjF", function(module, exports) {

$parcel$export(module.exports, "getTrialOfferingName", () => $9022767753f2cb24$export$38ffae8c634274ba);

var $VSDnB = parcelRequire("VSDnB");
const $9022767753f2cb24$export$38ffae8c634274ba = (product, edition)=>{
    if (edition === 'standard') {
        if (product === 'jira' && (0, $VSDnB.fg)('edition_awareness_upsell_jira_fg')) return 'premium';
        if (product === 'jira-service-management' && (0, $VSDnB.fg)('edition_awareness_upsell_jsm_fg')) return 'premium';
        if (product === 'confluence' && (0, $VSDnB.fg)('edition_awareness_standard_upsell_confluence_ab_fg')) return 'premium';
    }
    return 'standard';
};

});

parcelRegister("hWEZj", function(module, exports) {

$parcel$export(module.exports, "StandardToPremiumModal", () => $286a7ef68df09633$export$a74acc125b20e3e5);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3FEPM = parcelRequire("3FEPM");

var $8XFbn = parcelRequire("8XFbn");

var $giRpK = parcelRequire("giRpK");

var $ri7ET = parcelRequire("ri7ET");

var $5iKOj = parcelRequire("5iKOj");
function $286a7ef68df09633$export$a74acc125b20e3e5() {
    const { product: product, cloudId: cloudId } = (0, $3FEPM.useEditionAwareness)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            hamsProductKey: (0, $8XFbn.getHamsKey)(product)
        }), [
        cloudId,
        product
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $giRpK.DismissibleModalEntryPoint), {
        entryPoint: (0, $5iKOj.entryPoint),
        entryPointParams: entryPointParams,
        dialogConfig: (0, $ri7ET.DIALOG_CONFIG)
    });
}

});
parcelRegister("giRpK", function(module, exports) {

$parcel$export(module.exports, "DismissibleModalEntryPoint", () => $43925d55c39183ba$export$3362d3660491ee6d);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");

var $iNb86 = parcelRequire("iNb86");

var $fqeRg = parcelRequire("fqeRg");
function $43925d55c39183ba$export$3362d3660491ee6d(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kgoHi.default), {
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqeRg.ModalEntryPoint), {
                ...props
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iNb86.DismissMenu), {})
        ]
    });
}

});
parcelRegister("iNb86", function(module, exports) {

$parcel$export(module.exports, "DismissMenu", () => $52e1e788eba4639e$export$6c8332cc6beadf8a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8U6zd = parcelRequire("8U6zd");

var $e4yMr = parcelRequire("e4yMr");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $bdFM8 = parcelRequire("bdFM8");
var $cWTTi = parcelRequire("cWTTi");
var $iB3Ak = parcelRequire("iB3Ak");
var $G85VY = parcelRequire("G85VY");

var $UsPWm = parcelRequire("UsPWm");

var $3FEPM = parcelRequire("3FEPM");

var $RKWjF = parcelRequire("RKWjF");
const $52e1e788eba4639e$var$dismissMenuStyles = (0, $8CUq3.xcss)({
    borderWidth: 'border.width',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    borderStyle: 'solid',
    backgroundColor: 'elevation.surface',
    borderRadius: 'border.radius.100',
    paddingInline: 'space.100',
    paddingBlock: '0',
    minHeight: '32px',
    color: 'color.text',
    transitionProperty: 'color, background-color',
    transitionDuration: '200ms',
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    textDecoration: 'none',
    borderColor: 'color.border.discovery',
    borderLeftWidth: '0',
    borderTopLeftRadius: '0',
    borderBottomLeftRadius: '0',
    ':hover': {
        backgroundColor: 'color.background.accent.purple.subtlest.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.accent.purple.subtlest.pressed'
    }
});
const $52e1e788eba4639e$var$reasonsUlStyles = (0, $8CUq3.xcss)({
    marginTop: '0',
    marginLeft: 'space.200',
    paddingLeft: 'space.100'
});
const $52e1e788eba4639e$var$capitalizeName = (name)=>name.charAt(0).toUpperCase() + name.slice(1);
function $52e1e788eba4639e$export$6c8332cc6beadf8a() {
    const fireDismissMenuEvent = (0, $UsPWm.useOnClickDismissMenu)();
    const { product: product, edition: edition, onDismissButton: onDismissButton, handleSetSpotlight: handleSetSpotlight } = (0, $3FEPM.useEditionAwareness)();
    const trialOfferingName = (0, $RKWjF.getTrialOfferingName)(product, edition);
    const handleOnEvents = (0, $5uXOq.useCallback)((e)=>{
        if (e.type === 'DISMISS_SUCCEEDED' && onDismissButton) {
            onDismissButton();
            fireDismissMenuEvent('dismiss');
            handleSetSpotlight?.(true);
        }
        if (e.type === 'AD_CONTROL_DROP_DOWN_MENU_OPENED') fireDismissMenuEvent('openMenu');
        if (e.type === 'REASONS_BUTTON_CLICKED') fireDismissMenuEvent('learnMore');
    }, [
        onDismissButton,
        handleSetSpotlight,
        fireDismissMenuEvent
    ]);
    const getAdControlsTrigger = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5ILhZ.default), {
            ...props,
            ref: triggerRef,
            xcss: [
                $52e1e788eba4639e$var$dismissMenuStyles
            ],
            "aria-label": "More",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
                label: "",
                spacing: "none",
                color: "var(--ds-icon-subtlest, #626F86)"
            })
        }), []);
    const offering = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cgL5K.default), {
        weight: "bold",
        children: [
            $52e1e788eba4639e$var$capitalizeName(product),
            " ",
            $52e1e788eba4639e$var$capitalizeName(trialOfferingName)
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cWTTi.default), {
        onEvents: (e)=>handleOnEvents(e),
        shouldShowDismissFlag: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bdFM8.default), {
            itemId: "default-item",
            trigger: getAdControlsTrigger,
            children: (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iB3Ak.default), {
                            ...props,
                            children: "Dismiss"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $G85VY.default), {
                            ...props,
                            modalProps: {
                                body: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                                    space: "space.150",
                                    children: [
                                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                                id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.why-am-i-seeing-this",
                                                defaultMessage: "We think {offering} will improve your team's productivity. This recommendation is only shown to billing admins and is based on:",
                                                description: "A message that informs the user why they are seeing the current plan recommendation for their current product",
                                                values: {
                                                    offering: offering
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $luBm6.default), {
                                            as: "ul",
                                            xcss: $52e1e788eba4639e$var$reasonsUlStyles,
                                            children: [
                                                /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                                        id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.reason-1",
                                                        defaultMessage: "the size of your team",
                                                        description: "A reason why the user is seeing the current plan recommendation"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                                        id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.reason-2",
                                                        defaultMessage: "your existing Atlassian products",
                                                        description: "A reason why the user is seeing the current plan recommendation"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
                                                appearance: "default",
                                                href: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                                                target: "_blank",
                                                onClick: ()=>fireDismissMenuEvent('clickLink'),
                                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                                    id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.data-privacy.link",
                                                    defaultMessage: "Learn more about your data privacy with Atlassian",
                                                    description: "Link to Atlassian data privacy page"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }
                        })
                    ]
                })
        })
    });
}

});
parcelRegister("bdFM8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f01fbcffdc310c8b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $BLPHT = parcelRequire("BLPHT");
var $aRoVz = parcelRequire("aRoVz");

var $VSDnB = parcelRequire("VSDnB");


var $2oDNf = parcelRequire("2oDNf");

var $7PL8F = parcelRequire("7PL8F");
const $f01fbcffdc310c8b$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsDropdown'
};
const $f01fbcffdc310c8b$var$AdControlDropdownMenu = ({ children: children, itemId: itemId, onOpenChange: onOpenChange = ()=>{}, ...rest })=>{
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $2oDNf.default)();
    const { createEventDispatcher: createEventDispatcher } = (0, $7PL8F.useAdControlProvider)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
        ...rest,
        onOpenChange: (onOpenChangeArgs)=>{
            eventDispatcher.dispatch(onOpenChangeArgs.isOpen ? (0, $31d75b4fe1b5774a$export$17ff257e1f6e39f5) : (0, $31d75b4fe1b5774a$export$7fc09cf740f33ed4), createInteractedUIEvent($f01fbcffdc310c8b$var$interactedUIEventAction));
            onOpenChange(onOpenChangeArgs);
        },
        shouldFitContainer: false,
        shouldRenderToParent: (0, $VSDnB.fg)('should-render-to-parent-should-be-true-growth-trai'),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aRoVz.default), {
            children: typeof children === 'function' ? children({
                itemId: itemId
            }) : children
        })
    });
};
var $f01fbcffdc310c8b$export$2e2bcd8739ae039 = $f01fbcffdc310c8b$var$AdControlDropdownMenu;

});
// ACT Event types
// AdControlDropdownMenu
const $31d75b4fe1b5774a$export$17ff257e1f6e39f5 = 'AD_CONTROL_DROP_DOWN_MENU_OPENED';
const $31d75b4fe1b5774a$export$7fc09cf740f33ed4 = 'AD_CONTROL_DROP_DOWN_MENU_CLOSED';
const $31d75b4fe1b5774a$export$e33200507ac1d20a = 'DISMISS_STARTED';
const $31d75b4fe1b5774a$export$103f41d1f3bf374e = 'DISMISS_SUCCEEDED';
const $31d75b4fe1b5774a$export$6d3088110036f124 = 'DISMISS_FAILED';
const $31d75b4fe1b5774a$export$5595c6967e83d351 = 'REASONS_BUTTON_CLICKED';
const $31d75b4fe1b5774a$export$ff50ad60f08a4bc0 = 'REASONS_MODAL_SHOWN';
const $31d75b4fe1b5774a$export$6bd2d8eacca15ce1 = 'REASONS_MODAL_DISMISSED';
const $31d75b4fe1b5774a$export$5c5fc6956b7600ea = 'FLAG_DISMISSED';

parcelRegister("2oDNf", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d2cae71ad56ba41$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $2NMNM = parcelRequire("2NMNM");
function $5d2cae71ad56ba41$export$2e2bcd8739ae039() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const createInteractedUIEvent = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((action)=>createAnalyticsEvent({
            eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
            ...action
        }), [
        createAnalyticsEvent
    ]);
    const createScreenUIEvent = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((name)=>createAnalyticsEvent({
            eventType: (0, $676c5e519aa5ba55$export$f1d537d508d2945a),
            name: name
        }), [
        createAnalyticsEvent
    ]);
    return {
        createInteractedUIEvent: createInteractedUIEvent,
        createScreenUIEvent: createScreenUIEvent
    };
}

});

parcelRegister("7PL8F", function(module, exports) {

$parcel$export(module.exports, "useAdControlProvider", () => $0ed4b49fdaa1ff5b$export$450072b04d50916);

var $5uXOq = parcelRequire("5uXOq");


var $lxmOh = parcelRequire("lxmOh");

var $3bxlB = parcelRequire("3bxlB");
function $0ed4b49fdaa1ff5b$export$450072b04d50916() {
    const { state: state, modalPropsRef: modalPropsRef, dispatch: dispatch, onEvents: onEvents, shouldShowDismissFlag: shouldShowDismissFlag } = (0, $3bxlB.useAdControlContext)();
    /**
	 * Add a flag with flagProps to state for the item was dismissed
	 * {@link https://atlassian.design/components/flag/examples}
	 */ const addFlag = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((itemId, flagProps)=>{
        dispatch({
            type: 'ADD_FLAG',
            payload: {
                itemId: itemId,
                flagProps: flagProps
            }
        });
    }, [
        dispatch
    ]);
    /**
	 * Open a modal and set the modal props reference
	 */ const openModal = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((modalProps, modalItemId)=>{
        modalPropsRef.current = modalProps;
        dispatch({
            type: 'OPEN_MODAL',
            payload: modalItemId
        });
    }, [
        dispatch,
        modalPropsRef
    ]);
    /**
	 * Close a modal and clear the modal props reference
	 */ const closeModal = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        modalPropsRef.current = undefined;
        dispatch({
            type: 'CLOSE_MODAL'
        });
    }, [
        dispatch,
        modalPropsRef
    ]);
    /**
	 * The internal event handler that is used by the ACTEventDispatcher
	 */ const handleOnEvents = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((event)=>{
        // Handle the events that have side effects on the state.
        switch(event.type){
            case 0, $31d75b4fe1b5774a$export$5c5fc6956b7600ea:
                dispatch({
                    type: 'REMOVE_FLAG',
                    payload: event.itemId
                });
                break;
        }
        // Call the onEvents handler that is passed from the consumer.
        onEvents(event);
    }, [
        dispatch,
        onEvents
    ]);
    /**
	 * Create an event dispatcher for the given item id
	 */ const createEventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((itemId)=>{
        return new (0, $lxmOh.default)(itemId, handleOnEvents);
    }, [
        handleOnEvents
    ]);
    return {
        state: state,
        openModal: openModal,
        closeModal: closeModal,
        createEventDispatcher: createEventDispatcher,
        addFlag: addFlag,
        shouldShowDismissFlag: shouldShowDismissFlag
    };
}

});
parcelRegister("lxmOh", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dd17db5a3b25b16$export$2e2bcd8739ae039);
class $9dd17db5a3b25b16$export$2e2bcd8739ae039 {
    constructor(itemId, handler){
        this.itemId = itemId;
        this.handler = handler;
    }
    dispatch(type, analyticsEvent) {
        this._dispatch({
            type: type,
            itemId: this.itemId,
            analyticsEvent: analyticsEvent
        });
    }
    dispatchError(type, error) {
        this._dispatch({
            type: type,
            itemId: this.itemId,
            error: error
        });
    }
    _dispatch(event) {
        if (this.handler) this.handler(event);
    }
}

});

parcelRegister("3bxlB", function(module, exports) {

$parcel$export(module.exports, "useAdControlContext", () => $6b83d9125d8db136$export$4e82dc865a56141b);

var $5uXOq = parcelRequire("5uXOq");

var $9a0CE = parcelRequire("9a0CE");
function $6b83d9125d8db136$export$4e82dc865a56141b() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $9a0CE.AdControlContext));
}

});
parcelRegister("9a0CE", function(module, exports) {

$parcel$export(module.exports, "AdControlContext", () => $6c4d44a0b878cedb$export$554b2f9bd0a293df);

var $5uXOq = parcelRequire("5uXOq");

var $csTpu = parcelRequire("csTpu");
const $6c4d44a0b878cedb$export$554b2f9bd0a293df = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    state: {
        ...(0, $csTpu.initialAdControlProviderState)
    },
    modalPropsRef: undefined,
    dispatch: ()=>{},
    onEvents: ()=>{},
    shouldShowDismissFlag: true
});

});
parcelRegister("csTpu", function(module, exports) {

$parcel$export(module.exports, "initialAdControlProviderState", () => $50e18fde0ce055e6$export$22776e7a42f7089d);
$parcel$export(module.exports, "adControlProviderReducer", () => $50e18fde0ce055e6$export$5f3557676ca801eb);
const $50e18fde0ce055e6$export$22776e7a42f7089d = {
    flags: new Map()
};
const $50e18fde0ce055e6$export$5f3557676ca801eb = (state, action)=>{
    switch(action.type){
        case 'ADD_FLAG':
            return {
                ...state,
                flags: new Map(state.flags).set(action.payload.itemId, action.payload.flagProps)
            };
        case 'REMOVE_FLAG':
            {
                // Clone the flags map and delete the flag
                const flags = new Map(state.flags);
                flags.delete(action.payload);
                return {
                    ...state,
                    flags: flags
                };
            }
        case 'OPEN_MODAL':
            return {
                ...state,
                modalItemId: action.payload
            };
        case 'CLOSE_MODAL':
            return {
                ...state,
                modalItemId: undefined
            };
        default:
            return state;
    }
};

});





parcelRegister("cWTTi", function(module, exports) {

$parcel$export(module.exports, "default", () => $caafb1275a9043be$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");

var $9a0CE = parcelRequire("9a0CE");

var $csTpu = parcelRequire("csTpu");

var $eW72t = parcelRequire("eW72t");

var $iWO3E = parcelRequire("iWO3E");

var $3rGmd = parcelRequire("3rGmd");
const $caafb1275a9043be$var$AdControlProvider = ({ children: children, onEvents: onEvents = ()=>{}, shouldShowDismissFlag: shouldShowDismissFlag = true })=>{
    const [state, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useReducer((0, $csTpu.adControlProviderReducer), (0, $csTpu.initialAdControlProviderState));
    const modalPropsRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const modalProps = modalPropsRef.current ?? {
        body: '',
        title: ''
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eW72t.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9a0CE.AdControlContext).Provider, {
            value: {
                state: state,
                modalPropsRef: modalPropsRef,
                dispatch: dispatch,
                onEvents: onEvents,
                shouldShowDismissFlag: shouldShowDismissFlag
            },
            children: [
                children,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3rGmd.default), {
                    itemId: state.modalItemId,
                    ...modalProps
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {}),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iWO3E.default), {})
                })
            ]
        })
    });
};
var $caafb1275a9043be$export$2e2bcd8739ae039 = $caafb1275a9043be$var$AdControlProvider;

});
parcelRegister("eW72t", function(module, exports) {

$parcel$export(module.exports, "default", () => $083a544524683d55$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $96nTn = parcelRequire("96nTn");

var $8FqfZ = parcelRequire("8FqfZ");

var $gP1fu = parcelRequire("gP1fu");
const $083a544524683d55$var$ActIntlProvider = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $96nTn.default), {
        defaultMessages: (0, $gP1fu.default),
        loaderFn: (0, $8FqfZ.fetchMessagesForLocale),
        children: children
    });
};
var $083a544524683d55$export$2e2bcd8739ae039 = $083a544524683d55$var$ActIntlProvider;

});
parcelRegister("8FqfZ", function(module, exports) {

$parcel$export(module.exports, "fetchMessagesForLocale", () => $ba5477c776593cbe$export$2b153a2030b0feb2);

var $55XL5 = parcelRequire("55XL5");

var $gP1fu = parcelRequire("gP1fu");
const $ba5477c776593cbe$var$localeMap = {
    pt: 'pt-BR',
    'pt-PT': 'pt-BR',
    'en-AU': 'en-GB'
};
const $ba5477c776593cbe$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const targetLocale = ($ba5477c776593cbe$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (targetLocale in (0, $55XL5.locales)) {
            const messages = await (0, $55XL5.locales)[targetLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $55XL5.locales)) {
            const messages = await (0, $55XL5.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    /**
	 * English bundled by default as this is the majority of users
	 */ return 0, $gP1fu.default;
};

});
parcelRegister("55XL5", function(module, exports) {

$parcel$export(module.exports, "locales", () => $29a4ce0bd59e6338$export$df1c34db1371eeed);


























const $29a4ce0bd59e6338$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("6rJdg")),
    da: ()=>(parcelRequire("iEvkU")),
    de: ()=>(parcelRequire("6yZ10")),
    en_GB: ()=>(parcelRequire("ah4Ew")),
    en_ZZ: ()=>(parcelRequire("fvugb")),
    en: ()=>Promise.resolve((parcelRequire("gP1fu"))),
    es: ()=>(parcelRequire("dytK2")),
    fi: ()=>(parcelRequire("cerZY")),
    fr: ()=>(parcelRequire("kjeqX")),
    hu: ()=>(parcelRequire("cNhfk")),
    it: ()=>(parcelRequire("cQlia")),
    ja: ()=>(parcelRequire("5Zdkj")),
    ko: ()=>(parcelRequire("jDh1Y")),
    nb: ()=>(parcelRequire("6PdFI")),
    nl: ()=>(parcelRequire("gVLkY")),
    pl: ()=>(parcelRequire("e9ZAS")),
    pt_BR: ()=>(parcelRequire("dNa0W")),
    ru: ()=>(parcelRequire("2M4RD")),
    sv: ()=>(parcelRequire("6ROqa")),
    th: ()=>(parcelRequire("loHgn")),
    tr: ()=>(parcelRequire("78S04")),
    uk: ()=>(parcelRequire("lbJZY")),
    vi: ()=>(parcelRequire("2BNWj")),
    zh_TW: ()=>(parcelRequire("cIPTd")),
    zh: ()=>(parcelRequire("20fua"))
};

});
parcelRegister("6rJdg", function(module, exports) {

let $4b18560515a1475c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4b18560515a1475c$var$load("5afiz").then(()=>parcelRequire('244Rz'));

});

parcelRegister("iEvkU", function(module, exports) {

let $d944451fe8a3fe37$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d944451fe8a3fe37$var$load("5NG15").then(()=>parcelRequire('byL9G'));

});

parcelRegister("6yZ10", function(module, exports) {

let $4c753f63cbae63ce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4c753f63cbae63ce$var$load("8Ktoo").then(()=>parcelRequire('iPCdj'));

});

parcelRegister("ah4Ew", function(module, exports) {

let $77af19d4a9f74366$var$load = (parcelRequire("28QjX"))(4);
module.exports = $77af19d4a9f74366$var$load("wZhIp").then(()=>parcelRequire('jTiyz'));

});

parcelRegister("fvugb", function(module, exports) {

let $b4a139406aba4bee$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b4a139406aba4bee$var$load("4tsDS").then(()=>parcelRequire('knTYu'));

});

parcelRegister("dytK2", function(module, exports) {

let $9de58567a633e495$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9de58567a633e495$var$load("j9oSn").then(()=>parcelRequire('4k82d'));

});

parcelRegister("cerZY", function(module, exports) {

let $8e7c82c7081bc08f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8e7c82c7081bc08f$var$load("fOB9Y").then(()=>parcelRequire('48wMp'));

});

parcelRegister("kjeqX", function(module, exports) {

let $ec90c73efd10ff6a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ec90c73efd10ff6a$var$load("6RPKH").then(()=>parcelRequire('fc44T'));

});

parcelRegister("cNhfk", function(module, exports) {

let $9507705e17ed3d5c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9507705e17ed3d5c$var$load("gpgZU").then(()=>parcelRequire('kel6P'));

});

parcelRegister("cQlia", function(module, exports) {

let $959adb84e49fc50d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $959adb84e49fc50d$var$load("lRujw").then(()=>parcelRequire('4zI6N'));

});

parcelRegister("5Zdkj", function(module, exports) {

let $45bcfca6c275b3f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $45bcfca6c275b3f5$var$load("fJEq7").then(()=>parcelRequire('1JqFz'));

});

parcelRegister("jDh1Y", function(module, exports) {

let $e4aeded0caf82d17$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e4aeded0caf82d17$var$load("PMoQX").then(()=>parcelRequire('h95YY'));

});

parcelRegister("6PdFI", function(module, exports) {

let $4f821c7517c11286$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4f821c7517c11286$var$load("e1ip1").then(()=>parcelRequire('gKNWn'));

});

parcelRegister("gVLkY", function(module, exports) {

let $c536b06b9489faae$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c536b06b9489faae$var$load("lDEAf").then(()=>parcelRequire('e5Htj'));

});

parcelRegister("e9ZAS", function(module, exports) {

let $a4f1af2e8aea71f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a4f1af2e8aea71f7$var$load("4mNEp").then(()=>parcelRequire('6lCnn'));

});

parcelRegister("dNa0W", function(module, exports) {

let $a0a79e8dc73abd3e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a0a79e8dc73abd3e$var$load("i5Pyj").then(()=>parcelRequire('74uqO'));

});

parcelRegister("2M4RD", function(module, exports) {

let $2053d659c570db1b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2053d659c570db1b$var$load("2QiXa").then(()=>parcelRequire('lI543'));

});

parcelRegister("6ROqa", function(module, exports) {

let $4ffecddf1c885b0a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4ffecddf1c885b0a$var$load("5BkfB").then(()=>parcelRequire('6eQg4'));

});

parcelRegister("loHgn", function(module, exports) {

let $f93d6601af68deb9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f93d6601af68deb9$var$load("ab543").then(()=>parcelRequire('kBjTK'));

});

parcelRegister("78S04", function(module, exports) {

let $53332b0b5cc9368a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $53332b0b5cc9368a$var$load("1pkJr").then(()=>parcelRequire('cEoSm'));

});

parcelRegister("lbJZY", function(module, exports) {

let $f6ce4e6d2da03df6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f6ce4e6d2da03df6$var$load("kvSKH").then(()=>parcelRequire('372Q4'));

});

parcelRegister("2BNWj", function(module, exports) {

let $1e65c66a1fc44d4e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1e65c66a1fc44d4e$var$load("hHwia").then(()=>parcelRequire('chF8B'));

});

parcelRegister("cIPTd", function(module, exports) {

let $9431d84f2ef3ba7a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9431d84f2ef3ba7a$var$load("iGTFs").then(()=>parcelRequire('2qJyh'));

});

parcelRegister("20fua", function(module, exports) {

let $175797fa889e8e53$var$load = (parcelRequire("28QjX"))(4);
module.exports = $175797fa889e8e53$var$load("7nLOm").then(()=>parcelRequire('8A9An'));

});




parcelRegister("iWO3E", function(module, exports) {

$parcel$export(module.exports, "default", () => $89d58ca4a5288e3d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fWXJB = parcelRequire("fWXJB");
var $6ARj7 = parcelRequire("6ARj7");

var $dp5jO = parcelRequire("dp5jO");

var $MHKc7 = parcelRequire("MHKc7");



var $2oDNf = parcelRequire("2oDNf");

var $7PL8F = parcelRequire("7PL8F");

var $bjkOk = parcelRequire("bjkOk");

var $9BZKI = parcelRequire("9BZKI");
const $89d58ca4a5288e3d$var$ACT_FLAG_WRAPPER = 'act-flag-wrapper';
const $89d58ca4a5288e3d$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsFlagClose'
};
const $89d58ca4a5288e3d$var$DismissalFlagGroup = ()=>{
    (0, $9BZKI.overridePortalIndex)($89d58ca4a5288e3d$var$ACT_FLAG_WRAPPER);
    const { state: { flags: flags }, createEventDispatcher: createEventDispatcher } = (0, $7PL8F.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $2oDNf.default)();
    const handleOnDismissed = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((id)=>{
        createEventDispatcher(id).dispatch((0, $31d75b4fe1b5774a$export$5c5fc6956b7600ea), createInteractedUIEvent($89d58ca4a5288e3d$var$interactedUIEventAction));
    }, [
        createEventDispatcher,
        createInteractedUIEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ARj7.default), {
        onDismissed: handleOnDismissed,
        children: Array.from(flags.entries()).map(([itemId, { actions: actions = [], ...flagProps } = {
            actions: []
        }], i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                id: $89d58ca4a5288e3d$var$ACT_FLAG_WRAPPER,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fWXJB.default), {
                    id: itemId,
                    testId: `act-flag-${itemId}`,
                    icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dp5jO))), {
                        label: "Success",
                        spacing: "spacious",
                        color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`
                    }),
                    title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $bjkOk.messages).notInterestedFlag
                    }),
                    description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $bjkOk.messages).dismissalMessage
                    }),
                    ...flagProps,
                    actions: actions.map((action)=>({
                            ...action,
                            onClick: (e)=>{
                                action.onClick?.(e, ()=>handleOnDismissed(itemId));
                            }
                        }))
                })
            }, i))
    });
};
var $89d58ca4a5288e3d$export$2e2bcd8739ae039 = $89d58ca4a5288e3d$var$DismissalFlagGroup;

});
parcelRegister("bjkOk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9491d2480bd43369$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9491d2480bd43369$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    notInterested: {
        id: 'act.action.notInterested.button.text',
        defaultMessage: 'Not interested',
        description: 'The text of a button to indicate the users can dismiss the current component'
    },
    notInterestedFlag: {
        id: 'act.action.notInterestedFlag.flag.text',
        defaultMessage: 'Got it, thanks for letting us know',
        description: 'A message that informs the users the dismissal action is taken'
    },
    showReasons: {
        id: 'act.action.showReasons.common.text',
        defaultMessage: 'Why am I seeing this?',
        description: "The text of a button to indicate the users can click and see the reasons for a component's appearance"
    },
    dismissalMessage: {
        id: 'act.action.dismissalMessage.common.text',
        defaultMessage: "You won\u2019t see this here as often.",
        description: 'A message that informs the users the dismissal action is taken'
    },
    reasonsModalOkButton: {
        id: 'act.action.reasonsModalOkButton.common.text',
        defaultMessage: 'OK',
        description: 'The text of a button to indicate the users can dismiss the current modal'
    }
});

});

parcelRegister("9BZKI", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PORTAL_OVERRIDE_INDEX", () => $05b6c23337aa70ff$export$335243096683aa37);
$parcel$export(module.exports, "overridePortalIndex", () => $05b6c23337aa70ff$export$61df98316049b30);
const $05b6c23337aa70ff$export$335243096683aa37 = 900;
function $05b6c23337aa70ff$export$61df98316049b30(elementId, index = $05b6c23337aa70ff$export$335243096683aa37) {
    setTimeout(()=>{
        if (typeof document !== 'undefined') {
            const parentPortal = $05b6c23337aa70ff$export$148feac3be949786(document.getElementById(elementId), '.atlaskit-portal');
            if (parentPortal) parentPortal.setAttribute('style', `z-index:${index};`);
        }
    }, 0);
}
function $05b6c23337aa70ff$var$collectionHas(all, curr) {
    for(let i = 0, len = all.length; i < len; i++){
        if (all[i] === curr) return true;
    }
    return false;
}
function $05b6c23337aa70ff$export$148feac3be949786(elm, selector) {
    let all = document.querySelectorAll(selector);
    let cur = elm?.parentNode;
    while(cur && !$05b6c23337aa70ff$var$collectionHas(all, cur))cur = cur.parentNode;
    return cur;
}

});


parcelRegister("3rGmd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab01225816809c5d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $eCeGD = parcelRequire("eCeGD");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $MHKc7 = parcelRequire("MHKc7");


var $2oDNf = parcelRequire("2oDNf");

var $7PL8F = parcelRequire("7PL8F");

var $bjkOk = parcelRequire("bjkOk");

var $9BZKI = parcelRequire("9BZKI");
const $ab01225816809c5d$var$adControlScreenName = 'adControlsReasonsModal';
const $ab01225816809c5d$var$ACT_MODAL_CONTENT = 'ACT_MODAL_CONTENT';
const $ab01225816809c5d$var$ReasonsModal = ({ body: body, itemId: itemId, title: title, zIndexOverride: zIndexOverride = (0, $9BZKI.DEFAULT_PORTAL_OVERRIDE_INDEX), ...props })=>{
    const { closeModal: closeModal, createEventDispatcher: createEventDispatcher } = (0, $7PL8F.useAdControlProvider)();
    const { createScreenUIEvent: createScreenUIEvent } = (0, $2oDNf.default)();
    const isMounted = (0, $5uXOq.useRef)(false);
    const eventDispatcherRef = (0, $5uXOq.useRef)();
    eventDispatcherRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>itemId !== undefined ? createEventDispatcher(itemId) : eventDispatcherRef.current, [
        createEventDispatcher,
        itemId
    ]);
    const isOpen = itemId !== undefined;
    (0, $5uXOq.useEffect)(()=>{
        const eventDispatcher = eventDispatcherRef.current;
        if (!eventDispatcher) return;
        if (isOpen) eventDispatcher.dispatch((0, $31d75b4fe1b5774a$export$ff50ad60f08a4bc0), createScreenUIEvent($ab01225816809c5d$var$adControlScreenName));
        else if (isMounted.current && !isOpen) eventDispatcher.dispatch((0, $31d75b4fe1b5774a$export$6bd2d8eacca15ce1), createScreenUIEvent($ab01225816809c5d$var$adControlScreenName));
    }, [
        createScreenUIEvent,
        isOpen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    if (isOpen && zIndexOverride) (0, $9BZKI.overridePortalIndex)($ab01225816809c5d$var$ACT_MODAL_CONTENT, zIndexOverride);
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
        children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1R1Ge.default), {
            shouldCloseOnEscapePress: true,
            onClose: closeModal,
            ...props,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
                id: $ab01225816809c5d$var$ACT_MODAL_CONTENT,
                children: [
                    title !== null && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                            children: title ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $bjkOk.messages).showReasons
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                        children: body
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $juxqI.default), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                            appearance: "primary",
                            onClick: closeModal,
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $bjkOk.messages).reasonsModalOkButton
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $ab01225816809c5d$export$2e2bcd8739ae039 = $ab01225816809c5d$var$ReasonsModal;

});


parcelRegister("iB3Ak", function(module, exports) {

$parcel$export(module.exports, "default", () => $3438e1e7198567ad$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $6B7KL = parcelRequire("6B7KL");


var $2oDNf = parcelRequire("2oDNf");

var $7PL8F = parcelRequire("7PL8F");

var $bjkOk = parcelRequire("bjkOk");
const $3438e1e7198567ad$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'notInterested'
};
const $3438e1e7198567ad$var$DismissalButton = ({ itemId: itemId, onClick: onClick, children: children, flagProps: flagProps, ...props })=>{
    const { addFlag: addFlag, createEventDispatcher: createEventDispatcher, shouldShowDismissFlag: shouldShowDismissFlag } = (0, $7PL8F.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $2oDNf.default)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(async (e)=>{
        eventDispatcher.dispatch((0, $31d75b4fe1b5774a$export$e33200507ac1d20a), createInteractedUIEvent($3438e1e7198567ad$var$interactedUIEventAction));
        shouldShowDismissFlag && addFlag(itemId, flagProps);
        try {
            await onClick?.(e, itemId);
            eventDispatcher.dispatch((0, $31d75b4fe1b5774a$export$103f41d1f3bf374e));
        } catch (e) {
            eventDispatcher.dispatchError((0, $31d75b4fe1b5774a$export$6d3088110036f124), e);
        }
    }, [
        addFlag,
        createInteractedUIEvent,
        eventDispatcher,
        flagProps,
        itemId,
        onClick,
        shouldShowDismissFlag
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
        onClick: handleOnClick,
        ...props,
        children: children ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $bjkOk.messages).notInterested
        })
    });
};
var $3438e1e7198567ad$export$2e2bcd8739ae039 = $3438e1e7198567ad$var$DismissalButton;

});

parcelRegister("G85VY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d5f846aab069a22$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $6B7KL = parcelRequire("6B7KL");


var $2oDNf = parcelRequire("2oDNf");

var $7PL8F = parcelRequire("7PL8F");

var $bjkOk = parcelRequire("bjkOk");
const $3d5f846aab069a22$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsReasons'
};
const $3d5f846aab069a22$var$ReasonsButton = ({ children: children, itemId: itemId, modalProps: modalProps, onClick: onClick, ...props })=>{
    const { createEventDispatcher: createEventDispatcher, openModal: openModal } = (0, $7PL8F.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $2oDNf.default)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((e)=>{
        eventDispatcher.dispatch((0, $31d75b4fe1b5774a$export$5595c6967e83d351), createInteractedUIEvent($3d5f846aab069a22$var$interactedUIEventAction));
        openModal(modalProps, itemId);
        onClick?.(e, itemId);
    }, [
        createInteractedUIEvent,
        eventDispatcher,
        itemId,
        modalProps,
        onClick,
        openModal
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
        onClick: handleOnClick,
        ...props,
        children: children ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $bjkOk.messages).showReasons
        })
    });
};
var $3d5f846aab069a22$export$2e2bcd8739ae039 = $3d5f846aab069a22$var$ReasonsButton;

});

parcelRegister("UsPWm", function(module, exports) {

$parcel$export(module.exports, "useOnClickDismissMenu", () => $afc7c92a6d8e429c$export$d840cf3018e72a62);

var $5uXOq = parcelRequire("5uXOq");

var $fK9DC = parcelRequire("fK9DC");
const $afc7c92a6d8e429c$export$d840cf3018e72a62 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $fK9DC.useAnalytics)();
    return (0, $5uXOq.useCallback)((dismissMenuIntent)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'editionAwarenessDismissMenu',
            attributes: {
                dismissMenuIntent: dismissMenuIntent
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
};

});



parcelRegister("ri7ET", function(module, exports) {

$parcel$export(module.exports, "DIALOG_CONFIG", () => $7d318bb3cf9f8f15$export$3b6761b6086f6dfd);
const $7d318bb3cf9f8f15$export$3b6761b6086f6dfd = {
    touchpointIntent: 'startTrial',
    dialogId: 'standard-to-premium-modal',
    dialogType: 'modal'
};

});

parcelRegister("5iKOj", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $9c3d0f52c9ff64af$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $4Tvrd = parcelRequire("4Tvrd");

const $9c3d0f52c9ff64af$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("c15Jg")), {
        moduleId: "9dc17d8c",
        priority: "interaction",
        moduleId: 'edition-awareness-standard-to-premium-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, hamsProductKey: hamsProductKey })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                standardToPremiumModalQuery: {
                    parameters: $4Tvrd.default,
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: hamsProductKey
                    }
                }
            }
        })
});

});
parcelRegister("4Tvrd", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0af41ddd62bf95e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<67206532cf6e6f51082ec69fc9e97638>>
 * @relayHash de6e2bac8a58a1f311e29bca101d04f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41a183f07082b19942dc28b868628bc31ce5d5b683a639aab2d17f96750539e

var $eiowN = parcelRequire("eiowN");
const $a0af41ddd62bf95e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Premium"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "standardToPremiumModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "standardToPremiumModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e41a183f07082b19942dc28b868628bc31ce5d5b683a639aab2d17f96750539e",
            "metadata": {},
            "name": "standardToPremiumModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a0af41ddd62bf95e$var$node.hash = "2c7841c5e5f86c438cbec88e2db2ae41";
(0, $eiowN.PreloadableQueryRegistry).set($a0af41ddd62bf95e$var$node.params.id, $a0af41ddd62bf95e$var$node);
var $a0af41ddd62bf95e$export$2e2bcd8739ae039 = $a0af41ddd62bf95e$var$node;

});

parcelRegister("c15Jg", function(module, exports) {

let $8bfa05ba1def6e4b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8bfa05ba1def6e4b$var$load("itojv").then(()=>parcelRequire('93xcu'));

});




parcelRegister("jZ4fr", function(module, exports) {

$parcel$export(module.exports, "EngagementSpotlight", () => $bfd4434fdcf1c696$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1QiBP = parcelRequire("1QiBP");

var $gPtFm = parcelRequire("gPtFm");

var $bPTaj = parcelRequire("bPTaj");

var $f9Hff = parcelRequire("f9Hff");

var $iQWvK = parcelRequire("iQWvK");
const $bfd4434fdcf1c696$var$SpotlightWithVariables = (0, $gPtFm.default)((0, $iQWvK.default));
const $bfd4434fdcf1c696$export$f57123e11f24bec9 = (0, $bPTaj.default)($bfd4434fdcf1c696$var$SpotlightWithVariables);
const $bfd4434fdcf1c696$var$SpotlightWithMessage = (0, $f9Hff.default)($bfd4434fdcf1c696$export$f57123e11f24bec9, 'spotlight');
function $bfd4434fdcf1c696$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1QiBP.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($bfd4434fdcf1c696$var$SpotlightWithMessage, {
            ...props
        })
    });
}

});
parcelRegister("gPtFm", function(module, exports) {

$parcel$export(module.exports, "default", () => $aefa8c8d82352ccc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5yTPS = parcelRequire("5yTPS");
function $aefa8c8d82352ccc$export$2e2bcd8739ae039(TargetComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithVariables extends (0, $5uXOq.Component) {
        static{
            this.displayName = `${TargetComponent.displayName || TargetComponent.name || ''}WithEPVariables`;
        }
        render() {
            const props = $aefa8c8d82352ccc$var$runMessagePropsReplacement(this.props);
            if (!props) return null;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(TargetComponent, {
                ...props
            });
        }
    }
    return WithVariables;
}
/**
 * Runs replacement over spotlight message properties.
 * Returns null if replacement fails.
 */ function $aefa8c8d82352ccc$var$runMessagePropsReplacement(props) {
    const { variables: variables, ...otherProps } = props;
    const { title: title, body: body, primaryText: primaryText, primaryAction: primaryAction, secondaryText: secondaryText, secondaryAction: secondaryAction } = props;
    const inputs = {
        title: title,
        body: body,
        primaryText: primaryText,
        primaryActionUrl: primaryAction && primaryAction.data && primaryAction.data.url,
        secondaryText: secondaryText,
        secondaryActionUrl: secondaryAction && secondaryAction.data && secondaryAction.data.url
    };
    const replacedInputs = (0, $5yTPS.runTemplateOnInputs)(variables || {}, inputs);
    if (!replacedInputs) return null;
    const outputProps = {
        ...otherProps,
        title: replacedInputs.title,
        body: replacedInputs.body,
        primaryText: replacedInputs.primaryText,
        secondaryText: replacedInputs.secondaryText
    };
    if (primaryAction) outputProps.primaryAction = (0, $5yTPS.rebuildButtonAction)(replacedInputs.primaryActionUrl, primaryAction);
    if (secondaryAction) outputProps.secondaryAction = (0, $5yTPS.rebuildButtonAction)(replacedInputs.secondaryActionUrl, secondaryAction);
    return outputProps;
}

});
parcelRegister("5yTPS", function(module, exports) {

$parcel$export(module.exports, "rebuildButtonAction", () => $622ebbd98b1631f7$export$5d0ec4f796aceeb1);
$parcel$export(module.exports, "runTemplateOnInputs", () => $622ebbd98b1631f7$export$d808999430a3f186);

var $4KQrx = parcelRequire("4KQrx");
function $622ebbd98b1631f7$export$5d0ec4f796aceeb1(replacedUrl, action) {
    return {
        ...action,
        data: action.data && {
            ...action.data,
            url: replacedUrl
        }
    };
}
function $622ebbd98b1631f7$export$d808999430a3f186(variables, messageInputs) {
    const keys = Object.keys(messageInputs);
    const output = {};
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const input = messageInputs[key];
        if (input) {
            const isUrl = key === 'primaryActionUrl' || key === 'secondaryActionUrl';
            const replacedInput = isUrl ? (0, $4KQrx.runTemplateForUrl)(input, variables) : (0, $4KQrx.runTemplateForHtml)(input, variables);
            if (replacedInput.type === (0, $c9ec58d20996f864$export$edb46161045fece7)) return null;
            output[key] = replacedInput.result;
        }
    }
    return output;
}

});
const $c9ec58d20996f864$export$e26f00bd90899835 = 'success';
const $c9ec58d20996f864$export$edb46161045fece7 = 'error';

parcelRegister("4KQrx", function(module, exports) {

$parcel$export(module.exports, "runTemplateForUrl", () => $ac5798f8b467fc46$export$416b2ef51d91ea20);
$parcel$export(module.exports, "runTemplateForHtml", () => $ac5798f8b467fc46$export$5681b97796b74884);

var $aw4un = parcelRequire("aw4un");

var $jgdnH = parcelRequire("jgdnH");


var $9OzUk = parcelRequire("9OzUk");
function $ac5798f8b467fc46$export$5d49303889cd00ad(template) {
    const parsedTemplate = (0, $aw4un.default)(template);
    return (0, $9OzUk.getRequiredVariablesFromTemplate)(parsedTemplate);
}
function $ac5798f8b467fc46$export$416b2ef51d91ea20(template, variables) {
    const epTemplate = (0, $aw4un.default)(template);
    return (0, $jgdnH.replaceForUrl)(epTemplate, variables);
}
function $ac5798f8b467fc46$export$5681b97796b74884(template, variables) {
    const epTemplate = (0, $aw4un.default)(template);
    return (0, $jgdnH.replaceForHtml)(epTemplate, variables);
}

});
parcelRegister("aw4un", function(module, exports) {

$parcel$export(module.exports, "default", () => $66b88773aebc8159$export$2e2bcd8739ae039);

var $2zjmT = parcelRequire("2zjmT");
/**
 * This is regular expression to parse double and triple bracket variables.
 * We should replace this with an imperative parser or a library if we want to
 * add more functionality, but this is simple enough as it is.
 *
 * The regular expression is:
 *
 * # Try to match triple bracket variables in a capture group:
 * (
 *   {{{ # Start matching on leading "{{{"
 *     (
 *       # Match on 1+ inner characters
 *       (
 *         # Do negative look-ahead for closing brackets '}}}'.
 *         # Then match on any character. What this means is, match on any
 *         # character that isn't a bracket followed by two other brackets.
 *         # So, first check if we're not at the end of the tag, otherwise
 *         # match.
 *         # Negative look-ahead won't collect the character, just fail if it's
 *         # the triple bracket sequence.
 *         (?!}}}).
 *       )+
 *     ) # Finish `UNESCAPED_GROUP_CONTENTS`, which is our UNESCAPED variable
 *       # name capture group
 *   }}}
 * )
 *
 * | # OR try matching the double bracket variables
 *
 * # The logic is the same, throughout
 * (
 *   {{
 *     (
 *       (
 *         (?!}}).
 *       )+
 *     ) # Finish `ESCAPED_GROUP_CONTENTS`, which is our ESCAPED variable name
 *       # capture group
 *   }}
 * )
 *
 * See https://regex101.com/r/Eo26HD/1 too.
 *
 * Group indexes are named bellow.
 */ const $66b88773aebc8159$var$PARSE_VARIABLES_REGEXP = /({{{(((?!}}}).)+)}}})|({{(((?!}}).)+)}})/g;
const $66b88773aebc8159$var$UNESCAPED_MATCH = 1;
const $66b88773aebc8159$var$UNESCAPED_GROUP_CONTENTS = 2;
const $66b88773aebc8159$var$ESCAPED_GROUP_CONTENTS = 5;
function $66b88773aebc8159$export$2e2bcd8739ae039(template) {
    const parts = (0, $2zjmT.regexpParts)(template, $66b88773aebc8159$var$PARSE_VARIABLES_REGEXP);
    return {
        parts: parts.map((regexpPart)=>{
            if (regexpPart.type === 'text') return regexpPart;
            if (regexpPart.match[$66b88773aebc8159$var$UNESCAPED_MATCH]) return {
                type: 'unescaped',
                variableName: regexpPart.match[$66b88773aebc8159$var$UNESCAPED_GROUP_CONTENTS] || ''
            };
            return {
                type: 'escaped',
                variableName: regexpPart.match[$66b88773aebc8159$var$ESCAPED_GROUP_CONTENTS] || ''
            };
        })
    };
}

});
parcelRegister("2zjmT", function(module, exports) {

$parcel$export(module.exports, "regexpParts", () => $08d9fc1afbfb58e1$export$b16d411b3b6d6dff);
function $08d9fc1afbfb58e1$export$b16d411b3b6d6dff(input, regexp) {
    const allMatches = $08d9fc1afbfb58e1$export$1ab25a4faafb1ac3(input, regexp);
    const state = allMatches.reduce((memo, matchResult)=>{
        const leadingIndex = matchResult.index || 0;
        const leading = input.slice(memo.currentPosition, leadingIndex);
        if (leading) memo.result.push({
            type: 'text',
            text: leading
        });
        memo.result.push({
            type: 'match',
            match: matchResult
        });
        return {
            currentPosition: leadingIndex + $08d9fc1afbfb58e1$export$3aff5fb0c83cea11(matchResult),
            result: memo.result
        };
    }, {
        currentPosition: 0,
        result: []
    });
    const trailing = input.slice(state.currentPosition, input.length);
    if (trailing) state.result.push({
        type: 'text',
        text: trailing
    });
    return state.result;
}
function $08d9fc1afbfb58e1$export$1ab25a4faafb1ac3(input, regexp) {
    const result = [];
    for(let m = regexp.exec(input); m; m = regexp.exec(input))result.push(m);
    return result;
}
function $08d9fc1afbfb58e1$export$3aff5fb0c83cea11(matchResult) {
    return matchResult[0] ? matchResult[0].length : 0;
}

});


parcelRegister("jgdnH", function(module, exports) {

$parcel$export(module.exports, "replaceForUrl", () => $05830e2163b9771d$export$d10ae881b12b8ef2);
$parcel$export(module.exports, "replaceForHtml", () => $05830e2163b9771d$export$ca536300dbd6350);

var $9OzUk = parcelRequire("9OzUk");

var $e4chf = parcelRequire("e4chf");
/**
 * Runs variable validation and if successful calls the provided function and
 * wraps it in a result object, otherwise returns a failure.
 */ function $05830e2163b9771d$var$withVariableValidation(template, variables, fn) {
    const requiredKeys = (0, $9OzUk.getRequiredVariablesFromTemplate)(template);
    const missingKeys = requiredKeys.filter((variableName)=>!variables[variableName]);
    if (missingKeys.length) return {
        type: 'error',
        errorType: 'missing-variables-error',
        missingVariables: missingKeys
    };
    return {
        type: 'success',
        result: fn(template, variables)
    };
}
/**
 * Replaces variables onto a template, using the provided escaping function.
 */ function $05830e2163b9771d$var$rawReplaceVariables(template, variables, escapeFn) {
    return template.parts.map((templatePart)=>{
        if (templatePart.type === 'text') return templatePart.text;
        if (templatePart.type === 'escaped') return escapeFn(variables[templatePart.variableName]);
        return variables[templatePart.variableName];
    }).join('');
}
/**
 * Without validation, runs a template with URI escaping.
 */ function $05830e2163b9771d$var$rawReplaceVariablesForUrl(template, variables) {
    return $05830e2163b9771d$var$rawReplaceVariables(template, variables, encodeURIComponent);
}
/**
 * Without validation, runs a template with HTML escaping.
 */ function $05830e2163b9771d$var$rawReplaceVariablesForHtml(template, variables) {
    return $05830e2163b9771d$var$rawReplaceVariables(template, variables, (0, $e4chf.default));
}
function $05830e2163b9771d$export$d10ae881b12b8ef2(template, variables) {
    return $05830e2163b9771d$var$withVariableValidation(template, variables, $05830e2163b9771d$var$rawReplaceVariablesForUrl);
}
function $05830e2163b9771d$export$ca536300dbd6350(template, variables) {
    return $05830e2163b9771d$var$withVariableValidation(template, variables, $05830e2163b9771d$var$rawReplaceVariablesForHtml);
}

});
parcelRegister("9OzUk", function(module, exports) {

$parcel$export(module.exports, "getRequiredVariablesFromTemplate", () => $e84b2def1adf6c31$export$4a33186abb06007b);

var $49Drv = parcelRequire("49Drv");
function $e84b2def1adf6c31$export$bf97a83dc861479c(template) {
    const variableParts = template.parts.filter((part)=>part.type === 'escaped' || part.type === 'unescaped');
    return variableParts;
}
function $e84b2def1adf6c31$export$4a33186abb06007b(template) {
    const variableParts = $e84b2def1adf6c31$export$bf97a83dc861479c(template);
    const variableNames = variableParts.map((part)=>part.variableName);
    return (0, $49Drv.uniqStrings)(variableNames);
}

});
parcelRegister("49Drv", function(module, exports) {

$parcel$export(module.exports, "uniqStrings", () => $87c69c0fd6ae5d16$export$c150c7c1a29f33d8);
/**
 * Removes duplicate strings from an array.
 */ function $87c69c0fd6ae5d16$export$c150c7c1a29f33d8(strings) {
    const ourSet = {};
    for(let i = 0; i < strings.length; i++)ourSet[strings[i]] = null;
    return Object.keys(ourSet);
}

});


parcelRegister("e4chf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9ff333996c100ad$export$2e2bcd8739ae039);
/**
 * Escapes an HTML string.
 *
 * @param {String} input
 * @return {String}
 */ function $a9ff333996c100ad$export$2e2bcd8739ae039(input) {
    return input.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39');
}

});





parcelRegister("iQWvK", function(module, exports) {

$parcel$export(module.exports, "default", () => $80ccf854c3896af1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $7gs1W = parcelRequire("7gs1W");

var $02CEF = parcelRequire("02CEF");

var $9pLR7 = parcelRequire("9pLR7");
class $80ccf854c3896af1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    getButtonClickHandler(buttonType, action) {
        const { fireClickEvent: fireClickEvent } = this.props;
        switch(action.type){
            case (0, $02CEF.buttonActionTypes).LINK:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                    window.open(action.data.url, action.data.target);
                };
            default:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                };
        }
    }
    getButtonActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (secondaryAction && secondaryText) actions.push({
            onClick: this.getButtonClickHandler('secondary', secondaryAction),
            text: secondaryText,
            appearance: secondaryAction.appearance
        });
        if (primaryAction && primaryText) actions.push({
            onClick: this.getButtonClickHandler('primary', primaryAction),
            text: primaryText,
            appearance: primaryAction.appearance,
            autoFocus: true
        });
        return actions;
    }
    render() {
        const { body: body, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, title: title, image: image, pulse: pulse, target: target, targetBgColor: targetBgColor, targetRadius: targetRadius } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7gs1W.default), {
            actions: this.getButtonActions(),
            dialogPlacement: dialogPlacement,
            dialogWidth: dialogWidth,
            heading: title,
            image: image,
            pulse: pulse,
            target: target,
            targetBgColor: targetBgColor,
            targetRadius: targetRadius,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9pLR7.default), {
                html: body
            })
        });
    }
}

});


parcelRegister("8Mq6c", function(module, exports) {

$parcel$export(module.exports, "default", () => $706129bebcc29179$export$2e2bcd8739ae039);

var $1gxex = parcelRequire("1gxex");

var $7CfdH = parcelRequire("7CfdH");
class $706129bebcc29179$export$2e2bcd8739ae039 {
    constructor(configOrCloudId, stargateUrl){
        let config;
        if (typeof configOrCloudId === 'string') config = {
            cloudId: configOrCloudId,
            stargateUrl: stargateUrl,
            isFedRAMPEnvironment: false
        };
        else config = configOrCloudId;
        if (!config.cloudId || !config.stargateUrl) throw new Error('Need a valid CloudId and Stargate url');
        this.cloudId = config.cloudId;
        this.stargateUrl = config.stargateUrl;
        this.orgId = config.orgId;
        this.workspaceId = config.workspaceId;
        this.coordinationOptions = config.coordinationOptions;
    }
    async start(messageId, variationId) {
        if (!(0, $7CfdH.isMessagingEnabled)()) return false;
        return (0, $1gxex.startMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            variationId: variationId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    async stop(messageId) {
        if (!(0, $7CfdH.isMessagingEnabled)()) return false;
        return (0, $1gxex.stopMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
}

});

parcelRegister("jcYbC", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e3fbc9fddcea1b7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
class $1e3fbc9fddcea1b7$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            fallback: null
        };
    }
    async componentDidMount() {
        const { client: client, messageId: messageId } = this.props;
        try {
            const started = await client.start(messageId);
            if (started) // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                shouldRenderChildren: true
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to start flow message ${messageId}. ${err}`);
        }
    }
    injectStop(children) {
        return /*#__PURE__*/ (0, $5uXOq.cloneElement)(children, {
            stop: this.stop
        });
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const { shouldRenderChildren: shouldRenderChildren } = this.state;
        return shouldRenderChildren ? this.injectStop(children) : fallback;
    }
    constructor(...args){
        super(...args), this.state = {
            shouldRenderChildren: false
        }, this.stop = async ()=>{
            const { client: client, messageId: messageId } = this.props;
            try {
                await client.stop(messageId);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to stop flow message ${messageId}. ${err}`);
            }
        };
    }
}

});

parcelRegister("e2ecT", function(module, exports) {

$parcel$export(module.exports, "JiraLogo", () => $4fb076f76caca502$export$17d3acb0b4379d02);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a167340a2e0cfcb20a6307fe2beeb167>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $4fb076f76caca502$var$svg = `<svg height="100%" viewBox="0 0 56 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z"/>
    <path fill="var(--text-color, #292a2e)" d="M50.89 17.13a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M42.78 17V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-3.73 0V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zm-5.17 8.87q-1.55 0-2.45-.82-.9-.83-.9-2.35v-.59h1.96v.61q0 .77.38 1.16t1.02.39 1-.39q.38-.4.38-1.16V6.82h1.94v7.14q0 1.52-.9 2.35-.89.83-2.43.83"/>
</svg>
`;
const $4fb076f76caca502$var$customThemeSvg = `<svg height="100%" viewBox="0 0 56 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z"/>
    <path fill="var(--themed-text-color, currentcolor)" d="M50.89 17.13a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M42.78 17V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-3.73 0V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zm-5.17 8.87q-1.55 0-2.45-.82-.9-.83-.9-2.35v-.59h1.96v.61q0 .77.38 1.16t1.02.39 1-.39q.38-.4.38-1.16V6.82h1.94v7.14q0 1.52-.9 2.35-.89.83-2.43.83"/>
</svg>
`;
function $4fb076f76caca502$export$17d3acb0b4379d02({ iconColor: iconColor, textColor: textColor, size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $4fb076f76caca502$var$svg,
        customThemeSvg: $4fb076f76caca502$var$customThemeSvg,
        iconColor: iconColor,
        textColor: textColor,
        label: label || 'Jira',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("in1mr", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementLogo", () => $076101c0fca1455b$export$dabef2be6cd28c20);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::34b8a4184b02ac47a3937769fbcff9c3>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $076101c0fca1455b$var$svg = `<svg height="100%" viewBox="0 0 206 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z"/>
    <path fill="var(--text-color, #292a2e)" d="M205.27 9.36v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19a3 3 0 0 0 .32-.03 5 5 0 0 0 .32-.06l.29 1.46q-.31.1-.64.13a5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-7.02 5.01V17h-1.93V9.36h1.82l.03 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.6.34.92.98.33.64.33 1.55V17h-1.92v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.35 1.35 0 0 0-.55.57q-.2.37-.2.9m-6.81 4.6q-1.16 0-2-.48a3.25 3.25 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.54 1.54 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25M171.93 17V9.36h1.8l.08 1.87h-.14q.17-.7.51-1.13.35-.44.81-.64.47-.21.97-.21.83 0 1.33.52.51.52.73 1.57h-.22q.16-.71.55-1.18.39-.46.91-.69.53-.23 1.12-.23.69 0 1.24.3t.87.88.32 1.42V17h-1.92v-4.82q0-.67-.37-1a1.32 1.32 0 0 0-.9-.32q-.4 0-.7.18a1.2 1.2 0 0 0-.46.49q-.16.32-.16.73V17h-1.87v-4.89q0-.57-.35-.91-.34-.34-.89-.34a1.4 1.4 0 0 0-.68.17 1.2 1.2 0 0 0-.49.51q-.18.33-.18.81V17zm-4.89.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06A3.4 3.4 0 0 1 165 9.77q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26T166 11q-.39.26-.59.7t-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11a1.5 1.5 0 0 0 .53-.31q.22-.21.33-.52l1.75.34q-.18.62-.63 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.91 2.86q-.94 0-1.63-.24-.69-.23-1.13-.65a2.3 2.3 0 0 1-.62-.94l1.64-.51q.11.21.31.42.21.21.55.35.35.14.87.14.81 0 1.28-.38.47-.37.47-1.16v-1.41h-.15a2.3 2.3 0 0 1-.4.58q-.25.29-.68.48-.42.19-1.07.19a3.1 3.1 0 0 1-1.58-.41q-.7-.41-1.13-1.24-.42-.83-.42-2.08 0-1.28.42-2.15t1.14-1.31q.71-.44 1.58-.44.66 0 1.09.23.44.22.7.54.27.32.4.61h.09V9.36h1.89v7.62q0 1.02-.47 1.7-.46.68-1.29 1-.82.33-1.88.33m.03-4.62q.55 0 .94-.27.38-.27.58-.77.21-.5.21-1.21 0-.7-.2-1.22-.2-.53-.58-.81-.38-.29-.94-.29-.57 0-.96.3a1.86 1.86 0 0 0-.58.83 3.5 3.5 0 0 0-.19 1.2q0 .68.2 1.19t.58.79q.39.27.95.27m-9.36 1.73a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32.71-.44 1.58-.44.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.7 2.7 0 0 1-.41.61 2.1 2.1 0 0 1-.7.53q-.43.21-1.08.21m.57-1.55q.56 0 .94-.3t.58-.84q.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83-.94-.29q-.57 0-.96.3-.38.3-.58.83a3.7 3.7 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31m-10.13-3.02V17h-1.93V9.36h1.82l.03 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.6.34.92.98.33.64.33 1.55V17h-1.92v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.34 1.34 0 0 0-.55.57q-.2.37-.2.9m-7.9 4.58a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32.71-.44 1.58-.44.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84t.21-1.25q0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M115.65 17V6.81h2.99l1.78 4.95q.1.31.23.81a47 47 0 0 1 .52 2.17q.12.54.2.94h-.39q.08-.39.2-.92a93 93 0 0 1 .53-2.18q.13-.5.23-.81l1.76-4.95h2.99V17h-1.96v-4.96q0-.33.01-.81l.03-1.04.03-1.13q.01-.57.01-1.07h.14q-.14.55-.3 1.14l-.31 1.14a44 44 0 0 1-.55 1.76L122.01 17h-1.66l-1.8-4.96q-.1-.29-.25-.74l-.3-1a129 129 0 0 1-.64-2.29h.16l.02 1.03.03 1.12.02 1.05q.01.49.01.83V17zm-8.37.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.45-2.06.45-.9 1.26-1.39.82-.5 1.93-.5.72 0 1.36.23a3.1 3.1 0 0 1 1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26a1.66 1.66 0 0 0-.59.7q-.2.44-.2.99v.88q0 .69.23 1.17.24.47.66.71t.99.24q.37 0 .68-.11a1.5 1.5 0 0 0 .53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.31-.01q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.96-.49q.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86q.39.31.97.31.32 0 .57-.09.26-.09.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06t-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17M91.92 17V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zM85.77 17l-2.83-7.64h2.04l1.34 4.05q.24.74.41 1.49l.37 1.54h-.44q.19-.79.36-1.54t.41-1.49l1.33-4.05h2.02L87.95 17zm-8.01 0V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.49-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-4.89.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7q-.21.44-.21.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31a1.4 1.4 0 0 0 .34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.87-.01q-1.2 0-2.09-.37t-1.39-1.09q-.5-.73-.53-1.77h1.92q.04.53.32.88t.74.53q.46.17 1.03.17t1.01-.17q.44-.18.68-.49.25-.31.25-.72a.9.9 0 0 0-.22-.62 1.7 1.7 0 0 0-.62-.42 5.3 5.3 0 0 0-.96-.31l-1.13-.29q-1.28-.32-2.01-.99-.72-.67-.72-1.76 0-.91.49-1.59t1.35-1.06 1.94-.38q1.11 0 1.93.38.83.38 1.3 1.06.47.67.49 1.54h-1.9q-.06-.64-.55-.98-.48-.35-1.29-.35a2.5 2.5 0 0 0-.94.17q-.39.16-.6.44a1.06 1.06 0 0 0-.2.64q0 .4.24.66.25.26.63.42.39.16.81.26l.94.23a6.5 6.5 0 0 1 1.15.38q.55.24.97.6.42.35.66.84t.24 1.14q0 .91-.46 1.59t-1.33 1.06-2.1.38m-13.18-.03a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M42.78 17V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-3.73 0V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zm-5.17 8.87q-1.55 0-2.45-.82-.9-.83-.9-2.35v-.59h1.96v.61q0 .77.38 1.16t1.02.39 1-.39q.38-.4.38-1.16V6.82h1.94v7.14q0 1.52-.9 2.35-.89.83-2.43.83"/>
</svg>
`;
const $076101c0fca1455b$var$customThemeSvg = `<svg height="100%" viewBox="0 0 206 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z"/>
    <path fill="var(--themed-text-color, currentcolor)" d="M205.27 9.36v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19a3 3 0 0 0 .32-.03 5 5 0 0 0 .32-.06l.29 1.46q-.31.1-.64.13a5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-7.02 5.01V17h-1.93V9.36h1.82l.03 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.6.34.92.98.33.64.33 1.55V17h-1.92v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.35 1.35 0 0 0-.55.57q-.2.37-.2.9m-6.81 4.6q-1.16 0-2-.48a3.25 3.25 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.54 1.54 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25M171.93 17V9.36h1.8l.08 1.87h-.14q.17-.7.51-1.13.35-.44.81-.64.47-.21.97-.21.83 0 1.33.52.51.52.73 1.57h-.22q.16-.71.55-1.18.39-.46.91-.69.53-.23 1.12-.23.69 0 1.24.3t.87.88.32 1.42V17h-1.92v-4.82q0-.67-.37-1a1.32 1.32 0 0 0-.9-.32q-.4 0-.7.18a1.2 1.2 0 0 0-.46.49q-.16.32-.16.73V17h-1.87v-4.89q0-.57-.35-.91-.34-.34-.89-.34a1.4 1.4 0 0 0-.68.17 1.2 1.2 0 0 0-.49.51q-.18.33-.18.81V17zm-4.89.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06A3.4 3.4 0 0 1 165 9.77q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26T166 11q-.39.26-.59.7t-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11a1.5 1.5 0 0 0 .53-.31q.22-.21.33-.52l1.75.34q-.18.62-.63 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.91 2.86q-.94 0-1.63-.24-.69-.23-1.13-.65a2.3 2.3 0 0 1-.62-.94l1.64-.51q.11.21.31.42.21.21.55.35.35.14.87.14.81 0 1.28-.38.47-.37.47-1.16v-1.41h-.15a2.3 2.3 0 0 1-.4.58q-.25.29-.68.48-.42.19-1.07.19a3.1 3.1 0 0 1-1.58-.41q-.7-.41-1.13-1.24-.42-.83-.42-2.08 0-1.28.42-2.15t1.14-1.31q.71-.44 1.58-.44.66 0 1.09.23.44.22.7.54.27.32.4.61h.09V9.36h1.89v7.62q0 1.02-.47 1.7-.46.68-1.29 1-.82.33-1.88.33m.03-4.62q.55 0 .94-.27.38-.27.58-.77.21-.5.21-1.21 0-.7-.2-1.22-.2-.53-.58-.81-.38-.29-.94-.29-.57 0-.96.3a1.86 1.86 0 0 0-.58.83 3.5 3.5 0 0 0-.19 1.2q0 .68.2 1.19t.58.79q.39.27.95.27m-9.36 1.73a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32.71-.44 1.58-.44.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.7 2.7 0 0 1-.41.61 2.1 2.1 0 0 1-.7.53q-.43.21-1.08.21m.57-1.55q.56 0 .94-.3t.58-.84q.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83-.94-.29q-.57 0-.96.3-.38.3-.58.83a3.7 3.7 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31m-10.13-3.02V17h-1.93V9.36h1.82l.03 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.6.34.92.98.33.64.33 1.55V17h-1.92v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.34 1.34 0 0 0-.55.57q-.2.37-.2.9m-7.9 4.58a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32.71-.44 1.58-.44.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84t.21-1.25q0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M115.65 17V6.81h2.99l1.78 4.95q.1.31.23.81a47 47 0 0 1 .52 2.17q.12.54.2.94h-.39q.08-.39.2-.92a93 93 0 0 1 .53-2.18q.13-.5.23-.81l1.76-4.95h2.99V17h-1.96v-4.96q0-.33.01-.81l.03-1.04.03-1.13q.01-.57.01-1.07h.14q-.14.55-.3 1.14l-.31 1.14a44 44 0 0 1-.55 1.76L122.01 17h-1.66l-1.8-4.96q-.1-.29-.25-.74l-.3-1a129 129 0 0 1-.64-2.29h.16l.02 1.03.03 1.12.02 1.05q.01.49.01.83V17zm-8.37.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.45-2.06.45-.9 1.26-1.39.82-.5 1.93-.5.72 0 1.36.23a3.1 3.1 0 0 1 1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26a1.66 1.66 0 0 0-.59.7q-.2.44-.2.99v.88q0 .69.23 1.17.24.47.66.71t.99.24q.37 0 .68-.11a1.5 1.5 0 0 0 .53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.31-.01q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.96-.49q.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86q.39.31.97.31.32 0 .57-.09.26-.09.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06t-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17M91.92 17V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zM85.77 17l-2.83-7.64h2.04l1.34 4.05q.24.74.41 1.49l.37 1.54h-.44q.19-.79.36-1.54t.41-1.49l1.33-4.05h2.02L87.95 17zm-8.01 0V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.49-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-4.89.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7q-.21.44-.21.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31a1.4 1.4 0 0 0 .34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.87-.01q-1.2 0-2.09-.37t-1.39-1.09q-.5-.73-.53-1.77h1.92q.04.53.32.88t.74.53q.46.17 1.03.17t1.01-.17q.44-.18.68-.49.25-.31.25-.72a.9.9 0 0 0-.22-.62 1.7 1.7 0 0 0-.62-.42 5.3 5.3 0 0 0-.96-.31l-1.13-.29q-1.28-.32-2.01-.99-.72-.67-.72-1.76 0-.91.49-1.59t1.35-1.06 1.94-.38q1.11 0 1.93.38.83.38 1.3 1.06.47.67.49 1.54h-1.9q-.06-.64-.55-.98-.48-.35-1.29-.35a2.5 2.5 0 0 0-.94.17q-.39.16-.6.44a1.06 1.06 0 0 0-.2.64q0 .4.24.66.25.26.63.42.39.16.81.26l.94.23a6.5 6.5 0 0 1 1.15.38q.55.24.97.6.42.35.66.84t.24 1.14q0 .91-.46 1.59t-1.33 1.06-2.1.38m-13.18-.03a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M42.78 17V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-3.73 0V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zm-5.17 8.87q-1.55 0-2.45-.82-.9-.83-.9-2.35v-.59h1.96v.61q0 .77.38 1.16t1.02.39 1-.39q.38-.4.38-1.16V6.82h1.94v7.14q0 1.52-.9 2.35-.89.83-2.43.83"/>
</svg>
`;
function $076101c0fca1455b$export$dabef2be6cd28c20({ iconColor: iconColor, textColor: textColor, size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $076101c0fca1455b$var$svg,
        customThemeSvg: $076101c0fca1455b$var$customThemeSvg,
        iconColor: iconColor,
        textColor: textColor,
        label: label || 'Jira Service Management',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("37H9V", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryLogo", () => $33d3b4c3481bd349$export$c49a2b642fe9eef4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::148934b9256272f7f6a2d141594f436a>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $33d3b4c3481bd349$var$svg = `<svg height="100%" viewBox="0 0 186 24">
    <path fill="var(--tile-color,#c97cf4)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z"/>
    <path fill="var(--text-color, #292a2e)" d="m177.61 17.71.45-1.47.23.06q.41.11.73.06a.83.83 0 0 0 .52-.27q.21-.22.27-.62l.08-.44-2.88-7.67h2.04l1.34 4.05q.24.75.39 1.49.16.75.34 1.54h-.47l.37-1.54q.18-.75.43-1.49l1.4-4.05h2.02l-3.26 8.58q-.23.62-.59 1.06a2.3 2.3 0 0 1-.88.68q-.52.24-1.25.24-.4 0-.74-.06a2.5 2.5 0 0 1-.53-.14m-5.8-2.72V7.36h1.87v1.31h.08q.2-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V15zm-4.89.15q-1.16 0-2-.48a3.25 3.25 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.47-1.13.73-.68.25-1.54.25m-9.33-.16-2.83-7.64h2.04l1.34 4.05q.24.74.41 1.49l.37 1.54h-.44l.36-1.54q.17-.75.41-1.49l1.33-4.05h2.02L159.79 15zm-7.09.15q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.97-.49t1.96.49q.84.49 1.29 1.39.45.89.45 2.07t-.45 2.07a3.3 3.3 0 0 1-1.28 1.38q-.83.49-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23q-.19-.55-.58-.86-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31m-8.22 1.52q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86.97.31q.31 0 .57-.09t.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06t-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-8.2-.02q-.9 0-1.6-.25a2.85 2.85 0 0 1-1.14-.75 2.5 2.5 0 0 1-.57-1.2l1.8-.32q.15.55.54.82t1.02.27q.62 0 .98-.24t.36-.61q0-.31-.25-.51t-.76-.31l-1.31-.27q-1.09-.23-1.63-.77t-.54-1.39q0-.72.4-1.24.4-.53 1.1-.81.71-.29 1.65-.29.89 0 1.53.25a2.6 2.6 0 0 1 1.05.7q.4.44.55 1.06l-1.71.31a1.3 1.3 0 0 0-.46-.66q-.33-.27-.92-.27-.53 0-.9.23-.35.23-.35.59 0 .32.23.52.24.2.8.33l1.34.27q1.09.23 1.63.74t.54 1.33q0 .74-.43 1.3-.43.55-1.19.87-.75.31-1.74.31m-6.73-.16V7.36h1.93V15zm-.02-8.73V4.51h1.98v1.76zM120.9 15h-2.6v-1.69h2.52q1.02 0 1.71-.37t1.03-1.12q.35-.76.35-1.91t-.35-1.9a2.32 2.32 0 0 0-1.03-1.12q-.68-.37-1.69-.37h-2.6v-1.7h2.71q1.52 0 2.62.61a4.1 4.1 0 0 1 1.69 1.75q.59 1.14.59 2.73t-.59 2.74a4.1 4.1 0 0 1-1.7 1.76q-1.11.61-2.66.61m-1.55-10.19V15h-1.96V4.81zm-6.81 2.53v1.48h-4.44V7.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19q.12 0 .32-.03a5 5 0 0 0 .32-.06l.29 1.46a3.4 3.4 0 0 1-.64.13 5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.55-.59-1.59zm-5.13 9.61q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86.97.31q.32 0 .57-.09.26-.09.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.11.6-.4 1.06-.29.47-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-9.43-.07q-.79 0-1.39-.34a2.34 2.34 0 0 1-.92-.98q-.33-.65-.33-1.55V7.37h1.93v4.54q0 .75.38 1.16.38.42 1.05.42.46 0 .81-.19.35-.2.55-.57t.2-.9V7.38h1.93V15h-1.83L97 13.1h.12q-.31.98-.93 1.49t-1.56.51m-8.61.03a2.9 2.9 0 0 1-1.6-.46q-.71-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.13-1.32a2.9 2.9 0 0 1 1.57-.44q.66 0 1.09.23.43.22.69.54.27.32.4.61h.07V4.81h1.92V15h-1.89v-1.22h-.1a2.8 2.8 0 0 1-.4.61q-.27.31-.7.53-.43.21-1.07.21m.56-1.55q.55 0 .94-.3.38-.3.58-.84a3.5 3.5 0 0 0 .21-1.25q0-.72-.2-1.25t-.59-.83q-.38-.29-.94-.29-.57 0-.95.31a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.22q0 .69.19 1.23.2.54.58.85.39.31.95.31m-8.55 1.58q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.97-.49 1.96.49q.83.49 1.29 1.39.45.89.45 2.07t-.45 2.07T80 14.67t-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23 1.87 1.87 0 0 0-.59-.88q-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31M69.35 15V7.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.49-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V15zm-8.98 0V4.81h3.9q1.16 0 1.97.45.81.44 1.22 1.21.42.77.42 1.76t-.42 1.76-1.24 1.2q-.81.43-1.99.43H61.7v-1.6h2.25q.66 0 1.09-.22.43-.23.64-.64a2.05 2.05 0 0 0 .21-.93q0-.53-.2-.93a1.44 1.44 0 0 0-.64-.63q-.43-.23-1.09-.23h-1.6V15zm-9.48.13a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V7.36h1.91V15h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M42.78 15V7.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V15zm-3.73 0V7.36h1.93V15zm-.02-8.73V4.51h1.98v1.76zm-5.17 8.87q-1.55 0-2.45-.82-.9-.83-.9-2.35v-.59h1.96v.61q0 .77.38 1.16t1.02.39 1-.39q.38-.4.38-1.16V4.82h1.94v7.14q0 1.52-.9 2.35-.89.83-2.43.83"/>
</svg>
`;
const $33d3b4c3481bd349$var$customThemeSvg = `<svg height="100%" viewBox="0 0 186 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228"/>
    <path fill="var(--themed-text-color, currentcolor)" d="m177.61 19.71.45-1.47.23.06q.41.11.73.06a.83.83 0 0 0 .52-.27q.21-.22.27-.62l.08-.44-2.88-7.67h2.04l1.34 4.05q.24.75.39 1.49.16.75.34 1.54h-.47l.37-1.54q.18-.75.43-1.49l1.4-4.05h2.02l-3.26 8.58q-.23.62-.59 1.06a2.3 2.3 0 0 1-.88.68q-.52.24-1.25.24-.4 0-.74-.06a2.5 2.5 0 0 1-.53-.14m-5.8-2.72V9.36h1.87v1.31h.08q.2-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-4.89.15q-1.16 0-2-.48a3.25 3.25 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-9.33-.16-2.83-7.64h2.04l1.34 4.05q.24.74.41 1.49l.37 1.54h-.44q.18-.79.36-1.54.17-.75.41-1.49l1.33-4.05h2.02L159.79 17zm-7.09.15q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.97-.49t1.96.49q.84.49 1.29 1.39.45.89.45 2.07t-.45 2.07a3.3 3.3 0 0 1-1.28 1.38q-.83.49-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23q-.19-.55-.58-.86-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31m-8.22 1.52q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86.97.31q.31 0 .57-.09t.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06t-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-8.2-.02q-.9 0-1.6-.25a2.85 2.85 0 0 1-1.14-.75 2.5 2.5 0 0 1-.57-1.2l1.8-.32q.15.55.54.82t1.02.27q.62 0 .98-.24t.36-.61q0-.31-.25-.51t-.76-.31l-1.31-.27q-1.09-.23-1.63-.77t-.54-1.39q0-.72.4-1.24.4-.53 1.1-.81.71-.29 1.65-.29.89 0 1.53.25a2.6 2.6 0 0 1 1.05.7q.4.44.55 1.06l-1.71.31a1.3 1.3 0 0 0-.46-.66q-.33-.27-.92-.27-.53 0-.9.23-.35.23-.35.6 0 .32.23.52.24.2.8.33l1.34.27q1.09.23 1.63.74t.54 1.33q0 .74-.43 1.3-.43.55-1.19.87-.75.31-1.74.31m-6.73-.17V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zM120.9 17h-2.6v-1.69h2.52q1.02 0 1.71-.37t1.03-1.12q.35-.76.35-1.91t-.35-1.9a2.32 2.32 0 0 0-1.03-1.12q-.68-.37-1.69-.37h-2.6v-1.7h2.71q1.52 0 2.62.61a4.1 4.1 0 0 1 1.69 1.75q.59 1.14.59 2.73t-.59 2.74a4.1 4.1 0 0 1-1.7 1.76q-1.11.61-2.66.61m-1.55-10.19V17h-1.96V6.81zm-6.81 2.53v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19q.12 0 .32-.03a5 5 0 0 0 .32-.06l.29 1.46a3.4 3.4 0 0 1-.64.13 5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-5.13 9.61q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86q-.2.54-.2 1.24t.2 1.24.59.86.97.31q.32 0 .57-.09.26-.09.46-.27a1.6 1.6 0 0 0 .34-.42q.14-.25.2-.56l1.79.35q-.11.6-.4 1.06-.29.47-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-9.43-.07q-.79 0-1.39-.34a2.34 2.34 0 0 1-.92-.98q-.33-.65-.33-1.55V9.37h1.93v4.54q0 .75.38 1.16.38.42 1.05.42.46 0 .81-.19.35-.2.55-.57t.2-.9V9.38h1.93V17h-1.83L97 15.1h.12q-.31.98-.93 1.49t-1.56.51m-8.61.03a2.9 2.9 0 0 1-1.6-.46q-.71-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.13-1.32a2.9 2.9 0 0 1 1.57-.44q.66 0 1.09.23.43.22.69.54.27.32.4.61h.07V6.81h1.92V17h-1.89v-1.22h-.1a2.8 2.8 0 0 1-.4.61q-.27.31-.7.53-.43.21-1.07.21m.56-1.55q.55 0 .94-.3.38-.3.58-.84a3.5 3.5 0 0 0 .21-1.25q0-.72-.2-1.25t-.59-.83q-.38-.29-.94-.29-.57 0-.95.31a1.85 1.85 0 0 0-.58.83 3.6 3.6 0 0 0-.19 1.22q0 .69.19 1.23.2.54.58.85.39.31.95.31m-8.55 1.58q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.97-.49 1.96.49q.83.49 1.29 1.39.45.89.45 2.07t-.45 2.07T80 16.67t-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23 1.87 1.87 0 0 0-.58-.86q-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31M69.35 17V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.49-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-8.98 0V6.81h3.9q1.16 0 1.97.45.81.44 1.22 1.21.42.77.42 1.76t-.42 1.76a3 3 0 0 1-1.24 1.2q-.81.43-1.99.43H61.7v-1.6h2.25q.66 0 1.09-.22.43-.23.64-.64a2.05 2.05 0 0 0 .21-.93q0-.53-.2-.93a1.44 1.44 0 0 0-.64-.63q-.43-.23-1.09-.23h-1.6V17zm-9.48.13a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32a2.9 2.9 0 0 1 1.58-.44q.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.6 2.6 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83q-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M42.78 17V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-3.73 0V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zm-5.17 8.87q-1.55 0-2.45-.82-.9-.83-.9-2.35v-.59h1.96v.61q0 .77.38 1.16t1.02.39 1-.39q.38-.4.38-1.16V6.82h1.94v7.14q0 1.52-.9 2.35-.89.83-2.43.83"/>
</svg>
`;
function $33d3b4c3481bd349$export$c49a2b642fe9eef4({ iconColor: iconColor, textColor: textColor, size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $33d3b4c3481bd349$var$svg,
        customThemeSvg: $33d3b4c3481bd349$var$customThemeSvg,
        iconColor: iconColor,
        textColor: textColor,
        label: label || 'Jira Product Discovery',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8QdPr", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceManagementLogo", () => $778042e341d749ff$export$abc95e6180bb1d88);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b4ecc7c790ded0a88df0ffba2446edb>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $mfib2 = parcelRequire("mfib2");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $778042e341d749ff$var$svg = `<svg height="100%" viewBox="0 0 247 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z"/>
    <path fill="var(--text-color, #292a2e)" d="M246.18 9.36v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19q.12 0 .32-.03.21-.03.32-.06l.29 1.46q-.31.1-.64.13a5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-7.02 5.01V17h-1.93V9.36h1.82l.03 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.6.34.92.98.33.64.33 1.55V17h-1.92v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.34 1.34 0 0 0-.55.57q-.2.37-.2.9m-6.81 4.6q-1.16 0-2-.48a3.25 3.25 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.54 1.54 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34a2.66 2.66 0 0 1-.63 1.09q-.45.46-1.13.73-.68.25-1.54.25M212.83 17V9.36h1.8l.08 1.87h-.14q.17-.7.51-1.13.35-.44.81-.64.47-.21.97-.21.83 0 1.33.52.51.52.73 1.57h-.22q.16-.71.55-1.18.39-.46.91-.69.53-.23 1.12-.23.69 0 1.24.3t.87.88.32 1.42V17h-1.92v-4.82q0-.67-.37-1a1.32 1.32 0 0 0-.9-.32q-.4 0-.7.18a1.2 1.2 0 0 0-.46.49q-.16.32-.16.73V17h-1.87v-4.89q0-.57-.35-.91-.34-.34-.89-.34-.37 0-.68.17a1.2 1.2 0 0 0-.49.51q-.18.33-.18.81V17zm-4.88.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.45-2.06.45-.9 1.26-1.39.82-.5 1.93-.5.72 0 1.36.23a3.1 3.1 0 0 1 1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26a1.66 1.66 0 0 0-.59.7q-.2.44-.2.99v.88q0 .69.23 1.17.24.47.66.71t.99.24q.37 0 .68-.11a1.5 1.5 0 0 0 .53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.93 2.86q-.94 0-1.63-.24-.69-.23-1.13-.65a2.26 2.26 0 0 1-.61-.94l1.64-.51q.11.21.32.42.2.21.55.35t.87.14q.81 0 1.28-.38.47-.37.47-1.16v-1.41h-.15q-.14.29-.4.58a2 2 0 0 1-.68.48q-.42.19-1.07.19a3.1 3.1 0 0 1-1.58-.41q-.7-.41-1.13-1.24-.42-.83-.42-2.08 0-1.28.42-2.15t1.14-1.31q.71-.44 1.58-.44.66 0 1.09.23.44.22.7.54.27.32.4.61h.09V9.36h1.89v7.62q0 1.02-.47 1.7-.46.68-1.29 1-.82.33-1.88.33m.03-4.62q.55 0 .94-.27.38-.27.58-.77.21-.5.21-1.21 0-.7-.2-1.22-.2-.53-.58-.81-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.5 3.5 0 0 0-.19 1.2q0 .68.2 1.19t.58.79q.39.27.95.27m-9.38 1.73a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32.71-.44 1.58-.44.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.7 2.7 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83-.94-.29q-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31m-10.13-3.02V17h-1.93V9.36h1.82l.03 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.6.34.92.98.33.64.33 1.55V17h-1.92v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.35 1.35 0 0 0-.55.57q-.2.37-.2.9m-7.91 4.58a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32.71-.44 1.58-.44.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.7 2.7 0 0 1-.41.61 2.1 2.1 0 0 1-.7.53q-.43.21-1.08.21m.57-1.55q.56 0 .94-.3t.58-.84q.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83-.94-.29q-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.7 3.7 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M156.56 17V6.81h2.99l1.78 4.95q.1.31.23.81a47 47 0 0 1 .52 2.17q.12.54.2.94h-.39q.08-.39.2-.92a77 77 0 0 1 .53-2.18q.13-.5.23-.81l1.76-4.95h3V17h-1.96v-4.96q0-.33.01-.81a304 304 0 0 0 .05-2.17q.01-.57.01-1.07h.14q-.14.55-.3 1.14l-.31 1.14q-.16.55-.3 1-.14.46-.25.76L162.91 17h-1.66l-1.8-4.96q-.1-.29-.25-.74l-.3-1q-.16-.55-.32-1.13a94 94 0 0 1-.31-1.15h.16l.02 1.03.03 1.12.02 1.05q.01.49.01.83V17zm-8.37.15q-1.16 0-2-.48a3.25 3.25 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.45-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.56 1.56 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.99.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.3-.01q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86a3.6 3.6 0 0 0-.2 1.24q0 .7.2 1.24t.59.86.97.31q.32 0 .57-.09.26-.09.46-.27t.34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06-.29.47-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-7.13-.17V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zM126.68 17l-2.83-7.64h2.04l1.34 4.05q.24.74.41 1.49l.37 1.54h-.44q.19-.79.36-1.54t.41-1.49l1.33-4.05h2.02L128.85 17zm-8.02 0V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.94 1.94 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03 1.8 1.8 0 0 0-.86.21 1.5 1.5 0 0 0-.6.57 1.64 1.64 0 0 0-.21.85V17zm-4.89.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.45-2.06.45-.9 1.26-1.39.82-.5 1.93-.5.73 0 1.36.23a3.1 3.1 0 0 1 1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.56 1.56 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.99.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.89-.01q-1.2 0-2.09-.37t-1.39-1.09q-.5-.73-.53-1.77h1.92q.04.53.31.88.28.35.74.53.46.17 1.02.17.57 0 1.01-.17.44-.18.68-.49.25-.31.25-.72a.9.9 0 0 0-.22-.62 1.7 1.7 0 0 0-.62-.42 5.3 5.3 0 0 0-.96-.31l-1.13-.29q-1.28-.32-2.01-.99-.72-.67-.72-1.76 0-.91.49-1.59t1.35-1.06 1.94-.38q1.11 0 1.93.38.83.38 1.3 1.06.47.67.49 1.54h-1.9q-.06-.64-.55-.98-.48-.35-1.29-.35a2.5 2.5 0 0 0-.94.17 1.36 1.36 0 0 0-.6.44 1.07 1.07 0 0 0-.2.64q0 .4.24.66.25.26.63.42.39.16.81.26l.94.23q.61.14 1.15.38.55.24.97.6.42.35.66.84t.24 1.14q0 .91-.46 1.59t-1.33 1.06-2.1.38M92.15 17V9.36h1.87v1.31h.08q.2-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-4.88.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.14.71.49.47.77 1.2t.28 1.72v.57h-6.35v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31a1.4 1.4 0 0 0 .34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25M71.14 17V9.36h1.8l.08 1.87h-.14q.17-.7.51-1.13.35-.44.81-.64.47-.21.97-.21.83 0 1.33.52.51.52.73 1.57h-.22q.16-.71.55-1.18.39-.46.91-.69.53-.23 1.12-.23.69 0 1.24.3.56.3.87.88.32.58.32 1.42V17H80.1v-4.82q0-.67-.37-1a1.32 1.32 0 0 0-.89-.32q-.4 0-.7.18a1.2 1.2 0 0 0-.46.49q-.16.32-.16.73V17h-1.87v-4.89q0-.57-.35-.91-.34-.34-.89-.34-.37 0-.68.17a1.2 1.2 0 0 0-.49.51q-.18.33-.18.81V17zm-5.18.15q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.97-.49 1.96.49q.83.49 1.29 1.39.45.89.45 2.07t-.45 2.07-1.29 1.38q-.83.49-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23 1.87 1.87 0 0 0-.58-.86q-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31m-4.61-6.27v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19q.12 0 .32-.03.21-.03.32-.06l.29 1.46q-.31.1-.64.13a5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-5.1 9.61q-.9 0-1.6-.25a2.84 2.84 0 0 1-1.14-.75 2.5 2.5 0 0 1-.57-1.2l1.8-.32q.15.55.54.82t1.02.27q.62 0 .98-.24t.36-.61q0-.31-.25-.51t-.76-.31l-1.31-.27q-1.09-.23-1.63-.77t-.54-1.39q0-.72.4-1.24.4-.53 1.1-.81.71-.29 1.65-.29.89 0 1.53.25.65.25 1.05.7.4.44.55 1.06l-1.71.31a1.3 1.3 0 0 0-.46-.66q-.33-.27-.92-.27-.53 0-.9.23-.35.23-.35.6 0 .32.23.52.24.2.8.33l1.34.27q1.09.23 1.63.74t.54 1.33q0 .74-.43 1.3-.43.55-1.19.87-.75.31-1.74.31m-9.02-.07q-.79 0-1.39-.34a2.34 2.34 0 0 1-.92-.98q-.33-.65-.33-1.55V9.37h1.93v4.54q0 .75.38 1.16t1.05.42q.46 0 .81-.19.35-.2.55-.57t.2-.9V9.38h1.93V17h-1.82l-.02-1.9h.12q-.31.98-.93 1.49t-1.56.51m-8.5.04q-1.35 0-2.41-.62t-1.67-1.79-.61-2.82.62-2.82q.62-1.18 1.68-1.79 1.07-.62 2.4-.62.85 0 1.59.24.75.24 1.32.7t.94 1.12.49 1.51h-1.98a2.2 2.2 0 0 0-.28-.77 2 2 0 0 0-.51-.57q-.3-.24-.69-.36a2.8 2.8 0 0 0-.83-.12q-.81 0-1.43.41-.62.4-.97 1.18-.34.78-.34 1.89 0 1.13.35 1.91.35.77.96 1.17a2.6 2.6 0 0 0 1.43.4q.45 0 .83-.12.39-.12.7-.36.32-.24.52-.57.21-.34.29-.77h1.98q-.09.72-.43 1.36a4.2 4.2 0 0 1-.9 1.15 4.2 4.2 0 0 1-1.32.79q-.76.28-1.69.28"/>
</svg>
`;
const $778042e341d749ff$var$customThemeSvg = `<svg height="100%" viewBox="0 0 247 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5"/>
    <path fill="var(--themed-text-color, currentcolor)" d="M246.18 9.36v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19q.12 0 .32-.03.21-.03.32-.06l.29 1.46q-.31.1-.64.13a5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-7.02 5.01V17h-1.93V9.36h1.82l.03 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.6.34.92.98.33.64.33 1.55V17h-1.92v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.34 1.34 0 0 0-.55.57q-.2.37-.2.9m-6.81 4.6q-1.16 0-2-.48a3.25 3.25 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.72 0 1.36.23t1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.54 1.54 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34a2.66 2.66 0 0 1-.63 1.09q-.45.46-1.13.73-.68.25-1.54.25M212.83 17V9.36h1.8l.08 1.87h-.14q.17-.7.51-1.13.35-.44.81-.64.47-.21.97-.21.83 0 1.33.52.51.52.73 1.57h-.22q.16-.71.55-1.18.39-.46.91-.69.53-.23 1.12-.23.69 0 1.24.3t.87.88.32 1.42V17h-1.92v-4.82q0-.67-.37-1a1.32 1.32 0 0 0-.9-.32q-.4 0-.7.18a1.2 1.2 0 0 0-.46.49q-.16.32-.16.73V17h-1.87v-4.89q0-.57-.35-.91-.34-.34-.89-.34-.37 0-.68.17a1.2 1.2 0 0 0-.49.51q-.18.33-.18.81V17zm-4.88.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.45-2.06.45-.9 1.26-1.39.82-.5 1.93-.5.72 0 1.36.23a3.1 3.1 0 0 1 1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26a1.66 1.66 0 0 0-.59.7q-.2.44-.2.99v.88q0 .69.23 1.17.24.47.66.71t.99.24q.37 0 .68-.11a1.5 1.5 0 0 0 .53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.93 2.86q-.94 0-1.63-.24-.69-.23-1.13-.65a2.26 2.26 0 0 1-.61-.94l1.64-.51q.11.21.32.42.2.21.55.35t.87.14q.81 0 1.28-.38.47-.37.47-1.16v-1.41h-.15q-.14.29-.4.58a2 2 0 0 1-.68.48q-.42.19-1.07.19a3.1 3.1 0 0 1-1.58-.41q-.7-.41-1.13-1.24-.42-.83-.42-2.08 0-1.28.42-2.15t1.14-1.31q.71-.44 1.58-.44.66 0 1.09.23.44.22.7.54.27.32.4.61h.09V9.36h1.89v7.62q0 1.02-.47 1.7-.46.68-1.29 1-.82.33-1.88.33m.03-4.62q.55 0 .94-.27.38-.27.58-.77.21-.5.21-1.21 0-.7-.2-1.22-.2-.53-.58-.81-.38-.29-.94-.29-.57 0-.96.3-.38.3-.58.83a3.5 3.5 0 0 0-.19 1.2q0 .68.2 1.19t.58.79q.39.27.95.27m-9.38 1.73a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32.71-.44 1.58-.44.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.7 2.7 0 0 1-.41.61q-.27.32-.7.53t-1.08.21m.57-1.55q.55 0 .94-.3.38-.3.58-.84.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83-.94-.29q-.57 0-.96.3-.38.3-.58.83a3.6 3.6 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31m-10.13-3.02V17h-1.93V9.36h1.82l.03 1.9h-.13q.31-.97.92-1.48.62-.51 1.57-.51.79 0 1.37.34.6.34.92.98.33.64.33 1.55V17h-1.92v-4.54q0-.74-.38-1.16t-1.05-.42q-.45 0-.81.2a1.35 1.35 0 0 0-.55.57q-.2.37-.2.9m-7.91 4.58a2.9 2.9 0 0 1-1.59-.46q-.7-.46-1.12-1.33-.41-.88-.41-2.15 0-1.29.42-2.17.42-.87 1.14-1.32.71-.44 1.58-.44.66 0 1.09.23.43.22.69.54t.4.61h.08V9.36h1.91V17h-1.9v-1.22h-.08a2.7 2.7 0 0 1-.41.61 2.1 2.1 0 0 1-.7.53q-.43.21-1.08.21m.57-1.55q.56 0 .94-.3t.58-.84q.21-.54.21-1.25 0-.72-.2-1.25t-.58-.83-.94-.29q-.57 0-.96.3a1.85 1.85 0 0 0-.58.83 3.7 3.7 0 0 0-.19 1.23q0 .69.2 1.23t.58.85q.39.31.95.31M156.56 17V6.81h2.99l1.78 4.95q.1.31.23.81a47 47 0 0 1 .52 2.17q.12.54.2.94h-.39q.08-.39.2-.92a77 77 0 0 1 .53-2.18q.13-.5.23-.81l1.76-4.95h3V17h-1.96v-4.96q0-.33.01-.81a304 304 0 0 0 .05-2.17q.01-.57.01-1.07h.14q-.14.55-.3 1.14l-.31 1.14q-.16.55-.3 1-.14.46-.25.76L162.91 17h-1.66l-1.8-4.96q-.1-.29-.25-.74l-.3-1q-.16-.55-.32-1.13a94 94 0 0 1-.31-1.15h.16l.02 1.03.03 1.12.02 1.05q.01.49.01.83V17zm-8.37.15q-1.16 0-2-.48a3.25 3.25 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.45-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.13.71.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.56 1.56 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.99.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.3-.01q-1.13 0-1.96-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07a3.3 3.3 0 0 1 1.28-1.39q.83-.49 1.96-.49.66 0 1.22.17t1 .49.73.78.41 1.03l-1.8.36q-.06-.3-.2-.54a1.5 1.5 0 0 0-.33-.4 1.3 1.3 0 0 0-.44-.26 1.6 1.6 0 0 0-.56-.09q-.58 0-.97.31t-.59.86a3.6 3.6 0 0 0-.2 1.24q0 .7.2 1.24t.59.86.97.31q.32 0 .57-.09.26-.09.46-.27t.34-.42q.14-.25.2-.56l1.79.35q-.12.6-.4 1.06-.29.47-.73.79a3.3 3.3 0 0 1-1 .51q-.56.17-1.23.17m-7.13-.17V9.36h1.93V17zm-.02-8.73V6.52h1.98v1.75zM126.68 17l-2.83-7.64h2.04l1.34 4.05q.24.74.41 1.49l.37 1.54h-.44q.19-.79.36-1.54t.41-1.49l1.33-4.05h2.02L128.85 17zm-8.02 0V9.36h1.87v1.31h.08q.21-.68.71-1.05a1.94 1.94 0 0 1 1.16-.36q.15 0 .34.02.18.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03 1.8 1.8 0 0 0-.86.21 1.5 1.5 0 0 0-.6.57 1.64 1.64 0 0 0-.21.85V17zm-4.89.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.45-2.06.45-.9 1.26-1.39.82-.5 1.93-.5.73 0 1.36.23a3.1 3.1 0 0 1 1.14.71q.49.47.77 1.2t.28 1.72v.57h-6.34v-1.25h5.39l-.9.35q0-.62-.19-1.08a1.56 1.56 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.99.24q.37 0 .68-.11t.53-.31q.22-.21.34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25m-8.89-.01q-1.2 0-2.09-.37t-1.39-1.09q-.5-.73-.53-1.77h1.92q.04.53.31.88.28.35.74.53.46.17 1.02.17.57 0 1.01-.17.44-.18.68-.49.25-.31.25-.72a.9.9 0 0 0-.22-.62 1.7 1.7 0 0 0-.62-.42 5.3 5.3 0 0 0-.96-.31l-1.13-.29q-1.28-.32-2.01-.99-.72-.67-.72-1.76 0-.91.49-1.59t1.35-1.06 1.94-.38q1.11 0 1.93.38.83.38 1.3 1.06.47.67.49 1.54h-1.9q-.06-.64-.55-.98-.48-.35-1.29-.35a2.5 2.5 0 0 0-.94.17 1.36 1.36 0 0 0-.6.44 1.07 1.07 0 0 0-.2.64q0 .4.24.66.25.26.63.42.39.16.81.26l.94.23q.61.14 1.15.38.55.24.97.6.42.35.66.84t.24 1.14q0 .91-.46 1.59t-1.33 1.06-2.1.38M92.15 17V9.36h1.87v1.31h.08q.2-.68.71-1.05a1.93 1.93 0 0 1 1.16-.36q.15 0 .34.02.19.01.32.04v1.74a2 2 0 0 0-.38-.07 5 5 0 0 0-.48-.03q-.48 0-.86.21a1.5 1.5 0 0 0-.6.57 1.65 1.65 0 0 0-.21.85V17zm-4.88.15q-1.16 0-2-.48a3.26 3.26 0 0 1-1.29-1.37q-.45-.88-.45-2.08 0-1.18.44-2.06a3.4 3.4 0 0 1 1.26-1.39q.82-.5 1.93-.5.73 0 1.36.23.64.23 1.14.71.49.47.77 1.2t.28 1.72v.57h-6.35v-1.25h5.39l-.9.35a2.8 2.8 0 0 0-.19-1.08 1.55 1.55 0 0 0-.57-.72q-.37-.26-.93-.26-.55 0-.94.26t-.59.7-.2.99v.88q0 .69.23 1.17.24.47.66.71t.98.24q.37 0 .68-.11t.53-.31a1.4 1.4 0 0 0 .34-.52l1.75.34q-.18.62-.64 1.09-.45.46-1.13.73-.68.25-1.54.25M71.14 17V9.36h1.8l.08 1.87h-.14q.17-.7.51-1.13.35-.44.81-.64.47-.21.97-.21.83 0 1.33.52.51.52.73 1.57h-.22q.16-.71.55-1.18.39-.46.91-.69.53-.23 1.12-.23.69 0 1.24.3.56.3.87.88.32.58.32 1.42V17H80.1v-4.82q0-.67-.37-1a1.32 1.32 0 0 0-.89-.32q-.4 0-.7.18a1.2 1.2 0 0 0-.46.49q-.16.32-.16.73V17h-1.87v-4.89q0-.57-.35-.91-.34-.34-.89-.34-.37 0-.68.17a1.2 1.2 0 0 0-.49.51q-.18.33-.18.81V17zm-5.18.15q-1.13 0-1.97-.49a3.3 3.3 0 0 1-1.28-1.38q-.45-.89-.45-2.06 0-1.18.45-2.07.45-.9 1.28-1.39t1.97-.49 1.96.49q.83.49 1.29 1.39.45.89.45 2.07t-.45 2.07-1.29 1.38q-.83.49-1.96.49m0-1.53q.58 0 .97-.31.39-.32.58-.87a3.7 3.7 0 0 0 .19-1.23 3.7 3.7 0 0 0-.19-1.23 1.87 1.87 0 0 0-.58-.86q-.39-.32-.97-.32t-.97.32q-.38.32-.58.86-.19.54-.19 1.23 0 .68.19 1.23.2.55.58.87.39.31.97.31m-4.61-6.27v1.48h-4.44V9.36zm-3.38-1.82h1.92v7.27q0 .38.17.57t.56.19q.12 0 .32-.03.21-.03.32-.06l.29 1.46q-.31.1-.64.13a5 5 0 0 1-.62.04q-1.13 0-1.73-.55-.59-.56-.59-1.59zm-5.1 9.61q-.9 0-1.6-.25a2.84 2.84 0 0 1-1.14-.75 2.5 2.5 0 0 1-.57-1.2l1.8-.32q.15.55.54.82t1.02.27q.62 0 .98-.24t.36-.61q0-.31-.25-.51t-.76-.31l-1.31-.27q-1.09-.23-1.63-.77t-.54-1.39q0-.72.4-1.24.4-.53 1.1-.81.71-.29 1.65-.29.89 0 1.53.25.65.25 1.05.7.4.44.55 1.06l-1.71.31a1.3 1.3 0 0 0-.46-.66q-.33-.27-.92-.27-.53 0-.9.23-.35.23-.35.6 0 .32.23.52.24.2.8.33l1.34.27q1.09.23 1.63.74t.54 1.33q0 .74-.43 1.3-.43.55-1.19.87-.75.31-1.74.31m-9.02-.07q-.79 0-1.39-.34a2.34 2.34 0 0 1-.92-.98q-.33-.65-.33-1.55V9.37h1.93v4.54q0 .75.38 1.16t1.05.42q.46 0 .81-.19.35-.2.55-.57t.2-.9V9.38h1.93V17h-1.82l-.02-1.9h.12q-.31.98-.93 1.49t-1.56.51m-8.5.04q-1.35 0-2.41-.62t-1.67-1.79-.61-2.82.62-2.82q.62-1.18 1.68-1.79 1.07-.62 2.4-.62.85 0 1.59.24.75.24 1.32.7t.94 1.12.49 1.51h-1.98a2.2 2.2 0 0 0-.28-.77 2 2 0 0 0-.51-.57q-.3-.24-.69-.36a2.8 2.8 0 0 0-.83-.12q-.81 0-1.43.41-.62.4-.97 1.18-.34.78-.34 1.89 0 1.13.35 1.91.35.77.96 1.17a2.6 2.6 0 0 0 1.43.4q.45 0 .83-.12.39-.12.7-.36.32-.24.52-.57.21-.34.29-.77h1.98q-.09.72-.43 1.36a4.2 4.2 0 0 1-.9 1.15 4.2 4.2 0 0 1-1.32.79q-.76.28-1.69.28"/>
</svg>
`;
function $778042e341d749ff$export$abc95e6180bb1d88({ iconColor: iconColor, textColor: textColor, size: size, appearance: appearance = 'brand', label: label, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $mfib2.LogoWrapper), {
        svg: $778042e341d749ff$var$svg,
        customThemeSvg: $778042e341d749ff$var$customThemeSvg,
        iconColor: iconColor,
        textColor: textColor,
        label: label || 'Customer Service Management',
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("921sX", function(module, exports) {

$parcel$export(module.exports, "AccountMenuNav3", () => $0203a463eaa24bfa$export$4ff56e5cf713dc64);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7pImm = parcelRequire("7pImm");

var $eUECn = parcelRequire("eUECn");

var $1bGms = parcelRequire("1bGms");
const $0203a463eaa24bfa$export$4ff56e5cf713dc64 = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1bGms.AccountMenu), {
        ...props,
        AccountMenuLoggedOutState: (0, $7pImm.AccountMenuLoggedOutStateNav3),
        AccountMenuTrigger: (0, $eUECn.AccountMenuTriggerNav3)
    });
};

});
parcelRegister("1bGms", function(module, exports) {

$parcel$export(module.exports, "AccountMenu", () => $eb480c5bace8303e$export$ff20d75d5eda4388);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1PVpv = parcelRequire("1PVpv");

var $kHCo7 = parcelRequire("kHCo7");

var $6EBh3 = parcelRequire("6EBh3");

var $8NZjk = parcelRequire("8NZjk");

var $fnXLr = parcelRequire("fnXLr");
const $eb480c5bace8303e$export$ff20d75d5eda4388 = ({ testId: testId, name: name, picture: picture, email: email, managedBy: managedBy, manageProfileLink: manageProfileLink, viewProfileLink: viewProfileLink, onViewProfileClick: onViewProfileClick, switchAccountLink: switchAccountLink, logOutLink: logOutLink, logInLink: logInLink, onThemeChange: onThemeChange, currentTheme: currentTheme, extraMenuItems: extraMenuItems, trustPicture: trustPicture = false, AccountMenuLoggedOutState: AccountMenuLoggedOutState, AccountMenuTrigger: AccountMenuTrigger })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PVpv.NavigationAnalyticsContext), {
        data: (0, $kHCo7.ANALYTICS_CONTEXT),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8NZjk.AccountMenuIntlProvider), {
            children: logInLink ? /*#__PURE__*/ (0, $2OMIu.jsx)(AccountMenuLoggedOutState, {
                testId: testId && `${testId}--logged-out-state`,
                logInLink: logInLink
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fnXLr.AccountMenuPopup), {
                testId: testId,
                picture: picture,
                trustPicture: trustPicture,
                email: email,
                AccountMenuTrigger: AccountMenuTrigger,
                content: ({ onClose: closePopup })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6EBh3.AccountMenuContent), {
                        testId: testId && `${testId}--content`,
                        closePopup: closePopup,
                        name: name,
                        picture: picture,
                        email: email,
                        managedBy: managedBy,
                        manageProfileLink: manageProfileLink,
                        viewProfileLink: viewProfileLink,
                        onViewProfileClick: onViewProfileClick,
                        switchAccountLink: switchAccountLink,
                        logOutLink: logOutLink,
                        onThemeChange: onThemeChange,
                        currentTheme: currentTheme,
                        extraMenuItems: extraMenuItems
                    })
            })
        })
    });

});
parcelRegister("fnXLr", function(module, exports) {

$parcel$export(module.exports, "AccountMenuPopup", () => $8d206fa9e8c3fd62$export$473cb05bf335b0e1);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $c543i = parcelRequire("c543i");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");

var $kHCo7 = parcelRequire("kHCo7");
const $8d206fa9e8c3fd62$export$473cb05bf335b0e1 = ({ testId: testId, picture: picture, email: email, content: content, trustPicture: trustPicture = false, AccountMenuTrigger: AccountMenuTrigger })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const close = (0, $c543i.useCallbackWithAnalytics)(()=>setIsOpen(false), {
        eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
        action: 'closed',
        actionSubject: 'popup',
        actionSubjectId: 'accountMenu'
    }, (0, $kHCo7.NAVIGATION_CHANNEL));
    const open = (0, $c543i.useCallbackWithAnalytics)(()=>setIsOpen(true), {
        eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
        action: 'opened',
        actionSubject: 'popup',
        actionSubjectId: 'accountMenu'
    }, (0, $kHCo7.NAVIGATION_CHANNEL));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
        isOpen: isOpen,
        onClose: close,
        testId: testId,
        placement: "bottom",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)(AccountMenuTrigger, {
                onClick: isOpen ? close : open,
                testId: testId && `${testId}--trigger`,
                picture: picture,
                email: email,
                trustPicture: trustPicture,
                ...triggerProps
            }),
        content: content,
        shouldRenderToParent: (0, $VSDnB.fg)('should-render-to-parent-should-be-true-identity-ki')
    });
};

});



parcelRegister("67hPg", function(module, exports) {

$parcel$export(module.exports, "Trigger", () => $f5abbb29b5666c06$export$41fb9f06171c75f4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3Du7S = parcelRequire("3Du7S");

var $7F2yO = parcelRequire("7F2yO");

var $kKgGa = parcelRequire("kKgGa");

var $e2pRJ = parcelRequire("e2pRJ");

var $hDhQq = parcelRequire("hDhQq");
const $f5abbb29b5666c06$var$emptyEntryPointParams = {};
const $f5abbb29b5666c06$var$emptyEntryPointProps = {};
function $f5abbb29b5666c06$export$41fb9f06171c75f4({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, forwardedRef: forwardedRef, trigger: trigger }) {
    const { setPanel: setPanel } = trigger;
    const environmentProvider = (0, $e2pRJ.useRelayEnvironmentProvider)();
    const id = (0, $5uXOq.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $f5abbb29b5666c06$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference })=>{
        setPanel(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kKgGa.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: fallback || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hDhQq.DefaultFallback), {}),
            errorFallback: errorFallback,
            runtimeProps: entryPointProps || $f5abbb29b5666c06$var$emptyEntryPointProps
        }));
    }, [
        setPanel,
        id,
        entryPointProps,
        fallback,
        errorFallback
    ]);
    const triggerRef = (0, $7F2yO.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const mergedRef = (0, $3Du7S.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}

});
parcelRegister("hDhQq", function(module, exports) {

$parcel$export(module.exports, "DefaultFallback", () => $5d43ace1d77c91f8$export$93c734e924cdbdaa);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $iwwXK = parcelRequire("iwwXK");
function $5d43ace1d77c91f8$export$93c734e924cdbdaa() {
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {})
        ]
    });
}

});


parcelRegister("kNJSJ", function(module, exports) {

$parcel$export(module.exports, "usePanel", () => $0ef0a2f3e739e762$export$9168a42f32e3d071);

var $5uXOq = parcelRequire("5uXOq");
function $0ef0a2f3e739e762$export$9168a42f32e3d071(preloadedPanel) {
    const [panel, setPanel] = (0, $5uXOq.useState)(preloadedPanel);
    const Panel = (0, $5uXOq.useMemo)(()=>{
        const PanelComponent = ()=>panel ?? null;
        return PanelComponent;
    }, [
        panel
    ]);
    const trigger = (0, $5uXOq.useMemo)(()=>({
            setPanel: (panel)=>setPanel(panel)
        }), [
        setPanel
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            Panel: Panel,
            trigger: trigger
        }), [
        Panel,
        trigger
    ]);
}

});

parcelRegister("ce4pa", function(module, exports) {

$parcel$export(module.exports, "ExperienceSuccess", () => $a91ff3a48261deb0$export$4962f3898bd5c829);

var $5uXOq = parcelRequire("5uXOq");
const $a91ff3a48261deb0$export$4962f3898bd5c829 = ({ experience: experience })=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        experience.success();
    }, [
        experience
    ]);
    return null;
};

});

parcelRegister("bPysz", function(module, exports) {

$parcel$export(module.exports, "ProductSearchInputSkeleton", () => $f7d66de1ed5c4c15$export$91fb362ea940bd8b);
/*
 * Minimalistic version of the search dialog, that provides a ready-only view
 * to be used as a loading component in async components and SSR.
 */ 
var $2OMIu = parcelRequire("2OMIu");

var $cFUJK = parcelRequire("cFUJK");
var $2AbEM = parcelRequire("2AbEM");
parcelRequire("5uXOq");
const $f7d66de1ed5c4c15$export$91fb362ea940bd8b = ({ theme: theme, ...rest })=>{
    if (theme) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2AbEM.ThemeProvider), {
        partialSearchCSS: theme,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cFUJK.default), {
            ...rest
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cFUJK.default), {
        ...rest
    });
};

});
parcelRegister("cFUJK", function(module, exports) {

$parcel$export(module.exports, "default", () => $de03a6aae28371f7$export$2e2bcd8739ae039);
/*
 * Skeleton consumed by product-search-dialog only,
 * check the comments in packages/product-search-dialog/src/common/product-search-input/product-search-input-skeleton.tsx.
 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2AbEM = parcelRequire("2AbEM");

var $b9NEf = parcelRequire("b9NEf");

var $hLeR9 = parcelRequire("hLeR9");

var $6I8Kl = parcelRequire("6I8Kl");

var $42CjB = parcelRequire("42CjB");

var $j1SOM = parcelRequire("j1SOM");

var $8I7W7 = parcelRequire("8I7W7");
const $de03a6aae28371f7$var$MAX_INPUT_LENGTH = 500;
const $de03a6aae28371f7$export$9b2f977cfc67f251 = (props)=>{
    const theme = (0, $2AbEM.useTheme)();
    const { forwardRef: forwardRef, features: features, shouldFillContainer: shouldFillContainer, placeholder: nonFeaturesPlaceholder, ariaLabel: ariaLabel, dataSsrPlaceholder: dataSsrPlaceholder } = props;
    const { enabled: enabled, advancedSearchUrl: advancedSearchUrl, placeholder: placeholder, customScriptDataAttributes: customScriptDataAttributes } = features?.interactiveSkeleton || {};
    if (enabled || (0, $j1SOM.getInputSkeletonFocus)()) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8I7W7.SSRsearchInput), {
        shouldFillContainer: shouldFillContainer,
        advancedSearchUrl: advancedSearchUrl,
        placeholder: placeholder || nonFeaturesPlaceholder,
        customScriptDataAttributes: customScriptDataAttributes,
        theme: theme
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hLeR9.SearchAnchorWrapper), {
        shouldFillContainer: shouldFillContainer,
        "data-ssr-placeholder": dataSsrPlaceholder,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $b9NEf.SearchInputContainer), {
            ...theme,
            shouldFillContainer: shouldFillContainer,
            isExpanded: false,
            role: "search",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.MobileSearchIconWrapper), {
                    isExpanded: false,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                        label: "Search",
                        icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6I8Kl.SearchIcon), {
                                theme: theme,
                                isExpanded: false,
                                size: "medium"
                            })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.DesktopSearchIconWrapper), {
                    ...theme,
                    isExpanded: false,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6I8Kl.SearchIcon), {
                        theme: theme,
                        isExpanded: false
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.SearchInputField), {
                    "data-test-id": "search-dialog-search-skeleton",
                    isExpanded: false,
                    placeholder: nonFeaturesPlaceholder || placeholder,
                    ref: forwardRef || undefined,
                    disabled: true,
                    value: "",
                    maxLength: $de03a6aae28371f7$var$MAX_INPUT_LENGTH,
                    onChange: ()=>{},
                    "aria-label": ariaLabel || nonFeaturesPlaceholder || placeholder,
                    ...theme
                })
            ]
        })
    });
};
var $de03a6aae28371f7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)($de03a6aae28371f7$export$9b2f977cfc67f251, {
        ...props,
        forwardRef: ref
    }));

});
parcelRegister("2AbEM", function(module, exports) {

$parcel$export(module.exports, "ThemeProvider", () => $7a9ddac47e3fba86$export$d8964aec282183a3);
$parcel$export(module.exports, "useTheme", () => $7a9ddac47e3fba86$export$93d4e7f90805808f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

/**
 * Pls see the function generateTheme inside - atlassian-frontend/packages/navigation/atlassian-navigation/src/theme/themeGenerator.ts
 * This default generator should overwrite the exact same properties which are being produced by the theme generator.
 */ const $7a9ddac47e3fba86$export$e6c62eb05a8288ed = {
    default: {
        default: {
            backgroundColor: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
            borderColor: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
            borderWidth: "var(--ds-border-width, 1px)",
            iconColor: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7090862dc3038a9f)})`
        },
        focus: {
            borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
            backgroundColor: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`}`
        },
        hover: {
            backgroundColor: "var(--ds-background-input-hovered, rgba(222, 235, 255, 0.9))"
        }
    }
};
const $7a9ddac47e3fba86$var$getTheme = (searchCSS)=>{
    if (!searchCSS) return $7a9ddac47e3fba86$export$e6c62eb05a8288ed.default;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, $7a9ddac47e3fba86$export$e6c62eb05a8288ed.default, searchCSS);
};
const $7a9ddac47e3fba86$var$ctx = /*#__PURE__*/ (0, $5uXOq.createContext)($7a9ddac47e3fba86$export$e6c62eb05a8288ed.default);
const $7a9ddac47e3fba86$export$d8964aec282183a3 = ({ value: value, partialSearchCSS: partialSearchCSS, children: children })=>{
    const theme = $7a9ddac47e3fba86$var$getTheme(partialSearchCSS || value);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7a9ddac47e3fba86$var$ctx.Provider, {
        value: theme,
        children: children
    });
};
const $7a9ddac47e3fba86$export$93d4e7f90805808f = ()=>{
    return (0, $5uXOq.useContext)($7a9ddac47e3fba86$var$ctx);
};
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $7a9ddac47e3fba86$export$f9bb738f552c610d = $7a9ddac47e3fba86$var$ctx;
// todo - deprecate (requires product update)
// eslint-disable-next-line
const $7a9ddac47e3fba86$export$62640b580a501775 = (suppliedTheme)=>{
    return suppliedTheme;
};

});

parcelRegister("b9NEf", function(module, exports) {

$parcel$export(module.exports, "MobileSearchIconWrapper", () => $978931f79bc05084$export$63e083aca343a6ae);
$parcel$export(module.exports, "DesktopSearchIconWrapper", () => $978931f79bc05084$export$9673cb6b61244e6e);
$parcel$export(module.exports, "InputBoxOverlayRight", () => $978931f79bc05084$export$1da38d078e896a10);
$parcel$export(module.exports, "ClearIconWrapper", () => $978931f79bc05084$export$ff9b1a25d343474d);
$parcel$export(module.exports, "ArrowIconWrapper", () => $978931f79bc05084$export$54c466678ae7c638);
$parcel$export(module.exports, "SearchInputContainer", () => $978931f79bc05084$export$c2b37b18a8b54130);
$parcel$export(module.exports, "SearchInputField", () => $978931f79bc05084$export$b6261a2c5ea449d);
$parcel$export(module.exports, "HiddenTooltip", () => $978931f79bc05084$export$ca6fe3402791d08e);
$parcel$export(module.exports, "SSRsearchInputField", () => $978931f79bc05084$export$6d53dccb772ed720);
$parcel$export(module.exports, "SSRsearchInputWrapper", () => $978931f79bc05084$export$c47d4a3e1f1297f1);
$parcel$export(module.exports, "SSRformContainer", () => $978931f79bc05084$export$58ae19ee1fc7be8a);
$parcel$export(module.exports, "SSRsearchInputContainer", () => $978931f79bc05084$export$b40f2abde293e8e4);
$parcel$export(module.exports, "SSRdesktopSearchIconWrapper", () => $978931f79bc05084$export$eb4e9f55bbe045df);
$parcel$export(module.exports, "SSRmobileSearchIconWrapper", () => $978931f79bc05084$export$3f33ed4b273b43d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $btzsC = parcelRequire("btzsC");

var $3JZ8k = parcelRequire("3JZ8k");


var $h9kUS = parcelRequire("h9kUS");

var $bWGt6 = parcelRequire("bWGt6");
function $978931f79bc05084$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $978931f79bc05084$var$expandedPlaceholderColor = "var(--ds-text-subtlest, #B5BEC9)";
const $978931f79bc05084$export$63e083aca343a6ae = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "eq4kchp13"
})("display:none;@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){display:", (props)=>props.isExpanded ? 'none' : 'block', ";}");
const $978931f79bc05084$export$9673cb6b61244e6e = /*#__PURE__*/ (0, $bWGt6.default)('span', {
    target: "eq4kchp12"
})("width:", (0, $3JZ8k.grid).multiple(2).px, ";height:", (0, $3JZ8k.grid).multiple(2).px, ";position:absolute;top:", (0, $3JZ8k.grid).px, ";left:", (0, $3JZ8k.grid).px, ";color:", (props)=>props.isExpanded ? `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})` : props.default.color, ";display:inline-flex;align-items:baseline;:focus{box-shadow:0 0 0 2px ", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`, ";border-radius:100%;outline:none;}&>span[role='img']{line-height:0;}@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){display:none;}");
const $978931f79bc05084$export$1da38d078e896a10 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp11"
})("position:absolute;display:flex;top:0;right:0;height:100%;align-items:center;margin:auto 0;@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){right:24px;}");
const $978931f79bc05084$export$ff9b1a25d343474d = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp10"
})("width:", (0, $3JZ8k.grid).multiple(2).px, ";height:", (0, $3JZ8k.grid).multiple(2).px, ";padding:5px var(--ds-space-075, 6px);color:", `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`, ";background-color:transparent;@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){display:none;}:hover{cursor:pointer;color:", `var(--ds-icon, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`, ";}&>span>svg{vertical-align:unset;}");
const $978931f79bc05084$export$54c466678ae7c638 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp9"
})("display:none;margin:0 ", (0, $3JZ8k.grid).px, ";height:", (0, $3JZ8k.grid).multiple(4).px, ";padding-bottom:", (0, $3JZ8k.grid).multiple(0.25).px, ";color:", (props)=>props.default.color, ";@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){display:flex;align-items:center;}:hover{border-radius:100%;background-color:", (props)=>props.hover.backgroundColor, ";color:", (props)=>props.hover.color, ";}");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $978931f79bc05084$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $978931f79bc05084$export$c2b37b18a8b54130 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp8"
})(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $f8Sb3.css)("position:relative;max-width:100%; @media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){ width:100%;}"), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    const boundedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        width: props.isExpanded ? (0, $3JZ8k.dialogWidth) : (0, $3JZ8k.collapsedSearchInputWidth)
    });
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    const fluidStyles = $978931f79bc05084$var$_ref;
    const styles = props.shouldFillContainer ? fluidStyles : boundedStyles;
    // todo - this should be another class
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $f8Sb3.css)(styles, " @media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){width:100%;height:", (0, $3JZ8k.atlassianNavigationHeight), ";background-color:", props.default.backgroundColor, "; display:flex;align-items:center;max-width:initial;}");
    return styles;
});
const $978931f79bc05084$export$b6261a2c5ea449d = /*#__PURE__*/ (0, $bWGt6.default)("input", {
    target: "eq4kchp7"
})("height:", (0, $3JZ8k.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:5px;/* Refer to @atlaskit/textfield for more details */font:var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);", (props)=>`
    border: ${"var(--ds-border-width, 1px)"} solid ${props.isExpanded ? props.focus.borderColor : props.default.borderColor};
    box-shadow: ${props.isExpanded ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${props.focus.borderColor}, -12px 0 24px 0 ${props.default.backgroundColor}` : 'none'};
    background-color: ${props.isExpanded ? props.focus.backgroundColor : props.default.backgroundColor};
    color: ${props.isExpanded ? props.focus.color : props.default.color};

    &::placeholder {
      color: ${props.isExpanded ? $978931f79bc05084$var$expandedPlaceholderColor : props.default.color};
    }
    :focus {
      border: ${"var(--ds-border-width, 1px)"} solid ${props.focus.borderColor};
    }
    @media screen and (max-width: ${0, $3JZ8k.dialogPageTakeoverWidth}px) {
      ${props.isExpanded ? `
            padding: 0 ${(0, $3JZ8k.grid).multiple(1.5).px} ${(0, $3JZ8k.grid).multiple(0.25).px};
            margin: 0 ${(0, $3JZ8k.grid).multiple(3).px} 0 0;` : `
            display: none;
          `}
    }
  `, " ", (0, $h9kUS.media).above.xs, "{font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);}");
const $978931f79bc05084$export$ca6fe3402791d08e = /*#__PURE__*/ (0, $bWGt6.default)((0, $btzsC.default), {
    target: "eq4kchp6"
})({
    name: "eivff4",
    styles: "display:none"
});
const $978931f79bc05084$export$6d53dccb772ed720 = /*#__PURE__*/ (0, $bWGt6.default)('input', {
    target: "eq4kchp5"
})("height:", (0, $3JZ8k.inputFieldHeight).px, ";width:100%;padding:0px var(--ds-space-150, 12px) 0px 30px;box-sizing:border-box;outline:none;border-radius:5px;font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);border:", ()=>`${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`}`, ";background-color:var(--ds-background-input, rgb(255, 255, 255));color:", `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`, ";:hover{background-color:var(--ds-background-input-hovered, rgb(255, 255, 255));}:focus{color:", `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`, ";box-shadow:", ()=>`inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`}`, ";}@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){display:none;}");
const $978931f79bc05084$export$c47d4a3e1f1297f1 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp4"
})("position:relative;height:32px;@media screen and (min-width: 781px){min-width:", (props)=>props.shouldFillContainer ? '100%' : '200px', ";}", (props)=>props.shouldFillContainer ? 'width: 100%;' : '', ";");
const $978931f79bc05084$export$58ae19ee1fc7be8a = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp3"
})({
    name: "bjn8wh",
    styles: "position:relative"
});
const $978931f79bc05084$export$b40f2abde293e8e4 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "eq4kchp2"
})("position:relative;max-width:100%;@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){width:100%;}width:", (props)=>{
    if (props.shouldFillContainer) return '100%';
    return 0, $3JZ8k.collapsedSearchInputWidth;
}, ";");
const $978931f79bc05084$export$eb4e9f55bbe045df = /*#__PURE__*/ (0, $bWGt6.default)('span', {
    target: "eq4kchp1"
})("width:", (0, $3JZ8k.grid).multiple(2).px, ";height:", (0, $3JZ8k.grid).multiple(2).px, ";position:absolute;top:", (0, $3JZ8k.grid).px, ";left:", (0, $3JZ8k.grid).px, ";color:rgb(107, 119, 140);display:inline-flex;align-items:baseline;@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){display:none;}");
const $978931f79bc05084$export$3f33ed4b273b43d = /*#__PURE__*/ (0, $bWGt6.default)('span', {
    target: "eq4kchp0"
})("display:none;padding:", (0, $3JZ8k.grid).multiple(0.5).px, ";padding-right:var(--ds-space-025, 2px);color:rgb(52, 69, 99);@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){display:flex;}");

});
parcelRegister("3JZ8k", function(module, exports) {

$parcel$export(module.exports, "zIndex", () => $f8d02d6b2df072ff$export$56446adcecbeec34);
$parcel$export(module.exports, "grid", () => $f8d02d6b2df072ff$export$85fc379452d91af0);
$parcel$export(module.exports, "atlassianNavigationHeight", () => $f8d02d6b2df072ff$export$b9930dabfa4a3a3);
$parcel$export(module.exports, "collapsedSearchInputWidth", () => $f8d02d6b2df072ff$export$f6af7620e8789c39);
$parcel$export(module.exports, "dialogWidth", () => $f8d02d6b2df072ff$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogPageTakeoverWidth", () => $f8d02d6b2df072ff$export$ce4512df260a325a);
$parcel$export(module.exports, "dialogPageCentreWidth", () => $f8d02d6b2df072ff$export$a406031ed42c8e02);
$parcel$export(module.exports, "inputFieldHeight", () => $f8d02d6b2df072ff$export$e00021bea368c518);
$parcel$export(module.exports, "enlargedInputFieldHeight", () => $f8d02d6b2df072ff$export$30310ee354b45eb0);
$parcel$export(module.exports, "primaryTextColour", () => $f8d02d6b2df072ff$export$eeb0307e2964e28d);
$parcel$export(module.exports, "itemLinkSecondaryColor", () => $f8d02d6b2df072ff$export$7168c0a11fb9ab29);
$parcel$export(module.exports, "itemHighlightColor", () => $f8d02d6b2df072ff$export$4ac85ff259fe4fce);
$parcel$export(module.exports, "visitedLinkColor", () => $f8d02d6b2df072ff$export$271fb8b1437b1d62);
$parcel$export(module.exports, "nowrapEllipsis", () => $f8d02d6b2df072ff$export$b6b16ffe83ef4b56);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $k5uoT = parcelRequire("k5uoT");

function $f8d02d6b2df072ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f8d02d6b2df072ff$var$GRID_UNIT = (0, $k5uoT.gridSize)();
const $f8d02d6b2df072ff$var$AkGrid = (num = 1)=>({
        px: `${num * $f8d02d6b2df072ff$var$GRID_UNIT}px`,
        unitless: num * $f8d02d6b2df072ff$var$GRID_UNIT,
        multiple: (multiplier)=>$f8d02d6b2df072ff$var$AkGrid(multiplier * num),
        half: ()=>$f8d02d6b2df072ff$var$AkGrid(0.5 * num),
        twice: ()=>$f8d02d6b2df072ff$var$AkGrid(2 * num)
    });
const $f8d02d6b2df072ff$export$56446adcecbeec34 = {
    searchDialog: (0, $k5uoT.layers).dialog()
};
const $f8d02d6b2df072ff$export$85fc379452d91af0 = $f8d02d6b2df072ff$var$AkGrid(1);
const $f8d02d6b2df072ff$export$b9930dabfa4a3a3 = '56px';
const $f8d02d6b2df072ff$export$f6af7620e8789c39 = '200px';
const $f8d02d6b2df072ff$export$64d8573e83b64ff8 = '150px';
const $f8d02d6b2df072ff$export$a3da89b899389ed8 = '780px';
const $f8d02d6b2df072ff$export$ce4512df260a325a = 780;
const $f8d02d6b2df072ff$export$a406031ed42c8e02 = '1130px';
const $f8d02d6b2df072ff$export$e00021bea368c518 = $f8d02d6b2df072ff$export$85fc379452d91af0.multiple(4);
const $f8d02d6b2df072ff$export$30310ee354b45eb0 = $f8d02d6b2df072ff$export$85fc379452d91af0.multiple(6);
const $f8d02d6b2df072ff$export$eeb0307e2964e28d = `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`;
const $f8d02d6b2df072ff$export$7168c0a11fb9ab29 = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`;
const $f8d02d6b2df072ff$export$4ac85ff259fe4fce = `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
const $f8d02d6b2df072ff$export$271fb8b1437b1d62 = `var(--ds-link-visited, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`;
const $f8d02d6b2df072ff$export$b6b16ffe83ef4b56 = {
    name: "sqm42b",
    styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};

});


parcelRegister("hLeR9", function(module, exports) {

$parcel$export(module.exports, "AbsoluteContainer", () => $0b21a022edbcff7e$export$36aa0f4a98890c96);
$parcel$export(module.exports, "SearchDialogAnchor", () => $0b21a022edbcff7e$export$f565ce1043dae7c9);
$parcel$export(module.exports, "SearchAnchorWrapper", () => $0b21a022edbcff7e$export$dfece74a62f1398d);
$parcel$export(module.exports, "EnlargedSearchAnchorWrapper", () => $0b21a022edbcff7e$export$5566658d36f6ca7b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $3JZ8k = parcelRequire("3JZ8k");

var $bWGt6 = parcelRequire("bWGt6");
const $0b21a022edbcff7e$export$36aa0f4a98890c96 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "exl9bxq3"
})("", (props)=>{
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        ...props.shouldFillContainer && {
            left: 0
        },
        right: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $3JZ8k.zIndex).searchDialog
    });
    return {};
});
const $0b21a022edbcff7e$export$f565ce1043dae7c9 = /*#__PURE__*/ (0, $bWGt6.default)('div', {
    target: "exl9bxq2"
})("position:relative;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>{
    if (props.isExpanded) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $f8Sb3.css)("@media screen and (max-width: ", (0, $3JZ8k.dialogPageCentreWidth), "){ position:", props.shouldFillContainer ? 'static' : 'fixed', "; z-index:", (0, $3JZ8k.zIndex).searchDialog, ";left:calc((100% - ", (0, $3JZ8k.dialogWidth), ") / 2);;}@media screen and (max-width: ", (0, $3JZ8k.dialogPageTakeoverWidth), "px){ ", props.shouldFillContainer && 'position: fixed;', ";top:0;right:0;bottom:0;left:0;display:flex;flex-direction:column;overflow:auto;}");
    return {};
});
const $0b21a022edbcff7e$export$dfece74a62f1398d = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "exl9bxq1"
})("position:relative;@media screen and (min-width: ", (0, $3JZ8k.dialogPageTakeoverWidth) + 1, "px){", (props)=>props.shouldFillContainer ? 'width: 100%;' : 'min-width: 200px;', ";}", (props)=>props.shouldFillContainer ? 'max-width: 780px;' : '', " width:", (0, $3JZ8k.inputFieldHeight).px, ";height:", (0, $3JZ8k.inputFieldHeight).px, ";");
const $0b21a022edbcff7e$export$5566658d36f6ca7b = /*#__PURE__*/ (0, $bWGt6.default)($0b21a022edbcff7e$export$dfece74a62f1398d, {
    target: "exl9bxq0"
})("height:", (props)=>props.isExpanded ? (0, $3JZ8k.enlargedInputFieldHeight).px : (0, $3JZ8k.inputFieldHeight).px, ";");

});

parcelRegister("6I8Kl", function(module, exports) {

$parcel$export(module.exports, "SearchIcon", () => $4439160c76b81f6f$export$82eafebb825fc23f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $26g7Y = parcelRequire("26g7Y");

const $4439160c76b81f6f$export$82eafebb825fc23f = ({ isExpanded: isExpanded, theme: theme, size: size = 'small', primaryColor: primaryColor = `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`, label: label = '' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y))), {
        label: label,
        LEGACY_primaryColor: isExpanded ? primaryColor : theme.default.color,
        LEGACY_size: size,
        // NOTE: color do not accept string type but here primaryColor is string, so need to use any
        color: isExpanded ? primaryColor : theme.default.color
    });

});

parcelRegister("j1SOM", function(module, exports) {

$parcel$export(module.exports, "getInputSkeletonQuery", () => $a306a1ec994c7560$export$b8b6c2e7a0664212);
$parcel$export(module.exports, "setInputSkeletonQuery", () => $a306a1ec994c7560$export$baa1c819dd4691f3);
$parcel$export(module.exports, "getInputSkeletonFocus", () => $a306a1ec994c7560$export$38fcbc98be180790);
$parcel$export(module.exports, "setInputSkeletonIsFocus", () => $a306a1ec994c7560$export$d3c6894b4e9af000);
$parcel$export(module.exports, "getInputSkeletonSelection", () => $a306a1ec994c7560$export$a0c71b3bd9ec143c);
$parcel$export(module.exports, "setInputSkeletonSelection", () => $a306a1ec994c7560$export$e0d745255b135363);
$parcel$export(module.exports, "resetInputSkeletonState", () => $a306a1ec994c7560$export$c89dd2d5d4024c5e);
$parcel$export(module.exports, "removeInputSkeletonEventListeners", () => $a306a1ec994c7560$export$166ce39761ad7743);
$parcel$export(module.exports, "removeInputSkeletonState", () => $a306a1ec994c7560$export$c830bcf42e072a93);
const $a306a1ec994c7560$export$b8b6c2e7a0664212 = ()=>{
    return window?.inputSkeletonState?.query || '';
};
const $a306a1ec994c7560$export$baa1c819dd4691f3 = (newQuery)=>{
    if (window?.inputSkeletonState) window.inputSkeletonState.query = newQuery;
};
const $a306a1ec994c7560$export$38fcbc98be180790 = ()=>{
    return window?.inputSkeletonState?.isFocused || false;
};
const $a306a1ec994c7560$export$d3c6894b4e9af000 = (newIsFocused)=>{
    if (window?.inputSkeletonState) window.inputSkeletonState.isFocused = newIsFocused;
};
const $a306a1ec994c7560$export$a0c71b3bd9ec143c = ()=>{
    const selectionStart = window?.inputSkeletonState?.selectionStart || 0;
    const selectionEnd = window?.inputSkeletonState?.selectionEnd || 0;
    const selectionDirection = window?.inputSkeletonState?.selectionDirection || 'none';
    return {
        selectionStart: selectionStart,
        selectionEnd: selectionEnd,
        selectionDirection: selectionDirection
    };
};
const $a306a1ec994c7560$export$e0d745255b135363 = (newSelectionStart, newSelectionEnd, newSelectionDirection)=>{
    if (window?.inputSkeletonState) {
        window.inputSkeletonState.selectionStart = newSelectionStart;
        window.inputSkeletonState.selectionEnd = newSelectionEnd;
        window.inputSkeletonState.selectionDirection = newSelectionDirection;
    }
};
const $a306a1ec994c7560$export$c89dd2d5d4024c5e = ()=>{
    window.inputSkeletonState = {
        query: '',
        placeholder: '',
        isFocused: false,
        selectionStart: 0,
        selectionEnd: 0,
        selectionDirection: 'none',
        listeners: []
    };
};
const $a306a1ec994c7560$export$166ce39761ad7743 = ()=>{
    if (window.inputSkeletonState) {
        window.inputSkeletonState.listeners.forEach((ssrEventListener)=>{
            const [target, event, handler] = ssrEventListener;
            target.removeEventListener(event, handler);
        });
        window.inputSkeletonState.listeners = [];
    }
};
const $a306a1ec994c7560$export$c830bcf42e072a93 = ()=>{
    if (window['inputSkeletonState']) {
        $a306a1ec994c7560$export$166ce39761ad7743();
        delete window['inputSkeletonState'];
    }
};

});

parcelRegister("8I7W7", function(module, exports) {

$parcel$export(module.exports, "SSRsearchInput", () => SSRsearchInput);
/* eslint-disable import/extensions */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $b9NEf = parcelRequire("b9NEf");


var $6I8Kl = parcelRequire("6I8Kl");
const SSRsearchInput = ({ advancedSearchUrl, placeholder, customScriptDataAttributes, theme, shouldFillContainer })=>{
    const scriptRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useLayoutEffect)(()=>{
        const current = scriptRef?.current;
        if (current) // eslint-disable-next-line
        eval(current.innerHTML);
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.SSRsearchInputWrapper), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            id: "ssr-search-input-popout-container",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.SSRformContainer), {
                id: "ssr-form-container",
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)("form", {
                    method: "get",
                    action: advancedSearchUrl,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $b9NEf.SSRsearchInputContainer), {
                            shouldFillContainer: shouldFillContainer,
                            id: "ssr-input-container",
                            role: "search",
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.SSRmobileSearchIconWrapper), {
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6I8Kl.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false,
                                        size: "medium"
                                    })
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.SSRdesktopSearchIconWrapper), {
                                    id: "ssr-search-icon-wrapper",
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6I8Kl.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.SSRsearchInputField), {
                                    id: "ssr-search-input",
                                    name: "text",
                                    placeholder: placeholder,
                                    autoComplete: "off",
                                    "aria-label": placeholder
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("script", {
                            "data-test-id": "ssr-scripts-init",
                            ref: scriptRef,
                            dangerouslySetInnerHTML: {
                                __html: (0, $9b06243a4405ae90$export$bc237d627614fc48)
                            },
                            ...customScriptDataAttributes
                        })
                    ]
                })
            })
        })
    });
};

});
/* eslint-disable */ // @ts-ignore
const $9b06243a4405ae90$export$bc237d627614fc48 = `(function(document,window){var _a;var getWeakRef=function(queryId){var element=document.getElementById(queryId);if(!element){return null}return new WeakRef(element)};var currentInput=getWeakRef("ssr-search-input");var container=getWeakRef("ssr-input-container");var topContainer=getWeakRef("ssr-search-input-popout-container");var iconWrapper=getWeakRef("ssr-search-icon-wrapper");var formContainer=getWeakRef("ssr-form-container");var pageWidth=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;if(window["inputSkeletonState"]){for(var _i=0,_b=window["inputSkeletonState"].listeners;_i<_b.length;_i++){var listener=_b[_i];var target=listener[0],event_1=listener[1],handler=listener[2];target.removeEventListener(event_1,handler)}window["inputSkeletonState"].listeners=[]}function setExpandedStyles(){var _a,_b,_c,_d,_e,_f;(_a=iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.deref())===null||_a===void 0?void 0:_a.setAttribute("style","color: rgb(9, 30, 66);");if(pageWidth<=1130){(_b=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_b===void 0?void 0:_b.setAttribute("style","position: absolute;right: 0px;z-index: 300;");(_c=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_c===void 0?void 0:_c.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");(_d=container===null||container===void 0?void 0:container.deref())===null||_d===void 0?void 0:_d.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}else{(_e=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_e===void 0?void 0:_e.setAttribute("style","position: absolute; right:0px; z-index:300;");(_f=container===null||container===void 0?void 0:container.deref())===null||_f===void 0?void 0:_f.setAttribute("style","width: 780px;")}}function resetInputSkeleton(){window["inputSkeletonState"]={query:"",placeholder:"",isFocused:false,selectionStart:0,selectionEnd:0,selectionDirection:"none",listeners:[]}}if(window["inputSkeletonState"]){var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(window.inputSkeletonState.isFocused&&inputRef){inputRef.value=window.inputSkeletonState.query;inputRef.placeholder=window.inputSkeletonState.placeholder;inputRef.focus();inputRef.setSelectionRange(window.inputSkeletonState.selectionStart,window.inputSkeletonState.selectionEnd,window.inputSkeletonState.selectionDirection);setExpandedStyles()}}else{resetInputSkeleton()}var queryValue=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!queryValue){var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){inputRef.value=queryValue}}var mediaQuery=window.matchMedia("(max-width: 1130px)");function handleSmallScreen(){var _a,_b,_c;if(window["inputSkeletonState"]){if(window.inputSkeletonState.isFocused){(_a=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_a===void 0?void 0:_a.setAttribute("style","position: absolute;right: 0px;z-index: 300;");(_b=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_b===void 0?void 0:_b.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");(_c=container===null||container===void 0?void 0:container.deref())===null||_c===void 0?void 0:_c.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}}}(_a=mediaQuery===null||mediaQuery===void 0?void 0:mediaQuery.addEventListener)===null||_a===void 0?void 0:_a.call(mediaQuery,"change",function(){return handleSmallScreen()});function changeHandler(e){var input=e.target;if(window.inputSkeletonState){window.inputSkeletonState.query=input===null||input===void 0?void 0:input.value;if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"){window.sessionStorage.setItem("atlassian.search-dialog-query",input.value)}var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){window.inputSkeletonState.selectionStart=inputRef.selectionStart||0;window.inputSkeletonState.selectionEnd=inputRef.selectionEnd||0;window.inputSkeletonState.selectionDirection=inputRef.selectionDirection||"none"}}}function focusHandler(e){if(window.inputSkeletonState){window.inputSkeletonState.isFocused=true;var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){window.inputSkeletonState.placeholder=inputRef.placeholder}}setExpandedStyles()}function blurClickHandler(e){var _a,_b,_c,_d,_e;var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(!inputRef){return}if(currentInput&&e.target===inputRef&&window.inputSkeletonState){window.inputSkeletonState.selectionStart=inputRef.selectionStart||0;window.inputSkeletonState.selectionEnd=inputRef.selectionEnd||0;window.inputSkeletonState.selectionDirection=inputRef.selectionDirection||"none";if(!((_a=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_a===void 0?void 0:_a.hasAttribute("style"))){window.inputSkeletonState.isFocused=true;setExpandedStyles()}}if(currentInput&&e.target!==inputRef){resetInputSkeleton();var sessionQuery=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!sessionQuery){inputRef.value=sessionQuery}else{inputRef.value=""}(_b=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_b===void 0?void 0:_b.removeAttribute("style");(_c=container===null||container===void 0?void 0:container.deref())===null||_c===void 0?void 0:_c.removeAttribute("style");(_d=iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.deref())===null||_d===void 0?void 0:_d.removeAttribute("style");inputRef.removeAttribute("style");(_e=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_e===void 0?void 0:_e.removeAttribute("style")}}function addListener(target,event,handler){var _a;target.addEventListener(event,handler);(_a=window===null||window===void 0?void 0:window.inputSkeletonState)===null||_a===void 0?void 0:_a.listeners.push([target,event,handler])}{var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){addListener(inputRef,"input",changeHandler);addListener(inputRef,"select",changeHandler);addListener(inputRef,"keydown",changeHandler);addListener(inputRef,"focus",focusHandler)}}addListener(document,"click",blurClickHandler)})(document,window);`;




parcelRegister("ghYvR", function(module, exports) {

$parcel$export(module.exports, "ProductSearchInputSkeletonInteractive", () => $3c18a1528422c7a4$export$e3798ad624b9f761);
/*
 * An interactive version of the search input skeleton which allows users to
 * type into the skeleton's input.  The state of the skeleton input is saved in
 * the browser's storage (specifically within window.inputSkeletonState).
 * On the first render of this component, this stored state is used as initial
 * an initial state. This behaviour allows one instance of this component
 * to be replaced by another and appear to seamlessly act as a single component.
 *
 * This component is intended to be used for client side rendering only.
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2VWh9 = parcelRequire("2VWh9");
var $2AbEM = parcelRequire("2AbEM");
const $3c18a1528422c7a4$export$e3798ad624b9f761 = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2AbEM.ThemeProvider), {
        partialSearchCSS: props.theme,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2VWh9.SearchInputSkeletonInteractive), {
            ...props
        })
    });
};

});
parcelRegister("2VWh9", function(module, exports) {

$parcel$export(module.exports, "SearchInputSkeletonInteractive", () => $8f3a15c2a2955cf8$export$fca483ab36e9fec9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9enEu = parcelRequire("9enEu");

var $3bWiA = parcelRequire("3bWiA");

var $3ZeOg = parcelRequire("3ZeOg");

var $j1SOM = parcelRequire("j1SOM");
const $8f3a15c2a2955cf8$export$fca483ab36e9fec9 = ({ placeholder: placeholder, stickySearchEnabled: stickySearchEnabled, onEnter: onEnter, shouldFillContainer: shouldFillContainer })=>{
    // Initialise stored inputSkeletonState if necessary
    const checkedForInputSkeletonState = (0, $5uXOq.useRef)(false);
    if (!checkedForInputSkeletonState.current) {
        if (!window.inputSkeletonState) (0, $j1SOM.resetInputSkeletonState)();
        checkedForInputSkeletonState.current = true;
    }
    const searchInputRef = (0, $5uXOq.useRef)(null);
    // Use the stored state as initial values for expansion and query
    const [isExpanded, setIsExpanded] = (0, $5uXOq.useState)((0, $j1SOM.getInputSkeletonFocus)());
    const [value, setValue] = (0, $5uXOq.useState)(()=>{
        const stickySearchQuery = (0, $3ZeOg.getSessionItem)((0, $3ZeOg.SEARCH_QUERY_KEY));
        return stickySearchEnabled && stickySearchQuery ? stickySearchQuery : (0, $j1SOM.getInputSkeletonQuery)();
    });
    // Use the stored state to focus and set selection
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $j1SOM.removeInputSkeletonEventListeners)();
        const isFoucsed = (0, $j1SOM.getInputSkeletonFocus)();
        const { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = (0, $j1SOM.getInputSkeletonSelection)();
        if (isFoucsed) {
            searchInputRef?.current?.focus();
            searchInputRef?.current?.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
        }
    }, []);
    const onFocus = ()=>{
        setIsExpanded(true);
        (0, $j1SOM.setInputSkeletonIsFocus)(true);
        searchInputRef?.current?.focus();
    };
    const onBlur = ()=>{
        setIsExpanded(false);
        (0, $j1SOM.setInputSkeletonIsFocus)(false);
        if (!stickySearchEnabled) {
            setValue('');
            (0, $j1SOM.setInputSkeletonQuery)('');
            (0, $j1SOM.setInputSkeletonSelection)(0, 0, 'none');
        }
    };
    const onKeyDown = (e)=>{
        if (e.key === 'Escape') {
            searchInputRef?.current?.blur();
            onBlur();
        }
    };
    const onInput = (newValue)=>{
        setValue(newValue);
        (0, $j1SOM.setInputSkeletonQuery)(newValue);
        (0, $j1SOM.setInputSkeletonSelection)(searchInputRef?.current?.selectionStart || 0, searchInputRef?.current?.selectionEnd || 0, searchInputRef?.current?.selectionDirection || 'none');
        if (stickySearchEnabled) (0, $3ZeOg.setSessionItem)((0, $3ZeOg.SEARCH_QUERY_KEY), newValue);
    };
    const onSelect = ()=>{
        (0, $j1SOM.setInputSkeletonSelection)(searchInputRef?.current?.selectionStart || 0, searchInputRef?.current?.selectionEnd || 0, searchInputRef?.current?.selectionDirection || 'none');
    };
    // Fixes some instances where callbacks would not be called when the search
    // input is clicked as the component is being destroyed
    (0, $5uXOq.useEffect)(()=>{
        let storedSearchInputRef = null;
        if (searchInputRef.current) storedSearchInputRef = searchInputRef.current;
        return ()=>{
            if (storedSearchInputRef) {
                (0, $j1SOM.setInputSkeletonQuery)(storedSearchInputRef.value);
                (0, $j1SOM.setInputSkeletonIsFocus)(document.activeElement === storedSearchInputRef);
                (0, $j1SOM.setInputSkeletonSelection)(storedSearchInputRef.selectionStart || 0, storedSearchInputRef.selectionEnd || 0, storedSearchInputRef.selectionDirection || 'none');
            }
        };
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9enEu.SearchAnchor), {
        isExpanded: isExpanded,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bWiA.default), {
            "data-test-id": "search-dialog-input-skeleton-interactive",
            isExpanded: isExpanded,
            placeholder: placeholder,
            onInput: onInput,
            onSelect: onSelect,
            onEnter: onEnter,
            shouldFillContainer: shouldFillContainer,
            value: value,
            ref: searchInputRef
        })
    });
};

});
parcelRegister("9enEu", function(module, exports) {

$parcel$export(module.exports, "SearchAnchor", () => $ca26fcb83502085a$export$bc951697710bb35a);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hLeR9 = parcelRequire("hLeR9");
const $ca26fcb83502085a$export$bc951697710bb35a = ({ children: children, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, isExpanded: isExpanded, shouldFillContainer: shouldFillContainer })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $hLeR9.SearchAnchorWrapper), {
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hLeR9.AbsoluteContainer), {
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hLeR9.SearchDialogAnchor), {
                onBlur: onBlur,
                onFocus: onFocus,
                onKeyDown: onKeyDown,
                isExpanded: isExpanded,
                shouldFillContainer: shouldFillContainer,
                children: children
            })
        })
    });

});

parcelRegister("3bWiA", function(module, exports) {

$parcel$export(module.exports, "default", () => $11a67e855bc3630f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $bu8Mq = parcelRequire("bu8Mq");

var $42CjB = parcelRequire("42CjB");

var $2AbEM = parcelRequire("2AbEM");

var $6I8Kl = parcelRequire("6I8Kl");

var $b9NEf = parcelRequire("b9NEf");

var $lWgWi = parcelRequire("lWgWi");
const $11a67e855bc3630f$var$MAX_INPUT_LENGTH = 500;
const $11a67e855bc3630f$export$55d7609a8f1eccd2 = ({ onInput: onInput, onClick: onClick, onEnter: onEnter, isExpanded: isExpanded, placeholder: placeholder, forwardRef: forwardRef, value: value, theme: theme, tooltipContent: tooltipContent, onBack: onBack, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, exitSearchLabel: exitSearchLabel, clearSearchLabel: clearSearchLabel, onSelect: onSelect, toggleAISearchButton: toggleAISearchButton, shouldFillContainer: shouldFillContainer })=>{
    const handleInput = (e)=>{
        if (onInput) onInput(e.currentTarget.value);
    };
    const handleClick = (e)=>{
        if (onClick) onClick(e);
    };
    const handleTabEnter = (e)=>{
        if (e.key === 'Enter' && onClick) onClick();
    };
    const handleKeyDown = (e)=>{
        if (e.nativeEvent?.isComposing || e.keyCode === 229) return;
        if (!e.defaultPrevented && e.key === 'Enter') {
            e.preventDefault();
            onEnter && onEnter(e);
        }
    };
    const handleSelect = (e)=>{
        if (onSelect) onSelect(e);
    };
    const TooltipComponent = tooltipContent && !isExpanded ? undefined : (0, $b9NEf.HiddenTooltip);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        // NOTE: Types in React 18 have changed, `styled(TooltipPrimitive)` is no longer valid
        component: TooltipComponent,
        position: "bottom",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $b9NEf.SearchInputContainer), {
            ...theme,
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            role: "search",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.MobileSearchIconWrapper), {
                    isExpanded: isExpanded,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                        label: "Search",
                        onClick: handleClick,
                        icon: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6I8Kl.SearchIcon), {
                                theme: theme,
                                isExpanded: isExpanded,
                                size: "medium"
                            })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.DesktopSearchIconWrapper), {
                    ...theme,
                    isExpanded: isExpanded,
                    onKeyPress: handleTabEnter,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6I8Kl.SearchIcon), {
                        theme: theme,
                        isExpanded: isExpanded
                    })
                }),
                isExpanded && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.ArrowIconWrapper), {
                    ...theme,
                    onClick: onBack,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bu8Mq))), {
                        label: exitSearchLabel || 'Exit Search',
                        LEGACY_size: "large",
                        color: "currentColor"
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.SearchInputField), {
                    "data-test-id": "search-dialog-input",
                    onInput: handleInput,
                    onChange: handleInput,
                    onKeyDown: handleKeyDown,
                    onClick: handleClick,
                    onSelect: handleSelect,
                    isExpanded: isExpanded,
                    placeholder: placeholder,
                    ref: forwardRef || undefined,
                    value: value,
                    maxLength: $11a67e855bc3630f$var$MAX_INPUT_LENGTH,
                    "aria-label": placeholder,
                    ...theme
                }),
                (showClearButton || !!toggleAISearchButton) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lWgWi.SearchInputOverlay), {
                    theme: theme,
                    showClearButton: showClearButton,
                    onClear: onClear,
                    allowChangeExpand: allowChangeExpand,
                    clearSearchLabel: clearSearchLabel,
                    toggleAISearchButton: toggleAISearchButton
                })
            ]
        })
    });
};
var $11a67e855bc3630f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const theme = (0, $2AbEM.useTheme)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($11a67e855bc3630f$export$55d7609a8f1eccd2, {
        ...props,
        theme: theme,
        forwardRef: ref
    });
});

});
parcelRegister("lWgWi", function(module, exports) {

$parcel$export(module.exports, "SearchInputOverlay", () => $55ed4baddf3d1eb5$export$bde709da22d710bb);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $b9NEf = parcelRequire("b9NEf");

var $ip0rq = parcelRequire("ip0rq");
const $55ed4baddf3d1eb5$export$bde709da22d710bb = ({ theme: theme, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, clearSearchLabel: clearSearchLabel, toggleAISearchButton: toggleAISearchButton })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $b9NEf.InputBoxOverlayRight), {
        children: [
            showClearButton && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b9NEf.ClearIconWrapper), {
                ...theme,
                role: "button",
                onClick: onClear,
                onMouseEnter: ()=>{
                    allowChangeExpand?.(false);
                },
                onMouseLeave: ()=>{
                    allowChangeExpand?.(true);
                },
                tabIndex: 0,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ip0rq))), {
                    color: "currentColor",
                    label: clearSearchLabel || 'Clear search session',
                    LEGACY_size: "small"
                })
            }),
            toggleAISearchButton
        ]
    });
};

});


parcelRegister("3ZeOg", function(module, exports) {

$parcel$export(module.exports, "SEARCH_QUERY_KEY", () => $ec26c0406ff6caf4$export$240cb7dc75f6cac2);
$parcel$export(module.exports, "SEARCH_FILTERS_KEY", () => $ec26c0406ff6caf4$export$978fb20afa14aaa7);
$parcel$export(module.exports, "SEARCH_SHOW_AI_DIALOG_KEY", () => $ec26c0406ff6caf4$export$f4dca218ecb5824a);
$parcel$export(module.exports, "getSessionItem", () => $ec26c0406ff6caf4$export$fdf7104ff19cc288);
$parcel$export(module.exports, "setSessionItem", () => $ec26c0406ff6caf4$export$a5376dd4adeb0fbf);
$parcel$export(module.exports, "deleteSessionItem", () => $ec26c0406ff6caf4$export$5896963da935fdc4);
const $ec26c0406ff6caf4$export$9d075e4b938a80be = 'atlassian.search-dialog-sticky';
const $ec26c0406ff6caf4$export$240cb7dc75f6cac2 = 'atlassian.search-dialog-query';
const $ec26c0406ff6caf4$export$978fb20afa14aaa7 = 'atlassian.search-dialog-filters';
const $ec26c0406ff6caf4$export$f4dca218ecb5824a = 'atlassian.search-dialog.ai-dialog';
const $ec26c0406ff6caf4$export$fdf7104ff19cc288 = (key)=>{
    return window.sessionStorage.getItem(key);
};
const $ec26c0406ff6caf4$export$a5376dd4adeb0fbf = (key, value)=>{
    try {
        window.sessionStorage.setItem(key, value);
    } catch (error) {
        error.code, DOMException.QUOTA_EXCEEDED_ERR;
    }
};
const $ec26c0406ff6caf4$export$5896963da935fdc4 = (key)=>{
    window.sessionStorage.removeItem(key);
};

});



parcelRegister("4eq41", function(module, exports) {

$parcel$export(module.exports, "AI_MATE_ATTRIBUTES", () => $3d29cfe9cceaa0f2$export$8cffc8b2c93affd4);
/**
 * NOTE: Some of these fields are used to track AI MAU
 * See this page for more details: https://hello.atlassian.net/wiki/spaces/AAI/pages/3770721410/Unified+event+Instrumentation+for+AI
 */ const $3d29cfe9cceaa0f2$export$8cffc8b2c93affd4 = {
    agentCreatorType: 'agentCreatorType',
    agentId: 'agentId',
    agentVisibility: 'agentVisibility',
    agentExternalConfigReference: 'agentExternalConfigReference',
    agentActions: 'agentActions',
    agentIsDefault: 'agentIsDefault',
    conversationChannelId: 'conversationChannelId',
    experienceId: 'experienceId',
    fullScreen: 'fullScreen',
    product: 'product',
    productHeader: 'productHeader',
    singleInstrumentationID: 'singleInstrumentationID'
};

});

parcelRegister("jSnf2", function(module, exports) {

$parcel$export(module.exports, "useAnalytics", () => $dfca0822997e10b2$export$e955abb82869dc84);

var $5uXOq = parcelRequire("5uXOq");

var $1SrMX = parcelRequire("1SrMX");
var $2NMNM = parcelRequire("2NMNM");

var $aFWqW = parcelRequire("aFWqW");

var $4eq41 = parcelRequire("4eq41");

var $VdqAi = parcelRequire("VdqAi");

var $eZRED = parcelRequire("eZRED");
const $dfca0822997e10b2$var$isTownSquareEvent = ()=>[
        'home.atlassian.com',
        'team.atlassian.com'
    ].some((host)=>window.location?.host.includes(host));
const $dfca0822997e10b2$var$DEFAULT_TAGS = [
    'atlaskit',
    'aiMate'
];
const $dfca0822997e10b2$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { propertiesRef: propertiesRef } = (0, $aFWqW.useAnalyticsPropertiesContext)();
    // TODO: Improve this functionality, potentially with a higher order provider for tags or similar
    // This is a temporary solution to add the 'townsquare' tag to operational events so Experience Tracker works in Atlas
    const maybeAtlasOperationalTags = (0, $5uXOq.useCallback)((inputPayload)=>{
        const payload = inputPayload instanceof (0, $1SrMX.default) ? inputPayload.payload : inputPayload;
        if (payload.actionSubject === 'ui' && payload.eventType === 'operational' && $dfca0822997e10b2$var$isTownSquareEvent()) return [
            'townsquare'
        ];
        return [];
    }, []);
    const getDefaultAttributes = (0, $5uXOq.useCallback)(()=>{
        const { agentCreatorType: agentCreatorType, agentId: agentId, agentVisibility: agentVisibility, agentExternalConfigReference: agentExternalConfigReference, agentActions: agentActions, agentIsDefault: agentIsDefault, conversationChannelId: conversationChannelId, experienceId: experienceId, fullScreen: fullScreen, product: product, productHeader: productHeader } = propertiesRef.current;
        return {
            [(0, $4eq41.AI_MATE_ATTRIBUTES).agentCreatorType]: agentCreatorType,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).agentId]: agentId,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).agentVisibility]: agentVisibility,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).conversationChannelId]: conversationChannelId,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).experienceId]: experienceId,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).fullScreen]: fullScreen,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).product]: product,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).productHeader]: productHeader,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).singleInstrumentationID]: conversationChannelId,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).agentExternalConfigReference]: agentExternalConfigReference,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).agentActions]: agentActions,
            [(0, $4eq41.AI_MATE_ATTRIBUTES).agentIsDefault]: agentIsDefault
        };
    }, [
        propertiesRef
    ]);
    const trackAIMAUEvent = (0, $5uXOq.useCallback)((payload)=>{
        // Handle tags
        const tags = [
            ...$dfca0822997e10b2$var$DEFAULT_TAGS
        ];
        if ($dfca0822997e10b2$var$isTownSquareEvent()) tags.push('townsquare');
        const { source: source, subjectId: subjectId, proactive: proactive, userGenerated: userGenerated, messageId: messageId, messageActions: messageActions, singleInstrumentationID: singleInstrumentationID, timestamp: timestamp, citedProductList: citedProductList, citedProduct: citedProduct, sourceProducts: sourceProducts, sourceProduct: sourceProduct, invokedPlugins: invokedPlugins } = payload;
        let attributes = {
            ...getDefaultAttributes(),
            isAIFeature: 1,
            proactiveAIGenerated: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0,
            aiFeatureName: 'aiChat',
            citedProductList: citedProductList,
            citedProduct: citedProduct,
            sourceProducts: sourceProducts,
            sourceProduct: sourceProduct
        };
        if (messageId) attributes.messageId = messageId;
        if (messageActions) attributes.messageActions = messageActions;
        if (timestamp) attributes.timestamp = timestamp;
        if (singleInstrumentationID) attributes.singleInstrumentationID = singleInstrumentationID;
        if (invokedPlugins) attributes.invokedPlugins = invokedPlugins;
        // Core AI MAU payload
        let eventPayload = {
            eventType: 'track',
            tags: tags,
            source: source,
            actionSubjectId: subjectId,
            attributes: attributes
        };
        // Handle specific AI MAU events
        switch(payload.type){
            case 'initiated':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiInteraction',
                    action: 'initiated'
                };
                break;
            case 'viewed':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiResult',
                    action: 'viewed'
                };
                break;
            case 'error':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiResult',
                    action: 'error'
                };
                break;
            case 'dismissed':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiInteraction',
                    action: 'dismissed'
                };
                break;
            case 'actioned':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiResult',
                    action: 'actioned',
                    attributes: {
                        ...eventPayload.attributes,
                        aiResultAction: payload.actionResult
                    }
                };
                break;
            case 'feedback':
                eventPayload = {
                    ...eventPayload,
                    actionSubject: 'aiFeedback',
                    action: 'submitted',
                    attributes: {
                        ...eventPayload.attributes,
                        aiFeedbackResult: payload.feedbackResult
                    }
                };
                break;
        }
        // Build event and apply context attributes
        const event = createAnalyticsEvent(eventPayload);
        const aiMateContextAttributes = (0, $eZRED.getAttributesFromContexts)(event.context);
        // Fire
        event.update({
            attributes: {
                ...event.payload.attributes,
                ...aiMateContextAttributes
            }
        }).fire((0, $VdqAi.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        getDefaultAttributes
    ]);
    const sendAnalyticsEvent = (0, $5uXOq.useCallback)((payload, options)=>{
        const extraTags = options?.removeDefaultTags ? [] : $dfca0822997e10b2$var$DEFAULT_TAGS;
        const allTags = Array.from(new Set([
            ...extraTags,
            ...payload.tags || [],
            ...maybeAtlasOperationalTags(payload)
        ]));
        const defaultAttributes = getDefaultAttributes();
        if (payload instanceof (0, $1SrMX.default)) {
            const aiMateContextAttributes = (0, $eZRED.getAttributesFromContexts)(payload.context);
            payload.update({
                ...payload.payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $VdqAi.ANALYTICS_CHANNEL));
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.attributes
                }
            });
            const aiMateContextAttributes = (0, $eZRED.getAttributesFromContexts)(event.context);
            event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $VdqAi.ANALYTICS_CHANNEL));
        }
    }, [
        createAnalyticsEvent,
        maybeAtlasOperationalTags,
        getDefaultAttributes
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent
    };
};

});
parcelRegister("aFWqW", function(module, exports) {

$parcel$export(module.exports, "AnalyticsContextWithSourceAndProperties", () => $ff5d4fd37d27263a$export$a00cd3c213413389);
$parcel$export(module.exports, "useAnalyticsPropertiesContext", () => $ff5d4fd37d27263a$export$ab8aa3dfd687f012);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");
const $ff5d4fd37d27263a$var$initialState = {
    conversationChannelId: '',
    experienceId: '',
    product: '',
    productHeader: '',
    agentId: null,
    agentExternalConfigReference: null,
    agentActions: [],
    agentIsDefault: null,
    fullScreen: false,
    agentCreatorType: '',
    agentVisibility: '',
    singleInstrumentationID: ''
};
const $ff5d4fd37d27263a$var$AnalyticsPropertiesContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    propertiesRef: {
        current: {
            ...$ff5d4fd37d27263a$var$initialState
        }
    },
    setAnalyticsPropertiesWithoutRerender: ()=>{}
});
const $ff5d4fd37d27263a$export$1aefd27d2ed3c1c9 = ({ children: children })=>{
    const propertiesRef = (0, $5uXOq.useRef)({
        ...$ff5d4fd37d27263a$var$initialState
    });
    const setAnalyticsPropertiesWithoutRerender = (0, $5uXOq.useCallback)((properties)=>{
        propertiesRef.current = {
            ...propertiesRef.current,
            ...properties
        };
    }, []);
    const value = (0, $5uXOq.useMemo)(()=>({
            propertiesRef: propertiesRef,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        }), [
        setAnalyticsPropertiesWithoutRerender
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ff5d4fd37d27263a$var$AnalyticsPropertiesContext.Provider, {
        value: value,
        children: children
    });
};
const $ff5d4fd37d27263a$export$a00cd3c213413389 = ({ source: source, children: children })=>{
    const data = (0, $5uXOq.useMemo)(()=>({
            source: source
        }), [
        source
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: data,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($ff5d4fd37d27263a$export$1aefd27d2ed3c1c9, {
            children: children
        })
    });
};
const $ff5d4fd37d27263a$export$ab8aa3dfd687f012 = ()=>{
    return (0, $5uXOq.useContext)($ff5d4fd37d27263a$var$AnalyticsPropertiesContext);
};

});

parcelRegister("VdqAi", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $0a756ecf0a3a3690$export$85183a312807388d);

var $e8KHW = parcelRequire("e8KHW");
const $0a756ecf0a3a3690$export$85183a312807388d = (0, $e8KHW.FabricChannel).aiMate;

});

parcelRegister("eZRED", function(module, exports) {

$parcel$export(module.exports, "getAttributesFromContexts", () => $177e3d94a217ad2a$export$d97c97ed77ff09e8);

var $1PVpv = parcelRequire("1PVpv");
const $177e3d94a217ad2a$var$isSourceAndAttributes = (x)=>{
    if (typeof x !== 'object' || x === null) return false;
    if (!('source' in x) || !('attributes' in x) || typeof x.attributes !== 'object' || x.attributes === null) return false;
    return true;
};
const $177e3d94a217ad2a$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    let aiMateOnly = context.filter((x)=>$177e3d94a217ad2a$var$isSourceAndAttributes(x) && x.source === 'AIMate' || x[0, $1PVpv.AI_MATE_CONTEXT]);
    return aiMateOnly.reduce((acc, x)=>{
        return {
            ...acc,
            ...x[0, $1PVpv.AI_MATE_CONTEXT]?.attributes ?? {},
            ...x.attributes ?? {}
        };
    }, {});
};

});


parcelRegister("5i4cN", function(module, exports) {

$parcel$export(module.exports, "ChatOpenerSubscriber", () => $f445f44794d90802$export$6fa95a645837361b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9oBwb = parcelRequire("9oBwb");
var $7Z8dX = parcelRequire("7Z8dX");
var $hjiMw = parcelRequire("hjiMw");

var $jSnf2 = parcelRequire("jSnf2");
// TODO: Deprecated; teams integrating this event should opt-out of chat open using `openChat` on the core event payload
// Once all teams have opted out the ignoredEvents logic can be removed
const $f445f44794d90802$var$ignoredEvents = new Set([
    'editor-context-payload',
    'browser-context-payload',
    'agent-changed'
]);
const $f445f44794d90802$var$eventsToSkipAnalytics = new Set([
    // This event is fired way too often https://atlassian.slack.com/archives/C06PKQPN8BF/p1729569226011399
    'editor-context-payload',
    'agent-changed'
]);
const $f445f44794d90802$export$6fa95a645837361b = ({ onTriggerOpeningChat: onTriggerOpeningChat })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jSnf2.useAnalytics)();
    const [triggerOpen, setTriggerOpen] = (0, $5uXOq.useState)(!!(0, $9oBwb.getRovoParams)()?.triggerOpen);
    // Trigger open rovo sidebar if not already open via URL param
    (0, $5uXOq.useEffect)(()=>{
        try {
            if (!triggerOpen) return;
            onTriggerOpeningChat();
            setTriggerOpen(false);
        } catch (error) {
        // Fail silently
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerOpen
    ]);
    (0, $hjiMw.useSubscribeAll)((payload)=>{
        const { type: type, source: source, openChat: openChat = true } = payload;
        const preventOpen = !openChat || $f445f44794d90802$var$ignoredEvents.has(type);
        if (!$f445f44794d90802$var$eventsToSkipAnalytics.has(type)) sendAnalyticsEvent({
            action: 'eventReceived',
            actionSubject: 'aiMatePubSubEvent',
            source: source,
            attributes: {
                publisherSource: source,
                payloadType: type,
                eventTriggersChatOpen: !preventOpen
            }
        });
        if (preventOpen) return;
        onTriggerOpeningChat();
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Z8dX.RovoPostMessagePubsubListener), {})
    });
};

});
parcelRegister("9oBwb", function(module, exports) {

$parcel$export(module.exports, "getRovoParams", () => $527b3a92d6af9e9e$export$6405071f390601f7);
$parcel$export(module.exports, "addRovoParamsToUrl", () => $527b3a92d6af9e9e$export$ef04687636c850fe);
$parcel$export(module.exports, "encodeRovoParams", () => $527b3a92d6af9e9e$export$eddc20a009406015);

var $hhCQV = parcelRequire("hhCQV");
const $527b3a92d6af9e9e$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $527b3a92d6af9e9e$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $527b3a92d6af9e9e$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch (error) {
        return false;
    }
};
const $527b3a92d6af9e9e$export$9748efee331ec573 = (param)=>`${0, $hhCQV.ROVO_PARAM_PREFIX}${$527b3a92d6af9e9e$export$fda91e425d265029(param)}`;
const $527b3a92d6af9e9e$export$f2888183a34644d4 = (param)=>{
    return $527b3a92d6af9e9e$export$858653b7ee3cbb17(param.replace((0, $hhCQV.ROVO_PARAM_PREFIX), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $527b3a92d6af9e9e$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $527b3a92d6af9e9e$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $hhCQV.ROVO_PARAM_PREFIX))) return;
        const paramKey = $527b3a92d6af9e9e$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $527b3a92d6af9e9e$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $527b3a92d6af9e9e$var$processParams(q).rovoParams;
    } catch (error) {
        return {};
    }
};
const $527b3a92d6af9e9e$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $527b3a92d6af9e9e$export$ef04687636c850fe(window.location.pathname, params));
};
const $527b3a92d6af9e9e$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $527b3a92d6af9e9e$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $527b3a92d6af9e9e$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $527b3a92d6af9e9e$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$527b3a92d6af9e9e$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).map(([key, value])=>{
        return `${$527b3a92d6af9e9e$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $527b3a92d6af9e9e$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $527b3a92d6af9e9e$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
	For products using react-resource-router (e.g Atlas) to
	pass as the value of `query` on the route definition. It ensures that our parameters
	are not stripped from the URL when loading the page, or through redirect hops
	Any new parameters we want to maintain should be added here as well, which means
	only a version bump is needed in those products to support the latest param list
	The !=false simply means that the parameter is supported but is optional, and should
	not contain a value of 'false'
	*/ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $hhCQV.ROVO_VALID_PARAMS).map((param)=>`${$527b3a92d6af9e9e$export$9748efee331ec573(param)}${suffix}`);
};

});
parcelRegister("hhCQV", function(module, exports) {

$parcel$export(module.exports, "ROVO_PARAM_PREFIX", () => $782eed6f93424f0d$export$5a550907ffbc9119);
$parcel$export(module.exports, "ROVO_VALID_PARAMS", () => $782eed6f93424f0d$export$3cd6b610e7ede579);
const $782eed6f93424f0d$export$5a550907ffbc9119 = 'rovoChat';
const $782eed6f93424f0d$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen',
    'insertPrompt'
];

});



parcelRegister("h4rOi", function(module, exports) {

$parcel$export(module.exports, "useRovoEntitlement", () => $15b18b9de1edfe29$export$66d5dd4be64dea43);
$parcel$export(module.exports, "useRovoEntitlementActions", () => $15b18b9de1edfe29$export$8004893135276275);
$parcel$export(module.exports, "RovoEntitlementSetter", () => $15b18b9de1edfe29$export$d03a05ad8547472c);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $15b18b9de1edfe29$var$rovoEntitlementStore = (0, $iXqE5.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $15b18b9de1edfe29$var$useStateHook = (0, $3sQ5x.createStateHook)($15b18b9de1edfe29$var$rovoEntitlementStore);
const $15b18b9de1edfe29$export$66d5dd4be64dea43 = ()=>{
    const result = $15b18b9de1edfe29$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $15b18b9de1edfe29$export$8004893135276275 = (0, $3sQ5x.createActionsHook)($15b18b9de1edfe29$var$rovoEntitlementStore);
const $15b18b9de1edfe29$export$d03a05ad8547472c = ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $15b18b9de1edfe29$export$8004893135276275();
    (0, $5uXOq.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};

});

parcelRegister("4QAPb", function(module, exports) {

$parcel$export(module.exports, "ChatContextSubscriber", () => $1af6b8e2e84b8435$export$29ff0802eb3bb217);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $hjiMw = parcelRequire("hjiMw");

var $1YYCC = parcelRequire("1YYCC");
const $1af6b8e2e84b8435$export$29ff0802eb3bb217 = ()=>{
    const { setEditorContext: setEditorContext, setBrowserContext: setBrowserContext, setJiraWorkflowContext: setJiraWorkflowContext, setDashboardContext: setDashboardContext, setAIFeatureContext: setAIFeatureContext } = (0, $1YYCC.useChatContextStoreActions)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hjiMw.Subscriber), {
        topic: "ai-mate",
        onEvent: async (payload)=>{
            // TODO https://product-fabric.atlassian.net/browse/AIM-1989 implement experience tracker
            try {
                switch(payload.type){
                    case 'editor-context-payload':
                        setEditorContext(payload.data);
                        break;
                    case 'browser-context-payload':
                        setBrowserContext(payload.data);
                        break;
                    case 'dashboard-insights-actions':
                        (0, $VSDnB.fg)('platform_avp_enable_dashboard_context_event_pubsub') && setDashboardContext(payload.data);
                        break;
                    case 'jira-workflow-wizard-actions':
                        (0, $VSDnB.fg)('enable_jira_workflow_wizard_agent_in_wf_editor') && setJiraWorkflowContext(payload.data);
                        break;
                    case 'set-message-context':
                        if ((0, $VSDnB.fg)('integrate_aiwb_to_rovo_chat')) setAIFeatureContext(payload.data);
                        break;
                    default:
                }
            } catch (error) {}
        }
    });
};

});
parcelRegister("1YYCC", function(module, exports) {

$parcel$export(module.exports, "useChatContextStoreActions", () => $ae2e3376a10d914c$export$53bf948a400e8426);
$parcel$export(module.exports, "useChatContextEditorContext", () => $ae2e3376a10d914c$export$9465f65715425f1b);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $ae2e3376a10d914c$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    initialState: {
        editorContext: undefined,
        browserContext: undefined,
        dashboardContext: undefined,
        jiraWorkflowContext: undefined,
        aiFeatureContext: {}
    },
    actions: {
        getAllContext: ()=>({ getState: getState })=>getState(),
        getAIFeatureContext: ()=>({ getState: getState })=>{
                const currentState = getState().aiFeatureContext;
                // Delete all properties that are undefined
                Object.keys(currentState).forEach((key)=>currentState[key] === undefined && delete currentState[key]);
                // Avoid sending an empty object
                return Object.keys(currentState).length ? currentState : undefined;
            },
        setAIFeatureContext: (chatContextData)=>({ getState: getState, setState: setState })=>{
                const currentAIFeatureContextState = getState().aiFeatureContext;
                const { contextKey: contextKey, setContext: setContext } = chatContextData;
                if (contextKey) {
                    const contextUpdated = setContext(currentAIFeatureContextState[contextKey]);
                    setState({
                        aiFeatureContext: {
                            ...currentAIFeatureContextState,
                            [contextKey]: contextUpdated
                        }
                    });
                }
            },
        getDashboardContext: ()=>({ getState: getState })=>getState().dashboardContext,
        setDashboardContext: (dashboardContext)=>({ setState: setState })=>{
                setState({
                    dashboardContext: dashboardContext
                });
            },
        getJiraWorkflowContext: ()=>({ getState: getState })=>getState().jiraWorkflowContext,
        setJiraWorkflowContext: (jiraWorkflowContext)=>({ setState: setState })=>{
                setState({
                    jiraWorkflowContext: jiraWorkflowContext
                });
            },
        getEditorContext: ()=>({ getState: getState })=>getState().editorContext,
        setEditorContext: (editorContext)=>({ setState: setState })=>{
                setState({
                    editorContext: editorContext
                });
            },
        getBrowserContext: ()=>({ getState: getState })=>getState().browserContext,
        setBrowserContext: (browserContext)=>({ setState: setState })=>{
                setState({
                    browserContext: browserContext
                });
            }
    }
});
const $ae2e3376a10d914c$export$53bf948a400e8426 = (0, $3sQ5x.createActionsHook)($ae2e3376a10d914c$export$6f57813fe9f31bf9);
const $ae2e3376a10d914c$export$9465f65715425f1b = (0, $3sQ5x.createHook)($ae2e3376a10d914c$export$6f57813fe9f31bf9, {
    selector: (state)=>state.editorContext
});

});


parcelRegister("hlVrS", function(module, exports) {

$parcel$export(module.exports, "ConversationAssistantButton", () => $00f6bc802b15a660$export$7c328c0993982813);
$parcel$export(module.exports, "ConversationAssistantButtonNav4", () => $00f6bc802b15a660$export$25e85d244cbf7845);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");
var $kbqIt = parcelRequire("kbqIt");

var $koVbs = parcelRequire("koVbs");

var $gKZoD = parcelRequire("gKZoD");

var $711X2 = parcelRequire("711X2");

var $iEN9D = parcelRequire("iEN9D");

var $8uiXJ = parcelRequire("8uiXJ");

var $imZsD = parcelRequire("imZsD");
var $k6T4f = parcelRequire("k6T4f");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $jSnf2 = parcelRequire("jSnf2");

var $fsNoS = parcelRequire("fsNoS");
var $5KAqU = parcelRequire("5KAqU");
var $9p6hi = parcelRequire("9p6hi");

var $dMUIg = parcelRequire("dMUIg");

var $kQZfA = parcelRequire("kQZfA");

var $cccYj = parcelRequire("cccYj");
const $00f6bc802b15a660$var$defaultButtonStyles = {
    paddingInline: '8px'
};
const $00f6bc802b15a660$var$inactiveButtonStyles = {
    background: "var(--ds-background-neutral, #091E420F)"
};
const $00f6bc802b15a660$var$disabledButtonStyles = {
    background: "var(--ds-background-disabled, #091E4208)",
    color: "var(--ds-text-disabled, #091E424F)"
};
const $00f6bc802b15a660$var$getConversationAssistantButton = (Button = (0, $711X2.PrimaryButton))=>({ testId: testId, isActive: isActive, isDisabled: isDisabled = false, onClick: onClickProp, tooltipContent: tooltipContent, siteId: siteId, productKey: productKey })=>{
        (0, $gKZoD.di)((0, $kbqIt.useCoordination), (0, $9p6hi.useCoordinationClient), (0, $iEN9D.default));
        const { formatMessage: formatMessage } = (0, $koVbs.default)();
        const { start: start } = (0, $5KAqU.useConversationAssistantSpotlightActions)();
        const [shouldShowMessage, setShouldShowMessage] = (0, $5uXOq.useState)(false);
        const messageId = productKey === 'confluence' ? 'confluence_rovo_chat_agents_spotlight_ga' : productKey === 'jira' ? 'jira_rovo_chat_agents_spotlight_ga' : '';
        const shouldUseCoordination = !!messageId;
        const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jSnf2.useAnalytics)();
        const openRovoChat = (event, analyticsEvent)=>{
            if (!isActive && onClick) onClick(event, analyticsEvent);
        };
        const onClick = (0, $5uXOq.useCallback)((...params)=>{
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'rovoChatButton',
                attributes: {
                    isActive: isActive,
                    isDisabled: isDisabled,
                    productKey: productKey
                }
            });
            return onClickProp?.(...params);
        }, [
            isActive,
            isDisabled,
            onClickProp,
            productKey,
            sendAnalyticsEvent
        ]);
        const interactionName = isActive ? 'close-rovo-chat-nav-button' : 'open-rovo-chat-nav-button';
        const getChildren = ()=>{
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Button, {
                onMouseEnter: ()=>{
                    if (shouldShowMessage) {
                        sendAnalyticsEvent({
                            eventType: 'ui',
                            action: 'hovered',
                            actionSubject: 'rovoChatButtonSpotlight'
                        });
                        start();
                    }
                },
                testId: testId,
                isSelected: isActive,
                onClick: onClick,
                isDisabled: isDisabled,
                tooltip: tooltipContent ?? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                    children: (0, $VSDnB.fg)('rovo_chat_top_nav_button_label') ? formatMessage((0, $cccYj.messages).rovoChatButtonLabel) : formatMessage((0, $cccYj.messages).buttonLabel)
                }),
                style: {
                    /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ ...$00f6bc802b15a660$var$defaultButtonStyles,
                    ...!isActive && $00f6bc802b15a660$var$inactiveButtonStyles,
                    ...isDisabled && $00f6bc802b15a660$var$disabledButtonStyles
                },
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dMUIg.ChatIcon), {}),
                interactionName: interactionName,
                children: (0, $VSDnB.fg)('rovo_chat_top_nav_button_label') ? formatMessage((0, $cccYj.messages).rovoChatButtonLabel) : formatMessage((0, $cccYj.messages).buttonLabel)
            });
        };
        return shouldUseCoordination ? /*#__PURE__*/ (0, $2OMIu.jsx)($00f6bc802b15a660$export$de76c194bfb85689, {
            setShouldShowMessage: setShouldShowMessage,
            messageId: messageId,
            siteId: siteId,
            children: getChildren(),
            shouldShowMessage: shouldShowMessage,
            openRovoChat: openRovoChat
        }) : getChildren();
    };
const $00f6bc802b15a660$export$7c328c0993982813 = $00f6bc802b15a660$var$getConversationAssistantButton((0, $711X2.PrimaryButton));
const $00f6bc802b15a660$export$25e85d244cbf7845 = $00f6bc802b15a660$var$getConversationAssistantButton(function Nav4Button({ tooltip: tooltip, ...props }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltip,
        // This button's visible text matches the tooltip
        // Announcing the tooltip means 'Chat' would be announced twice
        isScreenReaderAnnouncementDisabled: true,
        children: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8uiXJ.Button), {
                interactionName: props?.interactionName,
                ref: ref,
                ...triggerProps,
                ...props,
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps.onClick?.(event);
                },
                iconBefore: ()=>props.iconBefore || null
            })
    });
});
const $00f6bc802b15a660$export$de76c194bfb85689 = ({ children: children, messageId: messageId, siteId: siteId, setShouldShowMessage: setShouldShowMessage, shouldShowMessage: shouldShowMessage, openRovoChat: openRovoChat })=>{
    const { activeSpotlight: activeSpotlight } = (0, $5KAqU.useConversationAssistantSpotlightState)();
    const coordinationClient = (0, $9p6hi.useCoordinationClient)(siteId);
    const [onboardingStarted, stopOnboarding] = (0, $kbqIt.useCoordination)(coordinationClient, messageId);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jSnf2.useAnalytics)();
    const onDismissMessage = ()=>{
        setShouldShowMessage(false);
        stopOnboarding();
    };
    (0, $5uXOq.useEffect)(()=>{
        if (shouldShowMessage && activeSpotlight !== null) sendAnalyticsEvent({
            eventType: 'ui',
            action: 'shown',
            actionSubject: 'rovoChatButtonSpotlight'
        });
    }, [
        shouldShowMessage,
        activeSpotlight,
        sendAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (onboardingStarted) setShouldShowMessage(true);
    }, [
        onboardingStarted,
        setShouldShowMessage
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kQZfA.ConditionalWrapper), {
        condition: shouldShowMessage,
        wrapper: (children)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $imZsD.default), {
                blanketIsTinted: true,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Fk4Z.default), {
                    name: (0, $aa59d7827e216af2$export$12496216771c6bdd),
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $k6T4f.Pulse), {
                        radius: 3,
                        pulse: activeSpotlight === null,
                        children: [
                            children,
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fsNoS.ConversationAssistantOnboardingSpotlight), {
                                onDismiss: onDismissMessage,
                                openRovoChat: openRovoChat
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jZ4fr.EngagementSpotlight), {
                                engagementId: (0, $aa59d7827e216af2$export$12496216771c6bdd)
                            })
                        ]
                    })
                })
            }),
        children: children
    });
};

});
parcelRegister("kbqIt", function(module, exports) {

$parcel$export(module.exports, "useCoordination", () => $88a44f4ad6e3d72a$export$3c29cca421979b0e);

var $5uXOq = parcelRequire("5uXOq");
const $88a44f4ad6e3d72a$export$3c29cca421979b0e = (coordinationClient, messageId)=>{
    const [started, setStarted] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        (async ()=>{
            try {
                const started = await coordinationClient.start(messageId);
                if (started) setStarted(true);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to start flow message ${messageId}. ${err}`);
            }
        })();
    }, [
        coordinationClient,
        messageId
    ]);
    const stop = (0, $5uXOq.useCallback)(async (force)=>{
        if (!force && !started) return;
        try {
            await coordinationClient.stop(messageId);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to stop flow message ${messageId}. ${err}`);
        }
    }, [
        started,
        coordinationClient,
        messageId
    ]);
    return [
        started,
        stop
    ];
};

});

parcelRegister("fsNoS", function(module, exports) {

$parcel$export(module.exports, "ConversationAssistantOnboardingSpotlight", () => $7622f7ff4a4a9070$export$e4abc8af2fc5e2ac);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $gKZoD = parcelRequire("gKZoD");

var $7gs1W = parcelRequire("7gs1W");

var $jSnf2 = parcelRequire("jSnf2");

var $5KAqU = parcelRequire("5KAqU");


var $idu9A = parcelRequire("idu9A");
const $7622f7ff4a4a9070$export$e4abc8af2fc5e2ac = ({ openRovoChat: openRovoChat, openAgentSelectorMenu: openAgentSelectorMenu, onDismiss: onDismiss })=>{
    (0, $gKZoD.di)((0, $5KAqU.useConversationAssistantSpotlightState));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { end: end } = (0, $5KAqU.useConversationAssistantSpotlightActions)();
    const { activeSpotlight: activeSpotlight } = (0, $5KAqU.useConversationAssistantSpotlightState)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jSnf2.useAnalytics)();
    const renderActiveSpotlight = ()=>{
        const spotlights = [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7gs1W.default), {
                actions: [
                    {
                        onClick: (event, analyticsEvent)=>{
                            if (openRovoChat) openRovoChat(event, analyticsEvent);
                            end();
                            onDismiss();
                            sendAnalyticsEvent({
                                eventType: 'ui',
                                // this is more of 'chatButtonClicked'
                                action: 'dismissed',
                                actionSubject: 'rovoChatButtonSpotlight'
                            });
                        },
                        text: formatMessage((0, $idu9A.default).tryChat)
                    },
                    {
                        onClick: ()=>{
                            end();
                            onDismiss();
                            sendAnalyticsEvent({
                                eventType: 'ui',
                                action: 'dismissButtonClicked',
                                actionSubject: 'rovoChatButtonSpotlight'
                            });
                        },
                        text: formatMessage((0, $idu9A.default).dismissOnboarding),
                        appearance: 'subtle'
                    }
                ],
                heading: formatMessage((0, $idu9A.default).onboardingHeading),
                target: (0, $aa59d7827e216af2$export$12496216771c6bdd),
                targetRadius: 3,
                children: formatMessage((0, $idu9A.default).onboardingDescription)
            }, (0, $aa59d7827e216af2$export$12496216771c6bdd))
        ];
        if (activeSpotlight === null) return null;
        return spotlights[activeSpotlight];
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: renderActiveSpotlight()
    });
};

});
parcelRegister("5KAqU", function(module, exports) {

$parcel$export(module.exports, "useConversationAssistantSpotlightActions", () => $c316b97c3ee7919f$export$283f4929c8863814);
$parcel$export(module.exports, "useConversationAssistantSpotlightState", () => $c316b97c3ee7919f$export$258c2a6b93cdef4a);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $c316b97c3ee7919f$var$initialState = {
    activeSpotlight: null
};
const $c316b97c3ee7919f$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                activeSpotlight: 0
            });
        },
    next: ()=>({ setState: setState, getState: getState })=>{
            setState({
                activeSpotlight: (getState().activeSpotlight || 0) + 1
            });
        },
    end: ()=>({ setState: setState })=>{
            setState({
                activeSpotlight: null
            });
        }
};
const $c316b97c3ee7919f$var$ConversationAssistantSpotlightStore = (0, $iXqE5.createStore)({
    initialState: $c316b97c3ee7919f$var$initialState,
    actions: $c316b97c3ee7919f$var$actions,
    name: 'ConversationAssistantSpotlightStore'
});
const $c316b97c3ee7919f$export$283f4929c8863814 = (0, $3sQ5x.createActionsHook)($c316b97c3ee7919f$var$ConversationAssistantSpotlightStore);
const $c316b97c3ee7919f$export$258c2a6b93cdef4a = (0, $3sQ5x.createStateHook)($c316b97c3ee7919f$var$ConversationAssistantSpotlightStore);

});

const $aa59d7827e216af2$export$12496216771c6bdd = 'rovo-chat-button';

parcelRegister("idu9A", function(module, exports) {

$parcel$export(module.exports, "default", () => $817b3ce69fd4391b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $817b3ce69fd4391b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tryChat: {
        id: 'rovo-onboarding-try-chat',
        defaultMessage: 'Chat now',
        description: 'Action button for rovo onboarding spotlight'
    },
    dismissOnboarding: {
        id: 'rovo-onboarding-dismiss',
        defaultMessage: 'Dismiss',
        description: 'Dismiss button for rovo onboarding spotlight'
    },
    onboardingHeading: {
        id: 'rovo-onboarding-heading',
        defaultMessage: 'Chat with AI',
        description: 'Onboarding step heading'
    },
    onboardingDescription: {
        id: 'rovo-onboarding-description',
        defaultMessage: 'With Rovo Chat, use AI to explore company knowledge, create new things, and collaborate on your work.',
        description: 'Onboarding step description'
    }
});

});


parcelRegister("9p6hi", function(module, exports) {

$parcel$export(module.exports, "useCoordinationClient", () => $9751ca993e8ba900$export$ddc368dc94a41e62);

var $5uXOq = parcelRequire("5uXOq");

var $8Mq6c = parcelRequire("8Mq6c");
const $9751ca993e8ba900$export$ddc368dc94a41e62 = (cloudId, workspaceId, orgId)=>{
    return (0, $5uXOq.useMemo)(()=>new (0, $8Mq6c.default)({
            cloudId: cloudId,
            stargateUrl: '/gateway/api',
            workspaceId: workspaceId,
            orgId: orgId
        }), [
        cloudId,
        workspaceId,
        orgId
    ]);
};

});

parcelRegister("dMUIg", function(module, exports) {

$parcel$export(module.exports, "ChatIcon", () => $93d65af90b1ed4ae$export$52cd484a7ef4f2b9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $93d65af90b1ed4ae$export$52cd484a7ef4f2b9 = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    d: "M10.4489 3.4504L7.75593 4.49767C7.75381 4.4985 7.75381 4.5015 7.75593 4.50233L10.4489 5.5496C10.4496 5.54986 10.4501 5.55037 10.4503 5.55103L11.4976 8.24401C11.4984 8.24613 11.5014 8.24613 11.5023 8.24401L12.5495 5.55103C12.5498 5.55037 12.5503 5.54986 12.551 5.5496L15.2439 4.50233C15.2461 4.5015 15.2461 4.4985 15.2439 4.49767L12.551 3.4504C12.5503 3.45014 12.5498 3.44963 12.5495 3.44897L11.5023 0.755991C11.5014 0.753866 11.4984 0.753866 11.4976 0.755991L10.4503 3.44897C10.4501 3.44963 10.4496 3.45014 10.4489 3.4504Z",
                    stroke: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0 3.125C0 1.67525 1.17525 0.5 2.625 0.5H7.5V2H2.625C2.00368 2 1.5 2.50368 1.5 3.125V13.9576L4.05083 12.5H13.375C13.9963 12.5 14.5 11.9963 14.5 11.375V9H16V11.375C16 12.8247 14.8247 14 13.375 14H4.44917L1.12584 15.899C0.624381 16.1856 0 15.8237 0 15.2457V3.125Z",
                    fill: "currentColor"
                })
            ]
        })
    });
};

});

parcelRegister("kQZfA", function(module, exports) {

$parcel$export(module.exports, "ConditionalWrapper", () => $efbf4733520d1454$export$39aecc95f0365819);
const $efbf4733520d1454$export$39aecc95f0365819 = ({ condition: condition, wrapper: wrapper, children: children })=>condition ? wrapper(children) : children;

});

parcelRegister("cccYj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $772596c67e72ecec$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $772596c67e72ecec$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    buttonLabel: {
        id: 'conversation-assistant-button.label',
        defaultMessage: 'Chat',
        description: 'Label for the button that opens the conversation assistant'
    },
    rovoChatButtonLabel: {
        id: 'conversation-assistant-button.rovo-chat-label',
        defaultMessage: 'Rovo Chat',
        description: 'Label for the button that opens the conversation assistant'
    }
});

});


parcelRegister("ggewM", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $0c1a07eff7a37d70$export$f65ca476c09acec0);
const $0c1a07eff7a37d70$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});

parcelRegister("59y5F", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c083ca41bc0ca78$export$2e2bcd8739ae039);
// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.

var $jovBr = parcelRequire("jovBr");

var $j2niS = parcelRequire("j2niS");
var $3c083ca41bc0ca78$var$isValid = (0, $j2niS.default)((0, $jovBr.default), 1);
var $3c083ca41bc0ca78$export$2e2bcd8739ae039 = $3c083ca41bc0ca78$var$isValid;

});
parcelRegister("j2niS", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc047cf9e7996a6$export$2e2bcd8739ae039);
function $ddc047cf9e7996a6$export$2e2bcd8739ae039(fn, arity, a) {
    a = a || [];
    if (a.length >= arity) return fn.apply(null, a.slice(0, arity).reverse());
    return function() {
        var args = Array.prototype.slice.call(arguments);
        return $ddc047cf9e7996a6$export$2e2bcd8739ae039(fn, arity, a.concat(args));
    };
}

});


parcelRegister("dQChl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a14dd31138eb438e$export$2e2bcd8739ae039);
// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.

var $lb7qa = parcelRequire("lb7qa");

var $j2niS = parcelRequire("j2niS");
var $a14dd31138eb438e$var$isWithinInterval = (0, $j2niS.default)((0, $lb7qa.default), 2);
var $a14dd31138eb438e$export$2e2bcd8739ae039 = $a14dd31138eb438e$var$isWithinInterval;

});

parcelRegister("2xkYZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d8ef08fb2404f13$export$2e2bcd8739ae039);
// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.

var $gn1v9 = parcelRequire("gn1v9");

var $j2niS = parcelRequire("j2niS");
var $1d8ef08fb2404f13$var$sub = (0, $j2niS.default)((0, $gn1v9.default), 2);
var $1d8ef08fb2404f13$export$2e2bcd8739ae039 = $1d8ef08fb2404f13$var$sub;

});

const $90de389b166e701f$export$42f4885608027d0c = 'non_boolean';

const $6d71942d1f781fcc$export$4261d5d429e288ec = 'is-admin';
const $6d71942d1f781fcc$export$2eca2b4f46ed58e6 = 'is-nav4-tenant-opt-in';
const $6d71942d1f781fcc$export$a4507bf14f4bb764 = 'is-nav4-tenant-opt-out';
const $6d71942d1f781fcc$export$153ded4d539b820d = 'is-nav4-user-opt-in';
const $6d71942d1f781fcc$export$9c962957701a4fe8 = 'is-nav4-user-opt-out';

const $281cbd47ba46dd7d$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $281cbd47ba46dd7d$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $281cbd47ba46dd7d$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $281cbd47ba46dd7d$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $281cbd47ba46dd7d$export$4695c1a423ffe431 = 'DASHBOARD';
const $281cbd47ba46dd7d$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $281cbd47ba46dd7d$export$9a80695e72849f84 = 'X-Atlassian-Capability';

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';

const $acc1306b50923620$export$b8b9d90f9e5bd72b = 'jiraAtlassianNavigationNav4';
const $acc1306b50923620$export$d57b6b390e78d90f = 'jira-cosmos';
const $acc1306b50923620$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';

/**
 * Character key codes which can be used in keyboard events.
 */ const $5e71d9a7b5ef77ee$export$390330c10ff2b9a1 = 'ArrowUp';
const $5e71d9a7b5ef77ee$export$a80636c6f41931fe = 'ArrowDown';
const $5e71d9a7b5ef77ee$export$4af703091671bc = 'Home';
const $5e71d9a7b5ef77ee$export$e2bc30913faa5db7 = 'End';
const $5e71d9a7b5ef77ee$export$10f6869ed0a7d75b = 'Tab';
const $5e71d9a7b5ef77ee$export$8152f929a25a0ff4 = 'Enter';
const $5e71d9a7b5ef77ee$export$e51a3576c045c8d5 = 'Space';
const $5e71d9a7b5ef77ee$export$2bb790b9008907b4 = 'Escape';

const $af03419a6de12610$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $af03419a6de12610$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $af03419a6de12610$export$13f57c02915787b3 = 'atlaskit-portal';

const $edbbaf000cbe1dd7$export$ed5835cc67e87f72 = 'akPortalMount';
const $edbbaf000cbe1dd7$export$80816bd900e5bd00 = 'akPortalUnmount';

const $f5236820edf41c5d$export$eb5d9c90d65c7fea = 'ClientDispatcher';

const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;

const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';

const $37d1b046897e548f$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $37d1b046897e548f$export$bf6cd96e19b2987f = 100;
const $37d1b046897e548f$export$1ad8434180c5936c = 300000; // 5m

const $6f9e74bb556ace2f$export$881d135f98d8d7d0 = 100;
const $6f9e74bb556ace2f$export$9ab5bdcb8a1d6c34 = false;
const $6f9e74bb556ace2f$export$f267d0e9ab3eb265 = false;
const $6f9e74bb556ace2f$export$12c1dc38ea1692da = 0;

const $1520d876660a71bd$export$d2aa6c54a5925f01 = 'v3';
const $1520d876660a71bd$export$2bd315ece9f68967 = 'v4';

const $68cb678dc917978e$export$2ee9e5a3556c1e43 = 'sidebar';
const $68cb678dc917978e$export$793ed84f5e13fedc = 'top';
const $68cb678dc917978e$export$f1c9dd0f5207dd5e = 'tab';
const $68cb678dc917978e$export$b83d0ee9325a2d0a = 'projectTitle';

// TopNav or sidebar
const $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22 = 'global';
const $ce9c0831aed9ffb3$export$33d8c916a600c5e9 = 'container';

const $ce8062101363feb9$export$6dd9406e478a1fe2 = 'navigationItem';
const $ce8062101363feb9$export$b887e88d8d0739f6 = 'button';
const $ce8062101363feb9$export$64fed82162bd367 = 'dropdownItem';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $b276966247f2f12d$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

const $636842cf8e8f850b$export$b98e411ae80c806f = '/';

const $eb0760a6ada94ab6$export$3c96fa14fb694e11 = 'ssr/detail_render_trace';

const $b2e0d12d54fddedd$export$cf090d5281b5ae06 = 10000;
const $b2e0d12d54fddedd$export$8575e30be0feb909 = 30000;

const $ff8b18549b2c06bf$export$d6830277b06edd6 = 'normal';

const $eba99f58997c09b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eba99f58997c09b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eba99f58997c09b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $eba99f58997c09b3$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

const $3202ab0bf207425f$export$424ba99fce04562 = 600000;

const $49a076eb01652100$export$91a9dba2d38d9a6f = 'projects';
const $49a076eb01652100$export$ebb48b08205007c5 = 'issues';
const $49a076eb01652100$export$6737b9227f60f39d = 'filters';
const $49a076eb01652100$export$6e58b6b0aa48a271 = 'dashboards';
const $49a076eb01652100$export$20f1031cc9fdf29e = 'queues';
const $49a076eb01652100$export$f95f1a684a17f189 = 'boards';
const $49a076eb01652100$export$3c11110d46d67e8c = 'jwmBoards';
const $49a076eb01652100$export$5e2cc09b58170ca2 = 'addons';
const $49a076eb01652100$export$eebccb886b064713 = 'plans';
const $49a076eb01652100$export$1c2ea36059c73937 = 'alerts';

const $7a1562bd0ca086b0$export$ea341e6cc435ed40 = 15;
const $7a1562bd0ca086b0$export$7a3d0824e907e616 = 'navigation-favourite-store';

const $27f794e239d3d8c4$export$52483b87432059f1 = 'jiraEditionAwarenessForStandardToPremium';
const $27f794e239d3d8c4$export$83e119fb36bc846a = 'jira.user.theme.standard-to-premium-ea-pill.dismissed';

const $87844bbe4c23d937$export$b5a308a17bc991f3 = 'projectKey';
const $87844bbe4c23d937$export$929d50f83189406c = 'boardId';
const $87844bbe4c23d937$export$da6f46390e1a426f = 'projectId';

const $0f463a88567f1621$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $6784cbc7d62e5d7c$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$6e69f8dc03075ef8 = 'team-type';
const $6784cbc7d62e5d7c$export$c06666264cd35603 = 'team-type-shorthand';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $6784cbc7d62e5d7c$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $6784cbc7d62e5d7c$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$f93b83d735f01fa3 = 'pagesCreatePageNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $6784cbc7d62e5d7c$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $6784cbc7d62e5d7c$export$699265ec8ad9a740 = 'Software Development';
const $6784cbc7d62e5d7c$export$e07d1fa2da8ed874 = 'Customer Service';
const $6784cbc7d62e5d7c$export$76dcec3f438d9e56 = 'IT Support';
const $6784cbc7d62e5d7c$export$9a574c301f67ba30 = 'Human Resources';
const $6784cbc7d62e5d7c$export$363ec144a94029c8 = 'Finance';
const $6784cbc7d62e5d7c$export$df0fb32d68ae1e78 = 'Legal';
const $6784cbc7d62e5d7c$export$d9c0e3e59442fb4 = 'Marketing';
const $6784cbc7d62e5d7c$export$27dbc7d7ce66e6e3 = 'Operations';
const $6784cbc7d62e5d7c$export$a5dce388adf922bd = 'Sales';
const $6784cbc7d62e5d7c$export$e1473b31a257caff = 'Data Science';
const $6784cbc7d62e5d7c$export$85657457db93c2c2 = 'Product Management';
const $6784cbc7d62e5d7c$export$c0c2d1dfaeba89dd = 'Project Management';
const $6784cbc7d62e5d7c$export$2e6a7ad3ab9c82a3 = 'Design';
const $6784cbc7d62e5d7c$export$7b60378c3b4372e9 = 'Other or Personal';
const $6784cbc7d62e5d7c$export$572242e58bd07594 = 'CS';
const $6784cbc7d62e5d7c$export$d7de553940261eba = 'ITS';
const $6784cbc7d62e5d7c$export$4c29d0d04c15e55d = 'HR';
const $6784cbc7d62e5d7c$export$3950f7f841bf94b6 = 'FNC';
const $6784cbc7d62e5d7c$export$881249b988b6030f = 'LGL';
const $6784cbc7d62e5d7c$export$e4824f74b9879164 = 'MKT';
const $6784cbc7d62e5d7c$export$4f3cb0844009af52 = 'OPS';
const $6784cbc7d62e5d7c$export$1a65d50c4a641bb4 = 'SAL';
const $6784cbc7d62e5d7c$export$9ee64e8fbd8b03a2 = 'DS';
const $6784cbc7d62e5d7c$export$b8b1ac856ba1434b = 'DEV';
const $6784cbc7d62e5d7c$export$4f54a09a24fd1d74 = 'PDM';
const $6784cbc7d62e5d7c$export$79685802e8ff1098 = 'PJM';
const $6784cbc7d62e5d7c$export$e5c438b7501b5a24 = 'DES';
const $6784cbc7d62e5d7c$export$cbc0e551d91a692d = 'OTR';

const $111ca51573c84ae8$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';

const $53b7c6a1de61c1d4$export$80945eb3738bcee8 = '/gateway/api/me';

const $ec61554fda4e6d64$export$2b91517d6d5b4365 = `
fragment NavigationActivityItem on ActivitiesItem {
  id
  timestamp
  object {
    id
    name
    localResourceId
    type
    url
    iconUrl
    containers {
      name
      type
    }
    extension {
      ... on ActivitiesJiraIssue {
        issueKey
      }
    }
  }
}

query jira_NavigationActivity($first: Int, $cloudID: ID!) {
  activities {
    myActivities {
      workedOn(
        first: $first,
        filters: [
          {
            type: AND,
            arguments: {
              cloudIds: [$cloudID],
              products: [JIRA, JIRA_BUSINESS, JIRA_SOFTWARE, JIRA_OPS, JIRA_SERVICE_DESK]
            }
          }
        ]
      ) {
        nodes {
          ...NavigationActivityItem
        }
      }
    }
  }
}

`;

const $e706d38cada11fb1$export$eb2b39783d051b9 = 'navigation-recents-store';
const $e706d38cada11fb1$export$22ea57e66775a6b2 = 5;
const $e706d38cada11fb1$export$8666f31c8873bff = 10;
const $e706d38cada11fb1$export$5f1b6c5e9d257e5e = 20;

const $8acc83d90e579622$export$30fa7cc5f2690a43 = 56;
const $8acc83d90e579622$export$4033a111ca79977d = 1280;
const $8acc83d90e579622$export$24ec62cee78b7042 = 1130;
const $8acc83d90e579622$export$d8bde68ac946124f = '--ds--ans--fbc';
const $8acc83d90e579622$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $8acc83d90e579622$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $8acc83d90e579622$export$d81606c1fc5119bc = '--ds--ans--c';
const $8acc83d90e579622$export$65f656ad520ea71 = '--ds--ans--bc';

const $d0956fbcd917153f$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $d0956fbcd917153f$export$9e2cc65718a61846 = 'themePreference';
const $d0956fbcd917153f$export$89c5cf64ad15c3ea = 'changed';

const $da88f8f66d8f0f0a$export$3288b14b6745c572 = 204;
const $da88f8f66d8f0f0a$export$c09e7ea0fc79f34f = 409;
const $da88f8f66d8f0f0a$export$974c37534b0191b1 = 503;

// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $1cb976721581e2e6$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $1cb976721581e2e6$export$64aee74ba59709e5 = 439; // px
const $1cb976721581e2e6$export$1c07393c5bb1bc27 = 439; // px
const $1cb976721581e2e6$export$aa3478deee7adbeb = 350; // px
const $1cb976721581e2e6$export$21e515a86cd1733b = 'Chat';

const $34f68d752b7fdd6c$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!, $shouldShowRovoLLMEnabled: Boolean!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	}

	jira_isRovoLLMEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence") @include(if: $shouldShowRovoLLMEnabled)
}
`;

const $de7681b8672bb382$export$d983e94cf86f65d = 'global-create-button';
const $de7681b8672bb382$export$7e22286cafe320a7 = 'keyboard-shortcut';

// error types
const $4cff3ad70ea80f75$export$6c8cb487d6ffc522 = 'QueryError';
const $4cff3ad70ea80f75$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $4cff3ad70ea80f75$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $4cff3ad70ea80f75$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $4cff3ad70ea80f75$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $4cff3ad70ea80f75$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $4cff3ad70ea80f75$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $4cff3ad70ea80f75$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $4cff3ad70ea80f75$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $4cff3ad70ea80f75$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $4cff3ad70ea80f75$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $4cff3ad70ea80f75$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';

const $8e5bc4e5db4905c7$export$fe522736b61f6709 = 'RESOURCE_TYPE_GIC_OPTIN_STATUS';

const $fa76c7a777da2375$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $fa76c7a777da2375$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $fa76c7a777da2375$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';

const $146ecce9d079a34d$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $146ecce9d079a34d$export$2ee9e5a3556c1e43 = 'SIDEBAR';

const $95839ee75937f648$export$67a034c701fa7ff6 = 'uniapa';
const $95839ee75937f648$export$7a86d77850136bf4 = 'has-spotlight-been-shown';
const $95839ee75937f648$export$d2ea4f931a71a509 = 'jira-admin-product-request-spotlight';

const $309f32bbf2afff80$export$e0226a83abddbd07 = 'check-notifications';

const $3c41b45407aae96c$export$14c62ba6f49b806f = 9;

// Used for analytics event context for secondary (floating button) view
const $8e02302c3f52a3b4$export$75cc63c8ac8ae533 = 'nuxOnboardingQuickstartButton';

const $e7830161eb8674f1$export$6f454e69bce3a691 = 'business';
const $e7830161eb8674f1$export$e6952b12ade67489 = 'default';

const $f9d36ddc532997a4$export$fa5743fc6a1da5d8 = 'NAVIGATION_SIDEBAR_GLOBAL';

const $5a94e356f9d5e220$export$25ee35b01de9d734 = 'EOC_TENANT';

const $47a35bf911de1c9b$export$650f6934db1290c1 = 'cohort3';
const $47a35bf911de1c9b$export$a101f3562b5f0742 = 'cohort3.5';

const $1d21bc43afc62b3b$export$b8b9d90f9e5bd72b = 'jiraServicedeskStandardToPremiumModal';
const $1d21bc43afc62b3b$export$d57b6b390e78d90f = 'Sequoia';
const $1d21bc43afc62b3b$export$2a2c8ede6cfecb61 = '/gateway/api/graphql';

const $f524727bc2d3810c$export$f707547fc95f31c2 = 'atlassian-navigation.ui.settings.menu.home.heading.side-heading';


$parcel$global.rlb("l253H")
//# sourceMappingURL=shared~atlassian-navigation~vendor~ar.57399ffb.js.map
